import React__default, { useState, useEffect, useMemo, useLayoutEffect, useRef, forwardRef, useCallback, memo, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import styled, { css, useTheme, createGlobalStyle, keyframes } from 'styled-components';
import { flushSync, createPortal } from 'react-dom';
import { createPopper } from '@popperjs/core';
import _extends from '@babel/runtime/helpers/esm/extends';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inheritsLoose from '@babel/runtime/helpers/esm/inheritsLoose';
import _wrapNativeSuper from '@babel/runtime/helpers/esm/wrapNativeSuper';
import '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import _, { isDate, throttle, debounce as debounce$1, uniq, flatMap, kebabCase, omit } from 'lodash';
import { useLocation, Link as Link$1, Redirect as Redirect$1, useHistory as useHistory$1 } from 'react-router-dom';
import { useHistory, Redirect as Redirect$2, Switch as Switch$1, Route } from 'react-router';
import { setDefaultOptions, parseISO, format as format$1, differenceInHours, formatDistance, toDate, parse as parse$1, isValid, addYears, addQuarters, addMonths, addWeeks, addDays, addHours, addMinutes, addSeconds, addMilliseconds, differenceInYears, differenceInQuarters, differenceInMonths, differenceInWeeks, differenceInDays, differenceInMinutes, differenceInSeconds, differenceInMilliseconds, startOfYear, startOfQuarter, startOfMonth, startOfWeek, startOfDay, startOfHour, startOfMinute, startOfSecond, endOfYear, endOfQuarter, endOfMonth, endOfWeek, endOfDay, endOfHour, endOfMinute, endOfSecond, setHours, setMinutes, setSeconds, setMilliseconds, formatDistanceStrict } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import Select$1, { components } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { CircularProgressbar as CircularProgressbar$1, buildStyles } from 'react-circular-progressbar';
import { Upload } from 'tus-js-client';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var lottie_light_min = createCommonjsModule(function (module) {
typeof navigator !== "undefined" && function (root, factory) {
  if ( module.exports) {
    module.exports = factory(root);
  } else {
    root.lottie = factory(root);
    root.bodymovin = root.lottie;
  }
}(window || {}, function (window) {

  var i,
    e = "http://www.w3.org/2000/svg",
    A = "",
    s = -999999,
    p = !1,
    a = !0,
    r = "",
    n = /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
    _ = Math.pow,
    k = Math.sqrt,
    f = Math.floor,
    d = (Math.min),
    h = {};
  !function () {
    var t,
      e = ["abs", "acos", "acosh", "asin", "asinh", "atan", "atanh", "atan2", "ceil", "cbrt", "expm1", "clz32", "cos", "cosh", "exp", "floor", "fround", "hypot", "imul", "log", "log1p", "log2", "log10", "max", "min", "pow", "random", "round", "sign", "sin", "sinh", "sqrt", "tan", "tanh", "trunc", "E", "LN10", "LN2", "LOG10E", "LOG2E", "PI", "SQRT1_2", "SQRT2"],
      s = e.length;
    for (t = 0; t < s; t += 1) h[e[t]] = Math[e[t]];
  }(), h.random = Math.random, h.abs = function (t) {
    if ("object" === typeof t && t.length) {
      var e,
        s = x(t.length),
        i = t.length;
      for (e = 0; e < i; e += 1) s[e] = Math.abs(t[e]);
      return s;
    }
    return Math.abs(t);
  };
  var P = 150,
    j = Math.PI / 180,
    v = .5519;
  function l(t, e, s, i) {
    this.type = t, this.currentTime = e, this.totalTime = s, this.direction = i < 0 ? -1 : 1;
  }
  function m(t, e) {
    this.type = t, this.direction = e < 0 ? -1 : 1;
  }
  function c(t, e, s, i) {
    this.type = t, this.currentLoop = s, this.totalLoops = e, this.direction = i < 0 ? -1 : 1;
  }
  function u(t, e, s) {
    this.type = t, this.firstFrame = e, this.totalFrames = s;
  }
  function g(t, e) {
    this.type = t, this.target = e;
  }
  function y(t, e) {
    this.type = "renderFrameError", this.nativeError = t, this.currentTime = e;
  }
  function b(t) {
    this.type = "configError", this.nativeError = t;
  }
  var t,
    S = (t = 0, function () {
      return r + "__lottie_element_" + (t += 1);
    });
  function D(t, e, s) {
    var i, a, r, n, h, o, l, p;
    switch (o = s * (1 - e), l = s * (1 - (h = 6 * t - (n = Math.floor(6 * t))) * e), p = s * (1 - (1 - h) * e), n % 6) {
      case 0:
        i = s, a = p, r = o;
        break;
      case 1:
        i = l, a = s, r = o;
        break;
      case 2:
        i = o, a = s, r = p;
        break;
      case 3:
        i = o, a = l, r = s;
        break;
      case 4:
        i = p, a = o, r = s;
        break;
      case 5:
        i = s, a = o, r = l;
    }
    return [i, a, r];
  }
  function w(t, e, s) {
    var i,
      a = Math.max(t, e, s),
      r = Math.min(t, e, s),
      n = a - r,
      h = 0 === a ? 0 : n / a,
      o = a / 255;
    switch (a) {
      case r:
        i = 0;
        break;
      case t:
        i = e - s + n * (e < s ? 6 : 0), i /= 6 * n;
        break;
      case e:
        i = s - t + 2 * n, i /= 6 * n;
        break;
      case s:
        i = t - e + 4 * n, i /= 6 * n;
    }
    return [i, h, o];
  }
  function lt(t, e) {
    var s = w(255 * t[0], 255 * t[1], 255 * t[2]);
    return s[1] += e, 1 < s[1] ? s[1] = 1 : s[1] <= 0 && (s[1] = 0), D(s[0], s[1], s[2]);
  }
  function pt(t, e) {
    var s = w(255 * t[0], 255 * t[1], 255 * t[2]);
    return s[2] += e, 1 < s[2] ? s[2] = 1 : s[2] < 0 && (s[2] = 0), D(s[0], s[1], s[2]);
  }
  function ft(t, e) {
    var s = w(255 * t[0], 255 * t[1], 255 * t[2]);
    return s[0] += e / 360, 1 < s[0] ? s[0] -= 1 : s[0] < 0 && (s[0] += 1), D(s[0], s[1], s[2]);
  }
  !function () {
    var t,
      e,
      s = [];
    for (t = 0; t < 256; t += 1) e = t.toString(16), s[t] = 1 === e.length ? "0" + e : e;
  }();
  function C() {}
  C.prototype = {
    triggerEvent: function (t, e) {
      if (this._cbs[t]) for (var s = this._cbs[t], i = 0; i < s.length; i += 1) s[i](e);
    },
    addEventListener: function (t, e) {
      return this._cbs[t] || (this._cbs[t] = []), this._cbs[t].push(e), function () {
        this.removeEventListener(t, e);
      }.bind(this);
    },
    removeEventListener: function (t, e) {
      if (e) {
        if (this._cbs[t]) {
          for (var s = 0, i = this._cbs[t].length; s < i;) this._cbs[t][s] === e && (this._cbs[t].splice(s, 1), s -= 1, i -= 1), s += 1;
          this._cbs[t].length || (this._cbs[t] = null);
        }
      } else this._cbs[t] = null;
    }
  };
  var W = function () {
    function s(t, e) {
      var s,
        i = 0,
        a = [];
      switch (t) {
        case "int16":
        case "uint8c":
          s = 1;
          break;
        default:
          s = 1.1;
      }
      for (i = 0; i < e; i += 1) a.push(s);
      return a;
    }
    return "function" == typeof Uint8ClampedArray && "function" == typeof Float32Array ? function (t, e) {
      return "float32" === t ? new Float32Array(e) : "int16" === t ? new Int16Array(e) : "uint8c" === t ? new Uint8ClampedArray(e) : s(t, e);
    } : s;
  }();
  function x(t) {
    return Array.apply(null, {
      length: t
    });
  }
  function F(t) {
    return document.createElementNS(e, t);
  }
  function T(t) {
    return document.createElement(t);
  }
  function M() {}
  M.prototype = {
    addDynamicProperty: function (t) {
      -1 === this.dynamicProperties.indexOf(t) && (this.dynamicProperties.push(t), this.container.addDynamicProperty(this), this._isAnimated = !0);
    },
    iterateDynamicProperties: function () {
      var t;
      this._mdf = !1;
      var e = this.dynamicProperties.length;
      for (t = 0; t < e; t += 1) this.dynamicProperties[t].getValue(), this.dynamicProperties[t]._mdf && (this._mdf = !0);
    },
    initDynamicPropertyContainer: function (t) {
      this.container = t, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
    }
  };
  var E,
    I = (E = {
      0: "source-over",
      1: "multiply",
      2: "screen",
      3: "overlay",
      4: "darken",
      5: "lighten",
      6: "color-dodge",
      7: "color-burn",
      8: "hard-light",
      9: "soft-light",
      10: "difference",
      11: "exclusion",
      12: "hue",
      13: "saturation",
      14: "color",
      15: "luminosity"
    }, function (t) {
      return E[t] || "";
    }),
    L = {
      1: "butt",
      2: "round",
      3: "square"
    },
    V = {
      1: "miter",
      2: "round",
      3: "bevel"
    },
    R = function () {
      var a = Math.cos,
        r = Math.sin,
        n = Math.tan,
        i = Math.round;
      function t() {
        return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
      }
      function e(t) {
        if (0 === t) return this;
        var e = a(t),
          s = r(t);
        return this._t(e, -s, 0, 0, s, e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function s(t) {
        if (0 === t) return this;
        var e = a(t),
          s = r(t);
        return this._t(1, 0, 0, 0, 0, e, -s, 0, 0, s, e, 0, 0, 0, 0, 1);
      }
      function h(t) {
        if (0 === t) return this;
        var e = a(t),
          s = r(t);
        return this._t(e, 0, s, 0, 0, 1, 0, 0, -s, 0, e, 0, 0, 0, 0, 1);
      }
      function o(t) {
        if (0 === t) return this;
        var e = a(t),
          s = r(t);
        return this._t(e, -s, 0, 0, s, e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function l(t, e) {
        return this._t(1, e, t, 1, 0, 0);
      }
      function p(t, e) {
        return this.shear(n(t), n(e));
      }
      function f(t, e) {
        var s = a(e),
          i = r(e);
        return this._t(s, i, 0, 0, -i, s, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, n(t), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(s, -i, 0, 0, i, s, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function d(t, e, s) {
        return s || 0 === s || (s = 1), 1 === t && 1 === e && 1 === s ? this : this._t(t, 0, 0, 0, 0, e, 0, 0, 0, 0, s, 0, 0, 0, 0, 1);
      }
      function m(t, e, s, i, a, r, n, h, o, l, p, f, d, m, c, u) {
        return this.props[0] = t, this.props[1] = e, this.props[2] = s, this.props[3] = i, this.props[4] = a, this.props[5] = r, this.props[6] = n, this.props[7] = h, this.props[8] = o, this.props[9] = l, this.props[10] = p, this.props[11] = f, this.props[12] = d, this.props[13] = m, this.props[14] = c, this.props[15] = u, this;
      }
      function c(t, e, s) {
        return s = s || 0, 0 !== t || 0 !== e || 0 !== s ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, t, e, s, 1) : this;
      }
      function u(t, e, s, i, a, r, n, h, o, l, p, f, d, m, c, u) {
        var g = this.props;
        if (1 === t && 0 === e && 0 === s && 0 === i && 0 === a && 1 === r && 0 === n && 0 === h && 0 === o && 0 === l && 1 === p && 0 === f) return g[12] = g[12] * t + g[15] * d, g[13] = g[13] * r + g[15] * m, g[14] = g[14] * p + g[15] * c, g[15] *= u, this._identityCalculated = !1, this;
        var y = g[0],
          v = g[1],
          b = g[2],
          _ = g[3],
          k = g[4],
          A = g[5],
          P = g[6],
          S = g[7],
          D = g[8],
          w = g[9],
          C = g[10],
          x = g[11],
          F = g[12],
          T = g[13],
          M = g[14],
          E = g[15];
        return g[0] = y * t + v * a + b * o + _ * d, g[1] = y * e + v * r + b * l + _ * m, g[2] = y * s + v * n + b * p + _ * c, g[3] = y * i + v * h + b * f + _ * u, g[4] = k * t + A * a + P * o + S * d, g[5] = k * e + A * r + P * l + S * m, g[6] = k * s + A * n + P * p + S * c, g[7] = k * i + A * h + P * f + S * u, g[8] = D * t + w * a + C * o + x * d, g[9] = D * e + w * r + C * l + x * m, g[10] = D * s + w * n + C * p + x * c, g[11] = D * i + w * h + C * f + x * u, g[12] = F * t + T * a + M * o + E * d, g[13] = F * e + T * r + M * l + E * m, g[14] = F * s + T * n + M * p + E * c, g[15] = F * i + T * h + M * f + E * u, this._identityCalculated = !1, this;
      }
      function g() {
        return this._identityCalculated || (this._identity = !(1 !== this.props[0] || 0 !== this.props[1] || 0 !== this.props[2] || 0 !== this.props[3] || 0 !== this.props[4] || 1 !== this.props[5] || 0 !== this.props[6] || 0 !== this.props[7] || 0 !== this.props[8] || 0 !== this.props[9] || 1 !== this.props[10] || 0 !== this.props[11] || 0 !== this.props[12] || 0 !== this.props[13] || 0 !== this.props[14] || 1 !== this.props[15]), this._identityCalculated = !0), this._identity;
      }
      function y(t) {
        for (var e = 0; e < 16;) {
          if (t.props[e] !== this.props[e]) return !1;
          e += 1;
        }
        return !0;
      }
      function v(t) {
        var e;
        for (e = 0; e < 16; e += 1) t.props[e] = this.props[e];
        return t;
      }
      function b(t) {
        var e;
        for (e = 0; e < 16; e += 1) this.props[e] = t[e];
      }
      function _(t, e, s) {
        return {
          x: t * this.props[0] + e * this.props[4] + s * this.props[8] + this.props[12],
          y: t * this.props[1] + e * this.props[5] + s * this.props[9] + this.props[13],
          z: t * this.props[2] + e * this.props[6] + s * this.props[10] + this.props[14]
        };
      }
      function k(t, e, s) {
        return t * this.props[0] + e * this.props[4] + s * this.props[8] + this.props[12];
      }
      function A(t, e, s) {
        return t * this.props[1] + e * this.props[5] + s * this.props[9] + this.props[13];
      }
      function P(t, e, s) {
        return t * this.props[2] + e * this.props[6] + s * this.props[10] + this.props[14];
      }
      function S() {
        var t = this.props[0] * this.props[5] - this.props[1] * this.props[4],
          e = this.props[5] / t,
          s = -this.props[1] / t,
          i = -this.props[4] / t,
          a = this.props[0] / t,
          r = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / t,
          n = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / t,
          h = new R();
        return h.props[0] = e, h.props[1] = s, h.props[4] = i, h.props[5] = a, h.props[12] = r, h.props[13] = n, h;
      }
      function D(t) {
        return this.getInverseMatrix().applyToPointArray(t[0], t[1], t[2] || 0);
      }
      function w(t) {
        var e,
          s = t.length,
          i = [];
        for (e = 0; e < s; e += 1) i[e] = D(t[e]);
        return i;
      }
      function C(t, e, s) {
        var i = W("float32", 6);
        if (this.isIdentity()) i[0] = t[0], i[1] = t[1], i[2] = e[0], i[3] = e[1], i[4] = s[0], i[5] = s[1];else {
          var a = this.props[0],
            r = this.props[1],
            n = this.props[4],
            h = this.props[5],
            o = this.props[12],
            l = this.props[13];
          i[0] = t[0] * a + t[1] * n + o, i[1] = t[0] * r + t[1] * h + l, i[2] = e[0] * a + e[1] * n + o, i[3] = e[0] * r + e[1] * h + l, i[4] = s[0] * a + s[1] * n + o, i[5] = s[0] * r + s[1] * h + l;
        }
        return i;
      }
      function x(t, e, s) {
        return this.isIdentity() ? [t, e, s] : [t * this.props[0] + e * this.props[4] + s * this.props[8] + this.props[12], t * this.props[1] + e * this.props[5] + s * this.props[9] + this.props[13], t * this.props[2] + e * this.props[6] + s * this.props[10] + this.props[14]];
      }
      function F(t, e) {
        if (this.isIdentity()) return t + "," + e;
        var s = this.props;
        return Math.round(100 * (t * s[0] + e * s[4] + s[12])) / 100 + "," + Math.round(100 * (t * s[1] + e * s[5] + s[13])) / 100;
      }
      function T() {
        for (var t = 0, e = this.props, s = "matrix3d("; t < 16;) s += i(1e4 * e[t]) / 1e4, s += 15 === t ? ")" : ",", t += 1;
        return s;
      }
      function M(t) {
        return t < 1e-6 && 0 < t || -1e-6 < t && t < 0 ? i(1e4 * t) / 1e4 : t;
      }
      function E() {
        var t = this.props;
        return "matrix(" + M(t[0]) + "," + M(t[1]) + "," + M(t[4]) + "," + M(t[5]) + "," + M(t[12]) + "," + M(t[13]) + ")";
      }
      return function () {
        this.reset = t, this.rotate = e, this.rotateX = s, this.rotateY = h, this.rotateZ = o, this.skew = p, this.skewFromAxis = f, this.shear = l, this.scale = d, this.setTransform = m, this.translate = c, this.transform = u, this.applyToPoint = _, this.applyToX = k, this.applyToY = A, this.applyToZ = P, this.applyToPointArray = x, this.applyToTriplePoints = C, this.applyToPointStringified = F, this.toCSS = T, this.to2dCSS = E, this.clone = v, this.cloneFromProps = b, this.equals = y, this.inversePoints = w, this.inversePoint = D, this.getInverseMatrix = S, this._t = this.transform, this.isIdentity = g, this._identity = !0, this._identityCalculated = !1, this.props = W("float32", 16), this.reset();
      };
    }();
  !function (h, o) {
    var l,
      p = this,
      f = 256,
      d = 6,
      m = "random",
      c = o.pow(f, d),
      u = o.pow(2, 52),
      g = 2 * u,
      y = f - 1;
    function v(t) {
      var e,
        s = t.length,
        n = this,
        i = 0,
        a = n.i = n.j = 0,
        r = n.S = [];
      for (s || (t = [s++]); i < f;) r[i] = i++;
      for (i = 0; i < f; i++) r[i] = r[a = y & a + t[i % s] + (e = r[i])], r[a] = e;
      n.g = function (t) {
        for (var e, s = 0, i = n.i, a = n.j, r = n.S; t--;) e = r[i = y & i + 1], s = s * f + r[y & (r[i] = r[a = y & a + e]) + (r[a] = e)];
        return n.i = i, n.j = a, s;
      };
    }
    function b(t, e) {
      return e.i = t.i, e.j = t.j, e.S = t.S.slice(), e;
    }
    function _(t, e) {
      for (var s, i = t + "", a = 0; a < i.length;) e[y & a] = y & (s ^= 19 * e[y & a]) + i.charCodeAt(a++);
      return k(e);
    }
    function k(t) {
      return String.fromCharCode.apply(0, t);
    }
    o["seed" + m] = function (t, e, s) {
      var i = [],
        a = _(function t(e, s) {
          var i,
            a = [],
            r = typeof e;
          if (s && "object" == r) for (i in e) try {
            a.push(t(e[i], s - 1));
          } catch (t) {}
          return a.length ? a : "string" == r ? e : e + "\0";
        }((e = !0 === e ? {
          entropy: !0
        } : e || {}).entropy ? [t, k(h)] : null === t ? function () {
          try {
            if (l) return k(l.randomBytes(f));
            var t = new Uint8Array(f);
            return (p.crypto || p.msCrypto).getRandomValues(t), k(t);
          } catch (t) {
            var e = p.navigator,
              s = e && e.plugins;
            return [+new Date(), p, s, p.screen, k(h)];
          }
        }() : t, 3), i),
        r = new v(i),
        n = function () {
          for (var t = r.g(d), e = c, s = 0; t < u;) t = (t + s) * f, e *= f, s = r.g(1);
          for (; g <= t;) t /= 2, e /= 2, s >>>= 1;
          return (t + s) / e;
        };
      return n.int32 = function () {
        return 0 | r.g(4);
      }, n.quick = function () {
        return r.g(4) / 4294967296;
      }, n.double = n, _(k(r.S), h), (e.pass || s || function (t, e, s, i) {
        return i && (i.S && b(i, r), t.state = function () {
          return b(r, {});
        }), s ? (o[m] = t, e) : t;
      })(n, a, "global" in e ? e.global : this == o, e.state);
    }, _(o.random(), h);
  }([], h);
  var H = function () {
    var t = {
        getBezierEasing: function (t, e, s, i, a) {
          var r = a || ("bez_" + t + "_" + e + "_" + s + "_" + i).replace(/\./g, "p");
          if (h[r]) return h[r];
          var n = new o([t, e, s, i]);
          return h[r] = n;
        }
      },
      h = {};
    var l = 11,
      p = 1 / (l - 1),
      e = "function" == typeof Float32Array;
    function i(t, e) {
      return 1 - 3 * e + 3 * t;
    }
    function a(t, e) {
      return 3 * e - 6 * t;
    }
    function r(t) {
      return 3 * t;
    }
    function f(t, e, s) {
      return ((i(e, s) * t + a(e, s)) * t + r(e)) * t;
    }
    function d(t, e, s) {
      return 3 * i(e, s) * t * t + 2 * a(e, s) * t + r(e);
    }
    function o(t) {
      this._p = t, this._mSampleValues = e ? new Float32Array(l) : new Array(l), this._precomputed = !1, this.get = this.get.bind(this);
    }
    return o.prototype = {
      get: function (t) {
        var e = this._p[0],
          s = this._p[1],
          i = this._p[2],
          a = this._p[3];
        return this._precomputed || this._precompute(), e === s && i === a ? t : 0 === t ? 0 : 1 === t ? 1 : f(this._getTForX(t), s, a);
      },
      _precompute: function () {
        var t = this._p[0],
          e = this._p[1],
          s = this._p[2],
          i = this._p[3];
        this._precomputed = !0, t === e && s === i || this._calcSampleValues();
      },
      _calcSampleValues: function () {
        for (var t = this._p[0], e = this._p[2], s = 0; s < l; ++s) this._mSampleValues[s] = f(s * p, t, e);
      },
      _getTForX: function (t) {
        for (var e = this._p[0], s = this._p[2], i = this._mSampleValues, a = 0, r = 1, n = l - 1; r !== n && i[r] <= t; ++r) a += p;
        var h = a + (t - i[--r]) / (i[r + 1] - i[r]) * p,
          o = d(h, e, s);
        return .001 <= o ? function (t, e, s, i) {
          for (var a = 0; a < 4; ++a) {
            var r = d(e, s, i);
            if (0 === r) return e;
            e -= (f(e, s, i) - t) / r;
          }
          return e;
        }(t, h, e, s) : 0 === o ? h : function (t, e, s, i, a) {
          for (var r, n, h = 0; 0 < (r = f(n = e + (s - e) / 2, i, a) - t) ? s = n : e = n, 1e-7 < Math.abs(r) && ++h < 10;);
          return n;
        }(t, a, a + p, e, s);
      }
    }, t;
  }();
  function z(t, e) {
    var s,
      i,
      a = t.length;
    for (s = 0; s < a; s += 1) for (var r in i = t[s].prototype) Object.prototype.hasOwnProperty.call(i, r) && (e.prototype[r] = i[r]);
  }
  !function () {
    for (var a = 0, t = ["ms", "moz", "webkit", "o"], e = 0; e < t.length && !window.requestAnimationFrame; ++e) window.requestAnimationFrame = window[t[e] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[t[e] + "CancelAnimationFrame"] || window[t[e] + "CancelRequestAnimationFrame"];
    window.requestAnimationFrame || (window.requestAnimationFrame = function (t) {
      var e = new Date().getTime(),
        s = Math.max(0, 16 - (e - a)),
        i = setTimeout(function () {
          t(e + s);
        }, s);
      return a = e + s, i;
    }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function (t) {
      clearTimeout(t);
    });
  }();
  var dt = function () {
      var F = Math;
      function g(t, e, s, i, a, r) {
        var n = t * i + e * a + s * r - a * i - r * t - s * e;
        return -.001 < n && n < .001;
      }
      var p = function (t, e, s, i) {
        var a,
          r,
          n,
          h,
          o,
          l,
          p = P,
          f = 0,
          d = [],
          m = [],
          c = Et.newElement();
        for (n = s.length, a = 0; a < p; a += 1) {
          for (o = a / (p - 1), r = l = 0; r < n; r += 1) h = _(1 - o, 3) * t[r] + 3 * _(1 - o, 2) * o * s[r] + 3 * (1 - o) * _(o, 2) * i[r] + _(o, 3) * e[r], d[r] = h, null !== m[r] && (l += _(d[r] - m[r], 2)), m[r] = d[r];
          l && (f += l = k(l)), c.percents[a] = o, c.lengths[a] = f;
        }
        return c.addedLength = f, c;
      };
      function y(t) {
        this.segmentLength = 0, this.points = new Array(t);
      }
      function v(t, e) {
        this.partialLength = t, this.point = e;
      }
      var b,
        t = (b = {}, function (t, e, s, i) {
          var a = (t[0] + "_" + t[1] + "_" + e[0] + "_" + e[1] + "_" + s[0] + "_" + s[1] + "_" + i[0] + "_" + i[1]).replace(/\./g, "p");
          if (!b[a]) {
            var r,
              n,
              h,
              o,
              l,
              p,
              f,
              d = P,
              m = 0,
              c = null;
            2 === t.length && (t[0] !== e[0] || t[1] !== e[1]) && g(t[0], t[1], e[0], e[1], t[0] + s[0], t[1] + s[1]) && g(t[0], t[1], e[0], e[1], e[0] + i[0], e[1] + i[1]) && (d = 2);
            var u = new y(d);
            for (h = s.length, r = 0; r < d; r += 1) {
              for (f = x(h), l = r / (d - 1), n = p = 0; n < h; n += 1) o = _(1 - l, 3) * t[n] + 3 * _(1 - l, 2) * l * (t[n] + s[n]) + 3 * (1 - l) * _(l, 2) * (e[n] + i[n]) + _(l, 3) * e[n], f[n] = o, null !== c && (p += _(f[n] - c[n], 2));
              m += p = k(p), u.points[r] = new v(p, f), c = f;
            }
            u.segmentLength = m, b[a] = u;
          }
          return b[a];
        });
      function T(t, e) {
        var s = e.percents,
          i = e.lengths,
          a = s.length,
          r = f((a - 1) * t),
          n = t * e.addedLength,
          h = 0;
        if (r === a - 1 || 0 === r || n === i[r]) return s[r];
        for (var o = i[r] > n ? -1 : 1, l = !0; l;) if (i[r] <= n && i[r + 1] > n ? (h = (n - i[r]) / (i[r + 1] - i[r]), l = !1) : r += o, r < 0 || a - 1 <= r) {
          if (r === a - 1) return s[r];
          l = !1;
        }
        return s[r] + (s[r + 1] - s[r]) * h;
      }
      var M = W("float32", 8);
      return {
        getSegmentsLength: function (t) {
          var e,
            s = Mt.newElement(),
            i = t.c,
            a = t.v,
            r = t.o,
            n = t.i,
            h = t._length,
            o = s.lengths,
            l = 0;
          for (e = 0; e < h - 1; e += 1) o[e] = p(a[e], a[e + 1], r[e], n[e + 1]), l += o[e].addedLength;
          return i && h && (o[e] = p(a[e], a[0], r[e], n[0]), l += o[e].addedLength), s.totalLength = l, s;
        },
        getNewSegment: function (t, e, s, i, a, r, n) {
          a < 0 ? a = 0 : 1 < a && (a = 1);
          var h,
            o = T(a, n),
            l = T(r = 1 < r ? 1 : r, n),
            p = t.length,
            f = 1 - o,
            d = 1 - l,
            m = f * f * f,
            c = o * f * f * 3,
            u = o * o * f * 3,
            g = o * o * o,
            y = f * f * d,
            v = o * f * d + f * o * d + f * f * l,
            b = o * o * d + f * o * l + o * f * l,
            _ = o * o * l,
            k = f * d * d,
            A = o * d * d + f * l * d + f * d * l,
            P = o * l * d + f * l * l + o * d * l,
            S = o * l * l,
            D = d * d * d,
            w = l * d * d + d * l * d + d * d * l,
            C = l * l * d + d * l * l + l * d * l,
            x = l * l * l;
          for (h = 0; h < p; h += 1) M[4 * h] = F.round(1e3 * (m * t[h] + c * s[h] + u * i[h] + g * e[h])) / 1e3, M[4 * h + 1] = F.round(1e3 * (y * t[h] + v * s[h] + b * i[h] + _ * e[h])) / 1e3, M[4 * h + 2] = F.round(1e3 * (k * t[h] + A * s[h] + P * i[h] + S * e[h])) / 1e3, M[4 * h + 3] = F.round(1e3 * (D * t[h] + w * s[h] + C * i[h] + x * e[h])) / 1e3;
          return M;
        },
        getPointInSegment: function (t, e, s, i, a, r) {
          var n = T(a, r),
            h = 1 - n;
          return [F.round(1e3 * (h * h * h * t[0] + (n * h * h + h * n * h + h * h * n) * s[0] + (n * n * h + h * n * n + n * h * n) * i[0] + n * n * n * e[0])) / 1e3, F.round(1e3 * (h * h * h * t[1] + (n * h * h + h * n * h + h * h * n) * s[1] + (n * n * h + h * n * n + n * h * n) * i[1] + n * n * n * e[1])) / 1e3];
        },
        buildBezierData: t,
        pointOnLine2D: g,
        pointOnLine3D: function (t, e, s, i, a, r, n, h, o) {
          if (0 === s && 0 === r && 0 === o) return g(t, e, i, a, n, h);
          var l,
            p = F.sqrt(F.pow(i - t, 2) + F.pow(a - e, 2) + F.pow(r - s, 2)),
            f = F.sqrt(F.pow(n - t, 2) + F.pow(h - e, 2) + F.pow(o - s, 2)),
            d = F.sqrt(F.pow(n - i, 2) + F.pow(h - a, 2) + F.pow(o - r, 2));
          return -1e-4 < (l = f < p ? d < p ? p - f - d : d - f - p : f < d ? d - f - p : f - p - d) && l < 1e-4;
        }
      };
    }(),
    N = function () {
      var i,
        a,
        r = 1,
        n = [],
        h = {
          onmessage: function () {},
          postMessage: function (t) {
            i({
              data: t
            });
          }
        },
        s = {
          postMessage: function (t) {
            h.onmessage({
              data: t
            });
          }
        };
      function o() {
        a || ((a = function (t) {
          if (window.Worker && window.Blob && p) {
            var e = new Blob(["var _workerSelf = self; self.onmessage = ", t.toString()], {
                type: "text/javascript"
              }),
              s = URL.createObjectURL(e);
            return new Worker(s);
          }
          return i = t, h;
        }(function (e) {
          if (s.dataManager || (s.dataManager = function () {
            function f(t, e) {
              var s,
                i,
                a,
                r,
                n,
                h,
                o,
                l = t.length;
              for (i = 0; i < l; i += 1) if ("ks" in (s = t[i]) && !s.completed) {
                if (s.completed = !0, s.tt && (t[i - 1].td = s.tt), s.hasMask) {
                  var p = s.masksProperties;
                  for (r = p.length, a = 0; a < r; a += 1) if (p[a].pt.k.i) c(p[a].pt.k);else for (h = p[a].pt.k.length, n = 0; n < h; n += 1) p[a].pt.k[n].s && c(p[a].pt.k[n].s[0]), p[a].pt.k[n].e && c(p[a].pt.k[n].e[0]);
                }
                0 === s.ty ? (s.layers = d(s.refId, e), f(s.layers, e)) : 4 === s.ty ? m(s.shapes) : 5 === s.ty && (0 !== (o = s).t.a.length || "m" in o.t.p || (o.singleShape = !0));
              }
            }
            function d(t, e) {
              for (var s = 0, i = e.length; s < i;) {
                if (e[s].id === t) return e[s].layers.__used ? JSON.parse(JSON.stringify(e[s].layers)) : (e[s].layers.__used = !0, e[s].layers);
                s += 1;
              }
              return null;
            }
            function m(t) {
              var e, s, i;
              for (e = t.length - 1; 0 <= e; e -= 1) if ("sh" === t[e].ty) {
                if (t[e].ks.k.i) c(t[e].ks.k);else for (i = t[e].ks.k.length, s = 0; s < i; s += 1) t[e].ks.k[s].s && c(t[e].ks.k[s].s[0]), t[e].ks.k[s].e && c(t[e].ks.k[s].e[0]);
              } else "gr" === t[e].ty && m(t[e].it);
            }
            function c(t) {
              var e,
                s = t.i.length;
              for (e = 0; e < s; e += 1) t.i[e][0] += t.v[e][0], t.i[e][1] += t.v[e][1], t.o[e][0] += t.v[e][0], t.o[e][1] += t.v[e][1];
            }
            function h(t, e) {
              var s = e ? e.split(".") : [100, 100, 100];
              return t[0] > s[0] || !(s[0] > t[0]) && (t[1] > s[1] || !(s[1] > t[1]) && (t[2] > s[2] || !(s[2] > t[2]) && null));
            }
            var o,
              e = function () {
                var i = [4, 4, 14];
                function a(t) {
                  var e,
                    s,
                    i,
                    a = t.length;
                  for (e = 0; e < a; e += 1) 5 === t[e].ty && (s = t[e], i = s.t.d, s.t.d = {
                    k: [{
                      s: i,
                      t: 0
                    }]
                  });
                }
                return function (t) {
                  if (h(i, t.v) && (a(t.layers), t.assets)) {
                    var e,
                      s = t.assets.length;
                    for (e = 0; e < s; e += 1) t.assets[e].layers && a(t.assets[e].layers);
                  }
                };
              }(),
              s = (o = [4, 7, 99], function (t) {
                if (t.chars && !h(o, t.v)) {
                  var e,
                    s,
                    i,
                    a,
                    r,
                    n = t.chars.length;
                  for (e = 0; e < n; e += 1) if (t.chars[e].data && t.chars[e].data.shapes) for (i = (r = t.chars[e].data.shapes[0].it).length, s = 0; s < i; s += 1) (a = r[s].ks.k).__converted || (c(r[s].ks.k), a.__converted = !0);
                }
              }),
              i = function () {
                var i = [5, 7, 15];
                function a(t) {
                  var e,
                    s,
                    i,
                    a = t.length;
                  for (e = 0; e < a; e += 1) 5 === t[e].ty && (s = t[e], i = void 0, "number" == typeof (i = s.t.p).a && (i.a = {
                    a: 0,
                    k: i.a
                  }), "number" == typeof i.p && (i.p = {
                    a: 0,
                    k: i.p
                  }), "number" == typeof i.r && (i.r = {
                    a: 0,
                    k: i.r
                  }));
                }
                return function (t) {
                  if (h(i, t.v) && (a(t.layers), t.assets)) {
                    var e,
                      s = t.assets.length;
                    for (e = 0; e < s; e += 1) t.assets[e].layers && a(t.assets[e].layers);
                  }
                };
              }(),
              a = function () {
                var i = [4, 1, 9];
                function r(t) {
                  var e,
                    s,
                    i,
                    a = t.length;
                  for (e = 0; e < a; e += 1) if ("gr" === t[e].ty) r(t[e].it);else if ("fl" === t[e].ty || "st" === t[e].ty) if (t[e].c.k && t[e].c.k[0].i) for (i = t[e].c.k.length, s = 0; s < i; s += 1) t[e].c.k[s].s && (t[e].c.k[s].s[0] /= 255, t[e].c.k[s].s[1] /= 255, t[e].c.k[s].s[2] /= 255, t[e].c.k[s].s[3] /= 255), t[e].c.k[s].e && (t[e].c.k[s].e[0] /= 255, t[e].c.k[s].e[1] /= 255, t[e].c.k[s].e[2] /= 255, t[e].c.k[s].e[3] /= 255);else t[e].c.k[0] /= 255, t[e].c.k[1] /= 255, t[e].c.k[2] /= 255, t[e].c.k[3] /= 255;
                }
                function a(t) {
                  var e,
                    s = t.length;
                  for (e = 0; e < s; e += 1) 4 === t[e].ty && r(t[e].shapes);
                }
                return function (t) {
                  if (h(i, t.v) && (a(t.layers), t.assets)) {
                    var e,
                      s = t.assets.length;
                    for (e = 0; e < s; e += 1) t.assets[e].layers && a(t.assets[e].layers);
                  }
                };
              }(),
              r = function () {
                var i = [4, 4, 18];
                function l(t) {
                  var e, s, i;
                  for (e = t.length - 1; 0 <= e; e -= 1) if ("sh" === t[e].ty) {
                    if (t[e].ks.k.i) t[e].ks.k.c = t[e].closed;else for (i = t[e].ks.k.length, s = 0; s < i; s += 1) t[e].ks.k[s].s && (t[e].ks.k[s].s[0].c = t[e].closed), t[e].ks.k[s].e && (t[e].ks.k[s].e[0].c = t[e].closed);
                  } else "gr" === t[e].ty && l(t[e].it);
                }
                function a(t) {
                  var e,
                    s,
                    i,
                    a,
                    r,
                    n,
                    h = t.length;
                  for (s = 0; s < h; s += 1) {
                    if ((e = t[s]).hasMask) {
                      var o = e.masksProperties;
                      for (a = o.length, i = 0; i < a; i += 1) if (o[i].pt.k.i) o[i].pt.k.c = o[i].cl;else for (n = o[i].pt.k.length, r = 0; r < n; r += 1) o[i].pt.k[r].s && (o[i].pt.k[r].s[0].c = o[i].cl), o[i].pt.k[r].e && (o[i].pt.k[r].e[0].c = o[i].cl);
                    }
                    4 === e.ty && l(e.shapes);
                  }
                }
                return function (t) {
                  if (h(i, t.v) && (a(t.layers), t.assets)) {
                    var e,
                      s = t.assets.length;
                    for (e = 0; e < s; e += 1) t.assets[e].layers && a(t.assets[e].layers);
                  }
                };
              }();
            var t = {
              completeData: function (t) {
                t.__complete || (a(t), e(t), s(t), i(t), r(t), f(t.layers, t.assets), t.__complete = !0);
              }
            };
            return t.checkColors = a, t.checkChars = s, t.checkPathProperties = i, t.checkShapes = r, t.completeLayers = f, t;
          }()), s.assetLoader || (s.assetLoader = function () {
            function n(t) {
              var e = t.getResponseHeader("content-type");
              return e && "json" === t.responseType && -1 !== e.indexOf("json") ? t.response : t.response && "object" == typeof t.response ? t.response : t.response && "string" == typeof t.response ? JSON.parse(t.response) : t.responseText ? JSON.parse(t.responseText) : null;
            }
            return {
              load: function (e, s, t, i) {
                var a,
                  r = new XMLHttpRequest();
                try {
                  r.responseType = "json";
                } catch (t) {}
                r.onreadystatechange = function () {
                  if (4 === r.readyState) if (200 === r.status) a = n(r), t(a);else try {
                    a = n(r), t(a);
                  } catch (t) {
                    i && i(t);
                  }
                };
                try {
                  r.open("GET", e, !0);
                } catch (t) {
                  r.open("GET", s + "/" + e, !0);
                }
                r.send();
              }
            };
          }()), "loadAnimation" === e.data.type) s.assetLoader.load(e.data.path, e.data.fullPath, function (t) {
            s.dataManager.completeData(t), s.postMessage({
              id: e.data.id,
              payload: t,
              status: "success"
            });
          }, function () {
            s.postMessage({
              id: e.data.id,
              status: "error"
            });
          });else if ("complete" === e.data.type) {
            var t = e.data.animation;
            s.dataManager.completeData(t), s.postMessage({
              id: e.data.id,
              payload: t,
              status: "success"
            });
          } else "loadData" === e.data.type && s.assetLoader.load(e.data.path, e.data.fullPath, function (t) {
            s.postMessage({
              id: e.data.id,
              payload: t,
              status: "success"
            });
          }, function () {
            s.postMessage({
              id: e.data.id,
              status: "error"
            });
          });
        })).onmessage = function (t) {
          var e = t.data,
            s = e.id,
            i = n[s];
          n[s] = null, "success" === e.status ? i.onComplete(e.payload) : i.onError && i.onError();
        });
      }
      function l(t, e) {
        var s = "processId_" + (r += 1);
        return n[s] = {
          onComplete: t,
          onError: e
        }, s;
      }
      return {
        loadAnimation: function (t, e, s) {
          o();
          var i = l(e, s);
          a.postMessage({
            type: "loadAnimation",
            path: t,
            fullPath: window.location.origin + window.location.pathname,
            id: i
          });
        },
        loadData: function (t, e, s) {
          o();
          var i = l(e, s);
          a.postMessage({
            type: "loadData",
            path: t,
            fullPath: window.location.origin + window.location.pathname,
            id: i
          });
        },
        completeAnimation: function (t, e, s) {
          o();
          var i = l(e, s);
          a.postMessage({
            type: "complete",
            animation: t,
            id: i
          });
        }
      };
    }();
  function q(t) {
    for (var e = t.fStyle ? t.fStyle.split(" ") : [], s = "normal", i = "normal", a = e.length, r = 0; r < a; r += 1) switch (e[r].toLowerCase()) {
      case "italic":
        i = "italic";
        break;
      case "bold":
        s = "700";
        break;
      case "black":
        s = "900";
        break;
      case "medium":
        s = "500";
        break;
      case "regular":
      case "normal":
        s = "400";
        break;
      case "light":
      case "thin":
        s = "200";
    }
    return {
      style: i,
      weight: t.fWeight || s
    };
  }
  var O = function () {
      var r = {
          w: 0,
          size: 0,
          shapes: []
        },
        e = [];
      e = e.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
      var i = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"],
        s = [65039, 8205];
      function d(t, e) {
        var s = T("span");
        s.setAttribute("aria-hidden", !0), s.style.fontFamily = e;
        var i = T("span");
        i.innerText = "giItT1WQy@!-/#", s.style.position = "absolute", s.style.left = "-10000px", s.style.top = "-10000px", s.style.fontSize = "300px", s.style.fontVariant = "normal", s.style.fontStyle = "normal", s.style.fontWeight = "normal", s.style.letterSpacing = "0", s.appendChild(i), document.body.appendChild(s);
        var a = i.offsetWidth;
        return i.style.fontFamily = function (t) {
          var e,
            s = t.split(","),
            i = s.length,
            a = [];
          for (e = 0; e < i; e += 1) "sans-serif" !== s[e] && "monospace" !== s[e] && a.push(s[e]);
          return a.join(",");
        }(t) + ", " + e, {
          node: i,
          w: a,
          parent: s
        };
      }
      function m(t, e) {
        var s = F("text");
        s.style.fontSize = "100px";
        var i = q(e);
        return s.setAttribute("font-family", e.fFamily), s.setAttribute("font-style", i.style), s.setAttribute("font-weight", i.weight), s.textContent = "1", e.fClass ? (s.style.fontFamily = "inherit", s.setAttribute("class", e.fClass)) : s.style.fontFamily = e.fFamily, t.appendChild(s), T("canvas").getContext("2d").font = e.fWeight + " " + e.fStyle + " 100px " + e.fFamily, s;
      }
      var t = function () {
        this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
      };
      return t.isModifier = function (t, e) {
        var s = t.toString(16) + e.toString(16);
        return -1 !== i.indexOf(s);
      }, t.isZeroWidthJoiner = function (t, e) {
        return e ? t === s[0] && e === s[1] : t === s[1];
      }, t.isCombinedCharacter = function (t) {
        return -1 !== e.indexOf(t);
      }, t.prototype = {
        addChars: function (t) {
          if (t) {
            var e;
            this.chars || (this.chars = []);
            var s,
              i,
              a = t.length,
              r = this.chars.length;
            for (e = 0; e < a; e += 1) {
              for (s = 0, i = !1; s < r;) this.chars[s].style === t[e].style && this.chars[s].fFamily === t[e].fFamily && this.chars[s].ch === t[e].ch && (i = !0), s += 1;
              i || (this.chars.push(t[e]), r += 1);
            }
          }
        },
        addFonts: function (t, e) {
          if (t) {
            if (this.chars) return this.isLoaded = !0, void (this.fonts = t.list);
            var s,
              i = t.list,
              a = i.length,
              r = a;
            for (s = 0; s < a; s += 1) {
              var n,
                h,
                o = !0;
              if (i[s].loaded = !1, i[s].monoCase = d(i[s].fFamily, "monospace"), i[s].sansCase = d(i[s].fFamily, "sans-serif"), i[s].fPath) {
                if ("p" === i[s].fOrigin || 3 === i[s].origin) {
                  if (0 < (n = document.querySelectorAll('style[f-forigin="p"][f-family="' + i[s].fFamily + '"], style[f-origin="3"][f-family="' + i[s].fFamily + '"]')).length && (o = !1), o) {
                    var l = T("style");
                    l.setAttribute("f-forigin", i[s].fOrigin), l.setAttribute("f-origin", i[s].origin), l.setAttribute("f-family", i[s].fFamily), l.type = "text/css", l.innerText = "@font-face {font-family: " + i[s].fFamily + "; font-style: normal; src: url('" + i[s].fPath + "');}", e.appendChild(l);
                  }
                } else if ("g" === i[s].fOrigin || 1 === i[s].origin) {
                  for (n = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), h = 0; h < n.length; h += 1) -1 !== n[h].href.indexOf(i[s].fPath) && (o = !1);
                  if (o) {
                    var p = T("link");
                    p.setAttribute("f-forigin", i[s].fOrigin), p.setAttribute("f-origin", i[s].origin), p.type = "text/css", p.rel = "stylesheet", p.href = i[s].fPath, document.body.appendChild(p);
                  }
                } else if ("t" === i[s].fOrigin || 2 === i[s].origin) {
                  for (n = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), h = 0; h < n.length; h += 1) i[s].fPath === n[h].src && (o = !1);
                  if (o) {
                    var f = T("link");
                    f.setAttribute("f-forigin", i[s].fOrigin), f.setAttribute("f-origin", i[s].origin), f.setAttribute("rel", "stylesheet"), f.setAttribute("href", i[s].fPath), e.appendChild(f);
                  }
                }
              } else i[s].loaded = !0, r -= 1;
              i[s].helper = m(e, i[s]), i[s].cache = {}, this.fonts.push(i[s]);
            }
            0 === r ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
          } else this.isLoaded = !0;
        },
        getCharData: function (t, e, s) {
          for (var i = 0, a = this.chars.length; i < a;) {
            if (this.chars[i].ch === t && this.chars[i].style === e && this.chars[i].fFamily === s) return this.chars[i];
            i += 1;
          }
          return ("string" == typeof t && 13 !== t.charCodeAt(0) || !t) && console && console.warn && !this._warned && (this._warned = !0, console.warn("Missing character from exported characters list: ", t, e, s)), r;
        },
        getFontByName: function (t) {
          for (var e = 0, s = this.fonts.length; e < s;) {
            if (this.fonts[e].fName === t) return this.fonts[e];
            e += 1;
          }
          return this.fonts[0];
        },
        measureText: function (t, e, s) {
          var i = this.getFontByName(e),
            a = t.charCodeAt(0);
          if (!i.cache[a + 1]) {
            var r = i.helper;
            if (" " === t) {
              r.textContent = "|" + t + "|";
              var n = r.getComputedTextLength();
              r.textContent = "||";
              var h = r.getComputedTextLength();
              i.cache[a + 1] = (n - h) / 100;
            } else r.textContent = t, i.cache[a + 1] = r.getComputedTextLength() / 100;
          }
          return i.cache[a + 1] * s;
        },
        checkLoadedFonts: function () {
          var t,
            e,
            s,
            i = this.fonts.length,
            a = i;
          for (t = 0; t < i; t += 1) this.fonts[t].loaded ? a -= 1 : "n" === this.fonts[t].fOrigin || 0 === this.fonts[t].origin ? this.fonts[t].loaded = !0 : (e = this.fonts[t].monoCase.node, s = this.fonts[t].monoCase.w, e.offsetWidth !== s ? (a -= 1, this.fonts[t].loaded = !0) : (e = this.fonts[t].sansCase.node, s = this.fonts[t].sansCase.w, e.offsetWidth !== s && (a -= 1, this.fonts[t].loaded = !0)), this.fonts[t].loaded && (this.fonts[t].sansCase.parent.parentNode.removeChild(this.fonts[t].sansCase.parent), this.fonts[t].monoCase.parent.parentNode.removeChild(this.fonts[t].monoCase.parent)));
          0 !== a && Date.now() - this.initTime < 5e3 ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
        },
        setIsLoaded: function () {
          this.isLoaded = !0;
        }
      }, t;
    }(),
    B = function () {
      var f = s,
        a = Math.abs;
      function d(t, e) {
        var s,
          i = this.offsetTime;
        "multidimensional" === this.propType && (s = W("float32", this.pv.length));
        for (var a, r, n, h, o, l, p, f, d, m = e.lastIndex, c = m, u = this.keyframes.length - 1, g = !0; g;) {
          if (a = this.keyframes[c], r = this.keyframes[c + 1], c === u - 1 && t >= r.t - i) {
            a.h && (a = r), m = 0;
            break;
          }
          if (r.t - i > t) {
            m = c;
            break;
          }
          c < u - 1 ? c += 1 : (m = 0, g = !1);
        }
        n = this.keyframesMetadata[c] || {};
        var y,
          v,
          b,
          _,
          k,
          A,
          P,
          S,
          D,
          w,
          C = r.t - i,
          x = a.t - i;
        if (a.to) {
          n.bezierData || (n.bezierData = dt.buildBezierData(a.s, r.s || a.e, a.to, a.ti));
          var F = n.bezierData;
          if (C <= t || t < x) {
            var T = C <= t ? F.points.length - 1 : 0;
            for (o = F.points[T].point.length, h = 0; h < o; h += 1) s[h] = F.points[T].point[h];
          } else {
            n.__fnct ? d = n.__fnct : (d = H.getBezierEasing(a.o.x, a.o.y, a.i.x, a.i.y, a.n).get, n.__fnct = d), l = d((t - x) / (C - x));
            var M,
              E = F.segmentLength * l,
              I = e.lastFrame < t && e._lastKeyframeIndex === c ? e._lastAddedLength : 0;
            for (f = e.lastFrame < t && e._lastKeyframeIndex === c ? e._lastPoint : 0, g = !0, p = F.points.length; g;) {
              if (I += F.points[f].partialLength, 0 === E || 0 === l || f === F.points.length - 1) {
                for (o = F.points[f].point.length, h = 0; h < o; h += 1) s[h] = F.points[f].point[h];
                break;
              }
              if (I <= E && E < I + F.points[f + 1].partialLength) {
                for (M = (E - I) / F.points[f + 1].partialLength, o = F.points[f].point.length, h = 0; h < o; h += 1) s[h] = F.points[f].point[h] + (F.points[f + 1].point[h] - F.points[f].point[h]) * M;
                break;
              }
              f < p - 1 ? f += 1 : g = !1;
            }
            e._lastPoint = f, e._lastAddedLength = I - F.points[f].partialLength, e._lastKeyframeIndex = c;
          }
        } else {
          var L, V, R, z, N;
          if (u = a.s.length, y = r.s || a.e, this.sh && 1 !== a.h) {
            if (C <= t) s[0] = y[0], s[1] = y[1], s[2] = y[2];else if (t <= x) s[0] = a.s[0], s[1] = a.s[1], s[2] = a.s[2];else {
              var O = B(a.s),
                q = B(y);
              v = s, b = function (t, e, s) {
                var i,
                  a,
                  r,
                  n,
                  h,
                  o = [],
                  l = t[0],
                  p = t[1],
                  f = t[2],
                  d = t[3],
                  m = e[0],
                  c = e[1],
                  u = e[2],
                  g = e[3];
                (a = l * m + p * c + f * u + d * g) < 0 && (a = -a, m = -m, c = -c, u = -u, g = -g);
                h = 1e-6 < 1 - a ? (i = Math.acos(a), r = Math.sin(i), n = Math.sin((1 - s) * i) / r, Math.sin(s * i) / r) : (n = 1 - s, s);
                return o[0] = n * l + h * m, o[1] = n * p + h * c, o[2] = n * f + h * u, o[3] = n * d + h * g, o;
              }(O, q, (t - x) / (C - x)), _ = b[0], k = b[1], A = b[2], P = b[3], S = Math.atan2(2 * k * P - 2 * _ * A, 1 - 2 * k * k - 2 * A * A), D = Math.asin(2 * _ * k + 2 * A * P), w = Math.atan2(2 * _ * P - 2 * k * A, 1 - 2 * _ * _ - 2 * A * A), v[0] = S / j, v[1] = D / j, v[2] = w / j;
            }
          } else for (c = 0; c < u; c += 1) 1 !== a.h && (l = C <= t ? 1 : t < x ? 0 : (a.o.x.constructor === Array ? (n.__fnct || (n.__fnct = []), n.__fnct[c] ? d = n.__fnct[c] : (L = void 0 === a.o.x[c] ? a.o.x[0] : a.o.x[c], V = void 0 === a.o.y[c] ? a.o.y[0] : a.o.y[c], R = void 0 === a.i.x[c] ? a.i.x[0] : a.i.x[c], z = void 0 === a.i.y[c] ? a.i.y[0] : a.i.y[c], d = H.getBezierEasing(L, V, R, z).get, n.__fnct[c] = d)) : n.__fnct ? d = n.__fnct : (L = a.o.x, V = a.o.y, R = a.i.x, z = a.i.y, d = H.getBezierEasing(L, V, R, z).get, a.keyframeMetadata = d), d((t - x) / (C - x)))), y = r.s || a.e, N = 1 === a.h ? a.s[c] : a.s[c] + (y[c] - a.s[c]) * l, "multidimensional" === this.propType ? s[c] = N : s = N;
        }
        return e.lastIndex = m, s;
      }
      function B(t) {
        var e = t[0] * j,
          s = t[1] * j,
          i = t[2] * j,
          a = Math.cos(e / 2),
          r = Math.cos(s / 2),
          n = Math.cos(i / 2),
          h = Math.sin(e / 2),
          o = Math.sin(s / 2),
          l = Math.sin(i / 2);
        return [h * o * n + a * r * l, h * r * n + a * o * l, a * o * n - h * r * l, a * r * n - h * o * l];
      }
      function m() {
        var t = this.comp.renderedFrame - this.offsetTime,
          e = this.keyframes[0].t - this.offsetTime,
          s = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
        if (!(t === this._caching.lastFrame || this._caching.lastFrame !== f && (this._caching.lastFrame >= s && s <= t || this._caching.lastFrame < e && t < e))) {
          this._caching.lastFrame >= t && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
          var i = this.interpolateValue(t, this._caching);
          this.pv = i;
        }
        return this._caching.lastFrame = t, this.pv;
      }
      function c(t) {
        var e;
        if ("unidimensional" === this.propType) e = t * this.mult, 1e-5 < a(this.v - e) && (this.v = e, this._mdf = !0);else for (var s = 0, i = this.v.length; s < i;) e = t[s] * this.mult, 1e-5 < a(this.v[s] - e) && (this.v[s] = e, this._mdf = !0), s += 1;
      }
      function u() {
        if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length) if (this.lock) this.setVValue(this.pv);else {
          var t;
          this.lock = !0, this._mdf = this._isFirstFrame;
          var e = this.effectsSequence.length,
            s = this.kf ? this.pv : this.data.k;
          for (t = 0; t < e; t += 1) s = this.effectsSequence[t](s);
          this.setVValue(s), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
        }
      }
      function g(t) {
        this.effectsSequence.push(t), this.container.addDynamicProperty(this);
      }
      function n(t, e, s, i) {
        this.propType = "unidimensional", this.mult = s || 1, this.data = e, this.v = s ? e.k * s : e.k, this.pv = e.k, this._mdf = !1, this.elem = t, this.container = i, this.comp = t.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = u, this.setVValue = c, this.addEffect = g;
      }
      function h(t, e, s, i) {
        var a;
        this.propType = "multidimensional", this.mult = s || 1, this.data = e, this._mdf = !1, this.elem = t, this.container = i, this.comp = t.comp, this.k = !1, this.kf = !1, this.frameId = -1;
        var r = e.k.length;
        for (this.v = W("float32", r), this.pv = W("float32", r), this.vel = W("float32", r), a = 0; a < r; a += 1) this.v[a] = e.k[a] * this.mult, this.pv[a] = e.k[a];
        this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = u, this.setVValue = c, this.addEffect = g;
      }
      function o(t, e, s, i) {
        this.propType = "unidimensional", this.keyframes = e.k, this.keyframesMetadata = [], this.offsetTime = t.data.st, this.frameId = -1, this._caching = {
          lastFrame: f,
          lastIndex: 0,
          value: 0,
          _lastKeyframeIndex: -1
        }, this.k = !0, this.kf = !0, this.data = e, this.mult = s || 1, this.elem = t, this.container = i, this.comp = t.comp, this.v = f, this.pv = f, this._isFirstFrame = !0, this.getValue = u, this.setVValue = c, this.interpolateValue = d, this.effectsSequence = [m.bind(this)], this.addEffect = g;
      }
      function l(t, e, s, i) {
        var a;
        this.propType = "multidimensional";
        var r,
          n,
          h,
          o,
          l = e.k.length;
        for (a = 0; a < l - 1; a += 1) e.k[a].to && e.k[a].s && e.k[a + 1] && e.k[a + 1].s && (r = e.k[a].s, n = e.k[a + 1].s, h = e.k[a].to, o = e.k[a].ti, (2 === r.length && (r[0] !== n[0] || r[1] !== n[1]) && dt.pointOnLine2D(r[0], r[1], n[0], n[1], r[0] + h[0], r[1] + h[1]) && dt.pointOnLine2D(r[0], r[1], n[0], n[1], n[0] + o[0], n[1] + o[1]) || 3 === r.length && (r[0] !== n[0] || r[1] !== n[1] || r[2] !== n[2]) && dt.pointOnLine3D(r[0], r[1], r[2], n[0], n[1], n[2], r[0] + h[0], r[1] + h[1], r[2] + h[2]) && dt.pointOnLine3D(r[0], r[1], r[2], n[0], n[1], n[2], n[0] + o[0], n[1] + o[1], n[2] + o[2])) && (e.k[a].to = null, e.k[a].ti = null), r[0] === n[0] && r[1] === n[1] && 0 === h[0] && 0 === h[1] && 0 === o[0] && 0 === o[1] && (2 === r.length || r[2] === n[2] && 0 === h[2] && 0 === o[2]) && (e.k[a].to = null, e.k[a].ti = null));
        this.effectsSequence = [m.bind(this)], this.data = e, this.keyframes = e.k, this.keyframesMetadata = [], this.offsetTime = t.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = s || 1, this.elem = t, this.container = i, this.comp = t.comp, this.getValue = u, this.setVValue = c, this.interpolateValue = d, this.frameId = -1;
        var p = e.k[0].s.length;
        for (this.v = W("float32", p), this.pv = W("float32", p), a = 0; a < p; a += 1) this.v[a] = f, this.pv[a] = f;
        this._caching = {
          lastFrame: f,
          lastIndex: 0,
          value: W("float32", p)
        }, this.addEffect = g;
      }
      return {
        getProp: function (t, e, s, i, a) {
          var r;
          if (e.k.length) {
            if ("number" == typeof e.k[0]) r = new h(t, e, i, a);else switch (s) {
              case 0:
                r = new o(t, e, i, a);
                break;
              case 1:
                r = new l(t, e, i, a);
            }
          } else r = new n(t, e, i, a);
          return r.effectsSequence.length && a.addDynamicProperty(r), r;
        }
      };
    }(),
    X = function () {
      var n = [0, 0];
      function i(t, e, s) {
        if (this.elem = t, this.frameId = -1, this.propType = "transform", this.data = e, this.v = new R(), this.pre = new R(), this.appliedTransformations = 0, this.initDynamicPropertyContainer(s || t), e.p && e.p.s ? (this.px = B.getProp(t, e.p.x, 0, 0, this), this.py = B.getProp(t, e.p.y, 0, 0, this), e.p.z && (this.pz = B.getProp(t, e.p.z, 0, 0, this))) : this.p = B.getProp(t, e.p || {
          k: [0, 0, 0]
        }, 1, 0, this), e.rx) {
          if (this.rx = B.getProp(t, e.rx, 0, j, this), this.ry = B.getProp(t, e.ry, 0, j, this), this.rz = B.getProp(t, e.rz, 0, j, this), e.or.k[0].ti) {
            var i,
              a = e.or.k.length;
            for (i = 0; i < a; i += 1) e.or.k[i].to = null, e.or.k[i].ti = null;
          }
          this.or = B.getProp(t, e.or, 1, j, this), this.or.sh = !0;
        } else this.r = B.getProp(t, e.r || {
          k: 0
        }, 0, j, this);
        e.sk && (this.sk = B.getProp(t, e.sk, 0, j, this), this.sa = B.getProp(t, e.sa, 0, j, this)), this.a = B.getProp(t, e.a || {
          k: [0, 0, 0]
        }, 1, 0, this), this.s = B.getProp(t, e.s || {
          k: [100, 100, 100]
        }, 1, .01, this), e.o ? this.o = B.getProp(t, e.o, 0, .01, t) : this.o = {
          _mdf: !1,
          v: 1
        }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
      }
      return i.prototype = {
        applyToMatrix: function (t) {
          var e = this._mdf;
          this.iterateDynamicProperties(), this._mdf = this._mdf || e, this.a && t.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && t.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && t.skewFromAxis(-this.sk.v, this.sa.v), this.r ? t.rotate(-this.r.v) : t.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? t.translate(this.px.v, this.py.v, -this.pz.v) : t.translate(this.px.v, this.py.v, 0) : t.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
        },
        getValue: function (t) {
          if (this.elem.globalData.frameId !== this.frameId) {
            if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || t) {
              var e;
              if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
                var s, i;
                if (e = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime) i = this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (s = this.p.getValueAtTime((this.p.keyframes[0].t + .01) / e, 0), this.p.getValueAtTime(this.p.keyframes[0].t / e, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (s = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / e, 0), this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - .05) / e, 0)) : (s = this.p.pv, this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - .01) / e, this.p.offsetTime));else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                  s = [], i = [];
                  var a = this.px,
                    r = this.py;
                  a._caching.lastFrame + a.offsetTime <= a.keyframes[0].t ? (s[0] = a.getValueAtTime((a.keyframes[0].t + .01) / e, 0), s[1] = r.getValueAtTime((r.keyframes[0].t + .01) / e, 0), i[0] = a.getValueAtTime(a.keyframes[0].t / e, 0), i[1] = r.getValueAtTime(r.keyframes[0].t / e, 0)) : a._caching.lastFrame + a.offsetTime >= a.keyframes[a.keyframes.length - 1].t ? (s[0] = a.getValueAtTime(a.keyframes[a.keyframes.length - 1].t / e, 0), s[1] = r.getValueAtTime(r.keyframes[r.keyframes.length - 1].t / e, 0), i[0] = a.getValueAtTime((a.keyframes[a.keyframes.length - 1].t - .01) / e, 0), i[1] = r.getValueAtTime((r.keyframes[r.keyframes.length - 1].t - .01) / e, 0)) : (s = [a.pv, r.pv], i[0] = a.getValueAtTime((a._caching.lastFrame + a.offsetTime - .01) / e, a.offsetTime), i[1] = r.getValueAtTime((r._caching.lastFrame + r.offsetTime - .01) / e, r.offsetTime));
                } else s = i = n;
                this.v.rotate(-Math.atan2(s[1] - i[1], s[0] - i[0]));
              }
              this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
            }
            this.frameId = this.elem.globalData.frameId;
          }
        },
        precalculateMatrix: function () {
          if (!this.a.k && (this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1, !this.s.effectsSequence.length)) {
            if (this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2, this.sk) {
              if (this.sk.effectsSequence.length || this.sa.effectsSequence.length) return;
              this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
            }
            this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : this.rz.effectsSequence.length || this.ry.effectsSequence.length || this.rx.effectsSequence.length || this.or.effectsSequence.length || (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
          }
        },
        autoOrient: function () {}
      }, z([M], i), i.prototype.addDynamicProperty = function (t) {
        this._addDynamicProperty(t), this.elem.addDynamicProperty(t), this._isDirty = !0;
      }, i.prototype._addDynamicProperty = M.prototype.addDynamicProperty, {
        getTransformProperty: function (t, e, s) {
          return new i(t, e, s);
        }
      };
    }();
  function Y() {
    this.c = !1, this._length = 0, this._maxLength = 8, this.v = x(this._maxLength), this.o = x(this._maxLength), this.i = x(this._maxLength);
  }
  Y.prototype.setPathData = function (t, e) {
    this.c = t, this.setLength(e);
    for (var s = 0; s < e;) this.v[s] = xt.newElement(), this.o[s] = xt.newElement(), this.i[s] = xt.newElement(), s += 1;
  }, Y.prototype.setLength = function (t) {
    for (; this._maxLength < t;) this.doubleArrayLength();
    this._length = t;
  }, Y.prototype.doubleArrayLength = function () {
    this.v = this.v.concat(x(this._maxLength)), this.i = this.i.concat(x(this._maxLength)), this.o = this.o.concat(x(this._maxLength)), this._maxLength *= 2;
  }, Y.prototype.setXYAt = function (t, e, s, i, a) {
    var r;
    switch (this._length = Math.max(this._length, i + 1), this._length >= this._maxLength && this.doubleArrayLength(), s) {
      case "v":
        r = this.v;
        break;
      case "i":
        r = this.i;
        break;
      case "o":
        r = this.o;
        break;
      default:
        r = [];
    }
    (!r[i] || r[i] && !a) && (r[i] = xt.newElement()), r[i][0] = t, r[i][1] = e;
  }, Y.prototype.setTripleAt = function (t, e, s, i, a, r, n, h) {
    this.setXYAt(t, e, "v", n, h), this.setXYAt(s, i, "o", n, h), this.setXYAt(a, r, "i", n, h);
  }, Y.prototype.reverse = function () {
    var t = new Y();
    t.setPathData(this.c, this._length);
    var e = this.v,
      s = this.o,
      i = this.i,
      a = 0;
    this.c && (t.setTripleAt(e[0][0], e[0][1], i[0][0], i[0][1], s[0][0], s[0][1], 0, !1), a = 1);
    var r,
      n = this._length - 1,
      h = this._length;
    for (r = a; r < h; r += 1) t.setTripleAt(e[n][0], e[n][1], i[n][0], i[n][1], s[n][0], s[n][1], r, !1), n -= 1;
    return t;
  };
  var G,
    J,
    K = function () {
      var a = -999999;
      function t(t, e, s) {
        var i,
          a,
          r,
          n,
          h,
          o,
          l,
          p,
          f,
          d = s.lastIndex,
          m = this.keyframes;
        if (t < m[0].t - this.offsetTime) i = m[0].s[0], r = !0, d = 0;else if (t >= m[m.length - 1].t - this.offsetTime) i = m[m.length - 1].s ? m[m.length - 1].s[0] : m[m.length - 2].e[0], r = !0;else {
          for (var c, u, g, y = d, v = m.length - 1, b = !0; b && (c = m[y], !((u = m[y + 1]).t - this.offsetTime > t));) y < v - 1 ? y += 1 : b = !1;
          if (g = this.keyframesMetadata[y] || {}, d = y, !(r = 1 === c.h)) {
            if (t >= u.t - this.offsetTime) p = 1;else if (t < c.t - this.offsetTime) p = 0;else {
              var _;
              g.__fnct ? _ = g.__fnct : (_ = H.getBezierEasing(c.o.x, c.o.y, c.i.x, c.i.y).get, g.__fnct = _), p = _((t - (c.t - this.offsetTime)) / (u.t - this.offsetTime - (c.t - this.offsetTime)));
            }
            a = u.s ? u.s[0] : c.e[0];
          }
          i = c.s[0];
        }
        for (o = e._length, l = i.i[0].length, s.lastIndex = d, n = 0; n < o; n += 1) for (h = 0; h < l; h += 1) f = r ? i.i[n][h] : i.i[n][h] + (a.i[n][h] - i.i[n][h]) * p, e.i[n][h] = f, f = r ? i.o[n][h] : i.o[n][h] + (a.o[n][h] - i.o[n][h]) * p, e.o[n][h] = f, f = r ? i.v[n][h] : i.v[n][h] + (a.v[n][h] - i.v[n][h]) * p, e.v[n][h] = f;
      }
      function r() {
        this.paths = this.localShapeCollection;
      }
      function e(t) {
        (function (t, e) {
          if (t._length !== e._length || t.c !== e.c) return !1;
          var s,
            i = t._length;
          for (s = 0; s < i; s += 1) if (t.v[s][0] !== e.v[s][0] || t.v[s][1] !== e.v[s][1] || t.o[s][0] !== e.o[s][0] || t.o[s][1] !== e.o[s][1] || t.i[s][0] !== e.i[s][0] || t.i[s][1] !== e.i[s][1]) return !1;
          return !0;
        })(this.v, t) || (this.v = Ft.clone(t), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
      }
      function s() {
        if (this.elem.globalData.frameId !== this.frameId) if (this.effectsSequence.length) {
          if (this.lock) this.setVValue(this.pv);else {
            var t, e;
            this.lock = !0, this._mdf = !1, t = this.kf ? this.pv : this.data.ks ? this.data.ks.k : this.data.pt.k;
            var s = this.effectsSequence.length;
            for (e = 0; e < s; e += 1) t = this.effectsSequence[e](t);
            this.setVValue(t), this.lock = !1, this.frameId = this.elem.globalData.frameId;
          }
        } else this._mdf = !1;
      }
      function n(t, e, s) {
        this.propType = "shape", this.comp = t.comp, this.container = t, this.elem = t, this.data = e, this.k = !1, this.kf = !1, this._mdf = !1;
        var i = 3 === s ? e.pt.k : e.ks.k;
        this.v = Ft.clone(i), this.pv = Ft.clone(this.v), this.localShapeCollection = Tt.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = r, this.effectsSequence = [];
      }
      function i(t) {
        this.effectsSequence.push(t), this.container.addDynamicProperty(this);
      }
      function h(t, e, s) {
        this.propType = "shape", this.comp = t.comp, this.elem = t, this.container = t, this.offsetTime = t.data.st, this.keyframes = 3 === s ? e.pt.k : e.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
        var i = this.keyframes[0].s[0].i.length;
        this.v = Ft.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, i), this.pv = Ft.clone(this.v), this.localShapeCollection = Tt.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = a, this.reset = r, this._caching = {
          lastFrame: a,
          lastIndex: 0
        }, this.effectsSequence = [function () {
          var t = this.comp.renderedFrame - this.offsetTime,
            e = this.keyframes[0].t - this.offsetTime,
            s = this.keyframes[this.keyframes.length - 1].t - this.offsetTime,
            i = this._caching.lastFrame;
          return i !== a && (i < e && t < e || s < i && s < t) || (this._caching.lastIndex = i < t ? this._caching.lastIndex : 0, this.interpolateShape(t, this.pv, this._caching)), this._caching.lastFrame = t, this.pv;
        }.bind(this)];
      }
      n.prototype.interpolateShape = t, n.prototype.getValue = s, n.prototype.setVValue = e, n.prototype.addEffect = i, h.prototype.getValue = s, h.prototype.interpolateShape = t, h.prototype.setVValue = e, h.prototype.addEffect = i;
      var o = function () {
          var n = v;
          function t(t, e) {
            this.v = Ft.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = Tt.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = e.d, this.elem = t, this.comp = t.comp, this.frameId = -1, this.initDynamicPropertyContainer(t), this.p = B.getProp(t, e.p, 1, 0, this), this.s = B.getProp(t, e.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
          }
          return t.prototype = {
            reset: r,
            getValue: function () {
              this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
            },
            convertEllToPath: function () {
              var t = this.p.v[0],
                e = this.p.v[1],
                s = this.s.v[0] / 2,
                i = this.s.v[1] / 2,
                a = 3 !== this.d,
                r = this.v;
              r.v[0][0] = t, r.v[0][1] = e - i, r.v[1][0] = a ? t + s : t - s, r.v[1][1] = e, r.v[2][0] = t, r.v[2][1] = e + i, r.v[3][0] = a ? t - s : t + s, r.v[3][1] = e, r.i[0][0] = a ? t - s * n : t + s * n, r.i[0][1] = e - i, r.i[1][0] = a ? t + s : t - s, r.i[1][1] = e - i * n, r.i[2][0] = a ? t + s * n : t - s * n, r.i[2][1] = e + i, r.i[3][0] = a ? t - s : t + s, r.i[3][1] = e + i * n, r.o[0][0] = a ? t + s * n : t - s * n, r.o[0][1] = e - i, r.o[1][0] = a ? t + s : t - s, r.o[1][1] = e + i * n, r.o[2][0] = a ? t - s * n : t + s * n, r.o[2][1] = e + i, r.o[3][0] = a ? t - s : t + s, r.o[3][1] = e - i * n;
            }
          }, z([M], t), t;
        }(),
        l = function () {
          function t(t, e) {
            this.v = Ft.newElement(), this.v.setPathData(!0, 0), this.elem = t, this.comp = t.comp, this.data = e, this.frameId = -1, this.d = e.d, this.initDynamicPropertyContainer(t), 1 === e.sy ? (this.ir = B.getProp(t, e.ir, 0, 0, this), this.is = B.getProp(t, e.is, 0, .01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = B.getProp(t, e.pt, 0, 0, this), this.p = B.getProp(t, e.p, 1, 0, this), this.r = B.getProp(t, e.r, 0, j, this), this.or = B.getProp(t, e.or, 0, 0, this), this.os = B.getProp(t, e.os, 0, .01, this), this.localShapeCollection = Tt.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
          }
          return t.prototype = {
            reset: r,
            getValue: function () {
              this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
            },
            convertStarToPath: function () {
              var t,
                e,
                s,
                i,
                a = 2 * Math.floor(this.pt.v),
                r = 2 * Math.PI / a,
                n = !0,
                h = this.or.v,
                o = this.ir.v,
                l = this.os.v,
                p = this.is.v,
                f = 2 * Math.PI * h / (2 * a),
                d = 2 * Math.PI * o / (2 * a),
                m = -Math.PI / 2;
              m += this.r.v;
              var c = 3 === this.data.d ? -1 : 1;
              for (t = this.v._length = 0; t < a; t += 1) {
                s = n ? l : p, i = n ? f : d;
                var u = (e = n ? h : o) * Math.cos(m),
                  g = e * Math.sin(m),
                  y = 0 === u && 0 === g ? 0 : g / Math.sqrt(u * u + g * g),
                  v = 0 === u && 0 === g ? 0 : -u / Math.sqrt(u * u + g * g);
                u += +this.p.v[0], g += +this.p.v[1], this.v.setTripleAt(u, g, u - y * i * s * c, g - v * i * s * c, u + y * i * s * c, g + v * i * s * c, t, !0), n = !n, m += r * c;
              }
            },
            convertPolygonToPath: function () {
              var t,
                e = Math.floor(this.pt.v),
                s = 2 * Math.PI / e,
                i = this.or.v,
                a = this.os.v,
                r = 2 * Math.PI * i / (4 * e),
                n = .5 * -Math.PI,
                h = 3 === this.data.d ? -1 : 1;
              for (n += this.r.v, t = this.v._length = 0; t < e; t += 1) {
                var o = i * Math.cos(n),
                  l = i * Math.sin(n),
                  p = 0 === o && 0 === l ? 0 : l / Math.sqrt(o * o + l * l),
                  f = 0 === o && 0 === l ? 0 : -o / Math.sqrt(o * o + l * l);
                o += +this.p.v[0], l += +this.p.v[1], this.v.setTripleAt(o, l, o - p * r * a * h, l - f * r * a * h, o + p * r * a * h, l + f * r * a * h, t, !0), n += s * h;
              }
              this.paths.length = 0, this.paths[0] = this.v;
            }
          }, z([M], t), t;
        }(),
        p = function () {
          function t(t, e) {
            this.v = Ft.newElement(), this.v.c = !0, this.localShapeCollection = Tt.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = t, this.comp = t.comp, this.frameId = -1, this.d = e.d, this.initDynamicPropertyContainer(t), this.p = B.getProp(t, e.p, 1, 0, this), this.s = B.getProp(t, e.s, 1, 0, this), this.r = B.getProp(t, e.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
          }
          return t.prototype = {
            convertRectToPath: function () {
              var t = this.p.v[0],
                e = this.p.v[1],
                s = this.s.v[0] / 2,
                i = this.s.v[1] / 2,
                a = d(s, i, this.r.v),
                r = a * (1 - v);
              this.v._length = 0, 2 === this.d || 1 === this.d ? (this.v.setTripleAt(t + s, e - i + a, t + s, e - i + a, t + s, e - i + r, 0, !0), this.v.setTripleAt(t + s, e + i - a, t + s, e + i - r, t + s, e + i - a, 1, !0), 0 !== a ? (this.v.setTripleAt(t + s - a, e + i, t + s - a, e + i, t + s - r, e + i, 2, !0), this.v.setTripleAt(t - s + a, e + i, t - s + r, e + i, t - s + a, e + i, 3, !0), this.v.setTripleAt(t - s, e + i - a, t - s, e + i - a, t - s, e + i - r, 4, !0), this.v.setTripleAt(t - s, e - i + a, t - s, e - i + r, t - s, e - i + a, 5, !0), this.v.setTripleAt(t - s + a, e - i, t - s + a, e - i, t - s + r, e - i, 6, !0), this.v.setTripleAt(t + s - a, e - i, t + s - r, e - i, t + s - a, e - i, 7, !0)) : (this.v.setTripleAt(t - s, e + i, t - s + r, e + i, t - s, e + i, 2), this.v.setTripleAt(t - s, e - i, t - s, e - i + r, t - s, e - i, 3))) : (this.v.setTripleAt(t + s, e - i + a, t + s, e - i + r, t + s, e - i + a, 0, !0), 0 !== a ? (this.v.setTripleAt(t + s - a, e - i, t + s - a, e - i, t + s - r, e - i, 1, !0), this.v.setTripleAt(t - s + a, e - i, t - s + r, e - i, t - s + a, e - i, 2, !0), this.v.setTripleAt(t - s, e - i + a, t - s, e - i + a, t - s, e - i + r, 3, !0), this.v.setTripleAt(t - s, e + i - a, t - s, e + i - r, t - s, e + i - a, 4, !0), this.v.setTripleAt(t - s + a, e + i, t - s + a, e + i, t - s + r, e + i, 5, !0), this.v.setTripleAt(t + s - a, e + i, t + s - r, e + i, t + s - a, e + i, 6, !0), this.v.setTripleAt(t + s, e + i - a, t + s, e + i - a, t + s, e + i - r, 7, !0)) : (this.v.setTripleAt(t - s, e - i, t - s + r, e - i, t - s, e - i, 1, !0), this.v.setTripleAt(t - s, e + i, t - s, e + i - r, t - s, e + i, 2, !0), this.v.setTripleAt(t + s, e + i, t + s - r, e + i, t + s, e + i, 3, !0)));
            },
            getValue: function () {
              this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
            },
            reset: r
          }, z([M], t), t;
        }();
      var f = {
        getShapeProp: function (t, e, s) {
          var i;
          return 3 === s || 4 === s ? i = (3 === s ? e.pt : e.ks).k.length ? new h(t, e, s) : new n(t, e, s) : 5 === s ? i = new p(t, e) : 6 === s ? i = new o(t, e) : 7 === s && (i = new l(t, e)), i.k && t.addDynamicProperty(i), i;
        },
        getConstructorFunction: function () {
          return n;
        },
        getKeyframedConstructorFunction: function () {
          return h;
        }
      };
      return f;
    }(),
    U = (J = {}, (G = {}).registerModifier = function (t, e) {
      J[t] || (J[t] = e);
    }, G.getModifier = function (t, e, s) {
      return new J[t](e, s);
    }, G);
  function Z() {}
  function Q() {}
  function $() {}
  function tt() {}
  function et() {}
  function st() {
    this._length = 0, this._maxLength = 4, this.shapes = x(this._maxLength);
  }
  function it(t, e, s, i) {
    var a;
    this.elem = t, this.frameId = -1, this.dataProps = x(e.length), this.renderer = s, this.k = !1, this.dashStr = "", this.dashArray = W("float32", e.length ? e.length - 1 : 0), this.dashoffset = W("float32", 1), this.initDynamicPropertyContainer(i);
    var r,
      n = e.length || 0;
    for (a = 0; a < n; a += 1) r = B.getProp(t, e[a].v, 0, 0, this), this.k = r.k || this.k, this.dataProps[a] = {
      n: e[a].n,
      p: r
    };
    this.k || this.getValue(!0), this._isAnimated = this.k;
  }
  function at(t, e, s) {
    this.data = e, this.c = W("uint8c", 4 * e.p);
    var i = e.k.k[0].s ? e.k.k[0].s.length - 4 * e.p : e.k.k.length - 4 * e.p;
    this.o = W("float32", i), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = i, this.initDynamicPropertyContainer(s), this.prop = B.getProp(t, e.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
  }
  Z.prototype.initModifierProperties = function () {}, Z.prototype.addShapeToModifier = function () {}, Z.prototype.addShape = function (t) {
    if (!this.closed) {
      t.sh.container.addDynamicProperty(t.sh);
      var e = {
        shape: t.sh,
        data: t,
        localShapeCollection: Tt.newShapeCollection()
      };
      this.shapes.push(e), this.addShapeToModifier(e), this._isAnimated && t.setAsAnimated();
    }
  }, Z.prototype.init = function (t, e) {
    this.shapes = [], this.elem = t, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, e), this.frameId = s, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
  }, Z.prototype.processKeys = function () {
    this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
  }, z([M], Z), z([Z], Q), Q.prototype.initModifierProperties = function (t, e) {
    this.s = B.getProp(t, e.s, 0, .01, this), this.e = B.getProp(t, e.e, 0, .01, this), this.o = B.getProp(t, e.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = e.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
  }, Q.prototype.addShapeToModifier = function (t) {
    t.pathsData = [];
  }, Q.prototype.calculateShapeEdges = function (t, e, s, i, a) {
    var r = [];
    e <= 1 ? r.push({
      s: t,
      e: e
    }) : 1 <= t ? r.push({
      s: t - 1,
      e: e - 1
    }) : (r.push({
      s: t,
      e: 1
    }), r.push({
      s: 0,
      e: e - 1
    }));
    var n,
      h,
      o = [],
      l = r.length;
    for (n = 0; n < l; n += 1) {
      var p, f;
      if (!((h = r[n]).e * a < i || h.s * a > i + s)) p = h.s * a <= i ? 0 : (h.s * a - i) / s, f = h.e * a >= i + s ? 1 : (h.e * a - i) / s, o.push([p, f]);
    }
    return o.length || o.push([0, 0]), o;
  }, Q.prototype.releasePathsData = function (t) {
    var e,
      s = t.length;
    for (e = 0; e < s; e += 1) Mt.release(t[e]);
    return t.length = 0, t;
  }, Q.prototype.processShapes = function (t) {
    var e, s, i, a;
    if (this._mdf || t) {
      var r = this.o.v % 360 / 360;
      if (r < 0 && (r += 1), e = 1 < this.s.v ? 1 + r : this.s.v < 0 ? 0 + r : this.s.v + r, (s = 1 < this.e.v ? 1 + r : this.e.v < 0 ? 0 + r : this.e.v + r) < e) {
        var n = e;
        e = s, s = n;
      }
      e = 1e-4 * Math.round(1e4 * e), s = 1e-4 * Math.round(1e4 * s), this.sValue = e, this.eValue = s;
    } else e = this.sValue, s = this.eValue;
    var h,
      o,
      l,
      p,
      f,
      d = this.shapes.length,
      m = 0;
    if (s === e) for (a = 0; a < d; a += 1) this.shapes[a].localShapeCollection.releaseShapes(), this.shapes[a].shape._mdf = !0, this.shapes[a].shape.paths = this.shapes[a].localShapeCollection, this._mdf && (this.shapes[a].pathsData.length = 0);else if (1 === s && 0 === e || 0 === s && 1 === e) {
      if (this._mdf) for (a = 0; a < d; a += 1) this.shapes[a].pathsData.length = 0, this.shapes[a].shape._mdf = !0;
    } else {
      var c,
        u,
        g = [];
      for (a = 0; a < d; a += 1) if ((c = this.shapes[a]).shape._mdf || this._mdf || t || 2 === this.m) {
        if (o = (i = c.shape.paths)._length, f = 0, !c.shape._mdf && c.pathsData.length) f = c.totalShapeLength;else {
          for (l = this.releasePathsData(c.pathsData), h = 0; h < o; h += 1) p = dt.getSegmentsLength(i.shapes[h]), l.push(p), f += p.totalLength;
          c.totalShapeLength = f, c.pathsData = l;
        }
        m += f, c.shape._mdf = !0;
      } else c.shape.paths = c.localShapeCollection;
      var y,
        v = e,
        b = s,
        _ = 0;
      for (a = d - 1; 0 <= a; a -= 1) if ((c = this.shapes[a]).shape._mdf) {
        for ((u = c.localShapeCollection).releaseShapes(), 2 === this.m && 1 < d ? (y = this.calculateShapeEdges(e, s, c.totalShapeLength, _, m), _ += c.totalShapeLength) : y = [[v, b]], o = y.length, h = 0; h < o; h += 1) {
          v = y[h][0], b = y[h][1], g.length = 0, b <= 1 ? g.push({
            s: c.totalShapeLength * v,
            e: c.totalShapeLength * b
          }) : 1 <= v ? g.push({
            s: c.totalShapeLength * (v - 1),
            e: c.totalShapeLength * (b - 1)
          }) : (g.push({
            s: c.totalShapeLength * v,
            e: c.totalShapeLength
          }), g.push({
            s: 0,
            e: c.totalShapeLength * (b - 1)
          }));
          var k = this.addShapes(c, g[0]);
          if (g[0].s !== g[0].e) {
            if (1 < g.length) if (c.shape.paths.shapes[c.shape.paths._length - 1].c) {
              var A = k.pop();
              this.addPaths(k, u), k = this.addShapes(c, g[1], A);
            } else this.addPaths(k, u), k = this.addShapes(c, g[1]);
            this.addPaths(k, u);
          }
        }
        c.shape.paths = u;
      }
    }
  }, Q.prototype.addPaths = function (t, e) {
    var s,
      i = t.length;
    for (s = 0; s < i; s += 1) e.addShape(t[s]);
  }, Q.prototype.addSegment = function (t, e, s, i, a, r, n) {
    a.setXYAt(e[0], e[1], "o", r), a.setXYAt(s[0], s[1], "i", r + 1), n && a.setXYAt(t[0], t[1], "v", r), a.setXYAt(i[0], i[1], "v", r + 1);
  }, Q.prototype.addSegmentFromArray = function (t, e, s, i) {
    e.setXYAt(t[1], t[5], "o", s), e.setXYAt(t[2], t[6], "i", s + 1), i && e.setXYAt(t[0], t[4], "v", s), e.setXYAt(t[3], t[7], "v", s + 1);
  }, Q.prototype.addShapes = function (t, e, s) {
    var i,
      a,
      r,
      n,
      h,
      o,
      l,
      p,
      f = t.pathsData,
      d = t.shape.paths.shapes,
      m = t.shape.paths._length,
      c = 0,
      u = [],
      g = !0;
    for (p = s ? (h = s._length, s._length) : (s = Ft.newElement(), h = 0), u.push(s), i = 0; i < m; i += 1) {
      for (o = f[i].lengths, s.c = d[i].c, r = d[i].c ? o.length : o.length + 1, a = 1; a < r; a += 1) if (c + (n = o[a - 1]).addedLength < e.s) c += n.addedLength, s.c = !1;else {
        if (c > e.e) {
          s.c = !1;
          break;
        }
        e.s <= c && e.e >= c + n.addedLength ? (this.addSegment(d[i].v[a - 1], d[i].o[a - 1], d[i].i[a], d[i].v[a], s, h, g), g = !1) : (l = dt.getNewSegment(d[i].v[a - 1], d[i].v[a], d[i].o[a - 1], d[i].i[a], (e.s - c) / n.addedLength, (e.e - c) / n.addedLength, o[a - 1]), this.addSegmentFromArray(l, s, h, g), g = !1, s.c = !1), c += n.addedLength, h += 1;
      }
      if (d[i].c && o.length) {
        if (n = o[a - 1], c <= e.e) {
          var y = o[a - 1].addedLength;
          e.s <= c && e.e >= c + y ? (this.addSegment(d[i].v[a - 1], d[i].o[a - 1], d[i].i[0], d[i].v[0], s, h, g), g = !1) : (l = dt.getNewSegment(d[i].v[a - 1], d[i].v[0], d[i].o[a - 1], d[i].i[0], (e.s - c) / y, (e.e - c) / y, o[a - 1]), this.addSegmentFromArray(l, s, h, g), g = !1, s.c = !1);
        } else s.c = !1;
        c += n.addedLength, h += 1;
      }
      if (s._length && (s.setXYAt(s.v[p][0], s.v[p][1], "i", p), s.setXYAt(s.v[s._length - 1][0], s.v[s._length - 1][1], "o", s._length - 1)), c > e.e) break;
      i < m - 1 && (s = Ft.newElement(), g = !0, u.push(s), h = 0);
    }
    return u;
  }, U.registerModifier("tm", Q), z([Z], $), $.prototype.initModifierProperties = function (t, e) {
    this.getValue = this.processKeys, this.rd = B.getProp(t, e.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
  }, $.prototype.processPath = function (t, e) {
    var s,
      i = Ft.newElement();
    i.c = t.c;
    var a,
      r,
      n,
      h,
      o,
      l,
      p,
      f,
      d,
      m,
      c,
      u,
      g = t._length,
      y = 0;
    for (s = 0; s < g; s += 1) a = t.v[s], n = t.o[s], r = t.i[s], a[0] === n[0] && a[1] === n[1] && a[0] === r[0] && a[1] === r[1] ? 0 !== s && s !== g - 1 || t.c ? (h = 0 === s ? t.v[g - 1] : t.v[s - 1], l = (o = Math.sqrt(Math.pow(a[0] - h[0], 2) + Math.pow(a[1] - h[1], 2))) ? Math.min(o / 2, e) / o : 0, p = c = a[0] + (h[0] - a[0]) * l, f = u = a[1] - (a[1] - h[1]) * l, d = p - (p - a[0]) * v, m = f - (f - a[1]) * v, i.setTripleAt(p, f, d, m, c, u, y), y += 1, h = s === g - 1 ? t.v[0] : t.v[s + 1], l = (o = Math.sqrt(Math.pow(a[0] - h[0], 2) + Math.pow(a[1] - h[1], 2))) ? Math.min(o / 2, e) / o : 0, p = d = a[0] + (h[0] - a[0]) * l, f = m = a[1] + (h[1] - a[1]) * l, c = p - (p - a[0]) * v, u = f - (f - a[1]) * v, i.setTripleAt(p, f, d, m, c, u, y)) : i.setTripleAt(a[0], a[1], n[0], n[1], r[0], r[1], y) : i.setTripleAt(t.v[s][0], t.v[s][1], t.o[s][0], t.o[s][1], t.i[s][0], t.i[s][1], y), y += 1;
    return i;
  }, $.prototype.processShapes = function (t) {
    var e,
      s,
      i,
      a,
      r,
      n,
      h = this.shapes.length,
      o = this.rd.v;
    if (0 !== o) for (s = 0; s < h; s += 1) {
      if (n = (r = this.shapes[s]).localShapeCollection, r.shape._mdf || this._mdf || t) for (n.releaseShapes(), r.shape._mdf = !0, e = r.shape.paths.shapes, a = r.shape.paths._length, i = 0; i < a; i += 1) n.addShape(this.processPath(e[i], o));
      r.shape.paths = r.localShapeCollection;
    }
    this.dynamicProperties.length || (this._mdf = !1);
  }, U.registerModifier("rd", $), z([Z], tt), tt.prototype.initModifierProperties = function (t, e) {
    this.getValue = this.processKeys, this.amount = B.getProp(t, e.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
  }, tt.prototype.processPath = function (t, e) {
    var s = e / 100,
      i = [0, 0],
      a = t._length,
      r = 0;
    for (r = 0; r < a; r += 1) i[0] += t.v[r][0], i[1] += t.v[r][1];
    i[0] /= a, i[1] /= a;
    var n,
      h,
      o,
      l,
      p,
      f,
      d = Ft.newElement();
    for (d.c = t.c, r = 0; r < a; r += 1) n = t.v[r][0] + (i[0] - t.v[r][0]) * s, h = t.v[r][1] + (i[1] - t.v[r][1]) * s, o = t.o[r][0] + (i[0] - t.o[r][0]) * -s, l = t.o[r][1] + (i[1] - t.o[r][1]) * -s, p = t.i[r][0] + (i[0] - t.i[r][0]) * -s, f = t.i[r][1] + (i[1] - t.i[r][1]) * -s, d.setTripleAt(n, h, o, l, p, f, r);
    return d;
  }, tt.prototype.processShapes = function (t) {
    var e,
      s,
      i,
      a,
      r,
      n,
      h = this.shapes.length,
      o = this.amount.v;
    if (0 !== o) for (s = 0; s < h; s += 1) {
      if (n = (r = this.shapes[s]).localShapeCollection, r.shape._mdf || this._mdf || t) for (n.releaseShapes(), r.shape._mdf = !0, e = r.shape.paths.shapes, a = r.shape.paths._length, i = 0; i < a; i += 1) n.addShape(this.processPath(e[i], o));
      r.shape.paths = r.localShapeCollection;
    }
    this.dynamicProperties.length || (this._mdf = !1);
  }, U.registerModifier("pb", tt), z([Z], et), et.prototype.initModifierProperties = function (t, e) {
    this.getValue = this.processKeys, this.c = B.getProp(t, e.c, 0, null, this), this.o = B.getProp(t, e.o, 0, null, this), this.tr = X.getTransformProperty(t, e.tr, this), this.so = B.getProp(t, e.tr.so, 0, .01, this), this.eo = B.getProp(t, e.tr.eo, 0, .01, this), this.data = e, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new R(), this.rMatrix = new R(), this.sMatrix = new R(), this.tMatrix = new R(), this.matrix = new R();
  }, et.prototype.applyTransforms = function (t, e, s, i, a, r) {
    var n = r ? -1 : 1,
      h = i.s.v[0] + (1 - i.s.v[0]) * (1 - a),
      o = i.s.v[1] + (1 - i.s.v[1]) * (1 - a);
    t.translate(i.p.v[0] * n * a, i.p.v[1] * n * a, i.p.v[2]), e.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]), e.rotate(-i.r.v * n * a), e.translate(i.a.v[0], i.a.v[1], i.a.v[2]), s.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]), s.scale(r ? 1 / h : h, r ? 1 / o : o), s.translate(i.a.v[0], i.a.v[1], i.a.v[2]);
  }, et.prototype.init = function (t, e, s, i) {
    for (this.elem = t, this.arr = e, this.pos = s, this.elemsData = i, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, e[s]); 0 < s;) s -= 1, this._elements.unshift(e[s]);
    this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
  }, et.prototype.resetElements = function (t) {
    var e,
      s = t.length;
    for (e = 0; e < s; e += 1) t[e]._processed = !1, "gr" === t[e].ty && this.resetElements(t[e].it);
  }, et.prototype.cloneElements = function (t) {
    var e = JSON.parse(JSON.stringify(t));
    return this.resetElements(e), e;
  }, et.prototype.changeGroupRender = function (t, e) {
    var s,
      i = t.length;
    for (s = 0; s < i; s += 1) t[s]._render = e, "gr" === t[s].ty && this.changeGroupRender(t[s].it, e);
  }, et.prototype.processShapes = function (t) {
    var e,
      s,
      i,
      a,
      r,
      n = !1;
    if (this._mdf || t) {
      var h,
        o = Math.ceil(this.c.v);
      if (this._groups.length < o) {
        for (; this._groups.length < o;) {
          var l = {
            it: this.cloneElements(this._elements),
            ty: "gr"
          };
          l.it.push({
            a: {
              a: 0,
              ix: 1,
              k: [0, 0]
            },
            nm: "Transform",
            o: {
              a: 0,
              ix: 7,
              k: 100
            },
            p: {
              a: 0,
              ix: 2,
              k: [0, 0]
            },
            r: {
              a: 1,
              ix: 6,
              k: [{
                s: 0,
                e: 0,
                t: 0
              }, {
                s: 0,
                e: 0,
                t: 1
              }]
            },
            s: {
              a: 0,
              ix: 3,
              k: [100, 100]
            },
            sa: {
              a: 0,
              ix: 5,
              k: 0
            },
            sk: {
              a: 0,
              ix: 4,
              k: 0
            },
            ty: "tr"
          }), this.arr.splice(0, 0, l), this._groups.splice(0, 0, l), this._currentCopies += 1;
        }
        this.elem.reloadShapes(), n = !0;
      }
      for (i = r = 0; i <= this._groups.length - 1; i += 1) {
        if (h = r < o, this._groups[i]._render = h, this.changeGroupRender(this._groups[i].it, h), !h) {
          var p = this.elemsData[i].it,
            f = p[p.length - 1];
          0 !== f.transform.op.v ? (f.transform.op._mdf = !0, f.transform.op.v = 0) : f.transform.op._mdf = !1;
        }
        r += 1;
      }
      this._currentCopies = o;
      var d = this.o.v,
        m = d % 1,
        c = 0 < d ? Math.floor(d) : Math.ceil(d),
        u = this.pMatrix.props,
        g = this.rMatrix.props,
        y = this.sMatrix.props;
      this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
      var v,
        b,
        _ = 0;
      if (0 < d) {
        for (; _ < c;) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), _ += 1;
        m && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, m, !1), _ += m);
      } else if (d < 0) {
        for (; c < _;) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), _ -= 1;
        m && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -m, !0), _ -= m);
      }
      for (i = 1 === this.data.m ? 0 : this._currentCopies - 1, a = 1 === this.data.m ? 1 : -1, r = this._currentCopies; r;) {
        if (b = (s = (e = this.elemsData[i].it)[e.length - 1].transform.mProps.v.props).length, e[e.length - 1].transform.mProps._mdf = !0, e[e.length - 1].transform.op._mdf = !0, e[e.length - 1].transform.op.v = 1 === this._currentCopies ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1)), 0 !== _) {
          for ((0 !== i && 1 === a || i !== this._currentCopies - 1 && -1 === a) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(g[0], g[1], g[2], g[3], g[4], g[5], g[6], g[7], g[8], g[9], g[10], g[11], g[12], g[13], g[14], g[15]), this.matrix.transform(y[0], y[1], y[2], y[3], y[4], y[5], y[6], y[7], y[8], y[9], y[10], y[11], y[12], y[13], y[14], y[15]), this.matrix.transform(u[0], u[1], u[2], u[3], u[4], u[5], u[6], u[7], u[8], u[9], u[10], u[11], u[12], u[13], u[14], u[15]), v = 0; v < b; v += 1) s[v] = this.matrix.props[v];
          this.matrix.reset();
        } else for (this.matrix.reset(), v = 0; v < b; v += 1) s[v] = this.matrix.props[v];
        _ += 1, r -= 1, i += a;
      }
    } else for (r = this._currentCopies, i = 0, a = 1; r;) s = (e = this.elemsData[i].it)[e.length - 1].transform.mProps.v.props, e[e.length - 1].transform.mProps._mdf = !1, e[e.length - 1].transform.op._mdf = !1, r -= 1, i += a;
    return n;
  }, et.prototype.addShape = function () {}, U.registerModifier("rp", et), st.prototype.addShape = function (t) {
    this._length === this._maxLength && (this.shapes = this.shapes.concat(x(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = t, this._length += 1;
  }, st.prototype.releaseShapes = function () {
    var t;
    for (t = 0; t < this._length; t += 1) Ft.release(this.shapes[t]);
    this._length = 0;
  }, it.prototype.getValue = function (t) {
    if ((this.elem.globalData.frameId !== this.frameId || t) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || t, this._mdf)) {
      var e = 0,
        s = this.dataProps.length;
      for ("svg" === this.renderer && (this.dashStr = ""), e = 0; e < s; e += 1) "o" !== this.dataProps[e].n ? "svg" === this.renderer ? this.dashStr += " " + this.dataProps[e].p.v : this.dashArray[e] = this.dataProps[e].p.v : this.dashoffset[0] = this.dataProps[e].p.v;
    }
  }, z([M], it), at.prototype.comparePoints = function (t, e) {
    for (var s = 0, i = this.o.length / 2; s < i;) {
      if (.01 < Math.abs(t[4 * s] - t[4 * e + 2 * s])) return !1;
      s += 1;
    }
    return !0;
  }, at.prototype.checkCollapsable = function () {
    if (this.o.length / 2 != this.c.length / 4) return !1;
    if (this.data.k.k[0].s) for (var t = 0, e = this.data.k.k.length; t < e;) {
      if (!this.comparePoints(this.data.k.k[t].s, this.data.p)) return !1;
      t += 1;
    } else if (!this.comparePoints(this.data.k.k, this.data.p)) return !1;
    return !0;
  }, at.prototype.getValue = function (t) {
    if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || t) {
      var e,
        s,
        i,
        a = 4 * this.data.p;
      for (e = 0; e < a; e += 1) s = e % 4 == 0 ? 100 : 255, i = Math.round(this.prop.v[e] * s), this.c[e] !== i && (this.c[e] = i, this._cmdf = !t);
      if (this.o.length) for (a = this.prop.v.length, e = 4 * this.data.p; e < a; e += 1) s = e % 2 == 0 ? 100 : 1, i = e % 2 == 0 ? Math.round(100 * this.prop.v[e]) : this.prop.v[e], this.o[e - 4 * this.data.p] !== i && (this.o[e - 4 * this.data.p] = i, this._omdf = !t);
      this._mdf = !t;
    }
  }, z([M], at);
  var rt,
    nt,
    ht = function (t, e, s, i) {
      if (0 === e) return "";
      var a,
        r = t.o,
        n = t.i,
        h = t.v,
        o = " M" + i.applyToPointStringified(h[0][0], h[0][1]);
      for (a = 1; a < e; a += 1) o += " C" + i.applyToPointStringified(r[a - 1][0], r[a - 1][1]) + " " + i.applyToPointStringified(n[a][0], n[a][1]) + " " + i.applyToPointStringified(h[a][0], h[a][1]);
      return s && e && (o += " C" + i.applyToPointStringified(r[a - 1][0], r[a - 1][1]) + " " + i.applyToPointStringified(n[0][0], n[0][1]) + " " + i.applyToPointStringified(h[0][0], h[0][1]), o += "z"), o;
    },
    ot = function () {
      function t(t) {
        this.audios = [], this.audioFactory = t, this._volume = 1, this._isMuted = !1;
      }
      return t.prototype = {
        addAudio: function (t) {
          this.audios.push(t);
        },
        pause: function () {
          var t,
            e = this.audios.length;
          for (t = 0; t < e; t += 1) this.audios[t].pause();
        },
        resume: function () {
          var t,
            e = this.audios.length;
          for (t = 0; t < e; t += 1) this.audios[t].resume();
        },
        setRate: function (t) {
          var e,
            s = this.audios.length;
          for (e = 0; e < s; e += 1) this.audios[e].setRate(t);
        },
        createAudio: function (t) {
          return this.audioFactory ? this.audioFactory(t) : Howl ? new Howl({
            src: [t]
          }) : {
            isPlaying: !1,
            play: function () {
              this.isPlaying = !0;
            },
            seek: function () {
              this.isPlaying = !1;
            },
            playing: function () {},
            rate: function () {},
            setVolume: function () {}
          };
        },
        setAudioFactory: function (t) {
          this.audioFactory = t;
        },
        setVolume: function (t) {
          this._volume = t, this._updateVolume();
        },
        mute: function () {
          this._isMuted = !0, this._updateVolume();
        },
        unmute: function () {
          this._isMuted = !1, this._updateVolume();
        },
        getVolume: function () {
          return this._volume;
        },
        _updateVolume: function () {
          var t,
            e = this.audios.length;
          for (t = 0; t < e; t += 1) this.audios[t].volume(this._volume * (this._isMuted ? 0 : 1));
        }
      }, function () {
        return new t();
      };
    }(),
    mt = function () {
      var a = function () {
        var t = T("canvas");
        t.width = 1, t.height = 1;
        var e = t.getContext("2d");
        return e.fillStyle = "rgba(0,0,0,0)", e.fillRect(0, 0, 1, 1), t;
      }();
      function t() {
        this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function e() {
        this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function r(t, e, s) {
        var i = "";
        if (t.e) i = t.p;else if (e) {
          var a = t.p;
          -1 !== a.indexOf("images/") && (a = a.split("/")[1]), i = e + a;
        } else i = s, i += t.u ? t.u : "", i += t.p;
        return i;
      }
      function s() {
        this._imageLoaded = t.bind(this), this._footageLoaded = e.bind(this), this.testImageLoaded = function (t) {
          var e = 0,
            s = setInterval(function () {
              (t.getBBox().width || 500 < e) && (this._imageLoaded(), clearInterval(s)), e += 1;
            }.bind(this), 50);
        }.bind(this), this.createFootageData = function (t) {
          var e = {
              assetData: t
            },
            s = r(t, this.assetsPath, this.path);
          return N.loadData(s, function (t) {
            e.img = t, this._footageLoaded();
          }.bind(this), function () {
            e.img = {}, this._footageLoaded();
          }.bind(this)), e;
        }.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
      }
      return s.prototype = {
        loadAssets: function (t, e) {
          var s;
          this.imagesLoadedCb = e;
          var i = t.length;
          for (s = 0; s < i; s += 1) t[s].layers || (t[s].t && "seq" !== t[s].t ? 3 === t[s].t && (this.totalFootages += 1, this.images.push(this.createFootageData(t[s]))) : (this.totalImages += 1, this.images.push(this._createImageData(t[s]))));
        },
        setAssetsPath: function (t) {
          this.assetsPath = t || "";
        },
        setPath: function (t) {
          this.path = t || "";
        },
        loadedImages: function () {
          return this.totalImages === this.loadedAssets;
        },
        loadedFootages: function () {
          return this.totalFootages === this.loadedFootagesCount;
        },
        destroy: function () {
          this.imagesLoadedCb = null, this.images.length = 0;
        },
        getAsset: function (t) {
          for (var e = 0, s = this.images.length; e < s;) {
            if (this.images[e].assetData === t) return this.images[e].img;
            e += 1;
          }
          return null;
        },
        createImgData: function (t) {
          var e = r(t, this.assetsPath, this.path),
            s = T("img");
          s.crossOrigin = "anonymous", s.addEventListener("load", this._imageLoaded, !1), s.addEventListener("error", function () {
            i.img = a, this._imageLoaded();
          }.bind(this), !1), s.src = e;
          var i = {
            img: s,
            assetData: t
          };
          return i;
        },
        createImageData: function (t) {
          var e = r(t, this.assetsPath, this.path),
            s = F("image");
          n ? this.testImageLoaded(s) : s.addEventListener("load", this._imageLoaded, !1), s.addEventListener("error", function () {
            i.img = a, this._imageLoaded();
          }.bind(this), !1), s.setAttributeNS("http://www.w3.org/1999/xlink", "href", e), this._elementHelper.append ? this._elementHelper.append(s) : this._elementHelper.appendChild(s);
          var i = {
            img: s,
            assetData: t
          };
          return i;
        },
        imageLoaded: t,
        footageLoaded: e,
        setCacheType: function (t, e) {
          this._createImageData = "svg" === t ? (this._elementHelper = e, this.createImageData.bind(this)) : this.createImgData.bind(this);
        }
      }, s;
    }(),
    ct = (rt = {
      maskType: !0
    }, (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (rt.maskType = !1), rt),
    ut = ((nt = {}).createFilter = function (t, e) {
      var s = F("filter");
      return s.setAttribute("id", t), !0 !== e && (s.setAttribute("filterUnits", "objectBoundingBox"), s.setAttribute("x", "0%"), s.setAttribute("y", "0%"), s.setAttribute("width", "100%"), s.setAttribute("height", "100%")), s;
    }, nt.createAlphaToLuminanceFilter = function () {
      var t = F("feColorMatrix");
      return t.setAttribute("type", "matrix"), t.setAttribute("color-interpolation-filters", "sRGB"), t.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), t;
    }, nt);
  function gt(t, e, s) {
    this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = t, this._renderType = e, this._elem = s, this._animatorsData = x(this._textData.a.length), this._pathData = {}, this._moreOptions = {
      alignment: {}
    }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(s);
  }
  function yt(t, e, s) {
    var i = {
        propType: !1
      },
      a = B.getProp,
      r = e.a;
    this.a = {
      r: r.r ? a(t, r.r, 0, j, s) : i,
      rx: r.rx ? a(t, r.rx, 0, j, s) : i,
      ry: r.ry ? a(t, r.ry, 0, j, s) : i,
      sk: r.sk ? a(t, r.sk, 0, j, s) : i,
      sa: r.sa ? a(t, r.sa, 0, j, s) : i,
      s: r.s ? a(t, r.s, 1, .01, s) : i,
      a: r.a ? a(t, r.a, 1, 0, s) : i,
      o: r.o ? a(t, r.o, 0, .01, s) : i,
      p: r.p ? a(t, r.p, 1, 0, s) : i,
      sw: r.sw ? a(t, r.sw, 0, 0, s) : i,
      sc: r.sc ? a(t, r.sc, 1, 0, s) : i,
      fc: r.fc ? a(t, r.fc, 1, 0, s) : i,
      fh: r.fh ? a(t, r.fh, 0, 0, s) : i,
      fs: r.fs ? a(t, r.fs, 0, .01, s) : i,
      fb: r.fb ? a(t, r.fb, 0, .01, s) : i,
      t: r.t ? a(t, r.t, 0, 0, s) : i
    }, this.s = Dt.getTextSelectorProp(t, e.s, s), this.s.t = e.s.t;
  }
  function vt(t, e, s, i, a, r) {
    this.o = t, this.sw = e, this.sc = s, this.fc = i, this.m = a, this.p = r, this._mdf = {
      o: !0,
      sw: !!e,
      sc: !!s,
      fc: !!i,
      m: !0,
      p: !0
    };
  }
  function bt(t, e) {
    this._frameId = s, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, this.data = e, this.elem = t, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
      ascent: 0,
      boxWidth: this.defaultBoxWidth,
      f: "",
      fStyle: "",
      fWeight: "",
      fc: "",
      j: "",
      justifyOffset: "",
      l: [],
      lh: 0,
      lineWidths: [],
      ls: "",
      of: "",
      s: "",
      sc: "",
      sw: 0,
      t: 0,
      tr: 0,
      sz: 0,
      ps: null,
      fillColorAnim: !1,
      strokeColorAnim: !1,
      strokeWidthAnim: !1,
      yOffset: 0,
      finalSize: 0,
      finalText: [],
      finalLineHeight: 0,
      __complete: !1
    }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
  }
  gt.prototype.searchProperties = function () {
    var t,
      e,
      s = this._textData.a.length,
      i = B.getProp;
    for (t = 0; t < s; t += 1) e = this._textData.a[t], this._animatorsData[t] = new yt(this._elem, e, this);
    this._textData.p && "m" in this._textData.p ? (this._pathData = {
      a: i(this._elem, this._textData.p.a, 0, 0, this),
      f: i(this._elem, this._textData.p.f, 0, 0, this),
      l: i(this._elem, this._textData.p.l, 0, 0, this),
      r: i(this._elem, this._textData.p.r, 0, 0, this),
      p: i(this._elem, this._textData.p.p, 0, 0, this),
      m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
    }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = i(this._elem, this._textData.m.a, 1, 0, this);
  }, gt.prototype.getMeasures = function (t, e) {
    if (this.lettersChangedFlag = e, this._mdf || this._isFirstFrame || e || this._hasMaskedPath && this._pathData.m._mdf) {
      this._isFirstFrame = !1;
      var s,
        i,
        a,
        r,
        n,
        h,
        o,
        l,
        p,
        f,
        d,
        m,
        c,
        u,
        g,
        y,
        v,
        b,
        _,
        k = this._moreOptions.alignment.v,
        A = this._animatorsData,
        P = this._textData,
        S = this.mHelper,
        D = this._renderType,
        w = this.renderedLetters.length,
        C = t.l;
      if (this._hasMaskedPath) {
        if (_ = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
          var x,
            F = _.v;
          for (this._pathData.r.v && (F = F.reverse()), n = {
            tLength: 0,
            segments: []
          }, r = F._length - 1, a = y = 0; a < r; a += 1) x = dt.buildBezierData(F.v[a], F.v[a + 1], [F.o[a][0] - F.v[a][0], F.o[a][1] - F.v[a][1]], [F.i[a + 1][0] - F.v[a + 1][0], F.i[a + 1][1] - F.v[a + 1][1]]), n.tLength += x.segmentLength, n.segments.push(x), y += x.segmentLength;
          a = r, _.v.c && (x = dt.buildBezierData(F.v[a], F.v[0], [F.o[a][0] - F.v[a][0], F.o[a][1] - F.v[a][1]], [F.i[0][0] - F.v[0][0], F.i[0][1] - F.v[0][1]]), n.tLength += x.segmentLength, n.segments.push(x), y += x.segmentLength), this._pathData.pi = n;
        }
        if (n = this._pathData.pi, h = this._pathData.f.v, f = 1, p = !(l = d = 0), u = n.segments, h < 0 && _.v.c) for (n.tLength < Math.abs(h) && (h = -Math.abs(h) % n.tLength), f = (c = u[d = u.length - 1].points).length - 1; h < 0;) h += c[f].partialLength, (f -= 1) < 0 && (f = (c = u[d -= 1].points).length - 1);
        m = (c = u[d].points)[f - 1], g = (o = c[f]).partialLength;
      }
      r = C.length, i = s = 0;
      var T,
        M,
        E,
        I,
        L,
        V = 1.2 * t.finalSize * .714,
        R = !0;
      E = A.length;
      var z,
        N,
        O,
        q,
        B,
        j,
        W,
        H,
        X,
        Y,
        G,
        J,
        K = -1,
        U = h,
        Z = d,
        Q = f,
        $ = -1,
        tt = "",
        et = this.defaultPropsArray;
      if (2 === t.j || 1 === t.j) {
        var st = 0,
          it = 0,
          at = 2 === t.j ? -.5 : -1,
          rt = 0,
          nt = !0;
        for (a = 0; a < r; a += 1) if (C[a].n) {
          for (st && (st += it); rt < a;) C[rt].animatorJustifyOffset = st, rt += 1;
          nt = !(st = 0);
        } else {
          for (M = 0; M < E; M += 1) (T = A[M].a).t.propType && (nt && 2 === t.j && (it += T.t.v * at), (L = A[M].s.getMult(C[a].anIndexes[M], P.a[M].s.totalChars)).length ? st += T.t.v * L[0] * at : st += T.t.v * L * at);
          nt = !1;
        }
        for (st && (st += it); rt < a;) C[rt].animatorJustifyOffset = st, rt += 1;
      }
      for (a = 0; a < r; a += 1) {
        if (S.reset(), q = 1, C[a].n) s = 0, i += t.yOffset, i += R ? 1 : 0, h = U, R = !1, this._hasMaskedPath && (f = Q, m = (c = u[d = Z].points)[f - 1], g = (o = c[f]).partialLength, l = 0), J = X = G = tt = "", et = this.defaultPropsArray;else {
          if (this._hasMaskedPath) {
            if ($ !== C[a].line) {
              switch (t.j) {
                case 1:
                  h += y - t.lineWidths[C[a].line];
                  break;
                case 2:
                  h += (y - t.lineWidths[C[a].line]) / 2;
              }
              $ = C[a].line;
            }
            K !== C[a].ind && (C[K] && (h += C[K].extra), h += C[a].an / 2, K = C[a].ind), h += k[0] * C[a].an * .005;
            var ht = 0;
            for (M = 0; M < E; M += 1) (T = A[M].a).p.propType && ((L = A[M].s.getMult(C[a].anIndexes[M], P.a[M].s.totalChars)).length ? ht += T.p.v[0] * L[0] : ht += T.p.v[0] * L), T.a.propType && ((L = A[M].s.getMult(C[a].anIndexes[M], P.a[M].s.totalChars)).length ? ht += T.a.v[0] * L[0] : ht += T.a.v[0] * L);
            for (p = !0, this._pathData.a.v && (h = .5 * C[0].an + (y - this._pathData.f.v - .5 * C[0].an - .5 * C[C.length - 1].an) * K / (r - 1), h += this._pathData.f.v); p;) h + ht <= l + g || !c ? (v = (h + ht - l) / o.partialLength, N = m.point[0] + (o.point[0] - m.point[0]) * v, O = m.point[1] + (o.point[1] - m.point[1]) * v, S.translate(-k[0] * C[a].an * .005, -k[1] * V * .01), p = !1) : c && (l += o.partialLength, (f += 1) >= c.length && (f = 0, c = u[d += 1] ? u[d].points : _.v.c ? u[d = f = 0].points : (l -= o.partialLength, null)), c && (m = o, g = (o = c[f]).partialLength));
            z = C[a].an / 2 - C[a].add, S.translate(-z, 0, 0);
          } else z = C[a].an / 2 - C[a].add, S.translate(-z, 0, 0), S.translate(-k[0] * C[a].an * .005, -k[1] * V * .01, 0);
          for (M = 0; M < E; M += 1) (T = A[M].a).t.propType && (L = A[M].s.getMult(C[a].anIndexes[M], P.a[M].s.totalChars), 0 === s && 0 === t.j || (this._hasMaskedPath ? L.length ? h += T.t.v * L[0] : h += T.t.v * L : L.length ? s += T.t.v * L[0] : s += T.t.v * L));
          for (t.strokeWidthAnim && (j = t.sw || 0), t.strokeColorAnim && (B = t.sc ? [t.sc[0], t.sc[1], t.sc[2]] : [0, 0, 0]), t.fillColorAnim && t.fc && (W = [t.fc[0], t.fc[1], t.fc[2]]), M = 0; M < E; M += 1) (T = A[M].a).a.propType && ((L = A[M].s.getMult(C[a].anIndexes[M], P.a[M].s.totalChars)).length ? S.translate(-T.a.v[0] * L[0], -T.a.v[1] * L[1], T.a.v[2] * L[2]) : S.translate(-T.a.v[0] * L, -T.a.v[1] * L, T.a.v[2] * L));
          for (M = 0; M < E; M += 1) (T = A[M].a).s.propType && ((L = A[M].s.getMult(C[a].anIndexes[M], P.a[M].s.totalChars)).length ? S.scale(1 + (T.s.v[0] - 1) * L[0], 1 + (T.s.v[1] - 1) * L[1], 1) : S.scale(1 + (T.s.v[0] - 1) * L, 1 + (T.s.v[1] - 1) * L, 1));
          for (M = 0; M < E; M += 1) {
            if (T = A[M].a, L = A[M].s.getMult(C[a].anIndexes[M], P.a[M].s.totalChars), T.sk.propType && (L.length ? S.skewFromAxis(-T.sk.v * L[0], T.sa.v * L[1]) : S.skewFromAxis(-T.sk.v * L, T.sa.v * L)), T.r.propType && (L.length ? S.rotateZ(-T.r.v * L[2]) : S.rotateZ(-T.r.v * L)), T.ry.propType && (L.length ? S.rotateY(T.ry.v * L[1]) : S.rotateY(T.ry.v * L)), T.rx.propType && (L.length ? S.rotateX(T.rx.v * L[0]) : S.rotateX(T.rx.v * L)), T.o.propType && (L.length ? q += (T.o.v * L[0] - q) * L[0] : q += (T.o.v * L - q) * L), t.strokeWidthAnim && T.sw.propType && (L.length ? j += T.sw.v * L[0] : j += T.sw.v * L), t.strokeColorAnim && T.sc.propType) for (H = 0; H < 3; H += 1) L.length ? B[H] += (T.sc.v[H] - B[H]) * L[0] : B[H] += (T.sc.v[H] - B[H]) * L;
            if (t.fillColorAnim && t.fc) {
              if (T.fc.propType) for (H = 0; H < 3; H += 1) L.length ? W[H] += (T.fc.v[H] - W[H]) * L[0] : W[H] += (T.fc.v[H] - W[H]) * L;
              T.fh.propType && (W = L.length ? ft(W, T.fh.v * L[0]) : ft(W, T.fh.v * L)), T.fs.propType && (W = L.length ? lt(W, T.fs.v * L[0]) : lt(W, T.fs.v * L)), T.fb.propType && (W = L.length ? pt(W, T.fb.v * L[0]) : pt(W, T.fb.v * L));
            }
          }
          for (M = 0; M < E; M += 1) (T = A[M].a).p.propType && (L = A[M].s.getMult(C[a].anIndexes[M], P.a[M].s.totalChars), this._hasMaskedPath ? L.length ? S.translate(0, T.p.v[1] * L[0], -T.p.v[2] * L[1]) : S.translate(0, T.p.v[1] * L, -T.p.v[2] * L) : L.length ? S.translate(T.p.v[0] * L[0], T.p.v[1] * L[1], -T.p.v[2] * L[2]) : S.translate(T.p.v[0] * L, T.p.v[1] * L, -T.p.v[2] * L));
          if (t.strokeWidthAnim && (X = j < 0 ? 0 : j), t.strokeColorAnim && (Y = "rgb(" + Math.round(255 * B[0]) + "," + Math.round(255 * B[1]) + "," + Math.round(255 * B[2]) + ")"), t.fillColorAnim && t.fc && (G = "rgb(" + Math.round(255 * W[0]) + "," + Math.round(255 * W[1]) + "," + Math.round(255 * W[2]) + ")"), this._hasMaskedPath) {
            if (S.translate(0, -t.ls), S.translate(0, k[1] * V * .01 + i, 0), this._pathData.p.v) {
              b = (o.point[1] - m.point[1]) / (o.point[0] - m.point[0]);
              var ot = 180 * Math.atan(b) / Math.PI;
              o.point[0] < m.point[0] && (ot += 180), S.rotate(-ot * Math.PI / 180);
            }
            S.translate(N, O, 0), h -= k[0] * C[a].an * .005, C[a + 1] && K !== C[a + 1].ind && (h += C[a].an / 2, h += .001 * t.tr * t.finalSize);
          } else {
            switch (S.translate(s, i, 0), t.ps && S.translate(t.ps[0], t.ps[1] + t.ascent, 0), t.j) {
              case 1:
                S.translate(C[a].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[C[a].line]), 0, 0);
                break;
              case 2:
                S.translate(C[a].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[C[a].line]) / 2, 0, 0);
            }
            S.translate(0, -t.ls), S.translate(z, 0, 0), S.translate(k[0] * C[a].an * .005, k[1] * V * .01, 0), s += C[a].l + .001 * t.tr * t.finalSize;
          }
          "html" === D ? tt = S.toCSS() : "svg" === D ? tt = S.to2dCSS() : et = [S.props[0], S.props[1], S.props[2], S.props[3], S.props[4], S.props[5], S.props[6], S.props[7], S.props[8], S.props[9], S.props[10], S.props[11], S.props[12], S.props[13], S.props[14], S.props[15]], J = q;
        }
        this.lettersChangedFlag = w <= a ? (I = new vt(J, X, Y, G, tt, et), this.renderedLetters.push(I), w += 1, !0) : (I = this.renderedLetters[a]).update(J, X, Y, G, tt, et) || this.lettersChangedFlag;
      }
    }
  }, gt.prototype.getValue = function () {
    this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
  }, gt.prototype.mHelper = new R(), gt.prototype.defaultPropsArray = [], z([M], gt), vt.prototype.update = function (t, e, s, i, a, r) {
    this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1;
    var n = this._mdf.p = !1;
    return this.o !== t && (this.o = t, n = this._mdf.o = !0), this.sw !== e && (this.sw = e, n = this._mdf.sw = !0), this.sc !== s && (this.sc = s, n = this._mdf.sc = !0), this.fc !== i && (this.fc = i, n = this._mdf.fc = !0), this.m !== a && (this.m = a, n = this._mdf.m = !0), !r.length || this.p[0] === r[0] && this.p[1] === r[1] && this.p[4] === r[4] && this.p[5] === r[5] && this.p[12] === r[12] && this.p[13] === r[13] || (this.p = r, n = this._mdf.p = !0), n;
  }, bt.prototype.defaultBoxWidth = [0, 0], bt.prototype.copyData = function (t, e) {
    for (var s in e) Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
    return t;
  }, bt.prototype.setCurrentData = function (t) {
    t.__complete || this.completeTextData(t), this.currentData = t, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
  }, bt.prototype.searchProperty = function () {
    return this.searchKeyframes();
  }, bt.prototype.searchKeyframes = function () {
    return this.kf = 1 < this.data.d.k.length, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
  }, bt.prototype.addEffect = function (t) {
    this.effectsSequence.push(t), this.elem.addDynamicProperty(this);
  }, bt.prototype.getValue = function (t) {
    if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length || t) {
      this.currentData.t = this.data.d.k[this.keysIndex].s.t;
      var e = this.currentData,
        s = this.keysIndex;
      if (this.lock) this.setCurrentData(this.currentData);else {
        var i;
        this.lock = !0, this._mdf = !1;
        var a = this.effectsSequence.length,
          r = t || this.data.d.k[this.keysIndex].s;
        for (i = 0; i < a; i += 1) r = s !== this.keysIndex ? this.effectsSequence[i](r, r.t) : this.effectsSequence[i](this.currentData, r.t);
        e !== r && this.setCurrentData(r), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }
  }, bt.prototype.getKeyframeValue = function () {
    for (var t = this.data.d.k, e = this.elem.comp.renderedFrame, s = 0, i = t.length; s <= i - 1 && !(s === i - 1 || t[s + 1].t > e);) s += 1;
    return this.keysIndex !== s && (this.keysIndex = s), this.data.d.k[this.keysIndex].s;
  }, bt.prototype.buildFinalText = function (t) {
    for (var e, s, i = [], a = 0, r = t.length, n = !1; a < r;) e = t.charCodeAt(a), O.isCombinedCharacter(e) ? i[i.length - 1] += t.charAt(a) : 55296 <= e && e <= 56319 ? 56320 <= (s = t.charCodeAt(a + 1)) && s <= 57343 ? (n || O.isModifier(e, s) ? (i[i.length - 1] += t.substr(a, 2), n = !1) : i.push(t.substr(a, 2)), a += 1) : i.push(t.charAt(a)) : 56319 < e ? (s = t.charCodeAt(a + 1), O.isZeroWidthJoiner(e, s) ? (n = !0, i[i.length - 1] += t.substr(a, 2), a += 1) : i.push(t.charAt(a))) : O.isZeroWidthJoiner(e) ? (i[i.length - 1] += t.charAt(a), n = !0) : i.push(t.charAt(a)), a += 1;
    return i;
  }, bt.prototype.completeTextData = function (t) {
    t.__complete = !0;
    var e,
      s,
      i,
      a,
      r,
      n,
      h,
      o = this.elem.globalData.fontManager,
      l = this.data,
      p = [],
      f = 0,
      d = l.m.g,
      m = 0,
      c = 0,
      u = 0,
      g = [],
      y = 0,
      v = 0,
      b = o.getFontByName(t.f),
      _ = 0,
      k = q(b);
    t.fWeight = k.weight, t.fStyle = k.style, t.finalSize = t.s, t.finalText = this.buildFinalText(t.t), s = t.finalText.length, t.finalLineHeight = t.lh;
    var A,
      P = t.tr / 1e3 * t.finalSize;
    if (t.sz) for (var S, D, w = !0, C = t.sz[0], x = t.sz[1]; w;) {
      y = S = 0, s = (D = this.buildFinalText(t.t)).length, P = t.tr / 1e3 * t.finalSize;
      var F = -1;
      for (e = 0; e < s; e += 1) A = D[e].charCodeAt(0), i = !1, " " === D[e] ? F = e : 13 !== A && 3 !== A || (i = !(y = 0), S += t.finalLineHeight || 1.2 * t.finalSize), C < y + (_ = o.chars ? (h = o.getCharData(D[e], b.fStyle, b.fFamily), i ? 0 : h.w * t.finalSize / 100) : o.measureText(D[e], t.f, t.finalSize)) && " " !== D[e] ? (-1 === F ? s += 1 : e = F, S += t.finalLineHeight || 1.2 * t.finalSize, D.splice(e, F === e ? 1 : 0, "\r"), F = -1, y = 0) : (y += _, y += P);
      S += b.ascent * t.finalSize / 100, this.canResize && t.finalSize > this.minimumFontSize && x < S ? (t.finalSize -= 1, t.finalLineHeight = t.finalSize * t.lh / t.s) : (t.finalText = D, s = t.finalText.length, w = !1);
    }
    y = -P;
    var T,
      M = _ = 0;
    for (e = 0; e < s; e += 1) if (i = !1, 13 === (A = (T = t.finalText[e]).charCodeAt(0)) || 3 === A ? (M = 0, g.push(y), v = v < y ? y : v, y = -2 * P, i = !(a = ""), u += 1) : a = T, _ = o.chars ? (h = o.getCharData(T, b.fStyle, o.getFontByName(t.f).fFamily), i ? 0 : h.w * t.finalSize / 100) : o.measureText(a, t.f, t.finalSize), " " === T ? M += _ + P : (y += _ + P + M, M = 0), p.push({
      l: _,
      an: _,
      add: m,
      n: i,
      anIndexes: [],
      val: a,
      line: u,
      animatorJustifyOffset: 0
    }), 2 == d) {
      if (m += _, "" === a || " " === a || e === s - 1) {
        for ("" !== a && " " !== a || (m -= _); c <= e;) p[c].an = m, p[c].ind = f, p[c].extra = _, c += 1;
        f += 1, m = 0;
      }
    } else if (3 == d) {
      if (m += _, "" === a || e === s - 1) {
        for ("" === a && (m -= _); c <= e;) p[c].an = m, p[c].ind = f, p[c].extra = _, c += 1;
        m = 0, f += 1;
      }
    } else p[f].ind = f, p[f].extra = 0, f += 1;
    if (t.l = p, v = v < y ? y : v, g.push(y), t.sz) t.boxWidth = t.sz[0], t.justifyOffset = 0;else switch (t.boxWidth = v, t.j) {
      case 1:
        t.justifyOffset = -t.boxWidth;
        break;
      case 2:
        t.justifyOffset = -t.boxWidth / 2;
        break;
      default:
        t.justifyOffset = 0;
    }
    t.lineWidths = g;
    var E,
      I,
      L,
      V,
      R = l.a;
    n = R.length;
    var z = [];
    for (r = 0; r < n; r += 1) {
      for ((E = R[r]).a.sc && (t.strokeColorAnim = !0), E.a.sw && (t.strokeWidthAnim = !0), (E.a.fc || E.a.fh || E.a.fs || E.a.fb) && (t.fillColorAnim = !0), V = 0, L = E.s.b, e = 0; e < s; e += 1) (I = p[e]).anIndexes[r] = V, (1 == L && "" !== I.val || 2 == L && "" !== I.val && " " !== I.val || 3 == L && (I.n || " " == I.val || e == s - 1) || 4 == L && (I.n || e == s - 1)) && (1 === E.s.rn && z.push(V), V += 1);
      l.a[r].s.totalChars = V;
      var N,
        O = -1;
      if (1 === E.s.rn) for (e = 0; e < s; e += 1) O != (I = p[e]).anIndexes[r] && (O = I.anIndexes[r], N = z.splice(Math.floor(Math.random() * z.length), 1)[0]), I.anIndexes[r] = N;
    }
    t.yOffset = t.finalLineHeight || 1.2 * t.finalSize, t.ls = t.ls || 0, t.ascent = b.ascent * t.finalSize / 100;
  }, bt.prototype.updateDocumentData = function (t, e) {
    e = void 0 === e ? this.keysIndex : e;
    var s = this.copyData({}, this.data.d.k[e].s);
    s = this.copyData(s, t), this.data.d.k[e].s = s, this.recalculate(e), this.elem.addDynamicProperty(this);
  }, bt.prototype.recalculate = function (t) {
    var e = this.data.d.k[t].s;
    e.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(e);
  }, bt.prototype.canResizeFont = function (t) {
    this.canResize = t, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
  }, bt.prototype.setMinimumFontSize = function (t) {
    this.minimumFontSize = Math.floor(t) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
  };
  var _t,
    kt,
    At,
    Pt,
    St,
    Dt = function () {
      var u = Math.max,
        g = Math.min,
        y = Math.floor;
      function i(t, e) {
        this._currentTextLength = -1, this.k = !1, this.data = e, this.elem = t, this.comp = t.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(t), this.s = B.getProp(t, e.s || {
          k: 0
        }, 0, 0, this), this.e = "e" in e ? B.getProp(t, e.e, 0, 0, this) : {
          v: 100
        }, this.o = B.getProp(t, e.o || {
          k: 0
        }, 0, 0, this), this.xe = B.getProp(t, e.xe || {
          k: 0
        }, 0, 0, this), this.ne = B.getProp(t, e.ne || {
          k: 0
        }, 0, 0, this), this.sm = B.getProp(t, e.sm || {
          k: 100
        }, 0, 0, this), this.a = B.getProp(t, e.a, 0, .01, this), this.dynamicProperties.length || this.getValue();
      }
      return i.prototype = {
        getMult: function (t) {
          this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
          var e = 0,
            s = 0,
            i = 1,
            a = 1;
          0 < this.ne.v ? e = this.ne.v / 100 : s = -this.ne.v / 100, 0 < this.xe.v ? i = 1 - this.xe.v / 100 : a = 1 + this.xe.v / 100;
          var r = H.getBezierEasing(e, s, i, a).get,
            n = 0,
            h = this.finalS,
            o = this.finalE,
            l = this.data.sh;
          if (2 === l) n = r(n = o === h ? o <= t ? 1 : 0 : u(0, g(.5 / (o - h) + (t - h) / (o - h), 1)));else if (3 === l) n = r(n = o === h ? o <= t ? 0 : 1 : 1 - u(0, g(.5 / (o - h) + (t - h) / (o - h), 1)));else if (4 === l) o === h ? n = 0 : (n = u(0, g(.5 / (o - h) + (t - h) / (o - h), 1))) < .5 ? n *= 2 : n = 1 - 2 * (n - .5), n = r(n);else if (5 === l) {
            if (o === h) n = 0;else {
              var p = o - h,
                f = -p / 2 + (t = g(u(0, t + .5 - h), o - h)),
                d = p / 2;
              n = Math.sqrt(1 - f * f / (d * d));
            }
            n = r(n);
          } else n = 6 === l ? r(n = o === h ? 0 : (t = g(u(0, t + .5 - h), o - h), (1 + Math.cos(Math.PI + 2 * Math.PI * t / (o - h))) / 2)) : (t >= y(h) && (n = u(0, g(t - h < 0 ? g(o, 1) - (h - t) : o - t, 1))), r(n));
          if (100 !== this.sm.v) {
            var m = .01 * this.sm.v;
            0 === m && (m = 1e-8);
            var c = .5 - .5 * m;
            n < c ? n = 0 : 1 < (n = (n - c) / m) && (n = 1);
          }
          return n * this.a.v;
        },
        getValue: function (t) {
          this.iterateDynamicProperties(), this._mdf = t || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, t && 2 === this.data.r && (this.e.v = this._currentTextLength);
          var e = 2 === this.data.r ? 1 : 100 / this.data.totalChars,
            s = this.o.v / e,
            i = this.s.v / e + s,
            a = this.e.v / e + s;
          if (a < i) {
            var r = i;
            i = a, a = r;
          }
          this.finalS = i, this.finalE = a;
        }
      }, z([M], i), {
        getTextSelectorProp: function (t, e, s) {
          return new i(t, e, s);
        }
      };
    }(),
    wt = function (t, e, s) {
      var i = 0,
        a = t,
        r = x(a);
      return {
        newElement: function () {
          return i ? r[i -= 1] : e();
        },
        release: function (t) {
          i === a && (r = Ct.double(r), a *= 2), s && s(t), r[i] = t, i += 1;
        }
      };
    },
    Ct = {
      double: function (t) {
        return t.concat(x(t.length));
      }
    },
    xt = wt(8, function () {
      return W("float32", 2);
    }),
    Ft = ((_t = wt(4, function () {
      return new Y();
    }, function (t) {
      var e,
        s = t._length;
      for (e = 0; e < s; e += 1) xt.release(t.v[e]), xt.release(t.i[e]), xt.release(t.o[e]), t.v[e] = null, t.i[e] = null, t.o[e] = null;
      t._length = 0, t.c = !1;
    })).clone = function (t) {
      var e,
        s = _t.newElement(),
        i = void 0 === t._length ? t.v.length : t._length;
      for (s.setLength(i), s.c = t.c, e = 0; e < i; e += 1) s.setTripleAt(t.v[e][0], t.v[e][1], t.o[e][0], t.o[e][1], t.i[e][0], t.i[e][1], e);
      return s;
    }, _t),
    Tt = (kt = {
      newShapeCollection: function () {
        var t;
        t = At ? St[At -= 1] : new st();
        return t;
      },
      release: function (t) {
        var e,
          s = t._length;
        for (e = 0; e < s; e += 1) Ft.release(t.shapes[e]);
        t._length = 0, At === Pt && (St = Ct.double(St), Pt *= 2);
        St[At] = t, At += 1;
      }
    }, At = 0, St = x(Pt = 4), kt),
    Mt = wt(8, function () {
      return {
        lengths: [],
        totalLength: 0
      };
    }, function (t) {
      var e,
        s = t.lengths.length;
      for (e = 0; e < s; e += 1) Et.release(t.lengths[e]);
      t.lengths.length = 0;
    }),
    Et = wt(8, function () {
      return {
        addedLength: 0,
        percents: W("float32", P),
        lengths: W("float32", P)
      };
    }),
    It = function () {
      function r(t) {
        for (var e, s = t.split("\r\n"), i = {}, a = 0, r = 0; r < s.length; r += 1) 2 === (e = s[r].split(":")).length && (i[e[0]] = e[1].trim(), a += 1);
        if (0 === a) throw new Error();
        return i;
      }
      return function (e) {
        for (var t = [], s = 0; s < e.length; s += 1) {
          var i = e[s],
            a = {
              time: i.tm,
              duration: i.dr
            };
          try {
            a.payload = JSON.parse(e[s].cm);
          } catch (t) {
            try {
              a.payload = r(e[s].cm);
            } catch (t) {
              a.payload = {
                name: e[s]
              };
            }
          }
          t.push(a);
        }
        return t;
      };
    }();
  function Lt() {}
  function Vt(t, e) {
    this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.svgElement = F("svg");
    var s = "";
    if (e && e.title) {
      var i = F("title"),
        a = S();
      i.setAttribute("id", a), i.textContent = e.title, this.svgElement.appendChild(i), s += a;
    }
    if (e && e.description) {
      var r = F("desc"),
        n = S();
      r.setAttribute("id", n), r.textContent = e.description, this.svgElement.appendChild(r), s += " " + n;
    }
    s && this.svgElement.setAttribute("aria-labelledby", s);
    var h = F("defs");
    this.svgElement.appendChild(h);
    var o = F("g");
    this.svgElement.appendChild(o), this.layerElement = o, this.renderConfig = {
      preserveAspectRatio: e && e.preserveAspectRatio || "xMidYMid meet",
      imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
      contentVisibility: e && e.contentVisibility || "visible",
      progressiveLoad: e && e.progressiveLoad || !1,
      hideOnTransparent: !(e && !1 === e.hideOnTransparent),
      viewBoxOnly: e && e.viewBoxOnly || !1,
      viewBoxSize: e && e.viewBoxSize || !1,
      className: e && e.className || "",
      id: e && e.id || "",
      focusable: e && e.focusable,
      filterSize: {
        width: e && e.filterSize && e.filterSize.width || "100%",
        height: e && e.filterSize && e.filterSize.height || "100%",
        x: e && e.filterSize && e.filterSize.x || "0%",
        y: e && e.filterSize && e.filterSize.y || "0%"
      }
    }, this.globalData = {
      _mdf: !1,
      frameNum: -1,
      defs: h,
      renderConfig: this.renderConfig
    }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
  }
  function Rt(t, e, s) {
    this.data = t, this.element = e, this.globalData = s, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
    var i,
      a,
      r = this.globalData.defs,
      n = this.masksProperties ? this.masksProperties.length : 0;
    this.viewData = x(n), this.solidPath = "";
    var h,
      o,
      l,
      p,
      f,
      d,
      m = this.masksProperties,
      c = 0,
      u = [],
      g = S(),
      y = "clipPath",
      v = "clip-path";
    for (i = 0; i < n; i += 1) if (("a" !== m[i].mode && "n" !== m[i].mode || m[i].inv || 100 !== m[i].o.k || m[i].o.x) && (v = y = "mask"), "s" !== m[i].mode && "i" !== m[i].mode || 0 !== c ? l = null : ((l = F("rect")).setAttribute("fill", "#ffffff"), l.setAttribute("width", this.element.comp.data.w || 0), l.setAttribute("height", this.element.comp.data.h || 0), u.push(l)), a = F("path"), "n" === m[i].mode) this.viewData[i] = {
      op: B.getProp(this.element, m[i].o, 0, .01, this.element),
      prop: K.getShapeProp(this.element, m[i], 3),
      elem: a,
      lastPath: ""
    }, r.appendChild(a);else {
      var b;
      if (c += 1, a.setAttribute("fill", "s" === m[i].mode ? "#000000" : "#ffffff"), a.setAttribute("clip-rule", "nonzero"), 0 !== m[i].x.k ? (v = y = "mask", d = B.getProp(this.element, m[i].x, 0, null, this.element), b = S(), (p = F("filter")).setAttribute("id", b), (f = F("feMorphology")).setAttribute("operator", "erode"), f.setAttribute("in", "SourceGraphic"), f.setAttribute("radius", "0"), p.appendChild(f), r.appendChild(p), a.setAttribute("stroke", "s" === m[i].mode ? "#000000" : "#ffffff")) : d = f = null, this.storedData[i] = {
        elem: a,
        x: d,
        expan: f,
        lastPath: "",
        lastOperator: "",
        filterId: b,
        lastRadius: 0
      }, "i" === m[i].mode) {
        o = u.length;
        var _ = F("g");
        for (h = 0; h < o; h += 1) _.appendChild(u[h]);
        var k = F("mask");
        k.setAttribute("mask-type", "alpha"), k.setAttribute("id", g + "_" + c), k.appendChild(a), r.appendChild(k), _.setAttribute("mask", "url(" + A + "#" + g + "_" + c + ")"), u.length = 0, u.push(_);
      } else u.push(a);
      m[i].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[i] = {
        elem: a,
        lastPath: "",
        op: B.getProp(this.element, m[i].o, 0, .01, this.element),
        prop: K.getShapeProp(this.element, m[i], 3),
        invRect: l
      }, this.viewData[i].prop.k || this.drawPath(m[i], this.viewData[i].prop.v, this.viewData[i]);
    }
    for (this.maskElement = F(y), n = u.length, i = 0; i < n; i += 1) this.maskElement.appendChild(u[i]);
    0 < c && (this.maskElement.setAttribute("id", g), this.element.maskedElement.setAttribute(v, "url(" + A + "#" + g + ")"), r.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
  }
  function zt() {}
  function Nt() {}
  function Ot() {}
  function qt() {}
  function Bt() {}
  function jt(t, e) {
    this.elem = t, this.pos = e;
  }
  function Wt(t, e) {
    this.data = t, this.type = t.ty, this.d = "", this.lvl = e, this._mdf = !1, this.closed = !0 === t.hd, this.pElem = F("path"), this.msElem = null;
  }
  function Ht(t, e, s) {
    this.caches = [], this.styles = [], this.transformers = t, this.lStr = "", this.sh = s, this.lvl = e, this._isAnimated = !!s.k;
    for (var i = 0, a = t.length; i < a;) {
      if (t[i].mProps.dynamicProperties.length) {
        this._isAnimated = !0;
        break;
      }
      i += 1;
    }
  }
  function Xt(t, e, s) {
    this.transform = {
      mProps: t,
      op: e,
      container: s
    }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
  }
  function Yt(t, e, s) {
    this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = B.getProp(t, e.o, 0, .01, this), this.w = B.getProp(t, e.w, 0, null, this), this.d = new it(t, e.d || {}, "svg", this), this.c = B.getProp(t, e.c, 1, 255, this), this.style = s, this._isAnimated = !!this._isAnimated;
  }
  function Gt(t, e, s) {
    this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = B.getProp(t, e.o, 0, .01, this), this.c = B.getProp(t, e.c, 1, 255, this), this.style = s;
  }
  function Jt(t, e, s) {
    this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.initGradientData(t, e, s);
  }
  function Kt(t, e, s) {
    this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.w = B.getProp(t, e.w, 0, null, this), this.d = new it(t, e.d || {}, "svg", this), this.initGradientData(t, e, s), this._isAnimated = !!this._isAnimated;
  }
  function Ut() {
    this.it = [], this.prevViewData = [], this.gr = F("g");
  }
  Lt.prototype.checkLayers = function (t) {
    var e,
      s,
      i = this.layers.length;
    for (this.completeLayers = !0, e = i - 1; 0 <= e; e -= 1) this.elements[e] || (s = this.layers[e]).ip - s.st <= t - this.layers[e].st && s.op - s.st > t - this.layers[e].st && this.buildItem(e), this.completeLayers = !!this.elements[e] && this.completeLayers;
    this.checkPendingElements();
  }, Lt.prototype.createItem = function (t) {
    switch (t.ty) {
      case 2:
        return this.createImage(t);
      case 0:
        return this.createComp(t);
      case 1:
        return this.createSolid(t);
      case 3:
        return this.createNull(t);
      case 4:
        return this.createShape(t);
      case 5:
        return this.createText(t);
      case 6:
        return this.createAudio(t);
      case 13:
        return this.createCamera(t);
      case 15:
        return this.createFootage(t);
      default:
        return this.createNull(t);
    }
  }, Lt.prototype.createCamera = function () {
    throw new Error("You're using a 3d camera. Try the html renderer.");
  }, Lt.prototype.createAudio = function (t) {
    return new ne(t, this.globalData, this);
  }, Lt.prototype.createFootage = function (t) {
    return new FootageElement(t, this.globalData, this);
  }, Lt.prototype.buildAllItems = function () {
    var t,
      e = this.layers.length;
    for (t = 0; t < e; t += 1) this.buildItem(t);
    this.checkPendingElements();
  }, Lt.prototype.includeLayers = function (t) {
    var e;
    this.completeLayers = !1;
    var s,
      i = t.length,
      a = this.layers.length;
    for (e = 0; e < i; e += 1) for (s = 0; s < a;) {
      if (this.layers[s].id === t[e].id) {
        this.layers[s] = t[e];
        break;
      }
      s += 1;
    }
  }, Lt.prototype.setProjectInterface = function (t) {
    this.globalData.projectInterface = t;
  }, Lt.prototype.initItems = function () {
    this.globalData.progressiveLoad || this.buildAllItems();
  }, Lt.prototype.buildElementParenting = function (t, e, s) {
    for (var i = this.elements, a = this.layers, r = 0, n = a.length; r < n;) a[r].ind == e && (i[r] && !0 !== i[r] ? (s.push(i[r]), i[r].setAsParent(), void 0 !== a[r].parent ? this.buildElementParenting(t, a[r].parent, s) : t.setHierarchy(s)) : (this.buildItem(r), this.addPendingElement(t))), r += 1;
  }, Lt.prototype.addPendingElement = function (t) {
    this.pendingElements.push(t);
  }, Lt.prototype.searchExtraCompositions = function (t) {
    var e,
      s = t.length;
    for (e = 0; e < s; e += 1) if (t[e].xt) {
      var i = this.createComp(t[e]);
      i.initExpressions(), this.globalData.projectInterface.registerComposition(i);
    }
  }, Lt.prototype.setupGlobalData = function (t, e) {
    this.globalData.fontManager = new O(), this.globalData.fontManager.addChars(t.chars), this.globalData.fontManager.addFonts(t.fonts, e), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = t.fr, this.globalData.nm = t.nm, this.globalData.compSize = {
      w: t.w,
      h: t.h
    };
  }, z([Lt], Vt), Vt.prototype.createNull = function (t) {
    return new $t(t, this.globalData, this);
  }, Vt.prototype.createShape = function (t) {
    return new le(t, this.globalData, this);
  }, Vt.prototype.createText = function (t) {
    return new oe(t, this.globalData, this);
  }, Vt.prototype.createImage = function (t) {
    return new ae(t, this.globalData, this);
  }, Vt.prototype.createComp = function (t) {
    return new he(t, this.globalData, this);
  }, Vt.prototype.createSolid = function (t) {
    return new re(t, this.globalData, this);
  }, Vt.prototype.configAnimation = function (t) {
    this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + t.w + " " + t.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", t.w), this.svgElement.setAttribute("height", t.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), void 0 !== this.renderConfig.focusable && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
    var e = this.globalData.defs;
    this.setupGlobalData(t, e), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = t;
    var s = F("clipPath"),
      i = F("rect");
    i.setAttribute("width", t.w), i.setAttribute("height", t.h), i.setAttribute("x", 0), i.setAttribute("y", 0);
    var a = S();
    s.setAttribute("id", a), s.appendChild(i), this.layerElement.setAttribute("clip-path", "url(" + A + "#" + a + ")"), e.appendChild(s), this.layers = t.layers, this.elements = x(t.layers.length);
  }, Vt.prototype.destroy = function () {
    var t;
    this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
    var e = this.layers ? this.layers.length : 0;
    for (t = 0; t < e; t += 1) this.elements[t] && this.elements[t].destroy();
    this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
  }, Vt.prototype.updateContainerSize = function () {}, Vt.prototype.buildItem = function (t) {
    var e = this.elements;
    if (!e[t] && 99 !== this.layers[t].ty) {
      e[t] = !0;
      var s = this.createItem(this.layers[t]);
      e[t] = s, i && (0 === this.layers[t].ty && this.globalData.projectInterface.registerComposition(s), s.initExpressions()), this.appendElementInPos(s, t), this.layers[t].tt && (this.elements[t - 1] && !0 !== this.elements[t - 1] ? s.setMatte(e[t - 1].layerId) : (this.buildItem(t - 1), this.addPendingElement(s)));
    }
  }, Vt.prototype.checkPendingElements = function () {
    for (; this.pendingElements.length;) {
      var t = this.pendingElements.pop();
      if (t.checkParenting(), t.data.tt) for (var e = 0, s = this.elements.length; e < s;) {
        if (this.elements[e] === t) {
          t.setMatte(this.elements[e - 1].layerId);
          break;
        }
        e += 1;
      }
    }
  }, Vt.prototype.renderFrame = function (t) {
    if (this.renderedFrame !== t && !this.destroyed) {
      var e;
      null === t ? t = this.renderedFrame : this.renderedFrame = t, this.globalData.frameNum = t, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = t, this.globalData._mdf = !1;
      var s = this.layers.length;
      for (this.completeLayers || this.checkLayers(t), e = s - 1; 0 <= e; e -= 1) (this.completeLayers || this.elements[e]) && this.elements[e].prepareFrame(t - this.layers[e].st);
      if (this.globalData._mdf) for (e = 0; e < s; e += 1) (this.completeLayers || this.elements[e]) && this.elements[e].renderFrame();
    }
  }, Vt.prototype.appendElementInPos = function (t, e) {
    var s = t.getBaseElement();
    if (s) {
      for (var i, a = 0; a < e;) this.elements[a] && !0 !== this.elements[a] && this.elements[a].getBaseElement() && (i = this.elements[a].getBaseElement()), a += 1;
      i ? this.layerElement.insertBefore(s, i) : this.layerElement.appendChild(s);
    }
  }, Vt.prototype.hide = function () {
    this.layerElement.style.display = "none";
  }, Vt.prototype.show = function () {
    this.layerElement.style.display = "block";
  }, Rt.prototype.getMaskProperty = function (t) {
    return this.viewData[t].prop;
  }, Rt.prototype.renderFrame = function (t) {
    var e,
      s = this.element.finalTransform.mat,
      i = this.masksProperties.length;
    for (e = 0; e < i; e += 1) if ((this.viewData[e].prop._mdf || t) && this.drawPath(this.masksProperties[e], this.viewData[e].prop.v, this.viewData[e]), (this.viewData[e].op._mdf || t) && this.viewData[e].elem.setAttribute("fill-opacity", this.viewData[e].op.v), "n" !== this.masksProperties[e].mode && (this.viewData[e].invRect && (this.element.finalTransform.mProp._mdf || t) && this.viewData[e].invRect.setAttribute("transform", s.getInverseMatrix().to2dCSS()), this.storedData[e].x && (this.storedData[e].x._mdf || t))) {
      var a = this.storedData[e].expan;
      this.storedData[e].x.v < 0 ? ("erode" !== this.storedData[e].lastOperator && (this.storedData[e].lastOperator = "erode", this.storedData[e].elem.setAttribute("filter", "url(" + A + "#" + this.storedData[e].filterId + ")")), a.setAttribute("radius", -this.storedData[e].x.v)) : ("dilate" !== this.storedData[e].lastOperator && (this.storedData[e].lastOperator = "dilate", this.storedData[e].elem.setAttribute("filter", null)), this.storedData[e].elem.setAttribute("stroke-width", 2 * this.storedData[e].x.v));
    }
  }, Rt.prototype.getMaskelement = function () {
    return this.maskElement;
  }, Rt.prototype.createLayerSolidPath = function () {
    var t = "M0,0 ";
    return t += " h" + this.globalData.compSize.w, t += " v" + this.globalData.compSize.h, t += " h-" + this.globalData.compSize.w, t += " v-" + this.globalData.compSize.h + " ";
  }, Rt.prototype.drawPath = function (t, e, s) {
    var i,
      a,
      r = " M" + e.v[0][0] + "," + e.v[0][1];
    for (a = e._length, i = 1; i < a; i += 1) r += " C" + e.o[i - 1][0] + "," + e.o[i - 1][1] + " " + e.i[i][0] + "," + e.i[i][1] + " " + e.v[i][0] + "," + e.v[i][1];
    if (e.c && 1 < a && (r += " C" + e.o[i - 1][0] + "," + e.o[i - 1][1] + " " + e.i[0][0] + "," + e.i[0][1] + " " + e.v[0][0] + "," + e.v[0][1]), s.lastPath !== r) {
      var n = "";
      s.elem && (e.c && (n = t.inv ? this.solidPath + r : r), s.elem.setAttribute("d", n)), s.lastPath = r;
    }
  }, Rt.prototype.destroy = function () {
    this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
  }, zt.prototype = {
    initHierarchy: function () {
      this.hierarchy = [], this._isParent = !1, this.checkParenting();
    },
    setHierarchy: function (t) {
      this.hierarchy = t;
    },
    setAsParent: function () {
      this._isParent = !0;
    },
    checkParenting: function () {
      void 0 !== this.data.parent && this.comp.buildElementParenting(this, this.data.parent, []);
    }
  }, Nt.prototype = {
    initFrame: function () {
      this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
    },
    prepareProperties: function (t, e) {
      var s,
        i = this.dynamicProperties.length;
      for (s = 0; s < i; s += 1) (e || this._isParent && "transform" === this.dynamicProperties[s].propType) && (this.dynamicProperties[s].getValue(), this.dynamicProperties[s]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
    },
    addDynamicProperty: function (t) {
      -1 === this.dynamicProperties.indexOf(t) && this.dynamicProperties.push(t);
    }
  }, Ot.prototype = {
    initTransform: function () {
      this.finalTransform = {
        mProp: this.data.ks ? X.getTransformProperty(this, this.data.ks, this) : {
          o: 0
        },
        _matMdf: !1,
        _opMdf: !1,
        mat: new R()
      }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
    },
    renderTransform: function () {
      if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
        var t,
          e = this.finalTransform.mat,
          s = 0,
          i = this.hierarchy.length;
        if (!this.finalTransform._matMdf) for (; s < i;) {
          if (this.hierarchy[s].finalTransform.mProp._mdf) {
            this.finalTransform._matMdf = !0;
            break;
          }
          s += 1;
        }
        if (this.finalTransform._matMdf) for (t = this.finalTransform.mProp.v.props, e.cloneFromProps(t), s = 0; s < i; s += 1) t = this.hierarchy[s].finalTransform.mProp.v.props, e.transform(t[0], t[1], t[2], t[3], t[4], t[5], t[6], t[7], t[8], t[9], t[10], t[11], t[12], t[13], t[14], t[15]);
      }
    },
    globalToLocal: function (t) {
      var e = [];
      e.push(this.finalTransform);
      for (var s, i = !0, a = this.comp; i;) a.finalTransform ? (a.data.hasMask && e.splice(0, 0, a.finalTransform), a = a.comp) : i = !1;
      var r,
        n = e.length;
      for (s = 0; s < n; s += 1) r = e[s].mat.applyToPointArray(0, 0, 0), t = [t[0] - r[0], t[1] - r[1], 0];
      return t;
    },
    mHelper: new R()
  }, qt.prototype = {
    initRenderable: function () {
      this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
    },
    addRenderableComponent: function (t) {
      -1 === this.renderableComponents.indexOf(t) && this.renderableComponents.push(t);
    },
    removeRenderableComponent: function (t) {
      -1 !== this.renderableComponents.indexOf(t) && this.renderableComponents.splice(this.renderableComponents.indexOf(t), 1);
    },
    prepareRenderableFrame: function (t) {
      this.checkLayerLimits(t);
    },
    checkTransparency: function () {
      this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
    },
    checkLayerLimits: function (t) {
      this.data.ip - this.data.st <= t && this.data.op - this.data.st > t ? !0 !== this.isInRange && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : !1 !== this.isInRange && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
    },
    renderRenderable: function () {
      var t,
        e = this.renderableComponents.length;
      for (t = 0; t < e; t += 1) this.renderableComponents[t].renderFrame(this._isFirstFrame);
    },
    sourceRectAtTime: function () {
      return {
        top: 0,
        left: 0,
        width: 100,
        height: 100
      };
    },
    getLayerSize: function () {
      return 5 === this.data.ty ? {
        w: this.data.textData.width,
        h: this.data.textData.height
      } : {
        w: this.data.width,
        h: this.data.height
      };
    }
  }, z([qt, function (t) {
    function e() {}
    return e.prototype = t, e;
  }({
    initElement: function (t, e, s) {
      this.initFrame(), this.initBaseData(t, e, s), this.initTransform(t, e, s), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
    },
    hide: function () {
      this.hidden || this.isInRange && !this.isTransparent || ((this.baseElement || this.layerElement).style.display = "none", this.hidden = !0);
    },
    show: function () {
      this.isInRange && !this.isTransparent && (this.data.hd || ((this.baseElement || this.layerElement).style.display = "block"), this.hidden = !1, this._isFirstFrame = !0);
    },
    renderFrame: function () {
      this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
    },
    renderInnerContent: function () {},
    prepareFrame: function (t) {
      this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.checkTransparency();
    },
    destroy: function () {
      this.innerElem = null, this.destroyBaseElement();
    }
  })], Bt), Wt.prototype.reset = function () {
    this.d = "", this._mdf = !1;
  }, Ht.prototype.setAsAnimated = function () {
    this._isAnimated = !0;
  }, z([M], Yt), z([M], Gt), Jt.prototype.initGradientData = function (t, e, s) {
    this.o = B.getProp(t, e.o, 0, .01, this), this.s = B.getProp(t, e.s, 1, null, this), this.e = B.getProp(t, e.e, 1, null, this), this.h = B.getProp(t, e.h || {
      k: 0
    }, 0, .01, this), this.a = B.getProp(t, e.a || {
      k: 0
    }, 0, j, this), this.g = new at(t, e.g, this), this.style = s, this.stops = [], this.setGradientData(s.pElem, e), this.setGradientOpacity(e, s), this._isAnimated = !!this._isAnimated;
  }, Jt.prototype.setGradientData = function (t, e) {
    var s = S(),
      i = F(1 === e.t ? "linearGradient" : "radialGradient");
    i.setAttribute("id", s), i.setAttribute("spreadMethod", "pad"), i.setAttribute("gradientUnits", "userSpaceOnUse");
    var a,
      r,
      n,
      h = [];
    for (n = 4 * e.g.p, r = 0; r < n; r += 4) a = F("stop"), i.appendChild(a), h.push(a);
    t.setAttribute("gf" === e.ty ? "fill" : "stroke", "url(" + A + "#" + s + ")"), this.gf = i, this.cst = h;
  }, Jt.prototype.setGradientOpacity = function (t, e) {
    if (this.g._hasOpacity && !this.g._collapsable) {
      var s,
        i,
        a,
        r = F("mask"),
        n = F("path");
      r.appendChild(n);
      var h = S(),
        o = S();
      r.setAttribute("id", o);
      var l = F(1 === t.t ? "linearGradient" : "radialGradient");
      l.setAttribute("id", h), l.setAttribute("spreadMethod", "pad"), l.setAttribute("gradientUnits", "userSpaceOnUse"), a = t.g.k.k[0].s ? t.g.k.k[0].s.length : t.g.k.k.length;
      var p = this.stops;
      for (i = 4 * t.g.p; i < a; i += 2) (s = F("stop")).setAttribute("stop-color", "rgb(255,255,255)"), l.appendChild(s), p.push(s);
      n.setAttribute("gf" === t.ty ? "fill" : "stroke", "url(" + A + "#" + h + ")"), "gs" === t.ty && (n.setAttribute("stroke-linecap", L[t.lc || 2]), n.setAttribute("stroke-linejoin", V[t.lj || 2]), 1 === t.lj && n.setAttribute("stroke-miterlimit", t.ml)), this.of = l, this.ms = r, this.ost = p, this.maskId = o, e.msElem = n;
    }
  }, z([M], Jt), z([Jt, M], Kt);
  var Zt = function () {
    var g = new R(),
      y = new R();
    function e(t, e, s) {
      (s || e.transform.op._mdf) && e.transform.container.setAttribute("opacity", e.transform.op.v), (s || e.transform.mProps._mdf) && e.transform.container.setAttribute("transform", e.transform.mProps.v.to2dCSS());
    }
    function s(t, e, s) {
      var i,
        a,
        r,
        n,
        h,
        o,
        l,
        p,
        f,
        d,
        m,
        c = e.styles.length,
        u = e.lvl;
      for (o = 0; o < c; o += 1) {
        if (n = e.sh._mdf || s, e.styles[o].lvl < u) {
          for (p = y.reset(), d = u - e.styles[o].lvl, m = e.transformers.length - 1; !n && 0 < d;) n = e.transformers[m].mProps._mdf || n, d -= 1, m -= 1;
          if (n) for (d = u - e.styles[o].lvl, m = e.transformers.length - 1; 0 < d;) f = e.transformers[m].mProps.v.props, p.transform(f[0], f[1], f[2], f[3], f[4], f[5], f[6], f[7], f[8], f[9], f[10], f[11], f[12], f[13], f[14], f[15]), d -= 1, m -= 1;
        } else p = g;
        if (a = (l = e.sh.paths)._length, n) {
          for (r = "", i = 0; i < a; i += 1) (h = l.shapes[i]) && h._length && (r += ht(h, h._length, h.c, p));
          e.caches[o] = r;
        } else r = e.caches[o];
        e.styles[o].d += !0 === t.hd ? "" : r, e.styles[o]._mdf = n || e.styles[o]._mdf;
      }
    }
    function i(t, e, s) {
      var i = e.style;
      (e.c._mdf || s) && i.pElem.setAttribute("fill", "rgb(" + f(e.c.v[0]) + "," + f(e.c.v[1]) + "," + f(e.c.v[2]) + ")"), (e.o._mdf || s) && i.pElem.setAttribute("fill-opacity", e.o.v);
    }
    function a(t, e, s) {
      r(t, e, s), n(t, e, s);
    }
    function r(t, e, s) {
      var i,
        a,
        r,
        n,
        h,
        o = e.gf,
        l = e.g._hasOpacity,
        p = e.s.v,
        f = e.e.v;
      if (e.o._mdf || s) {
        var d = "gf" === t.ty ? "fill-opacity" : "stroke-opacity";
        e.style.pElem.setAttribute(d, e.o.v);
      }
      if (e.s._mdf || s) {
        var m = 1 === t.t ? "x1" : "cx",
          c = "x1" === m ? "y1" : "cy";
        o.setAttribute(m, p[0]), o.setAttribute(c, p[1]), l && !e.g._collapsable && (e.of.setAttribute(m, p[0]), e.of.setAttribute(c, p[1]));
      }
      if (e.g._cmdf || s) {
        i = e.cst;
        var u = e.g.c;
        for (r = i.length, a = 0; a < r; a += 1) (n = i[a]).setAttribute("offset", u[4 * a] + "%"), n.setAttribute("stop-color", "rgb(" + u[4 * a + 1] + "," + u[4 * a + 2] + "," + u[4 * a + 3] + ")");
      }
      if (l && (e.g._omdf || s)) {
        var g = e.g.o;
        for (r = (i = e.g._collapsable ? e.cst : e.ost).length, a = 0; a < r; a += 1) n = i[a], e.g._collapsable || n.setAttribute("offset", g[2 * a] + "%"), n.setAttribute("stop-opacity", g[2 * a + 1]);
      }
      if (1 === t.t) (e.e._mdf || s) && (o.setAttribute("x2", f[0]), o.setAttribute("y2", f[1]), l && !e.g._collapsable && (e.of.setAttribute("x2", f[0]), e.of.setAttribute("y2", f[1])));else if ((e.s._mdf || e.e._mdf || s) && (h = Math.sqrt(Math.pow(p[0] - f[0], 2) + Math.pow(p[1] - f[1], 2)), o.setAttribute("r", h), l && !e.g._collapsable && e.of.setAttribute("r", h)), e.e._mdf || e.h._mdf || e.a._mdf || s) {
        h || (h = Math.sqrt(Math.pow(p[0] - f[0], 2) + Math.pow(p[1] - f[1], 2)));
        var y = Math.atan2(f[1] - p[1], f[0] - p[0]),
          v = e.h.v;
        1 <= v ? v = .99 : v <= -1 && (v = -.99);
        var b = h * v,
          _ = Math.cos(y + e.a.v) * b + p[0],
          k = Math.sin(y + e.a.v) * b + p[1];
        o.setAttribute("fx", _), o.setAttribute("fy", k), l && !e.g._collapsable && (e.of.setAttribute("fx", _), e.of.setAttribute("fy", k));
      }
    }
    function n(t, e, s) {
      var i = e.style,
        a = e.d;
      a && (a._mdf || s) && a.dashStr && (i.pElem.setAttribute("stroke-dasharray", a.dashStr), i.pElem.setAttribute("stroke-dashoffset", a.dashoffset[0])), e.c && (e.c._mdf || s) && i.pElem.setAttribute("stroke", "rgb(" + f(e.c.v[0]) + "," + f(e.c.v[1]) + "," + f(e.c.v[2]) + ")"), (e.o._mdf || s) && i.pElem.setAttribute("stroke-opacity", e.o.v), (e.w._mdf || s) && (i.pElem.setAttribute("stroke-width", e.w.v), i.msElem && i.msElem.setAttribute("stroke-width", e.w.v));
    }
    return {
      createRenderFunction: function (t) {
        switch (t.ty) {
          case "fl":
            return i;
          case "gf":
            return r;
          case "gs":
            return a;
          case "st":
            return n;
          case "sh":
          case "el":
          case "rc":
          case "sr":
            return s;
          case "tr":
            return e;
          default:
            return null;
        }
      }
    };
  }();
  function Qt() {}
  function $t(t, e, s) {
    this.initFrame(), this.initBaseData(t, e, s), this.initFrame(), this.initTransform(t, e, s), this.initHierarchy();
  }
  function te() {}
  function ee() {}
  function se() {}
  function ie() {}
  function ae(t, e, s) {
    this.assetData = e.getAssetData(t.refId), this.initElement(t, e, s), this.sourceRect = {
      top: 0,
      left: 0,
      width: this.assetData.w,
      height: this.assetData.h
    };
  }
  function re(t, e, s) {
    this.initElement(t, e, s);
  }
  function ne(t, e, s) {
    this.initFrame(), this.initRenderable(), this.assetData = e.getAssetData(t.refId), this.initBaseData(t, e, s), this._isPlaying = !1, this._canPlay = !1;
    var i = this.globalData.getAssetsPath(this.assetData);
    this.audio = this.globalData.audioController.createAudio(i), this._currentTime = 0, this.globalData.audioController.addAudio(this), this.tm = t.tm ? B.getProp(this, t.tm, 0, e.frameRate, this) : {
      _placeholder: !0
    };
  }
  function he(t, e, s) {
    this.layers = t.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? x(this.layers.length) : [], this.initElement(t, e, s), this.tm = t.tm ? B.getProp(this, t.tm, 0, e.frameRate, this) : {
      _placeholder: !0
    };
  }
  function oe(t, e, s) {
    this.textSpans = [], this.renderType = "svg", this.initElement(t, e, s);
  }
  function le(t, e, s) {
    this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(t, e, s), this.prevViewData = [];
  }
  Qt.prototype = {
    checkMasks: function () {
      if (!this.data.hasMask) return !1;
      for (var t = 0, e = this.data.masksProperties.length; t < e;) {
        if ("n" !== this.data.masksProperties[t].mode && !1 !== this.data.masksProperties[t].cl) return !0;
        t += 1;
      }
      return !1;
    },
    initExpressions: function () {
      this.layerInterface = LayerExpressionInterface(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
      var t = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
      this.layerInterface.registerEffectsInterface(t), 0 === this.data.ty || this.data.xt ? this.compInterface = CompExpressionInterface(this) : 4 === this.data.ty ? (this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : 5 === this.data.ty && (this.layerInterface.textInterface = TextExpressionInterface(this), this.layerInterface.text = this.layerInterface.textInterface);
    },
    setBlendMode: function () {
      var t = I(this.data.bm);
      (this.baseElement || this.layerElement).style["mix-blend-mode"] = t;
    },
    initBaseData: function (t, e, s) {
      this.globalData = e, this.comp = s, this.data = t, this.layerId = S(), this.data.sr || (this.data.sr = 1), this.effectsManager = new ce(this.data, this, this.dynamicProperties);
    },
    getType: function () {
      return this.type;
    },
    sourceRectAtTime: function () {}
  }, $t.prototype.prepareFrame = function (t) {
    this.prepareProperties(t, !0);
  }, $t.prototype.renderFrame = function () {}, $t.prototype.getBaseElement = function () {
    return null;
  }, $t.prototype.destroy = function () {}, $t.prototype.sourceRectAtTime = function () {}, $t.prototype.hide = function () {}, z([Qt, Ot, zt, Nt], $t), te.prototype = {
    initRendererElement: function () {
      this.layerElement = F("g");
    },
    createContainerElements: function () {
      this.matteElement = F("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
      var t,
        e,
        s,
        i = null;
      if (this.data.td) {
        if (3 == this.data.td || 1 == this.data.td) {
          var a = F("mask");
          a.setAttribute("id", this.layerId), a.setAttribute("mask-type", 3 == this.data.td ? "luminance" : "alpha"), a.appendChild(this.layerElement), i = a, this.globalData.defs.appendChild(a), ct.maskType || 1 != this.data.td || (a.setAttribute("mask-type", "luminance"), t = S(), e = ut.createFilter(t), this.globalData.defs.appendChild(e), e.appendChild(ut.createAlphaToLuminanceFilter()), (s = F("g")).appendChild(this.layerElement), i = s, a.appendChild(s), s.setAttribute("filter", "url(" + A + "#" + t + ")"));
        } else if (2 == this.data.td) {
          var r = F("mask");
          r.setAttribute("id", this.layerId), r.setAttribute("mask-type", "alpha");
          var n = F("g");
          r.appendChild(n), t = S(), e = ut.createFilter(t);
          var h = F("feComponentTransfer");
          h.setAttribute("in", "SourceGraphic"), e.appendChild(h);
          var o = F("feFuncA");
          o.setAttribute("type", "table"), o.setAttribute("tableValues", "1.0 0.0"), h.appendChild(o), this.globalData.defs.appendChild(e);
          var l = F("rect");
          l.setAttribute("width", this.comp.data.w), l.setAttribute("height", this.comp.data.h), l.setAttribute("x", "0"), l.setAttribute("y", "0"), l.setAttribute("fill", "#ffffff"), l.setAttribute("opacity", "0"), n.setAttribute("filter", "url(" + A + "#" + t + ")"), n.appendChild(l), n.appendChild(this.layerElement), i = n, ct.maskType || (r.setAttribute("mask-type", "luminance"), e.appendChild(ut.createAlphaToLuminanceFilter()), s = F("g"), n.appendChild(l), s.appendChild(this.layerElement), i = s, n.appendChild(s)), this.globalData.defs.appendChild(r);
        }
      } else this.data.tt ? (this.matteElement.appendChild(this.layerElement), i = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
      if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 === this.data.ty && !this.data.hd) {
        var p = F("clipPath"),
          f = F("path");
        f.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
        var d = S();
        if (p.setAttribute("id", d), p.appendChild(f), this.globalData.defs.appendChild(p), this.checkMasks()) {
          var m = F("g");
          m.setAttribute("clip-path", "url(" + A + "#" + d + ")"), m.appendChild(this.layerElement), this.transformedElement = m, i ? i.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
        } else this.layerElement.setAttribute("clip-path", "url(" + A + "#" + d + ")");
      }
      0 !== this.data.bm && this.setBlendMode();
    },
    renderElement: function () {
      this.finalTransform._matMdf && this.transformedElement.setAttribute("transform", this.finalTransform.mat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.mProp.o.v);
    },
    destroyBaseElement: function () {
      this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
    },
    getBaseElement: function () {
      return this.data.hd ? null : this.baseElement;
    },
    createRenderableComponents: function () {
      this.maskManager = new Rt(this.data, this, this.globalData), this.renderableEffectsManager = new fe(this);
    },
    setMatte: function (t) {
      this.matteElement && this.matteElement.setAttribute("mask", "url(" + A + "#" + t + ")");
    }
  }, ee.prototype = {
    addShapeToModifiers: function (t) {
      var e,
        s = this.shapeModifiers.length;
      for (e = 0; e < s; e += 1) this.shapeModifiers[e].addShape(t);
    },
    isShapeInAnimatedModifiers: function (t) {
      for (var e = this.shapeModifiers.length; 0 < e;) if (this.shapeModifiers[0].isAnimatedWithShape(t)) return !0;
      return !1;
    },
    renderModifiers: function () {
      if (this.shapeModifiers.length) {
        var t,
          e = this.shapes.length;
        for (t = 0; t < e; t += 1) this.shapes[t].sh.reset();
        for (t = (e = this.shapeModifiers.length) - 1; 0 <= t && !this.shapeModifiers[t].processShapes(this._isFirstFrame); t -= 1);
      }
    },
    searchProcessedElement: function (t) {
      for (var e = this.processedElements, s = 0, i = e.length; s < i;) {
        if (e[s].elem === t) return e[s].pos;
        s += 1;
      }
      return 0;
    },
    addProcessedElement: function (t, e) {
      for (var s = this.processedElements, i = s.length; i;) if (s[i -= 1].elem === t) return void (s[i].pos = e);
      s.push(new jt(t, e));
    },
    prepareFrame: function (t) {
      this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
    }
  }, se.prototype.initElement = function (t, e, s) {
    this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(t, e, s), this.textProperty = new bt(this, t.t, this.dynamicProperties), this.textAnimator = new gt(t.t, this.renderType, this), this.initTransform(t, e, s), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
  }, se.prototype.prepareFrame = function (t) {
    this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
  }, se.prototype.createPathShape = function (t, e) {
    var s,
      i,
      a = e.length,
      r = "";
    for (s = 0; s < a; s += 1) i = e[s].ks.k, r += ht(i, i.i.length, !0, t);
    return r;
  }, se.prototype.updateDocumentData = function (t, e) {
    this.textProperty.updateDocumentData(t, e);
  }, se.prototype.canResizeFont = function (t) {
    this.textProperty.canResizeFont(t);
  }, se.prototype.setMinimumFontSize = function (t) {
    this.textProperty.setMinimumFontSize(t);
  }, se.prototype.applyTextPropertiesToMatrix = function (t, e, s, i, a) {
    switch (t.ps && e.translate(t.ps[0], t.ps[1] + t.ascent, 0), e.translate(0, -t.ls, 0), t.j) {
      case 1:
        e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[s]), 0, 0);
        break;
      case 2:
        e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[s]) / 2, 0, 0);
    }
    e.translate(i, a, 0);
  }, se.prototype.buildColor = function (t) {
    return "rgb(" + Math.round(255 * t[0]) + "," + Math.round(255 * t[1]) + "," + Math.round(255 * t[2]) + ")";
  }, se.prototype.emptyProp = new vt(), se.prototype.destroy = function () {}, z([Qt, Ot, zt, Nt, Bt], ie), ie.prototype.initElement = function (t, e, s) {
    this.initFrame(), this.initBaseData(t, e, s), this.initTransform(t, e, s), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), !this.data.xt && e.progressiveLoad || this.buildAllItems(), this.hide();
  }, ie.prototype.prepareFrame = function (t) {
    if (this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.isInRange || this.data.xt) {
      if (this.tm._placeholder) this.renderedFrame = t / this.data.sr;else {
        var e = this.tm.v;
        e === this.data.op && (e = this.data.op - 1), this.renderedFrame = e;
      }
      var s,
        i = this.elements.length;
      for (this.completeLayers || this.checkLayers(this.renderedFrame), s = i - 1; 0 <= s; s -= 1) (this.completeLayers || this.elements[s]) && (this.elements[s].prepareFrame(this.renderedFrame - this.layers[s].st), this.elements[s]._mdf && (this._mdf = !0));
    }
  }, ie.prototype.renderInnerContent = function () {
    var t,
      e = this.layers.length;
    for (t = 0; t < e; t += 1) (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
  }, ie.prototype.setElements = function (t) {
    this.elements = t;
  }, ie.prototype.getElements = function () {
    return this.elements;
  }, ie.prototype.destroyElements = function () {
    var t,
      e = this.layers.length;
    for (t = 0; t < e; t += 1) this.elements[t] && this.elements[t].destroy();
  }, ie.prototype.destroy = function () {
    this.destroyElements(), this.destroyBaseElement();
  }, z([Qt, Ot, te, zt, Nt, Bt], ae), ae.prototype.createContent = function () {
    var t = this.globalData.getAssetsPath(this.assetData);
    this.innerElem = F("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), this.layerElement.appendChild(this.innerElem);
  }, ae.prototype.sourceRectAtTime = function () {
    return this.sourceRect;
  }, z([ae], re), re.prototype.createContent = function () {
    var t = F("rect");
    t.setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.layerElement.appendChild(t);
  }, ne.prototype.prepareFrame = function (t) {
    if (this.prepareRenderableFrame(t, !0), this.prepareProperties(t, !0), this.tm._placeholder) this._currentTime = t / this.data.sr;else {
      var e = this.tm.v;
      this._currentTime = e;
    }
  }, z([qt, Qt, Nt], ne), ne.prototype.renderFrame = function () {
    this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || .1 < Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek())) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
  }, ne.prototype.show = function () {}, ne.prototype.hide = function () {
    this.audio.pause(), this._isPlaying = !1;
  }, ne.prototype.pause = function () {
    this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
  }, ne.prototype.resume = function () {
    this._canPlay = !0;
  }, ne.prototype.setRate = function (t) {
    this.audio.rate(t);
  }, ne.prototype.volume = function (t) {
    this.audio.volume(t);
  }, ne.prototype.getBaseElement = function () {
    return null;
  }, ne.prototype.destroy = function () {}, ne.prototype.sourceRectAtTime = function () {}, ne.prototype.initExpressions = function () {}, z([Vt, ie, te], he), z([Qt, Ot, te, zt, Nt, Bt, se], oe), oe.prototype.createContent = function () {
    this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = F("text"));
  }, oe.prototype.buildTextContents = function (t) {
    for (var e = 0, s = t.length, i = [], a = ""; e < s;) t[e] === String.fromCharCode(13) || t[e] === String.fromCharCode(3) ? (i.push(a), a = "") : a += t[e], e += 1;
    return i.push(a), i;
  }, oe.prototype.buildNewText = function () {
    var t,
      e,
      s = this.textProperty.currentData;
    this.renderedLetters = x(s ? s.l.length : 0), s.fc ? this.layerElement.setAttribute("fill", this.buildColor(s.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), s.sc && (this.layerElement.setAttribute("stroke", this.buildColor(s.sc)), this.layerElement.setAttribute("stroke-width", s.sw)), this.layerElement.setAttribute("font-size", s.finalSize);
    var i = this.globalData.fontManager.getFontByName(s.f);
    if (i.fClass) this.layerElement.setAttribute("class", i.fClass);else {
      this.layerElement.setAttribute("font-family", i.fFamily);
      var a = s.fWeight,
        r = s.fStyle;
      this.layerElement.setAttribute("font-style", r), this.layerElement.setAttribute("font-weight", a);
    }
    this.layerElement.setAttribute("aria-label", s.t);
    var n,
      h = s.l || [],
      o = !!this.globalData.fontManager.chars;
    e = h.length;
    var l,
      p = this.mHelper,
      f = "",
      d = this.data.singleShape,
      m = 0,
      c = 0,
      u = !0,
      g = .001 * s.tr * s.finalSize;
    if (!d || o || s.sz) {
      var y,
        v,
        b = this.textSpans.length;
      for (t = 0; t < e; t += 1) o && d && 0 !== t || (n = t < b ? this.textSpans[t] : F(o ? "path" : "text"), b <= t && (n.setAttribute("stroke-linecap", "butt"), n.setAttribute("stroke-linejoin", "round"), n.setAttribute("stroke-miterlimit", "4"), this.textSpans[t] = n, this.layerElement.appendChild(n)), n.style.display = "inherit"), p.reset(), p.scale(s.finalSize / 100, s.finalSize / 100), d && (h[t].n && (m = -g, c += s.yOffset, c += u ? 1 : 0, u = !1), this.applyTextPropertiesToMatrix(s, p, h[t].line, m, c), m += h[t].l || 0, m += g), o ? (l = (y = (v = this.globalData.fontManager.getCharData(s.finalText[t], i.fStyle, this.globalData.fontManager.getFontByName(s.f).fFamily)) && v.data || {}).shapes ? y.shapes[0].it : [], d ? f += this.createPathShape(p, l) : n.setAttribute("d", this.createPathShape(p, l))) : (d && n.setAttribute("transform", "translate(" + p.props[12] + "," + p.props[13] + ")"), n.textContent = h[t].val, n.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"));
      d && n && n.setAttribute("d", f);
    } else {
      var _ = this.textContainer,
        k = "start";
      switch (s.j) {
        case 1:
          k = "end";
          break;
        case 2:
          k = "middle";
          break;
        default:
          k = "start";
      }
      _.setAttribute("text-anchor", k), _.setAttribute("letter-spacing", g);
      var A = this.buildTextContents(s.finalText);
      for (e = A.length, c = s.ps ? s.ps[1] + s.ascent : 0, t = 0; t < e; t += 1) (n = this.textSpans[t] || F("tspan")).textContent = A[t], n.setAttribute("x", 0), n.setAttribute("y", c), n.style.display = "inherit", _.appendChild(n), this.textSpans[t] = n, c += s.finalLineHeight;
      this.layerElement.appendChild(_);
    }
    for (; t < this.textSpans.length;) this.textSpans[t].style.display = "none", t += 1;
    this._sizeChanged = !0;
  }, oe.prototype.sourceRectAtTime = function () {
    if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
      this._sizeChanged = !1;
      var t = this.layerElement.getBBox();
      this.bbox = {
        top: t.y,
        left: t.x,
        width: t.width,
        height: t.height
      };
    }
    return this.bbox;
  }, oe.prototype.renderInnerContent = function () {
    if (!this.data.singleShape && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
      var t, e;
      this._sizeChanged = !0;
      var s,
        i,
        a = this.textAnimator.renderedLetters,
        r = this.textProperty.currentData.l;
      for (e = r.length, t = 0; t < e; t += 1) r[t].n || (s = a[t], i = this.textSpans[t], s._mdf.m && i.setAttribute("transform", s.m), s._mdf.o && i.setAttribute("opacity", s.o), s._mdf.sw && i.setAttribute("stroke-width", s.sw), s._mdf.sc && i.setAttribute("stroke", s.sc), s._mdf.fc && i.setAttribute("fill", s.fc));
    }
  }, z([Qt, Ot, te, ee, zt, Nt, Bt], le), le.prototype.initSecondaryElement = function () {}, le.prototype.identityMatrix = new R(), le.prototype.buildExpressionInterface = function () {}, le.prototype.createContent = function () {
    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
  }, le.prototype.filterUniqueShapes = function () {
    var t,
      e,
      s,
      i,
      a = this.shapes.length,
      r = this.stylesList.length,
      n = [],
      h = !1;
    for (s = 0; s < r; s += 1) {
      for (i = this.stylesList[s], h = !1, t = n.length = 0; t < a; t += 1) -1 !== (e = this.shapes[t]).styles.indexOf(i) && (n.push(e), h = e._isAnimated || h);
      1 < n.length && h && this.setShapesAsAnimated(n);
    }
  }, le.prototype.setShapesAsAnimated = function (t) {
    var e,
      s = t.length;
    for (e = 0; e < s; e += 1) t[e].setAsAnimated();
  }, le.prototype.createStyleElement = function (t, e) {
    var s,
      i = new Wt(t, e),
      a = i.pElem;
    if ("st" === t.ty) s = new Yt(this, t, i);else if ("fl" === t.ty) s = new Gt(this, t, i);else if ("gf" === t.ty || "gs" === t.ty) {
      s = new ("gf" === t.ty ? Jt : Kt)(this, t, i), this.globalData.defs.appendChild(s.gf), s.maskId && (this.globalData.defs.appendChild(s.ms), this.globalData.defs.appendChild(s.of), a.setAttribute("mask", "url(" + A + "#" + s.maskId + ")"));
    }
    return "st" !== t.ty && "gs" !== t.ty || (a.setAttribute("stroke-linecap", L[t.lc || 2]), a.setAttribute("stroke-linejoin", V[t.lj || 2]), a.setAttribute("fill-opacity", "0"), 1 === t.lj && a.setAttribute("stroke-miterlimit", t.ml)), 2 === t.r && a.setAttribute("fill-rule", "evenodd"), t.ln && a.setAttribute("id", t.ln), t.cl && a.setAttribute("class", t.cl), t.bm && (a.style["mix-blend-mode"] = I(t.bm)), this.stylesList.push(i), this.addToAnimatedContents(t, s), s;
  }, le.prototype.createGroupElement = function (t) {
    var e = new Ut();
    return t.ln && e.gr.setAttribute("id", t.ln), t.cl && e.gr.setAttribute("class", t.cl), t.bm && (e.gr.style["mix-blend-mode"] = I(t.bm)), e;
  }, le.prototype.createTransformElement = function (t, e) {
    var s = X.getTransformProperty(this, t, this),
      i = new Xt(s, s.o, e);
    return this.addToAnimatedContents(t, i), i;
  }, le.prototype.createShapeElement = function (t, e, s) {
    var i = 4;
    "rc" === t.ty ? i = 5 : "el" === t.ty ? i = 6 : "sr" === t.ty && (i = 7);
    var a = new Ht(e, s, K.getShapeProp(this, t, i, this));
    return this.shapes.push(a), this.addShapeToModifiers(a), this.addToAnimatedContents(t, a), a;
  }, le.prototype.addToAnimatedContents = function (t, e) {
    for (var s = 0, i = this.animatedContents.length; s < i;) {
      if (this.animatedContents[s].element === e) return;
      s += 1;
    }
    this.animatedContents.push({
      fn: Zt.createRenderFunction(t),
      element: e,
      data: t
    });
  }, le.prototype.setElementStyles = function (t) {
    var e,
      s = t.styles,
      i = this.stylesList.length;
    for (e = 0; e < i; e += 1) this.stylesList[e].closed || s.push(this.stylesList[e]);
  }, le.prototype.reloadShapes = function () {
    var t;
    this._isFirstFrame = !0;
    var e = this.itemsData.length;
    for (t = 0; t < e; t += 1) this.prevViewData[t] = this.itemsData[t];
    for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), e = this.dynamicProperties.length, t = 0; t < e; t += 1) this.dynamicProperties[t].getValue();
    this.renderModifiers();
  }, le.prototype.searchShapes = function (t, e, s, i, a, r, n) {
    var h,
      o,
      l,
      p,
      f,
      d,
      m = [].concat(r),
      c = t.length - 1,
      u = [],
      g = [];
    for (h = c; 0 <= h; h -= 1) {
      if ((d = this.searchProcessedElement(t[h])) ? e[h] = s[d - 1] : t[h]._render = n, "fl" === t[h].ty || "st" === t[h].ty || "gf" === t[h].ty || "gs" === t[h].ty) d ? e[h].style.closed = !1 : e[h] = this.createStyleElement(t[h], a), t[h]._render && e[h].style.pElem.parentNode !== i && i.appendChild(e[h].style.pElem), u.push(e[h].style);else if ("gr" === t[h].ty) {
        if (d) for (l = e[h].it.length, o = 0; o < l; o += 1) e[h].prevViewData[o] = e[h].it[o];else e[h] = this.createGroupElement(t[h]);
        this.searchShapes(t[h].it, e[h].it, e[h].prevViewData, e[h].gr, a + 1, m, n), t[h]._render && e[h].gr.parentNode !== i && i.appendChild(e[h].gr);
      } else "tr" === t[h].ty ? (d || (e[h] = this.createTransformElement(t[h], i)), p = e[h].transform, m.push(p)) : "sh" === t[h].ty || "rc" === t[h].ty || "el" === t[h].ty || "sr" === t[h].ty ? (d || (e[h] = this.createShapeElement(t[h], m, a)), this.setElementStyles(e[h])) : "tm" === t[h].ty || "rd" === t[h].ty || "ms" === t[h].ty || "pb" === t[h].ty ? (d ? (f = e[h]).closed = !1 : ((f = U.getModifier(t[h].ty)).init(this, t[h]), e[h] = f, this.shapeModifiers.push(f)), g.push(f)) : "rp" === t[h].ty && (d ? (f = e[h]).closed = !0 : (f = U.getModifier(t[h].ty), (e[h] = f).init(this, t, h, e), this.shapeModifiers.push(f), n = !1), g.push(f));
      this.addProcessedElement(t[h], h + 1);
    }
    for (c = u.length, h = 0; h < c; h += 1) u[h].closed = !0;
    for (c = g.length, h = 0; h < c; h += 1) g[h].closed = !0;
  }, le.prototype.renderInnerContent = function () {
    var t;
    this.renderModifiers();
    var e = this.stylesList.length;
    for (t = 0; t < e; t += 1) this.stylesList[t].reset();
    for (this.renderShape(), t = 0; t < e; t += 1) (this.stylesList[t]._mdf || this._isFirstFrame) && (this.stylesList[t].msElem && (this.stylesList[t].msElem.setAttribute("d", this.stylesList[t].d), this.stylesList[t].d = "M0 0" + this.stylesList[t].d), this.stylesList[t].pElem.setAttribute("d", this.stylesList[t].d || "M0 0"));
  }, le.prototype.renderShape = function () {
    var t,
      e,
      s = this.animatedContents.length;
    for (t = 0; t < s; t += 1) e = this.animatedContents[t], (this._isFirstFrame || e.element._isAnimated) && !0 !== e.data && e.fn(e.data, e.element, this._isFirstFrame);
  }, le.prototype.destroy = function () {
    this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
  };
  function fe() {}
  var de = function () {
      var t = {},
        a = [],
        i = 0,
        r = 0,
        n = 0,
        h = !0,
        o = !1;
      function s(t) {
        for (var e = 0, s = t.target; e < r;) a[e].animation === s && (a.splice(e, 1), e -= 1, r -= 1, s.isPaused || f()), e += 1;
      }
      function l(t, e) {
        if (!t) return null;
        for (var s = 0; s < r;) {
          if (a[s].elem === t && null !== a[s].elem) return a[s].animation;
          s += 1;
        }
        var i = new me();
        return d(i, t), i.setData(t, e), i;
      }
      function p() {
        n += 1, c();
      }
      function f() {
        n -= 1;
      }
      function d(t, e) {
        t.addEventListener("destroy", s), t.addEventListener("_active", p), t.addEventListener("_idle", f), a.push({
          elem: e,
          animation: t
        }), r += 1;
      }
      function m(t) {
        var e,
          s = t - i;
        for (e = 0; e < r; e += 1) a[e].animation.advanceTime(s);
        i = t, n && !o ? window.requestAnimationFrame(m) : h = !0;
      }
      function e(t) {
        i = t, window.requestAnimationFrame(m);
      }
      function c() {
        !o && n && h && (window.requestAnimationFrame(e), h = !1);
      }
      return t.registerAnimation = l, t.loadAnimation = function (t) {
        var e = new me();
        return d(e, null), e.setParams(t), e;
      }, t.setSpeed = function (t, e) {
        var s;
        for (s = 0; s < r; s += 1) a[s].animation.setSpeed(t, e);
      }, t.setDirection = function (t, e) {
        var s;
        for (s = 0; s < r; s += 1) a[s].animation.setDirection(t, e);
      }, t.play = function (t) {
        var e;
        for (e = 0; e < r; e += 1) a[e].animation.play(t);
      }, t.pause = function (t) {
        var e;
        for (e = 0; e < r; e += 1) a[e].animation.pause(t);
      }, t.stop = function (t) {
        var e;
        for (e = 0; e < r; e += 1) a[e].animation.stop(t);
      }, t.togglePause = function (t) {
        var e;
        for (e = 0; e < r; e += 1) a[e].animation.togglePause(t);
      }, t.searchAnimations = function (t, e, s) {
        var i,
          a = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))),
          r = a.length;
        for (i = 0; i < r; i += 1) s && a[i].setAttribute("data-bm-type", s), l(a[i], t);
        if (e && 0 === r) {
          s || (s = "svg");
          var n = document.getElementsByTagName("body")[0];
          n.innerText = "";
          var h = T("div");
          h.style.width = "100%", h.style.height = "100%", h.setAttribute("data-bm-type", s), n.appendChild(h), l(h, t);
        }
      }, t.resize = function () {
        var t;
        for (t = 0; t < r; t += 1) a[t].animation.resize();
      }, t.goToAndStop = function (t, e, s) {
        var i;
        for (i = 0; i < r; i += 1) a[i].animation.goToAndStop(t, e, s);
      }, t.destroy = function (t) {
        var e;
        for (e = r - 1; 0 <= e; e -= 1) a[e].animation.destroy(t);
      }, t.freeze = function () {
        o = !0;
      }, t.unfreeze = function () {
        o = !1, c();
      }, t.setVolume = function (t, e) {
        var s;
        for (s = 0; s < r; s += 1) a[s].animation.setVolume(t, e);
      }, t.mute = function (t) {
        var e;
        for (e = 0; e < r; e += 1) a[e].animation.mute(t);
      }, t.unmute = function (t) {
        var e;
        for (e = 0; e < r; e += 1) a[e].animation.unmute(t);
      }, t.getRegisteredAnimations = function () {
        var t,
          e = a.length,
          s = [];
        for (t = 0; t < e; t += 1) s.push(a[t].animation);
        return s;
      }, t;
    }(),
    me = function () {
      this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = S(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = a, this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = {}, this.imagePreloader = new mt(), this.audioController = ot(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this);
    };
  function ce() {
    this.effectElements = [];
  }
  z([C], me), me.prototype.setParams = function (t) {
    (t.wrapper || t.container) && (this.wrapper = t.wrapper || t.container);
    var e = "svg";
    switch (t.animType ? e = t.animType : t.renderer && (e = t.renderer), e) {
      case "canvas":
        this.renderer = new CanvasRenderer(this, t.rendererSettings);
        break;
      case "svg":
        this.renderer = new Vt(this, t.rendererSettings);
        break;
      default:
        this.renderer = new HybridRenderer(this, t.rendererSettings);
    }
    this.imagePreloader.setCacheType(e, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = e, "" === t.loop || null === t.loop || void 0 === t.loop || !0 === t.loop ? this.loop = !0 : !1 === t.loop ? this.loop = !1 : this.loop = parseInt(t.loop, 10), this.autoplay = !("autoplay" in t) || t.autoplay, this.name = t.name ? t.name : "", this.autoloadSegments = !Object.prototype.hasOwnProperty.call(t, "autoloadSegments") || t.autoloadSegments, this.assetsPath = t.assetsPath, this.initialSegment = t.initialSegment, t.audioFactory && this.audioController.setAudioFactory(t.audioFactory), t.animationData ? this.setupAnimation(t.animationData) : t.path && (-1 !== t.path.lastIndexOf("\\") ? this.path = t.path.substr(0, t.path.lastIndexOf("\\") + 1) : this.path = t.path.substr(0, t.path.lastIndexOf("/") + 1), this.fileName = t.path.substr(t.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), N.loadAnimation(t.path, this.configAnimation, this.onSetupError));
  }, me.prototype.onSetupError = function () {
    this.trigger("data_failed");
  }, me.prototype.setupAnimation = function (t) {
    N.completeAnimation(t, this.configAnimation);
  }, me.prototype.setData = function (t, e) {
    e && "object" != typeof e && (e = JSON.parse(e));
    var s = {
        wrapper: t,
        animationData: e
      },
      i = t.attributes;
    s.path = i.getNamedItem("data-animation-path") ? i.getNamedItem("data-animation-path").value : i.getNamedItem("data-bm-path") ? i.getNamedItem("data-bm-path").value : i.getNamedItem("bm-path") ? i.getNamedItem("bm-path").value : "", s.animType = i.getNamedItem("data-anim-type") ? i.getNamedItem("data-anim-type").value : i.getNamedItem("data-bm-type") ? i.getNamedItem("data-bm-type").value : i.getNamedItem("bm-type") ? i.getNamedItem("bm-type").value : i.getNamedItem("data-bm-renderer") ? i.getNamedItem("data-bm-renderer").value : i.getNamedItem("bm-renderer") ? i.getNamedItem("bm-renderer").value : "canvas";
    var a = i.getNamedItem("data-anim-loop") ? i.getNamedItem("data-anim-loop").value : i.getNamedItem("data-bm-loop") ? i.getNamedItem("data-bm-loop").value : i.getNamedItem("bm-loop") ? i.getNamedItem("bm-loop").value : "";
    "false" === a ? s.loop = !1 : "true" === a ? s.loop = !0 : "" !== a && (s.loop = parseInt(a, 10));
    var r = i.getNamedItem("data-anim-autoplay") ? i.getNamedItem("data-anim-autoplay").value : i.getNamedItem("data-bm-autoplay") ? i.getNamedItem("data-bm-autoplay").value : !i.getNamedItem("bm-autoplay") || i.getNamedItem("bm-autoplay").value;
    s.autoplay = "false" !== r, s.name = i.getNamedItem("data-name") ? i.getNamedItem("data-name").value : i.getNamedItem("data-bm-name") ? i.getNamedItem("data-bm-name").value : i.getNamedItem("bm-name") ? i.getNamedItem("bm-name").value : "", "false" === (i.getNamedItem("data-anim-prerender") ? i.getNamedItem("data-anim-prerender").value : i.getNamedItem("data-bm-prerender") ? i.getNamedItem("data-bm-prerender").value : i.getNamedItem("bm-prerender") ? i.getNamedItem("bm-prerender").value : "") && (s.prerender = !1), this.setParams(s);
  }, me.prototype.includeLayers = function (t) {
    t.op > this.animationData.op && (this.animationData.op = t.op, this.totalFrames = Math.floor(t.op - this.animationData.ip));
    var e,
      s,
      i = this.animationData.layers,
      a = i.length,
      r = t.layers,
      n = r.length;
    for (s = 0; s < n; s += 1) for (e = 0; e < a;) {
      if (i[e].id === r[s].id) {
        i[e] = r[s];
        break;
      }
      e += 1;
    }
    if ((t.chars || t.fonts) && (this.renderer.globalData.fontManager.addChars(t.chars), this.renderer.globalData.fontManager.addFonts(t.fonts, this.renderer.globalData.defs)), t.assets) for (a = t.assets.length, e = 0; e < a; e += 1) this.animationData.assets.push(t.assets[e]);
    this.animationData.__complete = !1, N.completeAnimation(this.animationData, this.onSegmentComplete);
  }, me.prototype.onSegmentComplete = function (t) {
    this.animationData = t, i && i.initExpressions(this), this.loadNextSegment();
  }, me.prototype.loadNextSegment = function () {
    var t = this.animationData.segments;
    if (!t || 0 === t.length || !this.autoloadSegments) return this.trigger("data_ready"), void (this.timeCompleted = this.totalFrames);
    var e = t.shift();
    this.timeCompleted = e.time * this.frameRate;
    var s = this.path + this.fileName + "_" + this.segmentPos + ".json";
    this.segmentPos += 1, N.loadData(s, this.includeLayers.bind(this), function () {
      this.trigger("data_failed");
    }.bind(this));
  }, me.prototype.loadSegments = function () {
    this.animationData.segments || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
  }, me.prototype.imagesLoaded = function () {
    this.trigger("loaded_images"), this.checkLoaded();
  }, me.prototype.preloadImages = function () {
    this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
  }, me.prototype.configAnimation = function (t) {
    if (this.renderer) try {
      this.animationData = t, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(t), t.assets || (t.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(t.assets), this.markers = It(t.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
    } catch (t) {
      this.triggerConfigError(t);
    }
  }, me.prototype.waitForFontsLoaded = function () {
    this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
  }, me.prototype.checkLoaded = function () {
    !this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || "canvas" !== this.renderer.rendererType) && this.imagePreloader.loadedFootages() && (this.isLoaded = !0, i && i.initExpressions(this), this.renderer.initItems(), setTimeout(function () {
      this.trigger("DOMLoaded");
    }.bind(this), 0), this.gotoFrame(), this.autoplay && this.play());
  }, me.prototype.resize = function () {
    this.renderer.updateContainerSize();
  }, me.prototype.setSubframe = function (t) {
    this.isSubframeEnabled = !!t;
  }, me.prototype.gotoFrame = function () {
    this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
  }, me.prototype.renderFrame = function () {
    if (!1 !== this.isLoaded && this.renderer) try {
      this.renderer.renderFrame(this.currentFrame + this.firstFrame);
    } catch (t) {
      this.triggerRenderFrameError(t);
    }
  }, me.prototype.play = function (t) {
    t && this.name !== t || !0 === this.isPaused && (this.isPaused = !1, this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
  }, me.prototype.pause = function (t) {
    t && this.name !== t || !1 === this.isPaused && (this.isPaused = !0, this._idle = !0, this.trigger("_idle"), this.audioController.pause());
  }, me.prototype.togglePause = function (t) {
    t && this.name !== t || (!0 === this.isPaused ? this.play() : this.pause());
  }, me.prototype.stop = function (t) {
    t && this.name !== t || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
  }, me.prototype.getMarkerData = function (t) {
    for (var e, s = 0; s < this.markers.length; s += 1) if ((e = this.markers[s]).payload && e.payload.name === t) return e;
    return null;
  }, me.prototype.goToAndStop = function (t, e, s) {
    if (!s || this.name === s) {
      var i = Number(t);
      if (isNaN(i)) {
        var a = this.getMarkerData(t);
        a && this.goToAndStop(a.time, !0);
      } else e ? this.setCurrentRawFrameValue(t) : this.setCurrentRawFrameValue(t * this.frameModifier);
      this.pause();
    }
  }, me.prototype.goToAndPlay = function (t, e, s) {
    if (!s || this.name === s) {
      var i = Number(t);
      if (isNaN(i)) {
        var a = this.getMarkerData(t);
        a && (a.duration ? this.playSegments([a.time, a.time + a.duration], !0) : this.goToAndStop(a.time, !0));
      } else this.goToAndStop(i, e, s);
      this.play();
    }
  }, me.prototype.advanceTime = function (t) {
    if (!0 !== this.isPaused && !1 !== this.isLoaded) {
      var e = this.currentRawFrame + t * this.frameModifier,
        s = !1;
      e >= this.totalFrames - 1 && 0 < this.frameModifier ? this.loop && this.playCount !== this.loop ? e >= this.totalFrames ? (this.playCount += 1, this.checkSegments(e % this.totalFrames) || (this.setCurrentRawFrameValue(e % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(e) : this.checkSegments(e > this.totalFrames ? e % this.totalFrames : 0) || (s = !0, e = this.totalFrames - 1) : e < 0 ? this.checkSegments(e % this.totalFrames) || (!this.loop || this.playCount-- <= 0 && !0 !== this.loop ? (s = !0, e = 0) : (this.setCurrentRawFrameValue(this.totalFrames + e % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0)) : this.setCurrentRawFrameValue(e), s && (this.setCurrentRawFrameValue(e), this.pause(), this.trigger("complete"));
    }
  }, me.prototype.adjustSegment = function (t, e) {
    this.playCount = 0, t[1] < t[0] ? (0 < this.frameModifier && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = t[0] - t[1], this.timeCompleted = this.totalFrames, this.firstFrame = t[1], this.setCurrentRawFrameValue(this.totalFrames - .001 - e)) : t[1] > t[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = t[1] - t[0], this.timeCompleted = this.totalFrames, this.firstFrame = t[0], this.setCurrentRawFrameValue(.001 + e)), this.trigger("segmentStart");
  }, me.prototype.setSegment = function (t, e) {
    var s = -1;
    this.isPaused && (this.currentRawFrame + this.firstFrame < t ? s = t : this.currentRawFrame + this.firstFrame > e && (s = e - t)), this.firstFrame = t, this.totalFrames = e - t, this.timeCompleted = this.totalFrames, -1 !== s && this.goToAndStop(s, !0);
  }, me.prototype.playSegments = function (t, e) {
    if (e && (this.segments.length = 0), "object" == typeof t[0]) {
      var s,
        i = t.length;
      for (s = 0; s < i; s += 1) this.segments.push(t[s]);
    } else this.segments.push(t);
    this.segments.length && e && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
  }, me.prototype.resetSegments = function (t) {
    this.segments.length = 0, this.segments.push([this.animationData.ip, this.animationData.op]), t && this.checkSegments(0);
  }, me.prototype.checkSegments = function (t) {
    return !!this.segments.length && (this.adjustSegment(this.segments.shift(), t), !0);
  }, me.prototype.destroy = function (t) {
    t && this.name !== t || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.renderer = null, this.imagePreloader = null, this.projectInterface = null);
  }, me.prototype.setCurrentRawFrameValue = function (t) {
    this.currentRawFrame = t, this.gotoFrame();
  }, me.prototype.setSpeed = function (t) {
    this.playSpeed = t, this.updaFrameModifier();
  }, me.prototype.setDirection = function (t) {
    this.playDirection = t < 0 ? -1 : 1, this.updaFrameModifier();
  }, me.prototype.setVolume = function (t, e) {
    e && this.name !== e || this.audioController.setVolume(t);
  }, me.prototype.getVolume = function () {
    return this.audioController.getVolume();
  }, me.prototype.mute = function (t) {
    t && this.name !== t || this.audioController.mute();
  }, me.prototype.unmute = function (t) {
    t && this.name !== t || this.audioController.unmute();
  }, me.prototype.updaFrameModifier = function () {
    this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
  }, me.prototype.getPath = function () {
    return this.path;
  }, me.prototype.getAssetsPath = function (t) {
    var e = "";
    if (t.e) e = t.p;else if (this.assetsPath) {
      var s = t.p;
      -1 !== s.indexOf("images/") && (s = s.split("/")[1]), e = this.assetsPath + s;
    } else e = this.path, e += t.u ? t.u : "", e += t.p;
    return e;
  }, me.prototype.getAssetData = function (t) {
    for (var e = 0, s = this.assets.length; e < s;) {
      if (t === this.assets[e].id) return this.assets[e];
      e += 1;
    }
    return null;
  }, me.prototype.hide = function () {
    this.renderer.hide();
  }, me.prototype.show = function () {
    this.renderer.show();
  }, me.prototype.getDuration = function (t) {
    return t ? this.totalFrames : this.totalFrames / this.frameRate;
  }, me.prototype.trigger = function (t) {
    if (this._cbs && this._cbs[t]) switch (t) {
      case "enterFrame":
      case "drawnFrame":
        this.triggerEvent(t, new l(t, this.currentFrame, this.totalFrames, this.frameModifier));
        break;
      case "loopComplete":
        this.triggerEvent(t, new c(t, this.loop, this.playCount, this.frameMult));
        break;
      case "complete":
        this.triggerEvent(t, new m(t, this.frameMult));
        break;
      case "segmentStart":
        this.triggerEvent(t, new u(t, this.firstFrame, this.totalFrames));
        break;
      case "destroy":
        this.triggerEvent(t, new g(t, this));
        break;
      default:
        this.triggerEvent(t);
    }
    "enterFrame" === t && this.onEnterFrame && this.onEnterFrame.call(this, new l(t, this.currentFrame, this.totalFrames, this.frameMult)), "loopComplete" === t && this.onLoopComplete && this.onLoopComplete.call(this, new c(t, this.loop, this.playCount, this.frameMult)), "complete" === t && this.onComplete && this.onComplete.call(this, new m(t, this.frameMult)), "segmentStart" === t && this.onSegmentStart && this.onSegmentStart.call(this, new u(t, this.firstFrame, this.totalFrames)), "destroy" === t && this.onDestroy && this.onDestroy.call(this, new g(t, this));
  }, me.prototype.triggerRenderFrameError = function (t) {
    var e = new y(t, this.currentFrame);
    this.triggerEvent("error", e), this.onError && this.onError.call(this, e);
  }, me.prototype.triggerConfigError = function (t) {
    var e = new b(t, this.currentFrame);
    this.triggerEvent("error", e), this.onError && this.onError.call(this, e);
  };
  var lottie = {};
  function ue() {
     de.searchAnimations();
  }
  lottie.play = de.play, lottie.pause = de.pause, lottie.setLocationHref = function (t) {
    A = t;
  }, lottie.togglePause = de.togglePause, lottie.setSpeed = de.setSpeed, lottie.setDirection = de.setDirection, lottie.stop = de.stop, lottie.searchAnimations = ue, lottie.registerAnimation = de.registerAnimation, lottie.loadAnimation = function (t) {
    return de.loadAnimation(t);
  }, lottie.setSubframeRendering = function (t) {
    a = t;
  }, lottie.resize = de.resize, lottie.goToAndStop = de.goToAndStop, lottie.destroy = de.destroy, lottie.setQuality = function (t) {
    if ("string" == typeof t) switch (t) {
      case "high":
        P = 200;
        break;
      default:
      case "medium":
        P = 50;
        break;
      case "low":
        P = 10;
    } else !isNaN(t) && 1 < t && (P = t);
  }, lottie.inBrowser = function () {
    return "undefined" != typeof navigator;
  }, lottie.installPlugin = function (t, e) {
    "expressions" === t && (i = e);
  }, lottie.freeze = de.freeze, lottie.unfreeze = de.unfreeze, lottie.setVolume = de.setVolume, lottie.mute = de.mute, lottie.unmute = de.unmute, lottie.getRegisteredAnimations = de.getRegisteredAnimations, lottie.useWebWorker = function (t) {
    p = t;
  }, lottie.setIDPrefix = function (t) {
    r = t;
  }, lottie.__getFactory = function (t) {
    switch (t) {
      case "propertyFactory":
        return B;
      case "shapePropertyFactory":
        return K;
      case "matrix":
        return R;
      default:
        return null;
    }
  }, lottie.version = "5.8.1";
  var ge,
    be = "";
  {
    var _e = document.getElementsByTagName("script"),
      ke = _e[_e.length - 1] || {
        src: ""
      };
    ge = ke.src.replace(/^[^\?]+\??/, ""), be = function (t) {
      for (var e = ge.split("&"), s = 0; s < e.length; s += 1) {
        var i = e[s].split("=");
        if (decodeURIComponent(i[0]) == t) return decodeURIComponent(i[1]);
      }
      return null;
    }("renderer");
  }
  var Ae = setInterval(function () {
    "complete" === document.readyState && (clearInterval(Ae), ue());
  }, 100);
  return lottie;
});
});

const useLottie = (element, options = {}) => {
    const [lottiePlayer, setLottiePlayer] = useState(null);
    useEffect(() => {
        if (!element) {
            return;
        }
        const player = lottie_light_min.loadAnimation(Object.assign({ container: element }, options));
        setLottiePlayer(player);
        return () => {
            player.destroy();
        };
    }, [element, options]);
    return lottiePlayer;
};

const AnimationLoop = (_a) => {
    var { data } = _a, props = __rest(_a, ["data"]);
    const [animRef, setAnimRef] = useState(null);
    const options = useMemo(() => ({
        animationData: data,
        autoplay: true,
        loop: true,
    }), [data]);
    useLottie(animRef, options);
    return React__default.createElement("div", Object.assign({ ref: setAnimRef }, props));
};
AnimationLoop.displayName = "AnimationLoop";
AnimationLoop.propTypes = {
    data: PropTypes.any.isRequired,
};

const Animation = (_a) => {
    var { data } = _a, props = __rest(_a, ["data"]);
    const [animRef, setAnimRef] = useState(null);
    const options = useMemo(() => ({
        animationData: data,
        autoplay: true,
        loop: false,
    }), [data]);
    useLottie(animRef, options);
    return React__default.createElement("div", Object.assign({ ref: setAnimRef }, props));
};
Animation.displayName = "Animation";
Animation.propTypes = {
    data: PropTypes.any.isRequired,
};

const StyledAnimation = styled(AnimationLoop) `
  ${({ theme: { loading }, $size }) => {
    switch ($size) {
        case "small":
            return css `
          width: ${loading.size.sm};
          height: ${loading.size.sm};
        `;
        case "large":
            return css `
          width: ${loading.size.lg};
          height: ${loading.size.lg};
        `;
        default:
            return css `
          width: ${loading.size.md};
          height: ${loading.size.md};
        `;
    }
}}

  ${({ $inline }) => $inline &&
    css `
      display: inline-block;
    `}
`;

var v = "5.7.4";
var fr = 23.9759979248047;
var ip = 0;
var op = 46.9999959320078;
var w = 200;
var h = 200;
var nm = "Comp 1";
var ddd = 0;
var assets = [
];
var layers = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "Shape Layer 1",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: -1,
						s: [
							0
						]
					},
					{
						t: 46.9999959320078,
						s: [
							360
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					100,
					100,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					10.417,
					10.417,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								1920,
								1920
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								51.204,
								51.204
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 21.326,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 1,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: -1,
							s: [
								0
							]
						},
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 23.5,
							s: [
								25
							]
						},
						{
							t: 47.9999958454548,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: -1,
							s: [
								0
							]
						},
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 23.5,
							s: [
								100
							]
						},
						{
							t: 47.9999958454548,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			},
			{
				ty: "st",
				c: {
					a: 0,
					k: [
						0.250980392157,
						0.81568627451,
						0.745098039216,
						1
					],
					ix: 3
				},
				o: {
					a: 0,
					k: 100,
					ix: 4
				},
				w: {
					a: 0,
					k: 110,
					ix: 5
				},
				lc: 2,
				lj: 1,
				ml: 4,
				bm: 0,
				nm: "Stroke 1",
				mn: "ADBE Vector Graphic - Stroke",
				hd: false
			}
		],
		ip: 0,
		op: 46.9999959320078,
		st: -0.99999991344698,
		bm: 0
	}
];
var markers = [
];
var LoadingData = {
	v: v,
	fr: fr,
	ip: ip,
	op: op,
	w: w,
	h: h,
	nm: nm,
	ddd: ddd,
	assets: assets,
	layers: layers,
	markers: markers
};

var v$1 = "5.7.4";
var fr$1 = 23.9759979248047;
var ip$1 = 0;
var op$1 = 46.9999959320078;
var w$1 = 200;
var h$1 = 200;
var nm$1 = "Comp 1";
var ddd$1 = 0;
var assets$1 = [
];
var layers$1 = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "Shape Layer 1",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667
							],
							y: [
								1
							]
						},
						o: {
							x: [
								0.333
							],
							y: [
								0
							]
						},
						t: -1,
						s: [
							0
						]
					},
					{
						t: 46.9999959320078,
						s: [
							360
						]
					}
				],
				ix: 10
			},
			p: {
				a: 0,
				k: [
					100,
					100,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					10.417,
					10.417,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								1920,
								1920
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								51.204,
								51.204
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 21.326,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 1,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: -1,
							s: [
								0
							]
						},
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 23.5,
							s: [
								25
							]
						},
						{
							t: 47.9999958454548,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: -1,
							s: [
								0
							]
						},
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 23.5,
							s: [
								100
							]
						},
						{
							t: 47.9999958454548,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			},
			{
				ty: "st",
				c: {
					a: 0,
					k: [
						1,
						1,
						1,
						1
					],
					ix: 3
				},
				o: {
					a: 0,
					k: 100,
					ix: 4
				},
				w: {
					a: 0,
					k: 110,
					ix: 5
				},
				lc: 2,
				lj: 1,
				ml: 4,
				bm: 0,
				nm: "Stroke 1",
				mn: "ADBE Vector Graphic - Stroke",
				hd: false
			}
		],
		ip: 0,
		op: 46.9999959320078,
		st: -0.99999991344698,
		bm: 0
	}
];
var markers$1 = [
];
var LoadingWhiteData = {
	v: v$1,
	fr: fr$1,
	ip: ip$1,
	op: op$1,
	w: w$1,
	h: h$1,
	nm: nm$1,
	ddd: ddd$1,
	assets: assets$1,
	layers: layers$1,
	markers: markers$1
};

const Loading = (_a) => {
    var { contrast, size, inline } = _a, props = __rest(_a, ["contrast", "size", "inline"]);
    return (React__default.createElement(StyledAnimation, Object.assign({}, props, { data: contrast ? LoadingWhiteData : LoadingData, "$size": size, "$inline": inline })));
};
Loading.displayName = "Loading";
Loading.propTypes = {
    contrast: PropTypes.bool,
    size: PropTypes.oneOf(["small", "large", "medium"]),
};
Loading.defaultProps = {
    contrast: false,
    size: "medium",
};

var v$2 = "5.7.4";
var fr$2 = 25;
var ip$2 = 0;
var op$2 = 250;
var w$2 = 1920;
var h$2 = 1080;
var nm$2 = "virti_logo_01";
var ddd$2 = 0;
var assets$2 = [
];
var layers$2 = [
	{
		ddd: 0,
		ind: 1,
		ty: 3,
		nm: "Scale",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 0,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					960,
					540,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 0,
						s: [
							95,
							95,
							100
						]
					},
					{
						t: 50,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		ip: 0,
		op: 250,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "I_MATTE",
		parent: 1,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					320.997,
					0.445,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					160.499,
					0.222,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										160.499,
										-69.318
									],
									[
										160.499,
										69.763
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.066666670144,
								0.105882354081,
								0.196078434587,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 4",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 0,
					k: 0,
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 24,
							s: [
								0
							]
						},
						{
							t: 59,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 24,
		op: 250,
		st: 24,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "I",
		parent: 1,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					320.997,
					0.013,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					160.499,
					0.006,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0.917,
										0.016
									],
									[
										0,
										0
									],
									[
										0.016,
										-0.916
									],
									[
										0,
										0
									],
									[
										-0.822,
										-0.1
									],
									[
										-0.038,
										-0.002
									],
									[
										0,
										0
									],
									[
										-0.106,
										0.822
									],
									[
										0.017,
										0.128
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										-0.916,
										0.016
									],
									[
										0,
										0
									],
									[
										-0.1,
										0.822
									],
									[
										0.037,
										0.005
									],
									[
										0,
										0
									],
									[
										0.822,
										0.106
									],
									[
										0.017,
										-0.128
									],
									[
										0,
										0
									],
									[
										-0.021,
										-0.917
									]
								],
								v: [
									[
										161.658,
										-26.235
									],
									[
										159.328,
										-26.235
									],
									[
										157.658,
										-24.565
									],
									[
										157.658,
										24.555
									],
									[
										158.965,
										26.226
									],
									[
										159.078,
										26.235
									],
									[
										161.658,
										26.235
									],
									[
										163.338,
										24.94
									],
									[
										163.338,
										24.555
									],
									[
										163.338,
										-24.565
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.066666670144,
								0.105882354081,
								0.196078434587,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "I",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 250,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "T_MATTE",
		parent: 1,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					213.174,
					-44.785,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					1173.174,
					495.215,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												81.84,
												-23.484
											],
											[
												109.552,
												-23.484
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.066666670144,
										0.105882354081,
										0.196078434587,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 8,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 0,
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.15
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.85
										],
										y: [
											0
										]
									},
									t: 23,
									s: [
										0
									]
								},
								{
									t: 58,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								1151.393,
								493.032
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								95.696,
								-23.484
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								200,
								200
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 35,
									s: [
										0
									]
								},
								{
									t: 36,
									s: [
										100
									]
								}
							],
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "-",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.995,
												1.018
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												12.641
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												81.84,
												-69.318
											],
											[
												81.84,
												14.811
											],
											[
												96.625,
												23.502
											],
											[
												131.334,
												4.174
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.066666670144,
										0.105882354081,
										0.196078434587,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 8,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 0,
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.15
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.85
										],
										y: [
											0
										]
									},
									t: 18,
									s: [
										0
									]
								},
								{
									t: 53,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								1173.174,
								495.215
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								106.587,
								-22.393
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								200,
								200
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "t",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 18,
		op: 250,
		st: 18,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "T",
		parent: 1,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					184.654,
					-15.43,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					92.327,
					-7.715,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										1.16,
										-0.64
									],
									[
										4.51,
										0
									],
									[
										0,
										6.06
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-0.07,
										0.853
									],
									[
										0.008,
										0.087
									],
									[
										0,
										0
									],
									[
										0.894,
										0.028
									],
									[
										0.034,
										-0.001
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0.923,
										0.011
									],
									[
										0,
										0
									],
									[
										0.05,
										-0.899
									],
									[
										-0.002,
										-0.048
									],
									[
										0,
										0
									],
									[
										-10.71,
										0
									],
									[
										-4.375,
										3.127
									],
									[
										0.415,
										0.698
									],
									[
										0.045,
										0.055
									]
								],
								o: [
									[
										-0.39,
										-0.65
									],
									[
										-1.68,
										1
									],
									[
										-6.07,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0.853,
										0.07
									],
									[
										0.007,
										-0.087
									],
									[
										0,
										0
									],
									[
										0.028,
										-0.894
									],
									[
										-0.034,
										-0.001
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-0.011,
										-0.923
									],
									[
										0,
										0
									],
									[
										-0.899,
										-0.05
									],
									[
										-0.003,
										0.048
									],
									[
										0,
										0
									],
									[
										0,
										8.26
									],
									[
										5.378,
										0.019
									],
									[
										0.698,
										-0.415
									],
									[
										-0.036,
										-0.061
									],
									[
										0,
										0
									]
								],
								v: [
									[
										104.778,
										18.165
									],
									[
										102.708,
										17.645
									],
									[
										90.968,
										21.135
									],
									[
										84.248,
										11.715
									],
									[
										84.248,
										-21.205
									],
									[
										96.658,
										-21.205
									],
									[
										98.329,
										-22.624
									],
									[
										98.328,
										-22.885
									],
									[
										98.328,
										-24.565
									],
									[
										96.76,
										-26.235
									],
									[
										96.658,
										-26.235
									],
									[
										84.258,
										-26.235
									],
									[
										84.258,
										-40.435
									],
									[
										82.578,
										-42.115
									],
									[
										80.378,
										-41.985
									],
									[
										78.66,
										-40.448
									],
									[
										78.658,
										-40.305
									],
									[
										78.658,
										12.095
									],
									[
										90.278,
										26.685
									],
									[
										105.278,
										21.905
									],
									[
										105.79,
										19.89
									],
									[
										105.668,
										19.715
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.066666670144,
								0.105882354081,
								0.196078434587,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "T",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 250,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "R_MATTE",
		parent: 1,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					65.856,
					46.2,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					32.928,
					23.1,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-9.094,
										-0.011
									],
									[
										0,
										0
									],
									[
										-3.064,
										-1.113
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										-9.094
									],
									[
										0,
										0
									],
									[
										3.26,
										0.004
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										2.638,
										69.684
									],
									[
										2.638,
										-7.032
									],
									[
										19.11,
										-23.484
									],
									[
										20.16,
										-23.483
									],
									[
										29.718,
										-21.795
									],
									[
										63.218,
										-9.627
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.066666670144,
								0.105882354081,
								0.196078434587,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 3",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 0,
					k: 0,
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 12,
							s: [
								0
							]
						},
						{
							t: 47,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 12,
		op: 250,
		st: 12,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "R",
		parent: 1,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					30.874,
					-0.439,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					15.437,
					-0.219,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										1.16,
										0.39
									],
									[
										2.74,
										0.001
									],
									[
										4.14,
										-4.24
									],
									[
										0.63,
										-0.968
									],
									[
										-0.143,
										-4.648
									],
									[
										0,
										0
									],
									[
										-0.822,
										-0.1
									],
									[
										-0.038,
										-0.002
									],
									[
										0,
										0
									],
									[
										-0.112,
										0.821
									],
									[
										0.017,
										0.132
									],
									[
										0,
										0
									],
									[
										-3.06,
										4.59
									],
									[
										-5.02,
										0
									],
									[
										-2.105,
										-0.975
									],
									[
										-0.39,
										0.9
									],
									[
										0,
										0
									]
								],
								o: [
									[
										-2.545,
										-1.017
									],
									[
										-5.77,
										0
									],
									[
										-0.813,
										0.821
									],
									[
										-2.371,
										4
									],
									[
										0,
										0
									],
									[
										-0.1,
										0.822
									],
									[
										0.037,
										0.005
									],
									[
										0,
										0
									],
									[
										0.821,
										0.112
									],
									[
										0.018,
										-0.131
									],
									[
										0,
										0
									],
									[
										0,
										-5.07
									],
									[
										2.76,
										-4.15
									],
									[
										2.32,
										0.04
									],
									[
										0.9,
										0.39
									],
									[
										0,
										0
									],
									[
										0.4,
										-1.04
									]
								],
								v: [
									[
										29.398,
										-25.146
									],
									[
										21.398,
										-26.686
									],
									[
										5.548,
										-20.966
									],
									[
										3.378,
										-18.276
									],
									[
										-0.032,
										-5.036
									],
									[
										-0.032,
										24.554
									],
									[
										1.275,
										26.224
									],
									[
										1.388,
										26.234
									],
									[
										3.968,
										26.234
									],
									[
										5.657,
										24.95
									],
									[
										5.658,
										24.554
									],
									[
										5.658,
										-0.276
									],
									[
										7.928,
										-15.276
									],
									[
										21.018,
										-21.126
									],
									[
										27.728,
										-19.586
									],
									[
										29.798,
										-20.226
									],
									[
										30.798,
										-22.806
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.066666670144,
								0.105882354081,
								0.196078434587,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "R",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 250,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "I_MATTE",
		parent: 1,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-122.363,
					0.445,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-61.181,
					0.222,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-61.181,
										-69.318
									],
									[
										-61.181,
										69.763
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.066666670144,
								0.105882354081,
								0.196078434587,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 5",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 0,
					k: 0,
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 6,
							s: [
								0
							]
						},
						{
							t: 41,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 6,
		op: 250,
		st: 6,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "I",
		parent: 1,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-122.363,
					0.013,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-61.181,
					0.006,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0.917,
										0.016
									],
									[
										0,
										0
									],
									[
										0.016,
										-0.916
									],
									[
										0,
										0
									],
									[
										-0.822,
										-0.1
									],
									[
										-0.038,
										-0.002
									],
									[
										0,
										0
									],
									[
										-0.106,
										0.822
									],
									[
										0.017,
										0.128
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										-0.916,
										0.016
									],
									[
										0,
										0
									],
									[
										-0.1,
										0.822
									],
									[
										0.037,
										0.005
									],
									[
										0,
										0
									],
									[
										0.822,
										0.106
									],
									[
										0.017,
										-0.128
									],
									[
										0,
										0
									],
									[
										-0.021,
										-0.917
									]
								],
								v: [
									[
										-60.022,
										-26.235
									],
									[
										-62.352,
										-26.235
									],
									[
										-64.022,
										-24.565
									],
									[
										-64.022,
										24.555
									],
									[
										-62.715,
										26.226
									],
									[
										-62.602,
										26.235
									],
									[
										-60.022,
										26.235
									],
									[
										-58.342,
										24.94
									],
									[
										-58.342,
										24.555
									],
									[
										-58.342,
										-24.565
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.066666670144,
								0.105882354081,
								0.196078434587,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "I",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 250,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 4,
		nm: "V_MATTE",
		parent: 1,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-276.881,
					-47.187,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-138.44,
					-23.594,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-180.091,
										-69.318
									],
									[
										-138.911,
										22.131
									],
									[
										-96.79,
										-69.318
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.066666670144,
								0.105882354081,
								0.196078434587,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 6",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 0,
					k: 0,
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 0,
							s: [
								0
							]
						},
						{
							t: 35,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 0,
		op: 250,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "V",
		parent: 1,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-277.821,
					0.445,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-138.911,
					0.222,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										1.21,
										0
									],
									[
										0,
										0
									],
									[
										0.259,
										-0.72
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0.745,
										-0.036
									],
									[
										0,
										0
									],
									[
										-0.52,
										-1.03
									],
									[
										0,
										0
									],
									[
										-0.78,
										0
									],
									[
										0,
										0
									],
									[
										-0.233,
										0.662
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										-0.763,
										-0.059
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-0.254,
										-0.701
									],
									[
										0,
										0
									],
									[
										-1.16,
										0
									],
									[
										0,
										0
									],
									[
										0.39,
										0.9
									],
									[
										0,
										0
									],
									[
										0.7,
										-0.041
									],
									[
										0,
										0
									],
									[
										0.52,
										-1.03
									]
								],
								v: [
									[
										-115.552,
										-26.235
									],
									[
										-118.342,
										-26.235
									],
									[
										-120.072,
										-25.115
									],
									[
										-138.912,
										17.515
									],
									[
										-139.042,
										17.515
									],
									[
										-157.762,
										-25.115
									],
									[
										-159.442,
										-26.235
									],
									[
										-162.282,
										-26.235
									],
									[
										-163.052,
										-24.305
									],
									[
										-140.852,
										25.525
									],
									[
										-139.302,
										26.685
									],
									[
										-138.782,
										26.685
									],
									[
										-137.242,
										25.525
									],
									[
										-114.782,
										-24.305
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.066666670144,
								0.105882354081,
								0.196078434587,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "V",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 250,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 4,
		nm: "I_Line",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					320.997,
					0.445,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					160.499,
					0.222,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										160.499,
										-69.318
									],
									[
										160.499,
										69.763
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.274509803922,
								0.745098039216,
								0.686274509804,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 1,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 4",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 34,
							s: [
								0
							]
						},
						{
							t: 59,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 24,
							s: [
								0
							]
						},
						{
							t: 59,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 24,
		op: 250,
		st: 24,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "T_Line",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					213.174,
					-44.785,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					1173.174,
					495.215,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												81.84,
												-23.484
											],
											[
												109.552,
												-23.484
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.274509803922,
										0.745098039216,
										0.686274509804,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 1,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.15
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.85
										],
										y: [
											0
										]
									},
									t: 33,
									s: [
										0
									]
								},
								{
									t: 58,
									s: [
										100
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.15
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.85
										],
										y: [
											0
										]
									},
									t: 23,
									s: [
										0
									]
								},
								{
									t: 58,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								1151.393,
								493.032
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								95.696,
								-23.484
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								200,
								200
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 35,
									s: [
										0
									]
								},
								{
									t: 36,
									s: [
										100
									]
								}
							],
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "-",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.995,
												1.018
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												12.641
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												81.84,
												-69.318
											],
											[
												81.84,
												14.811
											],
											[
												96.625,
												23.502
											],
											[
												131.334,
												4.174
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.274509803922,
										0.745098039216,
										0.686274509804,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 1,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.15
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.85
										],
										y: [
											0
										]
									},
									t: 28,
									s: [
										0
									]
								},
								{
									t: 53,
									s: [
										100
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.15
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.85
										],
										y: [
											0
										]
									},
									t: 18,
									s: [
										0
									]
								},
								{
									t: 53,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								1173.174,
								495.215
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								106.587,
								-22.393
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								200,
								200
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "t",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 18,
		op: 250,
		st: 18,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "R_Line",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					65.856,
					46.2,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					32.928,
					23.1,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-9.094,
										-0.011
									],
									[
										0,
										0
									],
									[
										-3.064,
										-1.113
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										-9.094
									],
									[
										0,
										0
									],
									[
										3.26,
										0.004
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										2.638,
										69.684
									],
									[
										2.638,
										-7.032
									],
									[
										19.11,
										-23.484
									],
									[
										20.16,
										-23.483
									],
									[
										29.718,
										-21.795
									],
									[
										63.218,
										-9.627
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.274509803922,
								0.745098039216,
								0.686274509804,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 1,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 3",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 22,
							s: [
								0
							]
						},
						{
							t: 47,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 12,
							s: [
								0
							]
						},
						{
							t: 47,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 12,
		op: 250,
		st: 12,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "I_Line",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-122.363,
					0.445,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-61.181,
					0.222,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-61.181,
										-69.318
									],
									[
										-61.181,
										69.763
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.274509803922,
								0.745098039216,
								0.686274509804,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 1,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 5",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 16,
							s: [
								0
							]
						},
						{
							t: 41,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 6,
							s: [
								0
							]
						},
						{
							t: 41,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 6,
		op: 250,
		st: 6,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "V_Line",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-276.881,
					-47.187,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-138.44,
					-23.594,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-180.091,
										-69.318
									],
									[
										-138.911,
										22.131
									],
									[
										-96.79,
										-69.318
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.274509803922,
								0.745098039216,
								0.686274509804,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 1,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 6",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 10,
							s: [
								0
							]
						},
						{
							t: 35,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 0,
							s: [
								0
							]
						},
						{
							t: 35,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 0,
		op: 250,
		st: 0,
		bm: 0
	}
];
var markers$2 = [
];
var logoMid = {
	v: v$2,
	fr: fr$2,
	ip: ip$2,
	op: op$2,
	w: w$2,
	h: h$2,
	nm: nm$2,
	ddd: ddd$2,
	assets: assets$2,
	layers: layers$2,
	markers: markers$2
};

var v$3 = "5.7.4";
var fr$3 = 25;
var ip$3 = 0;
var op$3 = 250;
var w$3 = 1920;
var h$3 = 1080;
var nm$3 = "virti_logo_02";
var ddd$3 = 0;
var assets$3 = [
];
var layers$3 = [
	{
		ddd: 0,
		ind: 1,
		ty: 3,
		nm: "Scale",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 0,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					960,
					540,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.667,
								0.667,
								0.667
							],
							y: [
								1,
								1,
								1
							]
						},
						o: {
							x: [
								0.333,
								0.333,
								0.333
							],
							y: [
								0,
								0,
								0
							]
						},
						t: 0,
						s: [
							95,
							95,
							100
						]
					},
					{
						t: 50,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		ip: 0,
		op: 250,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "I_MATTE",
		parent: 1,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					320.997,
					0.445,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					160.499,
					0.222,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										160.499,
										-69.318
									],
									[
										160.499,
										69.763
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.066666670144,
								0.105882354081,
								0.196078434587,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 4",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 0,
					k: 0,
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 24,
							s: [
								0
							]
						},
						{
							t: 59,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 24,
		op: 250,
		st: 24,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "I",
		parent: 1,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					320.997,
					0.013,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					160.499,
					0.006,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0.917,
										0.016
									],
									[
										0,
										0
									],
									[
										0.016,
										-0.916
									],
									[
										0,
										0
									],
									[
										-0.822,
										-0.1
									],
									[
										-0.038,
										-0.002
									],
									[
										0,
										0
									],
									[
										-0.106,
										0.822
									],
									[
										0.017,
										0.128
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										-0.916,
										0.016
									],
									[
										0,
										0
									],
									[
										-0.1,
										0.822
									],
									[
										0.037,
										0.005
									],
									[
										0,
										0
									],
									[
										0.822,
										0.106
									],
									[
										0.017,
										-0.128
									],
									[
										0,
										0
									],
									[
										-0.021,
										-0.917
									]
								],
								v: [
									[
										161.658,
										-26.235
									],
									[
										159.328,
										-26.235
									],
									[
										157.658,
										-24.565
									],
									[
										157.658,
										24.555
									],
									[
										158.965,
										26.226
									],
									[
										159.078,
										26.235
									],
									[
										161.658,
										26.235
									],
									[
										163.338,
										24.94
									],
									[
										163.338,
										24.555
									],
									[
										163.338,
										-24.565
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.976470588235,
								0.976470588235,
								0.976470588235,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "I",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 250,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "T_MATTE",
		parent: 1,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					213.174,
					-44.785,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					1173.174,
					495.215,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												81.84,
												-23.484
											],
											[
												109.552,
												-23.484
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.066666670144,
										0.105882354081,
										0.196078434587,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 8,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 0,
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.15
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.85
										],
										y: [
											0
										]
									},
									t: 23,
									s: [
										0
									]
								},
								{
									t: 58,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								1151.393,
								493.032
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								95.696,
								-23.484
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								200,
								200
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 35,
									s: [
										0
									]
								},
								{
									t: 36,
									s: [
										100
									]
								}
							],
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "-",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.995,
												1.018
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												12.641
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												81.84,
												-69.318
											],
											[
												81.84,
												14.811
											],
											[
												96.625,
												23.502
											],
											[
												131.334,
												4.174
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.066666670144,
										0.105882354081,
										0.196078434587,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 8,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 0,
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.15
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.85
										],
										y: [
											0
										]
									},
									t: 18,
									s: [
										0
									]
								},
								{
									t: 53,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								1173.174,
								495.215
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								106.587,
								-22.393
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								200,
								200
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "t",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 18,
		op: 250,
		st: 18,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "T",
		parent: 1,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					184.654,
					-15.43,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					92.327,
					-7.715,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										1.16,
										-0.64
									],
									[
										4.51,
										0
									],
									[
										0,
										6.06
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-0.07,
										0.853
									],
									[
										0.008,
										0.087
									],
									[
										0,
										0
									],
									[
										0.894,
										0.028
									],
									[
										0.034,
										-0.001
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0.923,
										0.011
									],
									[
										0,
										0
									],
									[
										0.05,
										-0.899
									],
									[
										-0.002,
										-0.048
									],
									[
										0,
										0
									],
									[
										-10.71,
										0
									],
									[
										-4.375,
										3.127
									],
									[
										0.415,
										0.698
									],
									[
										0.045,
										0.055
									]
								],
								o: [
									[
										-0.39,
										-0.65
									],
									[
										-1.68,
										1
									],
									[
										-6.07,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0.853,
										0.07
									],
									[
										0.007,
										-0.087
									],
									[
										0,
										0
									],
									[
										0.028,
										-0.894
									],
									[
										-0.034,
										-0.001
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-0.011,
										-0.923
									],
									[
										0,
										0
									],
									[
										-0.899,
										-0.05
									],
									[
										-0.003,
										0.048
									],
									[
										0,
										0
									],
									[
										0,
										8.26
									],
									[
										5.378,
										0.019
									],
									[
										0.698,
										-0.415
									],
									[
										-0.036,
										-0.061
									],
									[
										0,
										0
									]
								],
								v: [
									[
										104.778,
										18.165
									],
									[
										102.708,
										17.645
									],
									[
										90.968,
										21.135
									],
									[
										84.248,
										11.715
									],
									[
										84.248,
										-21.205
									],
									[
										96.658,
										-21.205
									],
									[
										98.329,
										-22.624
									],
									[
										98.328,
										-22.885
									],
									[
										98.328,
										-24.565
									],
									[
										96.76,
										-26.235
									],
									[
										96.658,
										-26.235
									],
									[
										84.258,
										-26.235
									],
									[
										84.258,
										-40.435
									],
									[
										82.578,
										-42.115
									],
									[
										80.378,
										-41.985
									],
									[
										78.66,
										-40.448
									],
									[
										78.658,
										-40.305
									],
									[
										78.658,
										12.095
									],
									[
										90.278,
										26.685
									],
									[
										105.278,
										21.905
									],
									[
										105.79,
										19.89
									],
									[
										105.668,
										19.715
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.976470588235,
								0.976470588235,
								0.976470588235,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "T",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 250,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "R_MATTE",
		parent: 1,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					65.856,
					46.2,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					32.928,
					23.1,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-9.094,
										-0.011
									],
									[
										0,
										0
									],
									[
										-3.064,
										-1.113
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										-9.094
									],
									[
										0,
										0
									],
									[
										3.26,
										0.004
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										2.638,
										69.684
									],
									[
										2.638,
										-7.032
									],
									[
										19.11,
										-23.484
									],
									[
										20.16,
										-23.483
									],
									[
										29.718,
										-21.795
									],
									[
										63.218,
										-9.627
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.066666670144,
								0.105882354081,
								0.196078434587,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 3",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 0,
					k: 0,
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 12,
							s: [
								0
							]
						},
						{
							t: 47,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 12,
		op: 250,
		st: 12,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "R",
		parent: 1,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					30.874,
					-0.439,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					15.437,
					-0.219,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										1.16,
										0.39
									],
									[
										2.74,
										0.001
									],
									[
										4.14,
										-4.24
									],
									[
										0.63,
										-0.968
									],
									[
										-0.143,
										-4.648
									],
									[
										0,
										0
									],
									[
										-0.822,
										-0.1
									],
									[
										-0.038,
										-0.002
									],
									[
										0,
										0
									],
									[
										-0.112,
										0.821
									],
									[
										0.017,
										0.132
									],
									[
										0,
										0
									],
									[
										-3.06,
										4.59
									],
									[
										-5.02,
										0
									],
									[
										-2.105,
										-0.975
									],
									[
										-0.39,
										0.9
									],
									[
										0,
										0
									]
								],
								o: [
									[
										-2.545,
										-1.017
									],
									[
										-5.77,
										0
									],
									[
										-0.813,
										0.821
									],
									[
										-2.371,
										4
									],
									[
										0,
										0
									],
									[
										-0.1,
										0.822
									],
									[
										0.037,
										0.005
									],
									[
										0,
										0
									],
									[
										0.821,
										0.112
									],
									[
										0.018,
										-0.131
									],
									[
										0,
										0
									],
									[
										0,
										-5.07
									],
									[
										2.76,
										-4.15
									],
									[
										2.32,
										0.04
									],
									[
										0.9,
										0.39
									],
									[
										0,
										0
									],
									[
										0.4,
										-1.04
									]
								],
								v: [
									[
										29.398,
										-25.146
									],
									[
										21.398,
										-26.686
									],
									[
										5.548,
										-20.966
									],
									[
										3.378,
										-18.276
									],
									[
										-0.032,
										-5.036
									],
									[
										-0.032,
										24.554
									],
									[
										1.275,
										26.224
									],
									[
										1.388,
										26.234
									],
									[
										3.968,
										26.234
									],
									[
										5.657,
										24.95
									],
									[
										5.658,
										24.554
									],
									[
										5.658,
										-0.276
									],
									[
										7.928,
										-15.276
									],
									[
										21.018,
										-21.126
									],
									[
										27.728,
										-19.586
									],
									[
										29.798,
										-20.226
									],
									[
										30.798,
										-22.806
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.976470588235,
								0.976470588235,
								0.976470588235,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "R",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 250,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "I_MATTE",
		parent: 1,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-122.363,
					0.445,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-61.181,
					0.222,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-61.181,
										-69.318
									],
									[
										-61.181,
										69.763
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.066666670144,
								0.105882354081,
								0.196078434587,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 5",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 0,
					k: 0,
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 6,
							s: [
								0
							]
						},
						{
							t: 41,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 6,
		op: 250,
		st: 6,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "I",
		parent: 1,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-122.363,
					0.013,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-61.181,
					0.006,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0.917,
										0.016
									],
									[
										0,
										0
									],
									[
										0.016,
										-0.916
									],
									[
										0,
										0
									],
									[
										-0.822,
										-0.1
									],
									[
										-0.038,
										-0.002
									],
									[
										0,
										0
									],
									[
										-0.106,
										0.822
									],
									[
										0.017,
										0.128
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										-0.916,
										0.016
									],
									[
										0,
										0
									],
									[
										-0.1,
										0.822
									],
									[
										0.037,
										0.005
									],
									[
										0,
										0
									],
									[
										0.822,
										0.106
									],
									[
										0.017,
										-0.128
									],
									[
										0,
										0
									],
									[
										-0.021,
										-0.917
									]
								],
								v: [
									[
										-60.022,
										-26.235
									],
									[
										-62.352,
										-26.235
									],
									[
										-64.022,
										-24.565
									],
									[
										-64.022,
										24.555
									],
									[
										-62.715,
										26.226
									],
									[
										-62.602,
										26.235
									],
									[
										-60.022,
										26.235
									],
									[
										-58.342,
										24.94
									],
									[
										-58.342,
										24.555
									],
									[
										-58.342,
										-24.565
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.976470588235,
								0.976470588235,
								0.976470588235,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "I",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 250,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 4,
		nm: "V_MATTE",
		parent: 1,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-276.881,
					-47.187,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-138.44,
					-23.594,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-180.091,
										-69.318
									],
									[
										-138.911,
										22.131
									],
									[
										-96.79,
										-69.318
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.066666670144,
								0.105882354081,
								0.196078434587,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 6",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 0,
					k: 0,
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 0,
							s: [
								0
							]
						},
						{
							t: 35,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 0,
		op: 250,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "V",
		parent: 1,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-277.821,
					0.445,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-138.911,
					0.222,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										1.21,
										0
									],
									[
										0,
										0
									],
									[
										0.259,
										-0.72
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0.745,
										-0.036
									],
									[
										0,
										0
									],
									[
										-0.52,
										-1.03
									],
									[
										0,
										0
									],
									[
										-0.78,
										0
									],
									[
										0,
										0
									],
									[
										-0.233,
										0.662
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										-0.763,
										-0.059
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-0.254,
										-0.701
									],
									[
										0,
										0
									],
									[
										-1.16,
										0
									],
									[
										0,
										0
									],
									[
										0.39,
										0.9
									],
									[
										0,
										0
									],
									[
										0.7,
										-0.041
									],
									[
										0,
										0
									],
									[
										0.52,
										-1.03
									]
								],
								v: [
									[
										-115.552,
										-26.235
									],
									[
										-118.342,
										-26.235
									],
									[
										-120.072,
										-25.115
									],
									[
										-138.912,
										17.515
									],
									[
										-139.042,
										17.515
									],
									[
										-157.762,
										-25.115
									],
									[
										-159.442,
										-26.235
									],
									[
										-162.282,
										-26.235
									],
									[
										-163.052,
										-24.305
									],
									[
										-140.852,
										25.525
									],
									[
										-139.302,
										26.685
									],
									[
										-138.782,
										26.685
									],
									[
										-137.242,
										25.525
									],
									[
										-114.782,
										-24.305
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.976470588235,
								0.976470588235,
								0.976470588235,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "V",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 250,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 4,
		nm: "I_Line",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					320.997,
					0.445,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					160.499,
					0.222,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										160.499,
										-69.318
									],
									[
										160.499,
										69.763
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.274509803922,
								0.745098039216,
								0.686274509804,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 1,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 4",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 34,
							s: [
								0
							]
						},
						{
							t: 59,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 24,
							s: [
								0
							]
						},
						{
							t: 59,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 24,
		op: 250,
		st: 24,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "T_Line",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					213.174,
					-44.785,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					1173.174,
					495.215,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												81.84,
												-23.484
											],
											[
												109.552,
												-23.484
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.274509803922,
										0.745098039216,
										0.686274509804,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 1,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.15
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.85
										],
										y: [
											0
										]
									},
									t: 33,
									s: [
										0
									]
								},
								{
									t: 58,
									s: [
										100
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.15
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.85
										],
										y: [
											0
										]
									},
									t: 23,
									s: [
										0
									]
								},
								{
									t: 58,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								1151.393,
								493.032
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								95.696,
								-23.484
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								200,
								200
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 35,
									s: [
										0
									]
								},
								{
									t: 36,
									s: [
										100
									]
								}
							],
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "-",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.995,
												1.018
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												12.641
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												81.84,
												-69.318
											],
											[
												81.84,
												14.811
											],
											[
												96.625,
												23.502
											],
											[
												131.334,
												4.174
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.274509803922,
										0.745098039216,
										0.686274509804,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 1,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.15
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.85
										],
										y: [
											0
										]
									},
									t: 28,
									s: [
										0
									]
								},
								{
									t: 53,
									s: [
										100
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.15
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.85
										],
										y: [
											0
										]
									},
									t: 18,
									s: [
										0
									]
								},
								{
									t: 53,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								1173.174,
								495.215
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								106.587,
								-22.393
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								200,
								200
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "t",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 18,
		op: 250,
		st: 18,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "R_Line",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					65.856,
					46.2,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					32.928,
					23.1,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-9.094,
										-0.011
									],
									[
										0,
										0
									],
									[
										-3.064,
										-1.113
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										-9.094
									],
									[
										0,
										0
									],
									[
										3.26,
										0.004
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										2.638,
										69.684
									],
									[
										2.638,
										-7.032
									],
									[
										19.11,
										-23.484
									],
									[
										20.16,
										-23.483
									],
									[
										29.718,
										-21.795
									],
									[
										63.218,
										-9.627
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.274509803922,
								0.745098039216,
								0.686274509804,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 1,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 3",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 22,
							s: [
								0
							]
						},
						{
							t: 47,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 12,
							s: [
								0
							]
						},
						{
							t: 47,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 12,
		op: 250,
		st: 12,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "I_Line",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-122.363,
					0.445,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-61.181,
					0.222,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-61.181,
										-69.318
									],
									[
										-61.181,
										69.763
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.274509803922,
								0.745098039216,
								0.686274509804,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 1,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 5",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 16,
							s: [
								0
							]
						},
						{
							t: 41,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 6,
							s: [
								0
							]
						},
						{
							t: 41,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 6,
		op: 250,
		st: 6,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "V_Line",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-276.881,
					-47.187,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-138.44,
					-23.594,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-180.091,
										-69.318
									],
									[
										-138.911,
										22.131
									],
									[
										-96.79,
										-69.318
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.274509803922,
								0.745098039216,
								0.686274509804,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 1,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 6",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 10,
							s: [
								0
							]
						},
						{
							t: 35,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 0,
							s: [
								0
							]
						},
						{
							t: 35,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 0,
		op: 250,
		st: 0,
		bm: 0
	}
];
var markers$3 = [
];
var logoSnow = {
	v: v$3,
	fr: fr$3,
	ip: ip$3,
	op: op$3,
	w: w$3,
	h: h$3,
	nm: nm$3,
	ddd: ddd$3,
	assets: assets$3,
	layers: layers$3,
	markers: markers$3
};

var v$4 = "5.7.4";
var fr$4 = 25;
var ip$4 = 0;
var op$4 = 65;
var w$4 = 1920;
var h$4 = 1080;
var nm$4 = "virti_logo_02";
var ddd$4 = 0;
var assets$4 = [
];
var layers$4 = [
	{
		ddd: 0,
		ind: 1,
		ty: 3,
		nm: "Null 2",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 0,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					960,
					540,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					220,
					220,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		ip: 0,
		op: 65,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 3,
		nm: "Scale",
		parent: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 0,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0,
					0,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.566,
								0.566,
								0.667
							],
							y: [
								0.14,
								0.14,
								1
							]
						},
						o: {
							x: [
								0.42,
								0.42,
								0.333
							],
							y: [
								0.052,
								0.052,
								0
							]
						},
						t: 0,
						s: [
							95,
							95,
							100
						]
					},
					{
						i: {
							x: [
								0.31,
								0.31,
								0.833
							],
							y: [
								0.946,
								0.946,
								1
							]
						},
						o: {
							x: [
								0.574,
								0.574,
								0.333
							],
							y: [
								0.007,
								0.007,
								0
							]
						},
						t: 57,
						s: [
							100,
							100,
							100
						]
					},
					{
						i: {
							x: [
								0.085,
								0.085,
								0.833
							],
							y: [
								0.926,
								0.926,
								1
							]
						},
						o: {
							x: [
								0.416,
								0.416,
								0.167
							],
							y: [
								0.02,
								0.02,
								0
							]
						},
						t: 60,
						s: [
							110,
							110,
							100
						]
					},
					{
						t: 65,
						s: [
							100,
							100,
							100
						]
					}
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		ip: 0,
		op: 68,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "I_MATTE",
		parent: 2,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					320.997,
					0.445,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					160.499,
					0.222,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										160.499,
										-69.318
									],
									[
										160.499,
										69.763
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.066666670144,
								0.105882354081,
								0.196078434587,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 4",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 0,
					k: 0,
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 24,
							s: [
								0
							]
						},
						{
							t: 59,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 24,
		op: 76,
		st: 24,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "I",
		parent: 2,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					320.997,
					0.013,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					160.499,
					0.006,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0.917,
										0.016
									],
									[
										0,
										0
									],
									[
										0.016,
										-0.916
									],
									[
										0,
										0
									],
									[
										-0.822,
										-0.1
									],
									[
										-0.038,
										-0.002
									],
									[
										0,
										0
									],
									[
										-0.106,
										0.822
									],
									[
										0.017,
										0.128
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										-0.916,
										0.016
									],
									[
										0,
										0
									],
									[
										-0.1,
										0.822
									],
									[
										0.037,
										0.005
									],
									[
										0,
										0
									],
									[
										0.822,
										0.106
									],
									[
										0.017,
										-0.128
									],
									[
										0,
										0
									],
									[
										-0.021,
										-0.917
									]
								],
								v: [
									[
										161.658,
										-26.235
									],
									[
										159.328,
										-26.235
									],
									[
										157.658,
										-24.565
									],
									[
										157.658,
										24.555
									],
									[
										158.965,
										26.226
									],
									[
										159.078,
										26.235
									],
									[
										161.658,
										26.235
									],
									[
										163.338,
										24.94
									],
									[
										163.338,
										24.555
									],
									[
										163.338,
										-24.565
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.250980392157,
								0.81568627451,
								0.745098039216,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "I",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 68,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "T_MATTE",
		parent: 2,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					213.174,
					-44.785,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					1173.174,
					495.215,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												81.84,
												-23.484
											],
											[
												109.552,
												-23.484
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.066666670144,
										0.105882354081,
										0.196078434587,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 8,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 0,
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.15
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.85
										],
										y: [
											0
										]
									},
									t: 23,
									s: [
										0
									]
								},
								{
									t: 58,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								1151.393,
								493.032
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								95.696,
								-23.484
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								200,
								200
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 35,
									s: [
										0
									]
								},
								{
									t: 36,
									s: [
										100
									]
								}
							],
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "-",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.995,
												1.018
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												12.641
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												81.84,
												-69.318
											],
											[
												81.84,
												14.811
											],
											[
												96.625,
												23.502
											],
											[
												131.334,
												4.174
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.066666670144,
										0.105882354081,
										0.196078434587,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 8,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 0,
							k: 0,
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.15
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.85
										],
										y: [
											0
										]
									},
									t: 18,
									s: [
										0
									]
								},
								{
									t: 53,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								1173.174,
								495.215
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								106.587,
								-22.393
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								200,
								200
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "t",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 18,
		op: 76,
		st: 18,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "T",
		parent: 2,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					184.654,
					-15.43,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					92.327,
					-7.715,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										1.16,
										-0.64
									],
									[
										4.51,
										0
									],
									[
										0,
										6.06
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-0.07,
										0.853
									],
									[
										0.008,
										0.087
									],
									[
										0,
										0
									],
									[
										0.894,
										0.028
									],
									[
										0.034,
										-0.001
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0.923,
										0.011
									],
									[
										0,
										0
									],
									[
										0.05,
										-0.899
									],
									[
										-0.002,
										-0.048
									],
									[
										0,
										0
									],
									[
										-10.71,
										0
									],
									[
										-4.375,
										3.127
									],
									[
										0.415,
										0.698
									],
									[
										0.045,
										0.055
									]
								],
								o: [
									[
										-0.39,
										-0.65
									],
									[
										-1.68,
										1
									],
									[
										-6.07,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0.853,
										0.07
									],
									[
										0.007,
										-0.087
									],
									[
										0,
										0
									],
									[
										0.028,
										-0.894
									],
									[
										-0.034,
										-0.001
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-0.011,
										-0.923
									],
									[
										0,
										0
									],
									[
										-0.899,
										-0.05
									],
									[
										-0.003,
										0.048
									],
									[
										0,
										0
									],
									[
										0,
										8.26
									],
									[
										5.378,
										0.019
									],
									[
										0.698,
										-0.415
									],
									[
										-0.036,
										-0.061
									],
									[
										0,
										0
									]
								],
								v: [
									[
										104.778,
										18.165
									],
									[
										102.708,
										17.645
									],
									[
										90.968,
										21.135
									],
									[
										84.248,
										11.715
									],
									[
										84.248,
										-21.205
									],
									[
										96.658,
										-21.205
									],
									[
										98.329,
										-22.624
									],
									[
										98.328,
										-22.885
									],
									[
										98.328,
										-24.565
									],
									[
										96.76,
										-26.235
									],
									[
										96.658,
										-26.235
									],
									[
										84.258,
										-26.235
									],
									[
										84.258,
										-40.435
									],
									[
										82.578,
										-42.115
									],
									[
										80.378,
										-41.985
									],
									[
										78.66,
										-40.448
									],
									[
										78.658,
										-40.305
									],
									[
										78.658,
										12.095
									],
									[
										90.278,
										26.685
									],
									[
										105.278,
										21.905
									],
									[
										105.79,
										19.89
									],
									[
										105.668,
										19.715
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.250980392157,
								0.81568627451,
								0.745098039216,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "T",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 68,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "R_MATTE",
		parent: 2,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					65.856,
					46.2,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					32.928,
					23.1,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-9.094,
										-0.011
									],
									[
										0,
										0
									],
									[
										-3.064,
										-1.113
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										-9.094
									],
									[
										0,
										0
									],
									[
										3.26,
										0.004
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										2.638,
										69.684
									],
									[
										2.638,
										-7.032
									],
									[
										19.11,
										-23.484
									],
									[
										20.16,
										-23.483
									],
									[
										29.718,
										-21.795
									],
									[
										63.218,
										-9.627
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.066666670144,
								0.105882354081,
								0.196078434587,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 3",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 0,
					k: 0,
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 12,
							s: [
								0
							]
						},
						{
							t: 47,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 12,
		op: 76,
		st: 12,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "R",
		parent: 2,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					30.874,
					-0.439,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					15.437,
					-0.219,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										1.16,
										0.39
									],
									[
										2.74,
										0.001
									],
									[
										4.14,
										-4.24
									],
									[
										0.63,
										-0.968
									],
									[
										-0.143,
										-4.648
									],
									[
										0,
										0
									],
									[
										-0.822,
										-0.1
									],
									[
										-0.038,
										-0.002
									],
									[
										0,
										0
									],
									[
										-0.112,
										0.821
									],
									[
										0.017,
										0.132
									],
									[
										0,
										0
									],
									[
										-3.06,
										4.59
									],
									[
										-5.02,
										0
									],
									[
										-2.105,
										-0.975
									],
									[
										-0.39,
										0.9
									],
									[
										0,
										0
									]
								],
								o: [
									[
										-2.545,
										-1.017
									],
									[
										-5.77,
										0
									],
									[
										-0.813,
										0.821
									],
									[
										-2.371,
										4
									],
									[
										0,
										0
									],
									[
										-0.1,
										0.822
									],
									[
										0.037,
										0.005
									],
									[
										0,
										0
									],
									[
										0.821,
										0.112
									],
									[
										0.018,
										-0.131
									],
									[
										0,
										0
									],
									[
										0,
										-5.07
									],
									[
										2.76,
										-4.15
									],
									[
										2.32,
										0.04
									],
									[
										0.9,
										0.39
									],
									[
										0,
										0
									],
									[
										0.4,
										-1.04
									]
								],
								v: [
									[
										29.398,
										-25.146
									],
									[
										21.398,
										-26.686
									],
									[
										5.548,
										-20.966
									],
									[
										3.378,
										-18.276
									],
									[
										-0.032,
										-5.036
									],
									[
										-0.032,
										24.554
									],
									[
										1.275,
										26.224
									],
									[
										1.388,
										26.234
									],
									[
										3.968,
										26.234
									],
									[
										5.657,
										24.95
									],
									[
										5.658,
										24.554
									],
									[
										5.658,
										-0.276
									],
									[
										7.928,
										-15.276
									],
									[
										21.018,
										-21.126
									],
									[
										27.728,
										-19.586
									],
									[
										29.798,
										-20.226
									],
									[
										30.798,
										-22.806
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.250980392157,
								0.81568627451,
								0.745098039216,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "R",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 68,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "I_MATTE",
		parent: 2,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-122.363,
					0.445,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-61.181,
					0.222,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-61.181,
										-69.318
									],
									[
										-61.181,
										69.763
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.066666670144,
								0.105882354081,
								0.196078434587,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 5",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 0,
					k: 0,
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 6,
							s: [
								0
							]
						},
						{
							t: 41,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 6,
		op: 76,
		st: 6,
		bm: 0
	},
	{
		ddd: 0,
		ind: 10,
		ty: 4,
		nm: "I",
		parent: 2,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-122.363,
					0.013,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-61.181,
					0.006,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0.917,
										0.016
									],
									[
										0,
										0
									],
									[
										0.016,
										-0.916
									],
									[
										0,
										0
									],
									[
										-0.822,
										-0.1
									],
									[
										-0.038,
										-0.002
									],
									[
										0,
										0
									],
									[
										-0.106,
										0.822
									],
									[
										0.017,
										0.128
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										-0.916,
										0.016
									],
									[
										0,
										0
									],
									[
										-0.1,
										0.822
									],
									[
										0.037,
										0.005
									],
									[
										0,
										0
									],
									[
										0.822,
										0.106
									],
									[
										0.017,
										-0.128
									],
									[
										0,
										0
									],
									[
										-0.021,
										-0.917
									]
								],
								v: [
									[
										-60.022,
										-26.235
									],
									[
										-62.352,
										-26.235
									],
									[
										-64.022,
										-24.565
									],
									[
										-64.022,
										24.555
									],
									[
										-62.715,
										26.226
									],
									[
										-62.602,
										26.235
									],
									[
										-60.022,
										26.235
									],
									[
										-58.342,
										24.94
									],
									[
										-58.342,
										24.555
									],
									[
										-58.342,
										-24.565
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.250980392157,
								0.81568627451,
								0.745098039216,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "I",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 68,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "V_MATTE",
		parent: 2,
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-276.881,
					-47.187,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-138.44,
					-23.594,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-180.091,
										-69.318
									],
									[
										-138.911,
										22.131
									],
									[
										-96.79,
										-69.318
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.066666670144,
								0.105882354081,
								0.196078434587,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 6",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 0,
					k: 0,
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 0,
							s: [
								0
							]
						},
						{
							t: 35,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 0,
		op: 76,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 12,
		ty: 4,
		nm: "V",
		parent: 2,
		tt: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-277.821,
					0.445,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-138.911,
					0.222,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										1.21,
										0
									],
									[
										0,
										0
									],
									[
										0.259,
										-0.72
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0.745,
										-0.036
									],
									[
										0,
										0
									],
									[
										-0.52,
										-1.03
									],
									[
										0,
										0
									],
									[
										-0.78,
										0
									],
									[
										0,
										0
									],
									[
										-0.233,
										0.662
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										-0.763,
										-0.059
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-0.254,
										-0.701
									],
									[
										0,
										0
									],
									[
										-1.16,
										0
									],
									[
										0,
										0
									],
									[
										0.39,
										0.9
									],
									[
										0,
										0
									],
									[
										0.7,
										-0.041
									],
									[
										0,
										0
									],
									[
										0.52,
										-1.03
									]
								],
								v: [
									[
										-115.552,
										-26.235
									],
									[
										-118.342,
										-26.235
									],
									[
										-120.072,
										-25.115
									],
									[
										-138.912,
										17.515
									],
									[
										-139.042,
										17.515
									],
									[
										-157.762,
										-25.115
									],
									[
										-159.442,
										-26.235
									],
									[
										-162.282,
										-26.235
									],
									[
										-163.052,
										-24.305
									],
									[
										-140.852,
										25.525
									],
									[
										-139.302,
										26.685
									],
									[
										-138.782,
										26.685
									],
									[
										-137.242,
										25.525
									],
									[
										-114.782,
										-24.305
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0.250980392157,
								0.81568627451,
								0.745098039216,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "V",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 68,
		st: 0,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 4,
		nm: "I_Line",
		parent: 2,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					320.997,
					0.445,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					160.499,
					0.222,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										160.499,
										-69.318
									],
									[
										160.499,
										69.763
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.066666666667,
								0.105882352941,
								0.196078431373,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 1,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 4",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 34,
							s: [
								0
							]
						},
						{
							t: 59,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 24,
							s: [
								0
							]
						},
						{
							t: 59,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 24,
		op: 68,
		st: 24,
		bm: 0
	},
	{
		ddd: 0,
		ind: 14,
		ty: 4,
		nm: "T_Line",
		parent: 2,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					213.174,
					-44.785,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					1173.174,
					495.215,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												81.84,
												-23.484
											],
											[
												109.552,
												-23.484
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.066666666667,
										0.105882352941,
										0.196078431373,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 1,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 1",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.15
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.85
										],
										y: [
											0
										]
									},
									t: 33,
									s: [
										0
									]
								},
								{
									t: 58,
									s: [
										100
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.15
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.85
										],
										y: [
											0
										]
									},
									t: 23,
									s: [
										0
									]
								},
								{
									t: 58,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								1151.393,
								493.032
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								95.696,
								-23.484
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								200,
								200
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 35,
									s: [
										0
									]
								},
								{
									t: 36,
									s: [
										100
									]
								}
							],
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "-",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "gr",
				it: [
					{
						ty: "gr",
						it: [
							{
								ind: 0,
								ty: "sh",
								ix: 1,
								ks: {
									a: 0,
									k: {
										i: [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-1.995,
												1.018
											],
											[
												0,
												0
											]
										],
										o: [
											[
												0,
												0
											],
											[
												0,
												12.641
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										v: [
											[
												81.84,
												-69.318
											],
											[
												81.84,
												14.811
											],
											[
												96.625,
												23.502
											],
											[
												131.334,
												4.174
											]
										],
										c: false
									},
									ix: 2
								},
								nm: "Path 1",
								mn: "ADBE Vector Shape - Group",
								hd: false
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										0.066666666667,
										0.105882352941,
										0.196078431373,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 1,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 10,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform"
							}
						],
						nm: "Group 2",
						np: 2,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false
					},
					{
						ty: "tm",
						s: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.15
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.85
										],
										y: [
											0
										]
									},
									t: 28,
									s: [
										0
									]
								},
								{
									t: 53,
									s: [
										100
									]
								}
							],
							ix: 1
						},
						e: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.15
										],
										y: [
											1
										]
									},
									o: {
										x: [
											0.85
										],
										y: [
											0
										]
									},
									t: 18,
									s: [
										0
									]
								},
								{
									t: 53,
									s: [
										100
									]
								}
							],
							ix: 2
						},
						o: {
							a: 0,
							k: 0,
							ix: 3
						},
						m: 1,
						ix: 2,
						nm: "Trim Paths 1",
						mn: "ADBE Vector Filter - Trim",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								1173.174,
								495.215
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								106.587,
								-22.393
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								200,
								200
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "t",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 2,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 18,
		op: 68,
		st: 18,
		bm: 0
	},
	{
		ddd: 0,
		ind: 15,
		ty: 4,
		nm: "R_Line",
		parent: 2,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					65.856,
					46.2,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					32.928,
					23.1,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										-9.094,
										-0.011
									],
									[
										0,
										0
									],
									[
										-3.064,
										-1.113
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										-9.094
									],
									[
										0,
										0
									],
									[
										3.26,
										0.004
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										2.638,
										69.684
									],
									[
										2.638,
										-7.032
									],
									[
										19.11,
										-23.484
									],
									[
										20.16,
										-23.483
									],
									[
										29.718,
										-21.795
									],
									[
										63.218,
										-9.627
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.066666666667,
								0.105882352941,
								0.196078431373,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 1,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 3",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 22,
							s: [
								0
							]
						},
						{
							t: 47,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 12,
							s: [
								0
							]
						},
						{
							t: 47,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 12,
		op: 68,
		st: 12,
		bm: 0
	},
	{
		ddd: 0,
		ind: 16,
		ty: 4,
		nm: "I_Line",
		parent: 2,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-122.363,
					0.445,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-61.181,
					0.222,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-61.181,
										-69.318
									],
									[
										-61.181,
										69.763
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.066666666667,
								0.105882352941,
								0.196078431373,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 1,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 5",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 16,
							s: [
								0
							]
						},
						{
							t: 41,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 6,
							s: [
								0
							]
						},
						{
							t: 41,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 6,
		op: 68,
		st: 6,
		bm: 0
	},
	{
		ddd: 0,
		ind: 17,
		ty: 4,
		nm: "V_Line",
		parent: 2,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					-276.881,
					-47.187,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-138.44,
					-23.594,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					200,
					200,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-180.091,
										-69.318
									],
									[
										-138.911,
										22.131
									],
									[
										-96.79,
										-69.318
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.066666666667,
								0.105882352941,
								0.196078431373,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 1,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 10,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Group 6",
				np: 2,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 10,
							s: [
								0
							]
						},
						{
							t: 35,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.15
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.85
								],
								y: [
									0
								]
							},
							t: 0,
							s: [
								0
							]
						},
						{
							t: 35,
							s: [
								100
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 0,
		op: 68,
		st: 0,
		bm: 0
	}
];
var markers$4 = [
];
var splashScreen = {
	v: v$4,
	fr: fr$4,
	ip: ip$4,
	op: op$4,
	w: w$4,
	h: h$4,
	nm: nm$4,
	ddd: ddd$4,
	assets: assets$4,
	layers: layers$4,
	markers: markers$4
};

const AutosaveContainer = styled.div `
  display: grid;
  align-items: center;
  grid-template-columns: 75px 26px;
  gap: 12px;
  height: 32px;
  text-align: right;
`;

/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
      value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? useLayoutEffect : useEffect;

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;
  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;
    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && a instanceof Map && b instanceof Map) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done) if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done) if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }
    if (hasSet && a instanceof Set && b instanceof Set) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done) if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) if (a[i] !== b[i]) return false;
      return true;
    }
    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;
    for (i = length; i-- !== 0;) if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }
  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message || '').match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }
  var prevOptions = useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };
  var _React$useState = useState({
      styles: {
        popper: {
          position: optionsWithDefaults.strategy,
          left: '0',
          top: '0'
        },
        arrow: {
          position: 'absolute'
        }
      },
      attributes: {}
    }),
    state = _React$useState[0],
    setState = _React$useState[1];
  var updateStateModifier = useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        flushSync(function () {
          setState({
            styles: fromEntries(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };
    if (reactFastCompare(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }
    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

const IconContainer = styled.div `
  ${({ $size, $color }) => css `
    display: inline-flex;
    // not desirable to have min-width, but it's more practical
    // this is due to how fonts have a dynamic width given a height
    min-width: ${$size};
    height: ${$size};
    font-size: ${$size};
    line-height: ${$size};
    align-items: center;
    justify-content: center;

    // need this layer to override Icomoon's default colour rule
    [class^="virti-icon-"],
    [class*=" virti-icon-"] {
      display: inline-flex;
      align-items: center;
      justify-content: center;

      &::before {
        color: ${$color};
        vertical-align: middle;
      }
    }
  `}
`;

const getSize = (size) => {
    if (size == null) {
        return "1rem";
    }
    if (!isNaN(Number(size))) {
        return `${size}px`;
    }
    return size;
};

var source = "https://cdn.icomoon.io/204546/VirtiWeb/style.css?38wttk";
var icons = [
	"success-solid",
	"error-solid",
	"downloadcloud-solid",
	"microphoneoff-solid",
	"information-solid",
	"hint-solid",
	"compass-solid",
	"camera-offset-solid",
	"vh-feedback-solid",
	"emotion-solid",
	"objective-solid",
	"speech-bubble-solid",
	"medical-solid",
	"branch-solid",
	"medical-circle-solid",
	"speech-bubble-circle-solid",
	"v-fast-solid",
	"v-amazing-solid",
	"v-bold-solid",
	"video-2d-solid",
	"diagnosis-solid",
	"alert-solid",
	"ar-solid",
	"badge-solid",
	"bookmark-solid",
	"camera-solid",
	"document-solid",
	"fastforward-solid",
	"help-solid",
	"pause-solid",
	"play-solid",
	"rewind-solid",
	"skipbackward-solid",
	"skipforward-solid",
	"speaker-solid",
	"stop-solid",
	"tag-solid",
	"user-solid",
	"vr-solid",
	"bin-solid",
	"book-solid",
	"eye-closed-solid",
	"eye-solid",
	"heart-solid",
	"home-solid",
	"pill-solid",
	"star-solid",
	"testtubes-solid",
	"bell-solid",
	"briefcase-solid",
	"calendar-solid",
	"cap-solid",
	"clock-solid",
	"cog-solid",
	"dot-solid",
	"envelope-solid",
	"hotspot-solid",
	"microphone-solid",
	"padlock-solid",
	"pen-solid",
	"phone-solid",
	"support-solid",
	"video-solid",
	"add-solid",
	"beta-solid",
	"body-solid",
	"clipboard-solid",
	"fire-solid",
	"form-solid",
	"medicinejar-solid",
	"patient-solid",
	"streaming-solid",
	"downloaded-solid",
	"happy-solid",
	"haptics-solid",
	"liferaft-solid",
	"like-solid",
	"mute-solid",
	"neutral-solid",
	"reset-position-solid",
	"sad-solid",
	"share-screen-solid",
	"videooff-solid",
	"color-text-outline",
	"color-background-outline",
	"text-bold-outline",
	"text-italic-outline",
	"text-underline-outline",
	"align-left-outline",
	"align-middle-h-outline",
	"align-right-outline",
	"align-top-outline",
	"align-middle-v-outline",
	"align-bottom-outline",
	"dollar-outline",
	"simulation-outline",
	"swap-outline",
	"draggable-outline",
	"evaluation-outline",
	"expand-outline",
	"heatmap-outline",
	"start-point-outline",
	"iphone-outline",
	"envelope-outline",
	"cog-outline",
	"dropdown-outline",
	"clipboard-outline",
	"duplicate-outline",
	"v-fast-outline",
	"menu-expand-outline",
	"menu-collapse-outline",
	"plus-outline",
	"feedback-outline",
	"group-outline",
	"virtual-human-outline",
	"course-outline",
	"media-outline",
	"chevron-outline",
	"analytics-outline",
	"dashboard-outline",
	"exit-fullscreen-outline",
	"actions-outline",
	"hint-outline",
	"mouse-left-click-outline",
	"vh-actions-outline",
	"vh-feedback-outline",
	"captions-outline",
	"v-amazing-outline",
	"v-bold-outline",
	"video-3d-outline",
	"information-outline",
	"diagnosis-outline",
	"downloadcloud-outline",
	"downloaded-outline",
	"haptics-outline",
	"image-outline",
	"investigation-outline",
	"liferaft-outline",
	"mute-background-noise-outline",
	"mute-outline",
	"reset-position-outline",
	"upload-outline",
	"virti-outline",
	"background-noise-outline",
	"dots-outline",
	"hand-outline",
	"move-outline",
	"asterisk-outline",
	"beta-outline",
	"branch-outline",
	"checkbox-outline",
	"download-outline",
	"error-outline",
	"form-outline",
	"likertscale-outline",
	"link-outline",
	"logout-outline",
	"loop-outline",
	"medicinejar-outline",
	"paragraph-outline",
	"singlequestion-outline",
	"success-outline",
	"bell-outline",
	"briefcase-outline",
	"calendar-outline",
	"cap-outline",
	"clock-outline",
	"fullscreen-outline",
	"hotspot-outline",
	"microphone-outline",
	"minus-outline",
	"padlock-outline",
	"pen-outline",
	"phone-outline",
	"power-outline",
	"slider-outline",
	"support-outline",
	"video-outline",
	"arrow-outline",
	"barchart-outline",
	"bin-outline",
	"bloodpressure-outline",
	"book-outline",
	"brain-outline",
	"eye-outline",
	"heart-outline",
	"heartrate-outline",
	"home-outline",
	"linechart-outline",
	"lungs-outline",
	"minimise-outline",
	"pill-outline",
	"speechbubble-outline",
	"star-outline",
	"stethoscope-outline",
	"temperature-outline",
	"testtubes-outline",
	"virti-eye-outline",
	"virti-heart-outline",
	"virti-oxygen-outline",
	"alert-outline",
	"ar-outline",
	"badge-outline",
	"bookmark-outline",
	"camera-outline",
	"cross-outline",
	"document-outline",
	"fastforward-outline",
	"help-outline",
	"menu-outline",
	"pause-outline",
	"play-outline",
	"rewind-outline",
	"search-outline",
	"skipbackward-outline",
	"skipforward-outline",
	"speaker-outline",
	"stop-outline",
	"tag-outline",
	"tick-outline",
	"user-outline",
	"vr-outline",
	"arrow-up-outline"
];
var metadata = {
	source: source,
	icons: icons
};

const Icon = forwardRef((_a, ref) => {
    var _b;
    var { icon, type, size: inputSize, color } = _a, props = __rest(_a, ["icon", "type", "size", "color"]);
    const size = useMemo(() => getSize(inputSize), [inputSize]);
    const iconKey = useMemo(() => {
        const key = `${icon}-${type || "solid"}`;
        if (metadata.icons.includes(key)) {
            return key;
        }
        return `${icon}-${type === "outline" ? "solid" : "outline"}`;
    }, [icon, type]);
    return (React__default.createElement(IconContainer, Object.assign({ ref: ref }, props, { "data-testid": (_b = props["data-testid"]) !== null && _b !== void 0 ? _b : "Icon", "$size": size, "$color": color }),
        React__default.createElement("span", { className: `virti-icon-${iconKey}`, "aria-hidden": true, "data-name": iconKey })));
});
Icon.displayName = "Icon";
// NOTE: did not want to use enum and PropTypes.oneOf for this prop type
const IconPropType = PropTypes.string;
// propTypes and defaultProps are optional, but still useful for runtime checking and providing a fallback
Icon.propTypes = {
    /**
     * What Icon to use - usually in the form of [icon-name]-[type], separated by hyphens, e.g. help-solid or blood-pressure-outline.
     */
    icon: IconPropType.isRequired,
    /**
     * The style of the icon - either [solid] or [outlined]
     */
    type: PropTypes.oneOf(["solid", "outline"]),
    /**
     * The colour of the icon.
     */
    color: PropTypes.string,
    /**
     * How large should the icon be? (font-size)
     */
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
Icon.defaultProps = {
    type: "solid",
    color: "inherit",
    size: null,
};

function last() {
  var _ref;
  return _ref = arguments.length - 1, _ref < 0 || arguments.length <= _ref ? undefined : arguments[_ref];
}
function negation(a) {
  return -a;
}
function addition(a, b) {
  return a + b;
}
function subtraction(a, b) {
  return a - b;
}
function multiplication(a, b) {
  return a * b;
}
function division(a, b) {
  return a / b;
}
function max() {
  return Math.max.apply(Math, arguments);
}
function min() {
  return Math.min.apply(Math, arguments);
}
function comma() {
  return Array.of.apply(Array, arguments);
}
var defaultSymbols = {
  symbols: {
    '*': {
      infix: {
        symbol: '*',
        f: multiplication,
        notation: 'infix',
        precedence: 4,
        rightToLeft: 0,
        argCount: 2
      },
      symbol: '*',
      regSymbol: '\\*'
    },
    '/': {
      infix: {
        symbol: '/',
        f: division,
        notation: 'infix',
        precedence: 4,
        rightToLeft: 0,
        argCount: 2
      },
      symbol: '/',
      regSymbol: '/'
    },
    '+': {
      infix: {
        symbol: '+',
        f: addition,
        notation: 'infix',
        precedence: 2,
        rightToLeft: 0,
        argCount: 2
      },
      prefix: {
        symbol: '+',
        f: last,
        notation: 'prefix',
        precedence: 3,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: '+',
      regSymbol: '\\+'
    },
    '-': {
      infix: {
        symbol: '-',
        f: subtraction,
        notation: 'infix',
        precedence: 2,
        rightToLeft: 0,
        argCount: 2
      },
      prefix: {
        symbol: '-',
        f: negation,
        notation: 'prefix',
        precedence: 3,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: '-',
      regSymbol: '-'
    },
    ',': {
      infix: {
        symbol: ',',
        f: comma,
        notation: 'infix',
        precedence: 1,
        rightToLeft: 0,
        argCount: 2
      },
      symbol: ',',
      regSymbol: ','
    },
    '(': {
      prefix: {
        symbol: '(',
        f: last,
        notation: 'prefix',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: '(',
      regSymbol: '\\('
    },
    ')': {
      postfix: {
        symbol: ')',
        f: undefined,
        notation: 'postfix',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: ')',
      regSymbol: '\\)'
    },
    min: {
      func: {
        symbol: 'min',
        f: min,
        notation: 'func',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: 'min',
      regSymbol: 'min\\b'
    },
    max: {
      func: {
        symbol: 'max',
        f: max,
        notation: 'func',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: 'max',
      regSymbol: 'max\\b'
    }
  }
};
var defaultSymbolMap = defaultSymbols;

// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js

/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */
var ERRORS = {
  "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
  "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
  "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
  "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
  "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
  "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
  "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
  "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
  "9": "Please provide a number of steps to the modularScale helper.\n\n",
  "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
  "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
  "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
  "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "16": "You must provide a template to this method.\n\n",
  "17": "You passed an unsupported selector state to this method.\n\n",
  "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "23": "fontFace expects a name of a font-family.\n\n",
  "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "25": "fontFace expects localFonts to be an array.\n\n",
  "26": "fontFace expects fileFormats to be an array.\n\n",
  "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
  "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
  "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
  "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "36": "Property must be a string value.\n\n",
  "37": "Syntax Error at %s.\n\n",
  "38": "Formula contains a function that needs parentheses at %s.\n\n",
  "39": "Formula is missing closing parenthesis at %s.\n\n",
  "40": "Formula has too many closing parentheses at %s.\n\n",
  "41": "All values in a formula must have the same unit or be unitless.\n\n",
  "42": "Please provide a number of steps to the modularScale helper.\n\n",
  "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
  "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
  "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
  "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
  "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
  "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "53": "fontFace expects localFonts to be an array.\n\n",
  "54": "fontFace expects fileFormats to be an array.\n\n",
  "55": "fontFace expects a name of a font-family.\n\n",
  "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
  "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "61": "Property must be a string value.\n\n",
  "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
  "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
  "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
  "67": "You must provide a template to this method.\n\n",
  "68": "You passed an unsupported selector state to this method.\n\n",
  "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
  "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
  "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "73": "Please provide a valid CSS variable.\n\n",
  "74": "CSS variable not found and no default was provided.\n\n",
  "75": "important requires a valid style object, got a %s instead.\n\n",
  "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
  "77": "remToPx expects a value in \"rem\" but you provided it in \"%s\".\n\n",
  "78": "base must be set in \"px\" or \"%\" but you set it in \"%s\".\n"
};
/**
 * super basic version of sprintf
 * @private
 */

function format() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var a = args[0];
  var b = [];
  var c;
  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }
  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });
  return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */

var PolishedError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(PolishedError, _Error);
  function PolishedError(code) {
    var _this;
    if (process.env.NODE_ENV === 'production') {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    } else {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      _this = _Error.call(this, format.apply(void 0, [ERRORS[code]].concat(args))) || this;
    }
    return _assertThisInitialized(_this);
  }
  return PolishedError;
}(/*#__PURE__*/_wrapNativeSuper(Error));
var unitRegExp = /((?!\w)a|na|hc|mc|dg|me[r]?|xe|ni(?![a-zA-Z])|mm|cp|tp|xp|q(?!s)|hv|xamv|nimv|wv|sm|s(?!\D|$)|ged|darg?|nrut)/g; // Merges additional math functionality into the defaults.

function mergeSymbolMaps(additionalSymbols) {
  var symbolMap = {};
  symbolMap.symbols = additionalSymbols ? _extends({}, defaultSymbolMap.symbols, additionalSymbols.symbols) : _extends({}, defaultSymbolMap.symbols);
  return symbolMap;
}
function exec(operators, values) {
  var _ref;
  var op = operators.pop();
  values.push(op.f.apply(op, (_ref = []).concat.apply(_ref, values.splice(-op.argCount))));
  return op.precedence;
}
function calculate(expression, additionalSymbols) {
  var symbolMap = mergeSymbolMaps(additionalSymbols);
  var match;
  var operators = [symbolMap.symbols['('].prefix];
  var values = [];
  var pattern = new RegExp(
  // Pattern for numbers
  "\\d+(?:\\.\\d+)?|" +
  // ...and patterns for individual operators/function names
  Object.keys(symbolMap.symbols).map(function (key) {
    return symbolMap.symbols[key];
  }) // longer symbols should be listed first
  // $FlowFixMe
  .sort(function (a, b) {
    return b.symbol.length - a.symbol.length;
  }) // $FlowFixMe
  .map(function (val) {
    return val.regSymbol;
  }).join('|') + "|(\\S)", 'g');
  pattern.lastIndex = 0; // Reset regular expression object

  var afterValue = false;
  do {
    match = pattern.exec(expression);
    var _ref2 = match || [')', undefined],
      token = _ref2[0],
      bad = _ref2[1];
    var notNumber = symbolMap.symbols[token];
    var notNewValue = notNumber && !notNumber.prefix && !notNumber.func;
    var notAfterValue = !notNumber || !notNumber.postfix && !notNumber.infix; // Check for syntax errors:

    if (bad || (afterValue ? notAfterValue : notNewValue)) {
      throw new PolishedError(37, match ? match.index : expression.length, expression);
    }
    if (afterValue) {
      // We either have an infix or postfix operator (they should be mutually exclusive)
      var curr = notNumber.postfix || notNumber.infix;
      do {
        var prev = operators[operators.length - 1];
        if ((curr.precedence - prev.precedence || prev.rightToLeft) > 0) break; // Apply previous operator, since it has precedence over current one
      } while (exec(operators, values)); // Exit loop after executing an opening parenthesis or function

      afterValue = curr.notation === 'postfix';
      if (curr.symbol !== ')') {
        operators.push(curr); // Postfix always has precedence over any operator that follows after it

        if (afterValue) exec(operators, values);
      }
    } else if (notNumber) {
      // prefix operator or function
      operators.push(notNumber.prefix || notNumber.func);
      if (notNumber.func) {
        // Require an opening parenthesis
        match = pattern.exec(expression);
        if (!match || match[0] !== '(') {
          throw new PolishedError(38, match ? match.index : expression.length, expression);
        }
      }
    } else {
      // number
      values.push(+token);
      afterValue = true;
    }
  } while (match && operators.length);
  if (operators.length) {
    throw new PolishedError(39, match ? match.index : expression.length, expression);
  } else if (match) {
    throw new PolishedError(40, match ? match.index : expression.length, expression);
  } else {
    return values.pop();
  }
}
function reverseString(str) {
  return str.split('').reverse().join('');
}
/**
 * Helper for doing math with CSS Units. Accepts a formula as a string. All values in the formula must have the same unit (or be unitless). Supports complex formulas utliziing addition, subtraction, multiplication, division, square root, powers, factorial, min, max, as well as parentheses for order of operation.
 *
 *In cases where you need to do calculations with mixed units where one unit is a [relative length unit](https://developer.mozilla.org/en-US/docs/Web/CSS/length#Relative_length_units), you will want to use [CSS Calc](https://developer.mozilla.org/en-US/docs/Web/CSS/calc).
 *
 * *warning* While we've done everything possible to ensure math safely evalutes formulas expressed as strings, you should always use extreme caution when passing `math` user provided values.
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: math('12rem + 8rem'),
 *   fontSize: math('(12px + 2px) * 3'),
 *   fontSize: math('3px^2 + sqrt(4)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${math('12rem + 8rem')};
 *   fontSize: ${math('(12px + 2px) * 3')};
 *   fontSize: ${math('3px^2 + sqrt(4)')};
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   fontSize: '20rem',
 *   fontSize: '42px',
 *   fontSize: '11px',
 * }
 */

function math(formula, additionalSymbols) {
  var reversedFormula = reverseString(formula);
  var formulaMatch = reversedFormula.match(unitRegExp); // Check that all units are the same

  if (formulaMatch && !formulaMatch.every(function (unit) {
    return unit === formulaMatch[0];
  })) {
    throw new PolishedError(41);
  }
  var cleanFormula = reverseString(reversedFormula.replace(unitRegExp, ''));
  return "" + calculate(cleanFormula, additionalSymbols) + (formulaMatch ? reverseString(formulaMatch[0]) : '');
}
function colorToInt(color) {
  return Math.round(color * 255);
}
function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}
function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }
  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  } // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV

  var huePrime = (hue % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;
  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }
  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}
var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */

function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}
var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */

function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new PolishedError(3);
  }
  var normalizedColor = nameToHex(color);
  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }
  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha: alpha
    };
  }
  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }
  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }
  var rgbMatched = rgbRegex.exec(normalizedColor);
  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }
  var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));
  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
  }
  var hslMatched = hslRegex.exec(normalizedColor);
  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);
    if (!hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, rgbColorString);
    }
    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }
  var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));
  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);
    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";
    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
    if (!_hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, _rgbColorString);
    }
    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
    };
  }
  throw new PolishedError(5);
}
function rgbToHsl(color) {
  // make sure rgb are contained in a set of [0, 255]
  var red = color.red / 255;
  var green = color.green / 255;
  var blue = color.blue / 255;
  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var lightness = (max + min) / 2;
  if (max === min) {
    // achromatic
    if (color.alpha !== undefined) {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness,
        alpha: color.alpha
      };
    } else {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness
      };
    }
  }
  var hue;
  var delta = max - min;
  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
  switch (max) {
    case red:
      hue = (green - blue) / delta + (green < blue ? 6 : 0);
      break;
    case green:
      hue = (blue - red) / delta + 2;
      break;
    default:
      // blue case
      hue = (red - green) / delta + 4;
      break;
  }
  hue *= 60;
  if (color.alpha !== undefined) {
    return {
      hue: hue,
      saturation: saturation,
      lightness: lightness,
      alpha: color.alpha
    };
  }
  return {
    hue: hue,
    saturation: saturation,
    lightness: lightness
  };
}

/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */
function parseToHsl(color) {
  // Note: At a later stage we can optimize this function as right now a hsl
  // color would be parsed converted to rgb values and converted back to hsl.
  return rgbToHsl(parseToRgb(color));
}

/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }
  return value;
};
var reduceHexValue$1 = reduceHexValue;
function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}
function colorToHex(color) {
  return numberToHex(Math.round(color * 255));
}
function convertToHex(red, green, blue) {
  return reduceHexValue$1("#" + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}
function hslToHex(hue, saturation, lightness) {
  return hslToRgb(hue, saturation, lightness, convertToHex);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */
function hsl(value, saturation, lightness) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') {
    return hslToHex(value, saturation, lightness);
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined) {
    return hslToHex(value.hue, value.saturation, value.lightness);
  }
  throw new PolishedError(1);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */
function hsla(value, saturation, lightness, alpha) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') {
    return alpha >= 1 ? hslToHex(value, saturation, lightness) : "rgba(" + hslToRgb(value, saturation, lightness) + "," + alpha + ")";
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) {
    return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
  }
  throw new PolishedError(2);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */
function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue$1("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue$1("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }
  throw new PolishedError(6);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }
  throw new PolishedError(7);
}
var isRgb = function isRgb(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var isRgba = function isRgba(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};
var isHsl = function isHsl(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var isHsla = function isHsla(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */

function toColorString(color) {
  if (typeof color !== 'object') throw new PolishedError(8);
  if (isRgba(color)) return rgba(color);
  if (isRgb(color)) return rgb(color);
  if (isHsla(color)) return hsla(color);
  if (isHsl(color)) return hsl(color);
  throw new PolishedError(8);
}

// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function curried(f, length, acc) {
  return function fn() {
    // eslint-disable-next-line prefer-rest-params
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
} // eslint-disable-next-line no-redeclare

function curry(f) {
  // eslint-disable-line no-redeclare
  return curried(f, f.length, []);
}
function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}

/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */

function darken(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness - parseFloat(amount))
  }));
} // prettier-ignore

var curriedDarken = /*#__PURE__*/curry
/* ::<number | string, string, string> */(darken);
var curriedDarken$1 = curriedDarken;

/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */

function getLuminance(color) {
  if (color === 'transparent') return 0;
  var rgbColor = parseToRgb(color);
  var _Object$keys$map = Object.keys(rgbColor).map(function (key) {
      var channel = rgbColor[key] / 255;
      return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }),
    r = _Object$keys$map[0],
    g = _Object$keys$map[1],
    b = _Object$keys$map[2];
  return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}

/**
 * Returns the contrast ratio between two colors based on
 * [W3's recommended equation for calculating contrast](http://www.w3.org/TR/WCAG20/#contrast-ratiodef).
 *
 * @example
 * const contrastRatio = getContrast('#444', '#fff');
 */

function getContrast(color1, color2) {
  var luminance1 = getLuminance(color1);
  var luminance2 = getLuminance(color2);
  return parseFloat((luminance1 > luminance2 ? (luminance1 + 0.05) / (luminance2 + 0.05) : (luminance2 + 0.05) / (luminance1 + 0.05)).toFixed(2));
}

/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */

function lighten(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness + parseFloat(amount))
  }));
} // prettier-ignore

var curriedLighten = /*#__PURE__*/curry
/* ::<number | string, string, string> */(lighten);
var curriedLighten$1 = curriedLighten;

/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */

function mix(weight, color, otherColor) {
  if (color === 'transparent') return otherColor;
  if (otherColor === 'transparent') return color;
  if (weight === 0) return otherColor;
  var parsedColor1 = parseToRgb(color);
  var color1 = _extends({}, parsedColor1, {
    alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
  });
  var parsedColor2 = parseToRgb(otherColor);
  var color2 = _extends({}, parsedColor2, {
    alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
  }); // The formula is copied from the original Sass implementation:
  // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method

  var alphaDelta = color1.alpha - color2.alpha;
  var x = parseFloat(weight) * 2 - 1;
  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
  var z = 1 + x * alphaDelta;
  var weight1 = (y / z + 1) / 2.0;
  var weight2 = 1 - weight1;
  var mixedColor = {
    red: Math.floor(color1.red * weight1 + color2.red * weight2),
    green: Math.floor(color1.green * weight1 + color2.green * weight2),
    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
    alpha: color1.alpha * parseFloat(weight) + color2.alpha * (1 - parseFloat(weight))
  };
  return rgba(mixedColor);
} // prettier-ignore

var curriedMix = /*#__PURE__*/curry
/* ::<number | string, string, string, string> */(mix);
var mix$1 = curriedMix;
var defaultReturnIfLightColor = '#000';
var defaultReturnIfDarkColor = '#fff';
/**
 * Returns black or white (or optional passed colors) for best
 * contrast depending on the luminosity of the given color.
 * When passing custom return colors, strict mode ensures that the
 * return color always meets or exceeds WCAG level AA or greater. If this test
 * fails, the default return color (black or white) is returned in place of the
 * custom return color. You can optionally turn off strict mode.
 *
 * Follows [W3C specs for readability](https://www.w3.org/TR/WCAG20-TECHS/G18.html).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('black', '#001', '#ff8'),
 *   color: readableColor('white', '#001', '#ff8'),
 *   color: readableColor('red', '#333', '#ddd', true)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('black', '#001', '#ff8')};
 *   color: ${readableColor('white', '#001', '#ff8')};
 *   color: ${readableColor('red', '#333', '#ddd', true)};
 * `
 *
 * // CSS in JS Output
 * element {
 *   color: "#fff";
 *   color: "#ff8";
 *   color: "#001";
 *   color: "#000";
 * }
 */

function readableColor(color, returnIfLightColor, returnIfDarkColor, strict) {
  if (returnIfLightColor === void 0) {
    returnIfLightColor = defaultReturnIfLightColor;
  }
  if (returnIfDarkColor === void 0) {
    returnIfDarkColor = defaultReturnIfDarkColor;
  }
  if (strict === void 0) {
    strict = true;
  }
  var isColorLight = getLuminance(color) > 0.179;
  var preferredReturnColor = isColorLight ? returnIfLightColor : returnIfDarkColor;
  if (!strict || getContrast(color, preferredReturnColor) >= 4.5) {
    return preferredReturnColor;
  }
  return isColorLight ? defaultReturnIfLightColor : defaultReturnIfDarkColor;
}

/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff'),
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')};
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */

function transparentize(amount, color) {
  if (color === 'transparent') return color;
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
  var colorWithAlpha = _extends({}, parsedColor, {
    alpha: guard(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
  });
  return rgba(colorWithAlpha);
} // prettier-ignore

var curriedTransparentize = /*#__PURE__*/curry
/* ::<number | string, string, string> */(transparentize);
var curriedTransparentize$1 = curriedTransparentize;

const typeColor = css `
  ${({ $type, theme: { color } }) => {
    switch ($type) {
        case "menu":
            return color.contrast.base;
        case "success":
            return color.successDark;
        case "warning":
            return color.warningDark;
        case "error":
            return color.errorDark;
        case "midnight":
            return color.midnight;
        case "pink":
            return color.pink;
        case "turquoise":
            return color.turquoise;
        case "base":
            return color.base;
        case "white":
            return color.white;
        case "blue":
        default:
            return color.blue;
    }
}}
`;
const typeColorContrast = css `
  ${({ $type, theme: { color } }) => {
    switch ($type) {
        case "menu":
            return color.base;
        case "success":
            return color.contrast.successDark;
        case "warning":
            return color.contrast.warningDark;
        case "error":
            return color.contrast.errorDark;
        case "midnight":
            return color.contrast.midnight;
        case "pink":
            return color.contrast.pink;
        case "turquoise":
            return color.contrast.turquoise;
        case "base":
            return color.contrast.base;
        case "white":
            return color.contrast.white;
        case "blue":
        default:
            return color.contrast.blue;
    }
}}
`;
const TooltipContainer = styled.button.attrs({
    type: "button",
}) `
  ${({ $type, theme }) => css `
    border: transparent;
    background: transparent;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: ${theme.spacing.sm};
    cursor: pointer;

    color: ${$type === "menu" ? theme.color.base : typeColor};
  `}
`;
const TooltipPopper = styled.div `
  ${({ $opened, theme: { borderRadius, color, spacing } }) => css `
    z-index: 1006;
    opacity: 0;
    pointer-events: none;
    color: ${typeColorContrast};
    background-color: ${typeColor};
    border-radius: ${borderRadius.md};
    box-shadow: 0 0 3px ${curriedTransparentize$1(0.4, color.base)};

    ${$opened &&
    css `
      opacity: 1;
      transition: opacity ease 50ms 10ms;
      pointer-events: all;
    `}

    &[data-popper-placement='left-start'] {
      margin-top: ${spacing.md};
      border-top-right-radius: 0;
    }

    &[data-popper-placement="left-end"] {
      margin-bottom: ${spacing.md};
      border-bottom-right-radius: 0;
    }

    &[data-popper-placement="right-start"] {
      margin-top: ${spacing.md};
      border-top-left-radius: 0;
    }

    &[data-popper-placement="right-end"] {
      margin-bottom: ${spacing.md};
      border-bottom-left-radius: 0;
    }

    &[data-popper-placement="top-start"] {
      margin-left: ${spacing.md};
      border-bottom-left-radius: 0;
    }

    &[data-popper-placement="top-end"] {
      margin-right: ${spacing.md};
      border-bottom-right-radius: 0;
    }

    &[data-popper-placement="bottom-start"] {
      margin-left: ${spacing.md};
      border-top-left-radius: 0;
    }

    &[data-popper-placement="bottom-end"] {
      margin-right: ${spacing.md};
      border-top-right-radius: 0;
    }
  `}
`;
const TooltipContent = styled.div `
  ${({ theme }) => {
    const { tooltip: { height, width }, spacing, fontWeight, lineHeight, fontSize, } = theme;
    return css `
      z-index: 1006;
      padding: ${spacing.md};
      max-width: ${width};
      width: max-content;

      // for fallback
      max-height: ${height};
      max-height: max(${math(`${height} / 2`)}, min(${height}, 50vh));

      display: flex;
      flex-direction: column;
      overflow: auto;
      white-space: pre-wrap;
      color: ${typeColorContrast};
      font-weight: ${fontWeight.regular};
      line-height: ${lineHeight};
      font-size: ${fontSize.md};
    `;
}}
`;
const TemplateWrapper = styled.div `
  ${({ theme: { spacing } }) => css `
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    padding: ${spacing.md};
  `}
`;

const Tooltip = (_a) => {
    var { icon, iconContent, iconType, iconSize, iconColor, type, contentProps, popperStyle, children, placement, autoClose, hoverOpen, onClick, onOpen, disabled, positionStrategy, hideDelay } = _a, props = __rest(_a, ["icon", "iconContent", "iconType", "iconSize", "iconColor", "type", "contentProps", "popperStyle", "children", "placement", "autoClose", "hoverOpen", "onClick", "onOpen", "disabled", "positionStrategy", "hideDelay"]);
    const [opened, setOpened] = useState(false);
    const [refDom, setRefDom] = useState(null);
    const [popperDom, setPopperDom] = useState(null);
    useEffect(() => {
        onOpen(opened);
    }, [onOpen, opened]);
    const { styles, attributes, update } = usePopper(refDom, popperDom, {
        modifiers: [
            {
                name: "offset",
                options: {
                    offset: [0, 4],
                },
            },
        ],
        placement,
        strategy: positionStrategy || "fixed",
    });
    const iconName = useMemo(() => {
        if (icon) {
            return icon;
        }
        switch (type) {
            case "error":
            case "success":
                return type;
            default:
                return "alert";
        }
    }, [type, icon]);
    const togglePopper = useCallback((e) => setOpened((state) => {
        onClick(e, !state);
        return !state;
    }), [setOpened, onClick]);
    const hidePopper = useMemo(() => _.debounce(() => setOpened(false), hideDelay), [setOpened, hideDelay]);
    const showPopper = useCallback(() => {
        hidePopper.cancel();
        setOpened(true);
    }, [setOpened, hidePopper]);
    const showPopperClick = useCallback((e) => {
        onClick(e, true);
        showPopper();
    }, [showPopper, onClick]);
    useEffect(() => {
        const close = (e) => {
            if (!opened) {
                return;
            }
            if (refDom.contains(e.target) ||
                // if autoClose on, then close the popper if clicked inside
                (!autoClose && popperDom.contains(e.target))) {
                return;
            }
            setOpened(false);
        };
        document.addEventListener("click", close);
        return () => document.removeEventListener("click", close);
    }, [opened, setOpened, refDom, popperDom, autoClose]);
    useEffect(() => {
        if (opened) {
            update();
        }
    }, [opened, update]);
    const handleOnClick = useMemo(() => {
        if (disabled) {
            return undefined;
        }
        if (hoverOpen) {
            return showPopperClick;
        }
        return togglePopper;
    }, [disabled, hoverOpen, showPopperClick, togglePopper]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(TooltipContainer, Object.assign({ ref: setRefDom }, props, { "aria-label": `${opened && !hoverOpen ? "Close" : "Open"} tooltip`, "$type": type, disabled: disabled, onClick: handleOnClick, onMouseOver: !disabled && hoverOpen ? showPopper : undefined, onMouseLeave: !disabled && hoverOpen ? hidePopper : undefined }),
            icon === false ? null : (React__default.createElement(Icon, { className: "icon", icon: iconName === true ? null : iconName, type: icon && iconType ? iconType : "outline", size: icon && iconSize ? iconSize : "1.25rem", color: iconColor !== null && iconColor !== void 0 ? iconColor : undefined })),
            iconContent),
        React__default.createElement(TooltipPopper, Object.assign({ ref: setPopperDom, "$opened": opened, "$type": type, style: Object.assign(Object.assign({}, styles.popper), popperStyle), className: "menu" }, attributes.popper), opened && (React__default.createElement(TooltipContent, Object.assign({}, contentProps, { className: ["content", contentProps.className]
                .filter(Boolean)
                .join(" "), "$type": type, onClick: hoverOpen ? showPopperClick : undefined, onMouseOver: hoverOpen ? showPopper : undefined, onMouseLeave: hoverOpen ? hidePopper : undefined }), children)))));
};
Tooltip.displayName = "Tooltip";
Tooltip.propTypes = {
    contentProps: PropTypes.object,
    popperStyle: PropTypes.object,
    type: PropTypes.oneOf([
        "info",
        "success",
        "warning",
        "error",
        "menu",
        "blue",
        "midnight",
        "pink",
        "turquoise",
        "base",
        "white",
    ]),
    iconContent: PropTypes.node,
    icon: PropTypes.oneOfType([IconPropType, PropTypes.bool]),
    iconType: Icon.propTypes.type,
    iconSize: Icon.propTypes.size,
    placement: PropTypes.string,
    iconColor: PropTypes.string,
    autoClose: PropTypes.bool,
    hoverOpen: PropTypes.bool,
    hideDelay: PropTypes.number,
};
Tooltip.defaultProps = {
    contentProps: {},
    popperStyle: {},
    type: "info",
    icon: null,
    iconContent: null,
    iconType: null,
    iconSize: null,
    placement: "top-end",
    iconColor: undefined,
    autoClose: false,
    hoverOpen: false,
    onClick: () => null,
    onOpen: () => null,
    hideDelay: 300,
};

const AutosaveIndicator = ({ dirty, loading, error, className, }) => {
    var theme = useTheme();
    const message = useMemo(() => {
        if (error) {
            return "Error";
        }
        if (loading) {
            return "Saving...";
        }
        if (dirty) {
            return "Changes...";
        }
        return "Saved";
    }, [dirty, error, loading]);
    const icon = useMemo(() => {
        if (error) {
            return (React__default.createElement(Tooltip, { icon: "error", iconColor: theme.color.error, iconSize: "1.5rem", type: "error", placement: "top-start", "data-testid": "autosave-indicator-error-tooltip-button" }, error));
        }
        if (loading) {
            return React__default.createElement(Loading, { "data-testid": "autosave-indicator-icon-loading" });
        }
        if (dirty) {
            return (React__default.createElement(Icon, { icon: "alert", type: "outline", color: theme.color.primary, "data-testid": "autosave-indicator-icon-dirty", size: "1.5rem" }));
        }
        return (React__default.createElement(Icon, { "data-testid": "autosave-indicator-icon-success", icon: "success", color: theme.color.success, size: "1.5rem" }));
    }, [error, loading, dirty, theme.color]);
    return (React__default.createElement(AutosaveContainer, { className: className, "data-testid": "autosave-indicator" },
        React__default.createElement("div", { "data-testid": "autosave-indicator-message", className: "message" }, message),
        icon));
};
AutosaveIndicator.propTypes = {
    error: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    dirty: PropTypes.bool.isRequired,
    className: PropTypes.string,
};

let notExistWarn = false;
const getColor = (themeColor, $color, fallback = null) => {
    if (themeColor[$color]) {
        return [themeColor[$color], themeColor.contrast[$color], false];
    }
    if (fallback && themeColor[fallback]) {
        return [themeColor[fallback], themeColor.contrast[fallback], true];
    }
    if (!notExistWarn) {
        notExistWarn = true;
        console.trace(`Button colour does not exist: ${$color}`);
    }
    return [themeColor.primary, themeColor.contrast.primary, false];
};
const RoundButton = styled.button `
  ${({ theme: { borderRadius, color: themeColor, fontSize, fontWeight, spacing, button, lineHeight, }, disabled, $color, $design, $round, size, }) => css `
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      text-decoration: none;
      cursor: pointer;
      border-radius: ${$round ? button.roundRadius : borderRadius.lg};
      border: ${button.outlineBorderWidth} solid transparent;
      font-weight: ${fontWeight.bold};
      background: transparent;
      color: inherit;
      line-height: ${lineHeight};

      ${() => {
    switch ($design) {
        case "text": {
            const [color] = getColor(themeColor, $color);
            return css `
              color: ${color};
            `;
        }
        case "transparent": {
            return css ``;
        }
        case "outline": {
            const [color] = getColor(themeColor, $color);
            return css `
              border-color: ${color};
            `;
        }
        case "fill":
        default: {
            const [color, contrast] = getColor(themeColor, $color);
            return css `
              background: ${color};
              color: ${contrast};
            `;
        }
    }
}}
      ${() => {
    switch (size) {
        case "small":
            return css `
              font-size: ${fontSize.sm};
              padding: ${$round
                ? `${spacing.xs}`
                : `${spacing.xs} ${spacing.md}`};
            `;
        case "large":
            return css `
              font-size: ${fontSize.lg};
              padding: ${$round
                ? `${spacing.md}`
                : `${spacing.md} ${spacing.xl}`};
            `;
        default:
            return css `
              font-size: ${fontSize.md};
              padding: ${$round
                ? `${spacing.sm}`
                : `${spacing.sm} ${spacing.lg}`};
            `;
    }
}}

      ${disabled
    ? css `
            cursor: not-allowed;
            background: transparent;
            color: ${themeColor.midnight10};

            ${() => {
        switch ($design) {
            case "text":
            case "transparent": {
                return css ``;
            }
            case "outline": {
                return css `
                    border-color: ${themeColor.blue30};
                  `;
            }
            case "fill":
            default: {
                return css `
                    background: ${themeColor.blue30};
                  `;
            }
        }
    }}
          `
    : css `
            &:focus {
              box-shadow: 0 0 5px 1px ${themeColor.focus};
            }

            &:hover {
              ${() => {
        const [color, contrast, fallback] = getColor(themeColor, `${$color}10`, $color);
        return css `
                  border-color: transparent;
                  background: ${color};
                  color: ${contrast};

                  ${fallback &&
            css `
                    filter: brightness(115%);
                  `}
                `;
    }}
            }

            &:active {
              ${() => {
        const [color, contrast] = getColor(themeColor, $color);
        return css `
                  border-color: transparent;
                  background: ${color};
                  color: ${contrast};

                  filter: brightness(85%);
                `;
    }}
            }
          `}
    `}
`;
const ButtonContent = styled.div `
  ${({ theme: { spacing }, $loading }) => css `
    opacity: ${$loading ? 0 : 100};
    display: flex;
    flex-direction: row;
    flex: 1;
    align-items: center;
    justify-content: center;
    gap: ${spacing.sm};
  `}
`;
const ButtonLoading = styled(Loading) `
  ${({ $loading }) => css `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    visibility: ${$loading ? "visible" : "hidden"};
  `}
`;

const useRouterQuery = () => {
    const location = useLocation();
    if (location.search) {
        return new URLSearchParams(location.search);
    }
    // fallback, for unknown reasons pathname contains the search in some circumstances
    const path = location.pathname.split("?")[1];
    if (path) {
        return new URLSearchParams(path);
    }
    return new URLSearchParams(window.location.search);
};

const stateUrlDefaultOptions = {
    key: "filter",
    initialValue: "",
    replace: false,
    onChange: () => null,
};
const useStateUrl = (options) => {
    const config = Object.assign(Object.assign({}, stateUrlDefaultOptions), options);
    const { key, initialValue } = config;
    const query = useRouterQuery();
    const history = useHistory();
    const vars = useRef();
    const value = query.has(key) ? query.get(key) : initialValue;
    vars.current = {
        value,
        history,
        config,
    };
    const browsePage = useCallback((params, newValue) => {
        const callback = vars.current.config.replace
            ? vars.current.history.replace
            : vars.current.history.push;
        callback({
            // include window.location.pathname to workaround lingering `?varID` queries in params
            // also not using `useLocation` for location because of after unmount issues
            pathname: window.location.pathname.split("?")[0],
            search: params.toString(),
        });
        vars.current.config.onChange(newValue);
    }, []);
    const updateValue = useCallback((newValue) => {
        if (vars.current.value === newValue) {
            return;
        }
        const params = new URLSearchParams(window.location.search);
        if (newValue !== "") {
            params.set(vars.current.config.key, newValue);
        }
        else {
            if (!params.has(vars.current.config.key)) {
                return;
            }
            params.delete(vars.current.config.key);
        }
        browsePage(params, newValue);
    }, [browsePage]);
    const reset = useCallback(() => {
        const params = new URLSearchParams(window.location.search);
        if (!params.has(vars.current.config.key)) {
            return;
        }
        params.delete(vars.current.config.key);
        browsePage(params, vars.current.config.initialValue);
    }, [browsePage]);
    const result = useMemo(() => ({
        value,
        updateValue,
        reset,
    }), [value, updateValue, reset]);
    return result;
};

const useDebouncedSave = (dbValue, options) => {
    const { onUpdate, enter = true, key } = options;
    const [value, setValue] = useState(dbValue || "");
    const updateRef = useRef(onUpdate);
    const keyRef = useRef(key);
    updateRef.current = onUpdate;
    useEffect(() => {
        if (key !== keyRef.current) {
            setValue(dbValue);
            keyRef.current = key;
        }
    }, [dbValue, key]);
    const debounceUpdate = useMemo(() => _.debounce((value) => updateRef.current(value), 1000), []);
    const handleInputChange = useCallback((e) => {
        setValue(e.target.value);
        debounceUpdate(e.target.value);
    }, [debounceUpdate, setValue]);
    const handleComplete = useCallback(() => {
        debounceUpdate.flush();
    }, [debounceUpdate]);
    const handleSubmit = useCallback((e) => {
        if (!enter) {
            return;
        }
        if (e.which === 13 || e.keyCode === 13) {
            handleComplete();
        }
    }, [handleComplete, enter]);
    return {
        onBlur: handleComplete,
        onChange: handleInputChange,
        onKeyDown: handleSubmit,
        value,
        setValue,
    };
};

/**
 * Reference: https://dev.to/phuocng/merge-different-refs-1lf9
 */
const useRefs = (...refs) => {
    return useCallback((value) => {
        refs.forEach((ref) => {
            if (typeof ref === "function") {
                ref(value);
            }
            else if (ref != null) {
                ref.current = value;
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
};

const useMounted = () => {
    const mountedRef = useRef(false);
    useEffect(() => {
        mountedRef.current = true;
        return () => {
            mountedRef.current = false;
        };
    }, []);
    return mountedRef;
};

const useTooltipPlacement = (options) => {
    const { container = document.body, delay = 200 } = options || {};
    const { spacing } = useTheme();
    const [position, setPosition] = useState("top");
    const [hover, setHover] = useState(false);
    const [focus, setFocus] = useState(false);
    const [forceClosed, setForceClosed] = useState(false);
    const mounted = useMounted();
    const contentRef = useRef();
    const timerRef = useRef(null);
    const hoverTooltip = useCallback(() => {
        clearTimeout(timerRef.current);
        setHover(true);
    }, []);
    const leaveTooltip = useCallback(() => {
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            setForceClosed(false);
            setHover(false);
        }, delay);
    }, [delay]);
    const focusTooltip = useCallback(() => {
        setFocus(true);
    }, []);
    const blurTooltip = useCallback(() => {
        setForceClosed(false);
        setFocus(false);
    }, []);
    const close = useCallback(() => {
        setFocus(false);
        setHover(false);
        setForceClosed(true);
    }, []);
    const wrapperProps = useMemo(() => ({
        onMouseOver: hoverTooltip,
        onMouseLeave: leaveTooltip,
        onFocus: focusTooltip,
        onBlur: blurTooltip,
    }), [blurTooltip, focusTooltip, hoverTooltip, leaveTooltip]);
    useEffect(() => {
        const adjustPosition = () => {
            if (!mounted.current) {
                return;
            }
            const content = contentRef.current;
            if (!container || !content) {
                setPosition("top");
                return;
            }
            requestAnimationFrame(() => {
                let containerBox = container.getBoundingClientRect();
                let contentBox = content.getBoundingClientRect();
                const updatePos = (pos) => {
                    content.dataset.position = pos;
                    containerBox = container.getBoundingClientRect();
                    contentBox = content.getBoundingClientRect();
                };
                content.style.opacity = "0";
                let maybePos = null;
                updatePos("top");
                if (containerBox.top - contentBox.top < 0 &&
                    containerBox.right - contentBox.right >= 0 &&
                    containerBox.left - contentBox.left < 0) {
                    maybePos = "top";
                }
                if (!maybePos) {
                    updatePos("bottom");
                    if (containerBox.bottom - contentBox.bottom >= 0 &&
                        containerBox.right - contentBox.right >= 0 &&
                        containerBox.left - contentBox.left < 0) {
                        maybePos = "bottom";
                    }
                }
                if (!maybePos) {
                    updatePos("left");
                    if (containerBox.left - contentBox.left < 0) {
                        maybePos = "left";
                    }
                }
                if (!maybePos) {
                    updatePos("right");
                    if (containerBox.right - contentBox.right >= 0) {
                        maybePos = "right";
                    }
                }
                content.style.opacity = null;
                content.dataset.position = maybePos || "top";
            });
        };
        adjustPosition();
        if (!window.ResizeObserver || !window.MutationObserver || !container) {
            window.addEventListener("resize", adjustPosition);
            return () => {
                window.removeEventListener("resize", adjustPosition);
            };
        }
        const resize = new ResizeObserver(adjustPosition);
        const mutation = new MutationObserver(adjustPosition);
        const observeContent = () => {
            if (!mounted.current) {
                return;
            }
            if (!contentRef.current) {
                setTimeout(observeContent, 300);
                return;
            }
            resize.observe(contentRef.current, {});
        };
        observeContent();
        resize.observe(container, {});
        mutation.observe(container, {
            childList: true,
            attributes: true,
            attributeFilter: ["style", "class"],
        });
        return () => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const content = contentRef.current;
            if (content) {
                resize.unobserve(content);
            }
            resize.unobserve(container);
            resize.disconnect();
            mutation.disconnect();
        };
    }, [container, mounted, spacing]);
    return {
        showTooltip: !forceClosed && (hover || focus),
        wrapperProps,
        position,
        contentRef,
        close,
    };
};

const HelpTooltip = styled(Tooltip).attrs({
    icon: "help",
    iconType: "outline",
    type: "menu",
}) `
  color: ${({ theme }) => theme.color.primary};
`;
const HelpLabel = styled.label `
  display: flex;
  flex-direction: row;
  align-items: center;

  font-weight: ${({ theme }) => theme.fontWeight.bold};

  margin-bottom: ${({ theme }) => theme.spacing.md};
`;
const HelpContent = styled.p `
  margin-bottom: ${({ theme }) => theme.spacing.lg};

  :last-child {
    margin-bottom: 0;
  }
`;

const sentimentPositiveMin = 0.5;
const sentimentNegativeMax = -0.5;
const SmileyWrapper = styled.div `
  background: none;
  border: none;
  padding: 0;
  width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
  position: relative;
  cursor: pointer;
  color: ${({ $type, theme }) => {
    switch ($type) {
        case "success":
            return theme.color.success;
        case "error":
            return theme.color.error;
        default:
            return theme.color.warning;
    }
}};

  > * {
    position: relative;
  }
`;
const SmileyBackground = styled.div `
  width: calc(${({ $size }) => $size} - 4px);
  height: calc(${({ $size }) => $size} - 4px);
  border-radius: 100%;
  background: ${({ featuresColor }) => featuresColor};
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
`;

const SentimentSmiley = (_a) => {
    var { score, magnitude, size, featuresColor = "#FFF" } = _a, props = __rest(_a, ["score", "magnitude", "size", "featuresColor"]);
    const [type, icon, scoreText] = useMemo(() => {
        if (score == null) {
            return ["warning", "neutral", ""];
        }
        if (magnitude === 0) {
            return [
                "warning",
                "neutral",
                `Sentiment score: Neutral (${score > 0 ? "+" : ""}${score})`,
            ];
        }
        if (score >= sentimentPositiveMin) {
            return ["success", "happy", `Sentiment score: Positive (+${score})`];
        }
        if (score <= sentimentNegativeMax) {
            return ["error", "sad", `Sentiment score: Negative (${score})`];
        }
        return [
            "warning",
            "neutral",
            `Sentiment score: Neutral (${score > 0 ? "+" : ""}${score})`,
        ];
    }, [score, magnitude]);
    const smiley = (React__default.createElement(SmileyWrapper, Object.assign({}, props, { "data-testid": "sentiment-smiley", "$size": size, "$type": type, title: scoreText }),
        React__default.createElement(SmileyBackground, { featuresColor: featuresColor, "$size": size }),
        React__default.createElement(Icon, { icon: icon, size: size })));
    return (React__default.createElement(Tooltip, Object.assign({ iconContent: smiley, icon: false, type: type }, props), scoreText));
};
SentimentSmiley.defaultProps = {
    size: "30px",
    featuresColor: "#FFF",
    magnitude: 0,
    placement: "top",
};
SentimentSmiley.propTypes = {
    score: PropTypes.number.isRequired,
    magnitude: PropTypes.number,
    size: PropTypes.string,
    featuresColor: PropTypes.string,
    placement: PropTypes.string,
};

// simple function for generating random strings for e.g. html ids / classes
function generateRandomString(len = 10) {
    var str = ""; // String result
    for (var i = 0; i < len; i++) {
        // Loop `len` times
        var rand = Math.floor(Math.random() * 62); // random: 0..61
        var charCode = (rand += rand > 9 ? (rand < 36 ? 55 : 61) : 48); // Get correct charCode
        str += String.fromCharCode(charCode); // add Character to str
    }
    return str; // After all loops are done, return the concatenated string
}

const SimpleTooltipWrapper = styled.div `
  ${({ theme: { spacing } }) => css `
    position: relative;
    display: flex;
    flex-direction: row;
    gap: ${spacing.md};
  `}
`;
const TooltipContent$1 = styled.div.attrs((_a) => {
    var { role, "data-position": position } = _a, attrs = __rest(_a, ["role", "data-position"]);
    return (Object.assign(Object.assign({}, attrs), { role: role || "tooltip", className: "simple-tooltip-content", "data-position": position || "top" }));
}) `
  ${({ theme: { spacing, borderRadius, font } }) => css `
    ${font.note}
    position: absolute;
    z-index: 1006;

    border-radius: ${borderRadius.p1};
    opacity: 0;
    pointer-events: none;

    &[aria-expanded="true"] {
      opacity: 1;
      pointer-events: all;
    }

    &[data-position="top"] {
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      padding-bottom: ${spacing.p2};
    }

    &[data-position="bottom"] {
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      padding-top: ${spacing.p2};
    }
    &[data-position="left"] {
      top: 50%;
      right: 100%;
      transform: translateY(-50%);
      padding-right: ${spacing.p2};
    }

    &[data-position="right"] {
      top: 50%;
      left: 100%;
      transform: translateY(-50%);
      padding-left: ${spacing.p2};
    }
  `}
`;
const TooltipBox = styled.div `
  ${({ theme: { color, spacing, borderRadius, font } }) => css `
    background: ${color.midnight5};
    color: ${color.contrast.midnight5};
    border-radius: ${borderRadius.p1};
    padding: ${spacing.xs} ${spacing.sm};
    height: max-content;
    width: max-content;
    max-width: 300px;
  `}
`;

const SimpleTooltipContent = forwardRef((_a, ref) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React__default.createElement(TooltipContent$1, Object.assign({ ref: ref }, props),
        React__default.createElement(TooltipBox, null, children)));
});

const SimpleTooltip = (_a) => {
    var { id, role, title, icon, iconType, iconSize, children, 
    // looking at moving `container` to a context
    container } = _a, props = __rest(_a, ["id", "role", "title", "icon", "iconType", "iconSize", "children", "container"]);
    const [tooltipId] = useState(() => {
        if (id) {
            return id;
        }
        return `virti-tooltip-${generateRandomString()}`;
    });
    const { showTooltip, wrapperProps, position, contentRef } = useTooltipPlacement({
        container,
    });
    return (React__default.createElement(SimpleTooltipWrapper, Object.assign({ "data-textid": "SimpleTooltip" }, props, wrapperProps, { "aria-labelledby": tooltipId }),
        icon && React__default.createElement(Icon, { icon: icon, iconType: iconType, iconSize: iconSize }),
        children,
        React__default.createElement(SimpleTooltipContent, { ref: contentRef, id: tooltipId, role: role, "data-position": position, "aria-expanded": showTooltip }, title)));
};

let deprecateWarn = false;
const Button = forwardRef((_a, ref) => {
    var { icon, iconType, iconSize, type, title, tooltipId, as, loading, children, color, design, round, disabled, container, onClick } = _a, props = __rest(_a, ["icon", "iconType", "iconSize", "type", "title", "tooltipId", "as", "loading", "children", "color", "design", "round", "disabled", "container", "onClick"]);
    const theme = useTheme();
    const typeProp = type !== "link" ? type : null;
    const component = type === "link" && !as ? Link$1 || "a" : as;
    const { showTooltip, wrapperProps, position, contentRef, close } = useTooltipPlacement({ container });
    const colorProp = useMemo(() => {
        if (color === "danger") {
            return "error";
        }
        if (color === "primary" ||
            color === "secondary" ||
            color === "transparent-secondary" ||
            color === "alternative") {
            return "turquoise";
        }
        if (color === "transparent-primary") {
            return "blue";
        }
        if (color === "transparent-contrast") {
            return "white";
        }
        if (color === "transparent") {
            return "base";
        }
        return color;
    }, [color]);
    const designProp = useMemo(() => {
        if (color === "primary") {
            return "fill";
        }
        if (color === "secondary") {
            return "outline";
        }
        if (color === "transparent-primary" ||
            color === "transparent-secondary" ||
            color === "transparent-contrast" ||
            color === "transparent") {
            return "text";
        }
        if (color === "alternative") {
            return "transparent";
        }
        return design;
    }, [color, design]);
    const contrastLoading = useMemo(() => {
        if (designProp === "outline" || designProp === "transparent") {
            return theme.type !== "light";
        }
        if (colorProp === "white") {
            return theme.type !== "light";
        }
        return theme.type === "light";
    }, [theme, colorProp, designProp]);
    useEffect(() => {
        if (!deprecateWarn &&
            [
                "danger",
                "transparent-primary",
                "transparent-secondary",
                "transparent",
                "transparent-contrast",
            ].includes(color)) {
            deprecateWarn = true;
            console.trace(`Button colour is deprecated: ${color}`);
        }
    }, [color]);
    const handleClick = useCallback((e) => {
        if (onClick) {
            onClick(e);
        }
        close();
    }, [close, onClick]);
    return (React__default.createElement(RoundButton, Object.assign({ "data-testid": "Button", ref: ref, as: component, "aria-labelledby": tooltipId }, props, wrapperProps, { type: typeProp, "$color": colorProp, "$design": designProp, "$round": round, disabled: disabled || loading, onClick: handleClick }),
        React__default.createElement(ButtonContent, { "$loading": loading, className: "button-content" },
            icon && (React__default.createElement(Icon, { icon: icon, type: iconType, size: iconSize, className: "button-icon" })),
            children),
        React__default.createElement(ButtonLoading, { "$loading": loading, contrast: contrastLoading }),
        title && (React__default.createElement(SimpleTooltipContent, { ref: contentRef, "data-position": position, id: tooltipId, "aria-expanded": showTooltip && !disabled }, title))));
});
Button.displayName = "Button";
Button.defaultProps = {
    color: "blue",
    design: "fill",
    type: "button",
    size: "normal",
    loading: false,
    icon: undefined,
    iconType: null,
    iconSize: null,
};
Button.propTypes = {
    color: PropTypes.oneOf([
        "error",
        "warning",
        "success",
        "blue",
        "midnight",
        "pink",
        "turquoise",
        "base",
        "white",
        // named colours, will ignore and override design prop
        "primary",
        "secondary",
        "alternative",
        // deprecate these old colours
        "danger",
        "transparent-primary",
        "transparent-secondary",
        "transparent",
        "transparent-contrast",
    ]),
    design: PropTypes.oneOf(["fill", "outline", "transparent", "text"]),
    type: PropTypes.oneOf(["link", "button", "submit", "reset"]),
    size: PropTypes.oneOf(["small", "normal", "large"]),
    loading: PropTypes.bool,
    icon: IconPropType,
    iconType: Icon.propTypes.type,
    iconSize: Icon.propTypes.size,
};

const ButtonGroupButton = styled(Button) `
  border-radius: ${({ theme }) => math(`${theme.borderRadius.lg} * 2`)};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  margin: 0;
  border: 0;
  cursor: pointer;
  background-color: transparent;
  color: inherit;

  ${({ $isActive, $type }) => {
    if ($isActive) {
        switch ($type) {
            case "grey":
                return css `
            background-color: ${({ theme }) => theme.color.contrast.base};
            color: ${({ theme }) => theme.color.base};
          `;
            default:
                return css `
            background-color: ${({ theme }) => theme.color.primary};
            color: ${({ theme }) => theme.color.contrast.primary};
          `;
        }
    }
}}

  ${({ $isActive }) => $isActive &&
    css `
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);
    `}
`;
const ButtonGroup = styled.div `
  display: flex;
  border-radius: ${({ theme }) => math(`${theme.borderRadius.lg} * 2`)};
  border: 1px solid ${({ theme }) => theme.color.lightGrey};

  ${({ $type }) => {
    switch ($type) {
        case "grey":
            return css `
          background-color: ${({ theme }) => curriedLighten$1(0.1, theme.color.lightGrey)};
        `;
        default:
            return css `
          background-color: ${({ theme }) => theme.color.contrast.base};
        `;
    }
}}

  padding: ${({ $size, theme }) => {
    switch ($size) {
        case "small":
            return theme.spacing.xs;
        case "large":
            return theme.spacing.md;
        default:
            return theme.spacing.sm;
    }
}};

  ${ButtonGroupButton} {
    flex: 1;
  }
`;

const ButtonGroup$1 = (props) => {
    const [activeButton, setActiveButton] = useState(props.defaultLabel || props.labels[0]);
    const handleClick = useCallback((label) => {
        setActiveButton(label);
        props.onChange(label);
    }, [props.onChange]);
    return (React__default.createElement(ButtonGroup, { "data-testid": "ButtonGroup", "$size": props.size, "$type": props.type, role: "group" }, props.labels.map((label) => (React__default.createElement(ButtonGroupButton, { "data-testid": "ButtonGroupButton", key: label, size: props.size, "$isActive": label.toString() === activeButton, onClick: () => handleClick(label), "$type": props.type }, label)))));
};
ButtonGroup$1.displayName = "ButtonGroup";
ButtonGroup$1.propTypes = {
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    type: PropTypes.oneOf(["primary", "grey"]),
    defaultLabel: PropTypes.string,
    size: PropTypes.oneOf(["small", "normal", "large"]),
    onChange: PropTypes.func.isRequired,
};
ButtonGroup$1.defaultProps = {
    type: "primary",
    size: "normal",
};

const ButtonGroupContainer = styled.div `
  ${({ theme: { borderRadius, color, spacing } }) => css `
    border-radius: ${borderRadius.lg};
    background-color: ${color.blue30};
    padding: ${spacing.p1};
  `}
`;
const ItemButton = styled(Button).attrs((_a) => {
    var { $selected } = _a, attrs = __rest(_a, ["$selected"]);
    return (Object.assign(Object.assign({}, attrs), { color: $selected ? "white" : "blue", design: $selected ? "fill" : "transparent" }));
}) `
  ${({ theme: { color, fontWeight }, $selected }) => css `
    color: ${$selected ? null : color.midnight10};
    font-weight: ${fontWeight.regular};

    &:focus {
      box-shadow: none;
    }
  `}
`;

const ButtonGroupV2Item = (_a) => {
    var { name, title, selected, onClick } = _a, props = __rest(_a, ["name", "title", "selected", "onClick"]);
    const selectItem = useCallback(() => {
        if (selected) {
            return;
        }
        onClick(name);
    }, [name, onClick, selected]);
    return (React__default.createElement(ItemButton, Object.assign({}, props, { "$selected": selected, name: name, onClick: selectItem }), title));
};

const ButtonGroupV2 = (_a) => {
    var { items, selected, onChange } = _a, props = __rest(_a, ["items", "selected", "onChange"]);
    return (React__default.createElement(ButtonGroupContainer, Object.assign({}, props, { "data-testid": "ButtonGroupV2" }), items.map((item) => (React__default.createElement(ButtonGroupV2Item, Object.assign({ key: item.name }, item, { selected: selected === item.name, onClick: onChange }))))));
};
ButtonGroupV2.displayName = "ButtonGroupV2";

const ButtonDropdownWrapper = styled.div `
  position: relative;
  display: inline-block;
`;
const ButtonDropdownOpenerBtn = styled(Button) ``;
const ButtonDropdownMenu = styled.div `
  position: absolute;
  padding: ${({ theme }) => theme.spacing.sm} 0;
  background: ${({ theme }) => theme.color.contrast.base};
  transform: translateX(${(props) => (props.offsetX ? props.offsetX : 0)}px);
  z-index: 1001;
  will-change: transform;
  border-radius: ${({ theme }) => theme.spacing.xs};
  overflow: hidden;
  box-shadow: 0 0 8px 2px
      ${({ theme }) => curriedTransparentize$1(0.82, theme.color.darkGrey)},
    0px 4px 4px 0px rgba(0, 0, 0, 0.15);

  ${(props) => props.menuPositionHorizontal === "left" &&
    css `
      left: 0;
    `}
  ${(props) => props.menuPositionHorizontal === "right" &&
    css `
      right: 0;
    `}
  ${(props) => props.menuPositionVertical === "top" &&
    css `
      bottom: 100%;
    `}
  ${(props) => props.menuPositionVertical === "bottom" &&
    css `
      top: 100%;
    `}
`;
const IconWrapper = styled.span `
  display: inline-block;

  ${({ $open }) => $open
    ? css `
          transform: rotate(270deg);
        `
    : css `
          transform: rotate(90deg);
        `}
`;
const ButtonText = styled.div `
  display: inline-block;
  padding-right: ${({ theme }) => theme.spacing.sm};
`;

const BUTTON_HEIGHT = 38;
const randomId = generateRandomString(5);
const ButtonDropdown = ({ buttonText, children, htmlId, color, design, size, loading, disabled, dataTestIdMenu, dataTestIdWrapper, dataTestIdOpenerBtn, }) => {
    const [open, setOpen] = useState(false);
    const [offsetX, setOffsetX] = useState(0);
    const handleClick = useCallback(() => {
        var _a, _b;
        setOpen((opened) => !opened);
        setOffsetX((_b = (_a = openerBtnRef.current) === null || _a === void 0 ? void 0 : _a.offsetLeft) !== null && _b !== void 0 ? _b : 0);
    }, []);
    htmlId = htmlId !== null && htmlId !== void 0 ? htmlId : `ButtonDropdown-${randomId}`;
    const htmlIdMenu = `ButtonDropdownMenu-${randomId}`;
    useEffect(() => {
        const handleAnyClick = (e) => {
            let node = e.target;
            if (openerBtnRef.current &&
                node &&
                !openerBtnRef.current.contains(node) &&
                open) {
                setOpen(false);
            }
        };
        document.addEventListener("click", handleAnyClick);
        return () => {
            document.removeEventListener("click", handleAnyClick);
        };
    }, [open]);
    // ensure menu stays within viewport
    const [menuPositionHorizontal, setMenuPositionHorizontal] = useState("left");
    const [menuPositionVertical, setMenuPositionVertical] = useState("bottom");
    useLayoutEffect(() => {
        var _a, _b;
        if (open && menuRef.current && openerBtnRef.current) {
            const btnRect = openerBtnRef.current.getBoundingClientRect();
            const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
            const offsetLeft = btnRect.left + scrollLeft;
            const { clientWidth } = document.body;
            if (offsetLeft + ((_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) > clientWidth) {
                setMenuPositionHorizontal("right");
            }
            else {
                setMenuPositionHorizontal("left");
            }
            if (btnRect.top + ((_b = menuRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight) + BUTTON_HEIGHT >
                window.innerHeight) {
                setMenuPositionVertical("top");
            }
            else {
                setMenuPositionVertical("bottom");
            }
        }
    }, [open]);
    const openerBtnRef = useRef(null);
    const menuRef = useRef(null);
    return (React__default.createElement("div", { "data-testid": dataTestIdWrapper !== null && dataTestIdWrapper !== void 0 ? dataTestIdWrapper : "ButtonDropdownWrapper" },
        React__default.createElement(ButtonDropdownWrapper, null,
            React__default.createElement(ButtonDropdownOpenerBtn, { onClick: handleClick, "aria-haspopup": "true", "aria-expanded": open ? "true" : "false", ref: openerBtnRef, id: htmlId, "data-testid": dataTestIdOpenerBtn !== null && dataTestIdOpenerBtn !== void 0 ? dataTestIdOpenerBtn : "ButtonDropdownOpenerBtn", color: color, design: design, size: size, loading: loading, disabled: disabled },
                React__default.createElement(ButtonText, null, buttonText),
                React__default.createElement(IconWrapper, { "$open": open },
                    React__default.createElement(Icon, { icon: "chevron", size: ".75rem" }))),
            open && (React__default.createElement(ButtonDropdownMenu, { ref: menuRef, "aria-labelledby": htmlId, offsetX: offsetX, menuPositionHorizontal: menuPositionHorizontal, menuPositionVertical: menuPositionVertical, id: htmlIdMenu, "data-testid": dataTestIdMenu !== null && dataTestIdMenu !== void 0 ? dataTestIdMenu : "ButtonDropdownMenu" }, children)))));
};
ButtonDropdown.displayName = "ButtonDropdown";
// propTypes and defaultProps are optional, but still useful for runtime checking and providing a fallback
ButtonDropdown.propTypes = {
    buttonText: PropTypes.string,
    children: PropTypes.node,
    htmlId: PropTypes.string,
    color: PropTypes.oneOf([
        "error",
        "warning",
        "success",
        "blue",
        "midnight",
        "pink",
        "turquoise",
        "base",
        "white",
        // named colours, will ignore and override design prop
        "primary",
        "secondary",
        "alternative",
    ]),
    design: PropTypes.oneOf(["fill", "outline", "transparent", "text"]),
    size: PropTypes.oneOf(["small", "normal", "large"]),
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
};
ButtonDropdown.defaultProps = {
    color: "turquoise",
    design: "fill",
    size: "normal",
    loading: false,
    disabled: false,
};

const ellipsisFragment = css `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;

// source: https://www.joshwcomeau.com/css/custom-css-reset/
const resetFragment = css `
  /*
  1. Use a more-intuitive box-sizing model.
*/
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  /*
  2. Remove default margin
*/
  * {
    margin: 0;
  }
  /*
  3. Allow percentage-based heights in the application
*/
  html,
  body {
    height: 100%;
  }
  /*
  Typographic tweaks!
  4. Add accessible line-height
  5. Improve text rendering
*/
  body {
    line-height: 1.5;
    -webkit-font-smoothing: subpixel-antialiased;
  }
  /*
  6. Improve media defaults
*/
  img,
  picture,
  video,
  canvas,
  svg {
    display: block;
    max-width: 100%;
  }
  /*
  7. Remove built-in form typography styles
*/
  input,
  button,
  textarea,
  select {
    font: inherit;
  }
  /*
  8. Avoid text overflows
*/
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    overflow-wrap: break-word;
    font-weight: 400;
  }
  /*
  9. Create a root stacking context
*/
  #root,
  #__next {
    isolation: isolate;
  }
`;

const GlobalStyle = createGlobalStyle `
  ${({ theme, $reset }) => css `
    ${$reset && resetFragment}

    html, body {
      ${theme.font.body}
      color: ${theme.color.base};
    }

    code,
    pre {
      font-family: ${theme.fontFamilyMono};
    }

    h1,
    h2,
    h3 {
      font-family: ${theme.fontFamilyTitle};
    }
  `}
`;

const readableDictionary = (dictionary, ifLight, ifDark) => {
    return Object.entries(dictionary).reduce((prev, [name, color]) => (Object.assign(Object.assign({}, prev), { [name]: readableColor(color, ifLight, ifDark, true) })), {});
};

const componentSettings = {
    tooltip: {
        width: "400px",
        height: "350px",
    },
    code: {
        color: "#dddddd",
        contrast: readableColor("#dddddd"),
    },
    tabs: {
        headHeight: "200px",
        dotSize: "2px",
        titleWidth: "150px",
        color: {
            disabled: "#888",
        },
    },
    button: {
        outlineBorderWidth: "3px",
        roundRadius: "60px",
    },
    loading: {
        size: {
            sm: "1.2rem",
            md: "2rem",
            lg: "3.5rem",
        },
    },
    progress: {
        circleDoneColor: "#46beaf",
        circleTrailColor: "#d6d6d6",
        circleWidth: 7,
        circleFontSize: "1.5rem",
    },
};
const fragments = {
    ellipsis: ellipsisFragment,
};
const baseTheme = Object.assign(Object.assign({}, componentSettings), { 
    // typography
    fontFamily: '"Cabin", sans-serif', fontFamilyTitle: '"Ubuntu", sans-serif', fontFamilyMono: '"Ubuntu Mono", Courier', fontWeight: {
        light: 300,
        regular: 400,
        partBold: 500,
        bold: 700,
    }, fontSize: {
        xs: "0.8rem",
        sm: "0.9rem",
        md: "1rem",
        lg: "1.2rem",
        xl: "1.5rem",
        xxl: "1.8rem",
        h: "3.25rem",
    }, lineHeight: "1.5", spacing: {
        p1: "4px",
        p2: "8px",
        p3: "12px",
        p4: "16px",
        p5: "20px",
        p6: "24px",
        p7: "28px",
        p8: "32px",
        xs: "4px",
        sm: "8px",
        md: "16px",
        lg: "24px",
        xl: "32px",
    }, borderRadius: {
        p1: "4px",
        p2: "8px",
        p3: "12px",
        p4: "16px",
        p5: "20px",
        p6: "24px",
        p7: "28px",
        p8: "32px",
        sm: "8px",
        md: "16px",
        lg: "24px",
    }, fragments, font: {
        callout: css `
      ${({ theme }) => css `
        font-size: ${theme.fontSize.h};
        font-family: ${theme.fontFamilyTitle};
        font-weight: ${theme.fontWeight.regular};
      `}
    `,
        title: css `
      ${({ theme }) => css `
        font-size: ${theme.fontSize.xxl};
        font-family: ${theme.fontFamilyTitle};
        font-weight: ${theme.fontWeight.partBold};
      `}
    `,
        h1: css `
      ${({ theme }) => css `
        font-size: ${theme.fontSize.xl};
        font-family: ${theme.fontFamilyTitle};
        font-weight: ${theme.fontWeight.partBold};
      `}
    `,
        h2: css `
      ${({ theme }) => css `
        font-size: ${theme.fontSize.lg};
        font-family: ${theme.fontFamilyTitle};
        font-weight: ${theme.fontWeight.partBold};
      `}
    `,
        label: css `
      ${({ theme }) => css `
        font-size: ${theme.fontSize.md};
        font-family: ${theme.fontFamily};
        font-weight: ${theme.fontWeight.bold};
      `}
    `,
        body: css `
      ${({ theme }) => css `
        font-size: ${theme.fontSize.md};
        font-family: ${theme.fontFamily};
        font-weight: ${theme.fontWeight.regular};
      `}
    `,
        note: css `
      ${({ theme }) => css `
        font-size: ${theme.fontSize.sm};
        font-family: ${theme.fontFamily};
      `}
    `,
        smallnote: css `
      ${({ theme }) => css `
        font-size: ${theme.fontSize.xs};
        font-family: ${theme.fontFamily};
      `}
    `,
    } });

const colors = {
    blue: "#528fbf",
    blue10: "#97c5fe",
    blue20: "#a3bcd8",
    blue30: "#d6e1ee",
    blue40: "#f5f5ff",
    blue50: "#fafaff",
    blue60: "#f0f7fd",
    blue70: "#349adc",
    midnight: "#111b32",
    midnight5: "#232c41",
    midnight10: "#66677b",
    midnight20: "#b3b3bd",
    midnight30: "#e1e1e5",
    pink: "#dd6b9c",
    pink10: "#ebb3c9",
    pink20: "#f6dee7",
    pink30: "#fbeff3",
    turquoise: "#46beaf",
    turquoise10: "#a9dbd3",
    turquoise20: "#daefeb",
    red: "#cf3527",
    red10: "#faebe9",
    amber: "#fab010",
    amber10: "#fff7e7",
};
const names = Object.assign(Object.assign({}, colors), { white: "#fff", base: colors.midnight, primaryLight: colors.blue20, primary: colors.blue, primaryDark: colors.midnight10, secondaryLight: colors.turquoise10, secondary: colors.turquoise, secondaryDark: curriedDarken$1(0.2, colors.turquoise), error: colors.red, errorDark: curriedDarken$1(0.08, colors.red), warning: colors.amber, warningDark: curriedDarken$1(0.21, colors.amber), success: colors.turquoise, successDark: curriedDarken$1(0.2, colors.turquoise), lightGrey: colors.midnight20, darkGrey: colors.midnight10, focus: colors.blue40, highlight: colors.blue50 });
const LightTheme = Object.assign(Object.assign({}, baseTheme), { type: "light", 
    // colours
    color: Object.assign(Object.assign({}, names), { contrast: readableDictionary(names, colors.midnight, names.white) }) });

const colors$1 = {
    blue: "#528fbf",
    blue10: "#97c5fe",
    blue20: "#a3bcd8",
    blue30: "#d6e1ee",
    blue40: "#f5f5ff",
    blue50: "#fafaff",
    blue60: "#f0f7fd",
    blue70: "#349adc",
    midnight: "#111b32",
    midnight5: "#232c41",
    midnight10: "#66677b",
    midnight20: "#b3b3bd",
    midnight30: "#e1e1e5",
    pink: "#dd6b9c",
    pink10: "#ebb3c9",
    pink20: "#f6dee7",
    pink30: "#68586e",
    turquoise: "#46beaf",
    turquoise10: "#a9dbd3",
    turquoise20: "#daefeb",
    red: "#cf3527",
    red10: "#cf3527",
    amber: "#fab010",
    amber10: "#fff7e7",
};
const names$1 = Object.assign(Object.assign({}, colors$1), { white: "#fff", base: "#fafaff", primaryLight: colors$1.blue20, primary: colors$1.blue, primaryDark: colors$1.midnight10, secondaryLight: colors$1.turquoise10, secondary: colors$1.turquoise, secondaryDark: curriedDarken$1(0.2, colors$1.turquoise), error: colors$1.red, errorDark: curriedDarken$1(0.08, colors$1.red), warning: colors$1.amber, warningDark: curriedDarken$1(0.21, colors$1.amber), success: colors$1.turquoise, successDark: curriedDarken$1(0.2, colors$1.turquoise), lightGrey: colors$1.midnight20, darkGrey: colors$1.midnight10, focus: colors$1.blue40, highlight: colors$1.blue30 });
const DarkTheme = Object.assign(Object.assign({}, baseTheme), { type: "dark", 
    // colours
    color: Object.assign(Object.assign({}, names$1), { contrast: Object.assign(Object.assign({}, readableDictionary(names$1, colors$1.midnight, names$1.white)), { base: curriedDarken$1(0.05, colors$1.midnight) }) }) });

const ButtonDropdownButton = styled.button `
  ${ellipsisFragment}
  text-align: left;
  background: ${({ theme }) => theme.color.contrast.midnight10};
  color: ${({ theme }) => theme.color.midnight10};
  border: none;
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.lg};
  font-size: ${({ theme }) => theme.fontSize.md};
  width: 100%;
  cursor: pointer;

  :hover {
    background: ${({ theme }) => theme.color.blue40};
  }

  &&:disabled,
  &&[disabled] {
    cursor: not-allowed;
    background: transparent;
    color: ${({ theme }) => theme.color.midnight10};
  }
`;

// Generated with util/create-component.js
const ButtonDropdownButton$1 = ({ onClick, children, dataTestId, disabled, }) => {
    return (React__default.createElement(ButtonDropdownButton, { "data-testid": dataTestId !== null && dataTestId !== void 0 ? dataTestId : "ButtonDropdownButton", onClick: onClick, disabled: disabled }, children));
};
// propTypes and defaultProps are optional, but still useful for runtime checking and providing a fallback
ButtonDropdownButton$1.propTypes = {
    onClick: PropTypes.func,
    children: PropTypes.node,
    disabled: PropTypes.bool,
};
ButtonDropdownButton$1.defaultProps = {};

const CardContainer = styled.div `
  ${({ theme: { type, color, spacing }, $grow }) => css `
    display: flex;
    align-items: stretch;
    background-color: ${type === "light" ? color.white : color.midnight};
    box-shadow: 0 ${spacing.p1} ${spacing.p1} 0 rgba(0, 0, 0, 0.15);
    flex-direction: column;
    flex: ${$grow ? 1 : null};
  `}
`;
const CardBody = styled.div `
  ${({ theme: { spacing }, $horizontal, $noPadding }) => css `
    flex: 1;
    display: flex;
    flex-direction: ${$horizontal ? "row" : "column"};
    gap: ${spacing.lg};
    align-items: stretch;
    padding: ${$noPadding ? null : spacing.md};
  `}
`;
const CardTitle = styled.header `
  ${({ theme: { font, spacing, color } }) => css `
    ${font.h2}
    padding: ${spacing.md} ${spacing.xl};
    border-bottom: 1px solid ${color.blue40};
  `}
`;
const CardFooter = styled.footer `
  ${({ theme: { font, spacing, color } }) => css `
    ${font.h2}
    padding: ${spacing.md} ${spacing.xl};
    border-top: 1px solid ${color.blue40};
  `}
`;

const Card = forwardRef((_a, ref) => {
    var { title, footer, horizontal, noPadding, grow, children } = _a, props = __rest(_a, ["title", "footer", "horizontal", "noPadding", "grow", "children"]);
    return (React__default.createElement(CardContainer, Object.assign({ "data-testid": "Card", ref: ref }, props, { "$grow": grow }),
        title && React__default.createElement(CardTitle, { className: "title" }, title),
        React__default.createElement(CardBody, { className: "body", "$horizontal": horizontal, "$noPadding": noPadding }, children),
        footer && React__default.createElement(CardFooter, { className: "footer" }, footer)));
});
Card.defaultProps = {
    horizontal: false,
    noPadding: false,
    grow: false,
    title: null,
    footer: null,
};
Card.propTypes = {
    horizontal: PropTypes.bool,
    noPadding: PropTypes.bool,
    grow: PropTypes.bool,
    title: PropTypes.node,
    footer: PropTypes.node,
};

const shadedBoxFragment = css `
  ${({ $darkShading, $horizontal, theme: { font, color, borderRadius, spacing }, }) => css `
    padding: ${spacing.md};
    border-radius: ${borderRadius.lg};
    background-color: ${$darkShading ? color.blue40 : color.blue50};
    ${font.body}
    color: ${color.midnight10};
    display: flex;
    ${$horizontal
    ? css `
          flex-direction: row;
          align-items: center;
        `
    : css `
          flex-direction: column;
          align-items: stretch;
        `};
    gap: ${spacing.md};
  `}
`;
const InfoboxContainer = styled.div `
  ${shadedBoxFragment}
`;
const InfoboxContent = styled.div `
  ${({ theme: { spacing } }) => css `
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: ${spacing.p1};
  `}
`;
const InfoboxLink = styled.a `
  ${({ $darkShading, theme: { color } }) => css `
    ${shadedBoxFragment}
    cursor: pointer;
    &:hover {
      background-color: ${$darkShading ? color.blue30 : color.blue40};
    }
  `}
`;
const InfoboxTitle = styled.header `
  ${({ theme: { font, color, spacing } }) => css `
    display: flex;
    flex-direction: row;
    gap: ${spacing.p1};
    align-items: center;
    color: ${color.midnight};
    ${font.label}
  `}
`;
const InfoboxText = styled.div ``;

const Infobox = (_a) => {
    var { title, children, prefix, suffix, link } = _a, props = __rest(_a, ["title", "children", "prefix", "suffix", "link"]);
    const Container = link
        ? InfoboxLink
        : InfoboxContainer;
    return (React__default.createElement(Container, Object.assign({ "data-testid": "Infobox", "$horizontal": true }, props),
        prefix,
        React__default.createElement(InfoboxContent, { className: "infobox-content" },
            React__default.createElement(InfoboxTitle, { className: "infobox-title" }, title),
            React__default.createElement(InfoboxText, { className: "infobox-text" }, children)),
        suffix));
};
Infobox.propTypes = {
    title: PropTypes.node,
    prefix: PropTypes.node,
    suffix: PropTypes.node,
    link: PropTypes.bool,
};
Infobox.defaultProps = {
    title: null,
    prefix: null,
    suffix: null,
    link: false,
};

function addLinkState(to, prevPath, prevTitle) {
    const process = (newTo) => {
        if (typeof newTo === "string") {
            return {
                pathname: newTo,
                state: {
                    prevPath: prevPath || window.location.pathname,
                    prevTitle: prevTitle || document.title,
                },
            };
        }
        let state = null;
        if (newTo === null || newTo === void 0 ? void 0 : newTo.state) {
            if (typeof (newTo === null || newTo === void 0 ? void 0 : newTo.state) === "object") {
                state = newTo === null || newTo === void 0 ? void 0 : newTo.state;
            }
            if (!state) {
                state = { base: newTo === null || newTo === void 0 ? void 0 : newTo.state };
            }
        }
        return Object.assign(Object.assign({}, newTo), { state: Object.assign(Object.assign({}, state), { prevPath: prevPath || window.location.pathname, prevTitle: prevTitle || document.title }) });
    };
    if (typeof to === "function") {
        return (location) => {
            const newTo = to(location);
            return process(newTo);
        };
    }
    return process(to);
}

const StyledLink = styled(Link$1) `
  ${({ theme: { color } }) => css `
    color: ${color.turquoise};
    text-decoration: underline;

    &:hover {
      color: ${color.turquoise10};
    }
    &:active {
      color: ${color.turquoise20};
    }
  `}
`;

const Link = forwardRef((_a, ref) => {
    var { to, prevPath, prevTitle, as } = _a, props = __rest(_a, ["to", "prevPath", "prevTitle", "as"]);
    const toProps = useMemo(() => {
        if (typeof to === "string") {
            if (to.startsWith("http://") ||
                to.startsWith("https://") ||
                to.startsWith("mailto:") ||
                to.startsWith("tel:")) {
                return { as: "a", href: to };
            }
            if (as === "a") {
                return { href: to };
            }
        }
        return { to: addLinkState(to, prevPath, prevTitle) };
    }, [to, as, prevPath, prevTitle]);
    return (React__default.createElement(StyledLink, Object.assign({ "data-testid": "Link", as: as, ref: ref }, props, toProps)));
});
Link.propTypes = {
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    prevPath: PropTypes.string,
    prevTitle: PropTypes.string,
};

const Redirect = (_a) => {
    var { to, prevPath, prevTitle } = _a, props = __rest(_a, ["to", "prevPath", "prevTitle"]);
    const external = useMemo(() => {
        if (typeof to !== "string") {
            return false;
        }
        return to.startsWith("http://") || to.startsWith("https://");
    }, [to]);
    const prevTo = useMemo(() => addLinkState(to, prevPath, prevTitle), [to, prevPath, prevTitle]);
    useEffect(() => {
        if (external && typeof to === "string") {
            window.location = to;
        }
    }, [external, to]);
    if (external) {
        return null;
    }
    return React__default.createElement(Redirect$1, Object.assign({}, props, { to: prevTo }));
};

const LinkCardContainer = styled(Link) `
  ${({ theme: { type, color, spacing }, $grow }) => css `
    display: flex;
    align-items: stretch;
    flex-direction: column;
    flex: ${$grow ? 1 : null};

    text-decoration: none;
    background-color: ${type === "light" ? color.white : color.midnight};
    color: inherit;
    box-shadow: 0 ${spacing.p1} ${spacing.p1} 0 rgba(179, 179, 189, 0.5);
    cursor: pointer;

    &:hover {
      background-color: ${type === "light" ? color.blue40 : color.midnight5};
      color: inherit;

      .title {
        border-bottom: 1px solid ${color.blue30};
      }
    }

    &:active {
      background-color: ${type === "light" ? color.blue50 : color.midnight10};
      color: inherit;

      .title {
        border-bottom: 1px solid ${color.blue30};
      }
    }
  `}
`;

const LinkCard = forwardRef((_a, ref) => {
    var { as, title, horizontal, noPadding, grow, children } = _a, props = __rest(_a, ["as", "title", "horizontal", "noPadding", "grow", "children"]);
    return (React__default.createElement(LinkCardContainer, Object.assign({ "data-testid": "LinkCard", ref: ref }, props, { "$grow": grow }),
        title && React__default.createElement(CardTitle, { className: "title" }, title),
        React__default.createElement(CardBody, { className: "body", "$horizontal": horizontal, "$noPadding": noPadding }, children)));
});

const StyledCharacterCounter = styled.div `
  display: flex;
  font-size: 0.9rem;
  ${(props) => props.$nearMax &&
    css `
      color: ${(props) => props.theme.color.warningDark};
    `}
  ${(props) => props.$atMax &&
    css `
      color: ${(props) => props.theme.color.errorDark};
    `}
`;

const CharacterCounter = ({ currentCount, maxCount, }) => {
    const atMax = currentCount >= maxCount;
    const nearMax = currentCount / maxCount >= 0.75;
    return (React__default.createElement(StyledCharacterCounter, { "$nearMax": nearMax, "$atMax": atMax },
        React__default.createElement("div", null, currentCount),
        React__default.createElement("div", null, "/"),
        React__default.createElement("div", null, maxCount)));
};

const ChipFragment = css `
  ${({ theme: { color, borderRadius, font, spacing } }) => css `
    padding: ${spacing.p1} ${spacing.p3};
    color: ${color.midnight5};
    border-radius: ${borderRadius.sm};
    background-color: ${color.contrast.base};
    border: 1px solid ${color.turquoise10};
    ${font.body}
  `}
`;
const ChipContainer = styled.div `
  ${({ theme: { color, spacing, borderRadius, font }, $color }) => css `
    ${font.note}

    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: ${spacing.p2};
    padding: ${spacing.p1} ${spacing.p2};
    border-radius: ${borderRadius.p2};

    ${() => {
    switch ($color) {
        case "pink": {
            return css `
            background-color: ${color.pink10};
            color: ${color.contrast.pink10};
          `;
        }
        case "turquoise": {
            return css `
            background-color: ${color.turquoise20};
            color: ${color.contrast.turquoise20};
          `;
        }
        default: {
            return css `
            background-color: ${color.blue30};
            color: ${color.contrast.blue30};
          `;
        }
    }
}}
  `}
`;

const FilterChipBox = styled.label `
  ${({ theme: { color }, $disabled, $loading }) => css `
      ${ChipFragment}
      display: block;
      user-select: none;
      cursor: pointer;
      &:has(:checked) {
        color: ${color.contrast.turquoise20};
        background-color: ${color.turquoise20};
        border-color: ${color.turquoise20};
      }
      ${$loading
    ? css `
            cursor: not-allowed;
            background-color: ${color.turquoise20};
            border-color: transparent;
          `
    : css `
            &:focus {
              box-shadow: 0 0 5px 1px ${color.focus};
            }

            &:hover {
              border-color: ${color.turquoise10};
              background-color: ${color.turquoise20};
              &:has(:checked) {
                background-color: ${color.turquoise10};
              }
              color: ${color.contrast.turquoise};
            }
          `}
      ${$disabled &&
    css `
        &,
        &:hover,
        &:active {
          cursor: not-allowed;
          background-color: transparent;
          color: ${color.midnight10};
          border-color: ${color.blue30};
        }
      `}
    `}
`;
const FilterChipContent = styled.div `
  ${({ $loading, theme: { spacing } }) => css `
    display: flex;
    gap: 12px;
    justify-content: center;
    align-items: center;
    visibility: ${$loading ? "hidden" : "visible"};
  `}
`;
const FilterChipLoading = styled(Loading) `
  ${({ $loading }) => css `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    visibility: ${$loading ? "visible" : "hidden"};
  `}
`;
const HiddenCheckboxInput = styled.input `
  display: none;
`;
const LabelText = styled.div ``;
const CheckedIcon = styled(Icon) `
  ${({ theme: { color } }) => css `
    color: ${color.midnight};
  `}
`;

const FilterChip = forwardRef((_a, ref) => {
    var { loading, checked, children, disabled } = _a, props = __rest(_a, ["loading", "checked", "children", "disabled"]);
    return (React__default.createElement(FilterChipBox, { "$loading": loading, "$disabled": disabled || loading, htmlFor: props.id, "data-testid": "FilterChipLabel" },
        React__default.createElement(FilterChipContent, { "$loading": loading },
            checked && React__default.createElement(CheckedIcon, { icon: "tick" }),
            React__default.createElement(LabelText, null, children)),
        React__default.createElement(FilterChipLoading, { "$loading": loading }),
        React__default.createElement(HiddenCheckboxInput, Object.assign({ "data-testid": "FilterChipHiddenCheckbox", ref: ref, type: "checkbox", disabled: disabled, checked: checked }, props))));
});
FilterChip.displayName = "FilterChip";
FilterChip.propTypes = {
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    checked: PropTypes.bool.isRequired,
};

const Chip = (_a) => {
    var { color, icon, iconType, iconSize, children } = _a, props = __rest(_a, ["color", "icon", "iconType", "iconSize", "children"]);
    return (React__default.createElement(ChipContainer, Object.assign({}, props, { "$color": color }),
        React__default.createElement("div", { className: "text" }, children),
        icon && React__default.createElement(Icon, { icon: icon, type: iconType, size: iconSize })));
};

const ColorContainer = styled.div `
  ${({ theme: { spacing } }) => css `
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: ${spacing.p2};
  `}
`;
const ColorSwatch = styled.div `
  height: 3px;
  min-width: 1rem;
  width: 100%;
  box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.2);
`;
const ColorContent = styled.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
const ColorButton = styled(Button) `
  ${({ theme: { spacing } }) => css `
    padding: ${spacing.p1} ${spacing.p2};

    .button-content {
      flex-direction: column;
      gap: 1px;
    }
  `}
`;
const ColorPickerPopup = styled(TooltipContent$1) `
  ${({ theme: { color, spacing, borderRadius } }) => css `
    display: flex;
    flex-direction: column;
    gap: ${spacing.p2};
    width: 400px;
    max-width: 100vw;
    background: ${color.midnight};
    color: ${color.contrast.midnight};
    padding: ${spacing.p3};
    border-radius: ${borderRadius.p2};

    .rcp {
      border-radius: 0;
      background: transparent;
    }
    .rcp-saturation {
      border-radius: ${borderRadius.p1};
      user-select: none;
    }
    .rcp-body {
      padding-bottom: ${spacing.p2};
    }
    .rcp-section {
      gap: ${spacing.p4};
    }
  `}
`;
const ColorLabel = styled.label ``;
const ColorActions = styled.div `
  ${({ theme: { spacing } }) => css `
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: ${spacing.p2};
  `}
`;

function v$5(o, e) {
  return Array.isArray(o) ? o.includes(e) : o;
}
var X = o => {
  let e = o.getBoundingClientRect();
  return {
    width: e.width,
    height: e.height
  };
};
function f() {
  let o = useRef(null),
    [e, r] = useState({
      width: 1,
      height: 1
    });
  useLayoutEffect(() => {
    let s = () => {
        o.current && r(X(o.current));
      },
      t = ([{
        contentBoxSize: a
      }]) => {
        r({
          height: a[0].blockSize,
          width: a[0].inlineSize
        });
      };
    window.addEventListener("resize", s, !1);
    let i = new ResizeObserver(t);
    return o.current && i.observe(o.current), () => {
      window.removeEventListener("resize", s, !1), i.disconnect();
    };
  }, []);
  let n = useCallback(() => {
    let {
      left: s = 1,
      right: t = 1,
      top: i = 1,
      bottom: a = 1
    } = o.current?.getBoundingClientRect() ?? {};
    return {
      left: s,
      right: t,
      top: i,
      bottom: a
    };
  }, []);
  return [o, e, n];
}
function y(o, e, r) {
  return o < e ? e : o > r ? r : o;
}
var E = class {
    convert(e, r) {
      let n = this.toHex("#000000"),
        s = this.hex2rgb(n),
        t = this.rgb2hsv(s);
      if (e === "hex") {
        let i = r;
        n = this.toHex(i), s = this.hex2rgb(n), n.startsWith("rgba") && (s = this.toRgb(n), n = this.rgb2hex(s)), t = this.rgb2hsv(s);
      } else e === "rgb" ? (s = r, n = this.rgb2hex(s), t = this.rgb2hsv(s)) : e === "hsv" && (t = r, s = this.hsv2rgb(t), n = this.rgb2hex(s));
      return {
        hex: n,
        rgb: s,
        hsv: t
      };
    }
    toHex(e) {
      if (e.startsWith("#")) {
        if (e.length === 4 || e.length === 5) return e = e.split("").map((r, n) => n ? n < 4 ? r + r : r === "f" ? void 0 : r + r : "#").join(""), e;
        if (e.length === 7) return e;
        if (e.length === 9) return e.endsWith("ff") ? e.slice(0, 7) : e;
      } else {
        let r = document.createElement("canvas").getContext("2d");
        if (!r) throw new Error("2d context not supported or canvas already initialized");
        return r.fillStyle = e, r.fillStyle;
      }
      return "#000000";
    }
    toRgb(e) {
      let r = e.match(/\d+(\.\d+)?/gu) ?? [],
        [n, s, t, i] = Array.from({
          length: 4
        }).map((a, c) => y(+(r[c] ?? (c < 3 ? 0 : 1)), 0, c < 3 ? 255 : 1));
      return {
        r: n,
        g: s,
        b: t,
        a: i
      };
    }
    toHsv(e) {
      let r = e.match(/\d+(\.\d+)?/gu) ?? [],
        [n, s, t, i] = Array.from({
          length: 4
        }).map((a, c) => y(+(r[c] ?? (c < 3 ? 0 : 1)), 0, c ? c < 3 ? 100 : 1 : 360));
      return {
        h: n,
        s,
        v: t,
        a: i
      };
    }
    hex2rgb(e) {
      e = e.slice(1);
      let [r, n, s, t] = Array.from({
        length: 4
      }).map((i, a) => parseInt(e.slice(a * 2, a * 2 + 2), 16));
      return t = Number.isNaN(t) ? 1 : t / 255, {
        r,
        g: n,
        b: s,
        a: t
      };
    }
    rgb2hsv({
      r: e,
      g: r,
      b: n,
      a: s
    }) {
      e /= 255, r /= 255, n /= 255;
      let t = Math.max(e, r, n),
        i = t - Math.min(e, r, n),
        a = i ? (t === e ? (r - n) / i + (r < n ? 6 : 0) : t === r ? 2 + (n - e) / i : 4 + (e - r) / i) * 60 : 0,
        c = t ? i / t * 100 : 0,
        u = t * 100;
      return {
        h: a,
        s: c,
        v: u,
        a: s
      };
    }
    hsv2rgb({
      h: e,
      s: r,
      v: n,
      a: s
    }) {
      r /= 100, n /= 100;
      let t = ~~(e / 60),
        i = e / 60 - t,
        a = n * (1 - r),
        c = n * (1 - r * i),
        u = n * (1 - r * (1 - i)),
        l = t % 6,
        h = [n, c, a, a, u, n][l] * 255,
        d = [u, n, n, c, a, a][l] * 255,
        b = [a, a, u, n, n, c][l] * 255;
      return {
        r: h,
        g: d,
        b,
        a: s
      };
    }
    rgb2hex({
      r: e,
      g: r,
      b: n,
      a: s
    }) {
      let [t, i, a, c] = [e, r, n, s].map((u, l) => Math.round(l < 3 ? u : u * 255).toString(16).padStart(2, "0"));
      return ["#", t, i, a, c === "ff" ? void 0 : c].join("");
    }
  },
  m = new E();
function g(o) {
  return "touches" in o;
}
var x = /*#__PURE__*/memo(({
  onCoordinateChange: o,
  children: e,
  disabled: r
}) => {
  let [n, {
      width: s,
      height: t
    }, i] = f(),
    a = useCallback((u, l = !1) => {
      let {
          left: h,
          top: d
        } = i(),
        b = y(u.clientX - h, 0, s),
        I = y(u.clientY - d, 0, t);
      o(l, b, I);
    }, [s, t, i, o]),
    c = useCallback(u => {
      if (!g(u) && u.button !== 0) return;
      let l = d => {
          a(g(d) ? d.touches[0] : d);
        },
        h = d => {
          a(g(d) ? d.changedTouches[0] : d, !0), document.removeEventListener(g(d) ? "touchmove" : "mousemove", l, !1), document.removeEventListener(g(d) ? "touchend" : "mouseup", h, !1);
        };
      l(u), document.addEventListener(g(u) ? "touchmove" : "mousemove", l, !1), document.addEventListener(g(u) ? "touchend" : "mouseup", h, !1);
    }, [a]);
  return /*#__PURE__*/React__default.createElement("div", {
    ref: n,
    className: "rcp-interactive",
    onMouseDown: c,
    onTouchStart: c,
    "aria-disabled": r
  }, e);
});
var H = /*#__PURE__*/memo(({
  color: o,
  disabled: e,
  onChange: r,
  onChangeComplete: n
}) => {
  let [s, {
      width: t
    }] = f(),
    i = useMemo(() => ({
      x: o.hsv.a * t
    }), [o.hsv.a, t]),
    a = useCallback((l, h) => {
      let d = m.convert("hsv", {
        ...o.hsv,
        a: h / t
      });
      r(d), l && n?.(d);
    }, [o.hsv, t, r, n]),
    c = useMemo(() => [o.rgb.r, o.rgb.g, o.rgb.b].join(" "), [o.rgb.r, o.rgb.g, o.rgb.b]),
    u = useMemo(() => [c, o.rgb.a].join(" / "), [c, o.rgb.a]);
  return /*#__PURE__*/React__default.createElement(x, {
    disabled: e,
    onCoordinateChange: a
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: s,
    style: {
      background: `linear-gradient(to right, rgb(${c} / 0), rgb(${c} / 1)) top left / auto auto,
                      conic-gradient(#666 0.25turn, #999 0.25turn 0.5turn, #666 0.5turn 0.75turn, #999 0.75turn) top left / 12px 12px
                      repeat`
    },
    className: "rcp-alpha"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      left: i.x,
      background: `linear-gradient(to right, rgb(${u}), rgb(${u})) top left / auto auto,
                        conic-gradient(#666 0.25turn, #999 0.25turn 0.5turn, #666 0.5turn 0.75turn, #999 0.75turn) ${-i.x - 4}px 2px / 12px 12px
                        repeat`
    },
    className: "rcp-alpha-cursor"
  })));
});
function S(o, e) {
  return Math.round(o * 10 ** e) / 10 ** e;
}
function N({
  r: o,
  g: e,
  b: r,
  a: n
}) {
  let s = [Math.round(o), Math.round(e), Math.round(r)],
    t = S(n, 3);
  return t < 1 && s.push(t), s.join(", ");
}
function k({
  h: o,
  s: e,
  v: r,
  a: n
}) {
  let s = [`${Math.round(o)}\xB0`, `${Math.round(e)}%`, `${Math.round(r)}%`],
    t = S(n, 3);
  return t < 1 && s.push(t), s.join(", ");
}
var D = /*#__PURE__*/memo(({
  hideInput: o,
  color: e,
  disabled: r,
  onChange: n,
  onChangeComplete: s
}) => {
  let [t, i] = useState({
    hex: {
      value: e.hex,
      inputted: !1
    },
    rgb: {
      value: N(e.rgb),
      inputted: !1
    },
    hsv: {
      value: k(e.hsv),
      inputted: !1
    }
  });
  useEffect(() => {
    t.hex.inputted || i(l => ({
      ...l,
      hex: {
        ...l.hex,
        value: e.hex
      }
    }));
  }, [t.hex.inputted, e.hex]), useEffect(() => {
    t.rgb.inputted || i(l => ({
      ...l,
      rgb: {
        ...l.rgb,
        value: N(e.rgb)
      }
    }));
  }, [t.rgb.inputted, e.rgb]), useEffect(() => {
    t.hsv.inputted || i(l => ({
      ...l,
      hsv: {
        ...l.hsv,
        value: k(e.hsv)
      }
    }));
  }, [t.hsv.inputted, e.hsv]);
  let a = useCallback(l => h => {
      let {
        value: d
      } = h.target;
      i(b => ({
        ...b,
        [l]: {
          ...b[l],
          value: d
        }
      })), n(l === "hsv" ? m.convert("hsv", m.toHsv(d)) : l === "rgb" ? m.convert("rgb", m.toRgb(d)) : m.convert("hex", d));
    }, [n]),
    c = useCallback(l => () => {
      i(h => ({
        ...h,
        [l]: {
          ...h[l],
          inputted: !0
        }
      }));
    }, []),
    u = useCallback(l => h => {
      let {
        value: d
      } = h.target;
      i(b => ({
        ...b,
        [l]: {
          ...b[l],
          inputted: !1
        }
      })), s?.(l === "hsv" ? m.convert("hsv", m.toHsv(d)) : l === "rgb" ? m.convert("rgb", m.toRgb(d)) : m.convert("hex", d));
    }, [s]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "rcp-fields"
  }, !v$5(o, "hex") && /*#__PURE__*/React__default.createElement("div", {
    className: "rcp-fields-floor"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "rcp-field"
  }, /*#__PURE__*/React__default.createElement("input", {
    id: "hex",
    className: "rcp-field-input",
    readOnly: r,
    value: t.hex.value,
    onChange: a("hex"),
    onFocus: c("hex"),
    onBlur: u("hex")
  }), /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "hex",
    className: "rcp-field-label"
  }, "HEX"))), (!v$5(o, "rgb") || !v$5(o, "hsv")) && /*#__PURE__*/React__default.createElement("div", {
    className: "rcp-fields-floor"
  }, !v$5(o, "rgb") && /*#__PURE__*/React__default.createElement("div", {
    className: "rcp-field"
  }, /*#__PURE__*/React__default.createElement("input", {
    id: "rgb",
    className: "rcp-field-input",
    readOnly: r,
    value: t.rgb.value,
    onChange: a("rgb"),
    onFocus: c("rgb"),
    onBlur: u("rgb")
  }), /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "rgb",
    className: "rcp-field-label"
  }, "RGB")), !v$5(o, "hsv") && /*#__PURE__*/React__default.createElement("div", {
    className: "rcp-field"
  }, /*#__PURE__*/React__default.createElement("input", {
    id: "hsv",
    className: "rcp-field-input",
    readOnly: r,
    value: t.hsv.value,
    onChange: a("hsv"),
    onFocus: c("hsv"),
    onBlur: u("hsv")
  }), /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "hsv",
    className: "rcp-field-label"
  }, "HSV"))));
});
var F = /*#__PURE__*/memo(({
  color: o,
  disabled: e,
  onChange: r,
  onChangeComplete: n
}) => {
  let [s, {
      width: t
    }] = f(),
    i = useMemo(() => ({
      x: o.hsv.h / 360 * t
    }), [o.hsv.h, t]),
    a = useCallback((u, l) => {
      let h = m.convert("hsv", {
        ...o.hsv,
        h: l / t * 360
      });
      r(h), u && n?.(h);
    }, [o.hsv, t, r, n]),
    c = useMemo(() => [o.hsv.h, "100%", "50%"].join(" "), [o.hsv.h]);
  return /*#__PURE__*/React__default.createElement(x, {
    disabled: e,
    onCoordinateChange: a
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: s,
    className: "rcp-hue"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      left: i.x,
      backgroundColor: `hsl(${c})`
    },
    className: "rcp-hue-cursor"
  })));
});
var A = /*#__PURE__*/memo(({
  height: o,
  color: e,
  disabled: r,
  onChange: n,
  onChangeComplete: s
}) => {
  let [t, {
      width: i
    }] = f(),
    a = useMemo(() => {
      let h = e.hsv.s / 100 * i,
        d = (100 - e.hsv.v) / 100 * o;
      return {
        x: h,
        y: d
      };
    }, [e.hsv.s, e.hsv.v, i, o]),
    c = useCallback((h, d, b) => {
      let I = m.convert("hsv", {
        ...e.hsv,
        s: d / i * 100,
        v: 100 - b / o * 100
      });
      n(I), h && s?.(I);
    }, [e.hsv, i, o, n, s]),
    u = useMemo(() => [e.hsv.h, "100%", "50%"].join(" "), [e.hsv.h]),
    l = useMemo(() => [e.rgb.r, e.rgb.g, e.rgb.b].join(" "), [e.rgb.r, e.rgb.g, e.rgb.b]);
  return /*#__PURE__*/React__default.createElement(x, {
    disabled: r,
    onCoordinateChange: c
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: t,
    style: {
      height: o,
      backgroundColor: `hsl(${u})`
    },
    className: "rcp-saturation"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      left: a.x,
      top: a.y,
      backgroundColor: `rgb(${l})`
    },
    className: "rcp-saturation-cursor"
  })));
});
var re = /*#__PURE__*/memo(({
  height: o = 200,
  hideAlpha: e = !1,
  hideInput: r = !1,
  color: n,
  disabled: s = !1,
  onChange: t,
  onChangeComplete: i
}) => /*#__PURE__*/React__default.createElement("div", {
  className: "rcp-root rcp"
}, /*#__PURE__*/React__default.createElement(A, {
  height: o,
  color: n,
  disabled: s,
  onChange: t,
  onChangeComplete: i
}), /*#__PURE__*/React__default.createElement("div", {
  className: "rcp-body"
}, /*#__PURE__*/React__default.createElement("section", {
  className: "rcp-section"
}, /*#__PURE__*/React__default.createElement(F, {
  color: n,
  disabled: s,
  onChange: t,
  onChangeComplete: i
}), !e && /*#__PURE__*/React__default.createElement(H, {
  color: n,
  disabled: s,
  onChange: t,
  onChangeComplete: i
})), (!v$5(r, "hex") || !v$5(r, "rgb") || !v$5(r, "hsv")) && /*#__PURE__*/React__default.createElement("section", {
  className: "rcp-section"
}, /*#__PURE__*/React__default.createElement(D, {
  hideInput: r,
  color: n,
  disabled: s,
  onChange: t,
  onChangeComplete: i
})))));
function se(o) {
  let [e, r] = useState(m.convert("hex", o));
  return useEffect(() => {
    r(m.convert("hex", o));
  }, [o]), [e, r];
}

const convert = (value = "") => m.convert("hex", m.toHex(value));
const ColorPicker = forwardRef((_a, ref) => {
    var { children, value, onChange, defaultValue = "#000000ff", color, icon, iconType, iconSize, container, title } = _a, props = __rest(_a, ["children", "value", "onChange", "defaultValue", "color", "icon", "iconType", "iconSize", "container", "title"]);
    const theme = useTheme();
    const [wrapperRef, setWrapperRef] = useState(null);
    const [showInput, setShowInput] = useState(false);
    const [colorValue, setColor] = se(value || defaultValue);
    const toggleInput = useCallback(() => setShowInput((showing) => !showing), []);
    const clearValue = useCallback(() => {
        onChange("");
    }, [onChange]);
    const updateColor = useCallback((newColor) => {
        // setColor(newColor);
        onChange(newColor.hex);
    }, [onChange]);
    useEffect(() => {
        setColor(convert(value || defaultValue));
    }, [defaultValue, setColor, value]);
    const { showTooltip, wrapperProps: { onFocus, onBlur }, position, contentRef, } = useTooltipPlacement({
        container,
    });
    const openPicker = useCallback(() => {
        onFocus();
    }, [onFocus]);
    useEffect(() => {
        let clicking = false;
        let timer = null;
        const starting = () => {
            clicking = true;
            clearTimeout(timer);
            timer = setTimeout(() => (clicking = false), 500);
        };
        const close = (e) => {
            if (!wrapperRef || wrapperRef.contains(e.target) || !clicking) {
                return;
            }
            onBlur();
        };
        document.addEventListener("mousedown", starting);
        document.addEventListener("click", close);
        return () => {
            document.removeEventListener("mousedown", starting);
            document.removeEventListener("click", close);
        };
    }, [onBlur, wrapperRef]);
    return (React__default.createElement(ColorContainer, Object.assign({ ref: useRefs(ref, setWrapperRef) }, props),
        React__default.createElement(ColorButton, { color: color, design: "transparent", size: "small", onClick: openPicker },
            React__default.createElement(ColorContent, { className: "color-content" },
                icon && (React__default.createElement(Icon, { icon: icon, type: iconType, size: iconSize, className: "color-icon" })),
                React__default.createElement("div", { className: "color-children" }, children)),
            React__default.createElement(ColorSwatch, { className: "color-swatch", style: { backgroundColor: colorValue.hex } })),
        React__default.createElement(ColorPickerPopup, { ref: contentRef, "data-position": position, "aria-expanded": showTooltip },
            title && React__default.createElement(ColorLabel, null, title),
            React__default.createElement(re, { height: 200, hideInput: !showInput, color: colorValue, onChange: setColor, onChangeComplete: updateColor }),
            React__default.createElement(ColorActions, null,
                React__default.createElement(Button, { color: "turquoise", onClick: toggleInput, size: "small", icon: "cog" }),
                React__default.createElement(Button, { color: "turquoise", design: "outline", onClick: clearValue, size: "small", icon: "bin" })))));
});

const useDateLocale = (importLocaleFile) => {
    const [locale, setLocale] = useState(null);
    useLayoutEffect(() => {
        const loadLocale = () => __awaiter(void 0, void 0, void 0, function* () {
            const file = yield importLocaleFile();
            setLocale(file);
        });
        window.addEventListener("languagechange", loadLocale, {
            passive: true,
        });
        loadLocale();
        return () => {
            window.removeEventListener("languagechange", loadLocale);
        };
    }, [importLocaleFile]);
    useEffect(() => {
        if (locale) {
            setDefaultOptions({ locale });
        }
    }, [locale]);
};

const parseDatetime = (datetime) => {
    if (!datetime) {
        return null;
    }
    if (isDate(datetime)) {
        return datetime;
    }
    if (typeof datetime === "string") {
        if (datetime.includes("Z")) {
            const iso = parseISO(datetime);
            return iso;
        }
        const zoned = zonedTimeToUtc(datetime, "UTC");
        return zoned;
    }
    if (!isNaN(datetime)) {
        return new Date(1000 * datetime);
    }
    if (Number.isNaN(datetime)) {
        return null;
    }
    return zonedTimeToUtc(datetime, "UTC");
};

const formatDate = (date) => format$1(date, "P");
const formatDateLong = (date) => format$1(date, "PP");
const displayDate = (datetime, long = false) => {
    const parsed = parseDatetime(datetime);
    if (!parsed) {
        return null;
    }
    if (long) {
        return formatDateLong(parsed);
    }
    return formatDate(parsed);
};
const displayDateDifference = (datetime, long, hours) => {
    const parsed = parseDatetime(datetime);
    if (!parsed) {
        return null;
    }
    const amount = hours == null || typeof hours === "boolean" ? 24 : hours;
    if (differenceInHours(new Date(), parsed) < amount) {
        return formatDistance(parsed, new Date(), { addSuffix: true });
    }
    if (long) {
        return formatDateLong(parsed);
    }
    return formatDate(parsed);
};

const formatDatetime = (datetime) => format$1(datetime, "Pp");
const formatDatetimeLong = (datetime) => format$1(datetime, "PPpp");
const displayDatetime = (datetime, long = false) => {
    const parsed = parseDatetime(datetime);
    if (!parsed) {
        return null;
    }
    if (long) {
        return formatDatetimeLong(parsed);
    }
    return formatDatetime(parsed);
};
const displayDatetimeDifference = (datetime, long, hours) => {
    const parsed = parseDatetime(datetime);
    if (!parsed) {
        return null;
    }
    const amount = hours == null || typeof hours === "boolean" ? 24 : hours;
    if (differenceInHours(new Date(), parsed) < amount) {
        return formatDistance(parsed, new Date(), { addSuffix: true });
    }
    if (long) {
        return formatDatetimeLong(parsed);
    }
    return formatDatetime(parsed);
};

const formatTime = (date) => format$1(date, "p");
const formatTimeLong = (date) => format$1(date, "pp");
const displayTime = (datetime, long = false) => {
    const parsed = parseDatetime(datetime);
    if (!parsed) {
        return null;
    }
    if (long) {
        return formatTimeLong(parsed);
    }
    return formatTime(parsed);
};
const displayTimeDifference = (datetime, long, hours) => {
    const parsed = parseDatetime(datetime);
    if (!parsed) {
        return null;
    }
    const amount = hours == null || typeof hours === "boolean" ? 6 : hours;
    if (amount >= 24) {
        // not sure what to show, since we're not showing more than a day
        return null;
    }
    if (differenceInHours(new Date(), parsed) < amount) {
        return formatDistance(parsed, new Date(), { addSuffix: true });
    }
    if (long) {
        return formatTimeLong(parsed);
    }
    return formatTime(parsed);
};
const formatDuration = (length) => {
    const seconds = Math.ceil(length % 60);
    const minutes = Math.floor((length % (60 * 60)) / 60);
    const hours = Math.floor(length / (60 * 60));
    const time = [minutes, seconds];
    if (hours > 0) {
        time.unshift(hours);
    }
    return time
        .map((number, index) => index === 0 ? number : `${number}`.padStart(2, "0"))
        .join(":");
};

const Datetime = forwardRef(({ datetime, noDateDisplay, noTimeDisplay, noTime, long, difference, emptyDisplay, tick, }, ref) => {
    const [datetimeState, setDatetimeState] = useState(datetime);
    const updateState = useMemo(() => throttle((value) => setDatetimeState(value), tick), [tick]);
    const value = useMemo(() => {
        if (noDateDisplay && (noTime || noTimeDisplay)) {
            return null;
        }
        if (difference) {
            if (noDateDisplay) {
                return displayTimeDifference(datetimeState, long);
            }
            return noTime || noTimeDisplay
                ? displayDateDifference(datetimeState, long, difference)
                : displayDatetimeDifference(datetimeState, long, difference);
        }
        if (noDateDisplay) {
            return displayTime(datetimeState, long);
        }
        return noTime || noTimeDisplay
            ? displayDate(datetimeState, long)
            : displayDatetime(datetimeState, long);
    }, [noDateDisplay, noTime, noTimeDisplay, difference, datetimeState, long]);
    const iso = useMemo(() => {
        var _a;
        const parsed = parseDatetime(datetimeState);
        return (_a = parsed === null || parsed === void 0 ? void 0 : parsed.toISOString) === null || _a === void 0 ? void 0 : _a.call(parsed);
    }, [datetimeState]);
    const readable = useMemo(() => {
        const item = noTime
            ? displayDate(datetimeState, true)
            : displayDatetime(datetimeState, true);
        if (item !== value && item) {
            return item;
        }
        return undefined;
    }, [datetimeState, noTime, value]);
    useEffect(() => {
        updateState(datetime);
    }, [datetime, updateState]);
    if (!value && !iso) {
        return React__default.createElement(React__default.Fragment, null, emptyDisplay);
    }
    return (React__default.createElement("time", { ref: ref, dateTime: iso, title: readable }, value || emptyDisplay));
});
Datetime.propTypes = {
    datetime: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.number,
        // normally expect string value from server "yyyy-MM-dd hh:mm:ss" in UTC
        PropTypes.string,
    ]),
    // hide the time value when displaying
    noTimeDisplay: PropTypes.bool,
    // true if this is date only
    noTime: PropTypes.bool,
    long: PropTypes.bool,
    emptyDisplay: PropTypes.node,
    tick: PropTypes.number,
};
Datetime.defaultProps = {
    noTimeDisplay: false,
    noTime: false,
    long: false,
    emptyDisplay: null,
    tick: 5000,
};

const FieldWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
const FieldWrapperV2 = styled.div `
  ${({ theme: { spacing } }) => css `
    display: flex;
    flex-direction: column;
    gap: ${spacing.md};
  `}
`;
const FieldError = styled.label `
  ${({ theme }) => css `
    color: ${theme.color.error};
    font-size: ${theme.fontSize.sm};
    padding-top: 2px;
    margin-left: auto;
  `}
`;
const FieldLabelWrapper = styled.div `
  ${({ theme }) => css `
    display: flex;
    align-items: center;
    gap: ${theme.spacing.sm};
  `}
`;
const FieldLabel = styled.label `
  ${({ theme }) => css `
    font-size: ${theme.fontSize.md};
    font-weight: ${theme.fontWeight.partBold};
  `}
`;
const FieldGroup = styled.fieldset `
  ${({ theme: { spacing, borderRadius, color } }) => css `
    margin: ${spacing.sm} 0;
    padding: calc(${spacing.md} - 1px);
    border-radius: ${borderRadius.lg};
    border-top-left-radius: ${borderRadius.sm};
    border: 1px solid ${color.lightGrey};
    display: flex;
    flex-direction: column;
    gap: ${spacing.md};
    position: relative;
  `}
`;
const FieldGroupV2 = styled.fieldset `
  ${({ theme: { spacing, borderRadius, color } }) => css `
    margin: ${spacing.sm} 0;
    padding: ${spacing.md};
    border-radius: ${borderRadius.sm};
    border: 1px solid ${color.lightGrey};
    display: flex;
    flex-direction: column;
    gap: ${spacing.md};
    position: relative;
  `}
`;
const FieldGroupLegend = styled.legend `
  ${({ theme: { spacing, fontSize, fontWeight, color } }) => css `
    all: unset;
    padding-inline: ${spacing.sm};
    margin-inline: -${spacing.sm};
    font-size: ${fontSize.sm};
    font-weight: ${fontWeight.partBold};
    color: ${color.darkGrey};
    text-transform: uppercase;
  `}
`;

const FieldHelpWrapper = styled.div `
  ${({ theme: { spacing, color, fontSize, borderRadius } }) => css `
    display: flex;
    gap: ${spacing.sm};
    padding: calc(${spacing.sm} - 3px) ${spacing.sm};
    margin-block: 2px;
    font-size: calc(${fontSize.sm} + 1px);
    color: ${color.secondaryDark};
    background-color: ${mix$1(0.3, color.secondaryLight, color.contrast.base)};
    border-radius: ${borderRadius.sm};
  `}
`;
const InfoIcon = styled(Icon).attrs({
    icon: "information",
}) `
  ${({ theme }) => css `
    color: ${theme.color.secondary};
    margin-top: 2px;
  `}
`;
const FieldHelpContent = styled.div `
  flex: 1;
`;

const FieldHelp = forwardRef((_a, ref) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React__default.createElement(FieldHelpWrapper, Object.assign({ ref: ref }, props),
        React__default.createElement(InfoIcon, null),
        React__default.createElement(FieldHelpContent, null, children)));
});
FieldHelp.displayName = "FieldHelp";
FieldHelp.propTypes = {
    children: PropTypes.node.isRequired,
};

/*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */
function round(v) {
  return v + 0.5 | 0;
}
const lim = (v, l, h) => Math.max(Math.min(v, h), l);
function p2b(v) {
  return lim(round(v * 2.55), 0, 255);
}
function n2b(v) {
  return lim(round(v * 255), 0, 255);
}
function b2n(v) {
  return lim(round(v / 2.55) / 100, 0, 1);
}
function n2p(v) {
  return lim(round(v * 100), 0, 100);
}
const map$1 = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  A: 10,
  B: 11,
  C: 12,
  D: 13,
  E: 14,
  F: 15,
  a: 10,
  b: 11,
  c: 12,
  d: 13,
  e: 14,
  f: 15
};
const hex = [...'0123456789ABCDEF'];
const h1 = b => hex[b & 0xF];
const h2 = b => hex[(b & 0xF0) >> 4] + hex[b & 0xF];
const eq = b => (b & 0xF0) >> 4 === (b & 0xF);
const isShort = v => eq(v.r) && eq(v.g) && eq(v.b) && eq(v.a);
function hexParse(str) {
  var len = str.length;
  var ret;
  if (str[0] === '#') {
    if (len === 4 || len === 5) {
      ret = {
        r: 255 & map$1[str[1]] * 17,
        g: 255 & map$1[str[2]] * 17,
        b: 255 & map$1[str[3]] * 17,
        a: len === 5 ? map$1[str[4]] * 17 : 255
      };
    } else if (len === 7 || len === 9) {
      ret = {
        r: map$1[str[1]] << 4 | map$1[str[2]],
        g: map$1[str[3]] << 4 | map$1[str[4]],
        b: map$1[str[5]] << 4 | map$1[str[6]],
        a: len === 9 ? map$1[str[7]] << 4 | map$1[str[8]] : 255
      };
    }
  }
  return ret;
}
const alpha = (a, f) => a < 255 ? f(a) : '';
function hexString(v) {
  var f = isShort(v) ? h1 : h2;
  return v ? '#' + f(v.r) + f(v.g) + f(v.b) + alpha(v.a, f) : undefined;
}
const HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function hsl2rgbn(h, s, l) {
  const a = s * Math.min(l, 1 - l);
  const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  return [f(0), f(8), f(4)];
}
function hsv2rgbn(h, s, v) {
  const f = (n, k = (n + h / 60) % 6) => v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
  return [f(5), f(3), f(1)];
}
function hwb2rgbn(h, w, b) {
  const rgb = hsl2rgbn(h, 1, 0.5);
  let i;
  if (w + b > 1) {
    i = 1 / (w + b);
    w *= i;
    b *= i;
  }
  for (i = 0; i < 3; i++) {
    rgb[i] *= 1 - w - b;
    rgb[i] += w;
  }
  return rgb;
}
function hueValue(r, g, b, d, max) {
  if (r === max) {
    return (g - b) / d + (g < b ? 6 : 0);
  }
  if (g === max) {
    return (b - r) / d + 2;
  }
  return (r - g) / d + 4;
}
function rgb2hsl(v) {
  const range = 255;
  const r = v.r / range;
  const g = v.g / range;
  const b = v.b / range;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  let h, s, d;
  if (max !== min) {
    d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    h = hueValue(r, g, b, d, max);
    h = h * 60 + 0.5;
  }
  return [h | 0, s || 0, l];
}
function calln(f, a, b, c) {
  return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map(n2b);
}
function hsl2rgb(h, s, l) {
  return calln(hsl2rgbn, h, s, l);
}
function hwb2rgb(h, w, b) {
  return calln(hwb2rgbn, h, w, b);
}
function hsv2rgb(h, s, v) {
  return calln(hsv2rgbn, h, s, v);
}
function hue(h) {
  return (h % 360 + 360) % 360;
}
function hueParse(str) {
  const m = HUE_RE.exec(str);
  let a = 255;
  let v;
  if (!m) {
    return;
  }
  if (m[5] !== v) {
    a = m[6] ? p2b(+m[5]) : n2b(+m[5]);
  }
  const h = hue(+m[2]);
  const p1 = +m[3] / 100;
  const p2 = +m[4] / 100;
  if (m[1] === 'hwb') {
    v = hwb2rgb(h, p1, p2);
  } else if (m[1] === 'hsv') {
    v = hsv2rgb(h, p1, p2);
  } else {
    v = hsl2rgb(h, p1, p2);
  }
  return {
    r: v[0],
    g: v[1],
    b: v[2],
    a: a
  };
}
function rotate(v, deg) {
  var h = rgb2hsl(v);
  h[0] = hue(h[0] + deg);
  h = hsl2rgb(h);
  v.r = h[0];
  v.g = h[1];
  v.b = h[2];
}
function hslString(v) {
  if (!v) {
    return;
  }
  const a = rgb2hsl(v);
  const h = a[0];
  const s = n2p(a[1]);
  const l = n2p(a[2]);
  return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${b2n(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const map = {
  x: 'dark',
  Z: 'light',
  Y: 're',
  X: 'blu',
  W: 'gr',
  V: 'medium',
  U: 'slate',
  A: 'ee',
  T: 'ol',
  S: 'or',
  B: 'ra',
  C: 'lateg',
  D: 'ights',
  R: 'in',
  Q: 'turquois',
  E: 'hi',
  P: 'ro',
  O: 'al',
  N: 'le',
  M: 'de',
  L: 'yello',
  F: 'en',
  K: 'ch',
  G: 'arks',
  H: 'ea',
  I: 'ightg',
  J: 'wh'
};
const names$1$1 = {
  OiceXe: 'f0f8ff',
  antiquewEte: 'faebd7',
  aqua: 'ffff',
  aquamarRe: '7fffd4',
  azuY: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '0',
  blanKedOmond: 'ffebcd',
  Xe: 'ff',
  XeviTet: '8a2be2',
  bPwn: 'a52a2a',
  burlywood: 'deb887',
  caMtXe: '5f9ea0',
  KartYuse: '7fff00',
  KocTate: 'd2691e',
  cSO: 'ff7f50',
  cSnflowerXe: '6495ed',
  cSnsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: 'ffff',
  xXe: '8b',
  xcyan: '8b8b',
  xgTMnPd: 'b8860b',
  xWay: 'a9a9a9',
  xgYF: '6400',
  xgYy: 'a9a9a9',
  xkhaki: 'bdb76b',
  xmagFta: '8b008b',
  xTivegYF: '556b2f',
  xSange: 'ff8c00',
  xScEd: '9932cc',
  xYd: '8b0000',
  xsOmon: 'e9967a',
  xsHgYF: '8fbc8f',
  xUXe: '483d8b',
  xUWay: '2f4f4f',
  xUgYy: '2f4f4f',
  xQe: 'ced1',
  xviTet: '9400d3',
  dAppRk: 'ff1493',
  dApskyXe: 'bfff',
  dimWay: '696969',
  dimgYy: '696969',
  dodgerXe: '1e90ff',
  fiYbrick: 'b22222',
  flSOwEte: 'fffaf0',
  foYstWAn: '228b22',
  fuKsia: 'ff00ff',
  gaRsbSo: 'dcdcdc',
  ghostwEte: 'f8f8ff',
  gTd: 'ffd700',
  gTMnPd: 'daa520',
  Way: '808080',
  gYF: '8000',
  gYFLw: 'adff2f',
  gYy: '808080',
  honeyMw: 'f0fff0',
  hotpRk: 'ff69b4',
  RdianYd: 'cd5c5c',
  Rdigo: '4b0082',
  ivSy: 'fffff0',
  khaki: 'f0e68c',
  lavFMr: 'e6e6fa',
  lavFMrXsh: 'fff0f5',
  lawngYF: '7cfc00',
  NmoncEffon: 'fffacd',
  ZXe: 'add8e6',
  ZcSO: 'f08080',
  Zcyan: 'e0ffff',
  ZgTMnPdLw: 'fafad2',
  ZWay: 'd3d3d3',
  ZgYF: '90ee90',
  ZgYy: 'd3d3d3',
  ZpRk: 'ffb6c1',
  ZsOmon: 'ffa07a',
  ZsHgYF: '20b2aa',
  ZskyXe: '87cefa',
  ZUWay: '778899',
  ZUgYy: '778899',
  ZstAlXe: 'b0c4de',
  ZLw: 'ffffe0',
  lime: 'ff00',
  limegYF: '32cd32',
  lRF: 'faf0e6',
  magFta: 'ff00ff',
  maPon: '800000',
  VaquamarRe: '66cdaa',
  VXe: 'cd',
  VScEd: 'ba55d3',
  VpurpN: '9370db',
  VsHgYF: '3cb371',
  VUXe: '7b68ee',
  VsprRggYF: 'fa9a',
  VQe: '48d1cc',
  VviTetYd: 'c71585',
  midnightXe: '191970',
  mRtcYam: 'f5fffa',
  mistyPse: 'ffe4e1',
  moccasR: 'ffe4b5',
  navajowEte: 'ffdead',
  navy: '80',
  Tdlace: 'fdf5e6',
  Tive: '808000',
  TivedBb: '6b8e23',
  Sange: 'ffa500',
  SangeYd: 'ff4500',
  ScEd: 'da70d6',
  pOegTMnPd: 'eee8aa',
  pOegYF: '98fb98',
  pOeQe: 'afeeee',
  pOeviTetYd: 'db7093',
  papayawEp: 'ffefd5',
  pHKpuff: 'ffdab9',
  peru: 'cd853f',
  pRk: 'ffc0cb',
  plum: 'dda0dd',
  powMrXe: 'b0e0e6',
  purpN: '800080',
  YbeccapurpN: '663399',
  Yd: 'ff0000',
  Psybrown: 'bc8f8f',
  PyOXe: '4169e1',
  saddNbPwn: '8b4513',
  sOmon: 'fa8072',
  sandybPwn: 'f4a460',
  sHgYF: '2e8b57',
  sHshell: 'fff5ee',
  siFna: 'a0522d',
  silver: 'c0c0c0',
  skyXe: '87ceeb',
  UXe: '6a5acd',
  UWay: '708090',
  UgYy: '708090',
  snow: 'fffafa',
  sprRggYF: 'ff7f',
  stAlXe: '4682b4',
  tan: 'd2b48c',
  teO: '8080',
  tEstN: 'd8bfd8',
  tomato: 'ff6347',
  Qe: '40e0d0',
  viTet: 'ee82ee',
  JHt: 'f5deb3',
  wEte: 'ffffff',
  wEtesmoke: 'f5f5f5',
  Lw: 'ffff00',
  LwgYF: '9acd32'
};
function unpack() {
  const unpacked = {};
  const keys = Object.keys(names$1$1);
  const tkeys = Object.keys(map);
  let i, j, k, ok, nk;
  for (i = 0; i < keys.length; i++) {
    ok = nk = keys[i];
    for (j = 0; j < tkeys.length; j++) {
      k = tkeys[j];
      nk = nk.replace(k, map[k]);
    }
    k = parseInt(names$1$1[ok], 16);
    unpacked[nk] = [k >> 16 & 0xFF, k >> 8 & 0xFF, k & 0xFF];
  }
  return unpacked;
}
let names$2;
function nameParse(str) {
  if (!names$2) {
    names$2 = unpack();
    names$2.transparent = [0, 0, 0, 0];
  }
  const a = names$2[str.toLowerCase()];
  return a && {
    r: a[0],
    g: a[1],
    b: a[2],
    a: a.length === 4 ? a[3] : 255
  };
}
const RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function rgbParse(str) {
  const m = RGB_RE.exec(str);
  let a = 255;
  let r, g, b;
  if (!m) {
    return;
  }
  if (m[7] !== r) {
    const v = +m[7];
    a = m[8] ? p2b(v) : lim(v * 255, 0, 255);
  }
  r = +m[1];
  g = +m[3];
  b = +m[5];
  r = 255 & (m[2] ? p2b(r) : lim(r, 0, 255));
  g = 255 & (m[4] ? p2b(g) : lim(g, 0, 255));
  b = 255 & (m[6] ? p2b(b) : lim(b, 0, 255));
  return {
    r: r,
    g: g,
    b: b,
    a: a
  };
}
function rgbString(v) {
  return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${b2n(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const to = v => v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const from = v => v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function interpolate(rgb1, rgb2, t) {
  const r = from(b2n(rgb1.r));
  const g = from(b2n(rgb1.g));
  const b = from(b2n(rgb1.b));
  return {
    r: n2b(to(r + t * (from(b2n(rgb2.r)) - r))),
    g: n2b(to(g + t * (from(b2n(rgb2.g)) - g))),
    b: n2b(to(b + t * (from(b2n(rgb2.b)) - b))),
    a: rgb1.a + t * (rgb2.a - rgb1.a)
  };
}
function modHSL(v, i, ratio) {
  if (v) {
    let tmp = rgb2hsl(v);
    tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
    tmp = hsl2rgb(tmp);
    v.r = tmp[0];
    v.g = tmp[1];
    v.b = tmp[2];
  }
}
function clone(v, proto) {
  return v ? Object.assign(proto || {}, v) : v;
}
function fromObject(input) {
  var v = {
    r: 0,
    g: 0,
    b: 0,
    a: 255
  };
  if (Array.isArray(input)) {
    if (input.length >= 3) {
      v = {
        r: input[0],
        g: input[1],
        b: input[2],
        a: 255
      };
      if (input.length > 3) {
        v.a = n2b(input[3]);
      }
    }
  } else {
    v = clone(input, {
      r: 0,
      g: 0,
      b: 0,
      a: 1
    });
    v.a = n2b(v.a);
  }
  return v;
}
function functionParse(str) {
  if (str.charAt(0) === 'r') {
    return rgbParse(str);
  }
  return hueParse(str);
}
class Color {
  constructor(input) {
    if (input instanceof Color) {
      return input;
    }
    const type = typeof input;
    let v;
    if (type === 'object') {
      v = fromObject(input);
    } else if (type === 'string') {
      v = hexParse(input) || nameParse(input) || functionParse(input);
    }
    this._rgb = v;
    this._valid = !!v;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var v = clone(this._rgb);
    if (v) {
      v.a = b2n(v.a);
    }
    return v;
  }
  set rgb(obj) {
    this._rgb = fromObject(obj);
  }
  rgbString() {
    return this._valid ? rgbString(this._rgb) : undefined;
  }
  hexString() {
    return this._valid ? hexString(this._rgb) : undefined;
  }
  hslString() {
    return this._valid ? hslString(this._rgb) : undefined;
  }
  mix(color, weight) {
    if (color) {
      const c1 = this.rgb;
      const c2 = color.rgb;
      let w2;
      const p = weight === w2 ? 0.5 : weight;
      const w = 2 * p - 1;
      const a = c1.a - c2.a;
      const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
      w2 = 1 - w1;
      c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
      c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
      c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
      c1.a = p * c1.a + (1 - p) * c2.a;
      this.rgb = c1;
    }
    return this;
  }
  interpolate(color, t) {
    if (color) {
      this._rgb = interpolate(this._rgb, color._rgb, t);
    }
    return this;
  }
  clone() {
    return new Color(this.rgb);
  }
  alpha(a) {
    this._rgb.a = n2b(a);
    return this;
  }
  clearer(ratio) {
    const rgb = this._rgb;
    rgb.a *= 1 - ratio;
    return this;
  }
  greyscale() {
    const rgb = this._rgb;
    const val = round(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
    rgb.r = rgb.g = rgb.b = val;
    return this;
  }
  opaquer(ratio) {
    const rgb = this._rgb;
    rgb.a *= 1 + ratio;
    return this;
  }
  negate() {
    const v = this._rgb;
    v.r = 255 - v.r;
    v.g = 255 - v.g;
    v.b = 255 - v.b;
    return this;
  }
  lighten(ratio) {
    modHSL(this._rgb, 2, ratio);
    return this;
  }
  darken(ratio) {
    modHSL(this._rgb, 2, -ratio);
    return this;
  }
  saturate(ratio) {
    modHSL(this._rgb, 1, ratio);
    return this;
  }
  desaturate(ratio) {
    modHSL(this._rgb, 1, -ratio);
    return this;
  }
  rotate(deg) {
    rotate(this._rgb, deg);
    return this;
  }
}

/*!
 * Chart.js v4.4.7
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */

/**
 * @namespace Chart.helpers
 */ /**
    * An empty function that can be used, for example, for optional callback.
    */
function noop() {
  /* noop */}
/**
 * Returns a unique id, sequentially generated from a global variable.
 */
const uid = (() => {
  let id = 0;
  return () => id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */
function isNullOrUndef(value) {
  return value === null || value === undefined;
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */
function isArray(value) {
  if (Array.isArray && Array.isArray(value)) {
    return true;
  }
  const type = Object.prototype.toString.call(value);
  if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') {
    return true;
  }
  return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */
function isObject(value) {
  return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */
function isNumberFinite(value) {
  return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */
function finiteOrDefault(value, defaultValue) {
  return isNumberFinite(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */
function valueOrDefault(value, defaultValue) {
  return typeof value === 'undefined' ? defaultValue : value;
}
const toPercentage = (value, dimension) => typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const toDimension = (value, dimension) => typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */
function callback(fn, args, thisArg) {
  if (fn && typeof fn.call === 'function') {
    return fn.apply(thisArg, args);
  }
}
function each(loopable, fn, thisArg, reverse) {
  let i, len, keys;
  if (isArray(loopable)) {
    len = loopable.length;
    if (reverse) {
      for (i = len - 1; i >= 0; i--) {
        fn.call(thisArg, loopable[i], i);
      }
    } else {
      for (i = 0; i < len; i++) {
        fn.call(thisArg, loopable[i], i);
      }
    }
  } else if (isObject(loopable)) {
    keys = Object.keys(loopable);
    len = keys.length;
    for (i = 0; i < len; i++) {
      fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
  }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */
function _elementsEqual(a0, a1) {
  let i, ilen, v0, v1;
  if (!a0 || !a1 || a0.length !== a1.length) {
    return false;
  }
  for (i = 0, ilen = a0.length; i < ilen; ++i) {
    v0 = a0[i];
    v1 = a1[i];
    if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) {
      return false;
    }
  }
  return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */
function clone$1(source) {
  if (isArray(source)) {
    return source.map(clone$1);
  }
  if (isObject(source)) {
    const target = Object.create(null);
    const keys = Object.keys(source);
    const klen = keys.length;
    let k = 0;
    for (; k < klen; ++k) {
      target[keys[k]] = clone$1(source[keys[k]]);
    }
    return target;
  }
  return source;
}
function isValidKey(key) {
  return ['__proto__', 'prototype', 'constructor'].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */
function _merger(key, target, source, options) {
  if (!isValidKey(key)) {
    return;
  }
  const tval = target[key];
  const sval = source[key];
  if (isObject(tval) && isObject(sval)) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    merge(tval, sval, options);
  } else {
    target[key] = clone$1(sval);
  }
}
function merge(target, source, options) {
  const sources = isArray(source) ? source : [source];
  const ilen = sources.length;
  if (!isObject(target)) {
    return target;
  }
  options = options || {};
  const merger = options.merger || _merger;
  let current;
  for (let i = 0; i < ilen; ++i) {
    current = sources[i];
    if (!isObject(current)) {
      continue;
    }
    const keys = Object.keys(current);
    for (let k = 0, klen = keys.length; k < klen; ++k) {
      merger(keys[k], target, current, options);
    }
  }
  return target;
}
function mergeIf(target, source) {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  return merge(target, source, {
    merger: _mergerIf
  });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */
function _mergerIf(key, target, source) {
  if (!isValidKey(key)) {
    return;
  }
  const tval = target[key];
  const sval = source[key];
  if (isObject(tval) && isObject(sval)) {
    mergeIf(tval, sval);
  } else if (!Object.prototype.hasOwnProperty.call(target, key)) {
    target[key] = clone$1(sval);
  }
}
// resolveObjectKey resolver cache
const keyResolvers = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  '': v => v,
  // default resolvers
  x: o => o.x,
  y: o => o.y
};
/**
 * @private
 */
function _splitKey(key) {
  const parts = key.split('.');
  const keys = [];
  let tmp = '';
  for (const part of parts) {
    tmp += part;
    if (tmp.endsWith('\\')) {
      tmp = tmp.slice(0, -1) + '.';
    } else {
      keys.push(tmp);
      tmp = '';
    }
  }
  return keys;
}
function _getKeyResolver(key) {
  const keys = _splitKey(key);
  return obj => {
    for (const k of keys) {
      if (k === '') {
        break;
      }
      obj = obj && obj[k];
    }
    return obj;
  };
}
function resolveObjectKey(obj, key) {
  const resolver = keyResolvers[key] || (keyResolvers[key] = _getKeyResolver(key));
  return resolver(obj);
}
/**
 * @private
 */
function _capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
const defined = value => typeof value !== 'undefined';
const isFunction = value => typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const setsEqual = (a, b) => {
  if (a.size !== b.size) {
    return false;
  }
  for (const item of a) {
    if (!b.has(item)) {
      return false;
    }
  }
  return true;
};
/**
 * @param e - The event
 * @private
 */
function _isClickEvent(e) {
  return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}

/**
 * @alias Chart.helpers.math
 * @namespace
 */
const PI = Math.PI;
const TAU = 2 * PI;
const PITAU = TAU + PI;
const INFINITY = Number.POSITIVE_INFINITY;
const RAD_PER_DEG = PI / 180;
const HALF_PI = PI / 2;
const QUARTER_PI = PI / 4;
const TWO_THIRDS_PI = PI * 2 / 3;
const log10 = Math.log10;
const sign = Math.sign;
function almostEquals(x, y, epsilon) {
  return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */
function niceNum(range) {
  const roundedRange = Math.round(range);
  range = almostEquals(range, roundedRange, range / 1000) ? roundedRange : range;
  const niceRange = Math.pow(10, Math.floor(log10(range)));
  const fraction = range / niceRange;
  const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
  return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */
function _factorize(value) {
  const result = [];
  const sqrt = Math.sqrt(value);
  let i;
  for (i = 1; i < sqrt; i++) {
    if (value % i === 0) {
      result.push(i);
      result.push(value / i);
    }
  }
  if (sqrt === (sqrt | 0)) {
    result.push(sqrt);
  }
  result.sort((a, b) => a - b).pop();
  return result;
}
function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}
function almostWhole(x, epsilon) {
  const rounded = Math.round(x);
  return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */
function _setMinAndMaxByKey(array, target, property) {
  let i, ilen, value;
  for (i = 0, ilen = array.length; i < ilen; i++) {
    value = array[i][property];
    if (!isNaN(value)) {
      target.min = Math.min(target.min, value);
      target.max = Math.max(target.max, value);
    }
  }
}
function toRadians(degrees) {
  return degrees * (PI / 180);
}
function toDegrees(radians) {
  return radians * (180 / PI);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */
function _decimalPlaces(x) {
  if (!isNumberFinite(x)) {
    return;
  }
  let e = 1;
  let p = 0;
  while (Math.round(x * e) / e !== x) {
    e *= 10;
    p++;
  }
  return p;
}
// Gets the angle from vertical upright to the point about a centre.
function getAngleFromPoint(centrePoint, anglePoint) {
  const distanceFromXCenter = anglePoint.x - centrePoint.x;
  const distanceFromYCenter = anglePoint.y - centrePoint.y;
  const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
  let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
  if (angle < -0.5 * PI) {
    angle += TAU; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
  }
  return {
    angle,
    distance: radialDistanceFromCenter
  };
}
function distanceBetweenPoints(pt1, pt2) {
  return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */
function _angleDiff(a, b) {
  return (a - b + PITAU) % TAU - PI;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */
function _normalizeAngle(a) {
  return (a % TAU + TAU) % TAU;
}
/**
 * @private
 */
function _angleBetween(angle, start, end, sameAngleIsFullCircle) {
  const a = _normalizeAngle(angle);
  const s = _normalizeAngle(start);
  const e = _normalizeAngle(end);
  const angleToStart = _normalizeAngle(s - a);
  const angleToEnd = _normalizeAngle(e - a);
  const startToAngle = _normalizeAngle(a - s);
  const endToAngle = _normalizeAngle(a - e);
  return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */
function _limitValue(value, min, max) {
  return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */
function _int16Range(value) {
  return _limitValue(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */
function _isBetween(value, start, end, epsilon = 1e-6) {
  return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function _lookup(table, value, cmp) {
  cmp = cmp || (index => table[index] < value);
  let hi = table.length - 1;
  let lo = 0;
  let mid;
  while (hi - lo > 1) {
    mid = lo + hi >> 1;
    if (cmp(mid)) {
      lo = mid;
    } else {
      hi = mid;
    }
  }
  return {
    lo,
    hi
  };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */
const _lookupByKey = (table, key, value, last) => _lookup(table, value, last ? index => {
  const ti = table[index][key];
  return ti < value || ti === value && table[index + 1][key] === value;
} : index => table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */
const _rlookupByKey = (table, key, value) => _lookup(table, value, index => table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */
function _filterBetween(values, min, max) {
  let start = 0;
  let end = values.length;
  while (start < end && values[start] < min) {
    start++;
  }
  while (end > start && values[end - 1] > max) {
    end--;
  }
  return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];
function listenArrayEvents(array, listener) {
  if (array._chartjs) {
    array._chartjs.listeners.push(listener);
    return;
  }
  Object.defineProperty(array, '_chartjs', {
    configurable: true,
    enumerable: false,
    value: {
      listeners: [listener]
    }
  });
  arrayEvents.forEach(key => {
    const method = '_onData' + _capitalize(key);
    const base = array[key];
    Object.defineProperty(array, key, {
      configurable: true,
      enumerable: false,
      value(...args) {
        const res = base.apply(this, args);
        array._chartjs.listeners.forEach(object => {
          if (typeof object[method] === 'function') {
            object[method](...args);
          }
        });
        return res;
      }
    });
  });
}
function unlistenArrayEvents(array, listener) {
  const stub = array._chartjs;
  if (!stub) {
    return;
  }
  const listeners = stub.listeners;
  const index = listeners.indexOf(listener);
  if (index !== -1) {
    listeners.splice(index, 1);
  }
  if (listeners.length > 0) {
    return;
  }
  arrayEvents.forEach(key => {
    delete array[key];
  });
  delete array._chartjs;
}
/**
 * @param items
 */
function _arrayUnique(items) {
  const set = new Set(items);
  if (set.size === items.length) {
    return items;
  }
  return Array.from(set);
}
/**
* Request animation polyfill
*/
const requestAnimFrame = function () {
  if (typeof window === 'undefined') {
    return function (callback) {
      return callback();
    };
  }
  return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */
function throttled(fn, thisArg) {
  let argsToUse = [];
  let ticking = false;
  return function (...args) {
    // Save the args for use later
    argsToUse = args;
    if (!ticking) {
      ticking = true;
      requestAnimFrame.call(window, () => {
        ticking = false;
        fn.apply(thisArg, argsToUse);
      });
    }
  };
}
/**
 * Debounces calling `fn` for `delay` ms
 */
function debounce(fn, delay) {
  let timeout;
  return function (...args) {
    if (delay) {
      clearTimeout(timeout);
      timeout = setTimeout(fn, delay, args);
    } else {
      fn.apply(this, args);
    }
    return delay;
  };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */
const _toLeftRightCenter = align => align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */
const _alignStartEnd = (align, start, end) => align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */
const _textX = (align, left, right, rtl) => {
  const check = rtl ? 'left' : 'right';
  return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */
function _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled) {
  const pointCount = points.length;
  let start = 0;
  let count = pointCount;
  if (meta._sorted) {
    const {
      iScale,
      _parsed
    } = meta;
    const axis = iScale.axis;
    const {
      min,
      max,
      minDefined,
      maxDefined
    } = iScale.getUserBounds();
    if (minDefined) {
      start = _limitValue(Math.min(
      // @ts-expect-error Need to type _parsed
      _lookupByKey(_parsed, axis, min).lo,
      // @ts-expect-error Need to fix types on _lookupByKey
      animationsDisabled ? pointCount : _lookupByKey(points, axis, iScale.getPixelForValue(min)).lo), 0, pointCount - 1);
    }
    if (maxDefined) {
      count = _limitValue(Math.max(
      // @ts-expect-error Need to type _parsed
      _lookupByKey(_parsed, iScale.axis, max, true).hi + 1,
      // @ts-expect-error Need to fix types on _lookupByKey
      animationsDisabled ? 0 : _lookupByKey(points, axis, iScale.getPixelForValue(max), true).hi + 1), start, pointCount) - start;
    } else {
      count = pointCount - start;
    }
  }
  return {
    start,
    count
  };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */
function _scaleRangesChanged(meta) {
  const {
    xScale,
    yScale,
    _scaleRanges
  } = meta;
  const newRanges = {
    xmin: xScale.min,
    xmax: xScale.max,
    ymin: yScale.min,
    ymax: yScale.max
  };
  if (!_scaleRanges) {
    meta._scaleRanges = newRanges;
    return true;
  }
  const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
  Object.assign(_scaleRanges, newRanges);
  return changed;
}
const atEdge = t => t === 0 || t === 1;
const elasticIn = (t, s, p) => -(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * TAU / p));
const elasticOut = (t, s, p) => Math.pow(2, -10 * t) * Math.sin((t - s) * TAU / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */
const effects = {
  linear: t => t,
  easeInQuad: t => t * t,
  easeOutQuad: t => -t * (t - 2),
  easeInOutQuad: t => (t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
  easeInCubic: t => t * t * t,
  easeOutCubic: t => (t -= 1) * t * t + 1,
  easeInOutCubic: t => (t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
  easeInQuart: t => t * t * t * t,
  easeOutQuart: t => -((t -= 1) * t * t * t - 1),
  easeInOutQuart: t => (t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
  easeInQuint: t => t * t * t * t * t,
  easeOutQuint: t => (t -= 1) * t * t * t * t + 1,
  easeInOutQuint: t => (t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
  easeInSine: t => -Math.cos(t * HALF_PI) + 1,
  easeOutSine: t => Math.sin(t * HALF_PI),
  easeInOutSine: t => -0.5 * (Math.cos(PI * t) - 1),
  easeInExpo: t => t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
  easeOutExpo: t => t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
  easeInOutExpo: t => atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
  easeInCirc: t => t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
  easeOutCirc: t => Math.sqrt(1 - (t -= 1) * t),
  easeInOutCirc: t => (t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
  easeInElastic: t => atEdge(t) ? t : elasticIn(t, 0.075, 0.3),
  easeOutElastic: t => atEdge(t) ? t : elasticOut(t, 0.075, 0.3),
  easeInOutElastic(t) {
    const s = 0.1125;
    const p = 0.45;
    return atEdge(t) ? t : t < 0.5 ? 0.5 * elasticIn(t * 2, s, p) : 0.5 + 0.5 * elasticOut(t * 2 - 1, s, p);
  },
  easeInBack(t) {
    const s = 1.70158;
    return t * t * ((s + 1) * t - s);
  },
  easeOutBack(t) {
    const s = 1.70158;
    return (t -= 1) * t * ((s + 1) * t + s) + 1;
  },
  easeInOutBack(t) {
    let s = 1.70158;
    if ((t /= 0.5) < 1) {
      return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
    }
    return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
  },
  easeInBounce: t => 1 - effects.easeOutBounce(1 - t),
  easeOutBounce(t) {
    const m = 7.5625;
    const d = 2.75;
    if (t < 1 / d) {
      return m * t * t;
    }
    if (t < 2 / d) {
      return m * (t -= 1.5 / d) * t + 0.75;
    }
    if (t < 2.5 / d) {
      return m * (t -= 2.25 / d) * t + 0.9375;
    }
    return m * (t -= 2.625 / d) * t + 0.984375;
  },
  easeInOutBounce: t => t < 0.5 ? effects.easeInBounce(t * 2) * 0.5 : effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function isPatternOrGradient(value) {
  if (value && typeof value === 'object') {
    const type = value.toString();
    return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
  }
  return false;
}
function color(value) {
  return isPatternOrGradient(value) ? value : new Color(value);
}
function getHoverColor(value) {
  return isPatternOrGradient(value) ? value : new Color(value).saturate(0.5).darken(0.1).hexString();
}
const numbers = ['x', 'y', 'borderWidth', 'radius', 'tension'];
const colors$2 = ['color', 'borderColor', 'backgroundColor'];
function applyAnimationsDefaults(defaults) {
  defaults.set('animation', {
    delay: undefined,
    duration: 1000,
    easing: 'easeOutQuart',
    fn: undefined,
    from: undefined,
    loop: undefined,
    to: undefined,
    type: undefined
  });
  defaults.describe('animation', {
    _fallback: false,
    _indexable: false,
    _scriptable: name => name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
  });
  defaults.set('animations', {
    colors: {
      type: 'color',
      properties: colors$2
    },
    numbers: {
      type: 'number',
      properties: numbers
    }
  });
  defaults.describe('animations', {
    _fallback: 'animation'
  });
  defaults.set('transitions', {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: 'transparent'
        },
        visible: {
          type: 'boolean',
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: 'transparent'
        },
        visible: {
          type: 'boolean',
          easing: 'linear',
          fn: v => v | 0
        }
      }
    }
  });
}
function applyLayoutsDefaults(defaults) {
  defaults.set('layout', {
    autoPadding: true,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const intlCache = new Map();
function getNumberFormat(locale, options) {
  options = options || {};
  const cacheKey = locale + JSON.stringify(options);
  let formatter = intlCache.get(cacheKey);
  if (!formatter) {
    formatter = new Intl.NumberFormat(locale, options);
    intlCache.set(cacheKey, formatter);
  }
  return formatter;
}
function formatNumber(num, locale, options) {
  return getNumberFormat(locale, options).format(num);
}
const formatters = {
  values(value) {
    return isArray(value) ? value : '' + value;
  },
  numeric(tickValue, index, ticks) {
    if (tickValue === 0) {
      return '0';
    }
    const locale = this.chart.options.locale;
    let notation;
    let delta = tickValue;
    if (ticks.length > 1) {
      const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
      if (maxTick < 1e-4 || maxTick > 1e+15) {
        notation = 'scientific';
      }
      delta = calculateDelta(tickValue, ticks);
    }
    const logDelta = log10(Math.abs(delta));
    const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
    const options = {
      notation,
      minimumFractionDigits: numDecimal,
      maximumFractionDigits: numDecimal
    };
    Object.assign(options, this.options.ticks.format);
    return formatNumber(tickValue, locale, options);
  },
  logarithmic(tickValue, index, ticks) {
    if (tickValue === 0) {
      return '0';
    }
    const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor(log10(tickValue)));
    if ([1, 2, 3, 5, 10, 15].includes(remain) || index > 0.8 * ticks.length) {
      return formatters.numeric.call(this, tickValue, index, ticks);
    }
    return '';
  }
};
function calculateDelta(tickValue, ticks) {
  let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
  if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) {
    delta = tickValue - Math.floor(tickValue);
  }
  return delta;
}
var Ticks = {
  formatters
};
function applyScaleDefaults(defaults) {
  defaults.set('scale', {
    display: true,
    offset: false,
    reverse: false,
    beginAtZero: false,
    bounds: 'ticks',
    clip: true,
    grace: 0,
    grid: {
      display: true,
      lineWidth: 1,
      drawOnChartArea: true,
      drawTicks: true,
      tickLength: 8,
      tickWidth: (_ctx, options) => options.lineWidth,
      tickColor: (_ctx, options) => options.color,
      offset: false
    },
    border: {
      display: true,
      dash: [],
      dashOffset: 0.0,
      width: 1
    },
    title: {
      display: false,
      text: '',
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: false,
      textStrokeWidth: 0,
      textStrokeColor: '',
      padding: 3,
      display: true,
      autoSkip: true,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: Ticks.formatters.values,
      minor: {},
      major: {},
      align: 'center',
      crossAlign: 'near',
      showLabelBackdrop: false,
      backdropColor: 'rgba(255, 255, 255, 0.75)',
      backdropPadding: 2
    }
  });
  defaults.route('scale.ticks', 'color', '', 'color');
  defaults.route('scale.grid', 'color', '', 'borderColor');
  defaults.route('scale.border', 'color', '', 'borderColor');
  defaults.route('scale.title', 'color', '', 'color');
  defaults.describe('scale', {
    _fallback: false,
    _scriptable: name => !name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
    _indexable: name => name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
  });
  defaults.describe('scales', {
    _fallback: 'scale'
  });
  defaults.describe('scale.ticks', {
    _scriptable: name => name !== 'backdropPadding' && name !== 'callback',
    _indexable: name => name !== 'backdropPadding'
  });
}
const overrides = Object.create(null);
const descriptors = Object.create(null);
function getScope$1(node, key) {
  if (!key) {
    return node;
  }
  const keys = key.split('.');
  for (let i = 0, n = keys.length; i < n; ++i) {
    const k = keys[i];
    node = node[k] || (node[k] = Object.create(null));
  }
  return node;
}
function set(root, scope, values) {
  if (typeof scope === 'string') {
    return merge(getScope$1(root, scope), values);
  }
  return merge(getScope$1(root, ''), scope);
}
class Defaults {
  constructor(_descriptors, _appliers) {
    this.animation = undefined;
    this.backgroundColor = 'rgba(0,0,0,0.1)';
    this.borderColor = 'rgba(0,0,0,0.1)';
    this.color = '#666';
    this.datasets = {};
    this.devicePixelRatio = context => context.chart.platform.getDevicePixelRatio();
    this.elements = {};
    this.events = ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'];
    this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: 'normal',
      lineHeight: 1.2,
      weight: null
    };
    this.hover = {};
    this.hoverBackgroundColor = (ctx, options) => getHoverColor(options.backgroundColor);
    this.hoverBorderColor = (ctx, options) => getHoverColor(options.borderColor);
    this.hoverColor = (ctx, options) => getHoverColor(options.color);
    this.indexAxis = 'x';
    this.interaction = {
      mode: 'nearest',
      intersect: true,
      includeInvisible: false
    };
    this.maintainAspectRatio = true;
    this.onHover = null;
    this.onClick = null;
    this.parsing = true;
    this.plugins = {};
    this.responsive = true;
    this.scale = undefined;
    this.scales = {};
    this.showLine = true;
    this.drawActiveElementsOnTop = true;
    this.describe(_descriptors);
    this.apply(_appliers);
  }
  set(scope, values) {
    return set(this, scope, values);
  }
  get(scope) {
    return getScope$1(this, scope);
  }
  describe(scope, values) {
    return set(descriptors, scope, values);
  }
  override(scope, values) {
    return set(overrides, scope, values);
  }
  route(scope, name, targetScope, targetName) {
    const scopeObject = getScope$1(this, scope);
    const targetScopeObject = getScope$1(this, targetScope);
    const privateName = '_' + name;
    Object.defineProperties(scopeObject, {
      [privateName]: {
        value: scopeObject[name],
        writable: true
      },
      [name]: {
        enumerable: true,
        get() {
          const local = this[privateName];
          const target = targetScopeObject[targetName];
          if (isObject(local)) {
            return Object.assign({}, target, local);
          }
          return valueOrDefault(local, target);
        },
        set(value) {
          this[privateName] = value;
        }
      }
    });
  }
  apply(appliers) {
    appliers.forEach(apply => apply(this));
  }
}
var defaults = /* #__PURE__ */new Defaults({
  _scriptable: name => !name.startsWith('on'),
  _indexable: name => name !== 'events',
  hover: {
    _fallback: 'interaction'
  },
  interaction: {
    _scriptable: false,
    _indexable: false
  }
}, [applyAnimationsDefaults, applyLayoutsDefaults, applyScaleDefaults]);

/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */
function toFontString(font) {
  if (!font || isNullOrUndef(font.size) || isNullOrUndef(font.family)) {
    return null;
  }
  return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */
function _measureText(ctx, data, gc, longest, string) {
  let textWidth = data[string];
  if (!textWidth) {
    textWidth = data[string] = ctx.measureText(string).width;
    gc.push(string);
  }
  if (textWidth > longest) {
    longest = textWidth;
  }
  return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function _longestText(ctx, font, arrayOfThings, cache) {
  cache = cache || {};
  let data = cache.data = cache.data || {};
  let gc = cache.garbageCollect = cache.garbageCollect || [];
  if (cache.font !== font) {
    data = cache.data = {};
    gc = cache.garbageCollect = [];
    cache.font = font;
  }
  ctx.save();
  ctx.font = font;
  let longest = 0;
  const ilen = arrayOfThings.length;
  let i, j, jlen, thing, nestedThing;
  for (i = 0; i < ilen; i++) {
    thing = arrayOfThings[i];
    // Undefined strings and arrays should not be measured
    if (thing !== undefined && thing !== null && !isArray(thing)) {
      longest = _measureText(ctx, data, gc, longest, thing);
    } else if (isArray(thing)) {
      // if it is an array lets measure each element
      // to do maybe simplify this function a bit so we can do this more recursively?
      for (j = 0, jlen = thing.length; j < jlen; j++) {
        nestedThing = thing[j];
        // Undefined strings and arrays should not be measured
        if (nestedThing !== undefined && nestedThing !== null && !isArray(nestedThing)) {
          longest = _measureText(ctx, data, gc, longest, nestedThing);
        }
      }
    }
  }
  ctx.restore();
  const gcLen = gc.length / 2;
  if (gcLen > arrayOfThings.length) {
    for (i = 0; i < gcLen; i++) {
      delete data[gc[i]];
    }
    gc.splice(0, gcLen);
  }
  return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */
function _alignPixel(chart, pixel, width) {
  const devicePixelRatio = chart.currentDevicePixelRatio;
  const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
  return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */
function clearCanvas(canvas, ctx) {
  if (!ctx && !canvas) {
    return;
  }
  ctx = ctx || canvas.getContext('2d');
  ctx.save();
  // canvas.width and canvas.height do not consider the canvas transform,
  // while clearRect does
  ctx.resetTransform();
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.restore();
}
function drawPoint(ctx, options, x, y) {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  drawPointLegend(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function drawPointLegend(ctx, options, x, y, w) {
  let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
  const style = options.pointStyle;
  const rotation = options.rotation;
  const radius = options.radius;
  let rad = (rotation || 0) * RAD_PER_DEG;
  if (style && typeof style === 'object') {
    type = style.toString();
    if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(rad);
      ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
      ctx.restore();
      return;
    }
  }
  if (isNaN(radius) || radius <= 0) {
    return;
  }
  ctx.beginPath();
  switch (style) {
    // Default includes circle
    default:
      if (w) {
        ctx.ellipse(x, y, w / 2, radius, 0, 0, TAU);
      } else {
        ctx.arc(x, y, radius, 0, TAU);
      }
      ctx.closePath();
      break;
    case 'triangle':
      width = w ? w / 2 : radius;
      ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
      rad += TWO_THIRDS_PI;
      ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
      rad += TWO_THIRDS_PI;
      ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
      ctx.closePath();
      break;
    case 'rectRounded':
      // NOTE: the rounded rect implementation changed to use `arc` instead of
      // `quadraticCurveTo` since it generates better results when rect is
      // almost a circle. 0.516 (instead of 0.5) produces results with visually
      // closer proportion to the previous impl and it is inscribed in the
      // circle with `radius`. For more details, see the following PRs:
      // https://github.com/chartjs/Chart.js/issues/5597
      // https://github.com/chartjs/Chart.js/issues/5858
      cornerRadius = radius * 0.516;
      size = radius - cornerRadius;
      xOffset = Math.cos(rad + QUARTER_PI) * size;
      xOffsetW = Math.cos(rad + QUARTER_PI) * (w ? w / 2 - cornerRadius : size);
      yOffset = Math.sin(rad + QUARTER_PI) * size;
      yOffsetW = Math.sin(rad + QUARTER_PI) * (w ? w / 2 - cornerRadius : size);
      ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
      ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - HALF_PI, rad);
      ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + HALF_PI);
      ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
      ctx.closePath();
      break;
    case 'rect':
      if (!rotation) {
        size = Math.SQRT1_2 * radius;
        width = w ? w / 2 : size;
        ctx.rect(x - width, y - size, 2 * width, 2 * size);
        break;
      }
      rad += QUARTER_PI;
    /* falls through */
    case 'rectRot':
      xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
      ctx.moveTo(x - xOffsetW, y - yOffset);
      ctx.lineTo(x + yOffsetW, y - xOffset);
      ctx.lineTo(x + xOffsetW, y + yOffset);
      ctx.lineTo(x - yOffsetW, y + xOffset);
      ctx.closePath();
      break;
    case 'crossRot':
      rad += QUARTER_PI;
    /* falls through */
    case 'cross':
      xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
      ctx.moveTo(x - xOffsetW, y - yOffset);
      ctx.lineTo(x + xOffsetW, y + yOffset);
      ctx.moveTo(x + yOffsetW, y - xOffset);
      ctx.lineTo(x - yOffsetW, y + xOffset);
      break;
    case 'star':
      xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
      ctx.moveTo(x - xOffsetW, y - yOffset);
      ctx.lineTo(x + xOffsetW, y + yOffset);
      ctx.moveTo(x + yOffsetW, y - xOffset);
      ctx.lineTo(x - yOffsetW, y + xOffset);
      rad += QUARTER_PI;
      xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
      ctx.moveTo(x - xOffsetW, y - yOffset);
      ctx.lineTo(x + xOffsetW, y + yOffset);
      ctx.moveTo(x + yOffsetW, y - xOffset);
      ctx.lineTo(x - yOffsetW, y + xOffset);
      break;
    case 'line':
      xOffset = w ? w / 2 : Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      ctx.moveTo(x - xOffset, y - yOffset);
      ctx.lineTo(x + xOffset, y + yOffset);
      break;
    case 'dash':
      ctx.moveTo(x, y);
      ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
      break;
    case false:
      ctx.closePath();
      break;
  }
  ctx.fill();
  if (options.borderWidth > 0) {
    ctx.stroke();
  }
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */
function _isPointInArea(point, area, margin) {
  margin = margin || 0.5; // margin - default is to match rounded decimals
  return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function clipArea(ctx, area) {
  ctx.save();
  ctx.beginPath();
  ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
  ctx.clip();
}
function unclipArea(ctx) {
  ctx.restore();
}
/**
 * @private
 */
function _steppedLineTo(ctx, previous, target, flip, mode) {
  if (!previous) {
    return ctx.lineTo(target.x, target.y);
  }
  if (mode === 'middle') {
    const midpoint = (previous.x + target.x) / 2.0;
    ctx.lineTo(midpoint, previous.y);
    ctx.lineTo(midpoint, target.y);
  } else if (mode === 'after' !== !!flip) {
    ctx.lineTo(previous.x, target.y);
  } else {
    ctx.lineTo(target.x, previous.y);
  }
  ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */
function _bezierCurveTo(ctx, previous, target, flip) {
  if (!previous) {
    return ctx.lineTo(target.x, target.y);
  }
  ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function setRenderOpts(ctx, opts) {
  if (opts.translation) {
    ctx.translate(opts.translation[0], opts.translation[1]);
  }
  if (!isNullOrUndef(opts.rotation)) {
    ctx.rotate(opts.rotation);
  }
  if (opts.color) {
    ctx.fillStyle = opts.color;
  }
  if (opts.textAlign) {
    ctx.textAlign = opts.textAlign;
  }
  if (opts.textBaseline) {
    ctx.textBaseline = opts.textBaseline;
  }
}
function decorateText(ctx, x, y, line, opts) {
  if (opts.strikethrough || opts.underline) {
    /**
    * Now that IE11 support has been dropped, we can use more
    * of the TextMetrics object. The actual bounding boxes
    * are unflagged in Chrome, Firefox, Edge, and Safari so they
    * can be safely used.
    * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
    */
    const metrics = ctx.measureText(line);
    const left = x - metrics.actualBoundingBoxLeft;
    const right = x + metrics.actualBoundingBoxRight;
    const top = y - metrics.actualBoundingBoxAscent;
    const bottom = y + metrics.actualBoundingBoxDescent;
    const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
    ctx.strokeStyle = ctx.fillStyle;
    ctx.beginPath();
    ctx.lineWidth = opts.decorationWidth || 2;
    ctx.moveTo(left, yDecoration);
    ctx.lineTo(right, yDecoration);
    ctx.stroke();
  }
}
function drawBackdrop(ctx, opts) {
  const oldColor = ctx.fillStyle;
  ctx.fillStyle = opts.color;
  ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
  ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */
function renderText(ctx, text, x, y, font, opts = {}) {
  const lines = isArray(text) ? text : [text];
  const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
  let i, line;
  ctx.save();
  ctx.font = font.string;
  setRenderOpts(ctx, opts);
  for (i = 0; i < lines.length; ++i) {
    line = lines[i];
    if (opts.backdrop) {
      drawBackdrop(ctx, opts.backdrop);
    }
    if (stroke) {
      if (opts.strokeColor) {
        ctx.strokeStyle = opts.strokeColor;
      }
      if (!isNullOrUndef(opts.strokeWidth)) {
        ctx.lineWidth = opts.strokeWidth;
      }
      ctx.strokeText(line, x, y, opts.maxWidth);
    }
    ctx.fillText(line, x, y, opts.maxWidth);
    decorateText(ctx, x, y, line, opts);
    y += Number(font.lineHeight);
  }
  ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */
function addRoundedRectPath(ctx, rect) {
  const {
    x,
    y,
    w,
    h,
    radius
  } = rect;
  // top left arc
  ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * PI, PI, true);
  // line from top left to bottom left
  ctx.lineTo(x, y + h - radius.bottomLeft);
  // bottom left arc
  ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, PI, HALF_PI, true);
  // line from bottom left to bottom right
  ctx.lineTo(x + w - radius.bottomRight, y + h);
  // bottom right arc
  ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, HALF_PI, 0, true);
  // line from bottom right to top right
  ctx.lineTo(x + w, y + radius.topRight);
  // top right arc
  ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -HALF_PI, true);
  // line from top right to top left
  ctx.lineTo(x + radius.topLeft, y);
}
const LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
    * Converts the given line height `value` in pixels for a specific font `size`.
    * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
    * @param size - The font size (in pixels) used to resolve relative `value`.
    * @returns The effective line height in pixels (size * 1.2 if value is invalid).
    * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
    * @since 2.7.0
    */
function toLineHeight(value, size) {
  const matches = ('' + value).match(LINE_HEIGHT);
  if (!matches || matches[1] === 'normal') {
    return size * 1.2;
  }
  value = +matches[2];
  switch (matches[3]) {
    case 'px':
      return value;
    case '%':
      value /= 100;
      break;
  }
  return size * value;
}
const numberOrZero = v => +v || 0;
function _readValueToProps(value, props) {
  const ret = {};
  const objProps = isObject(props);
  const keys = objProps ? Object.keys(props) : props;
  const read = isObject(value) ? objProps ? prop => valueOrDefault(value[prop], value[props[prop]]) : prop => value[prop] : () => value;
  for (const prop of keys) {
    ret[prop] = numberOrZero(read(prop));
  }
  return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */
function toTRBL(value) {
  return _readValueToProps(value, {
    top: 'y',
    right: 'x',
    bottom: 'y',
    left: 'x'
  });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */
function toTRBLCorners(value) {
  return _readValueToProps(value, ['topLeft', 'topRight', 'bottomLeft', 'bottomRight']);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */
function toPadding(value) {
  const obj = toTRBL(value);
  obj.width = obj.left + obj.right;
  obj.height = obj.top + obj.bottom;
  return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */
function toFont(options, fallback) {
  options = options || {};
  fallback = fallback || defaults.font;
  let size = valueOrDefault(options.size, fallback.size);
  if (typeof size === 'string') {
    size = parseInt(size, 10);
  }
  let style = valueOrDefault(options.style, fallback.style);
  if (style && !('' + style).match(FONT_STYLE)) {
    console.warn('Invalid font style specified: "' + style + '"');
    style = undefined;
  }
  const font = {
    family: valueOrDefault(options.family, fallback.family),
    lineHeight: toLineHeight(valueOrDefault(options.lineHeight, fallback.lineHeight), size),
    size,
    style,
    weight: valueOrDefault(options.weight, fallback.weight),
    string: ''
  };
  font.string = toFontString(font);
  return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */
function resolve(inputs, context, index, info) {
  let cacheable = true;
  let i, ilen, value;
  for (i = 0, ilen = inputs.length; i < ilen; ++i) {
    value = inputs[i];
    if (value === undefined) {
      continue;
    }
    if (context !== undefined && typeof value === 'function') {
      value = value(context);
      cacheable = false;
    }
    if (index !== undefined && isArray(value)) {
      value = value[index % value.length];
      cacheable = false;
    }
    if (value !== undefined) {
      if (info && !cacheable) {
        info.cacheable = false;
      }
      return value;
    }
  }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */
function _addGrace(minmax, grace, beginAtZero) {
  const {
    min,
    max
  } = minmax;
  const change = toDimension(grace, (max - min) / 2);
  const keepZero = (value, add) => beginAtZero && value === 0 ? 0 : value + add;
  return {
    min: keepZero(min, -Math.abs(change)),
    max: keepZero(max, change)
  };
}
function createContext(parentContext, context) {
  return Object.assign(Object.create(parentContext), context);
}

/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */
function _createResolver(scopes, prefixes = [''], rootScopes, fallback, getTarget = () => scopes[0]) {
  const finalRootScopes = rootScopes || scopes;
  if (typeof fallback === 'undefined') {
    fallback = _resolve('_fallback', scopes);
  }
  const cache = {
    [Symbol.toStringTag]: 'Object',
    _cacheable: true,
    _scopes: scopes,
    _rootScopes: finalRootScopes,
    _fallback: fallback,
    _getTarget: getTarget,
    override: scope => _createResolver([scope, ...scopes], prefixes, finalRootScopes, fallback)
  };
  return new Proxy(cache, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(target, prop) {
      delete target[prop]; // remove from cache
      delete target._keys; // remove cached keys
      delete scopes[0][prop]; // remove from top level scope
      return true;
    },
    /**
    * A trap for getting property values.
    */
    get(target, prop) {
      return _cached(target, prop, () => _resolveWithPrefixes(prop, prefixes, scopes, target));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(target, prop) {
      return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(scopes[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(target, prop) {
      return getKeysFromAllScopes(target).includes(prop);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(target) {
      return getKeysFromAllScopes(target);
    },
    /**
    * A trap for setting property values.
    */
    set(target, prop, value) {
      const storage = target._storage || (target._storage = getTarget());
      target[prop] = storage[prop] = value; // set to top level scope + cache
      delete target._keys; // remove cached keys
      return true;
    }
  });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */
function _attachContext(proxy, context, subProxy, descriptorDefaults) {
  const cache = {
    _cacheable: false,
    _proxy: proxy,
    _context: context,
    _subProxy: subProxy,
    _stack: new Set(),
    _descriptors: _descriptors(proxy, descriptorDefaults),
    setContext: ctx => _attachContext(proxy, ctx, subProxy, descriptorDefaults),
    override: scope => _attachContext(proxy.override(scope), context, subProxy, descriptorDefaults)
  };
  return new Proxy(cache, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(target, prop) {
      delete target[prop]; // remove from cache
      delete proxy[prop]; // remove from proxy
      return true;
    },
    /**
    * A trap for getting property values.
    */
    get(target, prop, receiver) {
      return _cached(target, prop, () => _resolveWithContext(target, prop, receiver));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(target, prop) {
      return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
        enumerable: true,
        configurable: true
      } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(proxy);
    },
    /**
    * A trap for the in operator.
    */
    has(target, prop) {
      return Reflect.has(proxy, prop);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(proxy);
    },
    /**
    * A trap for setting property values.
    */
    set(target, prop, value) {
      proxy[prop] = value; // set to proxy
      delete target[prop]; // remove from cache
      return true;
    }
  });
}
/**
 * @private
 */
function _descriptors(proxy, defaults = {
  scriptable: true,
  indexable: true
}) {
  const {
    _scriptable = defaults.scriptable,
    _indexable = defaults.indexable,
    _allKeys = defaults.allKeys
  } = proxy;
  return {
    allKeys: _allKeys,
    scriptable: _scriptable,
    indexable: _indexable,
    isScriptable: isFunction(_scriptable) ? _scriptable : () => _scriptable,
    isIndexable: isFunction(_indexable) ? _indexable : () => _indexable
  };
}
const readKey = (prefix, name) => prefix ? prefix + _capitalize(name) : name;
const needsSubResolver = (prop, value) => isObject(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function _cached(target, prop, resolve) {
  if (Object.prototype.hasOwnProperty.call(target, prop) || prop === 'constructor') {
    return target[prop];
  }
  const value = resolve();
  // cache the resolved value
  target[prop] = value;
  return value;
}
function _resolveWithContext(target, prop, receiver) {
  const {
    _proxy,
    _context,
    _subProxy,
    _descriptors: descriptors
  } = target;
  let value = _proxy[prop]; // resolve from proxy
  // resolve with context
  if (isFunction(value) && descriptors.isScriptable(prop)) {
    value = _resolveScriptable(prop, value, target, receiver);
  }
  if (isArray(value) && value.length) {
    value = _resolveArray(prop, value, target, descriptors.isIndexable);
  }
  if (needsSubResolver(prop, value)) {
    // if the resolved value is an object, create a sub resolver for it
    value = _attachContext(value, _context, _subProxy && _subProxy[prop], descriptors);
  }
  return value;
}
function _resolveScriptable(prop, getValue, target, receiver) {
  const {
    _proxy,
    _context,
    _subProxy,
    _stack
  } = target;
  if (_stack.has(prop)) {
    throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
  }
  _stack.add(prop);
  let value = getValue(_context, _subProxy || receiver);
  _stack.delete(prop);
  if (needsSubResolver(prop, value)) {
    // When scriptable option returns an object, create a resolver on that.
    value = createSubResolver(_proxy._scopes, _proxy, prop, value);
  }
  return value;
}
function _resolveArray(prop, value, target, isIndexable) {
  const {
    _proxy,
    _context,
    _subProxy,
    _descriptors: descriptors
  } = target;
  if (typeof _context.index !== 'undefined' && isIndexable(prop)) {
    return value[_context.index % value.length];
  } else if (isObject(value[0])) {
    // Array of objects, return array or resolvers
    const arr = value;
    const scopes = _proxy._scopes.filter(s => s !== arr);
    value = [];
    for (const item of arr) {
      const resolver = createSubResolver(scopes, _proxy, prop, item);
      value.push(_attachContext(resolver, _context, _subProxy && _subProxy[prop], descriptors));
    }
  }
  return value;
}
function resolveFallback(fallback, prop, value) {
  return isFunction(fallback) ? fallback(prop, value) : fallback;
}
const getScope = (key, parent) => key === true ? parent : typeof key === 'string' ? resolveObjectKey(parent, key) : undefined;
function addScopes(set, parentScopes, key, parentFallback, value) {
  for (const parent of parentScopes) {
    const scope = getScope(key, parent);
    if (scope) {
      set.add(scope);
      const fallback = resolveFallback(scope._fallback, key, value);
      if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) {
        // When we reach the descriptor that defines a new _fallback, return that.
        // The fallback will resume to that new scope.
        return fallback;
      }
    } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) {
      // Fallback to `false` results to `false`, when falling back to different key.
      // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
      return null;
    }
  }
  return false;
}
function createSubResolver(parentScopes, resolver, prop, value) {
  const rootScopes = resolver._rootScopes;
  const fallback = resolveFallback(resolver._fallback, prop, value);
  const allScopes = [...parentScopes, ...rootScopes];
  const set = new Set();
  set.add(value);
  let key = addScopesFromKey(set, allScopes, prop, fallback || prop, value);
  if (key === null) {
    return false;
  }
  if (typeof fallback !== 'undefined' && fallback !== prop) {
    key = addScopesFromKey(set, allScopes, fallback, key, value);
    if (key === null) {
      return false;
    }
  }
  return _createResolver(Array.from(set), [''], rootScopes, fallback, () => subGetTarget(resolver, prop, value));
}
function addScopesFromKey(set, allScopes, key, fallback, item) {
  while (key) {
    key = addScopes(set, allScopes, key, fallback, item);
  }
  return key;
}
function subGetTarget(resolver, prop, value) {
  const parent = resolver._getTarget();
  if (!(prop in parent)) {
    parent[prop] = {};
  }
  const target = parent[prop];
  if (isArray(target) && isObject(value)) {
    // For array of objects, the object is used to store updated values
    return value;
  }
  return target || {};
}
function _resolveWithPrefixes(prop, prefixes, scopes, proxy) {
  let value;
  for (const prefix of prefixes) {
    value = _resolve(readKey(prefix, prop), scopes);
    if (typeof value !== 'undefined') {
      return needsSubResolver(prop, value) ? createSubResolver(scopes, proxy, prop, value) : value;
    }
  }
}
function _resolve(key, scopes) {
  for (const scope of scopes) {
    if (!scope) {
      continue;
    }
    const value = scope[key];
    if (typeof value !== 'undefined') {
      return value;
    }
  }
}
function getKeysFromAllScopes(target) {
  let keys = target._keys;
  if (!keys) {
    keys = target._keys = resolveKeysFromAllScopes(target._scopes);
  }
  return keys;
}
function resolveKeysFromAllScopes(scopes) {
  const set = new Set();
  for (const scope of scopes) {
    for (const key of Object.keys(scope).filter(k => !k.startsWith('_'))) {
      set.add(key);
    }
  }
  return Array.from(set);
}
function _parseObjectDataRadialScale(meta, data, start, count) {
  const {
    iScale
  } = meta;
  const {
    key = 'r'
  } = this._parsing;
  const parsed = new Array(count);
  let i, ilen, index, item;
  for (i = 0, ilen = count; i < ilen; ++i) {
    index = i + start;
    item = data[index];
    parsed[i] = {
      r: iScale.parse(resolveObjectKey(item, key), index)
    };
  }
  return parsed;
}
const EPSILON = Number.EPSILON || 1e-14;
const getPoint = (points, i) => i < points.length && !points[i].skip && points[i];
const getValueAxis = indexAxis => indexAxis === 'x' ? 'y' : 'x';
function splineCurve(firstPoint, middlePoint, afterPoint, t) {
  // Props to Rob Spencer at scaled innovation for his post on splining between points
  // http://scaledinnovation.com/analytics/splines/aboutSplines.html
  // This function must also respect "skipped" points
  const previous = firstPoint.skip ? middlePoint : firstPoint;
  const current = middlePoint;
  const next = afterPoint.skip ? middlePoint : afterPoint;
  const d01 = distanceBetweenPoints(current, previous);
  const d12 = distanceBetweenPoints(next, current);
  let s01 = d01 / (d01 + d12);
  let s12 = d12 / (d01 + d12);
  // If all points are the same, s01 & s02 will be inf
  s01 = isNaN(s01) ? 0 : s01;
  s12 = isNaN(s12) ? 0 : s12;
  const fa = t * s01; // scaling factor for triangle Ta
  const fb = t * s12;
  return {
    previous: {
      x: current.x - fa * (next.x - previous.x),
      y: current.y - fa * (next.y - previous.y)
    },
    next: {
      x: current.x + fb * (next.x - previous.x),
      y: current.y + fb * (next.y - previous.y)
    }
  };
}
/**
 * Adjust tangents to ensure monotonic properties
 */
function monotoneAdjust(points, deltaK, mK) {
  const pointsLen = points.length;
  let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
  let pointAfter = getPoint(points, 0);
  for (let i = 0; i < pointsLen - 1; ++i) {
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i + 1);
    if (!pointCurrent || !pointAfter) {
      continue;
    }
    if (almostEquals(deltaK[i], 0, EPSILON)) {
      mK[i] = mK[i + 1] = 0;
      continue;
    }
    alphaK = mK[i] / deltaK[i];
    betaK = mK[i + 1] / deltaK[i];
    squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
    if (squaredMagnitude <= 9) {
      continue;
    }
    tauK = 3 / Math.sqrt(squaredMagnitude);
    mK[i] = alphaK * tauK * deltaK[i];
    mK[i + 1] = betaK * tauK * deltaK[i];
  }
}
function monotoneCompute(points, mK, indexAxis = 'x') {
  const valueAxis = getValueAxis(indexAxis);
  const pointsLen = points.length;
  let delta, pointBefore, pointCurrent;
  let pointAfter = getPoint(points, 0);
  for (let i = 0; i < pointsLen; ++i) {
    pointBefore = pointCurrent;
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i + 1);
    if (!pointCurrent) {
      continue;
    }
    const iPixel = pointCurrent[indexAxis];
    const vPixel = pointCurrent[valueAxis];
    if (pointBefore) {
      delta = (iPixel - pointBefore[indexAxis]) / 3;
      pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
      pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
    }
    if (pointAfter) {
      delta = (pointAfter[indexAxis] - iPixel) / 3;
      pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
      pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
    }
  }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */
function splineCurveMonotone(points, indexAxis = 'x') {
  const valueAxis = getValueAxis(indexAxis);
  const pointsLen = points.length;
  const deltaK = Array(pointsLen).fill(0);
  const mK = Array(pointsLen);
  // Calculate slopes (deltaK) and initialize tangents (mK)
  let i, pointBefore, pointCurrent;
  let pointAfter = getPoint(points, 0);
  for (i = 0; i < pointsLen; ++i) {
    pointBefore = pointCurrent;
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i + 1);
    if (!pointCurrent) {
      continue;
    }
    if (pointAfter) {
      const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
      // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
      deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
    }
    mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : sign(deltaK[i - 1]) !== sign(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
  }
  monotoneAdjust(points, deltaK, mK);
  monotoneCompute(points, mK, indexAxis);
}
function capControlPoint(pt, min, max) {
  return Math.max(Math.min(pt, max), min);
}
function capBezierPoints(points, area) {
  let i, ilen, point, inArea, inAreaPrev;
  let inAreaNext = _isPointInArea(points[0], area);
  for (i = 0, ilen = points.length; i < ilen; ++i) {
    inAreaPrev = inArea;
    inArea = inAreaNext;
    inAreaNext = i < ilen - 1 && _isPointInArea(points[i + 1], area);
    if (!inArea) {
      continue;
    }
    point = points[i];
    if (inAreaPrev) {
      point.cp1x = capControlPoint(point.cp1x, area.left, area.right);
      point.cp1y = capControlPoint(point.cp1y, area.top, area.bottom);
    }
    if (inAreaNext) {
      point.cp2x = capControlPoint(point.cp2x, area.left, area.right);
      point.cp2y = capControlPoint(point.cp2y, area.top, area.bottom);
    }
  }
}
/**
 * @private
 */
function _updateBezierControlPoints(points, options, area, loop, indexAxis) {
  let i, ilen, point, controlPoints;
  // Only consider points that are drawn in case the spanGaps option is used
  if (options.spanGaps) {
    points = points.filter(pt => !pt.skip);
  }
  if (options.cubicInterpolationMode === 'monotone') {
    splineCurveMonotone(points, indexAxis);
  } else {
    let prev = loop ? points[points.length - 1] : points[0];
    for (i = 0, ilen = points.length; i < ilen; ++i) {
      point = points[i];
      controlPoints = splineCurve(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
      point.cp1x = controlPoints.previous.x;
      point.cp1y = controlPoints.previous.y;
      point.cp2x = controlPoints.next.x;
      point.cp2y = controlPoints.next.y;
      prev = point;
    }
  }
  if (options.capBezierPoints) {
    capBezierPoints(points, area);
  }
}

/**
 * Note: typedefs are auto-exported, so use a made-up `dom` namespace where
 * necessary to avoid duplicates with `export * from './helpers`; see
 * https://github.com/microsoft/TypeScript/issues/46011
 * @typedef { import('../core/core.controller.js').default } dom.Chart
 * @typedef { import('../../types').ChartEvent } ChartEvent
 */ /**
    * @private
    */
function _isDomSupported() {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */
function _getParentNode(domNode) {
  let parent = domNode.parentNode;
  if (parent && parent.toString() === '[object ShadowRoot]') {
    parent = parent.host;
  }
  return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */
function parseMaxStyle(styleValue, node, parentProperty) {
  let valueInPixels;
  if (typeof styleValue === 'string') {
    valueInPixels = parseInt(styleValue, 10);
    if (styleValue.indexOf('%') !== -1) {
      // percentage * size in dimension
      valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    }
  } else {
    valueInPixels = styleValue;
  }
  return valueInPixels;
}
const getComputedStyle = element => element.ownerDocument.defaultView.getComputedStyle(element, null);
function getStyle(el, property) {
  return getComputedStyle(el).getPropertyValue(property);
}
const positions = ['top', 'right', 'bottom', 'left'];
function getPositionedStyle(styles, style, suffix) {
  const result = {};
  suffix = suffix ? '-' + suffix : '';
  for (let i = 0; i < 4; i++) {
    const pos = positions[i];
    result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
  }
  result.width = result.left + result.right;
  result.height = result.top + result.bottom;
  return result;
}
const useOffsetPos = (x, y, target) => (x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */
function getCanvasPosition(e, canvas) {
  const touches = e.touches;
  const source = touches && touches.length ? touches[0] : e;
  const {
    offsetX,
    offsetY
  } = source;
  let box = false;
  let x, y;
  if (useOffsetPos(offsetX, offsetY, e.target)) {
    x = offsetX;
    y = offsetY;
  } else {
    const rect = canvas.getBoundingClientRect();
    x = source.clientX - rect.left;
    y = source.clientY - rect.top;
    box = true;
  }
  return {
    x,
    y,
    box
  };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */
function getRelativePosition(event, chart) {
  if ('native' in event) {
    return event;
  }
  const {
    canvas,
    currentDevicePixelRatio
  } = chart;
  const style = getComputedStyle(canvas);
  const borderBox = style.boxSizing === 'border-box';
  const paddings = getPositionedStyle(style, 'padding');
  const borders = getPositionedStyle(style, 'border', 'width');
  const {
    x,
    y,
    box
  } = getCanvasPosition(event, canvas);
  const xOffset = paddings.left + (box && borders.left);
  const yOffset = paddings.top + (box && borders.top);
  let {
    width,
    height
  } = chart;
  if (borderBox) {
    width -= paddings.width + borders.width;
    height -= paddings.height + borders.height;
  }
  return {
    x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
    y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
  };
}
function getContainerSize(canvas, width, height) {
  let maxWidth, maxHeight;
  if (width === undefined || height === undefined) {
    const container = canvas && _getParentNode(canvas);
    if (!container) {
      width = canvas.clientWidth;
      height = canvas.clientHeight;
    } else {
      const rect = container.getBoundingClientRect(); // this is the border box of the container
      const containerStyle = getComputedStyle(container);
      const containerBorder = getPositionedStyle(containerStyle, 'border', 'width');
      const containerPadding = getPositionedStyle(containerStyle, 'padding');
      width = rect.width - containerPadding.width - containerBorder.width;
      height = rect.height - containerPadding.height - containerBorder.height;
      maxWidth = parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
      maxHeight = parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
    }
  }
  return {
    width,
    height,
    maxWidth: maxWidth || INFINITY,
    maxHeight: maxHeight || INFINITY
  };
}
const round1 = v => Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function getMaximumSize(canvas, bbWidth, bbHeight, aspectRatio) {
  const style = getComputedStyle(canvas);
  const margins = getPositionedStyle(style, 'margin');
  const maxWidth = parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || INFINITY;
  const maxHeight = parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || INFINITY;
  const containerSize = getContainerSize(canvas, bbWidth, bbHeight);
  let {
    width,
    height
  } = containerSize;
  if (style.boxSizing === 'content-box') {
    const borders = getPositionedStyle(style, 'border', 'width');
    const paddings = getPositionedStyle(style, 'padding');
    width -= paddings.width + borders.width;
    height -= paddings.height + borders.height;
  }
  width = Math.max(0, width - margins.width);
  height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
  width = round1(Math.min(width, maxWidth, containerSize.maxWidth));
  height = round1(Math.min(height, maxHeight, containerSize.maxHeight));
  if (width && !height) {
    // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = round1(width / 2);
  }
  const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
  if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
    height = containerSize.height;
    width = round1(Math.floor(height * aspectRatio));
  }
  return {
    width,
    height
  };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */
function retinaScale(chart, forceRatio, forceStyle) {
  const pixelRatio = forceRatio || 1;
  const deviceHeight = Math.floor(chart.height * pixelRatio);
  const deviceWidth = Math.floor(chart.width * pixelRatio);
  chart.height = Math.floor(chart.height);
  chart.width = Math.floor(chart.width);
  const canvas = chart.canvas;
  // If no style has been set on the canvas, the render size is used as display size,
  // making the chart visually bigger, so let's enforce it to the "correct" values.
  // See https://github.com/chartjs/Chart.js/issues/3575
  if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
    canvas.style.height = `${chart.height}px`;
    canvas.style.width = `${chart.width}px`;
  }
  if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
    chart.currentDevicePixelRatio = pixelRatio;
    canvas.height = deviceHeight;
    canvas.width = deviceWidth;
    chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    return true;
  }
  return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */
const supportsEventListenerOptions = function () {
  let passiveSupported = false;
  try {
    const options = {
      get passive() {
        passiveSupported = true;
        return false;
      }
    };
    if (_isDomSupported()) {
      window.addEventListener('test', null, options);
      window.removeEventListener('test', null, options);
    }
  } catch (e) {
    // continue regardless of error
  }
  return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */
function readUsedSize(element, property) {
  const value = getStyle(element, property);
  const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
  return matches ? +matches[1] : undefined;
}

/**
 * @private
 */
function _pointInLine(p1, p2, t, mode) {
  return {
    x: p1.x + t * (p2.x - p1.x),
    y: p1.y + t * (p2.y - p1.y)
  };
}
/**
 * @private
 */
function _steppedInterpolation(p1, p2, t, mode) {
  return {
    x: p1.x + t * (p2.x - p1.x),
    y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
  };
}
/**
 * @private
 */
function _bezierInterpolation(p1, p2, t, mode) {
  const cp1 = {
    x: p1.cp2x,
    y: p1.cp2y
  };
  const cp2 = {
    x: p2.cp1x,
    y: p2.cp1y
  };
  const a = _pointInLine(p1, cp1, t);
  const b = _pointInLine(cp1, cp2, t);
  const c = _pointInLine(cp2, p2, t);
  const d = _pointInLine(a, b, t);
  const e = _pointInLine(b, c, t);
  return _pointInLine(d, e, t);
}
const getRightToLeftAdapter = function (rectX, width) {
  return {
    x(x) {
      return rectX + rectX + width - x;
    },
    setWidth(w) {
      width = w;
    },
    textAlign(align) {
      if (align === 'center') {
        return align;
      }
      return align === 'right' ? 'left' : 'right';
    },
    xPlus(x, value) {
      return x - value;
    },
    leftForLtr(x, itemWidth) {
      return x - itemWidth;
    }
  };
};
const getLeftToRightAdapter = function () {
  return {
    x(x) {
      return x;
    },
    setWidth(w) {},
    textAlign(align) {
      return align;
    },
    xPlus(x, value) {
      return x + value;
    },
    leftForLtr(x, _itemWidth) {
      return x;
    }
  };
};
function getRtlAdapter(rtl, rectX, width) {
  return rtl ? getRightToLeftAdapter(rectX, width) : getLeftToRightAdapter();
}
function overrideTextDirection(ctx, direction) {
  let style, original;
  if (direction === 'ltr' || direction === 'rtl') {
    style = ctx.canvas.style;
    original = [style.getPropertyValue('direction'), style.getPropertyPriority('direction')];
    style.setProperty('direction', direction, 'important');
    ctx.prevTextDirection = original;
  }
}
function restoreTextDirection(ctx, original) {
  if (original !== undefined) {
    delete ctx.prevTextDirection;
    ctx.canvas.style.setProperty('direction', original[0], original[1]);
  }
}
function propertyFn(property) {
  if (property === 'angle') {
    return {
      between: _angleBetween,
      compare: _angleDiff,
      normalize: _normalizeAngle
    };
  }
  return {
    between: _isBetween,
    compare: (a, b) => a - b,
    normalize: x => x
  };
}
function normalizeSegment({
  start,
  end,
  count,
  loop,
  style
}) {
  return {
    start: start % count,
    end: end % count,
    loop: loop && (end - start + 1) % count === 0,
    style
  };
}
function getSegment(segment, points, bounds) {
  const {
    property,
    start: startBound,
    end: endBound
  } = bounds;
  const {
    between,
    normalize
  } = propertyFn(property);
  const count = points.length;
  let {
    start,
    end,
    loop
  } = segment;
  let i, ilen;
  if (loop) {
    start += count;
    end += count;
    for (i = 0, ilen = count; i < ilen; ++i) {
      if (!between(normalize(points[start % count][property]), startBound, endBound)) {
        break;
      }
      start--;
      end--;
    }
    start %= count;
    end %= count;
  }
  if (end < start) {
    end += count;
  }
  return {
    start,
    end,
    loop,
    style: segment.style
  };
}
function _boundSegment(segment, points, bounds) {
  if (!bounds) {
    return [segment];
  }
  const {
    property,
    start: startBound,
    end: endBound
  } = bounds;
  const count = points.length;
  const {
    compare,
    between,
    normalize
  } = propertyFn(property);
  const {
    start,
    end,
    loop,
    style
  } = getSegment(segment, points, bounds);
  const result = [];
  let inside = false;
  let subStart = null;
  let value, point, prevValue;
  const startIsBefore = () => between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
  const endIsBefore = () => compare(endBound, value) === 0 || between(endBound, prevValue, value);
  const shouldStart = () => inside || startIsBefore();
  const shouldStop = () => !inside || endIsBefore();
  for (let i = start, prev = start; i <= end; ++i) {
    point = points[i % count];
    if (point.skip) {
      continue;
    }
    value = normalize(point[property]);
    if (value === prevValue) {
      continue;
    }
    inside = between(value, startBound, endBound);
    if (subStart === null && shouldStart()) {
      subStart = compare(value, startBound) === 0 ? i : prev;
    }
    if (subStart !== null && shouldStop()) {
      result.push(normalizeSegment({
        start: subStart,
        end: i,
        loop,
        count,
        style
      }));
      subStart = null;
    }
    prev = i;
    prevValue = value;
  }
  if (subStart !== null) {
    result.push(normalizeSegment({
      start: subStart,
      end,
      loop,
      count,
      style
    }));
  }
  return result;
}
function _boundSegments(line, bounds) {
  const result = [];
  const segments = line.segments;
  for (let i = 0; i < segments.length; i++) {
    const sub = _boundSegment(segments[i], line.points, bounds);
    if (sub.length) {
      result.push(...sub);
    }
  }
  return result;
}
function findStartAndEnd(points, count, loop, spanGaps) {
  let start = 0;
  let end = count - 1;
  if (loop && !spanGaps) {
    while (start < count && !points[start].skip) {
      start++;
    }
  }
  while (start < count && points[start].skip) {
    start++;
  }
  start %= count;
  if (loop) {
    end += start;
  }
  while (end > start && points[end % count].skip) {
    end--;
  }
  end %= count;
  return {
    start,
    end
  };
}
function solidSegments(points, start, max, loop) {
  const count = points.length;
  const result = [];
  let last = start;
  let prev = points[start];
  let end;
  for (end = start + 1; end <= max; ++end) {
    const cur = points[end % count];
    if (cur.skip || cur.stop) {
      if (!prev.skip) {
        loop = false;
        result.push({
          start: start % count,
          end: (end - 1) % count,
          loop
        });
        start = last = cur.stop ? end : null;
      }
    } else {
      last = end;
      if (prev.skip) {
        start = end;
      }
    }
    prev = cur;
  }
  if (last !== null) {
    result.push({
      start: start % count,
      end: last % count,
      loop
    });
  }
  return result;
}
function _computeSegments(line, segmentOptions) {
  const points = line.points;
  const spanGaps = line.options.spanGaps;
  const count = points.length;
  if (!count) {
    return [];
  }
  const loop = !!line._loop;
  const {
    start,
    end
  } = findStartAndEnd(points, count, loop, spanGaps);
  if (spanGaps === true) {
    return splitByStyles(line, [{
      start,
      end,
      loop
    }], points, segmentOptions);
  }
  const max = end < start ? end + count : end;
  const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
  return splitByStyles(line, solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function splitByStyles(line, segments, points, segmentOptions) {
  if (!segmentOptions || !segmentOptions.setContext || !points) {
    return segments;
  }
  return doSplitByStyles(line, segments, points, segmentOptions);
}
function doSplitByStyles(line, segments, points, segmentOptions) {
  const chartContext = line._chart.getContext();
  const baseStyle = readStyle(line.options);
  const {
    _datasetIndex: datasetIndex,
    options: {
      spanGaps
    }
  } = line;
  const count = points.length;
  const result = [];
  let prevStyle = baseStyle;
  let start = segments[0].start;
  let i = start;
  function addStyle(s, e, l, st) {
    const dir = spanGaps ? -1 : 1;
    if (s === e) {
      return;
    }
    s += count;
    while (points[s % count].skip) {
      s -= dir;
    }
    while (points[e % count].skip) {
      e += dir;
    }
    if (s % count !== e % count) {
      result.push({
        start: s % count,
        end: e % count,
        loop: l,
        style: st
      });
      prevStyle = st;
      start = e % count;
    }
  }
  for (const segment of segments) {
    start = spanGaps ? start : segment.start;
    let prev = points[start % count];
    let style;
    for (i = start + 1; i <= segment.end; i++) {
      const pt = points[i % count];
      style = readStyle(segmentOptions.setContext(createContext(chartContext, {
        type: 'segment',
        p0: prev,
        p1: pt,
        p0DataIndex: (i - 1) % count,
        p1DataIndex: i % count,
        datasetIndex
      })));
      if (styleChanged(style, prevStyle)) {
        addStyle(start, i - 1, segment.loop, prevStyle);
      }
      prev = pt;
      prevStyle = style;
    }
    if (start < i - 1) {
      addStyle(start, i - 1, segment.loop, prevStyle);
    }
  }
  return result;
}
function readStyle(options) {
  return {
    backgroundColor: options.backgroundColor,
    borderCapStyle: options.borderCapStyle,
    borderDash: options.borderDash,
    borderDashOffset: options.borderDashOffset,
    borderJoinStyle: options.borderJoinStyle,
    borderWidth: options.borderWidth,
    borderColor: options.borderColor
  };
}
function styleChanged(style, prevStyle) {
  if (!prevStyle) {
    return false;
  }
  const cache = [];
  const replacer = function (key, value) {
    if (!isPatternOrGradient(value)) {
      return value;
    }
    if (!cache.includes(value)) {
      cache.push(value);
    }
    return cache.indexOf(value);
  };
  return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}

class Animator {
  constructor() {
    this._request = null;
    this._charts = new Map();
    this._running = false;
    this._lastDate = undefined;
  }
  _notify(chart, anims, date, type) {
    const callbacks = anims.listeners[type];
    const numSteps = anims.duration;
    callbacks.forEach(fn => fn({
      chart,
      initial: anims.initial,
      numSteps,
      currentStep: Math.min(date - anims.start, numSteps)
    }));
  }
  _refresh() {
    if (this._request) {
      return;
    }
    this._running = true;
    this._request = requestAnimFrame.call(window, () => {
      this._update();
      this._request = null;
      if (this._running) {
        this._refresh();
      }
    });
  }
  _update(date = Date.now()) {
    let remaining = 0;
    this._charts.forEach((anims, chart) => {
      if (!anims.running || !anims.items.length) {
        return;
      }
      const items = anims.items;
      let i = items.length - 1;
      let draw = false;
      let item;
      for (; i >= 0; --i) {
        item = items[i];
        if (item._active) {
          if (item._total > anims.duration) {
            anims.duration = item._total;
          }
          item.tick(date);
          draw = true;
        } else {
          items[i] = items[items.length - 1];
          items.pop();
        }
      }
      if (draw) {
        chart.draw();
        this._notify(chart, anims, date, 'progress');
      }
      if (!items.length) {
        anims.running = false;
        this._notify(chart, anims, date, 'complete');
        anims.initial = false;
      }
      remaining += items.length;
    });
    this._lastDate = date;
    if (remaining === 0) {
      this._running = false;
    }
  }
  _getAnims(chart) {
    const charts = this._charts;
    let anims = charts.get(chart);
    if (!anims) {
      anims = {
        running: false,
        initial: true,
        items: [],
        listeners: {
          complete: [],
          progress: []
        }
      };
      charts.set(chart, anims);
    }
    return anims;
  }
  listen(chart, event, cb) {
    this._getAnims(chart).listeners[event].push(cb);
  }
  add(chart, items) {
    if (!items || !items.length) {
      return;
    }
    this._getAnims(chart).items.push(...items);
  }
  has(chart) {
    return this._getAnims(chart).items.length > 0;
  }
  start(chart) {
    const anims = this._charts.get(chart);
    if (!anims) {
      return;
    }
    anims.running = true;
    anims.start = Date.now();
    anims.duration = anims.items.reduce((acc, cur) => Math.max(acc, cur._duration), 0);
    this._refresh();
  }
  running(chart) {
    if (!this._running) {
      return false;
    }
    const anims = this._charts.get(chart);
    if (!anims || !anims.running || !anims.items.length) {
      return false;
    }
    return true;
  }
  stop(chart) {
    const anims = this._charts.get(chart);
    if (!anims || !anims.items.length) {
      return;
    }
    const items = anims.items;
    let i = items.length - 1;
    for (; i >= 0; --i) {
      items[i].cancel();
    }
    anims.items = [];
    this._notify(chart, anims, Date.now(), 'complete');
  }
  remove(chart) {
    return this._charts.delete(chart);
  }
}
var animator = /* #__PURE__ */new Animator();
const transparent = 'transparent';
const interpolators = {
  boolean(from, to, factor) {
    return factor > 0.5 ? to : from;
  },
  color(from, to, factor) {
    const c0 = color(from || transparent);
    const c1 = c0.valid && color(to || transparent);
    return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
  },
  number(from, to, factor) {
    return from + (to - from) * factor;
  }
};
class Animation$1 {
  constructor(cfg, target, prop, to) {
    const currentValue = target[prop];
    to = resolve([cfg.to, to, currentValue, cfg.from]);
    const from = resolve([cfg.from, currentValue, to]);
    this._active = true;
    this._fn = cfg.fn || interpolators[cfg.type || typeof from];
    this._easing = effects[cfg.easing] || effects.linear;
    this._start = Math.floor(Date.now() + (cfg.delay || 0));
    this._duration = this._total = Math.floor(cfg.duration);
    this._loop = !!cfg.loop;
    this._target = target;
    this._prop = prop;
    this._from = from;
    this._to = to;
    this._promises = undefined;
  }
  active() {
    return this._active;
  }
  update(cfg, to, date) {
    if (this._active) {
      this._notify(false);
      const currentValue = this._target[this._prop];
      const elapsed = date - this._start;
      const remain = this._duration - elapsed;
      this._start = date;
      this._duration = Math.floor(Math.max(remain, cfg.duration));
      this._total += elapsed;
      this._loop = !!cfg.loop;
      this._to = resolve([cfg.to, to, currentValue, cfg.from]);
      this._from = resolve([cfg.from, currentValue, to]);
    }
  }
  cancel() {
    if (this._active) {
      this.tick(Date.now());
      this._active = false;
      this._notify(false);
    }
  }
  tick(date) {
    const elapsed = date - this._start;
    const duration = this._duration;
    const prop = this._prop;
    const from = this._from;
    const loop = this._loop;
    const to = this._to;
    let factor;
    this._active = from !== to && (loop || elapsed < duration);
    if (!this._active) {
      this._target[prop] = to;
      this._notify(true);
      return;
    }
    if (elapsed < 0) {
      this._target[prop] = from;
      return;
    }
    factor = elapsed / duration % 2;
    factor = loop && factor > 1 ? 2 - factor : factor;
    factor = this._easing(Math.min(1, Math.max(0, factor)));
    this._target[prop] = this._fn(from, to, factor);
  }
  wait() {
    const promises = this._promises || (this._promises = []);
    return new Promise((res, rej) => {
      promises.push({
        res,
        rej
      });
    });
  }
  _notify(resolved) {
    const method = resolved ? 'res' : 'rej';
    const promises = this._promises || [];
    for (let i = 0; i < promises.length; i++) {
      promises[i][method]();
    }
  }
}
class Animations {
  constructor(chart, config) {
    this._chart = chart;
    this._properties = new Map();
    this.configure(config);
  }
  configure(config) {
    if (!isObject(config)) {
      return;
    }
    const animationOptions = Object.keys(defaults.animation);
    const animatedProps = this._properties;
    Object.getOwnPropertyNames(config).forEach(key => {
      const cfg = config[key];
      if (!isObject(cfg)) {
        return;
      }
      const resolved = {};
      for (const option of animationOptions) {
        resolved[option] = cfg[option];
      }
      (isArray(cfg.properties) && cfg.properties || [key]).forEach(prop => {
        if (prop === key || !animatedProps.has(prop)) {
          animatedProps.set(prop, resolved);
        }
      });
    });
  }
  _animateOptions(target, values) {
    const newOptions = values.options;
    const options = resolveTargetOptions(target, newOptions);
    if (!options) {
      return [];
    }
    const animations = this._createAnimations(options, newOptions);
    if (newOptions.$shared) {
      awaitAll(target.options.$animations, newOptions).then(() => {
        target.options = newOptions;
      }, () => {});
    }
    return animations;
  }
  _createAnimations(target, values) {
    const animatedProps = this._properties;
    const animations = [];
    const running = target.$animations || (target.$animations = {});
    const props = Object.keys(values);
    const date = Date.now();
    let i;
    for (i = props.length - 1; i >= 0; --i) {
      const prop = props[i];
      if (prop.charAt(0) === '$') {
        continue;
      }
      if (prop === 'options') {
        animations.push(...this._animateOptions(target, values));
        continue;
      }
      const value = values[prop];
      let animation = running[prop];
      const cfg = animatedProps.get(prop);
      if (animation) {
        if (cfg && animation.active()) {
          animation.update(cfg, value, date);
          continue;
        } else {
          animation.cancel();
        }
      }
      if (!cfg || !cfg.duration) {
        target[prop] = value;
        continue;
      }
      running[prop] = animation = new Animation$1(cfg, target, prop, value);
      animations.push(animation);
    }
    return animations;
  }
  update(target, values) {
    if (this._properties.size === 0) {
      Object.assign(target, values);
      return;
    }
    const animations = this._createAnimations(target, values);
    if (animations.length) {
      animator.add(this._chart, animations);
      return true;
    }
  }
}
function awaitAll(animations, properties) {
  const running = [];
  const keys = Object.keys(properties);
  for (let i = 0; i < keys.length; i++) {
    const anim = animations[keys[i]];
    if (anim && anim.active()) {
      running.push(anim.wait());
    }
  }
  return Promise.all(running);
}
function resolveTargetOptions(target, newOptions) {
  if (!newOptions) {
    return;
  }
  let options = target.options;
  if (!options) {
    target.options = newOptions;
    return;
  }
  if (options.$shared) {
    target.options = options = Object.assign({}, options, {
      $shared: false,
      $animations: {}
    });
  }
  return options;
}
function scaleClip(scale, allowedOverflow) {
  const opts = scale && scale.options || {};
  const reverse = opts.reverse;
  const min = opts.min === undefined ? allowedOverflow : 0;
  const max = opts.max === undefined ? allowedOverflow : 0;
  return {
    start: reverse ? max : min,
    end: reverse ? min : max
  };
}
function defaultClip(xScale, yScale, allowedOverflow) {
  if (allowedOverflow === false) {
    return false;
  }
  const x = scaleClip(xScale, allowedOverflow);
  const y = scaleClip(yScale, allowedOverflow);
  return {
    top: y.end,
    right: x.end,
    bottom: y.start,
    left: x.start
  };
}
function toClip(value) {
  let t, r, b, l;
  if (isObject(value)) {
    t = value.top;
    r = value.right;
    b = value.bottom;
    l = value.left;
  } else {
    t = r = b = l = value;
  }
  return {
    top: t,
    right: r,
    bottom: b,
    left: l,
    disabled: value === false
  };
}
function getSortedDatasetIndices(chart, filterVisible) {
  const keys = [];
  const metasets = chart._getSortedDatasetMetas(filterVisible);
  let i, ilen;
  for (i = 0, ilen = metasets.length; i < ilen; ++i) {
    keys.push(metasets[i].index);
  }
  return keys;
}
function applyStack(stack, value, dsIndex, options = {}) {
  const keys = stack.keys;
  const singleMode = options.mode === 'single';
  let i, ilen, datasetIndex, otherValue;
  if (value === null) {
    return;
  }
  let found = false;
  for (i = 0, ilen = keys.length; i < ilen; ++i) {
    datasetIndex = +keys[i];
    if (datasetIndex === dsIndex) {
      found = true;
      if (options.all) {
        continue;
      }
      break;
    }
    otherValue = stack.values[datasetIndex];
    if (isNumberFinite(otherValue) && (singleMode || value === 0 || sign(value) === sign(otherValue))) {
      value += otherValue;
    }
  }
  if (!found && !options.all) {
    return 0;
  }
  return value;
}
function convertObjectDataToArray(data, meta) {
  const {
    iScale,
    vScale
  } = meta;
  const iAxisKey = iScale.axis === 'x' ? 'x' : 'y';
  const vAxisKey = vScale.axis === 'x' ? 'x' : 'y';
  const keys = Object.keys(data);
  const adata = new Array(keys.length);
  let i, ilen, key;
  for (i = 0, ilen = keys.length; i < ilen; ++i) {
    key = keys[i];
    adata[i] = {
      [iAxisKey]: key,
      [vAxisKey]: data[key]
    };
  }
  return adata;
}
function isStacked(scale, meta) {
  const stacked = scale && scale.options.stacked;
  return stacked || stacked === undefined && meta.stack !== undefined;
}
function getStackKey(indexScale, valueScale, meta) {
  return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function getUserBounds(scale) {
  const {
    min,
    max,
    minDefined,
    maxDefined
  } = scale.getUserBounds();
  return {
    min: minDefined ? min : Number.NEGATIVE_INFINITY,
    max: maxDefined ? max : Number.POSITIVE_INFINITY
  };
}
function getOrCreateStack(stacks, stackKey, indexValue) {
  const subStack = stacks[stackKey] || (stacks[stackKey] = {});
  return subStack[indexValue] || (subStack[indexValue] = {});
}
function getLastIndexInStack(stack, vScale, positive, type) {
  for (const meta of vScale.getMatchingVisibleMetas(type).reverse()) {
    const value = stack[meta.index];
    if (positive && value > 0 || !positive && value < 0) {
      return meta.index;
    }
  }
  return null;
}
function updateStacks(controller, parsed) {
  const {
    chart,
    _cachedMeta: meta
  } = controller;
  const stacks = chart._stacks || (chart._stacks = {});
  const {
    iScale,
    vScale,
    index: datasetIndex
  } = meta;
  const iAxis = iScale.axis;
  const vAxis = vScale.axis;
  const key = getStackKey(iScale, vScale, meta);
  const ilen = parsed.length;
  let stack;
  for (let i = 0; i < ilen; ++i) {
    const item = parsed[i];
    const {
      [iAxis]: index,
      [vAxis]: value
    } = item;
    const itemStacks = item._stacks || (item._stacks = {});
    stack = itemStacks[vAxis] = getOrCreateStack(stacks, key, index);
    stack[datasetIndex] = value;
    stack._top = getLastIndexInStack(stack, vScale, true, meta.type);
    stack._bottom = getLastIndexInStack(stack, vScale, false, meta.type);
    const visualValues = stack._visualValues || (stack._visualValues = {});
    visualValues[datasetIndex] = value;
  }
}
function getFirstScaleId(chart, axis) {
  const scales = chart.scales;
  return Object.keys(scales).filter(key => scales[key].axis === axis).shift();
}
function createDatasetContext(parent, index) {
  return createContext(parent, {
    active: false,
    dataset: undefined,
    datasetIndex: index,
    index,
    mode: 'default',
    type: 'dataset'
  });
}
function createDataContext(parent, index, element) {
  return createContext(parent, {
    active: false,
    dataIndex: index,
    parsed: undefined,
    raw: undefined,
    element,
    index,
    mode: 'default',
    type: 'data'
  });
}
function clearStacks(meta, items) {
  const datasetIndex = meta.controller.index;
  const axis = meta.vScale && meta.vScale.axis;
  if (!axis) {
    return;
  }
  items = items || meta._parsed;
  for (const parsed of items) {
    const stacks = parsed._stacks;
    if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) {
      return;
    }
    delete stacks[axis][datasetIndex];
    if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) {
      delete stacks[axis]._visualValues[datasetIndex];
    }
  }
}
const isDirectUpdateMode = mode => mode === 'reset' || mode === 'none';
const cloneIfNotShared = (cached, shared) => shared ? cached : Object.assign({}, cached);
const createStack = (canStack, meta, chart) => canStack && !meta.hidden && meta._stacked && {
  keys: getSortedDatasetIndices(chart, true),
  values: null
};
class DatasetController {
  constructor(chart, datasetIndex) {
    this.chart = chart;
    this._ctx = chart.ctx;
    this.index = datasetIndex;
    this._cachedDataOpts = {};
    this._cachedMeta = this.getMeta();
    this._type = this._cachedMeta.type;
    this.options = undefined;
    this._parsing = false;
    this._data = undefined;
    this._objectData = undefined;
    this._sharedOptions = undefined;
    this._drawStart = undefined;
    this._drawCount = undefined;
    this.enableOptionSharing = false;
    this.supportsDecimation = false;
    this.$context = undefined;
    this._syncList = [];
    this.datasetElementType = new.target.datasetElementType;
    this.dataElementType = new.target.dataElementType;
    this.initialize();
  }
  initialize() {
    const meta = this._cachedMeta;
    this.configure();
    this.linkScales();
    meta._stacked = isStacked(meta.vScale, meta);
    this.addElements();
    if (this.options.fill && !this.chart.isPluginEnabled('filler')) {
      console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
  }
  updateIndex(datasetIndex) {
    if (this.index !== datasetIndex) {
      clearStacks(this._cachedMeta);
    }
    this.index = datasetIndex;
  }
  linkScales() {
    const chart = this.chart;
    const meta = this._cachedMeta;
    const dataset = this.getDataset();
    const chooseId = (axis, x, y, r) => axis === 'x' ? x : axis === 'r' ? r : y;
    const xid = meta.xAxisID = valueOrDefault(dataset.xAxisID, getFirstScaleId(chart, 'x'));
    const yid = meta.yAxisID = valueOrDefault(dataset.yAxisID, getFirstScaleId(chart, 'y'));
    const rid = meta.rAxisID = valueOrDefault(dataset.rAxisID, getFirstScaleId(chart, 'r'));
    const indexAxis = meta.indexAxis;
    const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
    const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
    meta.xScale = this.getScaleForId(xid);
    meta.yScale = this.getScaleForId(yid);
    meta.rScale = this.getScaleForId(rid);
    meta.iScale = this.getScaleForId(iid);
    meta.vScale = this.getScaleForId(vid);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(scaleID) {
    return this.chart.scales[scaleID];
  }
  _getOtherScale(scale) {
    const meta = this._cachedMeta;
    return scale === meta.iScale ? meta.vScale : meta.iScale;
  }
  reset() {
    this._update('reset');
  }
  _destroy() {
    const meta = this._cachedMeta;
    if (this._data) {
      unlistenArrayEvents(this._data, this);
    }
    if (meta._stacked) {
      clearStacks(meta);
    }
  }
  _dataCheck() {
    const dataset = this.getDataset();
    const data = dataset.data || (dataset.data = []);
    const _data = this._data;
    if (isObject(data)) {
      const meta = this._cachedMeta;
      this._data = convertObjectDataToArray(data, meta);
    } else if (_data !== data) {
      if (_data) {
        unlistenArrayEvents(_data, this);
        const meta = this._cachedMeta;
        clearStacks(meta);
        meta._parsed = [];
      }
      if (data && Object.isExtensible(data)) {
        listenArrayEvents(data, this);
      }
      this._syncList = [];
      this._data = data;
    }
  }
  addElements() {
    const meta = this._cachedMeta;
    this._dataCheck();
    if (this.datasetElementType) {
      meta.dataset = new this.datasetElementType();
    }
  }
  buildOrUpdateElements(resetNewElements) {
    const meta = this._cachedMeta;
    const dataset = this.getDataset();
    let stackChanged = false;
    this._dataCheck();
    const oldStacked = meta._stacked;
    meta._stacked = isStacked(meta.vScale, meta);
    if (meta.stack !== dataset.stack) {
      stackChanged = true;
      clearStacks(meta);
      meta.stack = dataset.stack;
    }
    this._resyncElements(resetNewElements);
    if (stackChanged || oldStacked !== meta._stacked) {
      updateStacks(this, meta._parsed);
      meta._stacked = isStacked(meta.vScale, meta);
    }
  }
  configure() {
    const config = this.chart.config;
    const scopeKeys = config.datasetScopeKeys(this._type);
    const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
    this.options = config.createResolver(scopes, this.getContext());
    this._parsing = this.options.parsing;
    this._cachedDataOpts = {};
  }
  parse(start, count) {
    const {
      _cachedMeta: meta,
      _data: data
    } = this;
    const {
      iScale,
      _stacked
    } = meta;
    const iAxis = iScale.axis;
    let sorted = start === 0 && count === data.length ? true : meta._sorted;
    let prev = start > 0 && meta._parsed[start - 1];
    let i, cur, parsed;
    if (this._parsing === false) {
      meta._parsed = data;
      meta._sorted = true;
      parsed = data;
    } else {
      if (isArray(data[start])) {
        parsed = this.parseArrayData(meta, data, start, count);
      } else if (isObject(data[start])) {
        parsed = this.parseObjectData(meta, data, start, count);
      } else {
        parsed = this.parsePrimitiveData(meta, data, start, count);
      }
      const isNotInOrderComparedToPrev = () => cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
      for (i = 0; i < count; ++i) {
        meta._parsed[i + start] = cur = parsed[i];
        if (sorted) {
          if (isNotInOrderComparedToPrev()) {
            sorted = false;
          }
          prev = cur;
        }
      }
      meta._sorted = sorted;
    }
    if (_stacked) {
      updateStacks(this, parsed);
    }
  }
  parsePrimitiveData(meta, data, start, count) {
    const {
      iScale,
      vScale
    } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = new Array(count);
    let i, ilen, index;
    for (i = 0, ilen = count; i < ilen; ++i) {
      index = i + start;
      parsed[i] = {
        [iAxis]: singleScale || iScale.parse(labels[index], index),
        [vAxis]: vScale.parse(data[index], index)
      };
    }
    return parsed;
  }
  parseArrayData(meta, data, start, count) {
    const {
      xScale,
      yScale
    } = meta;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for (i = 0, ilen = count; i < ilen; ++i) {
      index = i + start;
      item = data[index];
      parsed[i] = {
        x: xScale.parse(item[0], index),
        y: yScale.parse(item[1], index)
      };
    }
    return parsed;
  }
  parseObjectData(meta, data, start, count) {
    const {
      xScale,
      yScale
    } = meta;
    const {
      xAxisKey = 'x',
      yAxisKey = 'y'
    } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for (i = 0, ilen = count; i < ilen; ++i) {
      index = i + start;
      item = data[index];
      parsed[i] = {
        x: xScale.parse(resolveObjectKey(item, xAxisKey), index),
        y: yScale.parse(resolveObjectKey(item, yAxisKey), index)
      };
    }
    return parsed;
  }
  getParsed(index) {
    return this._cachedMeta._parsed[index];
  }
  getDataElement(index) {
    return this._cachedMeta.data[index];
  }
  applyStack(scale, parsed, mode) {
    const chart = this.chart;
    const meta = this._cachedMeta;
    const value = parsed[scale.axis];
    const stack = {
      keys: getSortedDatasetIndices(chart, true),
      values: parsed._stacks[scale.axis]._visualValues
    };
    return applyStack(stack, value, meta.index, {
      mode
    });
  }
  updateRangeFromParsed(range, scale, parsed, stack) {
    const parsedValue = parsed[scale.axis];
    let value = parsedValue === null ? NaN : parsedValue;
    const values = stack && parsed._stacks[scale.axis];
    if (stack && values) {
      stack.values = values;
      value = applyStack(stack, parsedValue, this._cachedMeta.index);
    }
    range.min = Math.min(range.min, value);
    range.max = Math.max(range.max, value);
  }
  getMinMax(scale, canStack) {
    const meta = this._cachedMeta;
    const _parsed = meta._parsed;
    const sorted = meta._sorted && scale === meta.iScale;
    const ilen = _parsed.length;
    const otherScale = this._getOtherScale(scale);
    const stack = createStack(canStack, meta, this.chart);
    const range = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    };
    const {
      min: otherMin,
      max: otherMax
    } = getUserBounds(otherScale);
    let i, parsed;
    function _skip() {
      parsed = _parsed[i];
      const otherValue = parsed[otherScale.axis];
      return !isNumberFinite(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
    }
    for (i = 0; i < ilen; ++i) {
      if (_skip()) {
        continue;
      }
      this.updateRangeFromParsed(range, scale, parsed, stack);
      if (sorted) {
        break;
      }
    }
    if (sorted) {
      for (i = ilen - 1; i >= 0; --i) {
        if (_skip()) {
          continue;
        }
        this.updateRangeFromParsed(range, scale, parsed, stack);
        break;
      }
    }
    return range;
  }
  getAllParsedValues(scale) {
    const parsed = this._cachedMeta._parsed;
    const values = [];
    let i, ilen, value;
    for (i = 0, ilen = parsed.length; i < ilen; ++i) {
      value = parsed[i][scale.axis];
      if (isNumberFinite(value)) {
        values.push(value);
      }
    }
    return values;
  }
  getMaxOverflow() {
    return false;
  }
  getLabelAndValue(index) {
    const meta = this._cachedMeta;
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const parsed = this.getParsed(index);
    return {
      label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
      value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
    };
  }
  _update(mode) {
    const meta = this._cachedMeta;
    this.update(mode || 'default');
    meta._clip = toClip(valueOrDefault(this.options.clip, defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
  }
  update(mode) {}
  draw() {
    const ctx = this._ctx;
    const chart = this.chart;
    const meta = this._cachedMeta;
    const elements = meta.data || [];
    const area = chart.chartArea;
    const active = [];
    const start = this._drawStart || 0;
    const count = this._drawCount || elements.length - start;
    const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
    let i;
    if (meta.dataset) {
      meta.dataset.draw(ctx, area, start, count);
    }
    for (i = start; i < start + count; ++i) {
      const element = elements[i];
      if (element.hidden) {
        continue;
      }
      if (element.active && drawActiveElementsOnTop) {
        active.push(element);
      } else {
        element.draw(ctx, area);
      }
    }
    for (i = 0; i < active.length; ++i) {
      active[i].draw(ctx, area);
    }
  }
  getStyle(index, active) {
    const mode = active ? 'active' : 'default';
    return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
  }
  getContext(index, active, mode) {
    const dataset = this.getDataset();
    let context;
    if (index >= 0 && index < this._cachedMeta.data.length) {
      const element = this._cachedMeta.data[index];
      context = element.$context || (element.$context = createDataContext(this.getContext(), index, element));
      context.parsed = this.getParsed(index);
      context.raw = dataset.data[index];
      context.index = context.dataIndex = index;
    } else {
      context = this.$context || (this.$context = createDatasetContext(this.chart.getContext(), this.index));
      context.dataset = dataset;
      context.index = context.datasetIndex = this.index;
    }
    context.active = !!active;
    context.mode = mode;
    return context;
  }
  resolveDatasetElementOptions(mode) {
    return this._resolveElementOptions(this.datasetElementType.id, mode);
  }
  resolveDataElementOptions(index, mode) {
    return this._resolveElementOptions(this.dataElementType.id, mode, index);
  }
  _resolveElementOptions(elementType, mode = 'default', index) {
    const active = mode === 'active';
    const cache = this._cachedDataOpts;
    const cacheKey = elementType + '-' + mode;
    const cached = cache[cacheKey];
    const sharing = this.enableOptionSharing && defined(index);
    if (cached) {
      return cloneIfNotShared(cached, sharing);
    }
    const config = this.chart.config;
    const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
    const prefixes = active ? [`${elementType}Hover`, 'hover', elementType, ''] : [elementType, ''];
    const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
    const names = Object.keys(defaults.elements[elementType]);
    const context = () => this.getContext(index, active, mode);
    const values = config.resolveNamedOptions(scopes, names, context, prefixes);
    if (values.$shared) {
      values.$shared = sharing;
      cache[cacheKey] = Object.freeze(cloneIfNotShared(values, sharing));
    }
    return values;
  }
  _resolveAnimations(index, transition, active) {
    const chart = this.chart;
    const cache = this._cachedDataOpts;
    const cacheKey = `animation-${transition}`;
    const cached = cache[cacheKey];
    if (cached) {
      return cached;
    }
    let options;
    if (chart.options.animation !== false) {
      const config = this.chart.config;
      const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
      const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
      options = config.createResolver(scopes, this.getContext(index, active, transition));
    }
    const animations = new Animations(chart, options && options.animations);
    if (options && options._cacheable) {
      cache[cacheKey] = Object.freeze(animations);
    }
    return animations;
  }
  getSharedOptions(options) {
    if (!options.$shared) {
      return;
    }
    return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
  }
  includeOptions(mode, sharedOptions) {
    return !sharedOptions || isDirectUpdateMode(mode) || this.chart._animationsDisabled;
  }
  _getSharedOptions(start, mode) {
    const firstOpts = this.resolveDataElementOptions(start, mode);
    const previouslySharedOptions = this._sharedOptions;
    const sharedOptions = this.getSharedOptions(firstOpts);
    const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
    this.updateSharedOptions(sharedOptions, mode, firstOpts);
    return {
      sharedOptions,
      includeOptions
    };
  }
  updateElement(element, index, properties, mode) {
    if (isDirectUpdateMode(mode)) {
      Object.assign(element, properties);
    } else {
      this._resolveAnimations(index, mode).update(element, properties);
    }
  }
  updateSharedOptions(sharedOptions, mode, newOptions) {
    if (sharedOptions && !isDirectUpdateMode(mode)) {
      this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
  }
  _setStyle(element, index, mode, active) {
    element.active = active;
    const options = this.getStyle(index, active);
    this._resolveAnimations(index, mode, active).update(element, {
      options: !active && this.getSharedOptions(options) || options
    });
  }
  removeHoverStyle(element, datasetIndex, index) {
    this._setStyle(element, index, 'active', false);
  }
  setHoverStyle(element, datasetIndex, index) {
    this._setStyle(element, index, 'active', true);
  }
  _removeDatasetHoverStyle() {
    const element = this._cachedMeta.dataset;
    if (element) {
      this._setStyle(element, undefined, 'active', false);
    }
  }
  _setDatasetHoverStyle() {
    const element = this._cachedMeta.dataset;
    if (element) {
      this._setStyle(element, undefined, 'active', true);
    }
  }
  _resyncElements(resetNewElements) {
    const data = this._data;
    const elements = this._cachedMeta.data;
    for (const [method, arg1, arg2] of this._syncList) {
      this[method](arg1, arg2);
    }
    this._syncList = [];
    const numMeta = elements.length;
    const numData = data.length;
    const count = Math.min(numData, numMeta);
    if (count) {
      this.parse(0, count);
    }
    if (numData > numMeta) {
      this._insertElements(numMeta, numData - numMeta, resetNewElements);
    } else if (numData < numMeta) {
      this._removeElements(numData, numMeta - numData);
    }
  }
  _insertElements(start, count, resetNewElements = true) {
    const meta = this._cachedMeta;
    const data = meta.data;
    const end = start + count;
    let i;
    const move = arr => {
      arr.length += count;
      for (i = arr.length - 1; i >= end; i--) {
        arr[i] = arr[i - count];
      }
    };
    move(data);
    for (i = start; i < end; ++i) {
      data[i] = new this.dataElementType();
    }
    if (this._parsing) {
      move(meta._parsed);
    }
    this.parse(start, count);
    if (resetNewElements) {
      this.updateElements(data, start, count, 'reset');
    }
  }
  updateElements(element, start, count, mode) {}
  _removeElements(start, count) {
    const meta = this._cachedMeta;
    if (this._parsing) {
      const removed = meta._parsed.splice(start, count);
      if (meta._stacked) {
        clearStacks(meta, removed);
      }
    }
    meta.data.splice(start, count);
  }
  _sync(args) {
    if (this._parsing) {
      this._syncList.push(args);
    } else {
      const [method, arg1, arg2] = args;
      this[method](arg1, arg2);
    }
    this.chart._dataChanges.push([this.index, ...args]);
  }
  _onDataPush() {
    const count = arguments.length;
    this._sync(['_insertElements', this.getDataset().data.length - count, count]);
  }
  _onDataPop() {
    this._sync(['_removeElements', this._cachedMeta.data.length - 1, 1]);
  }
  _onDataShift() {
    this._sync(['_removeElements', 0, 1]);
  }
  _onDataSplice(start, count) {
    if (count) {
      this._sync(['_removeElements', start, count]);
    }
    const newCount = arguments.length - 2;
    if (newCount) {
      this._sync(['_insertElements', start, newCount]);
    }
  }
  _onDataUnshift() {
    this._sync(['_insertElements', 0, arguments.length]);
  }
}
_defineProperty(DatasetController, "defaults", {});
_defineProperty(DatasetController, "datasetElementType", null);
_defineProperty(DatasetController, "dataElementType", null);
function getAllScaleValues(scale, type) {
  if (!scale._cache.$bar) {
    const visibleMetas = scale.getMatchingVisibleMetas(type);
    let values = [];
    for (let i = 0, ilen = visibleMetas.length; i < ilen; i++) {
      values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
    }
    scale._cache.$bar = _arrayUnique(values.sort((a, b) => a - b));
  }
  return scale._cache.$bar;
}
function computeMinSampleSize(meta) {
  const scale = meta.iScale;
  const values = getAllScaleValues(scale, meta.type);
  let min = scale._length;
  let i, ilen, curr, prev;
  const updateMinAndPrev = () => {
    if (curr === 32767 || curr === -32768) {
      return;
    }
    if (defined(prev)) {
      min = Math.min(min, Math.abs(curr - prev) || min);
    }
    prev = curr;
  };
  for (i = 0, ilen = values.length; i < ilen; ++i) {
    curr = scale.getPixelForValue(values[i]);
    updateMinAndPrev();
  }
  prev = undefined;
  for (i = 0, ilen = scale.ticks.length; i < ilen; ++i) {
    curr = scale.getPixelForTick(i);
    updateMinAndPrev();
  }
  return min;
}
function computeFitCategoryTraits(index, ruler, options, stackCount) {
  const thickness = options.barThickness;
  let size, ratio;
  if (isNullOrUndef(thickness)) {
    size = ruler.min * options.categoryPercentage;
    ratio = options.barPercentage;
  } else {
    size = thickness * stackCount;
    ratio = 1;
  }
  return {
    chunk: size / stackCount,
    ratio,
    start: ruler.pixels[index] - size / 2
  };
}
function computeFlexCategoryTraits(index, ruler, options, stackCount) {
  const pixels = ruler.pixels;
  const curr = pixels[index];
  let prev = index > 0 ? pixels[index - 1] : null;
  let next = index < pixels.length - 1 ? pixels[index + 1] : null;
  const percent = options.categoryPercentage;
  if (prev === null) {
    prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
  }
  if (next === null) {
    next = curr + curr - prev;
  }
  const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
  const size = Math.abs(next - prev) / 2 * percent;
  return {
    chunk: size / stackCount,
    ratio: options.barPercentage,
    start
  };
}
function parseFloatBar(entry, item, vScale, i) {
  const startValue = vScale.parse(entry[0], i);
  const endValue = vScale.parse(entry[1], i);
  const min = Math.min(startValue, endValue);
  const max = Math.max(startValue, endValue);
  let barStart = min;
  let barEnd = max;
  if (Math.abs(min) > Math.abs(max)) {
    barStart = max;
    barEnd = min;
  }
  item[vScale.axis] = barEnd;
  item._custom = {
    barStart,
    barEnd,
    start: startValue,
    end: endValue,
    min,
    max
  };
}
function parseValue(entry, item, vScale, i) {
  if (isArray(entry)) {
    parseFloatBar(entry, item, vScale, i);
  } else {
    item[vScale.axis] = vScale.parse(entry, i);
  }
  return item;
}
function parseArrayOrPrimitive(meta, data, start, count) {
  const iScale = meta.iScale;
  const vScale = meta.vScale;
  const labels = iScale.getLabels();
  const singleScale = iScale === vScale;
  const parsed = [];
  let i, ilen, item, entry;
  for (i = start, ilen = start + count; i < ilen; ++i) {
    entry = data[i];
    item = {};
    item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
    parsed.push(parseValue(entry, item, vScale, i));
  }
  return parsed;
}
function isFloatBar(custom) {
  return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function barSign(size, vScale, actualBase) {
  if (size !== 0) {
    return sign(size);
  }
  return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function borderProps(properties) {
  let reverse, start, end, top, bottom;
  if (properties.horizontal) {
    reverse = properties.base > properties.x;
    start = 'left';
    end = 'right';
  } else {
    reverse = properties.base < properties.y;
    start = 'bottom';
    end = 'top';
  }
  if (reverse) {
    top = 'end';
    bottom = 'start';
  } else {
    top = 'start';
    bottom = 'end';
  }
  return {
    start,
    end,
    reverse,
    top,
    bottom
  };
}
function setBorderSkipped(properties, options, stack, index) {
  let edge = options.borderSkipped;
  const res = {};
  if (!edge) {
    properties.borderSkipped = res;
    return;
  }
  if (edge === true) {
    properties.borderSkipped = {
      top: true,
      right: true,
      bottom: true,
      left: true
    };
    return;
  }
  const {
    start,
    end,
    reverse,
    top,
    bottom
  } = borderProps(properties);
  if (edge === 'middle' && stack) {
    properties.enableBorderRadius = true;
    if ((stack._top || 0) === index) {
      edge = top;
    } else if ((stack._bottom || 0) === index) {
      edge = bottom;
    } else {
      res[parseEdge(bottom, start, end, reverse)] = true;
      edge = top;
    }
  }
  res[parseEdge(edge, start, end, reverse)] = true;
  properties.borderSkipped = res;
}
function parseEdge(edge, a, b, reverse) {
  if (reverse) {
    edge = swap(edge, a, b);
    edge = startEnd(edge, b, a);
  } else {
    edge = startEnd(edge, a, b);
  }
  return edge;
}
function swap(orig, v1, v2) {
  return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function startEnd(v, start, end) {
  return v === 'start' ? start : v === 'end' ? end : v;
}
function setInflateAmount(properties, {
  inflateAmount
}, ratio) {
  properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class BarController extends DatasetController {
  parsePrimitiveData(meta, data, start, count) {
    return parseArrayOrPrimitive(meta, data, start, count);
  }
  parseArrayData(meta, data, start, count) {
    return parseArrayOrPrimitive(meta, data, start, count);
  }
  parseObjectData(meta, data, start, count) {
    const {
      iScale,
      vScale
    } = meta;
    const {
      xAxisKey = 'x',
      yAxisKey = 'y'
    } = this._parsing;
    const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
    const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
    const parsed = [];
    let i, ilen, item, obj;
    for (i = start, ilen = start + count; i < ilen; ++i) {
      obj = data[i];
      item = {};
      item[iScale.axis] = iScale.parse(resolveObjectKey(obj, iAxisKey), i);
      parsed.push(parseValue(resolveObjectKey(obj, vAxisKey), item, vScale, i));
    }
    return parsed;
  }
  updateRangeFromParsed(range, scale, parsed, stack) {
    super.updateRangeFromParsed(range, scale, parsed, stack);
    const custom = parsed._custom;
    if (custom && scale === this._cachedMeta.vScale) {
      range.min = Math.min(range.min, custom.min);
      range.max = Math.max(range.max, custom.max);
    }
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(index) {
    const meta = this._cachedMeta;
    const {
      iScale,
      vScale
    } = meta;
    const parsed = this.getParsed(index);
    const custom = parsed._custom;
    const value = isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
    return {
      label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
      value
    };
  }
  initialize() {
    this.enableOptionSharing = true;
    super.initialize();
    const meta = this._cachedMeta;
    meta.stack = this.getDataset().stack;
  }
  update(mode) {
    const meta = this._cachedMeta;
    this.updateElements(meta.data, 0, meta.data.length, mode);
  }
  updateElements(bars, start, count, mode) {
    const reset = mode === 'reset';
    const {
      index,
      _cachedMeta: {
        vScale
      }
    } = this;
    const base = vScale.getBasePixel();
    const horizontal = vScale.isHorizontal();
    const ruler = this._getRuler();
    const {
      sharedOptions,
      includeOptions
    } = this._getSharedOptions(start, mode);
    for (let i = start; i < start + count; i++) {
      const parsed = this.getParsed(i);
      const vpixels = reset || isNullOrUndef(parsed[vScale.axis]) ? {
        base,
        head: base
      } : this._calculateBarValuePixels(i);
      const ipixels = this._calculateBarIndexPixels(i, ruler);
      const stack = (parsed._stacks || {})[vScale.axis];
      const properties = {
        horizontal,
        base: vpixels.base,
        enableBorderRadius: !stack || isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
        x: horizontal ? vpixels.head : ipixels.center,
        y: horizontal ? ipixels.center : vpixels.head,
        height: horizontal ? ipixels.size : Math.abs(vpixels.size),
        width: horizontal ? Math.abs(vpixels.size) : ipixels.size
      };
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
      }
      const options = properties.options || bars[i].options;
      setBorderSkipped(properties, options, stack, index);
      setInflateAmount(properties, options, ruler.ratio);
      this.updateElement(bars[i], i, properties, mode);
    }
  }
  _getStacks(last, dataIndex) {
    const {
      iScale
    } = this._cachedMeta;
    const metasets = iScale.getMatchingVisibleMetas(this._type).filter(meta => meta.controller.options.grouped);
    const stacked = iScale.options.stacked;
    const stacks = [];
    const currentParsed = this._cachedMeta.controller.getParsed(dataIndex);
    const iScaleValue = currentParsed && currentParsed[iScale.axis];
    const skipNull = meta => {
      const parsed = meta._parsed.find(item => item[iScale.axis] === iScaleValue);
      const val = parsed && parsed[meta.vScale.axis];
      if (isNullOrUndef(val) || isNaN(val)) {
        return true;
      }
    };
    for (const meta of metasets) {
      if (dataIndex !== undefined && skipNull(meta)) {
        continue;
      }
      if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) {
        stacks.push(meta.stack);
      }
      if (meta.index === last) {
        break;
      }
    }
    if (!stacks.length) {
      stacks.push(undefined);
    }
    return stacks;
  }
  _getStackCount(index) {
    return this._getStacks(undefined, index).length;
  }
  _getStackIndex(datasetIndex, name, dataIndex) {
    const stacks = this._getStacks(datasetIndex, dataIndex);
    const index = name !== undefined ? stacks.indexOf(name) : -1;
    return index === -1 ? stacks.length - 1 : index;
  }
  _getRuler() {
    const opts = this.options;
    const meta = this._cachedMeta;
    const iScale = meta.iScale;
    const pixels = [];
    let i, ilen;
    for (i = 0, ilen = meta.data.length; i < ilen; ++i) {
      pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
    }
    const barThickness = opts.barThickness;
    const min = barThickness || computeMinSampleSize(meta);
    return {
      min,
      pixels,
      start: iScale._startPixel,
      end: iScale._endPixel,
      stackCount: this._getStackCount(),
      scale: iScale,
      grouped: opts.grouped,
      ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
    };
  }
  _calculateBarValuePixels(index) {
    const {
      _cachedMeta: {
        vScale,
        _stacked,
        index: datasetIndex
      },
      options: {
        base: baseValue,
        minBarLength
      }
    } = this;
    const actualBase = baseValue || 0;
    const parsed = this.getParsed(index);
    const custom = parsed._custom;
    const floating = isFloatBar(custom);
    let value = parsed[vScale.axis];
    let start = 0;
    let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
    let head, size;
    if (length !== value) {
      start = length - value;
      length = value;
    }
    if (floating) {
      value = custom.barStart;
      length = custom.barEnd - custom.barStart;
      if (value !== 0 && sign(value) !== sign(custom.barEnd)) {
        start = 0;
      }
      start += value;
    }
    const startValue = !isNullOrUndef(baseValue) && !floating ? baseValue : start;
    let base = vScale.getPixelForValue(startValue);
    if (this.chart.getDataVisibility(index)) {
      head = vScale.getPixelForValue(start + length);
    } else {
      head = base;
    }
    size = head - base;
    if (Math.abs(size) < minBarLength) {
      size = barSign(size, vScale, actualBase) * minBarLength;
      if (value === actualBase) {
        base -= size / 2;
      }
      const startPixel = vScale.getPixelForDecimal(0);
      const endPixel = vScale.getPixelForDecimal(1);
      const min = Math.min(startPixel, endPixel);
      const max = Math.max(startPixel, endPixel);
      base = Math.max(Math.min(base, max), min);
      head = base + size;
      if (_stacked && !floating) {
        parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
      }
    }
    if (base === vScale.getPixelForValue(actualBase)) {
      const halfGrid = sign(size) * vScale.getLineWidthForValue(actualBase) / 2;
      base += halfGrid;
      size -= halfGrid;
    }
    return {
      size,
      base,
      head,
      center: head + size / 2
    };
  }
  _calculateBarIndexPixels(index, ruler) {
    const scale = ruler.scale;
    const options = this.options;
    const skipNull = options.skipNull;
    const maxBarThickness = valueOrDefault(options.maxBarThickness, Infinity);
    let center, size;
    if (ruler.grouped) {
      const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
      const range = options.barThickness === 'flex' ? computeFlexCategoryTraits(index, ruler, options, stackCount) : computeFitCategoryTraits(index, ruler, options, stackCount);
      const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
      center = range.start + range.chunk * stackIndex + range.chunk / 2;
      size = Math.min(maxBarThickness, range.chunk * range.ratio);
    } else {
      center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
      size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
    }
    return {
      base: center - size / 2,
      head: center + size / 2,
      center,
      size
    };
  }
  draw() {
    const meta = this._cachedMeta;
    const vScale = meta.vScale;
    const rects = meta.data;
    const ilen = rects.length;
    let i = 0;
    for (; i < ilen; ++i) {
      if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) {
        rects[i].draw(this._ctx);
      }
    }
  }
}
_defineProperty(BarController, "id", 'bar');
_defineProperty(BarController, "defaults", {
  datasetElementType: false,
  dataElementType: 'bar',
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: true,
  animations: {
    numbers: {
      type: 'number',
      properties: ['x', 'y', 'base', 'width', 'height']
    }
  }
});
_defineProperty(BarController, "overrides", {
  scales: {
    _index_: {
      type: 'category',
      offset: true,
      grid: {
        offset: true
      }
    },
    _value_: {
      type: 'linear',
      beginAtZero: true
    }
  }
});
class BubbleController extends DatasetController {
  initialize() {
    this.enableOptionSharing = true;
    super.initialize();
  }
  parsePrimitiveData(meta, data, start, count) {
    const parsed = super.parsePrimitiveData(meta, data, start, count);
    for (let i = 0; i < parsed.length; i++) {
      parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
    }
    return parsed;
  }
  parseArrayData(meta, data, start, count) {
    const parsed = super.parseArrayData(meta, data, start, count);
    for (let i = 0; i < parsed.length; i++) {
      const item = data[start + i];
      parsed[i]._custom = valueOrDefault(item[2], this.resolveDataElementOptions(i + start).radius);
    }
    return parsed;
  }
  parseObjectData(meta, data, start, count) {
    const parsed = super.parseObjectData(meta, data, start, count);
    for (let i = 0; i < parsed.length; i++) {
      const item = data[start + i];
      parsed[i]._custom = valueOrDefault(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
    }
    return parsed;
  }
  getMaxOverflow() {
    const data = this._cachedMeta.data;
    let max = 0;
    for (let i = data.length - 1; i >= 0; --i) {
      max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
    }
    return max > 0 && max;
  }
  getLabelAndValue(index) {
    const meta = this._cachedMeta;
    const labels = this.chart.data.labels || [];
    const {
      xScale,
      yScale
    } = meta;
    const parsed = this.getParsed(index);
    const x = xScale.getLabelForValue(parsed.x);
    const y = yScale.getLabelForValue(parsed.y);
    const r = parsed._custom;
    return {
      label: labels[index] || '',
      value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
    };
  }
  update(mode) {
    const points = this._cachedMeta.data;
    this.updateElements(points, 0, points.length, mode);
  }
  updateElements(points, start, count, mode) {
    const reset = mode === 'reset';
    const {
      iScale,
      vScale
    } = this._cachedMeta;
    const {
      sharedOptions,
      includeOptions
    } = this._getSharedOptions(start, mode);
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    for (let i = start; i < start + count; i++) {
      const point = points[i];
      const parsed = !reset && this.getParsed(i);
      const properties = {};
      const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
      const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
      properties.skip = isNaN(iPixel) || isNaN(vPixel);
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
        if (reset) {
          properties.options.radius = 0;
        }
      }
      this.updateElement(point, i, properties, mode);
    }
  }
  resolveDataElementOptions(index, mode) {
    const parsed = this.getParsed(index);
    let values = super.resolveDataElementOptions(index, mode);
    if (values.$shared) {
      values = Object.assign({}, values, {
        $shared: false
      });
    }
    const radius = values.radius;
    if (mode !== 'active') {
      values.radius = 0;
    }
    values.radius += valueOrDefault(parsed && parsed._custom, radius);
    return values;
  }
}
_defineProperty(BubbleController, "id", 'bubble');
_defineProperty(BubbleController, "defaults", {
  datasetElementType: false,
  dataElementType: 'point',
  animations: {
    numbers: {
      type: 'number',
      properties: ['x', 'y', 'borderWidth', 'radius']
    }
  }
});
_defineProperty(BubbleController, "overrides", {
  scales: {
    x: {
      type: 'linear'
    },
    y: {
      type: 'linear'
    }
  }
});
function getRatioAndOffset(rotation, circumference, cutout) {
  let ratioX = 1;
  let ratioY = 1;
  let offsetX = 0;
  let offsetY = 0;
  if (circumference < TAU) {
    const startAngle = rotation;
    const endAngle = startAngle + circumference;
    const startX = Math.cos(startAngle);
    const startY = Math.sin(startAngle);
    const endX = Math.cos(endAngle);
    const endY = Math.sin(endAngle);
    const calcMax = (angle, a, b) => _angleBetween(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
    const calcMin = (angle, a, b) => _angleBetween(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
    const maxX = calcMax(0, startX, endX);
    const maxY = calcMax(HALF_PI, startY, endY);
    const minX = calcMin(PI, startX, endX);
    const minY = calcMin(PI + HALF_PI, startY, endY);
    ratioX = (maxX - minX) / 2;
    ratioY = (maxY - minY) / 2;
    offsetX = -(maxX + minX) / 2;
    offsetY = -(maxY + minY) / 2;
  }
  return {
    ratioX,
    ratioY,
    offsetX,
    offsetY
  };
}
class DoughnutController extends DatasetController {
  constructor(chart, datasetIndex) {
    super(chart, datasetIndex);
    this.enableOptionSharing = true;
    this.innerRadius = undefined;
    this.outerRadius = undefined;
    this.offsetX = undefined;
    this.offsetY = undefined;
  }
  linkScales() {}
  parse(start, count) {
    const data = this.getDataset().data;
    const meta = this._cachedMeta;
    if (this._parsing === false) {
      meta._parsed = data;
    } else {
      let getter = i => +data[i];
      if (isObject(data[start])) {
        const {
          key = 'value'
        } = this._parsing;
        getter = i => +resolveObjectKey(data[i], key);
      }
      let i, ilen;
      for (i = start, ilen = start + count; i < ilen; ++i) {
        meta._parsed[i] = getter(i);
      }
    }
  }
  _getRotation() {
    return toRadians(this.options.rotation - 90);
  }
  _getCircumference() {
    return toRadians(this.options.circumference);
  }
  _getRotationExtents() {
    let min = TAU;
    let max = -TAU;
    for (let i = 0; i < this.chart.data.datasets.length; ++i) {
      if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
        const controller = this.chart.getDatasetMeta(i).controller;
        const rotation = controller._getRotation();
        const circumference = controller._getCircumference();
        min = Math.min(min, rotation);
        max = Math.max(max, rotation + circumference);
      }
    }
    return {
      rotation: min,
      circumference: max - min
    };
  }
  update(mode) {
    const chart = this.chart;
    const {
      chartArea
    } = chart;
    const meta = this._cachedMeta;
    const arcs = meta.data;
    const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
    const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
    const cutout = Math.min(toPercentage(this.options.cutout, maxSize), 1);
    const chartWeight = this._getRingWeight(this.index);
    const {
      circumference,
      rotation
    } = this._getRotationExtents();
    const {
      ratioX,
      ratioY,
      offsetX,
      offsetY
    } = getRatioAndOffset(rotation, circumference, cutout);
    const maxWidth = (chartArea.width - spacing) / ratioX;
    const maxHeight = (chartArea.height - spacing) / ratioY;
    const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
    const outerRadius = toDimension(this.options.radius, maxRadius);
    const innerRadius = Math.max(outerRadius * cutout, 0);
    const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
    this.offsetX = offsetX * outerRadius;
    this.offsetY = offsetY * outerRadius;
    meta.total = this.calculateTotal();
    this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
    this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
    this.updateElements(arcs, 0, arcs.length, mode);
  }
  _circumference(i, reset) {
    const opts = this.options;
    const meta = this._cachedMeta;
    const circumference = this._getCircumference();
    if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) {
      return 0;
    }
    return this.calculateCircumference(meta._parsed[i] * circumference / TAU);
  }
  updateElements(arcs, start, count, mode) {
    const reset = mode === 'reset';
    const chart = this.chart;
    const chartArea = chart.chartArea;
    const opts = chart.options;
    const animationOpts = opts.animation;
    const centerX = (chartArea.left + chartArea.right) / 2;
    const centerY = (chartArea.top + chartArea.bottom) / 2;
    const animateScale = reset && animationOpts.animateScale;
    const innerRadius = animateScale ? 0 : this.innerRadius;
    const outerRadius = animateScale ? 0 : this.outerRadius;
    const {
      sharedOptions,
      includeOptions
    } = this._getSharedOptions(start, mode);
    let startAngle = this._getRotation();
    let i;
    for (i = 0; i < start; ++i) {
      startAngle += this._circumference(i, reset);
    }
    for (i = start; i < start + count; ++i) {
      const circumference = this._circumference(i, reset);
      const arc = arcs[i];
      const properties = {
        x: centerX + this.offsetX,
        y: centerY + this.offsetY,
        startAngle,
        endAngle: startAngle + circumference,
        circumference,
        outerRadius,
        innerRadius
      };
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
      }
      startAngle += circumference;
      this.updateElement(arc, i, properties, mode);
    }
  }
  calculateTotal() {
    const meta = this._cachedMeta;
    const metaData = meta.data;
    let total = 0;
    let i;
    for (i = 0; i < metaData.length; i++) {
      const value = meta._parsed[i];
      if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) {
        total += Math.abs(value);
      }
    }
    return total;
  }
  calculateCircumference(value) {
    const total = this._cachedMeta.total;
    if (total > 0 && !isNaN(value)) {
      return TAU * (Math.abs(value) / total);
    }
    return 0;
  }
  getLabelAndValue(index) {
    const meta = this._cachedMeta;
    const chart = this.chart;
    const labels = chart.data.labels || [];
    const value = formatNumber(meta._parsed[index], chart.options.locale);
    return {
      label: labels[index] || '',
      value
    };
  }
  getMaxBorderWidth(arcs) {
    let max = 0;
    const chart = this.chart;
    let i, ilen, meta, controller, options;
    if (!arcs) {
      for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
        if (chart.isDatasetVisible(i)) {
          meta = chart.getDatasetMeta(i);
          arcs = meta.data;
          controller = meta.controller;
          break;
        }
      }
    }
    if (!arcs) {
      return 0;
    }
    for (i = 0, ilen = arcs.length; i < ilen; ++i) {
      options = controller.resolveDataElementOptions(i);
      if (options.borderAlign !== 'inner') {
        max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
      }
    }
    return max;
  }
  getMaxOffset(arcs) {
    let max = 0;
    for (let i = 0, ilen = arcs.length; i < ilen; ++i) {
      const options = this.resolveDataElementOptions(i);
      max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
    }
    return max;
  }
  _getRingWeightOffset(datasetIndex) {
    let ringWeightOffset = 0;
    for (let i = 0; i < datasetIndex; ++i) {
      if (this.chart.isDatasetVisible(i)) {
        ringWeightOffset += this._getRingWeight(i);
      }
    }
    return ringWeightOffset;
  }
  _getRingWeight(datasetIndex) {
    return Math.max(valueOrDefault(this.chart.data.datasets[datasetIndex].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
_defineProperty(DoughnutController, "id", 'doughnut');
_defineProperty(DoughnutController, "defaults", {
  datasetElementType: false,
  dataElementType: 'arc',
  animation: {
    animateRotate: true,
    animateScale: false
  },
  animations: {
    numbers: {
      type: 'number',
      properties: ['circumference', 'endAngle', 'innerRadius', 'outerRadius', 'startAngle', 'x', 'y', 'offset', 'borderWidth', 'spacing']
    }
  },
  cutout: '50%',
  rotation: 0,
  circumference: 360,
  radius: '100%',
  spacing: 0,
  indexAxis: 'r'
});
_defineProperty(DoughnutController, "descriptors", {
  _scriptable: name => name !== 'spacing',
  _indexable: name => name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash')
});
_defineProperty(DoughnutController, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(chart) {
          const data = chart.data;
          if (data.labels.length && data.datasets.length) {
            const {
              labels: {
                pointStyle,
                color
              }
            } = chart.legend.options;
            return data.labels.map((label, i) => {
              const meta = chart.getDatasetMeta(0);
              const style = meta.controller.getStyle(i);
              return {
                text: label,
                fillStyle: style.backgroundColor,
                strokeStyle: style.borderColor,
                fontColor: color,
                lineWidth: style.borderWidth,
                pointStyle: pointStyle,
                hidden: !chart.getDataVisibility(i),
                index: i
              };
            });
          }
          return [];
        }
      },
      onClick(e, legendItem, legend) {
        legend.chart.toggleDataVisibility(legendItem.index);
        legend.chart.update();
      }
    }
  }
});
class LineController extends DatasetController {
  initialize() {
    this.enableOptionSharing = true;
    this.supportsDecimation = true;
    super.initialize();
  }
  update(mode) {
    const meta = this._cachedMeta;
    const {
      dataset: line,
      data: points = [],
      _dataset
    } = meta;
    const animationsDisabled = this.chart._animationsDisabled;
    let {
      start,
      count
    } = _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled);
    this._drawStart = start;
    this._drawCount = count;
    if (_scaleRangesChanged(meta)) {
      start = 0;
      count = points.length;
    }
    line._chart = this.chart;
    line._datasetIndex = this.index;
    line._decimated = !!_dataset._decimated;
    line.points = points;
    const options = this.resolveDatasetElementOptions(mode);
    if (!this.options.showLine) {
      options.borderWidth = 0;
    }
    options.segment = this.options.segment;
    this.updateElement(line, undefined, {
      animated: !animationsDisabled,
      options
    }, mode);
    this.updateElements(points, start, count, mode);
  }
  updateElements(points, start, count, mode) {
    const reset = mode === 'reset';
    const {
      iScale,
      vScale,
      _stacked,
      _dataset
    } = this._cachedMeta;
    const {
      sharedOptions,
      includeOptions
    } = this._getSharedOptions(start, mode);
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const {
      spanGaps,
      segment
    } = this.options;
    const maxGapLength = isNumber(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
    const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
    const end = start + count;
    const pointsCount = points.length;
    let prevParsed = start > 0 && this.getParsed(start - 1);
    for (let i = 0; i < pointsCount; ++i) {
      const point = points[i];
      const properties = directUpdate ? point : {};
      if (i < start || i >= end) {
        properties.skip = true;
        continue;
      }
      const parsed = this.getParsed(i);
      const nullData = isNullOrUndef(parsed[vAxis]);
      const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
      const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
      properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
      properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
      if (segment) {
        properties.parsed = parsed;
        properties.raw = _dataset.data[i];
      }
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
      }
      if (!directUpdate) {
        this.updateElement(point, i, properties, mode);
      }
      prevParsed = parsed;
    }
  }
  getMaxOverflow() {
    const meta = this._cachedMeta;
    const dataset = meta.dataset;
    const border = dataset.options && dataset.options.borderWidth || 0;
    const data = meta.data || [];
    if (!data.length) {
      return border;
    }
    const firstPoint = data[0].size(this.resolveDataElementOptions(0));
    const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
    return Math.max(border, firstPoint, lastPoint) / 2;
  }
  draw() {
    const meta = this._cachedMeta;
    meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
    super.draw();
  }
}
_defineProperty(LineController, "id", 'line');
_defineProperty(LineController, "defaults", {
  datasetElementType: 'line',
  dataElementType: 'point',
  showLine: true,
  spanGaps: false
});
_defineProperty(LineController, "overrides", {
  scales: {
    _index_: {
      type: 'category'
    },
    _value_: {
      type: 'linear'
    }
  }
});
class PolarAreaController extends DatasetController {
  constructor(chart, datasetIndex) {
    super(chart, datasetIndex);
    this.innerRadius = undefined;
    this.outerRadius = undefined;
  }
  getLabelAndValue(index) {
    const meta = this._cachedMeta;
    const chart = this.chart;
    const labels = chart.data.labels || [];
    const value = formatNumber(meta._parsed[index].r, chart.options.locale);
    return {
      label: labels[index] || '',
      value
    };
  }
  parseObjectData(meta, data, start, count) {
    return _parseObjectDataRadialScale.bind(this)(meta, data, start, count);
  }
  update(mode) {
    const arcs = this._cachedMeta.data;
    this._updateRadius();
    this.updateElements(arcs, 0, arcs.length, mode);
  }
  getMinMax() {
    const meta = this._cachedMeta;
    const range = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    };
    meta.data.forEach((element, index) => {
      const parsed = this.getParsed(index).r;
      if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
        if (parsed < range.min) {
          range.min = parsed;
        }
        if (parsed > range.max) {
          range.max = parsed;
        }
      }
    });
    return range;
  }
  _updateRadius() {
    const chart = this.chart;
    const chartArea = chart.chartArea;
    const opts = chart.options;
    const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
    const outerRadius = Math.max(minSize / 2, 0);
    const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
    const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
    this.outerRadius = outerRadius - radiusLength * this.index;
    this.innerRadius = this.outerRadius - radiusLength;
  }
  updateElements(arcs, start, count, mode) {
    const reset = mode === 'reset';
    const chart = this.chart;
    const opts = chart.options;
    const animationOpts = opts.animation;
    const scale = this._cachedMeta.rScale;
    const centerX = scale.xCenter;
    const centerY = scale.yCenter;
    const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * PI;
    let angle = datasetStartAngle;
    let i;
    const defaultAngle = 360 / this.countVisibleElements();
    for (i = 0; i < start; ++i) {
      angle += this._computeAngle(i, mode, defaultAngle);
    }
    for (i = start; i < start + count; i++) {
      const arc = arcs[i];
      let startAngle = angle;
      let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
      let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
      angle = endAngle;
      if (reset) {
        if (animationOpts.animateScale) {
          outerRadius = 0;
        }
        if (animationOpts.animateRotate) {
          startAngle = endAngle = datasetStartAngle;
        }
      }
      const properties = {
        x: centerX,
        y: centerY,
        innerRadius: 0,
        outerRadius,
        startAngle,
        endAngle,
        options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
      };
      this.updateElement(arc, i, properties, mode);
    }
  }
  countVisibleElements() {
    const meta = this._cachedMeta;
    let count = 0;
    meta.data.forEach((element, index) => {
      if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) {
        count++;
      }
    });
    return count;
  }
  _computeAngle(index, mode, defaultAngle) {
    return this.chart.getDataVisibility(index) ? toRadians(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
  }
}
_defineProperty(PolarAreaController, "id", 'polarArea');
_defineProperty(PolarAreaController, "defaults", {
  dataElementType: 'arc',
  animation: {
    animateRotate: true,
    animateScale: true
  },
  animations: {
    numbers: {
      type: 'number',
      properties: ['x', 'y', 'startAngle', 'endAngle', 'innerRadius', 'outerRadius']
    }
  },
  indexAxis: 'r',
  startAngle: 0
});
_defineProperty(PolarAreaController, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(chart) {
          const data = chart.data;
          if (data.labels.length && data.datasets.length) {
            const {
              labels: {
                pointStyle,
                color
              }
            } = chart.legend.options;
            return data.labels.map((label, i) => {
              const meta = chart.getDatasetMeta(0);
              const style = meta.controller.getStyle(i);
              return {
                text: label,
                fillStyle: style.backgroundColor,
                strokeStyle: style.borderColor,
                fontColor: color,
                lineWidth: style.borderWidth,
                pointStyle: pointStyle,
                hidden: !chart.getDataVisibility(i),
                index: i
              };
            });
          }
          return [];
        }
      },
      onClick(e, legendItem, legend) {
        legend.chart.toggleDataVisibility(legendItem.index);
        legend.chart.update();
      }
    }
  },
  scales: {
    r: {
      type: 'radialLinear',
      angleLines: {
        display: false
      },
      beginAtZero: true,
      grid: {
        circular: true
      },
      pointLabels: {
        display: false
      },
      startAngle: 0
    }
  }
});
class PieController extends DoughnutController {}
_defineProperty(PieController, "id", 'pie');
_defineProperty(PieController, "defaults", {
  cutout: 0,
  rotation: 0,
  circumference: 360,
  radius: '100%'
});
class RadarController extends DatasetController {
  getLabelAndValue(index) {
    const vScale = this._cachedMeta.vScale;
    const parsed = this.getParsed(index);
    return {
      label: vScale.getLabels()[index],
      value: '' + vScale.getLabelForValue(parsed[vScale.axis])
    };
  }
  parseObjectData(meta, data, start, count) {
    return _parseObjectDataRadialScale.bind(this)(meta, data, start, count);
  }
  update(mode) {
    const meta = this._cachedMeta;
    const line = meta.dataset;
    const points = meta.data || [];
    const labels = meta.iScale.getLabels();
    line.points = points;
    if (mode !== 'resize') {
      const options = this.resolveDatasetElementOptions(mode);
      if (!this.options.showLine) {
        options.borderWidth = 0;
      }
      const properties = {
        _loop: true,
        _fullLoop: labels.length === points.length,
        options
      };
      this.updateElement(line, undefined, properties, mode);
    }
    this.updateElements(points, 0, points.length, mode);
  }
  updateElements(points, start, count, mode) {
    const scale = this._cachedMeta.rScale;
    const reset = mode === 'reset';
    for (let i = start; i < start + count; i++) {
      const point = points[i];
      const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
      const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
      const x = reset ? scale.xCenter : pointPosition.x;
      const y = reset ? scale.yCenter : pointPosition.y;
      const properties = {
        x,
        y,
        angle: pointPosition.angle,
        skip: isNaN(x) || isNaN(y),
        options
      };
      this.updateElement(point, i, properties, mode);
    }
  }
}
_defineProperty(RadarController, "id", 'radar');
_defineProperty(RadarController, "defaults", {
  datasetElementType: 'line',
  dataElementType: 'point',
  indexAxis: 'r',
  showLine: true,
  elements: {
    line: {
      fill: 'start'
    }
  }
});
_defineProperty(RadarController, "overrides", {
  aspectRatio: 1,
  scales: {
    r: {
      type: 'radialLinear'
    }
  }
});
class ScatterController extends DatasetController {
  getLabelAndValue(index) {
    const meta = this._cachedMeta;
    const labels = this.chart.data.labels || [];
    const {
      xScale,
      yScale
    } = meta;
    const parsed = this.getParsed(index);
    const x = xScale.getLabelForValue(parsed.x);
    const y = yScale.getLabelForValue(parsed.y);
    return {
      label: labels[index] || '',
      value: '(' + x + ', ' + y + ')'
    };
  }
  update(mode) {
    const meta = this._cachedMeta;
    const {
      data: points = []
    } = meta;
    const animationsDisabled = this.chart._animationsDisabled;
    let {
      start,
      count
    } = _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled);
    this._drawStart = start;
    this._drawCount = count;
    if (_scaleRangesChanged(meta)) {
      start = 0;
      count = points.length;
    }
    if (this.options.showLine) {
      if (!this.datasetElementType) {
        this.addElements();
      }
      const {
        dataset: line,
        _dataset
      } = meta;
      line._chart = this.chart;
      line._datasetIndex = this.index;
      line._decimated = !!_dataset._decimated;
      line.points = points;
      const options = this.resolveDatasetElementOptions(mode);
      options.segment = this.options.segment;
      this.updateElement(line, undefined, {
        animated: !animationsDisabled,
        options
      }, mode);
    } else if (this.datasetElementType) {
      delete meta.dataset;
      this.datasetElementType = false;
    }
    this.updateElements(points, start, count, mode);
  }
  addElements() {
    const {
      showLine
    } = this.options;
    if (!this.datasetElementType && showLine) {
      this.datasetElementType = this.chart.registry.getElement('line');
    }
    super.addElements();
  }
  updateElements(points, start, count, mode) {
    const reset = mode === 'reset';
    const {
      iScale,
      vScale,
      _stacked,
      _dataset
    } = this._cachedMeta;
    const firstOpts = this.resolveDataElementOptions(start, mode);
    const sharedOptions = this.getSharedOptions(firstOpts);
    const includeOptions = this.includeOptions(mode, sharedOptions);
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const {
      spanGaps,
      segment
    } = this.options;
    const maxGapLength = isNumber(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
    const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
    let prevParsed = start > 0 && this.getParsed(start - 1);
    for (let i = start; i < start + count; ++i) {
      const point = points[i];
      const parsed = this.getParsed(i);
      const properties = directUpdate ? point : {};
      const nullData = isNullOrUndef(parsed[vAxis]);
      const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
      const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
      properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
      properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
      if (segment) {
        properties.parsed = parsed;
        properties.raw = _dataset.data[i];
      }
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
      }
      if (!directUpdate) {
        this.updateElement(point, i, properties, mode);
      }
      prevParsed = parsed;
    }
    this.updateSharedOptions(sharedOptions, mode, firstOpts);
  }
  getMaxOverflow() {
    const meta = this._cachedMeta;
    const data = meta.data || [];
    if (!this.options.showLine) {
      let max = 0;
      for (let i = data.length - 1; i >= 0; --i) {
        max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
      }
      return max > 0 && max;
    }
    const dataset = meta.dataset;
    const border = dataset.options && dataset.options.borderWidth || 0;
    if (!data.length) {
      return border;
    }
    const firstPoint = data[0].size(this.resolveDataElementOptions(0));
    const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
    return Math.max(border, firstPoint, lastPoint) / 2;
  }
}
_defineProperty(ScatterController, "id", 'scatter');
_defineProperty(ScatterController, "defaults", {
  datasetElementType: false,
  dataElementType: 'point',
  showLine: false,
  fill: false
});
_defineProperty(ScatterController, "overrides", {
  interaction: {
    mode: 'point'
  },
  scales: {
    x: {
      type: 'linear'
    },
    y: {
      type: 'linear'
    }
  }
});

/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */
function abstract() {
  throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */
class DateAdapterBase {
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(members) {
    Object.assign(DateAdapterBase.prototype, members);
  }
  constructor(options) {
    _defineProperty(this, "options", void 0);
    this.options = options || {};
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {}
  formats() {
    return abstract();
  }
  parse() {
    return abstract();
  }
  format() {
    return abstract();
  }
  add() {
    return abstract();
  }
  diff() {
    return abstract();
  }
  startOf() {
    return abstract();
  }
  endOf() {
    return abstract();
  }
}
var adapters = {
  _date: DateAdapterBase
};
function binarySearch(metaset, axis, value, intersect) {
  const {
    controller,
    data,
    _sorted
  } = metaset;
  const iScale = controller._cachedMeta.iScale;
  if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
    const lookupMethod = iScale._reversePixels ? _rlookupByKey : _lookupByKey;
    if (!intersect) {
      return lookupMethod(data, axis, value);
    } else if (controller._sharedOptions) {
      const el = data[0];
      const range = typeof el.getRange === 'function' && el.getRange(axis);
      if (range) {
        const start = lookupMethod(data, axis, value - range);
        const end = lookupMethod(data, axis, value + range);
        return {
          lo: start.lo,
          hi: end.hi
        };
      }
    }
  }
  return {
    lo: 0,
    hi: data.length - 1
  };
}
function evaluateInteractionItems(chart, axis, position, handler, intersect) {
  const metasets = chart.getSortedVisibleDatasetMetas();
  const value = position[axis];
  for (let i = 0, ilen = metasets.length; i < ilen; ++i) {
    const {
      index,
      data
    } = metasets[i];
    const {
      lo,
      hi
    } = binarySearch(metasets[i], axis, value, intersect);
    for (let j = lo; j <= hi; ++j) {
      const element = data[j];
      if (!element.skip) {
        handler(element, index, j);
      }
    }
  }
}
function getDistanceMetricForAxis(axis) {
  const useX = axis.indexOf('x') !== -1;
  const useY = axis.indexOf('y') !== -1;
  return function (pt1, pt2) {
    const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
    const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
    return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
  };
}
function getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
  const items = [];
  if (!includeInvisible && !chart.isPointInArea(position)) {
    return items;
  }
  const evaluationFunc = function (element, datasetIndex, index) {
    if (!includeInvisible && !_isPointInArea(element, chart.chartArea, 0)) {
      return;
    }
    if (element.inRange(position.x, position.y, useFinalPosition)) {
      items.push({
        element,
        datasetIndex,
        index
      });
    }
  };
  evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
  return items;
}
function getNearestRadialItems(chart, position, axis, useFinalPosition) {
  let items = [];
  function evaluationFunc(element, datasetIndex, index) {
    const {
      startAngle,
      endAngle
    } = element.getProps(['startAngle', 'endAngle'], useFinalPosition);
    const {
      angle
    } = getAngleFromPoint(element, {
      x: position.x,
      y: position.y
    });
    if (_angleBetween(angle, startAngle, endAngle)) {
      items.push({
        element,
        datasetIndex,
        index
      });
    }
  }
  evaluateInteractionItems(chart, axis, position, evaluationFunc);
  return items;
}
function getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
  let items = [];
  const distanceMetric = getDistanceMetricForAxis(axis);
  let minDistance = Number.POSITIVE_INFINITY;
  function evaluationFunc(element, datasetIndex, index) {
    const inRange = element.inRange(position.x, position.y, useFinalPosition);
    if (intersect && !inRange) {
      return;
    }
    const center = element.getCenterPoint(useFinalPosition);
    const pointInArea = !!includeInvisible || chart.isPointInArea(center);
    if (!pointInArea && !inRange) {
      return;
    }
    const distance = distanceMetric(position, center);
    if (distance < minDistance) {
      items = [{
        element,
        datasetIndex,
        index
      }];
      minDistance = distance;
    } else if (distance === minDistance) {
      items.push({
        element,
        datasetIndex,
        index
      });
    }
  }
  evaluateInteractionItems(chart, axis, position, evaluationFunc);
  return items;
}
function getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
  if (!includeInvisible && !chart.isPointInArea(position)) {
    return [];
  }
  return axis === 'r' && !intersect ? getNearestRadialItems(chart, position, axis, useFinalPosition) : getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function getAxisItems(chart, position, axis, intersect, useFinalPosition) {
  const items = [];
  const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
  let intersectsItem = false;
  evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index) => {
    if (element[rangeMethod] && element[rangeMethod](position[axis], useFinalPosition)) {
      items.push({
        element,
        datasetIndex,
        index
      });
      intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
    }
  });
  if (intersect && !intersectsItem) {
    return [];
  }
  return items;
}
var Interaction = {
  evaluateInteractionItems,
  modes: {
    index(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const axis = options.axis || 'x';
      const includeInvisible = options.includeInvisible || false;
      const items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
      const elements = [];
      if (!items.length) {
        return [];
      }
      chart.getSortedVisibleDatasetMetas().forEach(meta => {
        const index = items[0].index;
        const element = meta.data[index];
        if (element && !element.skip) {
          elements.push({
            element,
            datasetIndex: meta.index,
            index
          });
        }
      });
      return elements;
    },
    dataset(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const axis = options.axis || 'xy';
      const includeInvisible = options.includeInvisible || false;
      let items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
      if (items.length > 0) {
        const datasetIndex = items[0].datasetIndex;
        const data = chart.getDatasetMeta(datasetIndex).data;
        items = [];
        for (let i = 0; i < data.length; ++i) {
          items.push({
            element: data[i],
            datasetIndex,
            index: i
          });
        }
      }
      return items;
    },
    point(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const axis = options.axis || 'xy';
      const includeInvisible = options.includeInvisible || false;
      return getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
    },
    nearest(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const axis = options.axis || 'xy';
      const includeInvisible = options.includeInvisible || false;
      return getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
    },
    x(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      return getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
    },
    y(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      return getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
    }
  }
};
const STATIC_POSITIONS = ['left', 'top', 'right', 'bottom'];
function filterByPosition(array, position) {
  return array.filter(v => v.pos === position);
}
function filterDynamicPositionByAxis(array, axis) {
  return array.filter(v => STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function sortByWeight(array, reverse) {
  return array.sort((a, b) => {
    const v0 = reverse ? b : a;
    const v1 = reverse ? a : b;
    return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
  });
}
function wrapBoxes(boxes) {
  const layoutBoxes = [];
  let i, ilen, box, pos, stack, stackWeight;
  for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
    box = boxes[i];
    ({
      position: pos,
      options: {
        stack,
        stackWeight = 1
      }
    } = box);
    layoutBoxes.push({
      index: i,
      box,
      pos,
      horizontal: box.isHorizontal(),
      weight: box.weight,
      stack: stack && pos + stack,
      stackWeight
    });
  }
  return layoutBoxes;
}
function buildStacks(layouts) {
  const stacks = {};
  for (const wrap of layouts) {
    const {
      stack,
      pos,
      stackWeight
    } = wrap;
    if (!stack || !STATIC_POSITIONS.includes(pos)) {
      continue;
    }
    const _stack = stacks[stack] || (stacks[stack] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    _stack.count++;
    _stack.weight += stackWeight;
  }
  return stacks;
}
function setLayoutDims(layouts, params) {
  const stacks = buildStacks(layouts);
  const {
    vBoxMaxWidth,
    hBoxMaxHeight
  } = params;
  let i, ilen, layout;
  for (i = 0, ilen = layouts.length; i < ilen; ++i) {
    layout = layouts[i];
    const {
      fullSize
    } = layout.box;
    const stack = stacks[layout.stack];
    const factor = stack && layout.stackWeight / stack.weight;
    if (layout.horizontal) {
      layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
      layout.height = hBoxMaxHeight;
    } else {
      layout.width = vBoxMaxWidth;
      layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
    }
  }
  return stacks;
}
function buildLayoutBoxes(boxes) {
  const layoutBoxes = wrapBoxes(boxes);
  const fullSize = sortByWeight(layoutBoxes.filter(wrap => wrap.box.fullSize), true);
  const left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
  const right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
  const top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
  const bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
  const centerHorizontal = filterDynamicPositionByAxis(layoutBoxes, 'x');
  const centerVertical = filterDynamicPositionByAxis(layoutBoxes, 'y');
  return {
    fullSize,
    leftAndTop: left.concat(top),
    rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
    chartArea: filterByPosition(layoutBoxes, 'chartArea'),
    vertical: left.concat(right).concat(centerVertical),
    horizontal: top.concat(bottom).concat(centerHorizontal)
  };
}
function getCombinedMax(maxPadding, chartArea, a, b) {
  return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function updateMaxPadding(maxPadding, boxPadding) {
  maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
  maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
  maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
  maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function updateDims(chartArea, params, layout, stacks) {
  const {
    pos,
    box
  } = layout;
  const maxPadding = chartArea.maxPadding;
  if (!isObject(pos)) {
    if (layout.size) {
      chartArea[pos] -= layout.size;
    }
    const stack = stacks[layout.stack] || {
      size: 0,
      count: 1
    };
    stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
    layout.size = stack.size / stack.count;
    chartArea[pos] += layout.size;
  }
  if (box.getPadding) {
    updateMaxPadding(maxPadding, box.getPadding());
  }
  const newWidth = Math.max(0, params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right'));
  const newHeight = Math.max(0, params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
  const widthChanged = newWidth !== chartArea.w;
  const heightChanged = newHeight !== chartArea.h;
  chartArea.w = newWidth;
  chartArea.h = newHeight;
  return layout.horizontal ? {
    same: widthChanged,
    other: heightChanged
  } : {
    same: heightChanged,
    other: widthChanged
  };
}
function handleMaxPadding(chartArea) {
  const maxPadding = chartArea.maxPadding;
  function updatePos(pos) {
    const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
    chartArea[pos] += change;
    return change;
  }
  chartArea.y += updatePos('top');
  chartArea.x += updatePos('left');
  updatePos('right');
  updatePos('bottom');
}
function getMargins(horizontal, chartArea) {
  const maxPadding = chartArea.maxPadding;
  function marginForPositions(positions) {
    const margin = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    positions.forEach(pos => {
      margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
    });
    return margin;
  }
  return horizontal ? marginForPositions(['left', 'right']) : marginForPositions(['top', 'bottom']);
}
function fitBoxes(boxes, chartArea, params, stacks) {
  const refitBoxes = [];
  let i, ilen, layout, box, refit, changed;
  for (i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i) {
    layout = boxes[i];
    box = layout.box;
    box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
    const {
      same,
      other
    } = updateDims(chartArea, params, layout, stacks);
    refit |= same && refitBoxes.length;
    changed = changed || other;
    if (!box.fullSize) {
      refitBoxes.push(layout);
    }
  }
  return refit && fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function setBoxDims(box, left, top, width, height) {
  box.top = top;
  box.left = left;
  box.right = left + width;
  box.bottom = top + height;
  box.width = width;
  box.height = height;
}
function placeBoxes(boxes, chartArea, params, stacks) {
  const userPadding = params.padding;
  let {
    x,
    y
  } = chartArea;
  for (const layout of boxes) {
    const box = layout.box;
    const stack = stacks[layout.stack] || {
      count: 1,
      placed: 0,
      weight: 1
    };
    const weight = layout.stackWeight / stack.weight || 1;
    if (layout.horizontal) {
      const width = chartArea.w * weight;
      const height = stack.size || box.height;
      if (defined(stack.start)) {
        y = stack.start;
      }
      if (box.fullSize) {
        setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
      } else {
        setBoxDims(box, chartArea.left + stack.placed, y, width, height);
      }
      stack.start = y;
      stack.placed += width;
      y = box.bottom;
    } else {
      const height = chartArea.h * weight;
      const width = stack.size || box.width;
      if (defined(stack.start)) {
        x = stack.start;
      }
      if (box.fullSize) {
        setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
      } else {
        setBoxDims(box, x, chartArea.top + stack.placed, width, height);
      }
      stack.start = x;
      stack.placed += height;
      x = box.right;
    }
  }
  chartArea.x = x;
  chartArea.y = y;
}
var layouts = {
  addBox(chart, item) {
    if (!chart.boxes) {
      chart.boxes = [];
    }
    item.fullSize = item.fullSize || false;
    item.position = item.position || 'top';
    item.weight = item.weight || 0;
    item._layers = item._layers || function () {
      return [{
        z: 0,
        draw(chartArea) {
          item.draw(chartArea);
        }
      }];
    };
    chart.boxes.push(item);
  },
  removeBox(chart, layoutItem) {
    const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
    if (index !== -1) {
      chart.boxes.splice(index, 1);
    }
  },
  configure(chart, item, options) {
    item.fullSize = options.fullSize;
    item.position = options.position;
    item.weight = options.weight;
  },
  update(chart, width, height, minPadding) {
    if (!chart) {
      return;
    }
    const padding = toPadding(chart.options.layout.padding);
    const availableWidth = Math.max(width - padding.width, 0);
    const availableHeight = Math.max(height - padding.height, 0);
    const boxes = buildLayoutBoxes(chart.boxes);
    const verticalBoxes = boxes.vertical;
    const horizontalBoxes = boxes.horizontal;
    each(chart.boxes, box => {
      if (typeof box.beforeLayout === 'function') {
        box.beforeLayout();
      }
    });
    const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap) => wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
    const params = Object.freeze({
      outerWidth: width,
      outerHeight: height,
      padding,
      availableWidth,
      availableHeight,
      vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
      hBoxMaxHeight: availableHeight / 2
    });
    const maxPadding = Object.assign({}, padding);
    updateMaxPadding(maxPadding, toPadding(minPadding));
    const chartArea = Object.assign({
      maxPadding,
      w: availableWidth,
      h: availableHeight,
      x: padding.left,
      y: padding.top
    }, padding);
    const stacks = setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
    fitBoxes(boxes.fullSize, chartArea, params, stacks);
    fitBoxes(verticalBoxes, chartArea, params, stacks);
    if (fitBoxes(horizontalBoxes, chartArea, params, stacks)) {
      fitBoxes(verticalBoxes, chartArea, params, stacks);
    }
    handleMaxPadding(chartArea);
    placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
    chartArea.x += chartArea.w;
    chartArea.y += chartArea.h;
    placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
    chart.chartArea = {
      left: chartArea.left,
      top: chartArea.top,
      right: chartArea.left + chartArea.w,
      bottom: chartArea.top + chartArea.h,
      height: chartArea.h,
      width: chartArea.w
    };
    each(boxes.chartArea, layout => {
      const box = layout.box;
      Object.assign(box, chart.chartArea);
      box.update(chartArea.w, chartArea.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class BasePlatform {
  acquireContext(canvas, aspectRatio) {}
  releaseContext(context) {
    return false;
  }
  addEventListener(chart, type, listener) {}
  removeEventListener(chart, type, listener) {}
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(element, width, height, aspectRatio) {
    width = Math.max(0, width || element.width);
    height = height || element.height;
    return {
      width,
      height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
    };
  }
  isAttached(canvas) {
    return true;
  }
  updateConfig(config) {}
}
class BasicPlatform extends BasePlatform {
  acquireContext(item) {
    return item && item.getContext && item.getContext('2d') || null;
  }
  updateConfig(config) {
    config.options.animation = false;
  }
}
const EXPANDO_KEY = '$chartjs';
const EVENT_TYPES = {
  touchstart: 'mousedown',
  touchmove: 'mousemove',
  touchend: 'mouseup',
  pointerenter: 'mouseenter',
  pointerdown: 'mousedown',
  pointermove: 'mousemove',
  pointerup: 'mouseup',
  pointerleave: 'mouseout',
  pointerout: 'mouseout'
};
const isNullOrEmpty = value => value === null || value === '';
function initCanvas(canvas, aspectRatio) {
  const style = canvas.style;
  const renderHeight = canvas.getAttribute('height');
  const renderWidth = canvas.getAttribute('width');
  canvas[EXPANDO_KEY] = {
    initial: {
      height: renderHeight,
      width: renderWidth,
      style: {
        display: style.display,
        height: style.height,
        width: style.width
      }
    }
  };
  style.display = style.display || 'block';
  style.boxSizing = style.boxSizing || 'border-box';
  if (isNullOrEmpty(renderWidth)) {
    const displayWidth = readUsedSize(canvas, 'width');
    if (displayWidth !== undefined) {
      canvas.width = displayWidth;
    }
  }
  if (isNullOrEmpty(renderHeight)) {
    if (canvas.style.height === '') {
      canvas.height = canvas.width / (aspectRatio || 2);
    } else {
      const displayHeight = readUsedSize(canvas, 'height');
      if (displayHeight !== undefined) {
        canvas.height = displayHeight;
      }
    }
  }
  return canvas;
}
const eventListenerOptions = supportsEventListenerOptions ? {
  passive: true
} : false;
function addListener(node, type, listener) {
  if (node) {
    node.addEventListener(type, listener, eventListenerOptions);
  }
}
function removeListener(chart, type, listener) {
  if (chart && chart.canvas) {
    chart.canvas.removeEventListener(type, listener, eventListenerOptions);
  }
}
function fromNativeEvent(event, chart) {
  const type = EVENT_TYPES[event.type] || event.type;
  const {
    x,
    y
  } = getRelativePosition(event, chart);
  return {
    type,
    chart,
    native: event,
    x: x !== undefined ? x : null,
    y: y !== undefined ? y : null
  };
}
function nodeListContains(nodeList, canvas) {
  for (const node of nodeList) {
    if (node === canvas || node.contains(canvas)) {
      return true;
    }
  }
}
function createAttachObserver(chart, type, listener) {
  const canvas = chart.canvas;
  const observer = new MutationObserver(entries => {
    let trigger = false;
    for (const entry of entries) {
      trigger = trigger || nodeListContains(entry.addedNodes, canvas);
      trigger = trigger && !nodeListContains(entry.removedNodes, canvas);
    }
    if (trigger) {
      listener();
    }
  });
  observer.observe(document, {
    childList: true,
    subtree: true
  });
  return observer;
}
function createDetachObserver(chart, type, listener) {
  const canvas = chart.canvas;
  const observer = new MutationObserver(entries => {
    let trigger = false;
    for (const entry of entries) {
      trigger = trigger || nodeListContains(entry.removedNodes, canvas);
      trigger = trigger && !nodeListContains(entry.addedNodes, canvas);
    }
    if (trigger) {
      listener();
    }
  });
  observer.observe(document, {
    childList: true,
    subtree: true
  });
  return observer;
}
const drpListeningCharts = new Map();
let oldDevicePixelRatio = 0;
function onWindowResize() {
  const dpr = window.devicePixelRatio;
  if (dpr === oldDevicePixelRatio) {
    return;
  }
  oldDevicePixelRatio = dpr;
  drpListeningCharts.forEach((resize, chart) => {
    if (chart.currentDevicePixelRatio !== dpr) {
      resize();
    }
  });
}
function listenDevicePixelRatioChanges(chart, resize) {
  if (!drpListeningCharts.size) {
    window.addEventListener('resize', onWindowResize);
  }
  drpListeningCharts.set(chart, resize);
}
function unlistenDevicePixelRatioChanges(chart) {
  drpListeningCharts.delete(chart);
  if (!drpListeningCharts.size) {
    window.removeEventListener('resize', onWindowResize);
  }
}
function createResizeObserver(chart, type, listener) {
  const canvas = chart.canvas;
  const container = canvas && _getParentNode(canvas);
  if (!container) {
    return;
  }
  const resize = throttled((width, height) => {
    const w = container.clientWidth;
    listener(width, height);
    if (w < container.clientWidth) {
      listener();
    }
  }, window);
  const observer = new ResizeObserver(entries => {
    const entry = entries[0];
    const width = entry.contentRect.width;
    const height = entry.contentRect.height;
    if (width === 0 && height === 0) {
      return;
    }
    resize(width, height);
  });
  observer.observe(container);
  listenDevicePixelRatioChanges(chart, resize);
  return observer;
}
function releaseObserver(chart, type, observer) {
  if (observer) {
    observer.disconnect();
  }
  if (type === 'resize') {
    unlistenDevicePixelRatioChanges(chart);
  }
}
function createProxyAndListen(chart, type, listener) {
  const canvas = chart.canvas;
  const proxy = throttled(event => {
    if (chart.ctx !== null) {
      listener(fromNativeEvent(event, chart));
    }
  }, chart);
  addListener(canvas, type, proxy);
  return proxy;
}
class DomPlatform extends BasePlatform {
  acquireContext(canvas, aspectRatio) {
    const context = canvas && canvas.getContext && canvas.getContext('2d');
    if (context && context.canvas === canvas) {
      initCanvas(canvas, aspectRatio);
      return context;
    }
    return null;
  }
  releaseContext(context) {
    const canvas = context.canvas;
    if (!canvas[EXPANDO_KEY]) {
      return false;
    }
    const initial = canvas[EXPANDO_KEY].initial;
    ['height', 'width'].forEach(prop => {
      const value = initial[prop];
      if (isNullOrUndef(value)) {
        canvas.removeAttribute(prop);
      } else {
        canvas.setAttribute(prop, value);
      }
    });
    const style = initial.style || {};
    Object.keys(style).forEach(key => {
      canvas.style[key] = style[key];
    });
    canvas.width = canvas.width;
    delete canvas[EXPANDO_KEY];
    return true;
  }
  addEventListener(chart, type, listener) {
    this.removeEventListener(chart, type);
    const proxies = chart.$proxies || (chart.$proxies = {});
    const handlers = {
      attach: createAttachObserver,
      detach: createDetachObserver,
      resize: createResizeObserver
    };
    const handler = handlers[type] || createProxyAndListen;
    proxies[type] = handler(chart, type, listener);
  }
  removeEventListener(chart, type) {
    const proxies = chart.$proxies || (chart.$proxies = {});
    const proxy = proxies[type];
    if (!proxy) {
      return;
    }
    const handlers = {
      attach: releaseObserver,
      detach: releaseObserver,
      resize: releaseObserver
    };
    const handler = handlers[type] || removeListener;
    handler(chart, type, proxy);
    proxies[type] = undefined;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(canvas, width, height, aspectRatio) {
    return getMaximumSize(canvas, width, height, aspectRatio);
  }
  isAttached(canvas) {
    const container = canvas && _getParentNode(canvas);
    return !!(container && container.isConnected);
  }
}
function _detectPlatform(canvas) {
  if (!_isDomSupported() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) {
    return BasicPlatform;
  }
  return DomPlatform;
}
class Element$1 {
  constructor() {
    _defineProperty(this, "x", void 0);
    _defineProperty(this, "y", void 0);
    _defineProperty(this, "active", false);
    _defineProperty(this, "options", void 0);
    _defineProperty(this, "$animations", void 0);
  }
  tooltipPosition(useFinalPosition) {
    const {
      x,
      y
    } = this.getProps(['x', 'y'], useFinalPosition);
    return {
      x,
      y
    };
  }
  hasValue() {
    return isNumber(this.x) && isNumber(this.y);
  }
  getProps(props, final) {
    const anims = this.$animations;
    if (!final || !anims) {
      // let's not create an object, if not needed
      return this;
    }
    const ret = {};
    props.forEach(prop => {
      ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
    });
    return ret;
  }
}
_defineProperty(Element$1, "defaults", {});
_defineProperty(Element$1, "defaultRoutes", undefined);
function autoSkip(scale, ticks) {
  const tickOpts = scale.options.ticks;
  const determinedMaxTicks = determineMaxTicks(scale);
  const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
  const majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
  const numMajorIndices = majorIndices.length;
  const first = majorIndices[0];
  const last = majorIndices[numMajorIndices - 1];
  const newTicks = [];
  if (numMajorIndices > ticksLimit) {
    skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
    return newTicks;
  }
  const spacing = calculateSpacing(majorIndices, ticks, ticksLimit);
  if (numMajorIndices > 0) {
    let i, ilen;
    const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
    skip(ticks, newTicks, spacing, isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
    for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
      skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
    }
    skip(ticks, newTicks, spacing, last, isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
    return newTicks;
  }
  skip(ticks, newTicks, spacing);
  return newTicks;
}
function determineMaxTicks(scale) {
  const offset = scale.options.offset;
  const tickLength = scale._tickSize();
  const maxScale = scale._length / tickLength + (offset ? 0 : 1);
  const maxChart = scale._maxLength / tickLength;
  return Math.floor(Math.min(maxScale, maxChart));
}
function calculateSpacing(majorIndices, ticks, ticksLimit) {
  const evenMajorSpacing = getEvenSpacing(majorIndices);
  const spacing = ticks.length / ticksLimit;
  if (!evenMajorSpacing) {
    return Math.max(spacing, 1);
  }
  const factors = _factorize(evenMajorSpacing);
  for (let i = 0, ilen = factors.length - 1; i < ilen; i++) {
    const factor = factors[i];
    if (factor > spacing) {
      return factor;
    }
  }
  return Math.max(spacing, 1);
}
function getMajorIndices(ticks) {
  const result = [];
  let i, ilen;
  for (i = 0, ilen = ticks.length; i < ilen; i++) {
    if (ticks[i].major) {
      result.push(i);
    }
  }
  return result;
}
function skipMajors(ticks, newTicks, majorIndices, spacing) {
  let count = 0;
  let next = majorIndices[0];
  let i;
  spacing = Math.ceil(spacing);
  for (i = 0; i < ticks.length; i++) {
    if (i === next) {
      newTicks.push(ticks[i]);
      count++;
      next = majorIndices[count * spacing];
    }
  }
}
function skip(ticks, newTicks, spacing, majorStart, majorEnd) {
  const start = valueOrDefault(majorStart, 0);
  const end = Math.min(valueOrDefault(majorEnd, ticks.length), ticks.length);
  let count = 0;
  let length, i, next;
  spacing = Math.ceil(spacing);
  if (majorEnd) {
    length = majorEnd - majorStart;
    spacing = length / Math.floor(length / spacing);
  }
  next = start;
  while (next < 0) {
    count++;
    next = Math.round(start + count * spacing);
  }
  for (i = Math.max(start, 0); i < end; i++) {
    if (i === next) {
      newTicks.push(ticks[i]);
      count++;
      next = Math.round(start + count * spacing);
    }
  }
}
function getEvenSpacing(arr) {
  const len = arr.length;
  let i, diff;
  if (len < 2) {
    return false;
  }
  for (diff = arr[0], i = 1; i < len; ++i) {
    if (arr[i] - arr[i - 1] !== diff) {
      return false;
    }
  }
  return diff;
}
const reverseAlign = align => align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const offsetFromEdge = (scale, edge, offset) => edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const getTicksLimit = (ticksLength, maxTicksLimit) => Math.min(maxTicksLimit || ticksLength, ticksLength);
function sample(arr, numItems) {
  const result = [];
  const increment = arr.length / numItems;
  const len = arr.length;
  let i = 0;
  for (; i < len; i += increment) {
    result.push(arr[Math.floor(i)]);
  }
  return result;
}
function getPixelForGridLine(scale, index, offsetGridLines) {
  const length = scale.ticks.length;
  const validIndex = Math.min(index, length - 1);
  const start = scale._startPixel;
  const end = scale._endPixel;
  const epsilon = 1e-6;
  let lineValue = scale.getPixelForTick(validIndex);
  let offset;
  if (offsetGridLines) {
    if (length === 1) {
      offset = Math.max(lineValue - start, end - lineValue);
    } else if (index === 0) {
      offset = (scale.getPixelForTick(1) - lineValue) / 2;
    } else {
      offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
    }
    lineValue += validIndex < index ? offset : -offset;
    if (lineValue < start - epsilon || lineValue > end + epsilon) {
      return;
    }
  }
  return lineValue;
}
function garbageCollect(caches, length) {
  each(caches, cache => {
    const gc = cache.gc;
    const gcLen = gc.length / 2;
    let i;
    if (gcLen > length) {
      for (i = 0; i < gcLen; ++i) {
        delete cache.data[gc[i]];
      }
      gc.splice(0, gcLen);
    }
  });
}
function getTickMarkLength(options) {
  return options.drawTicks ? options.tickLength : 0;
}
function getTitleHeight(options, fallback) {
  if (!options.display) {
    return 0;
  }
  const font = toFont(options.font, fallback);
  const padding = toPadding(options.padding);
  const lines = isArray(options.text) ? options.text.length : 1;
  return lines * font.lineHeight + padding.height;
}
function createScaleContext(parent, scale) {
  return createContext(parent, {
    scale,
    type: 'scale'
  });
}
function createTickContext(parent, index, tick) {
  return createContext(parent, {
    tick,
    index,
    type: 'tick'
  });
}
function titleAlign(align, position, reverse) {
  let ret = _toLeftRightCenter(align);
  if (reverse && position !== 'right' || !reverse && position === 'right') {
    ret = reverseAlign(ret);
  }
  return ret;
}
function titleArgs(scale, offset, position, align) {
  const {
    top,
    left,
    bottom,
    right,
    chart
  } = scale;
  const {
    chartArea,
    scales
  } = chart;
  let rotation = 0;
  let maxWidth, titleX, titleY;
  const height = bottom - top;
  const width = right - left;
  if (scale.isHorizontal()) {
    titleX = _alignStartEnd(align, left, right);
    if (isObject(position)) {
      const positionAxisID = Object.keys(position)[0];
      const value = position[positionAxisID];
      titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
    } else if (position === 'center') {
      titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
    } else {
      titleY = offsetFromEdge(scale, position, offset);
    }
    maxWidth = right - left;
  } else {
    if (isObject(position)) {
      const positionAxisID = Object.keys(position)[0];
      const value = position[positionAxisID];
      titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
    } else if (position === 'center') {
      titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
    } else {
      titleX = offsetFromEdge(scale, position, offset);
    }
    titleY = _alignStartEnd(align, bottom, top);
    rotation = position === 'left' ? -HALF_PI : HALF_PI;
  }
  return {
    titleX,
    titleY,
    maxWidth,
    rotation
  };
}
class Scale extends Element$1 {
  constructor(cfg) {
    super();
    this.id = cfg.id;
    this.type = cfg.type;
    this.options = undefined;
    this.ctx = cfg.ctx;
    this.chart = cfg.chart;
    this.top = undefined;
    this.bottom = undefined;
    this.left = undefined;
    this.right = undefined;
    this.width = undefined;
    this.height = undefined;
    this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
    this.maxWidth = undefined;
    this.maxHeight = undefined;
    this.paddingTop = undefined;
    this.paddingBottom = undefined;
    this.paddingLeft = undefined;
    this.paddingRight = undefined;
    this.axis = undefined;
    this.labelRotation = undefined;
    this.min = undefined;
    this.max = undefined;
    this._range = undefined;
    this.ticks = [];
    this._gridLineItems = null;
    this._labelItems = null;
    this._labelSizes = null;
    this._length = 0;
    this._maxLength = 0;
    this._longestTextCache = {};
    this._startPixel = undefined;
    this._endPixel = undefined;
    this._reversePixels = false;
    this._userMax = undefined;
    this._userMin = undefined;
    this._suggestedMax = undefined;
    this._suggestedMin = undefined;
    this._ticksLength = 0;
    this._borderValue = 0;
    this._cache = {};
    this._dataLimitsCached = false;
    this.$context = undefined;
  }
  init(options) {
    this.options = options.setContext(this.getContext());
    this.axis = options.axis;
    this._userMin = this.parse(options.min);
    this._userMax = this.parse(options.max);
    this._suggestedMin = this.parse(options.suggestedMin);
    this._suggestedMax = this.parse(options.suggestedMax);
  }
  parse(raw, index) {
    return raw;
  }
  getUserBounds() {
    let {
      _userMin,
      _userMax,
      _suggestedMin,
      _suggestedMax
    } = this;
    _userMin = finiteOrDefault(_userMin, Number.POSITIVE_INFINITY);
    _userMax = finiteOrDefault(_userMax, Number.NEGATIVE_INFINITY);
    _suggestedMin = finiteOrDefault(_suggestedMin, Number.POSITIVE_INFINITY);
    _suggestedMax = finiteOrDefault(_suggestedMax, Number.NEGATIVE_INFINITY);
    return {
      min: finiteOrDefault(_userMin, _suggestedMin),
      max: finiteOrDefault(_userMax, _suggestedMax),
      minDefined: isNumberFinite(_userMin),
      maxDefined: isNumberFinite(_userMax)
    };
  }
  getMinMax(canStack) {
    let {
      min,
      max,
      minDefined,
      maxDefined
    } = this.getUserBounds();
    let range;
    if (minDefined && maxDefined) {
      return {
        min,
        max
      };
    }
    const metas = this.getMatchingVisibleMetas();
    for (let i = 0, ilen = metas.length; i < ilen; ++i) {
      range = metas[i].controller.getMinMax(this, canStack);
      if (!minDefined) {
        min = Math.min(min, range.min);
      }
      if (!maxDefined) {
        max = Math.max(max, range.max);
      }
    }
    min = maxDefined && min > max ? max : min;
    max = minDefined && min > max ? min : max;
    return {
      min: finiteOrDefault(min, finiteOrDefault(max, min)),
      max: finiteOrDefault(max, finiteOrDefault(min, max))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const data = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
  }
  getLabelItems(chartArea = this.chart.chartArea) {
    const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
    return items;
  }
  beforeLayout() {
    this._cache = {};
    this._dataLimitsCached = false;
  }
  beforeUpdate() {
    callback(this.options.beforeUpdate, [this]);
  }
  update(maxWidth, maxHeight, margins) {
    const {
      beginAtZero,
      grace,
      ticks: tickOpts
    } = this.options;
    const sampleSize = tickOpts.sampleSize;
    this.beforeUpdate();
    this.maxWidth = maxWidth;
    this.maxHeight = maxHeight;
    this._margins = margins = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, margins);
    this.ticks = null;
    this._labelSizes = null;
    this._gridLineItems = null;
    this._labelItems = null;
    this.beforeSetDimensions();
    this.setDimensions();
    this.afterSetDimensions();
    this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
    if (!this._dataLimitsCached) {
      this.beforeDataLimits();
      this.determineDataLimits();
      this.afterDataLimits();
      this._range = _addGrace(this, grace, beginAtZero);
      this._dataLimitsCached = true;
    }
    this.beforeBuildTicks();
    this.ticks = this.buildTicks() || [];
    this.afterBuildTicks();
    const samplingEnabled = sampleSize < this.ticks.length;
    this._convertTicksToLabels(samplingEnabled ? sample(this.ticks, sampleSize) : this.ticks);
    this.configure();
    this.beforeCalculateLabelRotation();
    this.calculateLabelRotation();
    this.afterCalculateLabelRotation();
    if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
      this.ticks = autoSkip(this, this.ticks);
      this._labelSizes = null;
      this.afterAutoSkip();
    }
    if (samplingEnabled) {
      this._convertTicksToLabels(this.ticks);
    }
    this.beforeFit();
    this.fit();
    this.afterFit();
    this.afterUpdate();
  }
  configure() {
    let reversePixels = this.options.reverse;
    let startPixel, endPixel;
    if (this.isHorizontal()) {
      startPixel = this.left;
      endPixel = this.right;
    } else {
      startPixel = this.top;
      endPixel = this.bottom;
      reversePixels = !reversePixels;
    }
    this._startPixel = startPixel;
    this._endPixel = endPixel;
    this._reversePixels = reversePixels;
    this._length = endPixel - startPixel;
    this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    callback(this.options.afterUpdate, [this]);
  }
  beforeSetDimensions() {
    callback(this.options.beforeSetDimensions, [this]);
  }
  setDimensions() {
    if (this.isHorizontal()) {
      this.width = this.maxWidth;
      this.left = 0;
      this.right = this.width;
    } else {
      this.height = this.maxHeight;
      this.top = 0;
      this.bottom = this.height;
    }
    this.paddingLeft = 0;
    this.paddingTop = 0;
    this.paddingRight = 0;
    this.paddingBottom = 0;
  }
  afterSetDimensions() {
    callback(this.options.afterSetDimensions, [this]);
  }
  _callHooks(name) {
    this.chart.notifyPlugins(name, this.getContext());
    callback(this.options[name], [this]);
  }
  beforeDataLimits() {
    this._callHooks('beforeDataLimits');
  }
  determineDataLimits() {}
  afterDataLimits() {
    this._callHooks('afterDataLimits');
  }
  beforeBuildTicks() {
    this._callHooks('beforeBuildTicks');
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks('afterBuildTicks');
  }
  beforeTickToLabelConversion() {
    callback(this.options.beforeTickToLabelConversion, [this]);
  }
  generateTickLabels(ticks) {
    const tickOpts = this.options.ticks;
    let i, ilen, tick;
    for (i = 0, ilen = ticks.length; i < ilen; i++) {
      tick = ticks[i];
      tick.label = callback(tickOpts.callback, [tick.value, i, ticks], this);
    }
  }
  afterTickToLabelConversion() {
    callback(this.options.afterTickToLabelConversion, [this]);
  }
  beforeCalculateLabelRotation() {
    callback(this.options.beforeCalculateLabelRotation, [this]);
  }
  calculateLabelRotation() {
    const options = this.options;
    const tickOpts = options.ticks;
    const numTicks = getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
    const minRotation = tickOpts.minRotation || 0;
    const maxRotation = tickOpts.maxRotation;
    let labelRotation = minRotation;
    let tickWidth, maxHeight, maxLabelDiagonal;
    if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
      this.labelRotation = minRotation;
      return;
    }
    const labelSizes = this._getLabelSizes();
    const maxLabelWidth = labelSizes.widest.width;
    const maxLabelHeight = labelSizes.highest.height;
    const maxWidth = _limitValue(this.chart.width - maxLabelWidth, 0, this.maxWidth);
    tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
    if (maxLabelWidth + 6 > tickWidth) {
      tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
      maxHeight = this.maxHeight - getTickMarkLength(options.grid) - tickOpts.padding - getTitleHeight(options.title, this.chart.options.font);
      maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
      labelRotation = toDegrees(Math.min(Math.asin(_limitValue((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin(_limitValue(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin(_limitValue(maxLabelHeight / maxLabelDiagonal, -1, 1))));
      labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
    }
    this.labelRotation = labelRotation;
  }
  afterCalculateLabelRotation() {
    callback(this.options.afterCalculateLabelRotation, [this]);
  }
  afterAutoSkip() {}
  beforeFit() {
    callback(this.options.beforeFit, [this]);
  }
  fit() {
    const minSize = {
      width: 0,
      height: 0
    };
    const {
      chart,
      options: {
        ticks: tickOpts,
        title: titleOpts,
        grid: gridOpts
      }
    } = this;
    const display = this._isVisible();
    const isHorizontal = this.isHorizontal();
    if (display) {
      const titleHeight = getTitleHeight(titleOpts, chart.options.font);
      if (isHorizontal) {
        minSize.width = this.maxWidth;
        minSize.height = getTickMarkLength(gridOpts) + titleHeight;
      } else {
        minSize.height = this.maxHeight;
        minSize.width = getTickMarkLength(gridOpts) + titleHeight;
      }
      if (tickOpts.display && this.ticks.length) {
        const {
          first,
          last,
          widest,
          highest
        } = this._getLabelSizes();
        const tickPadding = tickOpts.padding * 2;
        const angleRadians = toRadians(this.labelRotation);
        const cos = Math.cos(angleRadians);
        const sin = Math.sin(angleRadians);
        if (isHorizontal) {
          const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
          minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
        } else {
          const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
          minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
        }
        this._calculatePadding(first, last, sin, cos);
      }
    }
    this._handleMargins();
    if (isHorizontal) {
      this.width = this._length = chart.width - this._margins.left - this._margins.right;
      this.height = minSize.height;
    } else {
      this.width = minSize.width;
      this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
    }
  }
  _calculatePadding(first, last, sin, cos) {
    const {
      ticks: {
        align,
        padding
      },
      position
    } = this.options;
    const isRotated = this.labelRotation !== 0;
    const labelsBelowTicks = position !== 'top' && this.axis === 'x';
    if (this.isHorizontal()) {
      const offsetLeft = this.getPixelForTick(0) - this.left;
      const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
      let paddingLeft = 0;
      let paddingRight = 0;
      if (isRotated) {
        if (labelsBelowTicks) {
          paddingLeft = cos * first.width;
          paddingRight = sin * last.height;
        } else {
          paddingLeft = sin * first.height;
          paddingRight = cos * last.width;
        }
      } else if (align === 'start') {
        paddingRight = last.width;
      } else if (align === 'end') {
        paddingLeft = first.width;
      } else if (align !== 'inner') {
        paddingLeft = first.width / 2;
        paddingRight = last.width / 2;
      }
      this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
      this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
    } else {
      let paddingTop = last.height / 2;
      let paddingBottom = first.height / 2;
      if (align === 'start') {
        paddingTop = 0;
        paddingBottom = first.height;
      } else if (align === 'end') {
        paddingTop = last.height;
        paddingBottom = 0;
      }
      this.paddingTop = paddingTop + padding;
      this.paddingBottom = paddingBottom + padding;
    }
  }
  _handleMargins() {
    if (this._margins) {
      this._margins.left = Math.max(this.paddingLeft, this._margins.left);
      this._margins.top = Math.max(this.paddingTop, this._margins.top);
      this._margins.right = Math.max(this.paddingRight, this._margins.right);
      this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
    }
  }
  afterFit() {
    callback(this.options.afterFit, [this]);
  }
  isHorizontal() {
    const {
      axis,
      position
    } = this.options;
    return position === 'top' || position === 'bottom' || axis === 'x';
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(ticks) {
    this.beforeTickToLabelConversion();
    this.generateTickLabels(ticks);
    let i, ilen;
    for (i = 0, ilen = ticks.length; i < ilen; i++) {
      if (isNullOrUndef(ticks[i].label)) {
        ticks.splice(i, 1);
        ilen--;
        i--;
      }
    }
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let labelSizes = this._labelSizes;
    if (!labelSizes) {
      const sampleSize = this.options.ticks.sampleSize;
      let ticks = this.ticks;
      if (sampleSize < ticks.length) {
        ticks = sample(ticks, sampleSize);
      }
      this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
    }
    return labelSizes;
  }
  _computeLabelSizes(ticks, length, maxTicksLimit) {
    const {
      ctx,
      _longestTextCache: caches
    } = this;
    const widths = [];
    const heights = [];
    const increment = Math.floor(length / getTicksLimit(length, maxTicksLimit));
    let widestLabelSize = 0;
    let highestLabelSize = 0;
    let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
    for (i = 0; i < length; i += increment) {
      label = ticks[i].label;
      tickFont = this._resolveTickFontOptions(i);
      ctx.font = fontString = tickFont.string;
      cache = caches[fontString] = caches[fontString] || {
        data: {},
        gc: []
      };
      lineHeight = tickFont.lineHeight;
      width = height = 0;
      if (!isNullOrUndef(label) && !isArray(label)) {
        width = _measureText(ctx, cache.data, cache.gc, width, label);
        height = lineHeight;
      } else if (isArray(label)) {
        for (j = 0, jlen = label.length; j < jlen; ++j) {
          nestedLabel = label[j];
          if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
            width = _measureText(ctx, cache.data, cache.gc, width, nestedLabel);
            height += lineHeight;
          }
        }
      }
      widths.push(width);
      heights.push(height);
      widestLabelSize = Math.max(width, widestLabelSize);
      highestLabelSize = Math.max(height, highestLabelSize);
    }
    garbageCollect(caches, length);
    const widest = widths.indexOf(widestLabelSize);
    const highest = heights.indexOf(highestLabelSize);
    const valueAt = idx => ({
      width: widths[idx] || 0,
      height: heights[idx] || 0
    });
    return {
      first: valueAt(0),
      last: valueAt(length - 1),
      widest: valueAt(widest),
      highest: valueAt(highest),
      widths,
      heights
    };
  }
  getLabelForValue(value) {
    return value;
  }
  getPixelForValue(value, index) {
    return NaN;
  }
  getValueForPixel(pixel) {}
  getPixelForTick(index) {
    const ticks = this.ticks;
    if (index < 0 || index > ticks.length - 1) {
      return null;
    }
    return this.getPixelForValue(ticks[index].value);
  }
  getPixelForDecimal(decimal) {
    if (this._reversePixels) {
      decimal = 1 - decimal;
    }
    const pixel = this._startPixel + decimal * this._length;
    return _int16Range(this._alignToPixels ? _alignPixel(this.chart, pixel, 0) : pixel);
  }
  getDecimalForPixel(pixel) {
    const decimal = (pixel - this._startPixel) / this._length;
    return this._reversePixels ? 1 - decimal : decimal;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const {
      min,
      max
    } = this;
    return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
  }
  getContext(index) {
    const ticks = this.ticks || [];
    if (index >= 0 && index < ticks.length) {
      const tick = ticks[index];
      return tick.$context || (tick.$context = createTickContext(this.getContext(), index, tick));
    }
    return this.$context || (this.$context = createScaleContext(this.chart.getContext(), this));
  }
  _tickSize() {
    const optionTicks = this.options.ticks;
    const rot = toRadians(this.labelRotation);
    const cos = Math.abs(Math.cos(rot));
    const sin = Math.abs(Math.sin(rot));
    const labelSizes = this._getLabelSizes();
    const padding = optionTicks.autoSkipPadding || 0;
    const w = labelSizes ? labelSizes.widest.width + padding : 0;
    const h = labelSizes ? labelSizes.highest.height + padding : 0;
    return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
  }
  _isVisible() {
    const display = this.options.display;
    if (display !== 'auto') {
      return !!display;
    }
    return this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(chartArea) {
    const axis = this.axis;
    const chart = this.chart;
    const options = this.options;
    const {
      grid,
      position,
      border
    } = options;
    const offset = grid.offset;
    const isHorizontal = this.isHorizontal();
    const ticks = this.ticks;
    const ticksLength = ticks.length + (offset ? 1 : 0);
    const tl = getTickMarkLength(grid);
    const items = [];
    const borderOpts = border.setContext(this.getContext());
    const axisWidth = borderOpts.display ? borderOpts.width : 0;
    const axisHalfWidth = axisWidth / 2;
    const alignBorderValue = function (pixel) {
      return _alignPixel(chart, pixel, axisWidth);
    };
    let borderValue, i, lineValue, alignedLineValue;
    let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
    if (position === 'top') {
      borderValue = alignBorderValue(this.bottom);
      ty1 = this.bottom - tl;
      ty2 = borderValue - axisHalfWidth;
      y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
      y2 = chartArea.bottom;
    } else if (position === 'bottom') {
      borderValue = alignBorderValue(this.top);
      y1 = chartArea.top;
      y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
      ty1 = borderValue + axisHalfWidth;
      ty2 = this.top + tl;
    } else if (position === 'left') {
      borderValue = alignBorderValue(this.right);
      tx1 = this.right - tl;
      tx2 = borderValue - axisHalfWidth;
      x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
      x2 = chartArea.right;
    } else if (position === 'right') {
      borderValue = alignBorderValue(this.left);
      x1 = chartArea.left;
      x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
      tx1 = borderValue + axisHalfWidth;
      tx2 = this.left + tl;
    } else if (axis === 'x') {
      if (position === 'center') {
        borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
      } else if (isObject(position)) {
        const positionAxisID = Object.keys(position)[0];
        const value = position[positionAxisID];
        borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
      }
      y1 = chartArea.top;
      y2 = chartArea.bottom;
      ty1 = borderValue + axisHalfWidth;
      ty2 = ty1 + tl;
    } else if (axis === 'y') {
      if (position === 'center') {
        borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
      } else if (isObject(position)) {
        const positionAxisID = Object.keys(position)[0];
        const value = position[positionAxisID];
        borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
      }
      tx1 = borderValue - axisHalfWidth;
      tx2 = tx1 - tl;
      x1 = chartArea.left;
      x2 = chartArea.right;
    }
    const limit = valueOrDefault(options.ticks.maxTicksLimit, ticksLength);
    const step = Math.max(1, Math.ceil(ticksLength / limit));
    for (i = 0; i < ticksLength; i += step) {
      const context = this.getContext(i);
      const optsAtIndex = grid.setContext(context);
      const optsAtIndexBorder = border.setContext(context);
      const lineWidth = optsAtIndex.lineWidth;
      const lineColor = optsAtIndex.color;
      const borderDash = optsAtIndexBorder.dash || [];
      const borderDashOffset = optsAtIndexBorder.dashOffset;
      const tickWidth = optsAtIndex.tickWidth;
      const tickColor = optsAtIndex.tickColor;
      const tickBorderDash = optsAtIndex.tickBorderDash || [];
      const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
      lineValue = getPixelForGridLine(this, i, offset);
      if (lineValue === undefined) {
        continue;
      }
      alignedLineValue = _alignPixel(chart, lineValue, lineWidth);
      if (isHorizontal) {
        tx1 = tx2 = x1 = x2 = alignedLineValue;
      } else {
        ty1 = ty2 = y1 = y2 = alignedLineValue;
      }
      items.push({
        tx1,
        ty1,
        tx2,
        ty2,
        x1,
        y1,
        x2,
        y2,
        width: lineWidth,
        color: lineColor,
        borderDash,
        borderDashOffset,
        tickWidth,
        tickColor,
        tickBorderDash,
        tickBorderDashOffset
      });
    }
    this._ticksLength = ticksLength;
    this._borderValue = borderValue;
    return items;
  }
  _computeLabelItems(chartArea) {
    const axis = this.axis;
    const options = this.options;
    const {
      position,
      ticks: optionTicks
    } = options;
    const isHorizontal = this.isHorizontal();
    const ticks = this.ticks;
    const {
      align,
      crossAlign,
      padding,
      mirror
    } = optionTicks;
    const tl = getTickMarkLength(options.grid);
    const tickAndPadding = tl + padding;
    const hTickAndPadding = mirror ? -padding : tickAndPadding;
    const rotation = -toRadians(this.labelRotation);
    const items = [];
    let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
    let textBaseline = 'middle';
    if (position === 'top') {
      y = this.bottom - hTickAndPadding;
      textAlign = this._getXAxisLabelAlignment();
    } else if (position === 'bottom') {
      y = this.top + hTickAndPadding;
      textAlign = this._getXAxisLabelAlignment();
    } else if (position === 'left') {
      const ret = this._getYAxisLabelAlignment(tl);
      textAlign = ret.textAlign;
      x = ret.x;
    } else if (position === 'right') {
      const ret = this._getYAxisLabelAlignment(tl);
      textAlign = ret.textAlign;
      x = ret.x;
    } else if (axis === 'x') {
      if (position === 'center') {
        y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
      } else if (isObject(position)) {
        const positionAxisID = Object.keys(position)[0];
        const value = position[positionAxisID];
        y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
      }
      textAlign = this._getXAxisLabelAlignment();
    } else if (axis === 'y') {
      if (position === 'center') {
        x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
      } else if (isObject(position)) {
        const positionAxisID = Object.keys(position)[0];
        const value = position[positionAxisID];
        x = this.chart.scales[positionAxisID].getPixelForValue(value);
      }
      textAlign = this._getYAxisLabelAlignment(tl).textAlign;
    }
    if (axis === 'y') {
      if (align === 'start') {
        textBaseline = 'top';
      } else if (align === 'end') {
        textBaseline = 'bottom';
      }
    }
    const labelSizes = this._getLabelSizes();
    for (i = 0, ilen = ticks.length; i < ilen; ++i) {
      tick = ticks[i];
      label = tick.label;
      const optsAtIndex = optionTicks.setContext(this.getContext(i));
      pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
      font = this._resolveTickFontOptions(i);
      lineHeight = font.lineHeight;
      lineCount = isArray(label) ? label.length : 1;
      const halfCount = lineCount / 2;
      const color = optsAtIndex.color;
      const strokeColor = optsAtIndex.textStrokeColor;
      const strokeWidth = optsAtIndex.textStrokeWidth;
      let tickTextAlign = textAlign;
      if (isHorizontal) {
        x = pixel;
        if (textAlign === 'inner') {
          if (i === ilen - 1) {
            tickTextAlign = !this.options.reverse ? 'right' : 'left';
          } else if (i === 0) {
            tickTextAlign = !this.options.reverse ? 'left' : 'right';
          } else {
            tickTextAlign = 'center';
          }
        }
        if (position === 'top') {
          if (crossAlign === 'near' || rotation !== 0) {
            textOffset = -lineCount * lineHeight + lineHeight / 2;
          } else if (crossAlign === 'center') {
            textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
          } else {
            textOffset = -labelSizes.highest.height + lineHeight / 2;
          }
        } else {
          if (crossAlign === 'near' || rotation !== 0) {
            textOffset = lineHeight / 2;
          } else if (crossAlign === 'center') {
            textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
          } else {
            textOffset = labelSizes.highest.height - lineCount * lineHeight;
          }
        }
        if (mirror) {
          textOffset *= -1;
        }
        if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) {
          x += lineHeight / 2 * Math.sin(rotation);
        }
      } else {
        y = pixel;
        textOffset = (1 - lineCount) * lineHeight / 2;
      }
      let backdrop;
      if (optsAtIndex.showLabelBackdrop) {
        const labelPadding = toPadding(optsAtIndex.backdropPadding);
        const height = labelSizes.heights[i];
        const width = labelSizes.widths[i];
        let top = textOffset - labelPadding.top;
        let left = 0 - labelPadding.left;
        switch (textBaseline) {
          case 'middle':
            top -= height / 2;
            break;
          case 'bottom':
            top -= height;
            break;
        }
        switch (textAlign) {
          case 'center':
            left -= width / 2;
            break;
          case 'right':
            left -= width;
            break;
          case 'inner':
            if (i === ilen - 1) {
              left -= width;
            } else if (i > 0) {
              left -= width / 2;
            }
            break;
        }
        backdrop = {
          left,
          top,
          width: width + labelPadding.width,
          height: height + labelPadding.height,
          color: optsAtIndex.backdropColor
        };
      }
      items.push({
        label,
        font,
        textOffset,
        options: {
          rotation,
          color,
          strokeColor,
          strokeWidth,
          textAlign: tickTextAlign,
          textBaseline,
          translation: [x, y],
          backdrop
        }
      });
    }
    return items;
  }
  _getXAxisLabelAlignment() {
    const {
      position,
      ticks
    } = this.options;
    const rotation = -toRadians(this.labelRotation);
    if (rotation) {
      return position === 'top' ? 'left' : 'right';
    }
    let align = 'center';
    if (ticks.align === 'start') {
      align = 'left';
    } else if (ticks.align === 'end') {
      align = 'right';
    } else if (ticks.align === 'inner') {
      align = 'inner';
    }
    return align;
  }
  _getYAxisLabelAlignment(tl) {
    const {
      position,
      ticks: {
        crossAlign,
        mirror,
        padding
      }
    } = this.options;
    const labelSizes = this._getLabelSizes();
    const tickAndPadding = tl + padding;
    const widest = labelSizes.widest.width;
    let textAlign;
    let x;
    if (position === 'left') {
      if (mirror) {
        x = this.right + padding;
        if (crossAlign === 'near') {
          textAlign = 'left';
        } else if (crossAlign === 'center') {
          textAlign = 'center';
          x += widest / 2;
        } else {
          textAlign = 'right';
          x += widest;
        }
      } else {
        x = this.right - tickAndPadding;
        if (crossAlign === 'near') {
          textAlign = 'right';
        } else if (crossAlign === 'center') {
          textAlign = 'center';
          x -= widest / 2;
        } else {
          textAlign = 'left';
          x = this.left;
        }
      }
    } else if (position === 'right') {
      if (mirror) {
        x = this.left + padding;
        if (crossAlign === 'near') {
          textAlign = 'right';
        } else if (crossAlign === 'center') {
          textAlign = 'center';
          x -= widest / 2;
        } else {
          textAlign = 'left';
          x -= widest;
        }
      } else {
        x = this.left + tickAndPadding;
        if (crossAlign === 'near') {
          textAlign = 'left';
        } else if (crossAlign === 'center') {
          textAlign = 'center';
          x += widest / 2;
        } else {
          textAlign = 'right';
          x = this.right;
        }
      }
    } else {
      textAlign = 'right';
    }
    return {
      textAlign,
      x
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror) {
      return;
    }
    const chart = this.chart;
    const position = this.options.position;
    if (position === 'left' || position === 'right') {
      return {
        top: 0,
        left: this.left,
        bottom: chart.height,
        right: this.right
      };
    }
    if (position === 'top' || position === 'bottom') {
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: chart.width
      };
    }
  }
  drawBackground() {
    const {
      ctx,
      options: {
        backgroundColor
      },
      left,
      top,
      width,
      height
    } = this;
    if (backgroundColor) {
      ctx.save();
      ctx.fillStyle = backgroundColor;
      ctx.fillRect(left, top, width, height);
      ctx.restore();
    }
  }
  getLineWidthForValue(value) {
    const grid = this.options.grid;
    if (!this._isVisible() || !grid.display) {
      return 0;
    }
    const ticks = this.ticks;
    const index = ticks.findIndex(t => t.value === value);
    if (index >= 0) {
      const opts = grid.setContext(this.getContext(index));
      return opts.lineWidth;
    }
    return 0;
  }
  drawGrid(chartArea) {
    const grid = this.options.grid;
    const ctx = this.ctx;
    const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
    let i, ilen;
    const drawLine = (p1, p2, style) => {
      if (!style.width || !style.color) {
        return;
      }
      ctx.save();
      ctx.lineWidth = style.width;
      ctx.strokeStyle = style.color;
      ctx.setLineDash(style.borderDash || []);
      ctx.lineDashOffset = style.borderDashOffset;
      ctx.beginPath();
      ctx.moveTo(p1.x, p1.y);
      ctx.lineTo(p2.x, p2.y);
      ctx.stroke();
      ctx.restore();
    };
    if (grid.display) {
      for (i = 0, ilen = items.length; i < ilen; ++i) {
        const item = items[i];
        if (grid.drawOnChartArea) {
          drawLine({
            x: item.x1,
            y: item.y1
          }, {
            x: item.x2,
            y: item.y2
          }, item);
        }
        if (grid.drawTicks) {
          drawLine({
            x: item.tx1,
            y: item.ty1
          }, {
            x: item.tx2,
            y: item.ty2
          }, {
            color: item.tickColor,
            width: item.tickWidth,
            borderDash: item.tickBorderDash,
            borderDashOffset: item.tickBorderDashOffset
          });
        }
      }
    }
  }
  drawBorder() {
    const {
      chart,
      ctx,
      options: {
        border,
        grid
      }
    } = this;
    const borderOpts = border.setContext(this.getContext());
    const axisWidth = border.display ? borderOpts.width : 0;
    if (!axisWidth) {
      return;
    }
    const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
    const borderValue = this._borderValue;
    let x1, x2, y1, y2;
    if (this.isHorizontal()) {
      x1 = _alignPixel(chart, this.left, axisWidth) - axisWidth / 2;
      x2 = _alignPixel(chart, this.right, lastLineWidth) + lastLineWidth / 2;
      y1 = y2 = borderValue;
    } else {
      y1 = _alignPixel(chart, this.top, axisWidth) - axisWidth / 2;
      y2 = _alignPixel(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
      x1 = x2 = borderValue;
    }
    ctx.save();
    ctx.lineWidth = borderOpts.width;
    ctx.strokeStyle = borderOpts.color;
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.stroke();
    ctx.restore();
  }
  drawLabels(chartArea) {
    const optionTicks = this.options.ticks;
    if (!optionTicks.display) {
      return;
    }
    const ctx = this.ctx;
    const area = this._computeLabelArea();
    if (area) {
      clipArea(ctx, area);
    }
    const items = this.getLabelItems(chartArea);
    for (const item of items) {
      const renderTextOptions = item.options;
      const tickFont = item.font;
      const label = item.label;
      const y = item.textOffset;
      renderText(ctx, label, 0, y, tickFont, renderTextOptions);
    }
    if (area) {
      unclipArea(ctx);
    }
  }
  drawTitle() {
    const {
      ctx,
      options: {
        position,
        title,
        reverse
      }
    } = this;
    if (!title.display) {
      return;
    }
    const font = toFont(title.font);
    const padding = toPadding(title.padding);
    const align = title.align;
    let offset = font.lineHeight / 2;
    if (position === 'bottom' || position === 'center' || isObject(position)) {
      offset += padding.bottom;
      if (isArray(title.text)) {
        offset += font.lineHeight * (title.text.length - 1);
      }
    } else {
      offset += padding.top;
    }
    const {
      titleX,
      titleY,
      maxWidth,
      rotation
    } = titleArgs(this, offset, position, align);
    renderText(ctx, title.text, 0, 0, font, {
      color: title.color,
      maxWidth,
      rotation,
      textAlign: titleAlign(align, position, reverse),
      textBaseline: 'middle',
      translation: [titleX, titleY]
    });
  }
  draw(chartArea) {
    if (!this._isVisible()) {
      return;
    }
    this.drawBackground();
    this.drawGrid(chartArea);
    this.drawBorder();
    this.drawTitle();
    this.drawLabels(chartArea);
  }
  _layers() {
    const opts = this.options;
    const tz = opts.ticks && opts.ticks.z || 0;
    const gz = valueOrDefault(opts.grid && opts.grid.z, -1);
    const bz = valueOrDefault(opts.border && opts.border.z, 0);
    if (!this._isVisible() || this.draw !== Scale.prototype.draw) {
      return [{
        z: tz,
        draw: chartArea => {
          this.draw(chartArea);
        }
      }];
    }
    return [{
      z: gz,
      draw: chartArea => {
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawTitle();
      }
    }, {
      z: bz,
      draw: () => {
        this.drawBorder();
      }
    }, {
      z: tz,
      draw: chartArea => {
        this.drawLabels(chartArea);
      }
    }];
  }
  getMatchingVisibleMetas(type) {
    const metas = this.chart.getSortedVisibleDatasetMetas();
    const axisID = this.axis + 'AxisID';
    const result = [];
    let i, ilen;
    for (i = 0, ilen = metas.length; i < ilen; ++i) {
      const meta = metas[i];
      if (meta[axisID] === this.id && (!type || meta.type === type)) {
        result.push(meta);
      }
    }
    return result;
  }
  _resolveTickFontOptions(index) {
    const opts = this.options.ticks.setContext(this.getContext(index));
    return toFont(opts.font);
  }
  _maxDigits() {
    const fontSize = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / fontSize;
  }
}
class TypedRegistry {
  constructor(type, scope, override) {
    this.type = type;
    this.scope = scope;
    this.override = override;
    this.items = Object.create(null);
  }
  isForType(type) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
  }
  register(item) {
    const proto = Object.getPrototypeOf(item);
    let parentScope;
    if (isIChartComponent(proto)) {
      parentScope = this.register(proto);
    }
    const items = this.items;
    const id = item.id;
    const scope = this.scope + '.' + id;
    if (!id) {
      throw new Error('class does not have id: ' + item);
    }
    if (id in items) {
      return scope;
    }
    items[id] = item;
    registerDefaults(item, scope, parentScope);
    if (this.override) {
      defaults.override(item.id, item.overrides);
    }
    return scope;
  }
  get(id) {
    return this.items[id];
  }
  unregister(item) {
    const items = this.items;
    const id = item.id;
    const scope = this.scope;
    if (id in items) {
      delete items[id];
    }
    if (scope && id in defaults[scope]) {
      delete defaults[scope][id];
      if (this.override) {
        delete overrides[id];
      }
    }
  }
}
function registerDefaults(item, scope, parentScope) {
  const itemDefaults = merge(Object.create(null), [parentScope ? defaults.get(parentScope) : {}, defaults.get(scope), item.defaults]);
  defaults.set(scope, itemDefaults);
  if (item.defaultRoutes) {
    routeDefaults(scope, item.defaultRoutes);
  }
  if (item.descriptors) {
    defaults.describe(scope, item.descriptors);
  }
}
function routeDefaults(scope, routes) {
  Object.keys(routes).forEach(property => {
    const propertyParts = property.split('.');
    const sourceName = propertyParts.pop();
    const sourceScope = [scope].concat(propertyParts).join('.');
    const parts = routes[property].split('.');
    const targetName = parts.pop();
    const targetScope = parts.join('.');
    defaults.route(sourceScope, sourceName, targetScope, targetName);
  });
}
function isIChartComponent(proto) {
  return 'id' in proto && 'defaults' in proto;
}
class Registry {
  constructor() {
    this.controllers = new TypedRegistry(DatasetController, 'datasets', true);
    this.elements = new TypedRegistry(Element$1, 'elements');
    this.plugins = new TypedRegistry(Object, 'plugins');
    this.scales = new TypedRegistry(Scale, 'scales');
    this._typedRegistries = [this.controllers, this.scales, this.elements];
  }
  add(...args) {
    this._each('register', args);
  }
  remove(...args) {
    this._each('unregister', args);
  }
  addControllers(...args) {
    this._each('register', args, this.controllers);
  }
  addElements(...args) {
    this._each('register', args, this.elements);
  }
  addPlugins(...args) {
    this._each('register', args, this.plugins);
  }
  addScales(...args) {
    this._each('register', args, this.scales);
  }
  getController(id) {
    return this._get(id, this.controllers, 'controller');
  }
  getElement(id) {
    return this._get(id, this.elements, 'element');
  }
  getPlugin(id) {
    return this._get(id, this.plugins, 'plugin');
  }
  getScale(id) {
    return this._get(id, this.scales, 'scale');
  }
  removeControllers(...args) {
    this._each('unregister', args, this.controllers);
  }
  removeElements(...args) {
    this._each('unregister', args, this.elements);
  }
  removePlugins(...args) {
    this._each('unregister', args, this.plugins);
  }
  removeScales(...args) {
    this._each('unregister', args, this.scales);
  }
  _each(method, args, typedRegistry) {
    [...args].forEach(arg => {
      const reg = typedRegistry || this._getRegistryForType(arg);
      if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) {
        this._exec(method, reg, arg);
      } else {
        each(arg, item => {
          const itemReg = typedRegistry || this._getRegistryForType(item);
          this._exec(method, itemReg, item);
        });
      }
    });
  }
  _exec(method, registry, component) {
    const camelMethod = _capitalize(method);
    callback(component['before' + camelMethod], [], component);
    registry[method](component);
    callback(component['after' + camelMethod], [], component);
  }
  _getRegistryForType(type) {
    for (let i = 0; i < this._typedRegistries.length; i++) {
      const reg = this._typedRegistries[i];
      if (reg.isForType(type)) {
        return reg;
      }
    }
    return this.plugins;
  }
  _get(id, typedRegistry, type) {
    const item = typedRegistry.get(id);
    if (item === undefined) {
      throw new Error('"' + id + '" is not a registered ' + type + '.');
    }
    return item;
  }
}
var registry = /* #__PURE__ */new Registry();
class PluginService {
  constructor() {
    this._init = [];
  }
  notify(chart, hook, args, filter) {
    if (hook === 'beforeInit') {
      this._init = this._createDescriptors(chart, true);
      this._notify(this._init, chart, 'install');
    }
    const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
    const result = this._notify(descriptors, chart, hook, args);
    if (hook === 'afterDestroy') {
      this._notify(descriptors, chart, 'stop');
      this._notify(this._init, chart, 'uninstall');
    }
    return result;
  }
  _notify(descriptors, chart, hook, args) {
    args = args || {};
    for (const descriptor of descriptors) {
      const plugin = descriptor.plugin;
      const method = plugin[hook];
      const params = [chart, args, descriptor.options];
      if (callback(method, params, plugin) === false && args.cancelable) {
        return false;
      }
    }
    return true;
  }
  invalidate() {
    if (!isNullOrUndef(this._cache)) {
      this._oldCache = this._cache;
      this._cache = undefined;
    }
  }
  _descriptors(chart) {
    if (this._cache) {
      return this._cache;
    }
    const descriptors = this._cache = this._createDescriptors(chart);
    this._notifyStateChanges(chart);
    return descriptors;
  }
  _createDescriptors(chart, all) {
    const config = chart && chart.config;
    const options = valueOrDefault(config.options && config.options.plugins, {});
    const plugins = allPlugins(config);
    return options === false && !all ? [] : createDescriptors(chart, plugins, options, all);
  }
  _notifyStateChanges(chart) {
    const previousDescriptors = this._oldCache || [];
    const descriptors = this._cache;
    const diff = (a, b) => a.filter(x => !b.some(y => x.plugin.id === y.plugin.id));
    this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
    this._notify(diff(descriptors, previousDescriptors), chart, 'start');
  }
}
function allPlugins(config) {
  const localIds = {};
  const plugins = [];
  const keys = Object.keys(registry.plugins.items);
  for (let i = 0; i < keys.length; i++) {
    plugins.push(registry.getPlugin(keys[i]));
  }
  const local = config.plugins || [];
  for (let i = 0; i < local.length; i++) {
    const plugin = local[i];
    if (plugins.indexOf(plugin) === -1) {
      plugins.push(plugin);
      localIds[plugin.id] = true;
    }
  }
  return {
    plugins,
    localIds
  };
}
function getOpts(options, all) {
  if (!all && options === false) {
    return null;
  }
  if (options === true) {
    return {};
  }
  return options;
}
function createDescriptors(chart, {
  plugins,
  localIds
}, options, all) {
  const result = [];
  const context = chart.getContext();
  for (const plugin of plugins) {
    const id = plugin.id;
    const opts = getOpts(options[id], all);
    if (opts === null) {
      continue;
    }
    result.push({
      plugin,
      options: pluginOpts(chart.config, {
        plugin,
        local: localIds[id]
      }, opts, context)
    });
  }
  return result;
}
function pluginOpts(config, {
  plugin,
  local
}, opts, context) {
  const keys = config.pluginScopeKeys(plugin);
  const scopes = config.getOptionScopes(opts, keys);
  if (local && plugin.defaults) {
    scopes.push(plugin.defaults);
  }
  return config.createResolver(scopes, context, [''], {
    scriptable: false,
    indexable: false,
    allKeys: true
  });
}
function getIndexAxis(type, options) {
  const datasetDefaults = defaults.datasets[type] || {};
  const datasetOptions = (options.datasets || {})[type] || {};
  return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function getAxisFromDefaultScaleID(id, indexAxis) {
  let axis = id;
  if (id === '_index_') {
    axis = indexAxis;
  } else if (id === '_value_') {
    axis = indexAxis === 'x' ? 'y' : 'x';
  }
  return axis;
}
function getDefaultScaleIDFromAxis(axis, indexAxis) {
  return axis === indexAxis ? '_index_' : '_value_';
}
function idMatchesAxis(id) {
  if (id === 'x' || id === 'y' || id === 'r') {
    return id;
  }
}
function axisFromPosition(position) {
  if (position === 'top' || position === 'bottom') {
    return 'x';
  }
  if (position === 'left' || position === 'right') {
    return 'y';
  }
}
function determineAxis(id, ...scaleOptions) {
  if (idMatchesAxis(id)) {
    return id;
  }
  for (const opts of scaleOptions) {
    const axis = opts.axis || axisFromPosition(opts.position) || id.length > 1 && idMatchesAxis(id[0].toLowerCase());
    if (axis) {
      return axis;
    }
  }
  throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function getAxisFromDataset(id, axis, dataset) {
  if (dataset[axis + 'AxisID'] === id) {
    return {
      axis
    };
  }
}
function retrieveAxisFromDatasets(id, config) {
  if (config.data && config.data.datasets) {
    const boundDs = config.data.datasets.filter(d => d.xAxisID === id || d.yAxisID === id);
    if (boundDs.length) {
      return getAxisFromDataset(id, 'x', boundDs[0]) || getAxisFromDataset(id, 'y', boundDs[0]);
    }
  }
  return {};
}
function mergeScaleConfig(config, options) {
  const chartDefaults = overrides[config.type] || {
    scales: {}
  };
  const configScales = options.scales || {};
  const chartIndexAxis = getIndexAxis(config.type, options);
  const scales = Object.create(null);
  Object.keys(configScales).forEach(id => {
    const scaleConf = configScales[id];
    if (!isObject(scaleConf)) {
      return console.error(`Invalid scale configuration for scale: ${id}`);
    }
    if (scaleConf._proxy) {
      return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
    }
    const axis = determineAxis(id, scaleConf, retrieveAxisFromDatasets(id, config), defaults.scales[scaleConf.type]);
    const defaultId = getDefaultScaleIDFromAxis(axis, chartIndexAxis);
    const defaultScaleOptions = chartDefaults.scales || {};
    scales[id] = mergeIf(Object.create(null), [{
      axis
    }, scaleConf, defaultScaleOptions[axis], defaultScaleOptions[defaultId]]);
  });
  config.data.datasets.forEach(dataset => {
    const type = dataset.type || config.type;
    const indexAxis = dataset.indexAxis || getIndexAxis(type, options);
    const datasetDefaults = overrides[type] || {};
    const defaultScaleOptions = datasetDefaults.scales || {};
    Object.keys(defaultScaleOptions).forEach(defaultID => {
      const axis = getAxisFromDefaultScaleID(defaultID, indexAxis);
      const id = dataset[axis + 'AxisID'] || axis;
      scales[id] = scales[id] || Object.create(null);
      mergeIf(scales[id], [{
        axis
      }, configScales[id], defaultScaleOptions[defaultID]]);
    });
  });
  Object.keys(scales).forEach(key => {
    const scale = scales[key];
    mergeIf(scale, [defaults.scales[scale.type], defaults.scale]);
  });
  return scales;
}
function initOptions(config) {
  const options = config.options || (config.options = {});
  options.plugins = valueOrDefault(options.plugins, {});
  options.scales = mergeScaleConfig(config, options);
}
function initData(data) {
  data = data || {};
  data.datasets = data.datasets || [];
  data.labels = data.labels || [];
  return data;
}
function initConfig(config) {
  config = config || {};
  config.data = initData(config.data);
  initOptions(config);
  return config;
}
const keyCache = new Map();
const keysCached = new Set();
function cachedKeys(cacheKey, generate) {
  let keys = keyCache.get(cacheKey);
  if (!keys) {
    keys = generate();
    keyCache.set(cacheKey, keys);
    keysCached.add(keys);
  }
  return keys;
}
const addIfFound = (set, obj, key) => {
  const opts = resolveObjectKey(obj, key);
  if (opts !== undefined) {
    set.add(opts);
  }
};
class Config {
  constructor(config) {
    this._config = initConfig(config);
    this._scopeCache = new Map();
    this._resolverCache = new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(type) {
    this._config.type = type;
  }
  get data() {
    return this._config.data;
  }
  set data(data) {
    this._config.data = initData(data);
  }
  get options() {
    return this._config.options;
  }
  set options(options) {
    this._config.options = options;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const config = this._config;
    this.clearCache();
    initOptions(config);
  }
  clearCache() {
    this._scopeCache.clear();
    this._resolverCache.clear();
  }
  datasetScopeKeys(datasetType) {
    return cachedKeys(datasetType, () => [[`datasets.${datasetType}`, '']]);
  }
  datasetAnimationScopeKeys(datasetType, transition) {
    return cachedKeys(`${datasetType}.transition.${transition}`, () => [[`datasets.${datasetType}.transitions.${transition}`, `transitions.${transition}`], [`datasets.${datasetType}`, '']]);
  }
  datasetElementScopeKeys(datasetType, elementType) {
    return cachedKeys(`${datasetType}-${elementType}`, () => [[`datasets.${datasetType}.elements.${elementType}`, `datasets.${datasetType}`, `elements.${elementType}`, '']]);
  }
  pluginScopeKeys(plugin) {
    const id = plugin.id;
    const type = this.type;
    return cachedKeys(`${type}-plugin-${id}`, () => [[`plugins.${id}`, ...(plugin.additionalOptionScopes || [])]]);
  }
  _cachedScopes(mainScope, resetCache) {
    const _scopeCache = this._scopeCache;
    let cache = _scopeCache.get(mainScope);
    if (!cache || resetCache) {
      cache = new Map();
      _scopeCache.set(mainScope, cache);
    }
    return cache;
  }
  getOptionScopes(mainScope, keyLists, resetCache) {
    const {
      options,
      type
    } = this;
    const cache = this._cachedScopes(mainScope, resetCache);
    const cached = cache.get(keyLists);
    if (cached) {
      return cached;
    }
    const scopes = new Set();
    keyLists.forEach(keys => {
      if (mainScope) {
        scopes.add(mainScope);
        keys.forEach(key => addIfFound(scopes, mainScope, key));
      }
      keys.forEach(key => addIfFound(scopes, options, key));
      keys.forEach(key => addIfFound(scopes, overrides[type] || {}, key));
      keys.forEach(key => addIfFound(scopes, defaults, key));
      keys.forEach(key => addIfFound(scopes, descriptors, key));
    });
    const array = Array.from(scopes);
    if (array.length === 0) {
      array.push(Object.create(null));
    }
    if (keysCached.has(keyLists)) {
      cache.set(keyLists, array);
    }
    return array;
  }
  chartOptionScopes() {
    const {
      options,
      type
    } = this;
    return [options, overrides[type] || {}, defaults.datasets[type] || {}, {
      type
    }, defaults, descriptors];
  }
  resolveNamedOptions(scopes, names, context, prefixes = ['']) {
    const result = {
      $shared: true
    };
    const {
      resolver,
      subPrefixes
    } = getResolver(this._resolverCache, scopes, prefixes);
    let options = resolver;
    if (needContext(resolver, names)) {
      result.$shared = false;
      context = isFunction(context) ? context() : context;
      const subResolver = this.createResolver(scopes, context, subPrefixes);
      options = _attachContext(resolver, context, subResolver);
    }
    for (const prop of names) {
      result[prop] = options[prop];
    }
    return result;
  }
  createResolver(scopes, context, prefixes = [''], descriptorDefaults) {
    const {
      resolver
    } = getResolver(this._resolverCache, scopes, prefixes);
    return isObject(context) ? _attachContext(resolver, context, undefined, descriptorDefaults) : resolver;
  }
}
function getResolver(resolverCache, scopes, prefixes) {
  let cache = resolverCache.get(scopes);
  if (!cache) {
    cache = new Map();
    resolverCache.set(scopes, cache);
  }
  const cacheKey = prefixes.join();
  let cached = cache.get(cacheKey);
  if (!cached) {
    const resolver = _createResolver(scopes, prefixes);
    cached = {
      resolver,
      subPrefixes: prefixes.filter(p => !p.toLowerCase().includes('hover'))
    };
    cache.set(cacheKey, cached);
  }
  return cached;
}
const hasFunction = value => isObject(value) && Object.getOwnPropertyNames(value).some(key => isFunction(value[key]));
function needContext(proxy, names) {
  const {
    isScriptable,
    isIndexable
  } = _descriptors(proxy);
  for (const prop of names) {
    const scriptable = isScriptable(prop);
    const indexable = isIndexable(prop);
    const value = (indexable || scriptable) && proxy[prop];
    if (scriptable && (isFunction(value) || hasFunction(value)) || indexable && isArray(value)) {
      return true;
    }
  }
  return false;
}
var version = "4.4.7";
const KNOWN_POSITIONS = ['top', 'bottom', 'left', 'right', 'chartArea'];
function positionIsHorizontal(position, axis) {
  return position === 'top' || position === 'bottom' || KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function compare2Level(l1, l2) {
  return function (a, b) {
    return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
  };
}
function onAnimationsComplete(context) {
  const chart = context.chart;
  const animationOptions = chart.options.animation;
  chart.notifyPlugins('afterRender');
  callback(animationOptions && animationOptions.onComplete, [context], chart);
}
function onAnimationProgress(context) {
  const chart = context.chart;
  const animationOptions = chart.options.animation;
  callback(animationOptions && animationOptions.onProgress, [context], chart);
}
function getCanvas(item) {
  if (_isDomSupported() && typeof item === 'string') {
    item = document.getElementById(item);
  } else if (item && item.length) {
    item = item[0];
  }
  if (item && item.canvas) {
    item = item.canvas;
  }
  return item;
}
const instances = {};
const getChart = key => {
  const canvas = getCanvas(key);
  return Object.values(instances).filter(c => c.canvas === canvas).pop();
};
function moveNumericKeys(obj, start, move) {
  const keys = Object.keys(obj);
  for (const key of keys) {
    const intKey = +key;
    if (intKey >= start) {
      const value = obj[key];
      delete obj[key];
      if (move > 0 || intKey > start) {
        obj[intKey + move] = value;
      }
    }
  }
}
function determineLastEvent(e, lastEvent, inChartArea, isClick) {
  if (!inChartArea || e.type === 'mouseout') {
    return null;
  }
  if (isClick) {
    return lastEvent;
  }
  return e;
}
function getSizeForArea(scale, chartArea, field) {
  return scale.options.clip ? scale[field] : chartArea[field];
}
function getDatasetArea(meta, chartArea) {
  const {
    xScale,
    yScale
  } = meta;
  if (xScale && yScale) {
    return {
      left: getSizeForArea(xScale, chartArea, 'left'),
      right: getSizeForArea(xScale, chartArea, 'right'),
      top: getSizeForArea(yScale, chartArea, 'top'),
      bottom: getSizeForArea(yScale, chartArea, 'bottom')
    };
  }
  return chartArea;
}
class Chart {
  static register(...items) {
    registry.add(...items);
    invalidatePlugins();
  }
  static unregister(...items) {
    registry.remove(...items);
    invalidatePlugins();
  }
  constructor(item, userConfig) {
    const config = this.config = new Config(userConfig);
    const initialCanvas = getCanvas(item);
    const existingChart = getChart(initialCanvas);
    if (existingChart) {
      throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
    }
    const options = config.createResolver(config.chartOptionScopes(), this.getContext());
    this.platform = new (config.platform || _detectPlatform(initialCanvas))();
    this.platform.updateConfig(config);
    const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
    const canvas = context && context.canvas;
    const height = canvas && canvas.height;
    const width = canvas && canvas.width;
    this.id = uid();
    this.ctx = context;
    this.canvas = canvas;
    this.width = width;
    this.height = height;
    this._options = options;
    this._aspectRatio = this.aspectRatio;
    this._layers = [];
    this._metasets = [];
    this._stacks = undefined;
    this.boxes = [];
    this.currentDevicePixelRatio = undefined;
    this.chartArea = undefined;
    this._active = [];
    this._lastEvent = undefined;
    this._listeners = {};
    this._responsiveListeners = undefined;
    this._sortedMetasets = [];
    this.scales = {};
    this._plugins = new PluginService();
    this.$proxies = {};
    this._hiddenIndices = {};
    this.attached = false;
    this._animationsDisabled = undefined;
    this.$context = undefined;
    this._doResize = debounce(mode => this.update(mode), options.resizeDelay || 0);
    this._dataChanges = [];
    instances[this.id] = this;
    if (!context || !canvas) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    animator.listen(this, 'complete', onAnimationsComplete);
    animator.listen(this, 'progress', onAnimationProgress);
    this._initialize();
    if (this.attached) {
      this.update();
    }
  }
  get aspectRatio() {
    const {
      options: {
        aspectRatio,
        maintainAspectRatio
      },
      width,
      height,
      _aspectRatio
    } = this;
    if (!isNullOrUndef(aspectRatio)) {
      return aspectRatio;
    }
    if (maintainAspectRatio && _aspectRatio) {
      return _aspectRatio;
    }
    return height ? width / height : null;
  }
  get data() {
    return this.config.data;
  }
  set data(data) {
    this.config.data = data;
  }
  get options() {
    return this._options;
  }
  set options(options) {
    this.config.options = options;
  }
  get registry() {
    return registry;
  }
  _initialize() {
    this.notifyPlugins('beforeInit');
    if (this.options.responsive) {
      this.resize();
    } else {
      retinaScale(this, this.options.devicePixelRatio);
    }
    this.bindEvents();
    this.notifyPlugins('afterInit');
    return this;
  }
  clear() {
    clearCanvas(this.canvas, this.ctx);
    return this;
  }
  stop() {
    animator.stop(this);
    return this;
  }
  resize(width, height) {
    if (!animator.running(this)) {
      this._resize(width, height);
    } else {
      this._resizeBeforeDraw = {
        width,
        height
      };
    }
  }
  _resize(width, height) {
    const options = this.options;
    const canvas = this.canvas;
    const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
    const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
    const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
    const mode = this.width ? 'resize' : 'attach';
    this.width = newSize.width;
    this.height = newSize.height;
    this._aspectRatio = this.aspectRatio;
    if (!retinaScale(this, newRatio, true)) {
      return;
    }
    this.notifyPlugins('resize', {
      size: newSize
    });
    callback(options.onResize, [this, newSize], this);
    if (this.attached) {
      if (this._doResize(mode)) {
        this.render();
      }
    }
  }
  ensureScalesHaveIDs() {
    const options = this.options;
    const scalesOptions = options.scales || {};
    each(scalesOptions, (axisOptions, axisID) => {
      axisOptions.id = axisID;
    });
  }
  buildOrUpdateScales() {
    const options = this.options;
    const scaleOpts = options.scales;
    const scales = this.scales;
    const updated = Object.keys(scales).reduce((obj, id) => {
      obj[id] = false;
      return obj;
    }, {});
    let items = [];
    if (scaleOpts) {
      items = items.concat(Object.keys(scaleOpts).map(id => {
        const scaleOptions = scaleOpts[id];
        const axis = determineAxis(id, scaleOptions);
        const isRadial = axis === 'r';
        const isHorizontal = axis === 'x';
        return {
          options: scaleOptions,
          dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
          dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
        };
      }));
    }
    each(items, item => {
      const scaleOptions = item.options;
      const id = scaleOptions.id;
      const axis = determineAxis(id, scaleOptions);
      const scaleType = valueOrDefault(scaleOptions.type, item.dtype);
      if (scaleOptions.position === undefined || positionIsHorizontal(scaleOptions.position, axis) !== positionIsHorizontal(item.dposition)) {
        scaleOptions.position = item.dposition;
      }
      updated[id] = true;
      let scale = null;
      if (id in scales && scales[id].type === scaleType) {
        scale = scales[id];
      } else {
        const scaleClass = registry.getScale(scaleType);
        scale = new scaleClass({
          id,
          type: scaleType,
          ctx: this.ctx,
          chart: this
        });
        scales[scale.id] = scale;
      }
      scale.init(scaleOptions, options);
    });
    each(updated, (hasUpdated, id) => {
      if (!hasUpdated) {
        delete scales[id];
      }
    });
    each(scales, scale => {
      layouts.configure(this, scale, scale.options);
      layouts.addBox(this, scale);
    });
  }
  _updateMetasets() {
    const metasets = this._metasets;
    const numData = this.data.datasets.length;
    const numMeta = metasets.length;
    metasets.sort((a, b) => a.index - b.index);
    if (numMeta > numData) {
      for (let i = numData; i < numMeta; ++i) {
        this._destroyDatasetMeta(i);
      }
      metasets.splice(numData, numMeta - numData);
    }
    this._sortedMetasets = metasets.slice(0).sort(compare2Level('order', 'index'));
  }
  _removeUnreferencedMetasets() {
    const {
      _metasets: metasets,
      data: {
        datasets
      }
    } = this;
    if (metasets.length > datasets.length) {
      delete this._stacks;
    }
    metasets.forEach((meta, index) => {
      if (datasets.filter(x => x === meta._dataset).length === 0) {
        this._destroyDatasetMeta(index);
      }
    });
  }
  buildOrUpdateControllers() {
    const newControllers = [];
    const datasets = this.data.datasets;
    let i, ilen;
    this._removeUnreferencedMetasets();
    for (i = 0, ilen = datasets.length; i < ilen; i++) {
      const dataset = datasets[i];
      let meta = this.getDatasetMeta(i);
      const type = dataset.type || this.config.type;
      if (meta.type && meta.type !== type) {
        this._destroyDatasetMeta(i);
        meta = this.getDatasetMeta(i);
      }
      meta.type = type;
      meta.indexAxis = dataset.indexAxis || getIndexAxis(type, this.options);
      meta.order = dataset.order || 0;
      meta.index = i;
      meta.label = '' + dataset.label;
      meta.visible = this.isDatasetVisible(i);
      if (meta.controller) {
        meta.controller.updateIndex(i);
        meta.controller.linkScales();
      } else {
        const ControllerClass = registry.getController(type);
        const {
          datasetElementType,
          dataElementType
        } = defaults.datasets[type];
        Object.assign(ControllerClass, {
          dataElementType: registry.getElement(dataElementType),
          datasetElementType: datasetElementType && registry.getElement(datasetElementType)
        });
        meta.controller = new ControllerClass(this, i);
        newControllers.push(meta.controller);
      }
    }
    this._updateMetasets();
    return newControllers;
  }
  _resetElements() {
    each(this.data.datasets, (dataset, datasetIndex) => {
      this.getDatasetMeta(datasetIndex).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements();
    this.notifyPlugins('reset');
  }
  update(mode) {
    const config = this.config;
    config.update();
    const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
    const animsDisabled = this._animationsDisabled = !options.animation;
    this._updateScales();
    this._checkEventBindings();
    this._updateHiddenIndices();
    this._plugins.invalidate();
    if (this.notifyPlugins('beforeUpdate', {
      mode,
      cancelable: true
    }) === false) {
      return;
    }
    const newControllers = this.buildOrUpdateControllers();
    this.notifyPlugins('beforeElementsUpdate');
    let minPadding = 0;
    for (let i = 0, ilen = this.data.datasets.length; i < ilen; i++) {
      const {
        controller
      } = this.getDatasetMeta(i);
      const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
      controller.buildOrUpdateElements(reset);
      minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
    }
    minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
    this._updateLayout(minPadding);
    if (!animsDisabled) {
      each(newControllers, controller => {
        controller.reset();
      });
    }
    this._updateDatasets(mode);
    this.notifyPlugins('afterUpdate', {
      mode
    });
    this._layers.sort(compare2Level('z', '_idx'));
    const {
      _active,
      _lastEvent
    } = this;
    if (_lastEvent) {
      this._eventHandler(_lastEvent, true);
    } else if (_active.length) {
      this._updateHoverStyles(_active, _active, true);
    }
    this.render();
  }
  _updateScales() {
    each(this.scales, scale => {
      layouts.removeBox(this, scale);
    });
    this.ensureScalesHaveIDs();
    this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const options = this.options;
    const existingEvents = new Set(Object.keys(this._listeners));
    const newEvents = new Set(options.events);
    if (!setsEqual(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
      this.unbindEvents();
      this.bindEvents();
    }
  }
  _updateHiddenIndices() {
    const {
      _hiddenIndices
    } = this;
    const changes = this._getUniformDataChanges() || [];
    for (const {
      method,
      start,
      count
    } of changes) {
      const move = method === '_removeElements' ? -count : count;
      moveNumericKeys(_hiddenIndices, start, move);
    }
  }
  _getUniformDataChanges() {
    const _dataChanges = this._dataChanges;
    if (!_dataChanges || !_dataChanges.length) {
      return;
    }
    this._dataChanges = [];
    const datasetCount = this.data.datasets.length;
    const makeSet = idx => new Set(_dataChanges.filter(c => c[0] === idx).map((c, i) => i + ',' + c.splice(1).join(',')));
    const changeSet = makeSet(0);
    for (let i = 1; i < datasetCount; i++) {
      if (!setsEqual(changeSet, makeSet(i))) {
        return;
      }
    }
    return Array.from(changeSet).map(c => c.split(',')).map(a => ({
      method: a[1],
      start: +a[2],
      count: +a[3]
    }));
  }
  _updateLayout(minPadding) {
    if (this.notifyPlugins('beforeLayout', {
      cancelable: true
    }) === false) {
      return;
    }
    layouts.update(this, this.width, this.height, minPadding);
    const area = this.chartArea;
    const noArea = area.width <= 0 || area.height <= 0;
    this._layers = [];
    each(this.boxes, box => {
      if (noArea && box.position === 'chartArea') {
        return;
      }
      if (box.configure) {
        box.configure();
      }
      this._layers.push(...box._layers());
    }, this);
    this._layers.forEach((item, index) => {
      item._idx = index;
    });
    this.notifyPlugins('afterLayout');
  }
  _updateDatasets(mode) {
    if (this.notifyPlugins('beforeDatasetsUpdate', {
      mode,
      cancelable: true
    }) === false) {
      return;
    }
    for (let i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
      this.getDatasetMeta(i).controller.configure();
    }
    for (let i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
      this._updateDataset(i, isFunction(mode) ? mode({
        datasetIndex: i
      }) : mode);
    }
    this.notifyPlugins('afterDatasetsUpdate', {
      mode
    });
  }
  _updateDataset(index, mode) {
    const meta = this.getDatasetMeta(index);
    const args = {
      meta,
      index,
      mode,
      cancelable: true
    };
    if (this.notifyPlugins('beforeDatasetUpdate', args) === false) {
      return;
    }
    meta.controller._update(mode);
    args.cancelable = false;
    this.notifyPlugins('afterDatasetUpdate', args);
  }
  render() {
    if (this.notifyPlugins('beforeRender', {
      cancelable: true
    }) === false) {
      return;
    }
    if (animator.has(this)) {
      if (this.attached && !animator.running(this)) {
        animator.start(this);
      }
    } else {
      this.draw();
      onAnimationsComplete({
        chart: this
      });
    }
  }
  draw() {
    let i;
    if (this._resizeBeforeDraw) {
      const {
        width,
        height
      } = this._resizeBeforeDraw;
      this._resizeBeforeDraw = null;
      this._resize(width, height);
    }
    this.clear();
    if (this.width <= 0 || this.height <= 0) {
      return;
    }
    if (this.notifyPlugins('beforeDraw', {
      cancelable: true
    }) === false) {
      return;
    }
    const layers = this._layers;
    for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
      layers[i].draw(this.chartArea);
    }
    this._drawDatasets();
    for (; i < layers.length; ++i) {
      layers[i].draw(this.chartArea);
    }
    this.notifyPlugins('afterDraw');
  }
  _getSortedDatasetMetas(filterVisible) {
    const metasets = this._sortedMetasets;
    const result = [];
    let i, ilen;
    for (i = 0, ilen = metasets.length; i < ilen; ++i) {
      const meta = metasets[i];
      if (!filterVisible || meta.visible) {
        result.push(meta);
      }
    }
    return result;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(true);
  }
  _drawDatasets() {
    if (this.notifyPlugins('beforeDatasetsDraw', {
      cancelable: true
    }) === false) {
      return;
    }
    const metasets = this.getSortedVisibleDatasetMetas();
    for (let i = metasets.length - 1; i >= 0; --i) {
      this._drawDataset(metasets[i]);
    }
    this.notifyPlugins('afterDatasetsDraw');
  }
  _drawDataset(meta) {
    const ctx = this.ctx;
    const clip = meta._clip;
    const useClip = !clip.disabled;
    const area = getDatasetArea(meta, this.chartArea);
    const args = {
      meta,
      index: meta.index,
      cancelable: true
    };
    if (this.notifyPlugins('beforeDatasetDraw', args) === false) {
      return;
    }
    if (useClip) {
      clipArea(ctx, {
        left: clip.left === false ? 0 : area.left - clip.left,
        right: clip.right === false ? this.width : area.right + clip.right,
        top: clip.top === false ? 0 : area.top - clip.top,
        bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
      });
    }
    meta.controller.draw();
    if (useClip) {
      unclipArea(ctx);
    }
    args.cancelable = false;
    this.notifyPlugins('afterDatasetDraw', args);
  }
  isPointInArea(point) {
    return _isPointInArea(point, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(e, mode, options, useFinalPosition) {
    const method = Interaction.modes[mode];
    if (typeof method === 'function') {
      return method(this, e, options, useFinalPosition);
    }
    return [];
  }
  getDatasetMeta(datasetIndex) {
    const dataset = this.data.datasets[datasetIndex];
    const metasets = this._metasets;
    let meta = metasets.filter(x => x && x._dataset === dataset).pop();
    if (!meta) {
      meta = {
        type: null,
        data: [],
        dataset: null,
        controller: null,
        hidden: null,
        xAxisID: null,
        yAxisID: null,
        order: dataset && dataset.order || 0,
        index: datasetIndex,
        _dataset: dataset,
        _parsed: [],
        _sorted: false
      };
      metasets.push(meta);
    }
    return meta;
  }
  getContext() {
    return this.$context || (this.$context = createContext(null, {
      chart: this,
      type: 'chart'
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(datasetIndex) {
    const dataset = this.data.datasets[datasetIndex];
    if (!dataset) {
      return false;
    }
    const meta = this.getDatasetMeta(datasetIndex);
    return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
  }
  setDatasetVisibility(datasetIndex, visible) {
    const meta = this.getDatasetMeta(datasetIndex);
    meta.hidden = !visible;
  }
  toggleDataVisibility(index) {
    this._hiddenIndices[index] = !this._hiddenIndices[index];
  }
  getDataVisibility(index) {
    return !this._hiddenIndices[index];
  }
  _updateVisibility(datasetIndex, dataIndex, visible) {
    const mode = visible ? 'show' : 'hide';
    const meta = this.getDatasetMeta(datasetIndex);
    const anims = meta.controller._resolveAnimations(undefined, mode);
    if (defined(dataIndex)) {
      meta.data[dataIndex].hidden = !visible;
      this.update();
    } else {
      this.setDatasetVisibility(datasetIndex, visible);
      anims.update(meta, {
        visible
      });
      this.update(ctx => ctx.datasetIndex === datasetIndex ? mode : undefined);
    }
  }
  hide(datasetIndex, dataIndex) {
    this._updateVisibility(datasetIndex, dataIndex, false);
  }
  show(datasetIndex, dataIndex) {
    this._updateVisibility(datasetIndex, dataIndex, true);
  }
  _destroyDatasetMeta(datasetIndex) {
    const meta = this._metasets[datasetIndex];
    if (meta && meta.controller) {
      meta.controller._destroy();
    }
    delete this._metasets[datasetIndex];
  }
  _stop() {
    let i, ilen;
    this.stop();
    animator.remove(this);
    for (i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
      this._destroyDatasetMeta(i);
    }
  }
  destroy() {
    this.notifyPlugins('beforeDestroy');
    const {
      canvas,
      ctx
    } = this;
    this._stop();
    this.config.clearCache();
    if (canvas) {
      this.unbindEvents();
      clearCanvas(canvas, ctx);
      this.platform.releaseContext(ctx);
      this.canvas = null;
      this.ctx = null;
    }
    delete instances[this.id];
    this.notifyPlugins('afterDestroy');
  }
  toBase64Image(...args) {
    return this.canvas.toDataURL(...args);
  }
  bindEvents() {
    this.bindUserEvents();
    if (this.options.responsive) {
      this.bindResponsiveEvents();
    } else {
      this.attached = true;
    }
  }
  bindUserEvents() {
    const listeners = this._listeners;
    const platform = this.platform;
    const _add = (type, listener) => {
      platform.addEventListener(this, type, listener);
      listeners[type] = listener;
    };
    const listener = (e, x, y) => {
      e.offsetX = x;
      e.offsetY = y;
      this._eventHandler(e);
    };
    each(this.options.events, type => _add(type, listener));
  }
  bindResponsiveEvents() {
    if (!this._responsiveListeners) {
      this._responsiveListeners = {};
    }
    const listeners = this._responsiveListeners;
    const platform = this.platform;
    const _add = (type, listener) => {
      platform.addEventListener(this, type, listener);
      listeners[type] = listener;
    };
    const _remove = (type, listener) => {
      if (listeners[type]) {
        platform.removeEventListener(this, type, listener);
        delete listeners[type];
      }
    };
    const listener = (width, height) => {
      if (this.canvas) {
        this.resize(width, height);
      }
    };
    let detached;
    const attached = () => {
      _remove('attach', attached);
      this.attached = true;
      this.resize();
      _add('resize', listener);
      _add('detach', detached);
    };
    detached = () => {
      this.attached = false;
      _remove('resize', listener);
      this._stop();
      this._resize(0, 0);
      _add('attach', attached);
    };
    if (platform.isAttached(this.canvas)) {
      attached();
    } else {
      detached();
    }
  }
  unbindEvents() {
    each(this._listeners, (listener, type) => {
      this.platform.removeEventListener(this, type, listener);
    });
    this._listeners = {};
    each(this._responsiveListeners, (listener, type) => {
      this.platform.removeEventListener(this, type, listener);
    });
    this._responsiveListeners = undefined;
  }
  updateHoverStyle(items, mode, enabled) {
    const prefix = enabled ? 'set' : 'remove';
    let meta, item, i, ilen;
    if (mode === 'dataset') {
      meta = this.getDatasetMeta(items[0].datasetIndex);
      meta.controller['_' + prefix + 'DatasetHoverStyle']();
    }
    for (i = 0, ilen = items.length; i < ilen; ++i) {
      item = items[i];
      const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
      if (controller) {
        controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
      }
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(activeElements) {
    const lastActive = this._active || [];
    const active = activeElements.map(({
      datasetIndex,
      index
    }) => {
      const meta = this.getDatasetMeta(datasetIndex);
      if (!meta) {
        throw new Error('No dataset found at index ' + datasetIndex);
      }
      return {
        datasetIndex,
        element: meta.data[index],
        index
      };
    });
    const changed = !_elementsEqual(active, lastActive);
    if (changed) {
      this._active = active;
      this._lastEvent = null;
      this._updateHoverStyles(active, lastActive);
    }
  }
  notifyPlugins(hook, args, filter) {
    return this._plugins.notify(this, hook, args, filter);
  }
  isPluginEnabled(pluginId) {
    return this._plugins._cache.filter(p => p.plugin.id === pluginId).length === 1;
  }
  _updateHoverStyles(active, lastActive, replay) {
    const hoverOptions = this.options.hover;
    const diff = (a, b) => a.filter(x => !b.some(y => x.datasetIndex === y.datasetIndex && x.index === y.index));
    const deactivated = diff(lastActive, active);
    const activated = replay ? active : diff(active, lastActive);
    if (deactivated.length) {
      this.updateHoverStyle(deactivated, hoverOptions.mode, false);
    }
    if (activated.length && hoverOptions.mode) {
      this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
  }
  _eventHandler(e, replay) {
    const args = {
      event: e,
      replay,
      cancelable: true,
      inChartArea: this.isPointInArea(e)
    };
    const eventFilter = plugin => (plugin.options.events || this.options.events).includes(e.native.type);
    if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) {
      return;
    }
    const changed = this._handleEvent(e, replay, args.inChartArea);
    args.cancelable = false;
    this.notifyPlugins('afterEvent', args, eventFilter);
    if (changed || args.changed) {
      this.render();
    }
    return this;
  }
  _handleEvent(e, replay, inChartArea) {
    const {
      _active: lastActive = [],
      options
    } = this;
    const useFinalPosition = replay;
    const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
    const isClick = _isClickEvent(e);
    const lastEvent = determineLastEvent(e, this._lastEvent, inChartArea, isClick);
    if (inChartArea) {
      this._lastEvent = null;
      callback(options.onHover, [e, active, this], this);
      if (isClick) {
        callback(options.onClick, [e, active, this], this);
      }
    }
    const changed = !_elementsEqual(active, lastActive);
    if (changed || replay) {
      this._active = active;
      this._updateHoverStyles(active, lastActive, replay);
    }
    this._lastEvent = lastEvent;
    return changed;
  }
  _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
    if (e.type === 'mouseout') {
      return [];
    }
    if (!inChartArea) {
      return lastActive;
    }
    const hoverOptions = this.options.hover;
    return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
  }
}
_defineProperty(Chart, "defaults", defaults);
_defineProperty(Chart, "instances", instances);
_defineProperty(Chart, "overrides", overrides);
_defineProperty(Chart, "registry", registry);
_defineProperty(Chart, "version", version);
_defineProperty(Chart, "getChart", getChart);
function invalidatePlugins() {
  return each(Chart.instances, chart => chart._plugins.invalidate());
}
function clipArc(ctx, element, endAngle) {
  const {
    startAngle,
    pixelMargin,
    x,
    y,
    outerRadius,
    innerRadius
  } = element;
  let angleMargin = pixelMargin / outerRadius;
  // Draw an inner border by clipping the arc and drawing a double-width border
  // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
  ctx.beginPath();
  ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
  if (innerRadius > pixelMargin) {
    angleMargin = pixelMargin / innerRadius;
    ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
  } else {
    ctx.arc(x, y, pixelMargin, endAngle + HALF_PI, startAngle - HALF_PI);
  }
  ctx.closePath();
  ctx.clip();
}
function toRadiusCorners(value) {
  return _readValueToProps(value, ['outerStart', 'outerEnd', 'innerStart', 'innerEnd']);
}
/**
 * Parse border radius from the provided options
 */
function parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
  const o = toRadiusCorners(arc.options.borderRadius);
  const halfThickness = (outerRadius - innerRadius) / 2;
  const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
  // Outer limits are complicated. We want to compute the available angular distance at
  // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
  // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
  //
  // If the borderRadius is large, that value can become negative.
  // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
  // we know that the thickness term will dominate and compute the limits at that point
  const computeOuterLimit = val => {
    const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
    return _limitValue(val, 0, Math.min(halfThickness, outerArcLimit));
  };
  return {
    outerStart: computeOuterLimit(o.outerStart),
    outerEnd: computeOuterLimit(o.outerEnd),
    innerStart: _limitValue(o.innerStart, 0, innerLimit),
    innerEnd: _limitValue(o.innerEnd, 0, innerLimit)
  };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */
function rThetaToXY(r, theta, x, y) {
  return {
    x: x + r * Math.cos(theta),
    y: y + r * Math.sin(theta)
  };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */
function pathArc(ctx, element, offset, spacing, end, circular) {
  const {
    x,
    y,
    startAngle: start,
    pixelMargin,
    innerRadius: innerR
  } = element;
  const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
  const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
  let spacingOffset = 0;
  const alpha = end - start;
  if (spacing) {
    // When spacing is present, it is the same for all items
    // So we adjust the start and end angle of the arc such that
    // the distance is the same as it would be without the spacing
    const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
    const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
    const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
    const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
    spacingOffset = (alpha - adjustedAngle) / 2;
  }
  const beta = Math.max(0.001, alpha * outerRadius - offset / PI) / outerRadius;
  const angleOffset = (alpha - beta) / 2;
  const startAngle = start + angleOffset + spacingOffset;
  const endAngle = end - angleOffset - spacingOffset;
  const {
    outerStart,
    outerEnd,
    innerStart,
    innerEnd
  } = parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
  const outerStartAdjustedRadius = outerRadius - outerStart;
  const outerEndAdjustedRadius = outerRadius - outerEnd;
  const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
  const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
  const innerStartAdjustedRadius = innerRadius + innerStart;
  const innerEndAdjustedRadius = innerRadius + innerEnd;
  const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
  const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
  ctx.beginPath();
  if (circular) {
    // The first arc segments from point 1 to point a to point 2
    const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
    ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
    ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
    // The corner segment from point 2 to point 3
    if (outerEnd > 0) {
      const pCenter = rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
      ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + HALF_PI);
    }
    // The line from point 3 to point 4
    const p4 = rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
    ctx.lineTo(p4.x, p4.y);
    // The corner segment from point 4 to point 5
    if (innerEnd > 0) {
      const pCenter = rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
      ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + HALF_PI, innerEndAdjustedAngle + Math.PI);
    }
    // The inner arc from point 5 to point b to point 6
    const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
    ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
    ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
    // The corner segment from point 6 to point 7
    if (innerStart > 0) {
      const pCenter = rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
      ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - HALF_PI);
    }
    // The line from point 7 to point 8
    const p8 = rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
    ctx.lineTo(p8.x, p8.y);
    // The corner segment from point 8 to point 1
    if (outerStart > 0) {
      const pCenter = rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
      ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - HALF_PI, outerStartAdjustedAngle);
    }
  } else {
    ctx.moveTo(x, y);
    const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
    const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
    ctx.lineTo(outerStartX, outerStartY);
    const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
    const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
    ctx.lineTo(outerEndX, outerEndY);
  }
  ctx.closePath();
}
function drawArc(ctx, element, offset, spacing, circular) {
  const {
    fullCircles,
    startAngle,
    circumference
  } = element;
  let endAngle = element.endAngle;
  if (fullCircles) {
    pathArc(ctx, element, offset, spacing, endAngle, circular);
    for (let i = 0; i < fullCircles; ++i) {
      ctx.fill();
    }
    if (!isNaN(circumference)) {
      endAngle = startAngle + (circumference % TAU || TAU);
    }
  }
  pathArc(ctx, element, offset, spacing, endAngle, circular);
  ctx.fill();
  return endAngle;
}
function drawBorder(ctx, element, offset, spacing, circular) {
  const {
    fullCircles,
    startAngle,
    circumference,
    options
  } = element;
  const {
    borderWidth,
    borderJoinStyle,
    borderDash,
    borderDashOffset
  } = options;
  const inner = options.borderAlign === 'inner';
  if (!borderWidth) {
    return;
  }
  ctx.setLineDash(borderDash || []);
  ctx.lineDashOffset = borderDashOffset;
  if (inner) {
    ctx.lineWidth = borderWidth * 2;
    ctx.lineJoin = borderJoinStyle || 'round';
  } else {
    ctx.lineWidth = borderWidth;
    ctx.lineJoin = borderJoinStyle || 'bevel';
  }
  let endAngle = element.endAngle;
  if (fullCircles) {
    pathArc(ctx, element, offset, spacing, endAngle, circular);
    for (let i = 0; i < fullCircles; ++i) {
      ctx.stroke();
    }
    if (!isNaN(circumference)) {
      endAngle = startAngle + (circumference % TAU || TAU);
    }
  }
  if (inner) {
    clipArc(ctx, element, endAngle);
  }
  if (!fullCircles) {
    pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.stroke();
  }
}
class ArcElement extends Element$1 {
  constructor(cfg) {
    super();
    _defineProperty(this, "circumference", void 0);
    _defineProperty(this, "endAngle", void 0);
    _defineProperty(this, "fullCircles", void 0);
    _defineProperty(this, "innerRadius", void 0);
    _defineProperty(this, "outerRadius", void 0);
    _defineProperty(this, "pixelMargin", void 0);
    _defineProperty(this, "startAngle", void 0);
    this.options = undefined;
    this.circumference = undefined;
    this.startAngle = undefined;
    this.endAngle = undefined;
    this.innerRadius = undefined;
    this.outerRadius = undefined;
    this.pixelMargin = 0;
    this.fullCircles = 0;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  inRange(chartX, chartY, useFinalPosition) {
    const point = this.getProps(['x', 'y'], useFinalPosition);
    const {
      angle,
      distance
    } = getAngleFromPoint(point, {
      x: chartX,
      y: chartY
    });
    const {
      startAngle,
      endAngle,
      innerRadius,
      outerRadius,
      circumference
    } = this.getProps(['startAngle', 'endAngle', 'innerRadius', 'outerRadius', 'circumference'], useFinalPosition);
    const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
    const _circumference = valueOrDefault(circumference, endAngle - startAngle);
    const nonZeroBetween = _angleBetween(angle, startAngle, endAngle) && startAngle !== endAngle;
    const betweenAngles = _circumference >= TAU || nonZeroBetween;
    const withinRadius = _isBetween(distance, innerRadius + rAdjust, outerRadius + rAdjust);
    return betweenAngles && withinRadius;
  }
  getCenterPoint(useFinalPosition) {
    const {
      x,
      y,
      startAngle,
      endAngle,
      innerRadius,
      outerRadius
    } = this.getProps(['x', 'y', 'startAngle', 'endAngle', 'innerRadius', 'outerRadius'], useFinalPosition);
    const {
      offset,
      spacing
    } = this.options;
    const halfAngle = (startAngle + endAngle) / 2;
    const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
    return {
      x: x + Math.cos(halfAngle) * halfRadius,
      y: y + Math.sin(halfAngle) * halfRadius
    };
  }
  tooltipPosition(useFinalPosition) {
    return this.getCenterPoint(useFinalPosition);
  }
  draw(ctx) {
    const {
      options,
      circumference
    } = this;
    const offset = (options.offset || 0) / 4;
    const spacing = (options.spacing || 0) / 2;
    const circular = options.circular;
    this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
    this.fullCircles = circumference > TAU ? Math.floor(circumference / TAU) : 0;
    if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) {
      return;
    }
    ctx.save();
    const halfAngle = (this.startAngle + this.endAngle) / 2;
    ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
    const fix = 1 - Math.sin(Math.min(PI, circumference || 0));
    const radiusOffset = offset * fix;
    ctx.fillStyle = options.backgroundColor;
    ctx.strokeStyle = options.borderColor;
    drawArc(ctx, this, radiusOffset, spacing, circular);
    drawBorder(ctx, this, radiusOffset, spacing, circular);
    ctx.restore();
  }
}
_defineProperty(ArcElement, "id", 'arc');
_defineProperty(ArcElement, "defaults", {
  borderAlign: 'center',
  borderColor: '#fff',
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: undefined,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: undefined,
  circular: true
});
_defineProperty(ArcElement, "defaultRoutes", {
  backgroundColor: 'backgroundColor'
});
_defineProperty(ArcElement, "descriptors", {
  _scriptable: true,
  _indexable: name => name !== 'borderDash'
});
function setStyle(ctx, options, style = options) {
  ctx.lineCap = valueOrDefault(style.borderCapStyle, options.borderCapStyle);
  ctx.setLineDash(valueOrDefault(style.borderDash, options.borderDash));
  ctx.lineDashOffset = valueOrDefault(style.borderDashOffset, options.borderDashOffset);
  ctx.lineJoin = valueOrDefault(style.borderJoinStyle, options.borderJoinStyle);
  ctx.lineWidth = valueOrDefault(style.borderWidth, options.borderWidth);
  ctx.strokeStyle = valueOrDefault(style.borderColor, options.borderColor);
}
function lineTo(ctx, previous, target) {
  ctx.lineTo(target.x, target.y);
}
function getLineMethod(options) {
  if (options.stepped) {
    return _steppedLineTo;
  }
  if (options.tension || options.cubicInterpolationMode === 'monotone') {
    return _bezierCurveTo;
  }
  return lineTo;
}
function pathVars(points, segment, params = {}) {
  const count = points.length;
  const {
    start: paramsStart = 0,
    end: paramsEnd = count - 1
  } = params;
  const {
    start: segmentStart,
    end: segmentEnd
  } = segment;
  const start = Math.max(paramsStart, segmentStart);
  const end = Math.min(paramsEnd, segmentEnd);
  const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
  return {
    count,
    start,
    loop: segment.loop,
    ilen: end < start && !outside ? count + end - start : end - start
  };
}
function pathSegment(ctx, line, segment, params) {
  const {
    points,
    options
  } = line;
  const {
    count,
    start,
    loop,
    ilen
  } = pathVars(points, segment, params);
  const lineMethod = getLineMethod(options);
  let {
    move = true,
    reverse
  } = params || {};
  let i, point, prev;
  for (i = 0; i <= ilen; ++i) {
    point = points[(start + (reverse ? ilen - i : i)) % count];
    if (point.skip) {
      continue;
    } else if (move) {
      ctx.moveTo(point.x, point.y);
      move = false;
    } else {
      lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    prev = point;
  }
  if (loop) {
    point = points[(start + (reverse ? ilen : 0)) % count];
    lineMethod(ctx, prev, point, reverse, options.stepped);
  }
  return !!loop;
}
function fastPathSegment(ctx, line, segment, params) {
  const points = line.points;
  const {
    count,
    start,
    ilen
  } = pathVars(points, segment, params);
  const {
    move = true,
    reverse
  } = params || {};
  let avgX = 0;
  let countX = 0;
  let i, point, prevX, minY, maxY, lastY;
  const pointIndex = index => (start + (reverse ? ilen - index : index)) % count;
  const drawX = () => {
    if (minY !== maxY) {
      ctx.lineTo(avgX, maxY);
      ctx.lineTo(avgX, minY);
      ctx.lineTo(avgX, lastY);
    }
  };
  if (move) {
    point = points[pointIndex(0)];
    ctx.moveTo(point.x, point.y);
  }
  for (i = 0; i <= ilen; ++i) {
    point = points[pointIndex(i)];
    if (point.skip) {
      continue;
    }
    const x = point.x;
    const y = point.y;
    const truncX = x | 0;
    if (truncX === prevX) {
      if (y < minY) {
        minY = y;
      } else if (y > maxY) {
        maxY = y;
      }
      avgX = (countX * avgX + x) / ++countX;
    } else {
      drawX();
      ctx.lineTo(x, y);
      prevX = truncX;
      countX = 0;
      minY = maxY = y;
    }
    lastY = y;
  }
  drawX();
}
function _getSegmentMethod(line) {
  const opts = line.options;
  const borderDash = opts.borderDash && opts.borderDash.length;
  const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
  return useFastPath ? fastPathSegment : pathSegment;
}
function _getInterpolationMethod(options) {
  if (options.stepped) {
    return _steppedInterpolation;
  }
  if (options.tension || options.cubicInterpolationMode === 'monotone') {
    return _bezierInterpolation;
  }
  return _pointInLine;
}
function strokePathWithCache(ctx, line, start, count) {
  let path = line._path;
  if (!path) {
    path = line._path = new Path2D();
    if (line.path(path, start, count)) {
      path.closePath();
    }
  }
  setStyle(ctx, line.options);
  ctx.stroke(path);
}
function strokePathDirect(ctx, line, start, count) {
  const {
    segments,
    options
  } = line;
  const segmentMethod = _getSegmentMethod(line);
  for (const segment of segments) {
    setStyle(ctx, options, segment.style);
    ctx.beginPath();
    if (segmentMethod(ctx, line, segment, {
      start,
      end: start + count - 1
    })) {
      ctx.closePath();
    }
    ctx.stroke();
  }
}
const usePath2D = typeof Path2D === 'function';
function draw(ctx, line, start, count) {
  if (usePath2D && !line.options.segment) {
    strokePathWithCache(ctx, line, start, count);
  } else {
    strokePathDirect(ctx, line, start, count);
  }
}
class LineElement extends Element$1 {
  constructor(cfg) {
    super();
    this.animated = true;
    this.options = undefined;
    this._chart = undefined;
    this._loop = undefined;
    this._fullLoop = undefined;
    this._path = undefined;
    this._points = undefined;
    this._segments = undefined;
    this._decimated = false;
    this._pointsUpdated = false;
    this._datasetIndex = undefined;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  updateControlPoints(chartArea, indexAxis) {
    const options = this.options;
    if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
      const loop = options.spanGaps ? this._loop : this._fullLoop;
      _updateBezierControlPoints(this._points, options, chartArea, loop, indexAxis);
      this._pointsUpdated = true;
    }
  }
  set points(points) {
    this._points = points;
    delete this._segments;
    delete this._path;
    this._pointsUpdated = false;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = _computeSegments(this, this.options.segment));
  }
  first() {
    const segments = this.segments;
    const points = this.points;
    return segments.length && points[segments[0].start];
  }
  last() {
    const segments = this.segments;
    const points = this.points;
    const count = segments.length;
    return count && points[segments[count - 1].end];
  }
  interpolate(point, property) {
    const options = this.options;
    const value = point[property];
    const points = this.points;
    const segments = _boundSegments(this, {
      property,
      start: value,
      end: value
    });
    if (!segments.length) {
      return;
    }
    const result = [];
    const _interpolate = _getInterpolationMethod(options);
    let i, ilen;
    for (i = 0, ilen = segments.length; i < ilen; ++i) {
      const {
        start,
        end
      } = segments[i];
      const p1 = points[start];
      const p2 = points[end];
      if (p1 === p2) {
        result.push(p1);
        continue;
      }
      const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
      const interpolated = _interpolate(p1, p2, t, options.stepped);
      interpolated[property] = point[property];
      result.push(interpolated);
    }
    return result.length === 1 ? result[0] : result;
  }
  pathSegment(ctx, segment, params) {
    const segmentMethod = _getSegmentMethod(this);
    return segmentMethod(ctx, this, segment, params);
  }
  path(ctx, start, count) {
    const segments = this.segments;
    const segmentMethod = _getSegmentMethod(this);
    let loop = this._loop;
    start = start || 0;
    count = count || this.points.length - start;
    for (const segment of segments) {
      loop &= segmentMethod(ctx, this, segment, {
        start,
        end: start + count - 1
      });
    }
    return !!loop;
  }
  draw(ctx, chartArea, start, count) {
    const options = this.options || {};
    const points = this.points || [];
    if (points.length && options.borderWidth) {
      ctx.save();
      draw(ctx, this, start, count);
      ctx.restore();
    }
    if (this.animated) {
      this._pointsUpdated = false;
      this._path = undefined;
    }
  }
}
_defineProperty(LineElement, "id", 'line');
_defineProperty(LineElement, "defaults", {
  borderCapStyle: 'butt',
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: 'miter',
  borderWidth: 3,
  capBezierPoints: true,
  cubicInterpolationMode: 'default',
  fill: false,
  spanGaps: false,
  stepped: false,
  tension: 0
});
_defineProperty(LineElement, "defaultRoutes", {
  backgroundColor: 'backgroundColor',
  borderColor: 'borderColor'
});
_defineProperty(LineElement, "descriptors", {
  _scriptable: true,
  _indexable: name => name !== 'borderDash' && name !== 'fill'
});
function inRange$1(el, pos, axis, useFinalPosition) {
  const options = el.options;
  const {
    [axis]: value
  } = el.getProps([axis], useFinalPosition);
  return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class PointElement extends Element$1 {
  constructor(cfg) {
    super();
    _defineProperty(this, "parsed", void 0);
    _defineProperty(this, "skip", void 0);
    _defineProperty(this, "stop", void 0);
    this.options = undefined;
    this.parsed = undefined;
    this.skip = undefined;
    this.stop = undefined;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  inRange(mouseX, mouseY, useFinalPosition) {
    const options = this.options;
    const {
      x,
      y
    } = this.getProps(['x', 'y'], useFinalPosition);
    return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
  }
  inXRange(mouseX, useFinalPosition) {
    return inRange$1(this, mouseX, 'x', useFinalPosition);
  }
  inYRange(mouseY, useFinalPosition) {
    return inRange$1(this, mouseY, 'y', useFinalPosition);
  }
  getCenterPoint(useFinalPosition) {
    const {
      x,
      y
    } = this.getProps(['x', 'y'], useFinalPosition);
    return {
      x,
      y
    };
  }
  size(options) {
    options = options || this.options || {};
    let radius = options.radius || 0;
    radius = Math.max(radius, radius && options.hoverRadius || 0);
    const borderWidth = radius && options.borderWidth || 0;
    return (radius + borderWidth) * 2;
  }
  draw(ctx, area) {
    const options = this.options;
    if (this.skip || options.radius < 0.1 || !_isPointInArea(this, area, this.size(options) / 2)) {
      return;
    }
    ctx.strokeStyle = options.borderColor;
    ctx.lineWidth = options.borderWidth;
    ctx.fillStyle = options.backgroundColor;
    drawPoint(ctx, options, this.x, this.y);
  }
  getRange() {
    const options = this.options || {};
    // @ts-expect-error Fallbacks should never be hit in practice
    return options.radius + options.hitRadius;
  }
}
_defineProperty(PointElement, "id", 'point');
/**
* @type {any}
*/
_defineProperty(PointElement, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: 'circle',
  radius: 3,
  rotation: 0
});
/**
* @type {any}
*/
_defineProperty(PointElement, "defaultRoutes", {
  backgroundColor: 'backgroundColor',
  borderColor: 'borderColor'
});
function getBarBounds(bar, useFinalPosition) {
  const {
    x,
    y,
    base,
    width,
    height
  } = bar.getProps(['x', 'y', 'base', 'width', 'height'], useFinalPosition);
  let left, right, top, bottom, half;
  if (bar.horizontal) {
    half = height / 2;
    left = Math.min(x, base);
    right = Math.max(x, base);
    top = y - half;
    bottom = y + half;
  } else {
    half = width / 2;
    left = x - half;
    right = x + half;
    top = Math.min(y, base);
    bottom = Math.max(y, base);
  }
  return {
    left,
    top,
    right,
    bottom
  };
}
function skipOrLimit(skip, value, min, max) {
  return skip ? 0 : _limitValue(value, min, max);
}
function parseBorderWidth(bar, maxW, maxH) {
  const value = bar.options.borderWidth;
  const skip = bar.borderSkipped;
  const o = toTRBL(value);
  return {
    t: skipOrLimit(skip.top, o.top, 0, maxH),
    r: skipOrLimit(skip.right, o.right, 0, maxW),
    b: skipOrLimit(skip.bottom, o.bottom, 0, maxH),
    l: skipOrLimit(skip.left, o.left, 0, maxW)
  };
}
function parseBorderRadius(bar, maxW, maxH) {
  const {
    enableBorderRadius
  } = bar.getProps(['enableBorderRadius']);
  const value = bar.options.borderRadius;
  const o = toTRBLCorners(value);
  const maxR = Math.min(maxW, maxH);
  const skip = bar.borderSkipped;
  const enableBorder = enableBorderRadius || isObject(value);
  return {
    topLeft: skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
    topRight: skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
    bottomLeft: skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
    bottomRight: skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
  };
}
function boundingRects(bar) {
  const bounds = getBarBounds(bar);
  const width = bounds.right - bounds.left;
  const height = bounds.bottom - bounds.top;
  const border = parseBorderWidth(bar, width / 2, height / 2);
  const radius = parseBorderRadius(bar, width / 2, height / 2);
  return {
    outer: {
      x: bounds.left,
      y: bounds.top,
      w: width,
      h: height,
      radius
    },
    inner: {
      x: bounds.left + border.l,
      y: bounds.top + border.t,
      w: width - border.l - border.r,
      h: height - border.t - border.b,
      radius: {
        topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
        topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
        bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
        bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
      }
    }
  };
}
function inRange(bar, x, y, useFinalPosition) {
  const skipX = x === null;
  const skipY = y === null;
  const skipBoth = skipX && skipY;
  const bounds = bar && !skipBoth && getBarBounds(bar, useFinalPosition);
  return bounds && (skipX || _isBetween(x, bounds.left, bounds.right)) && (skipY || _isBetween(y, bounds.top, bounds.bottom));
}
function hasRadius(radius) {
  return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function addNormalRectPath(ctx, rect) {
  ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function inflateRect(rect, amount, refRect = {}) {
  const x = rect.x !== refRect.x ? -amount : 0;
  const y = rect.y !== refRect.y ? -amount : 0;
  const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
  const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
  return {
    x: rect.x + x,
    y: rect.y + y,
    w: rect.w + w,
    h: rect.h + h,
    radius: rect.radius
  };
}
class BarElement extends Element$1 {
  constructor(cfg) {
    super();
    this.options = undefined;
    this.horizontal = undefined;
    this.base = undefined;
    this.width = undefined;
    this.height = undefined;
    this.inflateAmount = undefined;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  draw(ctx) {
    const {
      inflateAmount,
      options: {
        borderColor,
        backgroundColor
      }
    } = this;
    const {
      inner,
      outer
    } = boundingRects(this);
    const addRectPath = hasRadius(outer.radius) ? addRoundedRectPath : addNormalRectPath;
    ctx.save();
    if (outer.w !== inner.w || outer.h !== inner.h) {
      ctx.beginPath();
      addRectPath(ctx, inflateRect(outer, inflateAmount, inner));
      ctx.clip();
      addRectPath(ctx, inflateRect(inner, -inflateAmount, outer));
      ctx.fillStyle = borderColor;
      ctx.fill('evenodd');
    }
    ctx.beginPath();
    addRectPath(ctx, inflateRect(inner, inflateAmount));
    ctx.fillStyle = backgroundColor;
    ctx.fill();
    ctx.restore();
  }
  inRange(mouseX, mouseY, useFinalPosition) {
    return inRange(this, mouseX, mouseY, useFinalPosition);
  }
  inXRange(mouseX, useFinalPosition) {
    return inRange(this, mouseX, null, useFinalPosition);
  }
  inYRange(mouseY, useFinalPosition) {
    return inRange(this, null, mouseY, useFinalPosition);
  }
  getCenterPoint(useFinalPosition) {
    const {
      x,
      y,
      base,
      horizontal
    } = this.getProps(['x', 'y', 'base', 'horizontal'], useFinalPosition);
    return {
      x: horizontal ? (x + base) / 2 : x,
      y: horizontal ? y : (y + base) / 2
    };
  }
  getRange(axis) {
    return axis === 'x' ? this.width / 2 : this.height / 2;
  }
}
_defineProperty(BarElement, "id", 'bar');
_defineProperty(BarElement, "defaults", {
  borderSkipped: 'start',
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: 'auto',
  pointStyle: undefined
});
_defineProperty(BarElement, "defaultRoutes", {
  backgroundColor: 'backgroundColor',
  borderColor: 'borderColor'
});
const getBoxSize = (labelOpts, fontSize) => {
  let {
    boxHeight = fontSize,
    boxWidth = fontSize
  } = labelOpts;
  if (labelOpts.usePointStyle) {
    boxHeight = Math.min(boxHeight, fontSize);
    boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
  }
  return {
    boxWidth,
    boxHeight,
    itemHeight: Math.max(fontSize, boxHeight)
  };
};
const itemsEqual = (a, b) => a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class Legend extends Element$1 {
  constructor(config) {
    super();
    this._added = false;
    this.legendHitBoxes = [];
    this._hoveredItem = null;
    this.doughnutMode = false;
    this.chart = config.chart;
    this.options = config.options;
    this.ctx = config.ctx;
    this.legendItems = undefined;
    this.columnSizes = undefined;
    this.lineWidths = undefined;
    this.maxHeight = undefined;
    this.maxWidth = undefined;
    this.top = undefined;
    this.bottom = undefined;
    this.left = undefined;
    this.right = undefined;
    this.height = undefined;
    this.width = undefined;
    this._margins = undefined;
    this.position = undefined;
    this.weight = undefined;
    this.fullSize = undefined;
  }
  update(maxWidth, maxHeight, margins) {
    this.maxWidth = maxWidth;
    this.maxHeight = maxHeight;
    this._margins = margins;
    this.setDimensions();
    this.buildLabels();
    this.fit();
  }
  setDimensions() {
    if (this.isHorizontal()) {
      this.width = this.maxWidth;
      this.left = this._margins.left;
      this.right = this.width;
    } else {
      this.height = this.maxHeight;
      this.top = this._margins.top;
      this.bottom = this.height;
    }
  }
  buildLabels() {
    const labelOpts = this.options.labels || {};
    let legendItems = callback(labelOpts.generateLabels, [this.chart], this) || [];
    if (labelOpts.filter) {
      legendItems = legendItems.filter(item => labelOpts.filter(item, this.chart.data));
    }
    if (labelOpts.sort) {
      legendItems = legendItems.sort((a, b) => labelOpts.sort(a, b, this.chart.data));
    }
    if (this.options.reverse) {
      legendItems.reverse();
    }
    this.legendItems = legendItems;
  }
  fit() {
    const {
      options,
      ctx
    } = this;
    if (!options.display) {
      this.width = this.height = 0;
      return;
    }
    const labelOpts = options.labels;
    const labelFont = toFont(labelOpts.font);
    const fontSize = labelFont.size;
    const titleHeight = this._computeTitleHeight();
    const {
      boxWidth,
      itemHeight
    } = getBoxSize(labelOpts, fontSize);
    let width, height;
    ctx.font = labelFont.string;
    if (this.isHorizontal()) {
      width = this.maxWidth;
      height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
    } else {
      height = this.maxHeight;
      width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
    }
    this.width = Math.min(width, options.maxWidth || this.maxWidth);
    this.height = Math.min(height, options.maxHeight || this.maxHeight);
  }
  _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
    const {
      ctx,
      maxWidth,
      options: {
        labels: {
          padding
        }
      }
    } = this;
    const hitboxes = this.legendHitBoxes = [];
    const lineWidths = this.lineWidths = [0];
    const lineHeight = itemHeight + padding;
    let totalHeight = titleHeight;
    ctx.textAlign = 'left';
    ctx.textBaseline = 'middle';
    let row = -1;
    let top = -lineHeight;
    this.legendItems.forEach((legendItem, i) => {
      const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
      if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
        totalHeight += lineHeight;
        lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
        top += lineHeight;
        row++;
      }
      hitboxes[i] = {
        left: 0,
        top,
        row,
        width: itemWidth,
        height: itemHeight
      };
      lineWidths[lineWidths.length - 1] += itemWidth + padding;
    });
    return totalHeight;
  }
  _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
    const {
      ctx,
      maxHeight,
      options: {
        labels: {
          padding
        }
      }
    } = this;
    const hitboxes = this.legendHitBoxes = [];
    const columnSizes = this.columnSizes = [];
    const heightLimit = maxHeight - titleHeight;
    let totalWidth = padding;
    let currentColWidth = 0;
    let currentColHeight = 0;
    let left = 0;
    let col = 0;
    this.legendItems.forEach((legendItem, i) => {
      const {
        itemWidth,
        itemHeight
      } = calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
      if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
        totalWidth += currentColWidth + padding;
        columnSizes.push({
          width: currentColWidth,
          height: currentColHeight
        });
        left += currentColWidth + padding;
        col++;
        currentColWidth = currentColHeight = 0;
      }
      hitboxes[i] = {
        left,
        top: currentColHeight,
        col,
        width: itemWidth,
        height: itemHeight
      };
      currentColWidth = Math.max(currentColWidth, itemWidth);
      currentColHeight += itemHeight + padding;
    });
    totalWidth += currentColWidth;
    columnSizes.push({
      width: currentColWidth,
      height: currentColHeight
    });
    return totalWidth;
  }
  adjustHitBoxes() {
    if (!this.options.display) {
      return;
    }
    const titleHeight = this._computeTitleHeight();
    const {
      legendHitBoxes: hitboxes,
      options: {
        align,
        labels: {
          padding
        },
        rtl
      }
    } = this;
    const rtlHelper = getRtlAdapter(rtl, this.left, this.width);
    if (this.isHorizontal()) {
      let row = 0;
      let left = _alignStartEnd(align, this.left + padding, this.right - this.lineWidths[row]);
      for (const hitbox of hitboxes) {
        if (row !== hitbox.row) {
          row = hitbox.row;
          left = _alignStartEnd(align, this.left + padding, this.right - this.lineWidths[row]);
        }
        hitbox.top += this.top + titleHeight + padding;
        hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
        left += hitbox.width + padding;
      }
    } else {
      let col = 0;
      let top = _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
      for (const hitbox of hitboxes) {
        if (hitbox.col !== col) {
          col = hitbox.col;
          top = _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
        }
        hitbox.top = top;
        hitbox.left += this.left + padding;
        hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
        top += hitbox.height + padding;
      }
    }
  }
  isHorizontal() {
    return this.options.position === 'top' || this.options.position === 'bottom';
  }
  draw() {
    if (this.options.display) {
      const ctx = this.ctx;
      clipArea(ctx, this);
      this._draw();
      unclipArea(ctx);
    }
  }
  _draw() {
    const {
      options: opts,
      columnSizes,
      lineWidths,
      ctx
    } = this;
    const {
      align,
      labels: labelOpts
    } = opts;
    const defaultColor = defaults.color;
    const rtlHelper = getRtlAdapter(opts.rtl, this.left, this.width);
    const labelFont = toFont(labelOpts.font);
    const {
      padding
    } = labelOpts;
    const fontSize = labelFont.size;
    const halfFontSize = fontSize / 2;
    let cursor;
    this.drawTitle();
    ctx.textAlign = rtlHelper.textAlign('left');
    ctx.textBaseline = 'middle';
    ctx.lineWidth = 0.5;
    ctx.font = labelFont.string;
    const {
      boxWidth,
      boxHeight,
      itemHeight
    } = getBoxSize(labelOpts, fontSize);
    const drawLegendBox = function (x, y, legendItem) {
      if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) {
        return;
      }
      ctx.save();
      const lineWidth = valueOrDefault(legendItem.lineWidth, 1);
      ctx.fillStyle = valueOrDefault(legendItem.fillStyle, defaultColor);
      ctx.lineCap = valueOrDefault(legendItem.lineCap, 'butt');
      ctx.lineDashOffset = valueOrDefault(legendItem.lineDashOffset, 0);
      ctx.lineJoin = valueOrDefault(legendItem.lineJoin, 'miter');
      ctx.lineWidth = lineWidth;
      ctx.strokeStyle = valueOrDefault(legendItem.strokeStyle, defaultColor);
      ctx.setLineDash(valueOrDefault(legendItem.lineDash, []));
      if (labelOpts.usePointStyle) {
        const drawOptions = {
          radius: boxHeight * Math.SQRT2 / 2,
          pointStyle: legendItem.pointStyle,
          rotation: legendItem.rotation,
          borderWidth: lineWidth
        };
        const centerX = rtlHelper.xPlus(x, boxWidth / 2);
        const centerY = y + halfFontSize;
        drawPointLegend(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
      } else {
        const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
        const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
        const borderRadius = toTRBLCorners(legendItem.borderRadius);
        ctx.beginPath();
        if (Object.values(borderRadius).some(v => v !== 0)) {
          addRoundedRectPath(ctx, {
            x: xBoxLeft,
            y: yBoxTop,
            w: boxWidth,
            h: boxHeight,
            radius: borderRadius
          });
        } else {
          ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
        }
        ctx.fill();
        if (lineWidth !== 0) {
          ctx.stroke();
        }
      }
      ctx.restore();
    };
    const fillText = function (x, y, legendItem) {
      renderText(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
        strikethrough: legendItem.hidden,
        textAlign: rtlHelper.textAlign(legendItem.textAlign)
      });
    };
    const isHorizontal = this.isHorizontal();
    const titleHeight = this._computeTitleHeight();
    if (isHorizontal) {
      cursor = {
        x: _alignStartEnd(align, this.left + padding, this.right - lineWidths[0]),
        y: this.top + padding + titleHeight,
        line: 0
      };
    } else {
      cursor = {
        x: this.left + padding,
        y: _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
        line: 0
      };
    }
    overrideTextDirection(this.ctx, opts.textDirection);
    const lineHeight = itemHeight + padding;
    this.legendItems.forEach((legendItem, i) => {
      ctx.strokeStyle = legendItem.fontColor;
      ctx.fillStyle = legendItem.fontColor;
      const textWidth = ctx.measureText(legendItem.text).width;
      const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
      const width = boxWidth + halfFontSize + textWidth;
      let x = cursor.x;
      let y = cursor.y;
      rtlHelper.setWidth(this.width);
      if (isHorizontal) {
        if (i > 0 && x + width + padding > this.right) {
          y = cursor.y += lineHeight;
          cursor.line++;
          x = cursor.x = _alignStartEnd(align, this.left + padding, this.right - lineWidths[cursor.line]);
        }
      } else if (i > 0 && y + lineHeight > this.bottom) {
        x = cursor.x = x + columnSizes[cursor.line].width + padding;
        cursor.line++;
        y = cursor.y = _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
      }
      const realX = rtlHelper.x(x);
      drawLegendBox(realX, y, legendItem);
      x = _textX(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
      fillText(rtlHelper.x(x), y, legendItem);
      if (isHorizontal) {
        cursor.x += width + padding;
      } else if (typeof legendItem.text !== 'string') {
        const fontLineHeight = labelFont.lineHeight;
        cursor.y += calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
      } else {
        cursor.y += lineHeight;
      }
    });
    restoreTextDirection(this.ctx, opts.textDirection);
  }
  drawTitle() {
    const opts = this.options;
    const titleOpts = opts.title;
    const titleFont = toFont(titleOpts.font);
    const titlePadding = toPadding(titleOpts.padding);
    if (!titleOpts.display) {
      return;
    }
    const rtlHelper = getRtlAdapter(opts.rtl, this.left, this.width);
    const ctx = this.ctx;
    const position = titleOpts.position;
    const halfFontSize = titleFont.size / 2;
    const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
    let y;
    let left = this.left;
    let maxWidth = this.width;
    if (this.isHorizontal()) {
      maxWidth = Math.max(...this.lineWidths);
      y = this.top + topPaddingPlusHalfFontSize;
      left = _alignStartEnd(opts.align, left, this.right - maxWidth);
    } else {
      const maxHeight = this.columnSizes.reduce((acc, size) => Math.max(acc, size.height), 0);
      y = topPaddingPlusHalfFontSize + _alignStartEnd(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
    }
    const x = _alignStartEnd(position, left, left + maxWidth);
    ctx.textAlign = rtlHelper.textAlign(_toLeftRightCenter(position));
    ctx.textBaseline = 'middle';
    ctx.strokeStyle = titleOpts.color;
    ctx.fillStyle = titleOpts.color;
    ctx.font = titleFont.string;
    renderText(ctx, titleOpts.text, x, y, titleFont);
  }
  _computeTitleHeight() {
    const titleOpts = this.options.title;
    const titleFont = toFont(titleOpts.font);
    const titlePadding = toPadding(titleOpts.padding);
    return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
  }
  _getLegendItemAt(x, y) {
    let i, hitBox, lh;
    if (_isBetween(x, this.left, this.right) && _isBetween(y, this.top, this.bottom)) {
      lh = this.legendHitBoxes;
      for (i = 0; i < lh.length; ++i) {
        hitBox = lh[i];
        if (_isBetween(x, hitBox.left, hitBox.left + hitBox.width) && _isBetween(y, hitBox.top, hitBox.top + hitBox.height)) {
          return this.legendItems[i];
        }
      }
    }
    return null;
  }
  handleEvent(e) {
    const opts = this.options;
    if (!isListened(e.type, opts)) {
      return;
    }
    const hoveredItem = this._getLegendItemAt(e.x, e.y);
    if (e.type === 'mousemove' || e.type === 'mouseout') {
      const previous = this._hoveredItem;
      const sameItem = itemsEqual(previous, hoveredItem);
      if (previous && !sameItem) {
        callback(opts.onLeave, [e, previous, this], this);
      }
      this._hoveredItem = hoveredItem;
      if (hoveredItem && !sameItem) {
        callback(opts.onHover, [e, hoveredItem, this], this);
      }
    } else if (hoveredItem) {
      callback(opts.onClick, [e, hoveredItem, this], this);
    }
  }
}
function calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
  const itemWidth = calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
  const itemHeight = calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
  return {
    itemWidth,
    itemHeight
  };
}
function calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
  let legendItemText = legendItem.text;
  if (legendItemText && typeof legendItemText !== 'string') {
    legendItemText = legendItemText.reduce((a, b) => a.length > b.length ? a : b);
  }
  return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
  let itemHeight = _itemHeight;
  if (typeof legendItem.text !== 'string') {
    itemHeight = calculateLegendItemHeight(legendItem, fontLineHeight);
  }
  return itemHeight;
}
function calculateLegendItemHeight(legendItem, fontLineHeight) {
  const labelHeight = legendItem.text ? legendItem.text.length : 0;
  return fontLineHeight * labelHeight;
}
function isListened(type, opts) {
  if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) {
    return true;
  }
  if (opts.onClick && (type === 'click' || type === 'mouseup')) {
    return true;
  }
  return false;
}
var plugin_legend = {
  id: 'legend',
  _element: Legend,
  start(chart, _args, options) {
    const legend = chart.legend = new Legend({
      ctx: chart.ctx,
      options,
      chart
    });
    layouts.configure(chart, legend, options);
    layouts.addBox(chart, legend);
  },
  stop(chart) {
    layouts.removeBox(chart, chart.legend);
    delete chart.legend;
  },
  beforeUpdate(chart, _args, options) {
    const legend = chart.legend;
    layouts.configure(chart, legend, options);
    legend.options = options;
  },
  afterUpdate(chart) {
    const legend = chart.legend;
    legend.buildLabels();
    legend.adjustHitBoxes();
  },
  afterEvent(chart, args) {
    if (!args.replay) {
      chart.legend.handleEvent(args.event);
    }
  },
  defaults: {
    display: true,
    position: 'top',
    align: 'center',
    fullSize: true,
    reverse: false,
    weight: 1000,
    onClick(e, legendItem, legend) {
      const index = legendItem.datasetIndex;
      const ci = legend.chart;
      if (ci.isDatasetVisible(index)) {
        ci.hide(index);
        legendItem.hidden = true;
      } else {
        ci.show(index);
        legendItem.hidden = false;
      }
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: ctx => ctx.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(chart) {
        const datasets = chart.data.datasets;
        const {
          labels: {
            usePointStyle,
            pointStyle,
            textAlign,
            color,
            useBorderRadius,
            borderRadius
          }
        } = chart.legend.options;
        return chart._getSortedDatasetMetas().map(meta => {
          const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
          const borderWidth = toPadding(style.borderWidth);
          return {
            text: datasets[meta.index].label,
            fillStyle: style.backgroundColor,
            fontColor: color,
            hidden: !meta.visible,
            lineCap: style.borderCapStyle,
            lineDash: style.borderDash,
            lineDashOffset: style.borderDashOffset,
            lineJoin: style.borderJoinStyle,
            lineWidth: (borderWidth.width + borderWidth.height) / 4,
            strokeStyle: style.borderColor,
            pointStyle: pointStyle || style.pointStyle,
            rotation: style.rotation,
            textAlign: textAlign || style.textAlign,
            borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
            datasetIndex: meta.index
          };
        }, this);
      }
    },
    title: {
      color: ctx => ctx.chart.options.color,
      display: false,
      position: 'center',
      text: ''
    }
  },
  descriptors: {
    _scriptable: name => !name.startsWith('on'),
    labels: {
      _scriptable: name => !['generateLabels', 'filter', 'sort'].includes(name)
    }
  }
};
const positioners = {
  average(items) {
    if (!items.length) {
      return false;
    }
    let i, len;
    let xSet = new Set();
    let y = 0;
    let count = 0;
    for (i = 0, len = items.length; i < len; ++i) {
      const el = items[i].element;
      if (el && el.hasValue()) {
        const pos = el.tooltipPosition();
        xSet.add(pos.x);
        y += pos.y;
        ++count;
      }
    }
    if (count === 0 || xSet.size === 0) {
      return false;
    }
    const xAverage = [...xSet].reduce((a, b) => a + b) / xSet.size;
    return {
      x: xAverage,
      y: y / count
    };
  },
  nearest(items, eventPosition) {
    if (!items.length) {
      return false;
    }
    let x = eventPosition.x;
    let y = eventPosition.y;
    let minDistance = Number.POSITIVE_INFINITY;
    let i, len, nearestElement;
    for (i = 0, len = items.length; i < len; ++i) {
      const el = items[i].element;
      if (el && el.hasValue()) {
        const center = el.getCenterPoint();
        const d = distanceBetweenPoints(eventPosition, center);
        if (d < minDistance) {
          minDistance = d;
          nearestElement = el;
        }
      }
    }
    if (nearestElement) {
      const tp = nearestElement.tooltipPosition();
      x = tp.x;
      y = tp.y;
    }
    return {
      x,
      y
    };
  }
};
function pushOrConcat(base, toPush) {
  if (toPush) {
    if (isArray(toPush)) {
      Array.prototype.push.apply(base, toPush);
    } else {
      base.push(toPush);
    }
  }
  return base;
}
function splitNewlines(str) {
  if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
    return str.split('\n');
  }
  return str;
}
function createTooltipItem(chart, item) {
  const {
    element,
    datasetIndex,
    index
  } = item;
  const controller = chart.getDatasetMeta(datasetIndex).controller;
  const {
    label,
    value
  } = controller.getLabelAndValue(index);
  return {
    chart,
    label,
    parsed: controller.getParsed(index),
    raw: chart.data.datasets[datasetIndex].data[index],
    formattedValue: value,
    dataset: controller.getDataset(),
    dataIndex: index,
    datasetIndex,
    element
  };
}
function getTooltipSize(tooltip, options) {
  const ctx = tooltip.chart.ctx;
  const {
    body,
    footer,
    title
  } = tooltip;
  const {
    boxWidth,
    boxHeight
  } = options;
  const bodyFont = toFont(options.bodyFont);
  const titleFont = toFont(options.titleFont);
  const footerFont = toFont(options.footerFont);
  const titleLineCount = title.length;
  const footerLineCount = footer.length;
  const bodyLineItemCount = body.length;
  const padding = toPadding(options.padding);
  let height = padding.height;
  let width = 0;
  let combinedBodyLength = body.reduce((count, bodyItem) => count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
  combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
  if (titleLineCount) {
    height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
  }
  if (combinedBodyLength) {
    const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
    height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
  }
  if (footerLineCount) {
    height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
  }
  let widthPadding = 0;
  const maxLineWidth = function (line) {
    width = Math.max(width, ctx.measureText(line).width + widthPadding);
  };
  ctx.save();
  ctx.font = titleFont.string;
  each(tooltip.title, maxLineWidth);
  ctx.font = bodyFont.string;
  each(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
  widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
  each(body, bodyItem => {
    each(bodyItem.before, maxLineWidth);
    each(bodyItem.lines, maxLineWidth);
    each(bodyItem.after, maxLineWidth);
  });
  widthPadding = 0;
  ctx.font = footerFont.string;
  each(tooltip.footer, maxLineWidth);
  ctx.restore();
  width += padding.width;
  return {
    width,
    height
  };
}
function determineYAlign(chart, size) {
  const {
    y,
    height
  } = size;
  if (y < height / 2) {
    return 'top';
  } else if (y > chart.height - height / 2) {
    return 'bottom';
  }
  return 'center';
}
function doesNotFitWithAlign(xAlign, chart, options, size) {
  const {
    x,
    width
  } = size;
  const caret = options.caretSize + options.caretPadding;
  if (xAlign === 'left' && x + width + caret > chart.width) {
    return true;
  }
  if (xAlign === 'right' && x - width - caret < 0) {
    return true;
  }
}
function determineXAlign(chart, options, size, yAlign) {
  const {
    x,
    width
  } = size;
  const {
    width: chartWidth,
    chartArea: {
      left,
      right
    }
  } = chart;
  let xAlign = 'center';
  if (yAlign === 'center') {
    xAlign = x <= (left + right) / 2 ? 'left' : 'right';
  } else if (x <= width / 2) {
    xAlign = 'left';
  } else if (x >= chartWidth - width / 2) {
    xAlign = 'right';
  }
  if (doesNotFitWithAlign(xAlign, chart, options, size)) {
    xAlign = 'center';
  }
  return xAlign;
}
function determineAlignment(chart, options, size) {
  const yAlign = size.yAlign || options.yAlign || determineYAlign(chart, size);
  return {
    xAlign: size.xAlign || options.xAlign || determineXAlign(chart, options, size, yAlign),
    yAlign
  };
}
function alignX(size, xAlign) {
  let {
    x,
    width
  } = size;
  if (xAlign === 'right') {
    x -= width;
  } else if (xAlign === 'center') {
    x -= width / 2;
  }
  return x;
}
function alignY(size, yAlign, paddingAndSize) {
  let {
    y,
    height
  } = size;
  if (yAlign === 'top') {
    y += paddingAndSize;
  } else if (yAlign === 'bottom') {
    y -= height + paddingAndSize;
  } else {
    y -= height / 2;
  }
  return y;
}
function getBackgroundPoint(options, size, alignment, chart) {
  const {
    caretSize,
    caretPadding,
    cornerRadius
  } = options;
  const {
    xAlign,
    yAlign
  } = alignment;
  const paddingAndSize = caretSize + caretPadding;
  const {
    topLeft,
    topRight,
    bottomLeft,
    bottomRight
  } = toTRBLCorners(cornerRadius);
  let x = alignX(size, xAlign);
  const y = alignY(size, yAlign, paddingAndSize);
  if (yAlign === 'center') {
    if (xAlign === 'left') {
      x += paddingAndSize;
    } else if (xAlign === 'right') {
      x -= paddingAndSize;
    }
  } else if (xAlign === 'left') {
    x -= Math.max(topLeft, bottomLeft) + caretSize;
  } else if (xAlign === 'right') {
    x += Math.max(topRight, bottomRight) + caretSize;
  }
  return {
    x: _limitValue(x, 0, chart.width - size.width),
    y: _limitValue(y, 0, chart.height - size.height)
  };
}
function getAlignedX(tooltip, align, options) {
  const padding = toPadding(options.padding);
  return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function getBeforeAfterBodyLines(callback) {
  return pushOrConcat([], splitNewlines(callback));
}
function createTooltipContext(parent, tooltip, tooltipItems) {
  return createContext(parent, {
    tooltip,
    tooltipItems,
    type: 'tooltip'
  });
}
function overrideCallbacks(callbacks, context) {
  const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
  return override ? callbacks.override(override) : callbacks;
}
const defaultCallbacks = {
  beforeTitle: noop,
  title(tooltipItems) {
    if (tooltipItems.length > 0) {
      const item = tooltipItems[0];
      const labels = item.chart.data.labels;
      const labelCount = labels ? labels.length : 0;
      if (this && this.options && this.options.mode === 'dataset') {
        return item.dataset.label || '';
      } else if (item.label) {
        return item.label;
      } else if (labelCount > 0 && item.dataIndex < labelCount) {
        return labels[item.dataIndex];
      }
    }
    return '';
  },
  afterTitle: noop,
  beforeBody: noop,
  beforeLabel: noop,
  label(tooltipItem) {
    if (this && this.options && this.options.mode === 'dataset') {
      return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
    }
    let label = tooltipItem.dataset.label || '';
    if (label) {
      label += ': ';
    }
    const value = tooltipItem.formattedValue;
    if (!isNullOrUndef(value)) {
      label += value;
    }
    return label;
  },
  labelColor(tooltipItem) {
    const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
    const options = meta.controller.getStyle(tooltipItem.dataIndex);
    return {
      borderColor: options.borderColor,
      backgroundColor: options.backgroundColor,
      borderWidth: options.borderWidth,
      borderDash: options.borderDash,
      borderDashOffset: options.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(tooltipItem) {
    const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
    const options = meta.controller.getStyle(tooltipItem.dataIndex);
    return {
      pointStyle: options.pointStyle,
      rotation: options.rotation
    };
  },
  afterLabel: noop,
  afterBody: noop,
  beforeFooter: noop,
  footer: noop,
  afterFooter: noop
};
function invokeCallbackWithFallback(callbacks, name, ctx, arg) {
  const result = callbacks[name].call(ctx, arg);
  if (typeof result === 'undefined') {
    return defaultCallbacks[name].call(ctx, arg);
  }
  return result;
}
class Tooltip$1 extends Element$1 {
  constructor(config) {
    super();
    this.opacity = 0;
    this._active = [];
    this._eventPosition = undefined;
    this._size = undefined;
    this._cachedAnimations = undefined;
    this._tooltipItems = [];
    this.$animations = undefined;
    this.$context = undefined;
    this.chart = config.chart;
    this.options = config.options;
    this.dataPoints = undefined;
    this.title = undefined;
    this.beforeBody = undefined;
    this.body = undefined;
    this.afterBody = undefined;
    this.footer = undefined;
    this.xAlign = undefined;
    this.yAlign = undefined;
    this.x = undefined;
    this.y = undefined;
    this.height = undefined;
    this.width = undefined;
    this.caretX = undefined;
    this.caretY = undefined;
    this.labelColors = undefined;
    this.labelPointStyles = undefined;
    this.labelTextColors = undefined;
  }
  initialize(options) {
    this.options = options;
    this._cachedAnimations = undefined;
    this.$context = undefined;
  }
  _resolveAnimations() {
    const cached = this._cachedAnimations;
    if (cached) {
      return cached;
    }
    const chart = this.chart;
    const options = this.options.setContext(this.getContext());
    const opts = options.enabled && chart.options.animation && options.animations;
    const animations = new Animations(this.chart, opts);
    if (opts._cacheable) {
      this._cachedAnimations = Object.freeze(animations);
    }
    return animations;
  }
  getContext() {
    return this.$context || (this.$context = createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(context, options) {
    const {
      callbacks
    } = options;
    const beforeTitle = invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
    const title = invokeCallbackWithFallback(callbacks, 'title', this, context);
    const afterTitle = invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
    let lines = [];
    lines = pushOrConcat(lines, splitNewlines(beforeTitle));
    lines = pushOrConcat(lines, splitNewlines(title));
    lines = pushOrConcat(lines, splitNewlines(afterTitle));
    return lines;
  }
  getBeforeBody(tooltipItems, options) {
    return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
  }
  getBody(tooltipItems, options) {
    const {
      callbacks
    } = options;
    const bodyItems = [];
    each(tooltipItems, context => {
      const bodyItem = {
        before: [],
        lines: [],
        after: []
      };
      const scoped = overrideCallbacks(callbacks, context);
      pushOrConcat(bodyItem.before, splitNewlines(invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
      pushOrConcat(bodyItem.lines, invokeCallbackWithFallback(scoped, 'label', this, context));
      pushOrConcat(bodyItem.after, splitNewlines(invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
      bodyItems.push(bodyItem);
    });
    return bodyItems;
  }
  getAfterBody(tooltipItems, options) {
    return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
  }
  getFooter(tooltipItems, options) {
    const {
      callbacks
    } = options;
    const beforeFooter = invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
    const footer = invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
    const afterFooter = invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
    let lines = [];
    lines = pushOrConcat(lines, splitNewlines(beforeFooter));
    lines = pushOrConcat(lines, splitNewlines(footer));
    lines = pushOrConcat(lines, splitNewlines(afterFooter));
    return lines;
  }
  _createItems(options) {
    const active = this._active;
    const data = this.chart.data;
    const labelColors = [];
    const labelPointStyles = [];
    const labelTextColors = [];
    let tooltipItems = [];
    let i, len;
    for (i = 0, len = active.length; i < len; ++i) {
      tooltipItems.push(createTooltipItem(this.chart, active[i]));
    }
    if (options.filter) {
      tooltipItems = tooltipItems.filter((element, index, array) => options.filter(element, index, array, data));
    }
    if (options.itemSort) {
      tooltipItems = tooltipItems.sort((a, b) => options.itemSort(a, b, data));
    }
    each(tooltipItems, context => {
      const scoped = overrideCallbacks(options.callbacks, context);
      labelColors.push(invokeCallbackWithFallback(scoped, 'labelColor', this, context));
      labelPointStyles.push(invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
      labelTextColors.push(invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
    });
    this.labelColors = labelColors;
    this.labelPointStyles = labelPointStyles;
    this.labelTextColors = labelTextColors;
    this.dataPoints = tooltipItems;
    return tooltipItems;
  }
  update(changed, replay) {
    const options = this.options.setContext(this.getContext());
    const active = this._active;
    let properties;
    let tooltipItems = [];
    if (!active.length) {
      if (this.opacity !== 0) {
        properties = {
          opacity: 0
        };
      }
    } else {
      const position = positioners[options.position].call(this, active, this._eventPosition);
      tooltipItems = this._createItems(options);
      this.title = this.getTitle(tooltipItems, options);
      this.beforeBody = this.getBeforeBody(tooltipItems, options);
      this.body = this.getBody(tooltipItems, options);
      this.afterBody = this.getAfterBody(tooltipItems, options);
      this.footer = this.getFooter(tooltipItems, options);
      const size = this._size = getTooltipSize(this, options);
      const positionAndSize = Object.assign({}, position, size);
      const alignment = determineAlignment(this.chart, options, positionAndSize);
      const backgroundPoint = getBackgroundPoint(options, positionAndSize, alignment, this.chart);
      this.xAlign = alignment.xAlign;
      this.yAlign = alignment.yAlign;
      properties = {
        opacity: 1,
        x: backgroundPoint.x,
        y: backgroundPoint.y,
        width: size.width,
        height: size.height,
        caretX: position.x,
        caretY: position.y
      };
    }
    this._tooltipItems = tooltipItems;
    this.$context = undefined;
    if (properties) {
      this._resolveAnimations().update(this, properties);
    }
    if (changed && options.external) {
      options.external.call(this, {
        chart: this.chart,
        tooltip: this,
        replay
      });
    }
  }
  drawCaret(tooltipPoint, ctx, size, options) {
    const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
    ctx.lineTo(caretPosition.x1, caretPosition.y1);
    ctx.lineTo(caretPosition.x2, caretPosition.y2);
    ctx.lineTo(caretPosition.x3, caretPosition.y3);
  }
  getCaretPosition(tooltipPoint, size, options) {
    const {
      xAlign,
      yAlign
    } = this;
    const {
      caretSize,
      cornerRadius
    } = options;
    const {
      topLeft,
      topRight,
      bottomLeft,
      bottomRight
    } = toTRBLCorners(cornerRadius);
    const {
      x: ptX,
      y: ptY
    } = tooltipPoint;
    const {
      width,
      height
    } = size;
    let x1, x2, x3, y1, y2, y3;
    if (yAlign === 'center') {
      y2 = ptY + height / 2;
      if (xAlign === 'left') {
        x1 = ptX;
        x2 = x1 - caretSize;
        y1 = y2 + caretSize;
        y3 = y2 - caretSize;
      } else {
        x1 = ptX + width;
        x2 = x1 + caretSize;
        y1 = y2 - caretSize;
        y3 = y2 + caretSize;
      }
      x3 = x1;
    } else {
      if (xAlign === 'left') {
        x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
      } else if (xAlign === 'right') {
        x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
      } else {
        x2 = this.caretX;
      }
      if (yAlign === 'top') {
        y1 = ptY;
        y2 = y1 - caretSize;
        x1 = x2 - caretSize;
        x3 = x2 + caretSize;
      } else {
        y1 = ptY + height;
        y2 = y1 + caretSize;
        x1 = x2 + caretSize;
        x3 = x2 - caretSize;
      }
      y3 = y1;
    }
    return {
      x1,
      x2,
      x3,
      y1,
      y2,
      y3
    };
  }
  drawTitle(pt, ctx, options) {
    const title = this.title;
    const length = title.length;
    let titleFont, titleSpacing, i;
    if (length) {
      const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
      pt.x = getAlignedX(this, options.titleAlign, options);
      ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
      ctx.textBaseline = 'middle';
      titleFont = toFont(options.titleFont);
      titleSpacing = options.titleSpacing;
      ctx.fillStyle = options.titleColor;
      ctx.font = titleFont.string;
      for (i = 0; i < length; ++i) {
        ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
        pt.y += titleFont.lineHeight + titleSpacing;
        if (i + 1 === length) {
          pt.y += options.titleMarginBottom - titleSpacing;
        }
      }
    }
  }
  _drawColorBox(ctx, pt, i, rtlHelper, options) {
    const labelColor = this.labelColors[i];
    const labelPointStyle = this.labelPointStyles[i];
    const {
      boxHeight,
      boxWidth
    } = options;
    const bodyFont = toFont(options.bodyFont);
    const colorX = getAlignedX(this, 'left', options);
    const rtlColorX = rtlHelper.x(colorX);
    const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
    const colorY = pt.y + yOffSet;
    if (options.usePointStyle) {
      const drawOptions = {
        radius: Math.min(boxWidth, boxHeight) / 2,
        pointStyle: labelPointStyle.pointStyle,
        rotation: labelPointStyle.rotation,
        borderWidth: 1
      };
      const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
      const centerY = colorY + boxHeight / 2;
      ctx.strokeStyle = options.multiKeyBackground;
      ctx.fillStyle = options.multiKeyBackground;
      drawPoint(ctx, drawOptions, centerX, centerY);
      ctx.strokeStyle = labelColor.borderColor;
      ctx.fillStyle = labelColor.backgroundColor;
      drawPoint(ctx, drawOptions, centerX, centerY);
    } else {
      ctx.lineWidth = isObject(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
      ctx.strokeStyle = labelColor.borderColor;
      ctx.setLineDash(labelColor.borderDash || []);
      ctx.lineDashOffset = labelColor.borderDashOffset || 0;
      const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
      const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
      const borderRadius = toTRBLCorners(labelColor.borderRadius);
      if (Object.values(borderRadius).some(v => v !== 0)) {
        ctx.beginPath();
        ctx.fillStyle = options.multiKeyBackground;
        addRoundedRectPath(ctx, {
          x: outerX,
          y: colorY,
          w: boxWidth,
          h: boxHeight,
          radius: borderRadius
        });
        ctx.fill();
        ctx.stroke();
        ctx.fillStyle = labelColor.backgroundColor;
        ctx.beginPath();
        addRoundedRectPath(ctx, {
          x: innerX,
          y: colorY + 1,
          w: boxWidth - 2,
          h: boxHeight - 2,
          radius: borderRadius
        });
        ctx.fill();
      } else {
        ctx.fillStyle = options.multiKeyBackground;
        ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
        ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
        ctx.fillStyle = labelColor.backgroundColor;
        ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
      }
    }
    ctx.fillStyle = this.labelTextColors[i];
  }
  drawBody(pt, ctx, options) {
    const {
      body
    } = this;
    const {
      bodySpacing,
      bodyAlign,
      displayColors,
      boxHeight,
      boxWidth,
      boxPadding
    } = options;
    const bodyFont = toFont(options.bodyFont);
    let bodyLineHeight = bodyFont.lineHeight;
    let xLinePadding = 0;
    const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
    const fillLineOfText = function (line) {
      ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
      pt.y += bodyLineHeight + bodySpacing;
    };
    const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
    let bodyItem, textColor, lines, i, j, ilen, jlen;
    ctx.textAlign = bodyAlign;
    ctx.textBaseline = 'middle';
    ctx.font = bodyFont.string;
    pt.x = getAlignedX(this, bodyAlignForCalculation, options);
    ctx.fillStyle = options.bodyColor;
    each(this.beforeBody, fillLineOfText);
    xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
    for (i = 0, ilen = body.length; i < ilen; ++i) {
      bodyItem = body[i];
      textColor = this.labelTextColors[i];
      ctx.fillStyle = textColor;
      each(bodyItem.before, fillLineOfText);
      lines = bodyItem.lines;
      if (displayColors && lines.length) {
        this._drawColorBox(ctx, pt, i, rtlHelper, options);
        bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
      }
      for (j = 0, jlen = lines.length; j < jlen; ++j) {
        fillLineOfText(lines[j]);
        bodyLineHeight = bodyFont.lineHeight;
      }
      each(bodyItem.after, fillLineOfText);
    }
    xLinePadding = 0;
    bodyLineHeight = bodyFont.lineHeight;
    each(this.afterBody, fillLineOfText);
    pt.y -= bodySpacing;
  }
  drawFooter(pt, ctx, options) {
    const footer = this.footer;
    const length = footer.length;
    let footerFont, i;
    if (length) {
      const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
      pt.x = getAlignedX(this, options.footerAlign, options);
      pt.y += options.footerMarginTop;
      ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
      ctx.textBaseline = 'middle';
      footerFont = toFont(options.footerFont);
      ctx.fillStyle = options.footerColor;
      ctx.font = footerFont.string;
      for (i = 0; i < length; ++i) {
        ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
        pt.y += footerFont.lineHeight + options.footerSpacing;
      }
    }
  }
  drawBackground(pt, ctx, tooltipSize, options) {
    const {
      xAlign,
      yAlign
    } = this;
    const {
      x,
      y
    } = pt;
    const {
      width,
      height
    } = tooltipSize;
    const {
      topLeft,
      topRight,
      bottomLeft,
      bottomRight
    } = toTRBLCorners(options.cornerRadius);
    ctx.fillStyle = options.backgroundColor;
    ctx.strokeStyle = options.borderColor;
    ctx.lineWidth = options.borderWidth;
    ctx.beginPath();
    ctx.moveTo(x + topLeft, y);
    if (yAlign === 'top') {
      this.drawCaret(pt, ctx, tooltipSize, options);
    }
    ctx.lineTo(x + width - topRight, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
    if (yAlign === 'center' && xAlign === 'right') {
      this.drawCaret(pt, ctx, tooltipSize, options);
    }
    ctx.lineTo(x + width, y + height - bottomRight);
    ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
    if (yAlign === 'bottom') {
      this.drawCaret(pt, ctx, tooltipSize, options);
    }
    ctx.lineTo(x + bottomLeft, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
    if (yAlign === 'center' && xAlign === 'left') {
      this.drawCaret(pt, ctx, tooltipSize, options);
    }
    ctx.lineTo(x, y + topLeft);
    ctx.quadraticCurveTo(x, y, x + topLeft, y);
    ctx.closePath();
    ctx.fill();
    if (options.borderWidth > 0) {
      ctx.stroke();
    }
  }
  _updateAnimationTarget(options) {
    const chart = this.chart;
    const anims = this.$animations;
    const animX = anims && anims.x;
    const animY = anims && anims.y;
    if (animX || animY) {
      const position = positioners[options.position].call(this, this._active, this._eventPosition);
      if (!position) {
        return;
      }
      const size = this._size = getTooltipSize(this, options);
      const positionAndSize = Object.assign({}, position, this._size);
      const alignment = determineAlignment(chart, options, positionAndSize);
      const point = getBackgroundPoint(options, positionAndSize, alignment, chart);
      if (animX._to !== point.x || animY._to !== point.y) {
        this.xAlign = alignment.xAlign;
        this.yAlign = alignment.yAlign;
        this.width = size.width;
        this.height = size.height;
        this.caretX = position.x;
        this.caretY = position.y;
        this._resolveAnimations().update(this, point);
      }
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(ctx) {
    const options = this.options.setContext(this.getContext());
    let opacity = this.opacity;
    if (!opacity) {
      return;
    }
    this._updateAnimationTarget(options);
    const tooltipSize = {
      width: this.width,
      height: this.height
    };
    const pt = {
      x: this.x,
      y: this.y
    };
    opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
    const padding = toPadding(options.padding);
    const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    if (options.enabled && hasTooltipContent) {
      ctx.save();
      ctx.globalAlpha = opacity;
      this.drawBackground(pt, ctx, tooltipSize, options);
      overrideTextDirection(ctx, options.textDirection);
      pt.y += padding.top;
      this.drawTitle(pt, ctx, options);
      this.drawBody(pt, ctx, options);
      this.drawFooter(pt, ctx, options);
      restoreTextDirection(ctx, options.textDirection);
      ctx.restore();
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(activeElements, eventPosition) {
    const lastActive = this._active;
    const active = activeElements.map(({
      datasetIndex,
      index
    }) => {
      const meta = this.chart.getDatasetMeta(datasetIndex);
      if (!meta) {
        throw new Error('Cannot find a dataset at index ' + datasetIndex);
      }
      return {
        datasetIndex,
        element: meta.data[index],
        index
      };
    });
    const changed = !_elementsEqual(lastActive, active);
    const positionChanged = this._positionChanged(active, eventPosition);
    if (changed || positionChanged) {
      this._active = active;
      this._eventPosition = eventPosition;
      this._ignoreReplayEvents = true;
      this.update(true);
    }
  }
  handleEvent(e, replay, inChartArea = true) {
    if (replay && this._ignoreReplayEvents) {
      return false;
    }
    this._ignoreReplayEvents = false;
    const options = this.options;
    const lastActive = this._active || [];
    const active = this._getActiveElements(e, lastActive, replay, inChartArea);
    const positionChanged = this._positionChanged(active, e);
    const changed = replay || !_elementsEqual(active, lastActive) || positionChanged;
    if (changed) {
      this._active = active;
      if (options.enabled || options.external) {
        this._eventPosition = {
          x: e.x,
          y: e.y
        };
        this.update(true, replay);
      }
    }
    return changed;
  }
  _getActiveElements(e, lastActive, replay, inChartArea) {
    const options = this.options;
    if (e.type === 'mouseout') {
      return [];
    }
    if (!inChartArea) {
      return lastActive.filter(i => this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
    }
    const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
    if (options.reverse) {
      active.reverse();
    }
    return active;
  }
  _positionChanged(active, e) {
    const {
      caretX,
      caretY,
      options
    } = this;
    const position = positioners[options.position].call(this, active, e);
    return position !== false && (caretX !== position.x || caretY !== position.y);
  }
}
_defineProperty(Tooltip$1, "positioners", positioners);
var plugin_tooltip = {
  id: 'tooltip',
  _element: Tooltip$1,
  positioners,
  afterInit(chart, _args, options) {
    if (options) {
      chart.tooltip = new Tooltip$1({
        chart,
        options
      });
    }
  },
  beforeUpdate(chart, _args, options) {
    if (chart.tooltip) {
      chart.tooltip.initialize(options);
    }
  },
  reset(chart, _args, options) {
    if (chart.tooltip) {
      chart.tooltip.initialize(options);
    }
  },
  afterDraw(chart) {
    const tooltip = chart.tooltip;
    if (tooltip && tooltip._willRender()) {
      const args = {
        tooltip
      };
      if (chart.notifyPlugins('beforeTooltipDraw', {
        ...args,
        cancelable: true
      }) === false) {
        return;
      }
      tooltip.draw(chart.ctx);
      chart.notifyPlugins('afterTooltipDraw', args);
    }
  },
  afterEvent(chart, args) {
    if (chart.tooltip) {
      const useFinalPosition = args.replay;
      if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) {
        args.changed = true;
      }
    }
  },
  defaults: {
    enabled: true,
    external: null,
    position: 'average',
    backgroundColor: 'rgba(0,0,0,0.8)',
    titleColor: '#fff',
    titleFont: {
      weight: 'bold'
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: 'left',
    bodyColor: '#fff',
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: 'left',
    footerColor: '#fff',
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: 'bold'
    },
    footerAlign: 'left',
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (ctx, opts) => opts.bodyFont.size,
    boxWidth: (ctx, opts) => opts.bodyFont.size,
    multiKeyBackground: '#fff',
    displayColors: true,
    boxPadding: 0,
    borderColor: 'rgba(0,0,0,0)',
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: 'easeOutQuart'
    },
    animations: {
      numbers: {
        type: 'number',
        properties: ['x', 'y', 'width', 'height', 'caretX', 'caretY']
      },
      opacity: {
        easing: 'linear',
        duration: 200
      }
    },
    callbacks: defaultCallbacks
  },
  defaultRoutes: {
    bodyFont: 'font',
    footerFont: 'font',
    titleFont: 'font'
  },
  descriptors: {
    _scriptable: name => name !== 'filter' && name !== 'itemSort' && name !== 'external',
    _indexable: false,
    callbacks: {
      _scriptable: false,
      _indexable: false
    },
    animation: {
      _fallback: false
    },
    animations: {
      _fallback: 'animation'
    }
  },
  additionalOptionScopes: ['interaction']
};
const addIfString = (labels, raw, index, addedLabels) => {
  if (typeof raw === 'string') {
    index = labels.push(raw) - 1;
    addedLabels.unshift({
      index,
      label: raw
    });
  } else if (isNaN(raw)) {
    index = null;
  }
  return index;
};
function findOrAddLabel(labels, raw, index, addedLabels) {
  const first = labels.indexOf(raw);
  if (first === -1) {
    return addIfString(labels, raw, index, addedLabels);
  }
  const last = labels.lastIndexOf(raw);
  return first !== last ? index : first;
}
const validIndex = (index, max) => index === null ? null : _limitValue(Math.round(index), 0, max);
function _getLabelForValue(value) {
  const labels = this.getLabels();
  if (value >= 0 && value < labels.length) {
    return labels[value];
  }
  return value;
}
class CategoryScale extends Scale {
  constructor(cfg) {
    super(cfg);
    this._startValue = undefined;
    this._valueRange = 0;
    this._addedLabels = [];
  }
  init(scaleOptions) {
    const added = this._addedLabels;
    if (added.length) {
      const labels = this.getLabels();
      for (const {
        index,
        label
      } of added) {
        if (labels[index] === label) {
          labels.splice(index, 1);
        }
      }
      this._addedLabels = [];
    }
    super.init(scaleOptions);
  }
  parse(raw, index) {
    if (isNullOrUndef(raw)) {
      return null;
    }
    const labels = this.getLabels();
    index = isFinite(index) && labels[index] === raw ? index : findOrAddLabel(labels, raw, valueOrDefault(index, raw), this._addedLabels);
    return validIndex(index, labels.length - 1);
  }
  determineDataLimits() {
    const {
      minDefined,
      maxDefined
    } = this.getUserBounds();
    let {
      min,
      max
    } = this.getMinMax(true);
    if (this.options.bounds === 'ticks') {
      if (!minDefined) {
        min = 0;
      }
      if (!maxDefined) {
        max = this.getLabels().length - 1;
      }
    }
    this.min = min;
    this.max = max;
  }
  buildTicks() {
    const min = this.min;
    const max = this.max;
    const offset = this.options.offset;
    const ticks = [];
    let labels = this.getLabels();
    labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
    this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
    this._startValue = this.min - (offset ? 0.5 : 0);
    for (let value = min; value <= max; value++) {
      ticks.push({
        value
      });
    }
    return ticks;
  }
  getLabelForValue(value) {
    return _getLabelForValue.call(this, value);
  }
  configure() {
    super.configure();
    if (!this.isHorizontal()) {
      this._reversePixels = !this._reversePixels;
    }
  }
  getPixelForValue(value) {
    if (typeof value !== 'number') {
      value = this.parse(value);
    }
    return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
  }
  getPixelForTick(index) {
    const ticks = this.ticks;
    if (index < 0 || index > ticks.length - 1) {
      return null;
    }
    return this.getPixelForValue(ticks[index].value);
  }
  getValueForPixel(pixel) {
    return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
_defineProperty(CategoryScale, "id", 'category');
_defineProperty(CategoryScale, "defaults", {
  ticks: {
    callback: _getLabelForValue
  }
});
function generateTicks$1(generationOptions, dataRange) {
  const ticks = [];
  const MIN_SPACING = 1e-14;
  const {
    bounds,
    step,
    min,
    max,
    precision,
    count,
    maxTicks,
    maxDigits,
    includeBounds
  } = generationOptions;
  const unit = step || 1;
  const maxSpaces = maxTicks - 1;
  const {
    min: rmin,
    max: rmax
  } = dataRange;
  const minDefined = !isNullOrUndef(min);
  const maxDefined = !isNullOrUndef(max);
  const countDefined = !isNullOrUndef(count);
  const minSpacing = (rmax - rmin) / (maxDigits + 1);
  let spacing = niceNum((rmax - rmin) / maxSpaces / unit) * unit;
  let factor, niceMin, niceMax, numSpaces;
  if (spacing < MIN_SPACING && !minDefined && !maxDefined) {
    return [{
      value: rmin
    }, {
      value: rmax
    }];
  }
  numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
  if (numSpaces > maxSpaces) {
    spacing = niceNum(numSpaces * spacing / maxSpaces / unit) * unit;
  }
  if (!isNullOrUndef(precision)) {
    factor = Math.pow(10, precision);
    spacing = Math.ceil(spacing * factor) / factor;
  }
  if (bounds === 'ticks') {
    niceMin = Math.floor(rmin / spacing) * spacing;
    niceMax = Math.ceil(rmax / spacing) * spacing;
  } else {
    niceMin = rmin;
    niceMax = rmax;
  }
  if (minDefined && maxDefined && step && almostWhole((max - min) / step, spacing / 1000)) {
    numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
    spacing = (max - min) / numSpaces;
    niceMin = min;
    niceMax = max;
  } else if (countDefined) {
    niceMin = minDefined ? min : niceMin;
    niceMax = maxDefined ? max : niceMax;
    numSpaces = count - 1;
    spacing = (niceMax - niceMin) / numSpaces;
  } else {
    numSpaces = (niceMax - niceMin) / spacing;
    if (almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
      numSpaces = Math.round(numSpaces);
    } else {
      numSpaces = Math.ceil(numSpaces);
    }
  }
  const decimalPlaces = Math.max(_decimalPlaces(spacing), _decimalPlaces(niceMin));
  factor = Math.pow(10, isNullOrUndef(precision) ? decimalPlaces : precision);
  niceMin = Math.round(niceMin * factor) / factor;
  niceMax = Math.round(niceMax * factor) / factor;
  let j = 0;
  if (minDefined) {
    if (includeBounds && niceMin !== min) {
      ticks.push({
        value: min
      });
      if (niceMin < min) {
        j++;
      }
      if (almostEquals(Math.round((niceMin + j * spacing) * factor) / factor, min, relativeLabelSize(min, minSpacing, generationOptions))) {
        j++;
      }
    } else if (niceMin < min) {
      j++;
    }
  }
  for (; j < numSpaces; ++j) {
    const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
    if (maxDefined && tickValue > max) {
      break;
    }
    ticks.push({
      value: tickValue
    });
  }
  if (maxDefined && includeBounds && niceMax !== max) {
    if (ticks.length && almostEquals(ticks[ticks.length - 1].value, max, relativeLabelSize(max, minSpacing, generationOptions))) {
      ticks[ticks.length - 1].value = max;
    } else {
      ticks.push({
        value: max
      });
    }
  } else if (!maxDefined || niceMax === max) {
    ticks.push({
      value: niceMax
    });
  }
  return ticks;
}
function relativeLabelSize(value, minSpacing, {
  horizontal,
  minRotation
}) {
  const rad = toRadians(minRotation);
  const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
  const length = 0.75 * minSpacing * ('' + value).length;
  return Math.min(minSpacing / ratio, length);
}
class LinearScaleBase extends Scale {
  constructor(cfg) {
    super(cfg);
    this.start = undefined;
    this.end = undefined;
    this._startValue = undefined;
    this._endValue = undefined;
    this._valueRange = 0;
  }
  parse(raw, index) {
    if (isNullOrUndef(raw)) {
      return null;
    }
    if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) {
      return null;
    }
    return +raw;
  }
  handleTickRangeOptions() {
    const {
      beginAtZero
    } = this.options;
    const {
      minDefined,
      maxDefined
    } = this.getUserBounds();
    let {
      min,
      max
    } = this;
    const setMin = v => min = minDefined ? min : v;
    const setMax = v => max = maxDefined ? max : v;
    if (beginAtZero) {
      const minSign = sign(min);
      const maxSign = sign(max);
      if (minSign < 0 && maxSign < 0) {
        setMax(0);
      } else if (minSign > 0 && maxSign > 0) {
        setMin(0);
      }
    }
    if (min === max) {
      let offset = max === 0 ? 1 : Math.abs(max * 0.05);
      setMax(max + offset);
      if (!beginAtZero) {
        setMin(min - offset);
      }
    }
    this.min = min;
    this.max = max;
  }
  getTickLimit() {
    const tickOpts = this.options.ticks;
    let {
      maxTicksLimit,
      stepSize
    } = tickOpts;
    let maxTicks;
    if (stepSize) {
      maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
      if (maxTicks > 1000) {
        console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
        maxTicks = 1000;
      }
    } else {
      maxTicks = this.computeTickLimit();
      maxTicksLimit = maxTicksLimit || 11;
    }
    if (maxTicksLimit) {
      maxTicks = Math.min(maxTicksLimit, maxTicks);
    }
    return maxTicks;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const opts = this.options;
    const tickOpts = opts.ticks;
    let maxTicks = this.getTickLimit();
    maxTicks = Math.max(2, maxTicks);
    const numericGeneratorOptions = {
      maxTicks,
      bounds: opts.bounds,
      min: opts.min,
      max: opts.max,
      precision: tickOpts.precision,
      step: tickOpts.stepSize,
      count: tickOpts.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: tickOpts.minRotation || 0,
      includeBounds: tickOpts.includeBounds !== false
    };
    const dataRange = this._range || this;
    const ticks = generateTicks$1(numericGeneratorOptions, dataRange);
    if (opts.bounds === 'ticks') {
      _setMinAndMaxByKey(ticks, this, 'value');
    }
    if (opts.reverse) {
      ticks.reverse();
      this.start = this.max;
      this.end = this.min;
    } else {
      this.start = this.min;
      this.end = this.max;
    }
    return ticks;
  }
  configure() {
    const ticks = this.ticks;
    let start = this.min;
    let end = this.max;
    super.configure();
    if (this.options.offset && ticks.length) {
      const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
      start -= offset;
      end += offset;
    }
    this._startValue = start;
    this._endValue = end;
    this._valueRange = end - start;
  }
  getLabelForValue(value) {
    return formatNumber(value, this.chart.options.locale, this.options.ticks.format);
  }
}
class LinearScale extends LinearScaleBase {
  determineDataLimits() {
    const {
      min,
      max
    } = this.getMinMax(true);
    this.min = isNumberFinite(min) ? min : 0;
    this.max = isNumberFinite(max) ? max : 1;
    this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const horizontal = this.isHorizontal();
    const length = horizontal ? this.width : this.height;
    const minRotation = toRadians(this.options.ticks.minRotation);
    const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
    const tickFont = this._resolveTickFontOptions(0);
    return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
  }
  getPixelForValue(value) {
    return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
  }
  getValueForPixel(pixel) {
    return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
  }
}
_defineProperty(LinearScale, "id", 'linear');
_defineProperty(LinearScale, "defaults", {
  ticks: {
    callback: Ticks.formatters.numeric
  }
});
const log10Floor = v => Math.floor(log10(v));
const changeExponent = (v, m) => Math.pow(10, log10Floor(v) + m);
function isMajor(tickVal) {
  const remain = tickVal / Math.pow(10, log10Floor(tickVal));
  return remain === 1;
}
function steps(min, max, rangeExp) {
  const rangeStep = Math.pow(10, rangeExp);
  const start = Math.floor(min / rangeStep);
  const end = Math.ceil(max / rangeStep);
  return end - start;
}
function startExp(min, max) {
  const range = max - min;
  let rangeExp = log10Floor(range);
  while (steps(min, max, rangeExp) > 10) {
    rangeExp++;
  }
  while (steps(min, max, rangeExp) < 10) {
    rangeExp--;
  }
  return Math.min(rangeExp, log10Floor(min));
}
function generateTicks(generationOptions, {
  min,
  max
}) {
  min = finiteOrDefault(generationOptions.min, min);
  const ticks = [];
  const minExp = log10Floor(min);
  let exp = startExp(min, max);
  let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
  const stepSize = Math.pow(10, exp);
  const base = minExp > exp ? Math.pow(10, minExp) : 0;
  const start = Math.round((min - base) * precision) / precision;
  const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
  let significand = Math.floor((start - offset) / Math.pow(10, exp));
  let value = finiteOrDefault(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
  while (value < max) {
    ticks.push({
      value,
      major: isMajor(value),
      significand
    });
    if (significand >= 10) {
      significand = significand < 15 ? 15 : 20;
    } else {
      significand++;
    }
    if (significand >= 20) {
      exp++;
      significand = 2;
      precision = exp >= 0 ? 1 : precision;
    }
    value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
  }
  const lastTick = finiteOrDefault(generationOptions.max, value);
  ticks.push({
    value: lastTick,
    major: isMajor(lastTick),
    significand
  });
  return ticks;
}
class LogarithmicScale extends Scale {
  constructor(cfg) {
    super(cfg);
    this.start = undefined;
    this.end = undefined;
    this._startValue = undefined;
    this._valueRange = 0;
  }
  parse(raw, index) {
    const value = LinearScaleBase.prototype.parse.apply(this, [raw, index]);
    if (value === 0) {
      this._zero = true;
      return undefined;
    }
    return isNumberFinite(value) && value > 0 ? value : null;
  }
  determineDataLimits() {
    const {
      min,
      max
    } = this.getMinMax(true);
    this.min = isNumberFinite(min) ? Math.max(0, min) : null;
    this.max = isNumberFinite(max) ? Math.max(0, max) : null;
    if (this.options.beginAtZero) {
      this._zero = true;
    }
    if (this._zero && this.min !== this._suggestedMin && !isNumberFinite(this._userMin)) {
      this.min = min === changeExponent(this.min, 0) ? changeExponent(this.min, -1) : changeExponent(this.min, 0);
    }
    this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const {
      minDefined,
      maxDefined
    } = this.getUserBounds();
    let min = this.min;
    let max = this.max;
    const setMin = v => min = minDefined ? min : v;
    const setMax = v => max = maxDefined ? max : v;
    if (min === max) {
      if (min <= 0) {
        setMin(1);
        setMax(10);
      } else {
        setMin(changeExponent(min, -1));
        setMax(changeExponent(max, +1));
      }
    }
    if (min <= 0) {
      setMin(changeExponent(max, -1));
    }
    if (max <= 0) {
      setMax(changeExponent(min, +1));
    }
    this.min = min;
    this.max = max;
  }
  buildTicks() {
    const opts = this.options;
    const generationOptions = {
      min: this._userMin,
      max: this._userMax
    };
    const ticks = generateTicks(generationOptions, this);
    if (opts.bounds === 'ticks') {
      _setMinAndMaxByKey(ticks, this, 'value');
    }
    if (opts.reverse) {
      ticks.reverse();
      this.start = this.max;
      this.end = this.min;
    } else {
      this.start = this.min;
      this.end = this.max;
    }
    return ticks;
  }
  getLabelForValue(value) {
    return value === undefined ? '0' : formatNumber(value, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const start = this.min;
    super.configure();
    this._startValue = log10(start);
    this._valueRange = log10(this.max) - log10(start);
  }
  getPixelForValue(value) {
    if (value === undefined || value === 0) {
      value = this.min;
    }
    if (value === null || isNaN(value)) {
      return NaN;
    }
    return this.getPixelForDecimal(value === this.min ? 0 : (log10(value) - this._startValue) / this._valueRange);
  }
  getValueForPixel(pixel) {
    const decimal = this.getDecimalForPixel(pixel);
    return Math.pow(10, this._startValue + decimal * this._valueRange);
  }
}
_defineProperty(LogarithmicScale, "id", 'logarithmic');
_defineProperty(LogarithmicScale, "defaults", {
  ticks: {
    callback: Ticks.formatters.logarithmic,
    major: {
      enabled: true
    }
  }
});
function getTickBackdropHeight(opts) {
  const tickOpts = opts.ticks;
  if (tickOpts.display && opts.display) {
    const padding = toPadding(tickOpts.backdropPadding);
    return valueOrDefault(tickOpts.font && tickOpts.font.size, defaults.font.size) + padding.height;
  }
  return 0;
}
function measureLabelSize(ctx, font, label) {
  label = isArray(label) ? label : [label];
  return {
    w: _longestText(ctx, font.string, label),
    h: label.length * font.lineHeight
  };
}
function determineLimits(angle, pos, size, min, max) {
  if (angle === min || angle === max) {
    return {
      start: pos - size / 2,
      end: pos + size / 2
    };
  } else if (angle < min || angle > max) {
    return {
      start: pos - size,
      end: pos
    };
  }
  return {
    start: pos,
    end: pos + size
  };
}
function fitWithPointLabels(scale) {
  const orig = {
    l: scale.left + scale._padding.left,
    r: scale.right - scale._padding.right,
    t: scale.top + scale._padding.top,
    b: scale.bottom - scale._padding.bottom
  };
  const limits = Object.assign({}, orig);
  const labelSizes = [];
  const padding = [];
  const valueCount = scale._pointLabels.length;
  const pointLabelOpts = scale.options.pointLabels;
  const additionalAngle = pointLabelOpts.centerPointLabels ? PI / valueCount : 0;
  for (let i = 0; i < valueCount; i++) {
    const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
    padding[i] = opts.padding;
    const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
    const plFont = toFont(opts.font);
    const textSize = measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
    labelSizes[i] = textSize;
    const angleRadians = _normalizeAngle(scale.getIndexAngle(i) + additionalAngle);
    const angle = Math.round(toDegrees(angleRadians));
    const hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
    const vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
    updateLimits(limits, orig, angleRadians, hLimits, vLimits);
  }
  scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
  scale._pointLabelItems = buildPointLabelItems(scale, labelSizes, padding);
}
function updateLimits(limits, orig, angle, hLimits, vLimits) {
  const sin = Math.abs(Math.sin(angle));
  const cos = Math.abs(Math.cos(angle));
  let x = 0;
  let y = 0;
  if (hLimits.start < orig.l) {
    x = (orig.l - hLimits.start) / sin;
    limits.l = Math.min(limits.l, orig.l - x);
  } else if (hLimits.end > orig.r) {
    x = (hLimits.end - orig.r) / sin;
    limits.r = Math.max(limits.r, orig.r + x);
  }
  if (vLimits.start < orig.t) {
    y = (orig.t - vLimits.start) / cos;
    limits.t = Math.min(limits.t, orig.t - y);
  } else if (vLimits.end > orig.b) {
    y = (vLimits.end - orig.b) / cos;
    limits.b = Math.max(limits.b, orig.b + y);
  }
}
function createPointLabelItem(scale, index, itemOpts) {
  const outerDistance = scale.drawingArea;
  const {
    extra,
    additionalAngle,
    padding,
    size
  } = itemOpts;
  const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
  const angle = Math.round(toDegrees(_normalizeAngle(pointLabelPosition.angle + HALF_PI)));
  const y = yForAngle(pointLabelPosition.y, size.h, angle);
  const textAlign = getTextAlignForAngle(angle);
  const left = leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
  return {
    visible: true,
    x: pointLabelPosition.x,
    y,
    textAlign,
    left,
    top: y,
    right: left + size.w,
    bottom: y + size.h
  };
}
function isNotOverlapped(item, area) {
  if (!area) {
    return true;
  }
  const {
    left,
    top,
    right,
    bottom
  } = item;
  const apexesInArea = _isPointInArea({
    x: left,
    y: top
  }, area) || _isPointInArea({
    x: left,
    y: bottom
  }, area) || _isPointInArea({
    x: right,
    y: top
  }, area) || _isPointInArea({
    x: right,
    y: bottom
  }, area);
  return !apexesInArea;
}
function buildPointLabelItems(scale, labelSizes, padding) {
  const items = [];
  const valueCount = scale._pointLabels.length;
  const opts = scale.options;
  const {
    centerPointLabels,
    display
  } = opts.pointLabels;
  const itemOpts = {
    extra: getTickBackdropHeight(opts) / 2,
    additionalAngle: centerPointLabels ? PI / valueCount : 0
  };
  let area;
  for (let i = 0; i < valueCount; i++) {
    itemOpts.padding = padding[i];
    itemOpts.size = labelSizes[i];
    const item = createPointLabelItem(scale, i, itemOpts);
    items.push(item);
    if (display === 'auto') {
      item.visible = isNotOverlapped(item, area);
      if (item.visible) {
        area = item;
      }
    }
  }
  return items;
}
function getTextAlignForAngle(angle) {
  if (angle === 0 || angle === 180) {
    return 'center';
  } else if (angle < 180) {
    return 'left';
  }
  return 'right';
}
function leftForTextAlign(x, w, align) {
  if (align === 'right') {
    x -= w;
  } else if (align === 'center') {
    x -= w / 2;
  }
  return x;
}
function yForAngle(y, h, angle) {
  if (angle === 90 || angle === 270) {
    y -= h / 2;
  } else if (angle > 270 || angle < 90) {
    y -= h;
  }
  return y;
}
function drawPointLabelBox(ctx, opts, item) {
  const {
    left,
    top,
    right,
    bottom
  } = item;
  const {
    backdropColor
  } = opts;
  if (!isNullOrUndef(backdropColor)) {
    const borderRadius = toTRBLCorners(opts.borderRadius);
    const padding = toPadding(opts.backdropPadding);
    ctx.fillStyle = backdropColor;
    const backdropLeft = left - padding.left;
    const backdropTop = top - padding.top;
    const backdropWidth = right - left + padding.width;
    const backdropHeight = bottom - top + padding.height;
    if (Object.values(borderRadius).some(v => v !== 0)) {
      ctx.beginPath();
      addRoundedRectPath(ctx, {
        x: backdropLeft,
        y: backdropTop,
        w: backdropWidth,
        h: backdropHeight,
        radius: borderRadius
      });
      ctx.fill();
    } else {
      ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
  }
}
function drawPointLabels(scale, labelCount) {
  const {
    ctx,
    options: {
      pointLabels
    }
  } = scale;
  for (let i = labelCount - 1; i >= 0; i--) {
    const item = scale._pointLabelItems[i];
    if (!item.visible) {
      continue;
    }
    const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
    drawPointLabelBox(ctx, optsAtIndex, item);
    const plFont = toFont(optsAtIndex.font);
    const {
      x,
      y,
      textAlign
    } = item;
    renderText(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
      color: optsAtIndex.color,
      textAlign: textAlign,
      textBaseline: 'middle'
    });
  }
}
function pathRadiusLine(scale, radius, circular, labelCount) {
  const {
    ctx
  } = scale;
  if (circular) {
    ctx.arc(scale.xCenter, scale.yCenter, radius, 0, TAU);
  } else {
    let pointPosition = scale.getPointPosition(0, radius);
    ctx.moveTo(pointPosition.x, pointPosition.y);
    for (let i = 1; i < labelCount; i++) {
      pointPosition = scale.getPointPosition(i, radius);
      ctx.lineTo(pointPosition.x, pointPosition.y);
    }
  }
}
function drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
  const ctx = scale.ctx;
  const circular = gridLineOpts.circular;
  const {
    color,
    lineWidth
  } = gridLineOpts;
  if (!circular && !labelCount || !color || !lineWidth || radius < 0) {
    return;
  }
  ctx.save();
  ctx.strokeStyle = color;
  ctx.lineWidth = lineWidth;
  ctx.setLineDash(borderOpts.dash || []);
  ctx.lineDashOffset = borderOpts.dashOffset;
  ctx.beginPath();
  pathRadiusLine(scale, radius, circular, labelCount);
  ctx.closePath();
  ctx.stroke();
  ctx.restore();
}
function createPointLabelContext(parent, index, label) {
  return createContext(parent, {
    label,
    index,
    type: 'pointLabel'
  });
}
class RadialLinearScale extends LinearScaleBase {
  constructor(cfg) {
    super(cfg);
    this.xCenter = undefined;
    this.yCenter = undefined;
    this.drawingArea = undefined;
    this._pointLabels = [];
    this._pointLabelItems = [];
  }
  setDimensions() {
    const padding = this._padding = toPadding(getTickBackdropHeight(this.options) / 2);
    const w = this.width = this.maxWidth - padding.width;
    const h = this.height = this.maxHeight - padding.height;
    this.xCenter = Math.floor(this.left + w / 2 + padding.left);
    this.yCenter = Math.floor(this.top + h / 2 + padding.top);
    this.drawingArea = Math.floor(Math.min(w, h) / 2);
  }
  determineDataLimits() {
    const {
      min,
      max
    } = this.getMinMax(false);
    this.min = isNumberFinite(min) && !isNaN(min) ? min : 0;
    this.max = isNumberFinite(max) && !isNaN(max) ? max : 0;
    this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
  }
  generateTickLabels(ticks) {
    LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
    this._pointLabels = this.getLabels().map((value, index) => {
      const label = callback(this.options.pointLabels.callback, [value, index], this);
      return label || label === 0 ? label : '';
    }).filter((v, i) => this.chart.getDataVisibility(i));
  }
  fit() {
    const opts = this.options;
    if (opts.display && opts.pointLabels.display) {
      fitWithPointLabels(this);
    } else {
      this.setCenterPoint(0, 0, 0, 0);
    }
  }
  setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
    this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
    this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
    this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
  }
  getIndexAngle(index) {
    const angleMultiplier = TAU / (this._pointLabels.length || 1);
    const startAngle = this.options.startAngle || 0;
    return _normalizeAngle(index * angleMultiplier + toRadians(startAngle));
  }
  getDistanceFromCenterForValue(value) {
    if (isNullOrUndef(value)) {
      return NaN;
    }
    const scalingFactor = this.drawingArea / (this.max - this.min);
    if (this.options.reverse) {
      return (this.max - value) * scalingFactor;
    }
    return (value - this.min) * scalingFactor;
  }
  getValueForDistanceFromCenter(distance) {
    if (isNullOrUndef(distance)) {
      return NaN;
    }
    const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
  }
  getPointLabelContext(index) {
    const pointLabels = this._pointLabels || [];
    if (index >= 0 && index < pointLabels.length) {
      const pointLabel = pointLabels[index];
      return createPointLabelContext(this.getContext(), index, pointLabel);
    }
  }
  getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
    const angle = this.getIndexAngle(index) - HALF_PI + additionalAngle;
    return {
      x: Math.cos(angle) * distanceFromCenter + this.xCenter,
      y: Math.sin(angle) * distanceFromCenter + this.yCenter,
      angle
    };
  }
  getPointPositionForValue(index, value) {
    return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
  }
  getBasePosition(index) {
    return this.getPointPositionForValue(index || 0, this.getBaseValue());
  }
  getPointLabelPosition(index) {
    const {
      left,
      top,
      right,
      bottom
    } = this._pointLabelItems[index];
    return {
      left,
      top,
      right,
      bottom
    };
  }
  drawBackground() {
    const {
      backgroundColor,
      grid: {
        circular
      }
    } = this.options;
    if (backgroundColor) {
      const ctx = this.ctx;
      ctx.save();
      ctx.beginPath();
      pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
      ctx.closePath();
      ctx.fillStyle = backgroundColor;
      ctx.fill();
      ctx.restore();
    }
  }
  drawGrid() {
    const ctx = this.ctx;
    const opts = this.options;
    const {
      angleLines,
      grid,
      border
    } = opts;
    const labelCount = this._pointLabels.length;
    let i, offset, position;
    if (opts.pointLabels.display) {
      drawPointLabels(this, labelCount);
    }
    if (grid.display) {
      this.ticks.forEach((tick, index) => {
        if (index !== 0 || index === 0 && this.min < 0) {
          offset = this.getDistanceFromCenterForValue(tick.value);
          const context = this.getContext(index);
          const optsAtIndex = grid.setContext(context);
          const optsAtIndexBorder = border.setContext(context);
          drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
        }
      });
    }
    if (angleLines.display) {
      ctx.save();
      for (i = labelCount - 1; i >= 0; i--) {
        const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
        const {
          color,
          lineWidth
        } = optsAtIndex;
        if (!lineWidth || !color) {
          continue;
        }
        ctx.lineWidth = lineWidth;
        ctx.strokeStyle = color;
        ctx.setLineDash(optsAtIndex.borderDash);
        ctx.lineDashOffset = optsAtIndex.borderDashOffset;
        offset = this.getDistanceFromCenterForValue(opts.reverse ? this.min : this.max);
        position = this.getPointPosition(i, offset);
        ctx.beginPath();
        ctx.moveTo(this.xCenter, this.yCenter);
        ctx.lineTo(position.x, position.y);
        ctx.stroke();
      }
      ctx.restore();
    }
  }
  drawBorder() {}
  drawLabels() {
    const ctx = this.ctx;
    const opts = this.options;
    const tickOpts = opts.ticks;
    if (!tickOpts.display) {
      return;
    }
    const startAngle = this.getIndexAngle(0);
    let offset, width;
    ctx.save();
    ctx.translate(this.xCenter, this.yCenter);
    ctx.rotate(startAngle);
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    this.ticks.forEach((tick, index) => {
      if (index === 0 && this.min >= 0 && !opts.reverse) {
        return;
      }
      const optsAtIndex = tickOpts.setContext(this.getContext(index));
      const tickFont = toFont(optsAtIndex.font);
      offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
      if (optsAtIndex.showLabelBackdrop) {
        ctx.font = tickFont.string;
        width = ctx.measureText(tick.label).width;
        ctx.fillStyle = optsAtIndex.backdropColor;
        const padding = toPadding(optsAtIndex.backdropPadding);
        ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
      }
      renderText(ctx, tick.label, 0, -offset, tickFont, {
        color: optsAtIndex.color,
        strokeColor: optsAtIndex.textStrokeColor,
        strokeWidth: optsAtIndex.textStrokeWidth
      });
    });
    ctx.restore();
  }
  drawTitle() {}
}
_defineProperty(RadialLinearScale, "id", 'radialLinear');
_defineProperty(RadialLinearScale, "defaults", {
  display: true,
  animate: true,
  position: 'chartArea',
  angleLines: {
    display: true,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0.0
  },
  grid: {
    circular: false
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: true,
    callback: Ticks.formatters.numeric
  },
  pointLabels: {
    backdropColor: undefined,
    backdropPadding: 2,
    display: true,
    font: {
      size: 10
    },
    callback(label) {
      return label;
    },
    padding: 5,
    centerPointLabels: false
  }
});
_defineProperty(RadialLinearScale, "defaultRoutes", {
  'angleLines.color': 'borderColor',
  'pointLabels.color': 'color',
  'ticks.color': 'color'
});
_defineProperty(RadialLinearScale, "descriptors", {
  angleLines: {
    _fallback: 'grid'
  }
});
const INTERVALS = {
  millisecond: {
    common: true,
    size: 1,
    steps: 1000
  },
  second: {
    common: true,
    size: 1000,
    steps: 60
  },
  minute: {
    common: true,
    size: 60000,
    steps: 60
  },
  hour: {
    common: true,
    size: 3600000,
    steps: 24
  },
  day: {
    common: true,
    size: 86400000,
    steps: 30
  },
  week: {
    common: false,
    size: 604800000,
    steps: 4
  },
  month: {
    common: true,
    size: 2.628e9,
    steps: 12
  },
  quarter: {
    common: false,
    size: 7.884e9,
    steps: 4
  },
  year: {
    common: true,
    size: 3.154e10
  }
};
const UNITS = /* #__PURE__ */Object.keys(INTERVALS);
function sorter(a, b) {
  return a - b;
}
function parse(scale, input) {
  if (isNullOrUndef(input)) {
    return null;
  }
  const adapter = scale._adapter;
  const {
    parser,
    round,
    isoWeekday
  } = scale._parseOpts;
  let value = input;
  if (typeof parser === 'function') {
    value = parser(value);
  }
  if (!isNumberFinite(value)) {
    value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
  }
  if (value === null) {
    return null;
  }
  if (round) {
    value = round === 'week' && (isNumber(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
  }
  return +value;
}
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
  const ilen = UNITS.length;
  for (let i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
    const interval = INTERVALS[UNITS[i]];
    const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
    if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
      return UNITS[i];
    }
  }
  return UNITS[ilen - 1];
}
function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
  for (let i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
    const unit = UNITS[i];
    if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
      return unit;
    }
  }
  return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}
function determineMajorUnit(unit) {
  for (let i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
    if (INTERVALS[UNITS[i]].common) {
      return UNITS[i];
    }
  }
}
function addTick(ticks, time, timestamps) {
  if (!timestamps) {
    ticks[time] = true;
  } else if (timestamps.length) {
    const {
      lo,
      hi
    } = _lookup(timestamps, time);
    const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
    ticks[timestamp] = true;
  }
}
function setMajorTicks(scale, ticks, map, majorUnit) {
  const adapter = scale._adapter;
  const first = +adapter.startOf(ticks[0].value, majorUnit);
  const last = ticks[ticks.length - 1].value;
  let major, index;
  for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
    index = map[major];
    if (index >= 0) {
      ticks[index].major = true;
    }
  }
  return ticks;
}
function ticksFromTimestamps(scale, values, majorUnit) {
  const ticks = [];
  const map = {};
  const ilen = values.length;
  let i, value;
  for (i = 0; i < ilen; ++i) {
    value = values[i];
    map[value] = i;
    ticks.push({
      value,
      major: false
    });
  }
  return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}
class TimeScale extends Scale {
  constructor(props) {
    super(props);
    this._cache = {
      data: [],
      labels: [],
      all: []
    };
    this._unit = 'day';
    this._majorUnit = undefined;
    this._offsets = {};
    this._normalized = false;
    this._parseOpts = undefined;
  }
  init(scaleOpts, opts = {}) {
    const time = scaleOpts.time || (scaleOpts.time = {});
    const adapter = this._adapter = new adapters._date(scaleOpts.adapters.date);
    adapter.init(opts);
    mergeIf(time.displayFormats, adapter.formats());
    this._parseOpts = {
      parser: time.parser,
      round: time.round,
      isoWeekday: time.isoWeekday
    };
    super.init(scaleOpts);
    this._normalized = opts.normalized;
  }
  parse(raw, index) {
    if (raw === undefined) {
      return null;
    }
    return parse(this, raw);
  }
  beforeLayout() {
    super.beforeLayout();
    this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const options = this.options;
    const adapter = this._adapter;
    const unit = options.time.unit || 'day';
    let {
      min,
      max,
      minDefined,
      maxDefined
    } = this.getUserBounds();
    function _applyBounds(bounds) {
      if (!minDefined && !isNaN(bounds.min)) {
        min = Math.min(min, bounds.min);
      }
      if (!maxDefined && !isNaN(bounds.max)) {
        max = Math.max(max, bounds.max);
      }
    }
    if (!minDefined || !maxDefined) {
      _applyBounds(this._getLabelBounds());
      if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') {
        _applyBounds(this.getMinMax(false));
      }
    }
    min = isNumberFinite(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
    max = isNumberFinite(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
    this.min = Math.min(min, max - 1);
    this.max = Math.max(min + 1, max);
  }
  _getLabelBounds() {
    const arr = this.getLabelTimestamps();
    let min = Number.POSITIVE_INFINITY;
    let max = Number.NEGATIVE_INFINITY;
    if (arr.length) {
      min = arr[0];
      max = arr[arr.length - 1];
    }
    return {
      min,
      max
    };
  }
  buildTicks() {
    const options = this.options;
    const timeOpts = options.time;
    const tickOpts = options.ticks;
    const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
    if (options.bounds === 'ticks' && timestamps.length) {
      this.min = this._userMin || timestamps[0];
      this.max = this._userMax || timestamps[timestamps.length - 1];
    }
    const min = this.min;
    const max = this.max;
    const ticks = _filterBetween(timestamps, min, max);
    this._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
    this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : determineMajorUnit(this._unit);
    this.initOffsets(timestamps);
    if (options.reverse) {
      ticks.reverse();
    }
    return ticksFromTimestamps(this, ticks, this._majorUnit);
  }
  afterAutoSkip() {
    if (this.options.offsetAfterAutoskip) {
      this.initOffsets(this.ticks.map(tick => +tick.value));
    }
  }
  initOffsets(timestamps = []) {
    let start = 0;
    let end = 0;
    let first, last;
    if (this.options.offset && timestamps.length) {
      first = this.getDecimalForValue(timestamps[0]);
      if (timestamps.length === 1) {
        start = 1 - first;
      } else {
        start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
      }
      last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
      if (timestamps.length === 1) {
        end = last;
      } else {
        end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
      }
    }
    const limit = timestamps.length < 3 ? 0.5 : 0.25;
    start = _limitValue(start, 0, limit);
    end = _limitValue(end, 0, limit);
    this._offsets = {
      start,
      end,
      factor: 1 / (start + 1 + end)
    };
  }
  _generate() {
    const adapter = this._adapter;
    const min = this.min;
    const max = this.max;
    const options = this.options;
    const timeOpts = options.time;
    const minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
    const stepSize = valueOrDefault(options.ticks.stepSize, 1);
    const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
    const hasWeekday = isNumber(weekday) || weekday === true;
    const ticks = {};
    let first = min;
    let time, count;
    if (hasWeekday) {
      first = +adapter.startOf(first, 'isoWeek', weekday);
    }
    first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
    if (adapter.diff(max, min, minor) > 100000 * stepSize) {
      throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
    }
    const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
    for (time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++) {
      addTick(ticks, time, timestamps);
    }
    if (time === max || options.bounds === 'ticks' || count === 1) {
      addTick(ticks, time, timestamps);
    }
    return Object.keys(ticks).sort(sorter).map(x => +x);
  }
  getLabelForValue(value) {
    const adapter = this._adapter;
    const timeOpts = this.options.time;
    if (timeOpts.tooltipFormat) {
      return adapter.format(value, timeOpts.tooltipFormat);
    }
    return adapter.format(value, timeOpts.displayFormats.datetime);
  }
  format(value, format) {
    const options = this.options;
    const formats = options.time.displayFormats;
    const unit = this._unit;
    const fmt = format || formats[unit];
    return this._adapter.format(value, fmt);
  }
  _tickFormatFunction(time, index, ticks, format) {
    const options = this.options;
    const formatter = options.ticks.callback;
    if (formatter) {
      return callback(formatter, [time, index, ticks], this);
    }
    const formats = options.time.displayFormats;
    const unit = this._unit;
    const majorUnit = this._majorUnit;
    const minorFormat = unit && formats[unit];
    const majorFormat = majorUnit && formats[majorUnit];
    const tick = ticks[index];
    const major = majorUnit && majorFormat && tick && tick.major;
    return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
  }
  generateTickLabels(ticks) {
    let i, ilen, tick;
    for (i = 0, ilen = ticks.length; i < ilen; ++i) {
      tick = ticks[i];
      tick.label = this._tickFormatFunction(tick.value, i, ticks);
    }
  }
  getDecimalForValue(value) {
    return value === null ? NaN : (value - this.min) / (this.max - this.min);
  }
  getPixelForValue(value) {
    const offsets = this._offsets;
    const pos = this.getDecimalForValue(value);
    return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
  }
  getValueForPixel(pixel) {
    const offsets = this._offsets;
    const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
    return this.min + pos * (this.max - this.min);
  }
  _getLabelSize(label) {
    const ticksOpts = this.options.ticks;
    const tickLabelWidth = this.ctx.measureText(label).width;
    const angle = toRadians(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
    const cosRotation = Math.cos(angle);
    const sinRotation = Math.sin(angle);
    const tickFontSize = this._resolveTickFontOptions(0).size;
    return {
      w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
      h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
    };
  }
  _getLabelCapacity(exampleTime) {
    const timeOpts = this.options.time;
    const displayFormats = timeOpts.displayFormats;
    const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
    const exampleLabel = this._tickFormatFunction(exampleTime, 0, ticksFromTimestamps(this, [exampleTime], this._majorUnit), format);
    const size = this._getLabelSize(exampleLabel);
    const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
    return capacity > 0 ? capacity : 1;
  }
  getDataTimestamps() {
    let timestamps = this._cache.data || [];
    let i, ilen;
    if (timestamps.length) {
      return timestamps;
    }
    const metas = this.getMatchingVisibleMetas();
    if (this._normalized && metas.length) {
      return this._cache.data = metas[0].controller.getAllParsedValues(this);
    }
    for (i = 0, ilen = metas.length; i < ilen; ++i) {
      timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
    }
    return this._cache.data = this.normalize(timestamps);
  }
  getLabelTimestamps() {
    const timestamps = this._cache.labels || [];
    let i, ilen;
    if (timestamps.length) {
      return timestamps;
    }
    const labels = this.getLabels();
    for (i = 0, ilen = labels.length; i < ilen; ++i) {
      timestamps.push(parse(this, labels[i]));
    }
    return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
  }
  normalize(values) {
    return _arrayUnique(values.sort(sorter));
  }
}
_defineProperty(TimeScale, "id", 'time');
_defineProperty(TimeScale, "defaults", {
  bounds: 'data',
  adapters: {},
  time: {
    parser: false,
    unit: false,
    round: false,
    isoWeekday: false,
    minUnit: 'millisecond',
    displayFormats: {}
  },
  ticks: {
    source: 'auto',
    callback: false,
    major: {
      enabled: false
    }
  }
});
function interpolate$1(table, val, reverse) {
  let lo = 0;
  let hi = table.length - 1;
  let prevSource, nextSource, prevTarget, nextTarget;
  if (reverse) {
    if (val >= table[lo].pos && val <= table[hi].pos) {
      ({
        lo,
        hi
      } = _lookupByKey(table, 'pos', val));
    }
    ({
      pos: prevSource,
      time: prevTarget
    } = table[lo]);
    ({
      pos: nextSource,
      time: nextTarget
    } = table[hi]);
  } else {
    if (val >= table[lo].time && val <= table[hi].time) {
      ({
        lo,
        hi
      } = _lookupByKey(table, 'time', val));
    }
    ({
      time: prevSource,
      pos: prevTarget
    } = table[lo]);
    ({
      time: nextSource,
      pos: nextTarget
    } = table[hi]);
  }
  const span = nextSource - prevSource;
  return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class TimeSeriesScale extends TimeScale {
  constructor(props) {
    super(props);
    this._table = [];
    this._minPos = undefined;
    this._tableRange = undefined;
  }
  initOffsets() {
    const timestamps = this._getTimestampsForTable();
    const table = this._table = this.buildLookupTable(timestamps);
    this._minPos = interpolate$1(table, this.min);
    this._tableRange = interpolate$1(table, this.max) - this._minPos;
    super.initOffsets(timestamps);
  }
  buildLookupTable(timestamps) {
    const {
      min,
      max
    } = this;
    const items = [];
    const table = [];
    let i, ilen, prev, curr, next;
    for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
      curr = timestamps[i];
      if (curr >= min && curr <= max) {
        items.push(curr);
      }
    }
    if (items.length < 2) {
      return [{
        time: min,
        pos: 0
      }, {
        time: max,
        pos: 1
      }];
    }
    for (i = 0, ilen = items.length; i < ilen; ++i) {
      next = items[i + 1];
      prev = items[i - 1];
      curr = items[i];
      if (Math.round((next + prev) / 2) !== curr) {
        table.push({
          time: curr,
          pos: i / (ilen - 1)
        });
      }
    }
    return table;
  }
  _generate() {
    const min = this.min;
    const max = this.max;
    let timestamps = super.getDataTimestamps();
    if (!timestamps.includes(min) || !timestamps.length) {
      timestamps.splice(0, 0, min);
    }
    if (!timestamps.includes(max) || timestamps.length === 1) {
      timestamps.push(max);
    }
    return timestamps.sort((a, b) => a - b);
  }
  _getTimestampsForTable() {
    let timestamps = this._cache.all || [];
    if (timestamps.length) {
      return timestamps;
    }
    const data = this.getDataTimestamps();
    const label = this.getLabelTimestamps();
    if (data.length && label.length) {
      timestamps = this.normalize(data.concat(label));
    } else {
      timestamps = data.length ? data : label;
    }
    timestamps = this._cache.all = timestamps;
    return timestamps;
  }
  getDecimalForValue(value) {
    return (interpolate$1(this._table, value) - this._minPos) / this._tableRange;
  }
  getValueForPixel(pixel) {
    const offsets = this._offsets;
    const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
    return interpolate$1(this._table, decimal * this._tableRange + this._minPos, true);
  }
}
_defineProperty(TimeSeriesScale, "id", 'timeseries');
_defineProperty(TimeSeriesScale, "defaults", TimeScale.defaults);

const defaultDatasetIdKey = 'label';
function reforwardRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}
function setOptions(chart, nextOptions) {
  const options = chart.options;
  if (options && nextOptions) {
    Object.assign(options, nextOptions);
  }
}
function setLabels(currentData, nextLabels) {
  currentData.labels = nextLabels;
}
function setDatasets(currentData, nextDatasets) {
  let datasetIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultDatasetIdKey;
  const addedDatasets = [];
  currentData.datasets = nextDatasets.map(nextDataset => {
    // given the new set, find it's current match
    const currentDataset = currentData.datasets.find(dataset => dataset[datasetIdKey] === nextDataset[datasetIdKey]);
    // There is no original to update, so simply add new one
    if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) {
      return {
        ...nextDataset
      };
    }
    addedDatasets.push(currentDataset);
    Object.assign(currentDataset, nextDataset);
    return currentDataset;
  });
}
function cloneData(data) {
  let datasetIdKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultDatasetIdKey;
  const nextData = {
    labels: [],
    datasets: []
  };
  setLabels(nextData, data.labels);
  setDatasets(nextData, data.datasets, datasetIdKey);
  return nextData;
}
function ChartComponent(props, ref) {
  const {
    height = 150,
    width = 300,
    redraw = false,
    datasetIdKey,
    type,
    data,
    options,
    plugins = [],
    fallbackContent,
    updateMode,
    ...canvasProps
  } = props;
  const canvasRef = useRef(null);
  const chartRef = useRef(null);
  const renderChart = () => {
    if (!canvasRef.current) return;
    chartRef.current = new Chart(canvasRef.current, {
      type,
      data: cloneData(data, datasetIdKey),
      options: options && {
        ...options
      },
      plugins
    });
    reforwardRef(ref, chartRef.current);
  };
  const destroyChart = () => {
    reforwardRef(ref, null);
    if (chartRef.current) {
      chartRef.current.destroy();
      chartRef.current = null;
    }
  };
  useEffect(() => {
    if (!redraw && chartRef.current && options) {
      setOptions(chartRef.current, options);
    }
  }, [redraw, options]);
  useEffect(() => {
    if (!redraw && chartRef.current) {
      setLabels(chartRef.current.config.data, data.labels);
    }
  }, [redraw, data.labels]);
  useEffect(() => {
    if (!redraw && chartRef.current && data.datasets) {
      setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
    }
  }, [redraw, data.datasets]);
  useEffect(() => {
    if (!chartRef.current) return;
    if (redraw) {
      destroyChart();
      setTimeout(renderChart);
    } else {
      chartRef.current.update(updateMode);
    }
  }, [redraw, options, data.labels, data.datasets, updateMode]);
  useEffect(() => {
    if (!chartRef.current) return;
    destroyChart();
    setTimeout(renderChart);
  }, [type]);
  useEffect(() => {
    renderChart();
    return () => destroyChart();
  }, []);
  return /*#__PURE__*/React__default.createElement("canvas", {
    ref: canvasRef,
    role: "img",
    height: height,
    width: width,
    ...canvasProps
  }, fallbackContent);
}
const Chart$1 = /*#__PURE__*/forwardRef(ChartComponent);
function createTypedChart(type, registerables) {
  Chart.register(registerables);
  return /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React__default.createElement(Chart$1, {
    ...props,
    ref: ref,
    type: type
  }));
}
const Line = /* #__PURE__ */createTypedChart('line', LineController);
const Bar = /* #__PURE__ */createTypedChart('bar', BarController);

const GraphContent = styled.div `
  position: relative;
  flex: 1;

  .graph {
    cursor: pointer;
  }
`;
const GraphContainer = styled.div `
  display: flex;
  flex-direction: column;
`;
const GraphTooltipContainer = styled.div `
  ${({ theme: { color, borderRadius, spacing } }) => css `
    position: absolute;
    transition: top 200ms, left 200ms, height 200ms, width 200ms,
      transform 200ms, opacity 200ms;
    pointer-events: none;

    background: ${color.midnight5};
    color: ${color.contrast.midnight5};
    border-radius: ${borderRadius.p1};
    padding: ${spacing.xs} ${spacing.sm};

    min-width: 100px;
    width: max-content;
    min-height: 50px;
  `}
`;
const GraphTooltipTitle = styled.div `
  ${({ theme: { font } }) => css `
    ${font.note}
  `}
`;
const GraphTooltipData = styled.dl `
  ${({ theme: { font, spacing } }) => css `
    ${font.smallnote}

    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    gap: ${spacing.p1};
  `}
`;
const GraphTooltipLabel = styled.dt `
  flex: 1;
  text-align: start;
`;
const GraphTooltipValue = styled.dd `
  text-align: end;
`;
const GraphLegendContainer = styled.div `
  ${({ theme: { spacing } }) => css `
    padding: ${spacing.xs} ${spacing.sm};

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    gap: ${spacing.md} ${spacing.lg};
  `}
`;
const GraphLegendData = styled.div `
  ${({ theme: { spacing } }) => css `
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    gap: ${spacing.p1};
  `}
`;
const GraphColor = styled.div `
  ${({ theme: { fontSize, color }, $big }) => css `
    display: block;
    height: ${$big ? fontSize.md : fontSize.xs};
    width: ${$big ? fontSize.md : fontSize.xs};
    border: 1px solid ${color.contrast.midnight5};
  `}
`;
const GraphLegendLabel = styled.span `
  ${({ theme: { color } }) => css `
    color: ${color.midnight10};
  `}
`;

const DefaultGraphTooltip = (_a) => {
    var { show, stickTop, left, top, title = [], body = [], options, labelColors, showXLabel } = _a, props = __rest(_a, ["show", "stickTop", "left", "top", "title", "body", "options", "labelColors", "showXLabel"]);
    const { spacing } = useTheme();
    const [showing, setShowing] = useState(false);
    const containerRef = useRef();
    const [translate, setTranslate] = useState({
        x: "-50%",
        y: "calc(10%)",
    });
    const mounted = useMounted();
    useEffect(() => {
        if (show) {
            setShowing(true);
            return;
        }
        const timer = setTimeout(() => {
            if (!mounted.current) {
                return;
            }
            setShowing(false);
        }, 500);
        return () => clearTimeout(timer);
    }, [show, mounted]);
    useEffect(() => {
        const adjustTranslate = () => {
            if (!mounted.current) {
                return;
            }
            requestAnimationFrame(() => {
                const container = containerRef.current;
                if (!container) {
                    setTranslate({
                        x: "-50%",
                        y: "calc(10%)",
                    });
                    return;
                }
                let x = "-50%";
                let y = `calc(-100% - ${spacing.p2})`;
                const { offsetWidth, offsetHeight, offsetParent } = container;
                const parent = offsetParent;
                if (left + offsetWidth / 2 > parent.offsetWidth) {
                    x = `calc(-100% + ${spacing.p2})`;
                }
                if (left - offsetWidth / 2 < 0) {
                    x = `calc(0% - ${spacing.p2})`;
                }
                if (top - offsetHeight < 0) {
                    y = `calc(0% + ${spacing.p2})`;
                }
                if (stickTop) {
                    y = `calc(10% + ${spacing.p2})`;
                }
                setTranslate({ x, y });
            });
        };
        adjustTranslate();
        window.addEventListener("resize", adjustTranslate);
        if (!containerRef.current || !window.ResizeObserver) {
            return () => {
                window.removeEventListener("resize", adjustTranslate);
            };
        }
        const observer = new ResizeObserver(() => {
            adjustTranslate();
        });
        observer.observe(containerRef.current.offsetParent);
        return () => {
            window.removeEventListener("resize", adjustTranslate);
            observer.disconnect();
        };
    }, [spacing, stickTop, top, left, body.length, mounted]);
    return (React__default.createElement(GraphTooltipContainer, Object.assign({ ref: containerRef, "aria-hidden": true }, props, { style: {
            top: stickTop ? 0 : top,
            left,
            opacity: showing ? 1 : 0,
            transform: `translate(${translate.x}, ${translate.y})`,
        } }),
        React__default.createElement(GraphTooltipTitle, null, title.join(", ")),
        React__default.createElement(GraphTooltipData, null, body.map(([label, value], i) => (React__default.createElement(React__default.Fragment, { key: [label, value, i].join(",") }, showXLabel ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(GraphColor, { style: {
                    background: labelColors[i].backgroundColor,
                } }),
            React__default.createElement(GraphTooltipLabel, null, label),
            React__default.createElement(GraphTooltipValue, null, value))) : (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(GraphTooltipValue, null, value),
            React__default.createElement("span", null),
            React__default.createElement("span", null)))))))));
};

const DefaultGraphLegend = ({ items }) => {
    if (items.length <= 1) {
        return null;
    }
    return (React__default.createElement(GraphLegendContainer, null, items.map(({ label, color }) => (React__default.createElement(GraphLegendData, { key: label },
        React__default.createElement(GraphColor, { "$big": true, style: { background: color } }),
        React__default.createElement(GraphLegendLabel, null, label))))));
};

// source: https://stackoverflow.com/questions/70112637/draw-a-horizontal-and-vertical-line-on-mouse-hover-in-chart-js
const corsairPlugin = {
    id: "corsair",
    defaults: {
        enabled: false,
        width: 1,
        color: "#232c41",
        dash: [3, 3],
    },
    afterInit: (chart, args, opts) => {
        chart["corsair"] = {
            x: 0,
            y: 0,
        };
    },
    afterEvent: (chart, args) => {
        const { inChartArea } = args;
        const { type, x, y } = args.event;
        chart["corsair"] = { x, y, draw: inChartArea };
        chart.draw();
    },
    beforeDatasetsDraw: (chart, args, opts) => {
        const { ctx } = chart;
        const { top, bottom, left, right } = chart.chartArea;
        if (!chart["corsair"]) {
            return;
        }
        const { x, y, draw } = chart["corsair"];
        if (!draw || !opts.enabled)
            return;
        ctx.save();
        ctx.beginPath();
        ctx.lineWidth = opts.width;
        ctx.strokeStyle = opts.color;
        ctx.setLineDash(opts.dash);
        ctx.moveTo(x, bottom);
        ctx.lineTo(x, top);
        // ctx.moveTo(left, y)
        // ctx.lineTo(right, y)
        ctx.stroke();
        ctx.restore();
    },
};

const useGraphColorset = () => {
    const { color } = useTheme();
    const colorset = useMemo(() => [
        [color.pink, color.pink10],
        [color.turquoise, color.turquoise10],
        [color.blue, color.blue10],
        [color.midnight, color.midnight10],
        [color.red, color.red10],
        [color.amber, color.amber10],
    ], [color]);
    const getColor = useCallback((color, hover, i) => {
        if (color || hover) {
            return [color || curriedDarken$1(0.1, hover), hover || curriedLighten$1(0.1, color)];
        }
        return colorset[i % colorset.length];
    }, [colorset]);
    return [getColor, colorset];
};

const useMouseLeave = (container, callback) => {
    const callbackRef = useRef(callback);
    callbackRef.current = callback;
    const containerRef = useRef(container);
    containerRef.current = container;
    useEffect(() => {
        const mouseOver = (e) => {
            var _a;
            if (!containerRef.current || !e.target) {
                return;
            }
            if (document.body.contains(e.target) &&
                !containerRef.current.querySelector(".graph").contains(e.target)) {
                (_a = callbackRef.current) === null || _a === void 0 ? void 0 : _a.call(callbackRef);
            }
        };
        window.addEventListener("mouseover", mouseOver);
        return () => {
            window.removeEventListener("mouseover", mouseOver);
        };
    }, [containerRef]);
};

const formatDefault = (label) => label == null ? "" : "" + label;

const useGraphTooltip = (container, { isXTime = false, formatXLabel = formatDefault, formatYLabel = formatDefault, }) => {
    const [tooltipProps, setTooltipProps] = useState({
        show: false,
    });
    const keyRef = useRef(null);
    const updateTooltip = useMemo(() => debounce$1((context) => {
        const { chart, tooltip } = context;
        const { opacity, dataPoints, body, title, labelColors, caretX, caretY, options, } = tooltip;
        if (opacity === 0) {
            return;
        }
        const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;
        const left = positionX + caretX;
        const top = positionY + caretY;
        const key = [left, top].join(",");
        if (keyRef.current === key) {
            setTooltipProps((old) => (Object.assign(Object.assign({}, old), { show: true })));
            return;
        }
        keyRef.current = key;
        setTooltipProps((old) => (Object.assign(Object.assign({}, old), { show: true, left,
            top, title: uniq(dataPoints
                .map(({ raw, parsed }, i) => {
                const label = title[i];
                const value = isXTime ? parsed.x : raw.x;
                return formatXLabel(value != null ? value : label, true);
            })
                .filter(Boolean)), body: body.map((b) => {
                const [label, value] = b.lines.join("").split(": ");
                return [label, formatYLabel(value, true)];
            }), options,
            labelColors })));
    }, 100), [formatXLabel, formatYLabel, isXTime]);
    useMouseLeave(container, () => setTooltipProps((old) => (Object.assign(Object.assign({}, old), { show: false }))));
    return [tooltipProps, updateTooltip];
};

/*!
 * chartjs-adapter-date-fns v3.0.0
 * https://www.chartjs.org
 * (c) 2022 chartjs-adapter-date-fns Contributors
 * Released under the MIT license
 */
const FORMATS = {
  datetime: 'MMM d, yyyy, h:mm:ss aaaa',
  millisecond: 'h:mm:ss.SSS aaaa',
  second: 'h:mm:ss aaaa',
  minute: 'h:mm aaaa',
  hour: 'ha',
  day: 'MMM d',
  week: 'PP',
  month: 'MMM yyyy',
  quarter: 'qqq - yyyy',
  year: 'yyyy'
};
adapters._date.override({
  _id: 'date-fns',
  // DEBUG

  formats: function () {
    return FORMATS;
  },
  parse: function (value, fmt) {
    if (value === null || typeof value === 'undefined') {
      return null;
    }
    const type = typeof value;
    if (type === 'number' || value instanceof Date) {
      value = toDate(value);
    } else if (type === 'string') {
      if (typeof fmt === 'string') {
        value = parse$1(value, fmt, new Date(), this.options);
      } else {
        value = parseISO(value, this.options);
      }
    }
    return isValid(value) ? value.getTime() : null;
  },
  format: function (time, fmt) {
    return format$1(time, fmt, this.options);
  },
  add: function (time, amount, unit) {
    switch (unit) {
      case 'millisecond':
        return addMilliseconds(time, amount);
      case 'second':
        return addSeconds(time, amount);
      case 'minute':
        return addMinutes(time, amount);
      case 'hour':
        return addHours(time, amount);
      case 'day':
        return addDays(time, amount);
      case 'week':
        return addWeeks(time, amount);
      case 'month':
        return addMonths(time, amount);
      case 'quarter':
        return addQuarters(time, amount);
      case 'year':
        return addYears(time, amount);
      default:
        return time;
    }
  },
  diff: function (max, min, unit) {
    switch (unit) {
      case 'millisecond':
        return differenceInMilliseconds(max, min);
      case 'second':
        return differenceInSeconds(max, min);
      case 'minute':
        return differenceInMinutes(max, min);
      case 'hour':
        return differenceInHours(max, min);
      case 'day':
        return differenceInDays(max, min);
      case 'week':
        return differenceInWeeks(max, min);
      case 'month':
        return differenceInMonths(max, min);
      case 'quarter':
        return differenceInQuarters(max, min);
      case 'year':
        return differenceInYears(max, min);
      default:
        return 0;
    }
  },
  startOf: function (time, unit, weekday) {
    switch (unit) {
      case 'second':
        return startOfSecond(time);
      case 'minute':
        return startOfMinute(time);
      case 'hour':
        return startOfHour(time);
      case 'day':
        return startOfDay(time);
      case 'week':
        return startOfWeek(time);
      case 'isoWeek':
        return startOfWeek(time, {
          weekStartsOn: +weekday
        });
      case 'month':
        return startOfMonth(time);
      case 'quarter':
        return startOfQuarter(time);
      case 'year':
        return startOfYear(time);
      default:
        return time;
    }
  },
  endOf: function (time, unit) {
    switch (unit) {
      case 'second':
        return endOfSecond(time);
      case 'minute':
        return endOfMinute(time);
      case 'hour':
        return endOfHour(time);
      case 'day':
        return endOfDay(time);
      case 'week':
        return endOfWeek(time);
      case 'month':
        return endOfMonth(time);
      case 'quarter':
        return endOfQuarter(time);
      case 'year':
        return endOfYear(time);
      default:
        return time;
    }
  }
});

const zeroTime = (datetime) => {
    return setHours(setMinutes(setSeconds(setMilliseconds(datetime, 0), 0), 0), 0);
};

Chart.register(LineController, LineElement, PointElement, plugin_legend, plugin_tooltip, CategoryScale, LinearScale, TimeScale, corsairPlugin);
const LineGraph = (_a) => {
    var { title, datasets, formatYLabel = formatDefault, formatXLabel = formatDefault, xField = "x", yField = "y", tooltipComponent: TooltipComponent = DefaultGraphTooltip, legendComponent: LegendComponent = DefaultGraphLegend, corsair = true, isXTime = false, minDate = null, maxDate = null } = _a, props = __rest(_a, ["title", "datasets", "formatYLabel", "formatXLabel", "xField", "yField", "tooltipComponent", "legendComponent", "corsair", "isXTime", "minDate", "maxDate"]);
    const [getColor] = useGraphColorset();
    const containerRef = useRef();
    const [tooltipProps, setTooltipProps] = useGraphTooltip(containerRef.current, {
        isXTime,
        formatYLabel,
        formatXLabel,
    });
    const data = useMemo(() => {
        const labels = uniq(flatMap(flatMap(datasets.map((set) => set.data.map((data) => data[xField]))))).sort((a, b) => {
            if (typeof a === "string" || typeof b === "string") {
                return ("" + a).localeCompare("" + b);
            }
            return a - b;
        });
        if (isXTime) {
            const minTime = minDate
                ? zeroTime(parseDatetime(minDate))
                : zeroTime(parseDatetime(labels[0]));
            const maxTime = maxDate
                ? zeroTime(parseDatetime(maxDate))
                : zeroTime(parseDatetime(labels[labels.length - 1]));
            // generate a list of each day in the timespan
            let timeLabels = [];
            let time = minTime;
            while (time <= maxTime) {
                timeLabels.push(time.getTime());
                time = new Date(time.getTime() + 24 * 60 * 60 * 1000);
            }
            // limit to last 100 time slots maybe?
            // timeLabels = timeLabels.slice(-100);
            const formattedSets = datasets.map((set, i) => {
                const [color, hover] = getColor(set.color, set.hoverColor, i);
                const newSet = {
                    label: set.label,
                    borderColor: color,
                    backgroundColor: color,
                    hoverBorderColor: hover,
                    hoverBackgroundColor: hover,
                    data: timeLabels.map((time) => ({
                        x: time,
                        y: 0,
                    })),
                };
                set.data.forEach((set) => {
                    const date = zeroTime(parseDatetime(set[xField]));
                    const index = Math.round(((date === null || date === void 0 ? void 0 : date.getTime()) - (minTime === null || minTime === void 0 ? void 0 : minTime.getTime())) / (24 * 60 * 60 * 1000));
                    if (newSet.data[index]) {
                        newSet.data[index].y = set[yField];
                    }
                });
                return newSet;
            });
            return { labels: timeLabels, datasets: formattedSets };
        }
        const formattedSets = datasets.map((set, i) => {
            const [color, hover] = getColor(set.color, set.hoverColor, i);
            return {
                label: set.label,
                borderColor: color,
                backgroundColor: color,
                hoverBorderColor: hover,
                hoverBackgroundColor: hover,
                data: set.data.map((data) => ({
                    x: data[xField],
                    y: data[yField],
                })),
            };
        });
        return {
            labels,
            datasets: formattedSets,
        };
    }, [datasets, getColor, isXTime, maxDate, minDate, xField, yField]);
    const legendProps = useMemo(() => {
        const items = datasets.map((set, i) => {
            const [color] = getColor(set.color, set.hoverColor, i);
            return {
                label: set.label,
                color,
                i,
            };
        });
        return {
            items,
        };
    }, [datasets, getColor]);
    return (React__default.createElement(GraphContainer, Object.assign({}, props, { ref: containerRef }),
        React__default.createElement(GraphContent, null,
            React__default.createElement(Line, { "data-testid": "LineGraph", className: "graph", "aria-label": title, role: "img", data: data, options: {
                    responsive: true,
                    spanGaps: true,
                    maintainAspectRatio: false,
                    interaction: {
                        intersect: false,
                        mode: "x",
                        axis: "xy",
                    },
                    layout: {
                        padding: 5,
                    },
                    plugins: {
                        tooltip: {
                            enabled: false,
                            mode: "x",
                            position: "average",
                            external: setTooltipProps,
                            includeInvisible: true,
                        },
                        legend: {
                            display: false,
                        },
                        corsair: {
                            enabled: corsair,
                        },
                    },
                    scales: {
                        x: {
                            type: isXTime ? "time" : "linear",
                            ticks: {
                                autoSkipPadding: 40,
                                callback(tick) {
                                    const value = this.getLabelForValue(tick);
                                    return formatXLabel(isXTime ? tick : value, false);
                                },
                            },
                            time: isXTime
                                ? {
                                    unit: "day",
                                    minUnit: "day",
                                }
                                : undefined,
                            grid: {
                                drawOnChartArea: false,
                                color: "#B3B3BD",
                            },
                        },
                        y: {
                            beginAtZero: true,
                            border: { display: false },
                            ticks: {
                                autoSkipPadding: 40,
                                callback(tick) {
                                    const value = this.getLabelForValue(tick);
                                    return formatYLabel(value, false);
                                },
                                major: {
                                    enabled: true,
                                },
                            },
                            grid: {
                                color: "#E1E1E5",
                            },
                        },
                    },
                } }),
            React__default.createElement(TooltipComponent, Object.assign({ className: "tooltip" }, tooltipProps, { showXLabel: datasets.length > 1 }))),
        React__default.createElement(LegendComponent, Object.assign({ className: "legend" }, legendProps))));
};

Chart.register(CategoryScale, LinearScale, BarElement, plugin_legend, plugin_tooltip);
const BarGraph = (_a) => {
    var { title, datasets, formatYLabel = formatDefault, formatXLabel = formatDefault, xField = "x", yField = "y", tooltipComponent: TooltipComponent = DefaultGraphTooltip, legendComponent: LegendComponent = DefaultGraphLegend } = _a, props = __rest(_a, ["title", "datasets", "formatYLabel", "formatXLabel", "xField", "yField", "tooltipComponent", "legendComponent"]);
    const [getColor] = useGraphColorset();
    const containerRef = useRef();
    const [tooltipProps, setTooltipProps] = useGraphTooltip(containerRef.current, {
        formatXLabel,
        formatYLabel,
    });
    const data = useMemo(() => {
        const labels = uniq(flatMap(flatMap(datasets.map((set) => set.data.map((data) => data[xField])))));
        const formattedSets = datasets.map((set, i) => {
            const [color, hover] = getColor(set.color, set.hoverColor, i);
            return {
                label: set.label,
                borderColor: color,
                backgroundColor: color,
                hoverBorderColor: hover,
                hoverBackgroundColor: hover,
                data: labels.map((label) => {
                    const point = set.data.find((data) => data[xField] === label);
                    return point ? point[yField] : null;
                }),
            };
        });
        return {
            labels,
            datasets: formattedSets,
        };
    }, [datasets, xField, getColor, yField]);
    const legendProps = useMemo(() => {
        const items = datasets.map((set, i) => {
            const [color] = getColor(set.color, set.hoverColor, i);
            return {
                label: set.label,
                color,
            };
        });
        return {
            items,
        };
    }, [datasets, getColor]);
    return (React__default.createElement(GraphContainer, Object.assign({}, props, { ref: containerRef }),
        React__default.createElement(GraphContent, null,
            React__default.createElement(Bar, { "data-testid": "BarGraph", className: "graph", "aria-label": title, role: "img", data: data, options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    interaction: {
                        intersect: false,
                        mode: "x",
                        axis: "xy",
                    },
                    layout: {
                        padding: 5,
                    },
                    plugins: {
                        tooltip: {
                            enabled: false,
                            mode: data.datasets.length > 1 ? "index" : "x",
                            position: "average",
                            external: setTooltipProps,
                        },
                        legend: {
                            display: false,
                        },
                    },
                    scales: {
                        x: {
                            ticks: {
                                autoSkip: false,
                                maxRotation: 90,
                                callback(tick) {
                                    const value = this.getLabelForValue(tick);
                                    return formatXLabel(value, false);
                                },
                            },
                            grid: {
                                drawOnChartArea: false,
                                color: "#B3B3BD",
                            },
                        },
                        y: {
                            beginAtZero: true,
                            border: { display: false },
                            ticks: {
                                autoSkipPadding: 40,
                                callback(tick) {
                                    const value = this.getLabelForValue(tick);
                                    return formatYLabel(value, false);
                                },
                                major: {
                                    enabled: true,
                                },
                            },
                            grid: {
                                color: "#E1E1E5",
                            },
                        },
                    },
                } }),
            React__default.createElement(TooltipComponent, Object.assign({ className: "tooltip" }, tooltipProps, { stickTop: datasets.length > 1, showXLabel: datasets.length > 1 }))),
        React__default.createElement(LegendComponent, Object.assign({ className: "legend" }, legendProps))));
};

const formatDateLabel = (field) => {
    try {
        return displayDate(field);
    }
    catch (e) { }
    try {
        return displayDate(Number(field));
    }
    catch (e) { }
    return field;
};

var fallback = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2aWV3Qm94PSIwIDAgMTIyLjM1IDg2LjExIiB3aWR0aD0iMTIyLjM1IiBoZWlnaHQ9Ijg2LjExIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPgogICAgPGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj4KICAgICAgPGc+CiAgICAgICAgPHBhdGggZD0iTSA2Ni44NzQgMjIuNjQgTCA2NC42ODQgMjIuNjQgQyA2NC4xIDIyLjYyMiA2My41NzIgMjIuOTg3IDYzLjM4NCAyMy41NCBMIDQ4Ljg1NCA1Ni40IEwgNDguNzU0IDU2LjQgTCAzNC4zMTQgMjMuNTQgQyAzNC4xMjUgMjIuOTg3IDMzLjU5OCAyMi42MjIgMzMuMDE0IDIyLjY0IEwgMzAuODI0IDIyLjY0IEMgMjkuOTI0IDIyLjY0IDI5LjgyNCAyMy4zNCAzMC4yMjQgMjQuMTQgTCA0Ny4zNTQgNjIuNTggQyA0Ny42NTQgNjMuMjcgNDcuOTU0IDYzLjQ3IDQ4LjU1NCA2My40NyBMIDQ4Ljk0NCA2My40NyBDIDQ5LjQ4NSA2My40MzkgNDkuOTU3IDYzLjA4OSA1MC4xNDQgNjIuNTggTCA2Ny40NzQgMjQuMTQgQyA2Ny44NzQgMjMuMzQgNjcuNzc0IDIyLjY0IDY2Ljg3NCAyMi42NCBaIiBmaWxsPSIjMTExYjMyIi8+CiAgICAgICAgPHBhdGggZD0iTSA4OS44IDAgQyA4OC40MTkgMCA4Ny4zIDEuMTE5IDg3LjMgMi41IEwgODcuMyA4My42MSBDIDg3LjMgODUuNTM1IDg5LjM4MyA4Ni43MzcgOTEuMDUgODUuNzc1IEMgOTEuODI0IDg1LjMyOCA5Mi4zIDg0LjUwMyA5Mi4zIDgzLjYxIEwgOTIuMyAyLjUgQyA5Mi4zIDEuMTE5IDkxLjE4MSAwIDg5LjggMCBaIiBmaWxsPSIjNDZiZWFmIiBzdHlsZT0iIi8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPg==';

var FALLBACK_SHAPE = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgwIiBoZWlnaHQ9IjExMiIgdmlld0JveD0iMCAwIDE4MCAxMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGlkPSJHcm91cCAzMTg1Ij4KPHJlY3QgaWQ9IlJlY3RhbmdsZSAzMTIwIiB4PSIxMTIiIHk9IjQ0IiB3aWR0aD0iNjgiIGhlaWdodD0iNjgiIGZpbGw9IiM1MjhGQkYiLz4KPHJlY3QgaWQ9IlJlY3RhbmdsZSAzMTIxIiB4PSI0NCIgeT0iNDQiIHdpZHRoPSI2OCIgaGVpZ2h0PSI2OCIgZmlsbD0iI0RENkI5QyIvPgo8cmVjdCBpZD0iUmVjdGFuZ2xlIDMxMjIiIHdpZHRoPSI0NCIgaGVpZ2h0PSI0NCIgZmlsbD0iI0RENkI5QyIvPgo8L2c+Cjwvc3ZnPg==';

const ImageBlock = styled.img `
  ${({ theme, inline, responsive, cover }) => css `
    margin: 0 auto;
    display: ${inline ? "inline-block" : "block"};
    opacity: 0.2;
    transition: opacity 300ms;

    ${responsive &&
    css `
      max-width: 100%;
    `}
    ${cover &&
    css `
      width: 100%;
      max-height: 100%;
      object-fit: cover;
    `}
    &.image-loaded, &.image-error {
      opacity: 1;
    }
    &:not(.image-loaded),
    &.image-error {
      background-color: ${theme.color.midnight};
      background-image: url(${FALLBACK_SHAPE});
      background-size: min(45%, 250px);
      background-position: bottom right;
      background-repeat: no-repeat;
    }
  `}
`;

const TRANSPARENT = "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==";
const Image = (_a) => {
    var { className, src, fallback } = _a, props = __rest(_a, ["className", "src", "fallback"]);
    const [error, setError] = useState(0);
    const [onScreen, setOnScreen] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const imgRef = useRef();
    useEffect(() => {
        if (src) {
            setError(0);
            return;
        }
        if (fallback) {
            setError(1);
            return;
        }
        setError(2);
    }, [src, fallback, setError]);
    // lazy load the image, so only loads when it is on screen
    useEffect(() => {
        if (!window.IntersectionObserver) {
            setOnScreen(true);
            return;
        }
        const imgDom = imgRef.current;
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setOnScreen(true);
                    observer.unobserve(imgDom);
                }
            });
        }, {
            rootMargin: "50px",
        });
        observer.observe(imgDom);
        return () => observer.unobserve(imgDom);
    }, [setOnScreen]);
    const url = useMemo(() => {
        if (!onScreen) {
            return TRANSPARENT;
        }
        if (error === 0) {
            return src;
        }
        if (error === 1) {
            return fallback;
        }
        // 1px transparent png
        return TRANSPARENT;
    }, [error, onScreen, fallback, src]);
    const handleError = useCallback(() => {
        if (error === 0) {
            setError(fallback ? 1 : 2);
            return;
        }
        setError(2);
    }, [error, fallback, setError]);
    const handleLoad = useCallback(() => {
        if (url !== TRANSPARENT) {
            setLoaded(true);
        }
    }, [setLoaded, url]);
    return (React__default.createElement(ImageBlock, Object.assign({ ref: imgRef }, props, { className: [
            className,
            loaded && "image-loaded",
            error === 1 && "image-fallback",
            error === 2 && "image-error",
        ]
            .filter(Boolean)
            .join(" "), "data-testid": "Image", src: url, onError: handleError, onLoad: handleLoad })));
};
Image.displayName = "Image";
Image.propTypes = {
    src: PropTypes.string,
    fallback: PropTypes.string,
    responsive: PropTypes.bool,
    inline: PropTypes.bool,
    cover: PropTypes.bool,
};
Image.defaultProps = {
    responsive: false,
    inline: false,
    cover: false,
    src: "",
    fallback: "",
};

const LoadingSection = styled.div `
  ${({ theme: { color, spacing, borderRadius } }) => css `
    background-color: ${mix$1(0.2, color.lightGrey, color.contrast.base)};
    overflow: hidden;

    display: flex;
    flex-direction: row;
    gap: ${spacing.md};
    flex: 1;
    border-radius: ${borderRadius.p1};
  `}
`;
const LoadingContainer = styled(LoadingSection) `
  ${({ theme: { spacing } }) => css `
      position: relative;
      margin: ${spacing.md} 0;
      padding: 0 ${spacing.md} ${spacing.md};
      z-index: 0;
      flex: unset;
    `};
`;
const LoadingFlash = styled.div `
  ${({ theme: { color } }) => css `
    position: absolute;
    top: 0;
    left: -45%;
    height: 100%;
    width: 45%;
    background-image: linear-gradient(
      to left,
      ${curriedTransparentize$1(1 - 0.05, color.contrast.base)},
      ${curriedTransparentize$1(1 - 0.3, color.contrast.base)},
      ${curriedTransparentize$1(1 - 0.6, color.contrast.base)},
      ${curriedTransparentize$1(1 - 0.3, color.contrast.base)},
      ${curriedTransparentize$1(1 - 0.05, color.contrast.base)}
    );
    animation: loading 1.5s infinite;
    z-index: 1;

    @keyframes loading {
      0% {
        left: -45%;
      }
      100% {
        left: 100%;
      }
    }
  `}
`;
const MockImage = styled.div `
  ${({ theme: { spacing, color, borderRadius } }) => css `
      width: ${math(`${spacing.md} * 7`)};
      height: ${math(`${spacing.md} * 4`)};
      margin: ${spacing.md} 0 0;
      background-color: ${mix$1(0.6, color.lightGrey, color.contrast.base)};
      border-radius: ${borderRadius.p1};
    `};
`;
const MockText = styled.div `
  ${({ theme: { spacing, fontSize, color, borderRadius } }) => css `
    flex: 1;
    height: ${fontSize.md};
    margin: ${spacing.md} 0 0;
    background-color: ${mix$1(0.6, color.lightGrey, color.contrast.base)};
    border-radius: ${borderRadius.p1};
  `}
`;
const MockIcon = styled.div `
  ${({ theme: { fontSize, spacing, color, borderRadius } }) => css `
    width: ${fontSize.md};
    height: ${fontSize.md};
    background-color: ${mix$1(0.6, color.lightGrey, color.contrast.base)};
    margin: ${spacing.md} 0 0;
    border-radius: ${borderRadius.p1};
  `}
`;
const MockButton = styled.div `
  ${({ theme: { spacing, fontSize, color, borderRadius } }) => css `
    width: ${math(`${spacing.xl} * 4`)};
    height: calc(${fontSize.md} + (${spacing.p1} * 2));
    background-color: ${mix$1(0.6, color.lightGrey, color.contrast.base)};
    margin: ${spacing.md} 0 0;
    border-radius: ${borderRadius.p1};
  `}
`;

const LoadingPlaceholder = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React__default.createElement(LoadingContainer, Object.assign({}, props, { "data-testid": "LoadingPlaceholder" }),
        children,
        React__default.createElement(LoadingFlash, { "data-testid": "LoadingFlash" })));
};
LoadingPlaceholder.displayName = "LoadingPlaceholder";

const animateShowContaienr = keyframes `
  0% {
    visibility: hidden;
  }

  1% {
    visibility: visible;
  }

  100% {
    visibility: visible;
  }
`;
const animateShowBox = keyframes `
  0% {
    margin-top: 50px;
    opacity: 0;
  }
  100% {
    margin-top: 0;
    opacity: 1;
  }
`;
const ModalBox = styled.div `
  ${({ theme: { color, borderRadius } }) => css `
    transition: transform 300ms, opacity 300ms;
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: ${({ theme }) => math(`${theme.fontSize.md} * 10`)};
    max-height: 95%;

    user-select: text;

    // only place with responsiveness atm
    width: 95%;
    max-width: ${() => math(`768px * 0.9`)};
    @media screen and (min-width: 768px) {
      width: 90%;
      max-width: none;
    }
    @media screen and (min-width: 1200px) {
      width: ${() => math(`1200px * 0.9`)};
      max-width: none;
    }

    background: ${color.contrast.base};
    border-radius: ${borderRadius.md};
  `}
`;
const ModalContainer = styled.div `
  ${({ $hidden, theme: { color } }) => css `
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${color.midnight};
    background: ${curriedTransparentize$1(0.5, color.midnight)};
    user-select: none;
    overflow: auto;

    ${$hidden
    ? css `
          visibility: hidden;
          pointer-events: none;

          ${ModalBox} {
            margin-top: 50px;
            opacity: 0;
          }
        `
    : css `
          animation: ${animateShowContaienr} 300ms normal both;
          visibility: visible;
          backdrop-filter: blur(3px);

          ${ModalBox} {
            animation: ${animateShowBox} 300ms normal both;
            margin-top: 0;
            opacity: 1;
          }
        `}
    z-index: 1009;
  `}
`;
const ModalHeader = styled.div `
  ${({ theme: { spacing } }) => css `
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: ${spacing.md};
  `}
`;
const ModalTitle = styled.div `
  ${({ theme: { fontSize, fontWeight } }) => css `
    flex: 1;
    font-size: ${fontSize.lg};
    font-weight: ${fontWeight.bold};
  `}
`;
const ModalContent = styled.div `
  ${({ theme: { spacing } }) => css `
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: ${spacing.md} ${spacing.xl} ${spacing.xl};
    gap: ${spacing.md};

    overflow: auto;

    & & {
      padding: 0;
    }
  `}
`;
const ModalFooter = styled.div `
  ${({ theme: { spacing } }) => css `
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding: ${spacing.md};
    gap: ${spacing.md};
  `}
`;
const ModalCloseButton = styled.button.attrs({
    type: "button",
}) `
  ${({ theme: { spacing } }) => css `
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    cursor: pointer;
    background: transparent;
    border: transparent;
    padding: ${spacing.xs} ${spacing.sm};
  `}
`;

const instanceClassName = "virti-toolbox--Modal";

/**
 * Finds the container Modal instance that contains a given target element
 *
 * @param target
 * @returns
 */
const getContainerModal = (target) => {
    const modals = document.querySelectorAll(`.${instanceClassName}`);
    for (let i = 0; i < modals.length; i++) {
        const modal = modals[i];
        if (modal.contains(target)) {
            return modal;
        }
    }
    return null;
};

const Modal = forwardRef((_a, ref) => {
    var { show, onHide, title, titleRender, titleComponent, children, render, component, footer, footerRender, footerComponent, containerRef, alwaysRendered } = _a, props = __rest(_a, ["show", "onHide", "title", "titleRender", "titleComponent", "children", "render", "component", "footer", "footerRender", "footerComponent", "containerRef", "alwaysRendered"]);
    const [portalRef, setPortalRef] = useState(null);
    const boxRef = useRef();
    useLayoutEffect(() => {
        let element = containerRef;
        let added = false;
        if (!element) {
            added = true;
            element = document.createElement("div");
            document.body.append(element);
        }
        element.setAttribute("data-testid", "Modal");
        element.classList.add(instanceClassName);
        setPortalRef(element);
        return () => {
            if (added && element) {
                element === null || element === void 0 ? void 0 : element.remove();
            }
            if (element) {
                element.removeAttribute("data-testid");
                element.classList.remove(instanceClassName);
            }
        };
    }, [containerRef]);
    useEffect(() => {
        if (!show || !portalRef) {
            return;
        }
        let clickDownTarget;
        const checkMouseDown = (e) => {
            clickDownTarget = e.target;
        };
        const checkClick = (e) => {
            if (!(boxRef === null || boxRef === void 0 ? void 0 : boxRef.current)) {
                return;
            }
            if (!onHide) {
                return;
            }
            // clicked inside the box ref
            if (boxRef.current.contains(e.target)) {
                return;
            }
            // clicked in a node that's not attached to this document
            if (!document.body.contains(e.target)) {
                return;
            }
            const containerModal = getContainerModal(e.target);
            // ignore other instances of this component
            if (containerModal !== portalRef) {
                return;
            }
            // "click" shouldn't activate if it's not the same thing that was clicked on mousedown
            if (clickDownTarget !== e.target) {
                return;
            }
            onHide(e);
        };
        // needed this delay, otherwise the click to open can overlap with this check to close
        let checking = false;
        let mounted = true;
        setTimeout(() => {
            if (!mounted) {
                return;
            }
            // use mousedown and mouseup because click was activating despite different targets
            document.addEventListener("mousedown", checkMouseDown);
            document.addEventListener("mouseup", checkClick);
            checking = true;
        }, 50);
        document.body.style.setProperty("overflow", "hidden");
        portalRef.classList.add("open");
        return () => {
            portalRef.classList.remove("open");
            // check if this is the only Modal left
            let opened = 0;
            document
                .querySelectorAll(`.${instanceClassName}`)
                .forEach((element) => {
                if (element.classList.contains("open")) {
                    opened++;
                }
            });
            if (opened === 0) {
                document.body.style.setProperty("overflow", null);
            }
            mounted = false;
            if (!checking) {
                return;
            }
            document.removeEventListener("mousedown", checkMouseDown);
            document.removeEventListener("mouseup", checkClick);
        };
    }, [show, boxRef, portalRef, onHide]);
    const renderContent = () => {
        if (component) {
            const Item = component;
            return React__default.createElement(Item, null);
        }
        if (render) {
            return render();
        }
        return children;
    };
    const renderTitle = () => {
        if (titleComponent) {
            const Item = titleComponent;
            return React__default.createElement(Item, null);
        }
        if (titleRender) {
            return titleRender();
        }
        return title;
    };
    const renderFooter = () => {
        if (footerComponent) {
            const Item = footerComponent;
            return React__default.createElement(Item, null);
        }
        if (footerRender) {
            return footerRender();
        }
        return footer;
    };
    if (!portalRef) {
        return null;
    }
    const footerContent = show && renderFooter();
    return createPortal(show || alwaysRendered ? (React__default.createElement(ModalContainer, Object.assign({ ref: ref }, props, { "$hidden": !show }),
        React__default.createElement(ModalBox, { ref: boxRef, className: "modal-box" },
            React__default.createElement(ModalHeader, { className: "modal-header" },
                React__default.createElement(ModalTitle, { className: "modal-title" }, renderTitle()),
                onHide && (React__default.createElement(ModalCloseButton, { className: "modal-close", onClick: onHide },
                    React__default.createElement(Icon, { icon: "cross" })))),
            React__default.createElement(ModalContent, { className: "modal-content" }, renderContent()),
            footerContent && (React__default.createElement(ModalFooter, { className: "modal-footer" }, footerContent))))) : null, portalRef);
});
Modal.displayName = "Modal";
Modal.propTypes = {
    show: PropTypes.bool.isRequired,
    alwaysRendered: PropTypes.bool,
    onHide: PropTypes.func,
    title: PropTypes.node,
    titleRender: PropTypes.func,
    titleComponent: PropTypes.elementType,
    children: PropTypes.node,
    render: PropTypes.func,
    component: PropTypes.elementType,
    footerRender: PropTypes.func,
    footerComponent: PropTypes.elementType,
    footer: PropTypes.node,
    containerRef: PropTypes.instanceOf(HTMLElement),
};
Modal.defaultProps = {
    title: null,
    titleRender: null,
    titleComponent: null,
    children: null,
    render: null,
    component: null,
    footerRender: null,
    footerComponent: null,
    footer: null,
    containerRef: null,
};

const inputCss = css `
  ${({ theme: { color, borderRadius, fontSize, spacing, lineHeight }, $size, }) => css `
    display: block;
    background: transparent;
    color: ${color.base};
    width: 100%;
    flex: 1;
    min-width: 10px;
    border: 1px solid transparent;
    border-radius: ${borderRadius.p1};

    ${() => {
    switch ($size) {
        case "small": {
            return css `
            padding: ${spacing.p1} ${spacing.sm};
            min-height: calc(
              ${math(`${fontSize.md} * ${lineHeight}`)} +
                ${math(`(${spacing.p1} * 2) + 2px`)}
            );
          `;
        }
        case "large": {
            return css `
            padding: ${spacing.md} ${spacing.lg};
            min-height: calc(
              ${math(`${fontSize.md} * ${lineHeight}`)} +
                ${math(`(${spacing.md} * 2) + 2px`)}
            );
          `;
        }
        default: {
            return css `
            padding: ${spacing.sm} ${spacing.md};
            min-height: calc(
              ${math(`${fontSize.md} * ${lineHeight}`)} +
                ${math(`(${spacing.sm} * 2) + 2px`)}
            );
          `;
        }
    }
}};

    &:focus,
    &:focus-visible {
      outline: none;
    }

    &:disabled,
    &[disabled] {
      color: ${color.midnight10};
      background-color: ${color.blue50};
    }
  `}
`;
const inputContainerCss = css `
  ${({ theme: { color, borderRadius }, $error, $disabled, $multiline }) => css `
    position: relative;
    display: flex;
    flex-direction: row;
    padding: 0;
    background: ${color.contrast.base};
    border: 1px solid ${color.midnight20};
    border-radius: ${borderRadius.p1};
    transition: box-shadow 200ms;
    box-shadow: inset transparent 0 0 0 0, transparent 0 0 0 0;

    ${$multiline
    ? css `
          align-items: stretch;
        `
    : css `
          align-items: center;
        `}

    ${!$disabled &&
    $error &&
    css `
      border-color: ${color.error};
      box-shadow: inset ${color.error} 0 0 0 1px, ${color.error} 0 0 0 1px;

      ${InputLabel},
      ${InputDescription} {
        color: ${color.error};
      }
    `}

    ${!$disabled &&
    !$error &&
    css `
      &:hover {
        border-color: ${color.midnight10};

        ${InputLabel} {
          color: ${color.midnight};
        }
      }
    `}

    &:focus-within {
      border-color: ${color.turquoise};
      box-shadow: inset ${color.turquoise} 0 0 0 1px,
        ${color.turquoise} 0 0 0 1px;

      ${InputLabel} {
        color: ${color.turquoise};
      }
    }

    ${$disabled &&
    css `
      ${AppendContainer} {
        background-color: ${color.blue50};
      }
    `}
  `}
`;
const Input = styled.input `
  ${({ theme: { spacing }, $suffix, $prefix }) => css `
    ${inputCss}
    align-self: stretch;

    ${$suffix &&
    css `
      && {
        margin-right: 0;
        padding-right: ${spacing.p1};
      }
    `}

    ${$prefix &&
    css `
      && {
        margin-left: 0;
        padding-left: ${spacing.p1};
      }
    `}
  `}
`;
const InputContainer = styled.div `
  ${({ theme: { fontSize, spacing, lineHeight }, $description, $label }) => {
    const height = math(`${fontSize.xs} * ${lineHeight}`);
    return css `
      ${inputContainerCss}

      ${$description &&
        css `
        margin-bottom: calc(${height} + ${math(`2px + ${spacing.p1}`)});
      `}

    ${$label &&
        css `
        margin-top: ${math(`${height} / 2`)};
      `}
    `;
}}
`;
const AppendContainer = styled.div `
  ${({ theme: { borderRadius, spacing }, $suffix }) => css `
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: ${spacing.xs} ${spacing.sm};

    ${$suffix
    ? css `
          border-top-right-radius: ${borderRadius.p1};
          border-bottom-right-radius: ${borderRadius.p1};
        `
    : css `
          border-top-left-radius: ${borderRadius.p1};
          border-bottom-left-radius: ${borderRadius.p1};
        `}
  `}
`;
const Textarea = styled.textarea `
  ${({ $size, theme: { fontSize, spacing, lineHeight } }) => css `
    ${inputCss}
    min-width: 10px;
    max-height: max(100vh, 100vw, 900px);
    max-width: calc(100% + 2px);

    ${() => {
    switch ($size) {
        case "small": {
            return css `
            height: calc(
              ${math(`${fontSize.md} * ${lineHeight} * 2`)} +
                ${math(`(${spacing.xs} * 2) + 2px`)}
            );
            min-height: calc(
              ${math(`${fontSize.md} * ${lineHeight} * 1`)} +
                ${math(`(${spacing.xs} * 2) + 2px`)}
            );
          `;
        }
        case "large": {
            return css `
            height: calc(
              ${math(`${fontSize.md} * ${lineHeight} * 10`)} +
                ${math(`(${spacing.lg} * 2) + 2px`)}
            );
            min-height: calc(
              ${math(`${fontSize.md} * ${lineHeight} * 5`)} +
                ${math(`(${spacing.lg} * 2) + 2px`)}
            );
          `;
        }
        default: {
            return css `
            height: calc(
              ${math(`${fontSize.md} * ${lineHeight} * 6`)} +
                ${math(`(${spacing.sm} * 2) + 2px`)}
            );
            min-height: calc(
              ${math(`${fontSize.md} * ${lineHeight} * 3`)} +
                ${math(`(${spacing.sm} * 2) + 2px`)}
            );
          `;
        }
    }
}};
  `}
`;
const InputLabel = styled.label `
  ${({ theme: { spacing, color, font, borderRadius } }) => css `
    ${font.smallnote}
    position: absolute;
    top: 0;
    left: ${spacing.sm};
    transform: translate(0, -50%);
    background: ${color.contrast.base};
    padding: 0 ${spacing.p1};
    border-radius: ${borderRadius.p1};
    color: ${color.midnight5};
  `}
`;
const InputDescription = styled.div `
  ${({ theme: { font, spacing, color } }) => css `
    ${font.smallnote}
    position: absolute;
    top: calc(100% + 2px);
    left: 0;
    right: 0;
    width: calc(100% - (${spacing.md} * 2));
    padding: ${spacing.p1} 0 0;
    margin: 0 ${spacing.md};
    color: ${color.midnight10};
    background: ${color.contrast.midnight10};
  `}
`;

// functions to satisfy typescript's exclusive union check for TextInputProps
const isMultiline = (k, multiline) => {
    return !!multiline;
};
const isSingleline = (k, multiline) => {
    return !multiline;
};

const TextInput = forwardRef((_a, ref) => {
    var { multiline, className, size, label, prefix, suffix, error, disabled, description, id } = _a, props = __rest(_a, ["multiline", "className", "size", "label", "prefix", "suffix", "error", "disabled", "description", "id"]);
    const input = (isMultiline(props, multiline) && (React__default.createElement(Textarea, Object.assign({ ref: ref }, props, { className: "input", "data-testid": "TextInput", disabled: disabled, "$size": size })))) ||
        (isSingleline(props, multiline) && (React__default.createElement(Input, Object.assign({ ref: ref, type: "text" }, props, { id: id, className: "input", "data-testid": "TextInput", disabled: disabled, "$prefix": !!prefix, "$suffix": !!suffix, "$size": size }))));
    return (React__default.createElement(InputContainer, { className: className, "$size": size, "$error": error, "$disabled": disabled, "$multiline": multiline, "$description": !!description, "$label": !!label },
        !multiline && prefix && (React__default.createElement(AppendContainer, { className: "prefix" }, prefix)),
        label && (React__default.createElement(InputLabel, { className: "label", htmlFor: id }, label)),
        input,
        !multiline && suffix && (React__default.createElement(AppendContainer, { "$suffix": true, className: "suffix" }, suffix)),
        description && (React__default.createElement(InputDescription, { className: "description" }, description))));
});
TextInput.displayName = "TextInput";
TextInput.propTypes = {
    suffix: PropTypes.node,
    prefix: PropTypes.node,
    multiline: PropTypes.bool,
    size: PropTypes.oneOf(["small", "medium", "large"]),
    label: PropTypes.node,
    error: PropTypes.any,
    description: PropTypes.node,
    // override for `multiline` and `prefix` having weird auto-generated types
};
TextInput.defaultProps = {
    suffix: null,
    prefix: null,
    multiline: false,
    size: "medium",
    label: null,
    description: null,
};

const VerificationBlock = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm};
`;
const VerificationMessage = styled.div `
  font-style: italic;
`;
const ModalConfirmButton = styled(Button).attrs({
    type: "button",
}) ``;
const ModalCancelButton = styled(Button).attrs({
    type: "button",
}) ``;

const ConfirmationModal = (_a) => {
    var { show, onHide, onConfirm, component, render, children, footerComponent, footerRender, footer, cancelLabel, cancelColor, confirmLabel, confirmColor, confirmDisabled, loading, buttonSize, verificationText } = _a, props = __rest(_a, ["show", "onHide", "onConfirm", "component", "render", "children", "footerComponent", "footerRender", "footer", "cancelLabel", "cancelColor", "confirmLabel", "confirmColor", "confirmDisabled", "loading", "buttonSize", "verificationText"]);
    const [verificationInputText, setVerificationInputText] = useState("");
    const renderContent = () => {
        if (component) {
            const Item = component;
            return React__default.createElement(Item, null);
        }
        if (render) {
            return render();
        }
        return (children || (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("div", null, "Are you sure you want to navigate away from this page? All your unsaved changes will be lost."),
            React__default.createElement("div", null, "Press OK to continue, or Cancel to stay on the current page."))));
    };
    const updateText = useCallback((e) => {
        setVerificationInputText(e.target.value);
    }, []);
    const disabled = confirmDisabled ||
        (verificationText ? verificationInputText !== verificationText : false);
    const handleSubmit = useCallback((e) => {
        if (e) {
            e.preventDefault();
        }
        if (disabled) {
            return;
        }
        setVerificationInputText("");
        onConfirm();
    }, [disabled, onConfirm]);
    const handleHide = useCallback((e) => {
        setVerificationInputText("");
        onHide(e);
    }, [onHide]);
    const renderFooter = () => {
        if (footerComponent) {
            const Item = footerComponent;
            return React__default.createElement(Item, null);
        }
        if (footerRender) {
            return footerRender();
        }
        return footer;
    };
    return (React__default.createElement(Modal, Object.assign({}, props, { show: show, onHide: handleHide, footerRender: () => (React__default.createElement(React__default.Fragment, null,
            cancelLabel && (React__default.createElement(ModalCancelButton, { color: cancelColor, size: buttonSize, onClick: handleHide }, cancelLabel)),
            renderFooter(),
            React__default.createElement(ModalConfirmButton, { color: confirmColor, disabled: disabled, loading: loading, size: buttonSize, onClick: handleSubmit }, confirmLabel))) }),
        React__default.createElement(ModalContent, null, renderContent()),
        verificationText && (React__default.createElement(VerificationBlock, null,
            React__default.createElement(VerificationMessage, null,
                "Please type ",
                React__default.createElement("b", null, verificationText),
                " to confirm deletion:"),
            React__default.createElement("form", { onSubmit: handleSubmit },
                React__default.createElement(TextInput, { value: verificationInputText, name: "group-name", id: "group-name", onChange: updateText }))))));
};
ConfirmationModal.displayName = "ConfirmationModal";
ConfirmationModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    title: PropTypes.node,
    titleRender: PropTypes.func,
    titleComponent: PropTypes.elementType,
    children: PropTypes.node,
    render: PropTypes.func,
    component: PropTypes.elementType,
    footerRender: PropTypes.func,
    footerComponent: PropTypes.elementType,
    footer: PropTypes.node,
    cancelLabel: PropTypes.node,
    cancelColor: Button.propTypes.color,
    confirmLabel: PropTypes.node,
    confirmColor: Button.propTypes.color,
    confirmDisabled: PropTypes.bool,
    loading: PropTypes.bool,
    buttonSize: Button.propTypes.size,
    verificationText: PropTypes.string,
};
ConfirmationModal.defaultProps = {
    title: "Please confirm",
    titleRender: null,
    titleComponent: null,
    component: null,
    render: null,
    children: null,
    footerRender: null,
    footerComponent: null,
    footer: null,
    cancelLabel: "Cancel",
    cancelColor: "transparent",
    confirmLabel: "OK",
    confirmDisabled: false,
    confirmColor: "primary",
    loading: false,
    verificationText: null,
    buttonSize: Button.defaultProps.size,
};

const defaultOptions = { key: "page", pageSize: 12, onChange: () => null };
const usePaginationUrl = (options = {}) => {
    const config = Object.assign(Object.assign({}, defaultOptions), options);
    const { value, updateValue, reset } = useStateUrl(config);
    const { pageSize } = config;
    const page = Math.max(Number(value), 1);
    const result = useMemo(() => ({
        page,
        pageSize,
        changePage: updateValue,
        resetPage: reset,
        pageQuery: {
            limit: pageSize,
            offset: (page - 1) * pageSize,
        },
        controlProps: {
            onPageChange: updateValue,
            page,
            pageSize,
        },
    }), [page, updateValue, reset, pageSize]);
    return result;
};

const StyledControl = styled.div `
  ${({ theme: { spacing } }) => css `
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: ${spacing.md};
    margin: ${spacing.sm} auto;
    padding: 0 ${spacing.sm};
  `}
`;
const StyledChangePageButton = styled(Button).attrs({
    icon: "chevron",
    design: "text",
    color: "pink",
}) `
  ${({ theme: { spacing, color }, disabled, $previous, $squared }) => css `
    padding: ${spacing.p2};
    color: ${color.base};

    ${$squared &&
    css `
      height: 100%;
      aspect-ratio: 1/1;
    `}

    ${disabled &&
    css `
      pointer-events: none;
    `}

    transform: ${$previous && "scaleX(-1)"};
  `}
`;

// styles that are dynamic to state
const useSelectStyles = ({ inlineLabel = "", multi = false, menuPosition, }) => {
    const theme = useTheme();
    const stylesConfig = useMemo(() => {
        if (!theme) {
            return {};
        }
        const { color, spacing } = theme;
        const withInlineLabel = (base) => (Object.assign(Object.assign({}, base), { ":before": {
                color: color.midnight10,
                content: `"${inlineLabel} "`,
                paddingRight: spacing.xs,
            } }));
        return {
            multiValueRemove: (base, state) => 
            // we can explore better ways for this later
            state.data.isFixed ? Object.assign(Object.assign({}, base), { display: "none" }) : base,
            menu: (base, { placement }) => (Object.assign(Object.assign({}, base), { overflow: "auto" })),
            // Fixes the overlapping problem of the component
            menuPortal: (provided) => (Object.assign(Object.assign({}, provided), { zIndex: 9999 })),
            singleValue: inlineLabel && !multi ? withInlineLabel : undefined,
            valueContainer: inlineLabel && multi ? withInlineLabel : undefined,
        };
    }, [inlineLabel, multi, theme]);
    return stylesConfig;
};
const styles = css `
  ${({ theme: { color, borderRadius, spacing, fontSize }, $error }) => css `
  display: flex;
    width: 100%;
    flex: 1;
    min-height: calc(${fontSize.md} + ${math(`(${spacing.md} * 1.5) + 2px`)});

    .react-select {
      &__control {
        flex: 1;
        transition: none;
        background: ${color.contrast.base};
        padding: 0 5px 0 0;
        border-radius: ${borderRadius.p1};
        line-height: 1.1;
        transition: box-shadow 200ms;

        ${$error
    ? css `
                border: 1px solid ${color.error};
                box-shadow: inset ${color.error} 0 0 0 1px,
                  ${color.error} 0 0 0 1px;

                &:hover {
                  border-color: ${color.error};
                  cursor: pointer;

                  .react-select__dropdown-indicator {
                    color: ${color.error};
                  }
                }
              `
    : css `
                border: 1px solid ${color.lightGrey};
                box-shadow: inset transparent 0 0 0 0, transparent 0 0 0 0;

                &:hover {
                  border-color: ${color.turquoise};
                  cursor: pointer;

                  .react-select__dropdown-indicator {
                    color: ${color.turquoise};
                  }
                }
              `}

        &--is-disabled {
          background-color: ${color.blue50};
        }

        &--is-focused {
          border-color: ${color.turquoise};
          box-shadow: inset ${color.turquoise} 0 0 0 1px,
            ${color.turquoise} 0 0 0 1px;

          &:hover {
            border-color: ${color.turquoise};

            .react-select__dropdown-indicator {
              color: ${color.turquoise};
            }
          }
        }

        &--menu-is-open {
          border-radius: ${borderRadius.p1};

          .react-select__dropdown-indicator {
            transform: scaleY(-1);
            color: ${color.turquoise};
          }
        }
      }

      &__dropdown-indicator {
        color: ${color.midnight5};
      }

      &__input {
        grid-area: 1 / 3 !important;
      }

      &__input-container {
        color: ${color.base};

        &:after {
          grid-area: 1 / 3;
        }
      }

      &__value-container {
        color: ${color.base};
        padding: ${spacing.xs} ${spacing.sm} ${spacing.xs} ${spacing.md};

        &:hover {
          cursor: text;
        }
      }

      &__indicator-separator {
        display: none;

        svg {
          width: ${fontSize.xl};
          height: ${fontSize.xl};
        }
      }

      &__indicators {
        &-separator {
          display: none;
        }

        svg {
          width: ${fontSize.xl};
          height: ${fontSize.xl};
        }
      }

      &__menu {
        background: ${color.contrast.base};
        overflow: auto;
        box-shadow: none;
        margin: 0.3rem 0;
        border: 1px solid ${color.turquoise};
        border-radius: ${borderRadius.p1}
        border-color: ${color.primary};
        box-sizing: border-box;
        min-height: 70px;
        z-index: 2;

        left: 50%;
        transform: translateX(-50%);
        min-width: 100%;
        width: max-content;
        max-width: 200%;
      }

      &__menu-portal {
        transform: translateY(4px);
      }

      &__option--is-selected {
        background: ${color.focus};
        color: ${color.contrast.focus};
      }

      &__option--is-focused {
        background: ${color.highlight};
        color: ${color.contrast.highlight};
      }

      &__single-value {
        color: ${color.base};
        &:hover {
          cursor: pointer;
        }
      }

      &__multi-value {
        border-radius: ${borderRadius.p1};
        background-color: ${color.blue30};
        color: ${color.midnight};

        &:hover {
          cursor: pointer;
        }

        &__label {
          display: flex;
          flex-direction: row;
          align-items: center;
          padding: ${spacing.xs} ${spacing.sm};
          color: ${color.contrast.secondary};
          font-size: ${fontSize.sm};
        }

        &__remove {
          display: flex;
          flex-direction: row;
          align-items: center;
          background-color: ${color.blue30};
          border-radius: 0 ${borderRadius.p1} ${borderRadius.p1} 0;
          padding: ${spacing.xs} ${spacing.sm} ${spacing.xs} ${spacing.xs};

          &:hover,
          &:active {
            background-color: ${color.blue20};
            border-radius: 0 ${borderRadius.p1} ${borderRadius.p1} 0;
            filter: brightness(115%);
          }

          &:active {
            background-color: ${color.blue20};
            border-radius: 0 ${borderRadius.p1} ${borderRadius.p1} 0;
            filter: brightness(85%);
          }

          &:focus {
            box-shadow: 0 0 5px 1px ${color.focus};
          }

          svg {
            color: ${color.contrast.secondary};

            width: ${fontSize.lg};
            height: ${fontSize.lg};
          }
        }
      }
    }
  `}
`;
const SelectIndicator = styled(Icon).attrs({
    icon: "chevron",
    size: "0.8rem",
}) `
  transform: rotate(90deg) translateX(1px);
  flex: 1;
  align-self: center;
  justify-self: center;
`;
// styles that are static and do not change
const StyledSelect = styled(Select$1) `
  ${styles}
`;
const StyledCreatableSelect = styled(CreatableSelect) `
  ${styles}
`;
const SelectContainer = styled.div `
  ${({ theme: { color, fontSize, spacing, lineHeight }, $disabled, $error, $description, $label, }) => {
    const height = math(`${fontSize.xs} * ${lineHeight}`);
    return css `
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;

      ${$description &&
        css `
        margin-bottom: calc(${height} + ${math(`2px + ${spacing.p1}`)});
      `}

      ${$label &&
        css `
        margin-top: ${math(`${height} / 2`)};
      `}

    ${!$disabled &&
        $error &&
        css `
        ${SelectLabel},
        ${SelectDescription} {
          color: ${color.error};
        }
      `}

    &:focus-within,
    &:has(.react-select__control--is-focused) {
        ${SelectLabel} {
          color: ${color.turquoise};
        }
      }

      ${!$disabled &&
        !$error &&
        css `
        &:hover {
          ${SelectLabel} {
            color: ${color.turquoise};
          }
        }
      `}
    `;
}}
`;
const SelectLabel = styled.label `
  ${({ theme: { spacing, color, font, borderRadius } }) => css `
    ${font.smallnote}
    position: absolute;
    top: 0;
    left: ${spacing.sm};
    transform: translate(0, -50%);
    background: ${color.contrast.base};
    padding: 0 ${spacing.p1};
    border-radius: ${borderRadius.p1};
    color: ${color.midnight5};

    z-index: 1;
  `}
`;
const SelectDescription = styled.div `
  ${({ theme: { font, spacing, color } }) => css `
    ${font.smallnote}
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    width: 100%;
    padding: ${spacing.p1} ${spacing.md} 0 ${spacing.md};
    color: ${color.midnight10};
  `}
`;

const { SelectContainer: SelectContainer$1 } = components;
const CustomSelectContainer = (_a) => {
    var { innerProps } = _a, props = __rest(_a, ["innerProps"]);
    return (React__default.createElement(SelectContainer$1, Object.assign({}, props, { 
        // data-testid will never satisfy the typing for react-select
        innerProps: Object.assign(Object.assign({}, innerProps), { "data-testid": "Select" }) })));
};

const { DropdownIndicator } = components;
const CustomDropdownIndicator = (props) => {
    return (React__default.createElement(DropdownIndicator, Object.assign({}, props),
        React__default.createElement(SelectIndicator, null)));
};

const Select = forwardRef((props, ref) => {
    const { theme: reactSelectTheme, className, loading, placeholder, multi, disabled, clearable, searchable, options, onChange, onAdd, onRemove, value, inlineLabel, components, error, label, description, 
    /** creatable props start */
    creatable, allowCreateWhileLoading, createOptionPosition, formatCreateLabel, isValidNewOption, getNewOptionData, onCreateOption } = props, 
    /** creatable props end */
    baseProps = __rest(props, ["theme", "className", "loading", "placeholder", "multi", "disabled", "clearable", "searchable", "options", "onChange", "onAdd", "onRemove", "value", "inlineLabel", "components", "error", "label", "description", "creatable", "allowCreateWhileLoading", "createOptionPosition", "formatCreateLabel", "isValidNewOption", "getNewOptionData", "onCreateOption"]);
    const [prevOptions, setPrevOptions] = useState();
    useEffect(() => {
        if (options.length) {
            setPrevOptions(options);
        }
    }, [options]);
    const handleChange = useCallback((updatedOptions) => {
        onChange(updatedOptions);
        if (!multi) {
            return;
        }
        // addition case
        if (updatedOptions.length > (value === null || value === void 0 ? void 0 : value.length)) {
            const option = updatedOptions[updatedOptions.length - 1];
            onAdd(option.value, option.label);
        }
        // deletion case
        if (updatedOptions.length < (value === null || value === void 0 ? void 0 : value.length)) {
            const values = updatedOptions.map((option) => option.value);
            const option = value.find((option) => !values.includes(option.value));
            onRemove(option.value, option.label);
        }
    }, [onAdd, onRemove, value, onChange, multi]);
    const optionValue = useMemo(() => {
        var _a;
        if (!multi) {
            if (typeof (value === null || value === void 0 ? void 0 : value.value) !== "undefined") {
                return value;
            }
            return options.find((item) => item.value === value) || value;
        }
        if (!value) {
            return [];
        }
        if (typeof ((_a = value === null || value === void 0 ? void 0 : value[0]) === null || _a === void 0 ? void 0 : _a.value) !== "undefined") {
            return value;
        }
        if (!Array.isArray(value)) {
            return [value];
        }
        return value.map((itemValue) => {
            const option = options.find((item) => item.value === itemValue);
            return option || { value: itemValue, label: itemValue };
        });
    }, [options, multi, value]);
    const optionsCached = useMemo(() => {
        // this prevents the short second where options are an empty array, causing annoying UX
        if (loading && !options.length) {
            return prevOptions;
        }
        else {
            return options;
        }
    }, [options, prevOptions, loading]);
    const styles = useSelectStyles(props);
    const selectProps = Object.assign(Object.assign({}, baseProps), { components: Object.assign({ SelectContainer: CustomSelectContainer, DropdownIndicator: CustomDropdownIndicator }, (components || {})), menuPlacement: "auto", styles, placeholder: loading ? "" : placeholder, onChange: handleChange, options: optionsCached, value: optionValue, isMulti: multi, isLoading: loading, isDisabled: disabled, isSearchable: searchable, 
        // multi can't support clearing yet
        isClearable: !multi && clearable, classNamePrefix: "react-select", $error: error });
    if (creatable) {
        const createableProps = {
            allowCreateWhileLoading,
            createOptionPosition,
            formatCreateLabel,
            isValidNewOption,
            getNewOptionData,
            onCreateOption,
        };
        return (React__default.createElement(SelectContainer, { className: className, "$error": error, "$disabled": disabled },
            label && React__default.createElement(SelectLabel, { className: "label" }, label),
            React__default.createElement(StyledCreatableSelect, Object.assign({}, selectProps, { ref: ref }, createableProps)),
            description && (React__default.createElement(SelectDescription, { className: "description" }, description))));
    }
    return (React__default.createElement(SelectContainer, { className: className, "$error": error, "$disabled": disabled, "$description": !!description, "$label": !!label },
        label && React__default.createElement(SelectLabel, { className: "label" }, label),
        description && (React__default.createElement(SelectDescription, { className: "description" }, description)),
        React__default.createElement(StyledSelect, Object.assign({}, selectProps, { ref: ref }))));
});
Select.displayName = "Select";
Select.defaultProps = {
    multi: false,
    placeholder: "Search...",
    disabled: false,
    loading: false,
    clearable: false,
    searchable: true,
    onAdd: () => null,
    onRemove: () => null,
    onChange: () => null,
    creatable: false,
    createOptionPosition: "last",
    error: null,
};
Select.propTypes = {
    multi: PropTypes.bool,
    placeholder: PropTypes.node,
    inlineLabel: PropTypes.string,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    clearable: PropTypes.bool,
    searchable: PropTypes.bool,
    onAdd: PropTypes.func,
    onRemove: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.any,
    options: PropTypes.arrayOf(PropTypes.any).isRequired,
    creatable: PropTypes.bool,
    allowCreateWhileLoading: PropTypes.bool,
    createOptionPosition: PropTypes.oneOf(["first", "last"]),
    formatCreateLabel: PropTypes.func,
    isValidNewOption: PropTypes.func,
    getNewOptionData: PropTypes.func,
    onCreateOption: PropTypes.func,
    components: PropTypes.object,
    error: PropTypes.any,
};

const CreateSelect = (_a) => {
    var { value, onChange, onInputChange, setError = () => null, isEmailList } = _a, props = __rest(_a, ["value", "onChange", "onInputChange", "setError", "isEmailList"]);
    const [inputValue, setInputValue] = useState("");
    const validateEmail = (email) => {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    };
    const handleInputChange = useCallback((newValue) => {
        onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(newValue);
        setInputValue(newValue);
    }, [onInputChange]);
    const handleKeyDown = useCallback((event) => {
        if (!inputValue)
            return;
        switch (event.key) {
            case "Backspace":
                setError("");
                break;
            case " ":
            case "Tab":
                if (isEmailList && !validateEmail(inputValue)) {
                    setError(`"${inputValue}" is not a valid email address.`);
                    return;
                }
                onChange((prev) => [...prev, inputValue]);
                handleInputChange("");
                event.preventDefault();
                break;
            default:
                setError("");
        }
    }, [inputValue, setError, isEmailList, onChange, handleInputChange]);
    const handleBlur = useCallback(() => {
        if (!inputValue) {
            return;
        }
        if (isEmailList && !validateEmail(inputValue)) {
            setError(`"${inputValue}" is not a valid email address.`);
            return;
        }
        onChange((prev) => [...prev, inputValue]);
        handleInputChange("");
    }, [inputValue, isEmailList, onChange, handleInputChange, setError]);
    const handlePaste = useCallback((e) => {
        e.preventDefault();
        let text = e.clipboardData.getData("text");
        handleInputChange(text);
        const inputArray = text.split(/[\s,]+/);
        let invalidEmails = "";
        inputArray.forEach((input) => {
            if (!input) {
                return;
            }
            if (!isEmailList) {
                onChange((prev) => [...prev, input]);
            }
            if (validateEmail(input)) {
                onChange((prev) => [...prev, input]);
            }
            else {
                invalidEmails += ` ${input},`;
            }
        });
        if (invalidEmails.length) {
            setError(`Some emails are not valid: ${invalidEmails}`.slice(0, -1));
        }
        handleInputChange("");
    }, [handleInputChange, isEmailList, onChange, setError]);
    const parsedValues = useMemo(() => {
        // removes duplicates from the list
        const set = new Set(value || []);
        return Array.from(set).map((item) => {
            // returns an array in the Select label/value structure
            return {
                label: item,
                value: item,
            };
        });
    }, [value]);
    // there is no list to choose from, so we don't need a dropdown
    const components = {
        DropdownIndicator: null,
    };
    return (React__default.createElement("div", { onPaste: handlePaste, "data-testid": "create-select-pastable-wrapper" },
        React__default.createElement(Select, Object.assign({ onBlur: handleBlur, creatable: true, clearable: true, multi: true, components: components, menuIsOpen: false, value: parsedValues, inputValue: inputValue, options: [], onKeyDown: handleKeyDown, onInputChange: handleInputChange, onRemove: (e) => {
                const filteredValues = parsedValues.filter((item) => {
                    return item.value !== e;
                });
                onChange(filteredValues.map((item) => item.value));
            } }, props))));
};
CreateSelect.propTypes = {
    value: PropTypes.array,
    onChange: PropTypes.func,
    onInputChange: PropTypes.func,
    setError: PropTypes.func,
    isEmailList: PropTypes.bool,
};

const PaginationControl = (props) => {
    const { onPageChange, total, page, pageSize } = props, controlProps = __rest(props, ["onPageChange", "total", "page", "pageSize"]);
    const totalPages = Math.ceil(total / pageSize);
    const lastPage = isNaN(totalPages) ? 1 : Math.max(totalPages, 1);
    const pages = useMemo(() => {
        const list = [...Array(lastPage)].map((_, i) => ({
            label: i + 1,
            value: i + 1,
        }));
        if (page > lastPage) {
            return [...list, { value: page, label: page }];
        }
        return list;
    }, [lastPage, page]);
    const onNext = useCallback(() => {
        onPageChange(page + 1);
    }, [page, onPageChange]);
    const onPrevious = useCallback(() => {
        const index = pages.findIndex((item) => page - 1 === item.value);
        if (index > -1) {
            onPageChange(page - 1);
            return;
        }
        onPageChange(1);
    }, [pages, page, onPageChange]);
    const changePage = useCallback((item) => {
        if (item.value !== page && page > 0 && item.value <= lastPage) {
            onPageChange(item.value);
        }
    }, [lastPage, onPageChange, page]);
    if (page <= 0 ||
        lastPage === 1 ||
        totalPages < 2 ||
        isNaN(lastPage) ||
        isNaN(totalPages)) {
        return null;
    }
    return (React__default.createElement(StyledControl, Object.assign({}, controlProps),
        React__default.createElement(StyledChangePageButton, { onClick: onPrevious, "$previous": true, "$squared": true, disabled: page === 1 }),
        React__default.createElement(Select, { searchable: false, options: pages, value: page, onChange: changePage, placeholder: page }),
        React__default.createElement(StyledChangePageButton, { onClick: onNext, "$squared": true, disabled: page === lastPage })));
};
PaginationControl.defaultProps = {};
PaginationControl.propTypes = {
    total: PropTypes.number,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
};

const getBGColor = (themeColor, color) => {
    switch (color) {
        case "blue":
            return themeColor.blue30;
        case "midnight":
            return themeColor.midnight20;
        case "pink":
            return themeColor.pink20;
        case "turquoise":
            return themeColor.turquoise20;
        default:
            return themeColor.blue30;
    }
};
const ProgressBarWrapper = styled.div `
  width: 100%;
`;
const ProgressBarLabel = styled.div `
  ${({ $color, theme: { color: themeColor, fontWeight } }) => css `
    width: 100%;
    color: ${themeColor[$color] || themeColor.blue};
    font-weight: ${fontWeight.bold};
    margin-bottom: 0.1rem;
  `}
`;
const ProgressBarShape = styled.div `
  ${({ $height, $color, theme: { borderRadius, color: themeColor } }) => css `
    border-radius: ${borderRadius.lg};
    background-color: ${getBGColor(themeColor, $color)};
    width: 100%;
    height: ${$height}px;
  `}
`;
const ProgressBarShapeInner = styled.div `
  ${({ $progress, $color, theme: { color, borderRadius } }) => css `
    border-radius: ${borderRadius.lg};
    background-color: ${color[$color]};
    width: ${$progress}%;
    transition: width 0.2s;
    height: 100%;
  `}
`;

const ProgressBar = (_a) => {
    var { progress, max, color, labelText, height } = _a, props = __rest(_a, ["progress", "max", "color", "labelText", "height"]);
    const percentage = useMemo(() => {
        return (progress / max) * 100;
    }, [progress, max]);
    const $colorWithFallback = color !== null && color !== void 0 ? color : "blue";
    return (React__default.createElement(ProgressBarWrapper, Object.assign({}, props),
        labelText && (React__default.createElement(ProgressBarLabel, { "$color": $colorWithFallback }, labelText)),
        React__default.createElement(ProgressBarShape, { "$height": height !== null && height !== void 0 ? height : 8, "$color": $colorWithFallback },
            React__default.createElement(ProgressBarShapeInner, { "$color": $colorWithFallback, "$progress": percentage }))));
};
ProgressBar.propTypes = {
    progress: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    color: PropTypes.oneOf(["blue", "midnight", "pink", "turquoise"]),
    labelText: PropTypes.string,
    height: PropTypes.number,
};

// copied from `react-circular-progressbar`
const source$1 = css `
  /*
  * react-circular-progressbar styles
  * All of the styles in this file are configurable!
  */

  .CircularProgressbar {
    /*
    * This fixes an issue where the CircularProgressbar svg has
    * 0 width inside a "display: flex" container, and thus not visible.
    */
    width: 100%;
    /*
    * This fixes a centering issue with CircularProgressbarWithChildren:
    * https://github.com/kevinsqi/react-circular-progressbar/issues/94
    */
    vertical-align: middle;
  }

  .CircularProgressbar .CircularProgressbar-path {
    stroke: #3e98c7;
    stroke-linecap: round;
    -webkit-transition: stroke-dashoffset 0.5s ease 0s;
    transition: stroke-dashoffset 0.5s ease 0s;
  }

  .CircularProgressbar .CircularProgressbar-trail {
    stroke: #d6d6d6;
    /* Used when trail is not full diameter, i.e. when props.circleRatio is set */
    stroke-linecap: round;
  }

  .CircularProgressbar .CircularProgressbar-text {
    fill: #3e98c7;
    font-size: 20px;
    dominant-baseline: middle;
    text-anchor: middle;
  }

  .CircularProgressbar .CircularProgressbar-background {
    fill: #d6d6d6;
  }

  .CircularProgressbar.CircularProgressbar-inverted
    .CircularProgressbar-background {
    fill: #3e98c7;
  }

  .CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-text {
    fill: #fff;
  }

  .CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-path {
    stroke: #fff;
  }

  .CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-trail {
    stroke: transparent;
  }
`;
const ProgressbarWrapper = styled.div `
  width: 100%;
  height: 100%;
  flex: 1;
  ${source$1}
`;

const CircularProgressbar = ({ percentage, }) => {
    const { progress: { circleWidth, circleFontSize, circleDoneColor, circleTrailColor, }, } = useTheme();
    const value = useMemo(() => {
        const raw = Number(("" + percentage).split("%")[0]);
        return isFinite(raw) ? raw : 0;
    }, [percentage]);
    const display = useMemo(() => {
        if (percentage == null || percentage === "") {
            return "-";
        }
        return `${Math.round(value * 10) / 10}%`;
    }, [percentage, value]);
    return (React__default.createElement(ProgressbarWrapper, null,
        React__default.createElement(CircularProgressbar$1, { value: value, text: display, strokeWidth: circleWidth, styles: buildStyles({
                strokeLinecap: "butt",
                pathColor: circleDoneColor,
                trailColor: circleTrailColor,
                textSize: circleFontSize,
                textColor: "initial",
            }) })));
};
CircularProgressbar.propTypes = {
    percentage: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
};

// Generated with util/create-component.js
const SortIcon = styled(Icon).attrs({
    icon: "chevron",
}) `
  grid-column: 1;
  grid-row: 1;
  transition: transform 0.2s ease-in-out, opacity 0.2s ease-in-out;
  opacity: ${({ $active, $hidden }) => {
    if ($active) {
        return 1;
    }
    if ($hidden) {
        return 0;
    }
    return 0.5;
}};
`;
const SortUpIcon = styled(SortIcon) `
  transform: ${({ $active }) => $active ? "rotate(-90deg)" : "translateY(-6px) scale(.7) rotate(-90deg)"};
`;
const SortDownIcon = styled(SortIcon) `
  transform: ${({ $active }) => $active ? "rotate(90deg)" : "translateY(6px) scale(.7) rotate(90deg)"};
`;
const SortIconContainer = styled.span `
  display: grid;
`;
const SortButton = styled.button `
  background: transparent;
  border: none;
  cursor: pointer;
  color: inherit;
  font: inherit;
  line-height: inherit;
  padding: ${({ theme: { spacing: { sm, md }, }, }) => `${sm} ${md}`};
  width: 100%;
  display: flex;
  justify-content: space-between;

  &:hover {
    ${SortIconContainer} {
      color: ${({ theme }) => theme.color.primary};
    }
  }

  &:hover {
    ${SortUpIcon} {
      opacity: ${({ $sorted }) => !$sorted && "1"};
    }
  }
`;
const SortTh = styled.th `
  &:hover {
    border-color: ${({ theme }) => theme.color.primary};
  }
`;

const Table = styled.table `
  ${({ theme: { color, fontWeight } }) => css `
    width: 100%;
    border-collapse: collapse;
    text-align: left;

    thead {
      th,
      td {
        vertical-align: middle;
      }
    }

    th,
    td {
      padding: ${({ theme: { spacing: { md }, }, }) => `${math(`${md} * 0.75`)} ${md}`};
      border-bottom: 1px solid ${color.blue40};

      &.middle {
        text-align: center;
      }
    }

    th {
      color: ${color.darkGrey};
      font-weight: ${fontWeight.bold};
    }

    ${SortTh} {
      padding: 0;
    }
  `}
`;

const Table$1 = (_a) => {
    var props = __rest(_a, []);
    return (React__default.createElement(Table, Object.assign({ "data-testid": "Table" }, props)));
};
Table$1.displayName = "Table";
// propTypes and defaultProps are optional, but still useful for runtime checking and providing a fallback
Table$1.propTypes = {};
Table$1.defaultProps = {};

const SortableTh = (_a) => {
    var { sortField, onSort, currentSort, children } = _a, thProps = __rest(_a, ["sortField", "onSort", "currentSort", "children"]);
    const isSorted = currentSort.sortField === sortField;
    const isSortedAsc = isSorted && currentSort.sortDirection === "ASC";
    const isSortedDesc = isSorted && currentSort.sortDirection === "DESC";
    const nextSortDirection = isSortedAsc ? "DESC" : "ASC";
    const childrenAsText = () => {
        const labelParts = [];
        React__default.Children.map(children, (child) => {
            if (typeof child === "string") {
                labelParts.push(child);
            }
        });
        return labelParts.join(" ");
    };
    return (React__default.createElement(SortTh, Object.assign({}, thProps),
        React__default.createElement(SortButton, { onClick: () => onSort(sortField, nextSortDirection), "aria-label": `Sort table on '${childrenAsText()}' in ${nextSortDirection === "ASC" ? "ascending" : "descending"} direction`, "$sorted": isSorted },
            children,
            React__default.createElement(SortIconContainer, null,
                React__default.createElement(SortUpIcon, { "$active": isSortedAsc, "$hidden": isSortedDesc }),
                React__default.createElement(SortDownIcon, { "$active": isSortedDesc, "$hidden": isSortedAsc })))));
};

const LinkedTdTd = styled.td `
  ${() => css `
    ${cellFragment}
  `}
`;
const LinkedTdLink = styled(Link$1) `
  ${({ theme: { color } }) => css `
    ${cellPaddingFragment};
    display: block;
    width: 100%;
    height: 100%;
    text-decoration: none;
    color: ${color.midnight10};
    display: flex;
    flex-direction: column;
    cursor: pointer;
    justify-content: center;
  `}
`;

const cellPaddingFragment = css `
  ${({ theme: { spacing: { sm, md }, }, }) => css `
    padding: ${sm} ${md};
  `}
`;
const cellFragment = css `
  ${({ $center, theme: { color } }) => css `
    background-color: ${color.white};
    color: ${color.midnight10};
    vertical-align: middle;
    border-bottom: 1px solid ${color.midnight30};
    height: 54px;
    ${$center &&
    css `
      text-align: center;
    `}
  `}
`;
const Td = styled.td `
  ${cellPaddingFragment};
  ${cellFragment}
`;
const thFragment = css `
  ${cellPaddingFragment}
  ${cellFragment}
  ${({ theme: { color, fontWeight } }) => css `
    color: ${color.midnight5};
    font-weight: ${fontWeight.bold};
    background-color: ${color.blue50};
    border-top: 1px solid ${color.midnight30};
  `}
`;
const Th = styled.th `
  ${thFragment}
`;
const Thead = styled.thead ``;
const Tbody = styled.tbody ``;
const Tr = styled.tr ``;
const Table$2 = styled.table `
  ${({ theme: { color } }) => css `
    width: 100%;
    border-collapse: collapse;
    text-align: left;
    ${Tr}:has(${LinkedTdLink}):hover {
      ${Td}, ${LinkedTdTd} {
        background-color: ${color.pink30};
      }
    }
  `}
`;

const TableV2 = (_a) => {
    var props = __rest(_a, []);
    return (React__default.createElement(Table$2, Object.assign({ "data-testid": "TableV2" }, props)));
};
TableV2.displayName = "TableV2";
TableV2.propTypes = {};
TableV2.defaultProps = {};

const TdLink = forwardRef((_a, ref) => {
    var { $center, children, to, prevPath, prevTitle, as } = _a, props = __rest(_a, ["$center", "children", "to", "prevPath", "prevTitle", "as"]);
    const component = useMemo(() => {
        if (typeof to !== "string") {
            return as;
        }
        if (to.startsWith("http://") || to.startsWith("https://")) {
            return "a";
        }
        return as;
    }, [as, to]);
    const toProps = useMemo(() => {
        if (component === "a" && typeof to === "string") {
            return { href: to };
        }
        return { to: addLinkState(to, prevPath, prevTitle) };
    }, [to, component, prevPath, prevTitle]);
    return (React__default.createElement(LinkedTdTd, Object.assign({ ref: ref, "$center": $center, "data-testid": "LinkedTd" }, props),
        React__default.createElement(LinkedTdLink, Object.assign({ "data-testid": "LinkedTdLink", as: component }, toProps), children)));
});

// Generated with util/create-component.js
const SortIcon$1 = styled(Icon).attrs({
    icon: "chevron",
}) `
  grid-column: 1;
  grid-row: 1;
  transition: transform 0.2s ease-in-out, opacity 0.2s ease-in-out;
  opacity: ${({ $active, $hidden }) => {
    if ($active) {
        return 1;
    }
    if ($hidden) {
        return 0;
    }
    return 0.5;
}};
`;
const SortUpIcon$1 = styled(SortIcon$1) `
  transform: ${({ $active }) => $active ? "rotate(-90deg)" : "translateY(-6px) scale(.7) rotate(-90deg)"};
`;
const SortDownIcon$1 = styled(SortIcon$1) `
  transform: ${({ $active }) => $active ? "rotate(90deg)" : "translateY(6px) scale(.7) rotate(90deg)"};
`;
const SortIconContainer$1 = styled.span `
  display: grid;
`;
const SortButton$1 = styled.button `
  background: transparent;
  border: none;
  cursor: pointer;
  color: inherit;
  font: inherit;
  width: 100%;
  height: 100%;
  line-height: inherit;
  padding: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${cellPaddingFragment}

  &:hover {
    ${SortIconContainer$1} {
      color: ${({ theme }) => theme.color.primary};
    }
  }

  &:hover {
    ${SortUpIcon$1} {
      opacity: ${({ $sorted }) => !$sorted && "1"};
    }
  }
`;
const SortTh$1 = styled.th `
  ${thFragment}
  padding: 0;
  &:hover {
    border-color: ${({ theme }) => theme.color.primary};
  }
`;

const SortableThV2 = (_a) => {
    var { sortField, onSort, currentSort, children } = _a, thProps = __rest(_a, ["sortField", "onSort", "currentSort", "children"]);
    const isSorted = currentSort.sortField === sortField;
    const isSortedAsc = isSorted && currentSort.sortDirection === "ASC";
    const isSortedDesc = isSorted && currentSort.sortDirection === "DESC";
    const nextSortDirection = isSortedAsc ? "DESC" : "ASC";
    const childrenAsText = () => {
        const labelParts = [];
        React__default.Children.map(children, (child) => {
            if (typeof child === "string") {
                labelParts.push(child);
            }
        });
        return labelParts.join(" ");
    };
    return (React__default.createElement(SortTh$1, Object.assign({}, thProps),
        React__default.createElement(SortButton$1, { onClick: () => onSort(sortField, nextSortDirection), "aria-label": `Sort table on '${childrenAsText()}' in ${nextSortDirection === "ASC" ? "ascending" : "descending"} direction`, "$sorted": isSorted },
            children,
            React__default.createElement(SortIconContainer$1, null,
                React__default.createElement(SortUpIcon$1, { "$active": isSortedAsc, "$hidden": isSortedDesc }),
                React__default.createElement(SortDownIcon$1, { "$active": isSortedDesc, "$hidden": isSortedAsc })))));
};

const tabControl = (TabsComponent) => {
    const UncontrolledTabs = (props) => {
        var _a, _b;
        const { children, onChange } = props;
        const firstChild = (_a = Children.toArray(children)) === null || _a === void 0 ? void 0 : _a[0];
        const [tabName, setTabName] = useState((_b = firstChild.props) === null || _b === void 0 ? void 0 : _b.name);
        const handleChange = useCallback((name) => {
            setTabName(name);
            onChange(name);
        }, [onChange]);
        return (React__default.createElement(TabsComponent, Object.assign({}, props, { children: children, onChange: handleChange, selectedTabName: tabName })));
    };
    UncontrolledTabs.propTypes = {
        onChange: PropTypes.func,
    };
    UncontrolledTabs.defaultProps = {
        onChange: () => null,
    };
    return UncontrolledTabs;
};

const tabUrlParam = (TabsComponent) => {
    const UrlParamTabs = (_a) => {
        var _b, _c;
        var { urlKey, onChange } = _a, props = __rest(_a, ["urlKey", "onChange"]);
        const { children } = props;
        const firstChild = (_b = Children.toArray(children)) === null || _b === void 0 ? void 0 : _b[0];
        const { value: tabName, updateValue: setTabName, reset: resetTab, } = useStateUrl({
            key: urlKey,
            initialValue: ((_c = firstChild === null || firstChild === void 0 ? void 0 : firstChild.props) === null || _c === void 0 ? void 0 : _c.name) || null,
        });
        const handleChange = useCallback((name) => {
            if (!name) {
                resetTab();
                return;
            }
            setTabName(name);
        }, [setTabName, resetTab]);
        useEffect(() => {
            onChange(tabName);
        }, [tabName, onChange]);
        return (React__default.createElement(TabsComponent, Object.assign({}, props, { children: children, onChange: handleChange, selectedTabName: tabName })));
    };
    UrlParamTabs.propTypes = {
        urlKey: PropTypes.string,
        onChange: PropTypes.func,
    };
    UrlParamTabs.defaultProps = {
        urlKey: "tab",
        onChange: () => null,
    };
    return UrlParamTabs;
};

const TabsContainer = styled.div `
  ${({ theme, $fill }) => css `
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    border-radius: ${theme.borderRadius.sm};
    overflow: hidden;

    ${$fill &&
    css `
      flex: 1;
    `}
  `}
`;
const TabsList = styled.div `
  ${({ theme: { spacing, tabs } }) => css `
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: ${spacing.xs} ${spacing.sm};
    justify-content: flex-start;
    align-items: baseline;
    min-height: calc(${spacing.md} + 2rem);
    max-height: ${tabs.headHeight};
    overflow: auto;
  `}
`;
const TabsContent = styled.div `
  ${({ theme }) => css `
    flex: 1;
    padding: ${theme.spacing.sm} ${theme.spacing.xs} ${theme.spacing.md};
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: stretch;
  `}
`;
const TabHead = styled.div `
  ${({ theme: { color, spacing, tabs, fontWeight }, "aria-selected": $active, disabled, }) => css `
    position: relative;
    user-select: none;

    cursor: pointer;
    color: ${color.midnight10};
    font-weight: ${fontWeight.bold};
    text-decoration: none;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    text-align: center;
    gap: ${spacing.sm};

    padding: ${spacing.p3} ${spacing.lg};

    ${$active &&
    css `
      color: ${color.turquoise};
    `}

    ${disabled &&
    css `
      color: ${tabs.color.disabled};
      pointer-events: none;
      cursor: not-allowed;
    `}

    ${!$active &&
    !disabled &&
    css `
      &:active {
        color: ${color.turquoise};
      }

      &:hover {
        background: ${color.blue40};
      }

      &:focus {
        background: ${color.blue30};
      }
    `}
  `}
`;
const TabActiveBar = styled.div `
  ${({ theme: { color, tabs } }) => css `
    position: absolute;
    transition: left 150ms, width 150ms, top 150ms, opacity 50ms;
    display: block;
    height: ${tabs.dotSize};
    background: ${color.turquoise};
    z-index: 1;
    pointer-events: none;
  `}
`;
const TabTitle = styled.div `
  ${({ theme: { tabs, fragments } }) => css `
    ${fragments.ellipsis}

    flex: 1;
    max-width: ${tabs.titleWidth};
  `}
`;
const TabSpacer = styled.div `
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex-wrap: wrap;
  align-items: baseline;
`;
const TabsTitle = styled.header `
  ${({ theme: { font, spacing, fragments } }) => css `
    ${font.h2}
    ${fragments.ellipsis}

    width: auto;
    max-width: 50%;
    padding: ${spacing.p3} ${spacing.p6} ${spacing.p3} ${spacing.p1};
  `}
`;

const TabHeader = (_a) => {
    var { active, component, render, onChange, onClick } = _a, props = __rest(_a, ["active", "component", "render", "onChange", "onClick"]);
    const { disabled, name, title, selectable } = props;
    const handleClick = useCallback((e) => {
        if (e) {
            e.preventDefault();
        }
        if (disabled || !selectable) {
            return;
        }
        onClick(name);
        onChange(name);
    }, [disabled, name, onChange, onClick, selectable]);
    const activeProps = useMemo(() => ({
        "data-test-id": `tab-${kebabCase(name)}`,
        "aria-selected": !disabled && selectable && active,
        active: !disabled && selectable && active,
        onClick: handleClick,
    }), [active, disabled, handleClick, name, selectable]);
    if (component) {
        const Item = component;
        return React__default.createElement(Item, Object.assign({}, activeProps, props));
    }
    if (render) {
        return render(Object.assign(Object.assign({}, activeProps), props));
    }
    return (React__default.createElement(TabHead, Object.assign({}, activeProps, props),
        React__default.createElement(TabTitle, null, title)));
};
TabHeader.propTypes = {
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    title: PropTypes.node,
    disabled: PropTypes.bool,
    selectable: PropTypes.bool,
    active: PropTypes.bool,
    component: PropTypes.elementType,
    render: PropTypes.func,
};
TabHeader.defaultProps = {
    onClick: () => null,
    title: null,
    disabled: false,
    selectable: true,
    active: false,
    component: null,
    render: null,
};

const emptyPos = {
    left: 0,
    width: 0,
    top: 0,
    opacity: 0,
};
const useActiveBarPosition = ({ selected }) => {
    const [activePosition, setActivePosition] = useState(emptyPos);
    const containerRef = useRef();
    const adjustHighlight = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const container = containerRef.current;
        if (!container) {
            return;
        }
        yield new Promise((resolve) => setTimeout(resolve, 100));
        const tab = container.querySelector('[aria-selected="true"]');
        if (!tab) {
            setActivePosition(emptyPos);
            return;
        }
        setActivePosition({
            left: tab.offsetLeft,
            width: tab.clientWidth,
            top: tab.offsetTop + tab.clientHeight,
            opacity: 1,
        });
    }), []);
    useEffect(() => {
        adjustHighlight();
    }, [selected, adjustHighlight]);
    useLayoutEffect(() => {
        const container = containerRef.current;
        window.addEventListener("resize", adjustHighlight);
        if (!container || !window.ResizeObserver) {
            return () => {
                window.removeEventListener("resize", adjustHighlight);
            };
        }
        const observer = new ResizeObserver(() => {
            requestAnimationFrame(adjustHighlight);
        });
        observer.observe(container);
        return () => {
            window.removeEventListener("resize", adjustHighlight);
            observer.disconnect();
        };
    }, [adjustHighlight]);
    return { activePosition, containerRef };
};

const Tabs = (_a) => {
    var { onChange, children, tabsListComponent, tabsContentComponent, fill, selectedTabName, title } = _a, props = __rest(_a, ["onChange", "children", "tabsListComponent", "tabsContentComponent", "fill", "selectedTabName", "title"]);
    const firstChild = Children.toArray(children).find((child) => child);
    const TabsListComponent = useMemo(() => tabsListComponent || TabsList, [tabsListComponent]);
    const TabsContentComponent = useMemo(() => tabsContentComponent || TabsContent, [tabsContentComponent]);
    const { activePosition, containerRef } = useActiveBarPosition({
        selected: selectedTabName,
    });
    if (!firstChild) {
        return null;
    }
    const renderTabHeader = (end) => (child) => {
        if (!child)
            return null;
        const _a = child.props, { name, headerComponent, headerRender, $end, component, render, children } = _a, otherProps = __rest(_a, ["name", "headerComponent", "headerRender", "$end", "component", "render", "children"]);
        if ($end ^ end) {
            return null;
        }
        return (React__default.createElement(TabHeader, Object.assign({}, otherProps, { name: kebabCase(name), active: selectedTabName === name, component: headerComponent, render: headerRender, "$end": $end, onChange: onChange })));
    };
    return (React__default.createElement(TabsContainer, Object.assign({ ref: containerRef }, props, { "data-testid": "Tabs", "$fill": fill }),
        React__default.createElement(TabActiveBar, { className: "tab-active-bar", style: activePosition }),
        React__default.createElement(TabsListComponent, { className: "tab-list" },
            title && React__default.createElement(TabsTitle, { className: "tab-title" }, title),
            Children.map(children, renderTabHeader(false)),
            React__default.createElement(TabSpacer, { className: "tab-spacer" }, Children.map(children, renderTabHeader(true)))),
        React__default.createElement(TabsContentComponent, { className: "tab-content" }, Children.map(children, (child) => {
            var _a, _b;
            return ((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.name) === selectedTabName && !((_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b.disabled)
                ? cloneElement(child, Object.assign(Object.assign({}, child.props), { name: kebabCase(child.props.name), active: selectedTabName === child.props.name }))
                : null;
        }))));
};
Tabs.propTypes = {
    onChange: PropTypes.func.isRequired,
    tabsListComponent: PropTypes.elementType,
    tabsContentComponent: PropTypes.elementType,
    fill: PropTypes.bool,
    selectedTabName: PropTypes.string,
    title: PropTypes.node,
};
Tabs.defaultProps = {
    tabsListComponent: null,
    fill: false,
    selectedTabName: null,
    title: null,
};

const Tab = (_a) => {
    var { headerComponent, headerRender, component, render, children, onClick } = _a, props = __rest(_a, ["headerComponent", "headerRender", "component", "render", "children", "onClick"]);
    if (component) {
        const Item = component;
        return React__default.createElement(Item, Object.assign({}, props));
    }
    if (render) {
        return render(props);
    }
    return React__default.createElement(React__default.Fragment, null, children || null);
};
Tab.propTypes = {
    name: PropTypes.string.isRequired,
    title: TabHeader.propTypes.title,
    headerComponent: TabHeader.propTypes.component,
    headerRender: TabHeader.propTypes.render,
    component: PropTypes.elementType,
    render: PropTypes.func,
    $end: PropTypes.bool,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
};
Tab.defaultProps = {
    component: null,
    render: null,
    $end: false,
    onClick: () => null,
    disabled: false,
};

const UrlTab = (_a) => {
    var { title } = _a, props = __rest(_a, ["title"]);
    const name = kebabCase(props.path);
    return React__default.createElement(Tab, Object.assign({}, props, { name: name, title: title }));
};
UrlTab.propTypes = Object.assign(Object.assign({}, omit(Tab.propTypes, ["name"])), { path: PropTypes.string.isRequired });
UrlTab.defaultProps = Object.assign({}, Tab.defaultProps);

const UrlPathTabs = (_a) => {
    var _b, _c, _d;
    var { children, onChange, fill, tabsListComponent, tabsContentComponent, title } = _a, props = __rest(_a, ["children", "onChange", "fill", "tabsListComponent", "tabsContentComponent", "title"]);
    const tabs = Children.toArray(children);
    const history = useHistory();
    const selectedTab = tabs.find((tab) => {
        const { props: { path }, } = tab;
        return history.location.pathname === path;
    });
    const firstChild = tabs.find((child) => { var _a; return (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.path; });
    const handleChange = useCallback((path) => {
        history.push(path);
    }, [history]);
    const TabsListComponent = useMemo(() => tabsListComponent || TabsList, [tabsListComponent]);
    const TabsContentComponent = useMemo(() => tabsContentComponent || TabsContent, [tabsContentComponent]);
    useEffect(() => {
        var _a;
        const path = (_a = selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.props) === null || _a === void 0 ? void 0 : _a.path;
        if (path) {
            onChange(selectedTab);
        }
    }, [(_b = selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.props) === null || _b === void 0 ? void 0 : _b.path, onChange]);
    const { activePosition, containerRef } = useActiveBarPosition({
        selected: (_c = selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.props) === null || _c === void 0 ? void 0 : _c.path,
    });
    if (!firstChild) {
        return null;
    }
    const renderTabHeader = (end) => (child) => {
        if (!child)
            return null;
        const _a = child.props, { path, name, headerComponent, headerRender, $end, component, render, children } = _a, otherProps = __rest(_a, ["path", "name", "headerComponent", "headerRender", "$end", "component", "render", "children"]);
        if ($end ^ end) {
            return null;
        }
        return (React__default.createElement(TabHeader, Object.assign({}, otherProps, { name: path || name, as: path ? Link$1 : undefined, to: path, active: selectedTab.props.path === path, component: headerComponent, render: headerRender, "$end": $end, onChange: handleChange })));
    };
    if (!selectedTab) {
        return React__default.createElement(Redirect$2, { to: (_d = firstChild.props) === null || _d === void 0 ? void 0 : _d.path });
    }
    return (React__default.createElement(TabsContainer, Object.assign({ ref: containerRef }, props, { "data-testid": "Tabs", "$fill": fill }),
        React__default.createElement(TabActiveBar, { className: "tab-active-bar", style: activePosition }),
        React__default.createElement(TabsListComponent, { className: "tab-list" },
            title && React__default.createElement(TabsTitle, { className: "tab-title" }, title),
            Children.map(children, renderTabHeader(false)),
            React__default.createElement(TabSpacer, { className: "tab-spacer" }, Children.map(children, renderTabHeader(true)))),
        React__default.createElement(TabsContentComponent, { className: "tab-content" },
            React__default.createElement(Switch$1, null, Children.map(children, (child) => {
                var _a;
                if (!child || ((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.disabled)) {
                    return null;
                }
                const _b = child.props, { path } = _b, childProps = __rest(_b, ["path"]);
                return (React__default.createElement(Route, { path: path }, cloneElement(child, Object.assign(Object.assign({}, childProps), { active: selectedTab.props.path === child.props.name }))));
            })))));
};
UrlPathTabs.propTypes = {
    onChange: PropTypes.func,
    tabsListComponent: PropTypes.elementType,
    tabsContentComponent: PropTypes.elementType,
    fill: PropTypes.bool,
};
UrlPathTabs.defaultProps = {
    onChange: () => null,
    tabsListComponent: null,
    fill: false,
};

const TabHeadLink = (_a) => {
    var { name, title, to, state, icon } = _a, props = __rest(_a, ["name", "title", "to", "state", "icon"]);
    const history = useHistory$1();
    const handleClick = useCallback(() => {
        history.push(to, state);
    }, [history, to, state]);
    return (React__default.createElement(TabHead, Object.assign({}, props, { "data-intercom-target": `tab${name}`, onClick: handleClick }),
        React__default.createElement(TabTitle, null, title),
        " ",
        React__default.createElement(Icon, { icon: icon })));
};
TabHeadLink.defaultProps = {
    icon: 'expand',
};

const UncontrolledTabs = tabControl(Tabs);
const UrlParamTabs = tabUrlParam(Tabs);

/* For the label when one is given */
const Display = styled.label `
  ${({ theme: { lineHeight }, $disabled }) => css `
    display: block;
    margin-bottom: 0;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: ${lineHeight};

    ${$disabled &&
    css `
      cursor: not-allowed;
    `}
  `}
`;
/* The slider */
const Slider = styled.span `
  ${({ theme: { fontSize, color, borderRadius } }) => css `
    position: absolute;
    cursor: pointer;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: ${borderRadius.md};
    transition: border 200ms, background-color 200ms;

    border: 2px solid ${color.midnight20};
    background-color: ${color.contrast.base};

    /* The ball */
    &::before {
      position: absolute;
      content: "";
      border-radius: ${math(`${fontSize.lg} * 0.8`)};
      top: 50%;
      transition: height 200ms, width 200ms, left 200ms, transform 200ms,
        background-color 200ms;
      box-sizing: content-box;

      height: ${math(`${fontSize.lg} * 0.75`)};
      width: ${math(`${fontSize.lg} * 0.75`)};
      left: ${math(`${fontSize.lg} * 0.3`)};
      transform: translate(0, -50%);
      background: ${color.midnight20};
    }
  `}
`;
/* The switch - the box around the slider */
const Switch = styled.label `
  ${({ theme: { fontSize, color, spacing } }) => css `
    position: relative;
    display: inline-block;
    width: ${math(`${fontSize.md} * 3`)};
    height: calc((${fontSize.lg} * 1.25) + (${spacing.p1} * 2));
  `}
`;
/* Hide default HTML checkbox */
const Input$1 = styled.input `
  ${({ theme: { fontSize, color } }) => css `
    opacity: 0;
    width: 0;
    height: 0;

    /* When the switch is on */
    &:checked + ${Slider} {
      border: 2px solid ${color.turquoise};
      background-color: ${color.turquoise};

      &::before {
        height: ${math(`${fontSize.lg} * 1.25`)};
        width: ${math(`${fontSize.lg} * 1.25`)};
        left: calc(100% - ${math(`${fontSize.lg} * 0.10`)});
        transform: translate(-100%, -50%);
        background: ${color.contrast.base};
      }
    }

    &:disabled + ${Slider} {
      cursor: not-allowed;

      border: 2px solid ${color.midnight30};
      background-color: ${color.contrast.base};

      &::before {
        background: ${color.midnight30};
      }
    }

    &:disabled:checked + ${Slider} {
      border: 2px solid ${color.turquoise20};
      background-color: ${color.turquoise20};

      &::before {
        background: ${color.contrast.base};
      }
    }

    /* When the switch is hovered over */
    &:hover:not(:disabled) + ${Slider} {
      & {
        box-shadow: 0 0 1px 1px ${color.highlight};
      }
    }

    /* When the switch has focus */
    &:focus:not(:disabled) + ${Slider} {
      & {
        box-shadow: 0 0 1px 1px ${color.focus};
      }
    }

    /* When the switch is clicked on or the user presses spacebar when focused */
    &:active:not(:disabled) + ${Slider} {
      & {
        box-shadow: 0 0 7px 1px ${color.turquoise};
      }
    }
  `}
`;
const StyledToggle = styled.div `
  display: flex;
  flex-direction: ${({ flipped }) => (flipped ? "row-reverse" : "row")};
  align-items: center;
  gap: ${({ theme }) => theme.spacing.md};
`;

const ToggleSwitch = forwardRef((_a, ref) => {
    var { children, label, name, id, value, checked, onChange, containerRef, flipped, disabled } = _a, props = __rest(_a, ["children", "label", "name", "id", "value", "checked", "onChange", "containerRef", "flipped", "disabled"]);
    const display = children || label;
    const thisId = useMemo(() => {
        if (id) {
            return id;
        }
        return generateRandomString(6);
    }, [id]);
    return (React__default.createElement(StyledToggle, Object.assign({ ref: containerRef }, props, { flipped: flipped, "data-testid": "ToggleSwitch" }),
        display ? (React__default.createElement(Display, { htmlFor: thisId, "$disabled": disabled }, display)) : null,
        React__default.createElement(Switch, null,
            React__default.createElement(Input$1, { ref: ref, type: "checkbox", className: "input", id: thisId, name: name, disabled: disabled, value: checked ? value : false, checked: checked, onChange: onChange }),
            React__default.createElement(Slider, null))));
});
ToggleSwitch.displayName = "ToggleSwitch";
ToggleSwitch.propTypes = {
    children: PropTypes.node,
    label: PropTypes.node,
    id: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.any,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    flipped: PropTypes.bool,
    disabled: PropTypes.bool,
};
ToggleSwitch.defaultProps = {
    value: "1",
    onChange: () => null,
    flipped: false,
    disabled: false,
};

const UploadContent = styled.div `
  ${({ theme: { spacing } }) => css `
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: row;
    gap: ${spacing.md};
  `}
`;
const UploadingOverlay = styled.div `
  ${({ theme: { type, color } }) => css `
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${type === "light" ? color.white : color.midnight};
  `}
`;

const BoxContainer = styled.div `
  ${({ theme: { color, borderRadius } }) => css `
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 2px dashed ${color.blue20};
    background: ${color.blue50};
    border-radius: ${borderRadius.sm};
    min-height: 200px;
    cursor: pointer;
  `}
`;
const DraggingOverlay = styled.div `
  ${({ theme: { color, borderRadius } }) => css `
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${borderRadius.sm};
    background: ${color.blue40};
  `}
`;
const DraggingContent = styled.div ``;
const BoxContent = styled.h2 `
  ${({ theme: { font, spacing } }) => css `
    ${font.h2}
    padding: ${spacing.p1} ${spacing.md};
  `}
`;
const BoxIcon = styled.div `
  ${({ theme: { spacing } }) => css `
    margin-bottom: ${spacing.sm};
  `}
`;
const BoxSub = styled.span `
  ${({ theme: { font, color } }) => css `
    ${font.smallnote}
    color: ${color.midnight10};
  `}
`;

const getAcceptedFiles = (mediaType) => {
    switch (mediaType) {
        case "video":
        case "video2D":
        case "video3D":
            return ".mp4,video/*";
        case "image":
            return ".png,.jpg,.jpeg";
        case "audio":
            return ".wav,.mp3,audio/mpeg";
        case "document":
            return ".pdf,.docx,.txt,text/plain,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword";
        default:
            return mediaType;
    }
};

const stripTypePrefix = function (fileType) {
    return fileType
        .replace(/image\//g, "")
        .replace(/video\//g, "")
        .replace(/audio\//g, "")
        .toLowerCase();
};
const isAcceptedType = (fileType, accepted) => {
    if (!accepted) {
        return true;
    }
    if (!fileType) {
        return false;
    }
    if (accepted.includes(fileType)) {
        return true;
    }
    if (stripTypePrefix(accepted).includes(stripTypePrefix(fileType))) {
        return true;
    }
    // check image/* etc.
    const typePrefixes = ["image/", "video/", "audio/"];
    for (let key in typePrefixes) {
        const prefix = typePrefixes[key];
        if (accepted.includes(prefix + "*") && fileType.includes(prefix))
            return true;
    }
    return false;
};

const units = ["B", "kB", "MB", "GB", "TB"];
const formatFilesize = (size) => {
    size = parseInt("" + size, 10);
    if (size <= 0) {
        return "0B";
    }
    const unitIndex = Math.floor(Math.log10(size) / Math.log10(1024));
    const newSize = Math.round((size / Math.pow(1024, unitIndex)) * 10) / 10;
    return `${newSize}${units[unitIndex]}`;
};

const noDefault = (e) => {
    if (e) {
        e.preventDefault();
    }
};
const MediaUploadBox = forwardRef((_a, ref) => {
    var { is3D, addFiles, acceptedTypes = ["*"], maxFileSize, name, multiple, onAddError, overlayContent: inputOverlayContent, boxContent: inputBoxContent, icon, iconSize = "30px" } = _a, props = __rest(_a, ["is3D", "addFiles", "acceptedTypes", "maxFileSize", "name", "multiple", "onAddError", "overlayContent", "boxContent", "icon", "iconSize"]);
    const fileInput = useRef(null);
    const [dragNum, setDragNum] = useState(0);
    const acceptedFiles = useMemo(() => acceptedTypes.map(getAcceptedFiles).join(","), [acceptedTypes]);
    const checkFiles = useCallback((files) => {
        if (files.length > 1 && !multiple) {
            onAddError === null || onAddError === void 0 ? void 0 : onAddError("Cannot upload multiple files.");
            return false;
        }
        for (const file of files) {
            if (!acceptedTypes.find((type) => type === "*" || isAcceptedType(file.type, acceptedFiles))) {
                onAddError === null || onAddError === void 0 ? void 0 : onAddError(`Please provide valid ${acceptedTypes.join("/")} files.`);
                return false;
            }
            if (maxFileSize && file.size > maxFileSize) {
                const size = formatFilesize(maxFileSize);
                onAddError === null || onAddError === void 0 ? void 0 : onAddError(`One or more of your files exceeded the maximum size of ${size}.`);
                return false;
            }
        }
        return true;
    }, [acceptedFiles, acceptedTypes, maxFileSize, multiple, onAddError]);
    const handleDrop = useCallback((e) => {
        noDefault(e);
        if (dragNum === 0 || !e.dataTransfer) {
            return;
        }
        setDragNum(0);
        if (fileInput.current) {
            fileInput.current.files = e.dataTransfer.files;
        }
        if (checkFiles(e.dataTransfer.files)) {
            addFiles(e.dataTransfer.files, is3D || false);
        }
    }, [addFiles, checkFiles, is3D, dragNum]);
    const handleFileChange = useCallback((e) => {
        var _a;
        if (((_a = e.target) === null || _a === void 0 ? void 0 : _a.files) && checkFiles(e.target.files)) {
            addFiles(e.target.files, is3D || false);
        }
    }, [addFiles, checkFiles, is3D]);
    const handleDragEnter = useCallback((e) => {
        noDefault(e);
        setDragNum((prev) => { var _a, _b; return !!((_b = (_a = e === null || e === void 0 ? void 0 : e.dataTransfer) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length) ? prev + 1 : prev; });
    }, []);
    const handleDragLeave = useCallback((e) => {
        noDefault(e);
        setDragNum((prev) => Math.max(prev - 1, 0));
    }, []);
    const openFilePicker = useCallback(() => {
        var _a, _b;
        (_b = (_a = fileInput.current) === null || _a === void 0 ? void 0 : _a.click) === null || _b === void 0 ? void 0 : _b.call(_a);
    }, []);
    const fileExtensions = useMemo(() => {
        var _a;
        return (_a = acceptedTypes.flatMap) === null || _a === void 0 ? void 0 : _a.call(acceptedTypes, (type) => {
            if (type === "video") {
                return ["mov", "mp4"];
            }
            if (type === "image") {
                return ["png", "jpeg"];
            }
            if (type === "audio") {
                return ["wav", "mp3"];
            }
            if (type === "document") {
                return ["pdf", "doc", "docx", "txt"];
            }
            return [];
        });
    }, [acceptedTypes]);
    const overlayContent = useMemo(() => {
        if (inputOverlayContent) {
            return inputOverlayContent;
        }
        return is3D ? (React__default.createElement(React__default.Fragment, null, "Drop your 360\u00B0 media file here")) : (React__default.createElement(React__default.Fragment, null, "Drop your standard media file here"));
    }, [inputOverlayContent, is3D]);
    const boxContent = useMemo(() => {
        if (inputBoxContent) {
            return inputBoxContent;
        }
        return is3D ? React__default.createElement(React__default.Fragment, null, "Upload 360\u00B0 media") : React__default.createElement(React__default.Fragment, null, "Upload standard media");
    }, [inputBoxContent, is3D]);
    return (React__default.createElement(BoxContainer, Object.assign({}, props, { "data-testid": "uploader", onDrag: noDefault, onDragOver: noDefault, onDragEnter: handleDragEnter, onDragLeave: handleDragLeave, onDrop: handleDrop, onClick: openFilePicker, "data-dimension": is3D ? "3d" : "2d" }),
        React__default.createElement("input", { multiple: multiple, ref: useRefs(fileInput, ref), onChange: handleFileChange, type: "file", name: name, style: { display: "none" }, accept: acceptedFiles }),
        dragNum > 0 && (React__default.createElement(DraggingOverlay, { className: "upload-drag" },
            React__default.createElement(DraggingContent, null, overlayContent))),
        React__default.createElement(BoxIcon, { className: "upload-icon", style: {
                height: iconSize,
                width: iconSize,
            } }, (is3D || icon) && (React__default.createElement(Icon, { icon: icon || (is3D ? "video-3d" : "upload"), size: iconSize }))),
        React__default.createElement(BoxContent, { className: "upload-content" }, boxContent),
        fileExtensions && (React__default.createElement(BoxSub, { className: "upload-sub" }, fileExtensions.join(", ")))));
});

const ProgressWrapper = styled.div `
  ${({ theme: { spacing } }) => css `
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 ${spacing.md};
    flex: 1;
    align-self: stretch;
    gap: ${spacing.sm};
  `}
`;
const FileCount = styled.div ``;
const ErrorMessage = styled.div `
  ${({ theme: { color } }) => css `
    color: ${color.error};
  `}
`;
const ProgressbarWrapper$1 = styled.div `
  width: 100%;
  height: calc(100% - 8rem);
  max-height: calc(100% - 8rem);
  flex: 1;
  margin: 0 auto 0.5em auto;

  .CircularProgressbar {
    height: 100%;
    max-height: 100%;
  }
`;
const Actions = styled.div `
  font-size: 0.8rem;
`;
const Pause = styled.button `
  cursor: pointer;
  background: none;
  border: none;
  color: var(--link-text-color);
  text-decoration: none;
  font-weight: bold;

  &:hover {
    color: var(--link-text-color-hover);
  }
`;
const Cancel = styled.button `
  cursor: pointer;
  background: none;
  border: none;
  color: var(--link-text-color);
  text-decoration: none;
  font-weight: bold;

  &:hover {
    color: var(--link-text-color-hover);
  }
`;

const ProgressDataContainer = styled.div `
  ${({ theme: { font, color, spacing } }) => css `
    ${font.smallnote}

    display: flex;
    flex-direction: column;
    align-items: center;
    color: ${color.midnight20};

    p + p {
      margin-top: ${spacing.sm};
    }
  `}
`;
const StyledDots = styled.span.attrs({
    children: (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("span", null, "."),
        React__default.createElement("span", null, "."),
        React__default.createElement("span", null, "."))),
}) `
  display: block;
  overflow: hidden;
  width: 1em;

  span {
    animation: waitingDots 1s infinite;
  }
  @keyframes waitingDots {
    0%,
    100% {
      opacity: 0.3;
    }
    50% {
      opacity: 1;
    }
  }

  // Stagger the animation on each dot
  span:nth-child(3) {
    animation-delay: 0s;
  }
  span:nth-child(2) {
    animation-delay: -0.2s;
  }
  span:nth-child(1) {
    animation-delay: -0.4s;
  }
`;

const uploadProgress = (totalBytes, progress) => {
    if (!totalBytes)
        return null;
    return `${formatFilesize(totalBytes * progress)} / ${formatFilesize(totalBytes)}`;
};
const ProgressData = (_a) => {
    var { paused, totalBytes, progress } = _a, props = __rest(_a, ["paused", "totalBytes", "progress"]);
    const [ticks, setTicks] = useState([]);
    const [throttled, setThrottled] = useState(() => ({
        remainingTime: null,
        uploadProgress: `- / ${formatFilesize(totalBytes)}`,
        uploadRate: null,
    }));
    const [uiUpdated, setUiUpdated] = useState(Date.now());
    const waiting = ticks.length < 2;
    const timeSinceFirstTick = waiting
        ? null
        : ticks[ticks.length - 1].time - ticks[0].time;
    const progressSinceFirstTick = waiting
        ? null
        : ticks[ticks.length - 1].progress - ticks[0].progress;
    useEffect(() => {
        const tick = () => {
            // Skip if filesize not known yet
            if (!totalBytes)
                return;
            // Skip if the progress hasn't changed
            if (ticks.length && ticks[ticks.length - 1].progress === progress)
                return;
            // Store the last 4 ticks
            setTicks([...ticks, { progress: progress, time: Date.now() }].slice(-4));
        };
        if (paused) {
            setTicks([]);
            updateUiNow();
        }
        else {
            tick();
        }
        // `ticks` can't be a dependency because it will always be a new object
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paused, progress]);
    // Update the UI values only (roughly) once every two seconds
    const updateUiNow = useCallback(() => {
        const getRemainingTime = () => {
            if (waiting || !progressSinceFirstTick || !timeSinceFirstTick)
                return null;
            const timeRemaining = ((1 - ticks[0].progress) / progressSinceFirstTick) * timeSinceFirstTick;
            try {
                return formatDistanceStrict(new Date(), new Date(Date.now() + timeRemaining));
            }
            catch (e) {
                console.error(e);
                return "";
            }
        };
        const getUploadRate = () => {
            if (waiting || !progressSinceFirstTick || !timeSinceFirstTick)
                return null;
            const bytesPerSecond = (progressSinceFirstTick * totalBytes * 1000) / timeSinceFirstTick;
            return `${formatFilesize(bytesPerSecond)}/s`;
        };
        setUiUpdated(Date.now());
        setThrottled({
            remainingTime: getRemainingTime(),
            uploadProgress: uploadProgress(totalBytes, progress),
            uploadRate: getUploadRate(),
        });
    }, [
        progress,
        progressSinceFirstTick,
        ticks,
        timeSinceFirstTick,
        totalBytes,
        waiting,
    ]);
    useEffect(() => {
        const updateUi = () => {
            if (Date.now() - uiUpdated < 2000)
                return;
            updateUiNow();
        };
        updateUi();
        const interval = setInterval(updateUi, 500);
        return () => clearInterval(interval);
    }, [uiUpdated, updateUiNow]);
    return (React__default.createElement(ProgressDataContainer, Object.assign({}, props),
        throttled.uploadProgress ? (React__default.createElement("p", null,
            throttled.uploadProgress,
            " ",
            throttled.uploadRate && !waiting ? `(${throttled.uploadRate})` : "")) : (React__default.createElement(StyledDots, null)),
        throttled.remainingTime && !waiting ? (React__default.createElement("p", null,
            throttled.remainingTime,
            " remaining")) : (React__default.createElement(React__default.Fragment, null, paused ? React__default.createElement("p", null, "paused") : React__default.createElement(StyledDots, null)))));
};
ProgressData.propTypes = {
    paused: PropTypes.bool,
    progress: PropTypes.number.isRequired,
    totalBytes: PropTypes.number.isRequired,
};

const UploadingProgress = (_a) => {
    var { error, uploading, fileNum, fileCount, sent, total, paused, onPause, onCancel } = _a, props = __rest(_a, ["error", "uploading", "fileNum", "fileCount", "sent", "total", "paused", "onPause", "onCancel"]);
    const percent = useMemo(() => {
        if (!sent || !total) {
            return 0;
        }
        return Math.round((sent / total) * 100) / 100;
    }, [sent, total]);
    const pauseLabel = useMemo(() => {
        if (error) {
            return "Retry";
        }
        if (paused) {
            return "Resume";
        }
        return "Pause";
    }, [error, paused]);
    return (React__default.createElement(ProgressWrapper, Object.assign({}, props),
        uploading && fileCount > 1 && (React__default.createElement(FileCount, { "data-testid": "uploader-file-count-progress" },
            "Uploading file ",
            fileNum + 1,
            " of ",
            fileCount)),
        uploading && (React__default.createElement(ProgressbarWrapper$1, null,
            React__default.createElement(CircularProgressbar, { percentage: percent * 100 }))),
        uploading && (React__default.createElement(ProgressData, { progress: percent, paused: paused, totalBytes: total || 0 })),
        error && React__default.createElement(ErrorMessage, null, error),
        uploading && (React__default.createElement(Actions, null,
            React__default.createElement(Pause, { "data-testid": "uploader-pause-button", onClick: onPause }, pauseLabel),
            React__default.createElement(Cancel, { "data-testid": "uploader-cancel-button", onClick: onCancel }, "Cancel")))));
};
UploadingProgress.propTypes = {
    error: PropTypes.string,
    uploading: PropTypes.bool.isRequired,
    fileNum: PropTypes.number.isRequired,
    fileCount: PropTypes.number.isRequired,
    sent: PropTypes.number,
    total: PropTypes.number,
    paused: PropTypes.bool.isRequired,
    onPause: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

const useDraggingOver = (contentRef) => {
    const [dragging, setDragging] = useState(false);
    useEffect(() => {
        let timer = null;
        const checkDragging = (e) => {
            if (!contentRef.current || !(e.target instanceof HTMLElement)) {
                return;
            }
            if (timer) {
                clearTimeout(timer);
            }
            if (contentRef.current.contains(e.target)) {
                setDragging(true);
                return;
            }
            timer = setTimeout(() => {
                setDragging(false);
            }, 100);
        };
        const stopDragging = (e) => {
            if (!contentRef.current || !(e.target instanceof HTMLElement)) {
                return;
            }
            if (document.body.contains(e.target) &&
                !contentRef.current.contains(e.target)) {
                timer = setTimeout(() => {
                    setDragging(false);
                }, 100);
            }
        };
        window.addEventListener("dragover", checkDragging);
        window.addEventListener("dragleave", stopDragging);
        return () => {
            window.removeEventListener("dragover", checkDragging);
            window.removeEventListener("dragleave", stopDragging);
        };
    }, [contentRef]);
    return [dragging, setDragging];
};

const fileTypes = ["video", "image", "audio"];
const getFileType = (type) => {
    return (fileTypes.find((fileType) => isAcceptedType(type, getAcceptedFiles(fileType))) || null);
};

const noDefault$1 = (e) => {
    if (e) {
        e.preventDefault();
    }
};
const useMediaQueue = ({ onSuccess, getUploadEndpoint, onComplete, onSending, onError, onAddError, onCancel, multiple = false, chunkSize = 1024 * 1024 * 50, }) => {
    const upload = useRef(null);
    const [queue, setQueue] = useState([]);
    const [queueIndex, setQueueIndex] = useState(0);
    const [status, setStatus] = useState({ total: 0, sent: 0 });
    const [uploading, setUploading] = useState(false);
    const [paused, setPaused] = useState(false);
    const [error, setError] = useState(null);
    const contentRef = useRef(/** @type {HTMLDivElement | null} */ null);
    const [dragging, setDragging] = useDraggingOver(contentRef);
    const dataRef = useRef({
        onComplete,
        onSuccess,
        onSending,
        onError,
        queue,
    });
    dataRef.current = {
        onComplete,
        onSuccess,
        onSending,
        onError,
        queue,
    };
    const addFiles = useCallback((files, is3D = false) => {
        if (files.length > 1 && !multiple) {
            setDragging(false);
            onAddError === null || onAddError === void 0 ? void 0 : onAddError("Cannot upload multiple files.");
            return;
        }
        const adding = [];
        for (const file of files) {
            const type = getFileType(file.type);
            adding.push({
                is3D,
                type,
                file,
            });
        }
        setQueue((curr) => [...curr, ...adding]);
        setDragging(false);
    }, [multiple, setDragging, onAddError]);
    const cancelUpload = useCallback((e) => __awaiter(void 0, void 0, void 0, function* () {
        noDefault$1(e);
        if (upload.current) {
            yield upload.current.abort();
            upload.current = null;
        }
        setQueue([]);
        setQueueIndex(0);
        setUploading(false);
        setError(null);
        setPaused(false);
        setStatus({ total: 0, sent: 0 });
        onCancel === null || onCancel === void 0 ? void 0 : onCancel();
    }), [onCancel]);
    const pauseUpload = useCallback((e) => {
        noDefault$1(e);
        if (!upload.current) {
            setError(null);
            return;
        }
        setPaused((prev) => {
            if (!upload.current) {
                return prev;
            }
            if (prev) {
                upload.current.start();
            }
            else {
                upload.current.abort();
            }
            return !prev;
        });
    }, []);
    const startUpload = useCallback((item, index) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const endpoint = yield getUploadEndpoint(item.type);
        if (!upload.current) {
            const uploadObj = new Upload(item.file, {
                endpoint,
                removeFingerprintOnSuccess: true,
                retryDelays: [0, 3000, 5000, 10000, 20000],
                metadata: {
                    filename: item.file.name,
                    filetype: item.file.type,
                },
                onError: (e) => {
                    var _a, _b;
                    setUploading(false);
                    setError({ item, error: e });
                    upload.current = null;
                    (_b = (_a = dataRef.current) === null || _a === void 0 ? void 0 : _a.onError) === null || _b === void 0 ? void 0 : _b.call(_a, e, item);
                },
                chunkSize,
                onProgress: (sent, total) => {
                    setStatus({ sent, total });
                },
                onSuccess: () => __awaiter(void 0, void 0, void 0, function* () {
                    var _c, _d, _e, _f, _g;
                    const url = uploadObj === null || uploadObj === void 0 ? void 0 : uploadObj.url;
                    if (!url) {
                        const error = new Error("No url found with uploaded item");
                        setError({ item, error });
                        console.error(item, error, uploadObj);
                        upload.current = null;
                        (_d = (_c = dataRef.current) === null || _c === void 0 ? void 0 : _c.onError) === null || _d === void 0 ? void 0 : _d.call(_c, error, item);
                        setUploading(false);
                        return;
                    }
                    yield ((_e = dataRef.current) === null || _e === void 0 ? void 0 : _e.onSuccess(uploadObj, item));
                    setQueueIndex(index + 1);
                    setUploading(false);
                    upload.current = null;
                    if (dataRef.current.queue.length - 1 === index) {
                        yield ((_g = (_f = dataRef.current) === null || _f === void 0 ? void 0 : _f.onComplete) === null || _g === void 0 ? void 0 : _g.call(_f));
                        setQueue([]);
                        setQueueIndex(0);
                        setUploading(false);
                        return;
                    }
                }),
            });
            upload.current = uploadObj;
        }
        // reimplement old functionality from tus v1 to resume from localstorage
        const previousUploads = yield upload.current.findPreviousUploads();
        if (previousUploads.length > 0) {
            upload.current.resumeFromPreviousUpload(previousUploads[0]);
        }
        // Start the upload
        upload.current.start();
        (_b = (_a = dataRef.current) === null || _a === void 0 ? void 0 : _a.onSending) === null || _b === void 0 ? void 0 : _b.call(_a);
        setStatus({ sent: 0, total: item.file.size });
        setUploading(true);
        setPaused(false);
        setError(null);
    }), [chunkSize, getUploadEndpoint]);
    const startRef = useRef(startUpload);
    startRef.current = startUpload;
    const debounceStart = useMemo(() => debounce$1((item, index) => startRef.current(item, index), 50), []);
    // effect to automatically trigger uploading
    useEffect(() => {
        if (queue.length === 0 || error) {
            return;
        }
        if (!uploading && queue[queueIndex]) {
            debounceStart(queue[queueIndex], queueIndex);
        }
    }, [queueIndex, queue, uploading, error, debounceStart]);
    return {
        contentRef,
        pauseUpload,
        cancelUpload,
        addFiles,
        fileNum: queueIndex,
        fileCount: queue.length,
        dragging,
        paused,
        sent: status.sent,
        total: status.total,
        uploading,
    };
};

const Uploader = (_a) => {
    var { is3D, onComplete, onSuccess, onSending, onCancel, onError, chunkSize = 1024 * 1024 * 50, multiple, name, getUploadEndpoint, overlayContent: inputOverlayContent, boxContent: inputBoxContent, acceptedTypes = ["video", "image"], maxFileSize, loading, icon, iconSize } = _a, props = __rest(_a, ["is3D", "onComplete", "onSuccess", "onSending", "onCancel", "onError", "chunkSize", "multiple", "name", "getUploadEndpoint", "overlayContent", "boxContent", "acceptedTypes", "maxFileSize", "loading", "icon", "iconSize"]);
    const [error, setError] = useState(null);
    const handleError = useCallback((error) => {
        if (typeof error === "string") {
            setError(error);
            onError === null || onError === void 0 ? void 0 : onError(error);
            return;
        }
        setError((error === null || error === void 0 ? void 0 : error.message) || "Unknown error");
        onError === null || onError === void 0 ? void 0 : onError((error === null || error === void 0 ? void 0 : error.message) || "Unknown error");
    }, [onError]);
    const { contentRef, uploading, dragging, addFiles, fileNum, fileCount, sent, total, paused, pauseUpload: pauseQueue, cancelUpload: cancelQueue, } = useMediaQueue({
        onSuccess,
        getUploadEndpoint,
        onComplete,
        onSending,
        onCancel,
        onError: handleError,
        onAddError: handleError,
        multiple,
        chunkSize,
    });
    const pauseUpload = useCallback((e) => {
        setError(null);
        pauseQueue(e);
    }, [pauseQueue]);
    const cancelUpload = useCallback((e) => {
        setError(null);
        cancelQueue(e);
    }, [cancelQueue]);
    return (React__default.createElement(UploadContent, Object.assign({ ref: contentRef }, props, { "data-testid": "Uploader" }),
        React__default.createElement(MediaUploadBox, { className: "upload-box", is3D: is3D, addFiles: addFiles, maxFileSize: maxFileSize, multiple: multiple, onAddError: handleError, overlayContent: inputOverlayContent, boxContent: inputBoxContent, icon: icon || (is3D ? "video-3d" : "upload"), iconSize: iconSize, acceptedTypes: acceptedTypes, name: name }),
        (uploading || loading || error) && !dragging && (React__default.createElement(UploadingOverlay, { className: "overlay" },
            React__default.createElement(UploadingProgress, { className: "progress", uploading: uploading, error: error || "", fileNum: fileNum, fileCount: fileCount, sent: sent, total: total, paused: paused, onPause: pauseUpload, onCancel: cancelUpload })))));
};
Uploader.propTypes = {
    onSuccess: PropTypes.func.isRequired,
    getUploadEndpoint: PropTypes.func.isRequired,
    is3D: PropTypes.bool,
    onComplete: PropTypes.func,
    onSending: PropTypes.func,
    onCancel: PropTypes.func,
    onError: PropTypes.func,
    chunkSize: PropTypes.number,
    multiple: PropTypes.bool,
    name: PropTypes.string,
    overlayContent: PropTypes.node,
    boxContent: PropTypes.node,
    acceptedTypes: PropTypes.arrayOf(PropTypes.string.isRequired),
    maxFileSize: PropTypes.number,
    loading: PropTypes.bool,
    icon: IconPropType,
    iconSize: Icon.propTypes.size,
};

export { Animation, AnimationLoop, AutosaveIndicator, BarGraph, Button, ButtonDropdown, ButtonDropdownButton$1 as ButtonDropdownButton, ButtonGroup$1 as ButtonGroup, ButtonGroupV2, Card, CharacterCounter, Chip, CircularProgressbar, ColorPicker, ConfirmationModal, CreateSelect, CustomSelectContainer, DarkTheme, Datetime, DefaultGraphLegend, DefaultGraphTooltip, fallback as FALLBACK, FALLBACK_SHAPE, FieldError, FieldGroup, FieldGroupLegend, FieldGroupV2, FieldHelp, FieldLabel, FieldLabelWrapper, FieldWrapper, FieldWrapperV2, FilterChip, GlobalStyle, HelpContent, HelpLabel, HelpTooltip, Icon, IconPropType, Image, Infobox, LightTheme, LineGraph, Link, LinkCard, Loading, LoadingContainer, LoadingFlash, LoadingPlaceholder, LoadingSection, logoMid as LogoMid, logoSnow as LogoSnow, MediaUploadBox, MockButton, MockIcon, MockImage, MockText, Modal, PaginationControl, ProgressBar, Redirect, Select, SentimentSmiley, SimpleTooltip, SimpleTooltipContent, SortableTh, SortableThV2, splashScreen as SplashScreen, Tab, TabActiveBar, TabHead, TabHeadLink, TabHeader, TabSpacer, TabTitle, Table$1 as Table, TableV2, Tabs, TabsContainer, TabsContent, TabsList, TabsTitle, Tbody, Td, TdLink, TextInput, Th, Thead, ToggleSwitch, Tooltip, Tr, UncontrolledTabs, Uploader, UploadingProgress, UrlParamTabs, UrlPathTabs, UrlTab, displayDate, displayDateDifference, displayDatetime, displayDatetimeDifference, displayTime, displayTimeDifference, ellipsisFragment, formatDate, formatDateLabel, formatDateLong, formatDatetime, formatDatetimeLong, formatDuration, formatFilesize, formatTime, formatTimeLong, getAcceptedFiles, getFileType, inputContainerCss, inputCss, isAcceptedType, isMultiline, isSingleline, parseDatetime, resetFragment, stateUrlDefaultOptions, useDateLocale, useDebouncedSave, useLottie, useMediaQueue, useMounted, usePaginationUrl, useRefs, useRouterQuery, useStateUrl, useTooltipPlacement, zeroTime };
//# sourceMappingURL=index.esm.js.map
